webpackJsonp([1],{

/***/ 1000:
/***/ (function(module, exports) {



(function () {

  var OOP = window.OpenSeadragon;
  if (!OOP) {
    if (!OOP) {
      throw new Error('OpenSeadragon is missing.');
    }
  }

  var svgNS = 'http://www.w3.org/2000/svg';

  OOP.Viewer.prototype.svgOverlay = function () {
    if (this._svgOverlayInfo) {
      return this._svgOverlayInfo;
    }

    this._svgOverlayInfo = new Overlay(this);
    return this._svgOverlayInfo;
  };

  var Overlay = function Overlay(viewer) {
    var self = this;

    this._viewer = viewer;
    this._containerWidth = 0;
    this._containerHeight = 0;

    this._svg = document.createElementNS(svgNS, 'svg');
    this._svg.style.position = 'absolute';
    this._svg.style.left = 0;
    this._svg.style.top = 0;
    this._svg.style.width = '100%';
    this._svg.style.height = '100%';
    this._viewer.canvas.appendChild(this._svg);

    this._node = document.createElementNS(svgNS, 'g');
    this._svg.appendChild(this._node);

    this._viewer.addHandler('animation', function () {
      self.resize();
    });

    this._viewer.addHandler('open', function () {
      self.resize();
    });

    this._viewer.addHandler('rotate', function (evt) {
      self.resize();
    });

    this._viewer.addHandler('resize', function () {
      self.resize();
    });

    this.resize();
  };

  Overlay.prototype = {
    node: function node() {
      return this._node;
    },

    resize: function resize() {
      if (this._containerWidth !== this._viewer.container.clientWidth) {
        this._containerWidth = this._viewer.container.clientWidth;
        this._svg.setAttribute('width', this._containerWidth);
      }

      if (this._containerHeight !== this._viewer.container.clientHeight) {
        this._containerHeight = this._viewer.container.clientHeight;
        this._svg.setAttribute('height', this._containerHeight);
      }

      var p = this._viewer.viewport.pixelFromPoint(new OOP.Point(0, 0), true);
      var zoom = this._viewer.viewport.getZoom(true);
      var rotation = this._viewer.viewport.getRotation();

      var scale = this._viewer.viewport._containerInnerSize.x * zoom;
      this._node.setAttribute('transform', 'translate(' + p.x + ',' + p.y + ') scale(' + scale + ') rotate(' + rotation + ')');
    },

    onClick: function onClick(node, handler) {

      new OOP.MouseTracker({
        element: node,
        clickHandler: handler
      }).setTracking(true);
    }
  };
})();

/***/ }),

/***/ 1560:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1561:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1562:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1563:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1564:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1565:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1566:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1567:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1568:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1569:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1570:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1571:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1572:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1573:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1574:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1575:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1576:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1577:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1578:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1579:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1580:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1581:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1582:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1583:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1584:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1585:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1586:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1587:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1588:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1589:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1590:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1591:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1592:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1593:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1594:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1595:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1596:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1597:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1598:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1599:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1600:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1601:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1602:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1603:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1604:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1605:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1606:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1607:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1608:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1609:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1610:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1600)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(936),
  /* template */
  __webpack_require__(1990),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1573)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(939),
  /* template */
  __webpack_require__(1962),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1566)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(940),
  /* template */
  __webpack_require__(1955),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-14df7bc7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1700:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 591,
	"./af.js": 591,
	"./ar": 598,
	"./ar-dz": 592,
	"./ar-dz.js": 592,
	"./ar-kw": 593,
	"./ar-kw.js": 593,
	"./ar-ly": 594,
	"./ar-ly.js": 594,
	"./ar-ma": 595,
	"./ar-ma.js": 595,
	"./ar-sa": 596,
	"./ar-sa.js": 596,
	"./ar-tn": 597,
	"./ar-tn.js": 597,
	"./ar.js": 598,
	"./az": 599,
	"./az.js": 599,
	"./be": 600,
	"./be.js": 600,
	"./bg": 601,
	"./bg.js": 601,
	"./bm": 602,
	"./bm.js": 602,
	"./bn": 604,
	"./bn-bd": 603,
	"./bn-bd.js": 603,
	"./bn.js": 604,
	"./bo": 605,
	"./bo.js": 605,
	"./br": 606,
	"./br.js": 606,
	"./bs": 607,
	"./bs.js": 607,
	"./ca": 608,
	"./ca.js": 608,
	"./cs": 609,
	"./cs.js": 609,
	"./cv": 610,
	"./cv.js": 610,
	"./cy": 611,
	"./cy.js": 611,
	"./da": 612,
	"./da.js": 612,
	"./de": 615,
	"./de-at": 613,
	"./de-at.js": 613,
	"./de-ch": 614,
	"./de-ch.js": 614,
	"./de.js": 615,
	"./dv": 616,
	"./dv.js": 616,
	"./el": 617,
	"./el.js": 617,
	"./en-au": 618,
	"./en-au.js": 618,
	"./en-ca": 619,
	"./en-ca.js": 619,
	"./en-gb": 620,
	"./en-gb.js": 620,
	"./en-ie": 621,
	"./en-ie.js": 621,
	"./en-il": 622,
	"./en-il.js": 622,
	"./en-in": 623,
	"./en-in.js": 623,
	"./en-nz": 624,
	"./en-nz.js": 624,
	"./en-sg": 625,
	"./en-sg.js": 625,
	"./eo": 626,
	"./eo.js": 626,
	"./es": 630,
	"./es-do": 627,
	"./es-do.js": 627,
	"./es-mx": 628,
	"./es-mx.js": 628,
	"./es-us": 629,
	"./es-us.js": 629,
	"./es.js": 630,
	"./et": 631,
	"./et.js": 631,
	"./eu": 632,
	"./eu.js": 632,
	"./fa": 633,
	"./fa.js": 633,
	"./fi": 634,
	"./fi.js": 634,
	"./fil": 635,
	"./fil.js": 635,
	"./fo": 636,
	"./fo.js": 636,
	"./fr": 639,
	"./fr-ca": 637,
	"./fr-ca.js": 637,
	"./fr-ch": 638,
	"./fr-ch.js": 638,
	"./fr.js": 639,
	"./fy": 640,
	"./fy.js": 640,
	"./ga": 641,
	"./ga.js": 641,
	"./gd": 642,
	"./gd.js": 642,
	"./gl": 643,
	"./gl.js": 643,
	"./gom-deva": 644,
	"./gom-deva.js": 644,
	"./gom-latn": 645,
	"./gom-latn.js": 645,
	"./gu": 646,
	"./gu.js": 646,
	"./he": 647,
	"./he.js": 647,
	"./hi": 648,
	"./hi.js": 648,
	"./hr": 649,
	"./hr.js": 649,
	"./hu": 650,
	"./hu.js": 650,
	"./hy-am": 651,
	"./hy-am.js": 651,
	"./id": 652,
	"./id.js": 652,
	"./is": 653,
	"./is.js": 653,
	"./it": 655,
	"./it-ch": 654,
	"./it-ch.js": 654,
	"./it.js": 655,
	"./ja": 656,
	"./ja.js": 656,
	"./jv": 657,
	"./jv.js": 657,
	"./ka": 658,
	"./ka.js": 658,
	"./kk": 659,
	"./kk.js": 659,
	"./km": 660,
	"./km.js": 660,
	"./kn": 661,
	"./kn.js": 661,
	"./ko": 662,
	"./ko.js": 662,
	"./ku": 663,
	"./ku.js": 663,
	"./ky": 664,
	"./ky.js": 664,
	"./lb": 665,
	"./lb.js": 665,
	"./lo": 666,
	"./lo.js": 666,
	"./lt": 667,
	"./lt.js": 667,
	"./lv": 668,
	"./lv.js": 668,
	"./me": 669,
	"./me.js": 669,
	"./mi": 670,
	"./mi.js": 670,
	"./mk": 671,
	"./mk.js": 671,
	"./ml": 672,
	"./ml.js": 672,
	"./mn": 673,
	"./mn.js": 673,
	"./mr": 674,
	"./mr.js": 674,
	"./ms": 676,
	"./ms-my": 675,
	"./ms-my.js": 675,
	"./ms.js": 676,
	"./mt": 677,
	"./mt.js": 677,
	"./my": 678,
	"./my.js": 678,
	"./nb": 679,
	"./nb.js": 679,
	"./ne": 680,
	"./ne.js": 680,
	"./nl": 682,
	"./nl-be": 681,
	"./nl-be.js": 681,
	"./nl.js": 682,
	"./nn": 683,
	"./nn.js": 683,
	"./oc-lnc": 684,
	"./oc-lnc.js": 684,
	"./pa-in": 685,
	"./pa-in.js": 685,
	"./pl": 686,
	"./pl.js": 686,
	"./pt": 688,
	"./pt-br": 687,
	"./pt-br.js": 687,
	"./pt.js": 688,
	"./ro": 689,
	"./ro.js": 689,
	"./ru": 690,
	"./ru.js": 690,
	"./sd": 691,
	"./sd.js": 691,
	"./se": 692,
	"./se.js": 692,
	"./si": 693,
	"./si.js": 693,
	"./sk": 694,
	"./sk.js": 694,
	"./sl": 695,
	"./sl.js": 695,
	"./sq": 696,
	"./sq.js": 696,
	"./sr": 698,
	"./sr-cyrl": 697,
	"./sr-cyrl.js": 697,
	"./sr.js": 698,
	"./ss": 699,
	"./ss.js": 699,
	"./sv": 700,
	"./sv.js": 700,
	"./sw": 701,
	"./sw.js": 701,
	"./ta": 702,
	"./ta.js": 702,
	"./te": 703,
	"./te.js": 703,
	"./tet": 704,
	"./tet.js": 704,
	"./tg": 705,
	"./tg.js": 705,
	"./th": 706,
	"./th.js": 706,
	"./tk": 707,
	"./tk.js": 707,
	"./tl-ph": 708,
	"./tl-ph.js": 708,
	"./tlh": 709,
	"./tlh.js": 709,
	"./tr": 710,
	"./tr.js": 710,
	"./tzl": 711,
	"./tzl.js": 711,
	"./tzm": 713,
	"./tzm-latn": 712,
	"./tzm-latn.js": 712,
	"./tzm.js": 713,
	"./ug-cn": 714,
	"./ug-cn.js": 714,
	"./uk": 715,
	"./uk.js": 715,
	"./ur": 716,
	"./ur.js": 716,
	"./uz": 718,
	"./uz-latn": 717,
	"./uz-latn.js": 717,
	"./uz.js": 718,
	"./vi": 719,
	"./vi.js": 719,
	"./x-pseudo": 720,
	"./x-pseudo.js": 720,
	"./yo": 721,
	"./yo.js": 721,
	"./zh-cn": 722,
	"./zh-cn.js": 722,
	"./zh-hk": 723,
	"./zh-hk.js": 723,
	"./zh-mo": 724,
	"./zh-mo.js": 724,
	"./zh-tw": 725,
	"./zh-tw.js": 725
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1700;

/***/ }),

/***/ 1910:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1569)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(935),
  /* template */
  __webpack_require__(1958),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1911:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1588)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(937),
  /* template */
  __webpack_require__(1977),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1912:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1610)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(941),
  /* template */
  __webpack_require__(2001),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1913:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1563)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(942),
  /* template */
  __webpack_require__(1951),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-026cd335",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1914:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1567)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(943),
  /* template */
  __webpack_require__(1956),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-156bf33a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1915:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1592)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(944),
  /* template */
  __webpack_require__(1981),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7d2d56f8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1916:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1583)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(945),
  /* template */
  __webpack_require__(1972),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-48d9620c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1917:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1568)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(946),
  /* template */
  __webpack_require__(1957),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2160b31f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1918:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1579)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(947),
  /* template */
  __webpack_require__(1968),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3c376af6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1919:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1608)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(948),
  /* template */
  __webpack_require__(1998),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e2a0d496",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1920:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1602)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(949),
  /* template */
  __webpack_require__(1992),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b736bdde",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1921:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(950),
  /* template */
  __webpack_require__(2000),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1922:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1606)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(953),
  /* template */
  __webpack_require__(1996),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d0683510",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1923:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1572)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(954),
  /* template */
  __webpack_require__(1961),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-284ee59e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1924:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1587)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(957),
  /* template */
  __webpack_require__(1976),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-615432ba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1925:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1597)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(958),
  /* template */
  __webpack_require__(1987),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-96461186",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1926:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1605)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(959),
  /* template */
  __webpack_require__(1995),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cce5088a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1927:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1581)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(960),
  /* template */
  __webpack_require__(1970),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4089fdce",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1928:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1604)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(961),
  /* template */
  __webpack_require__(1994),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c8a1f744",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1929:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1574)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(962),
  /* template */
  __webpack_require__(1963),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-31177483",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1930:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1598)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(963),
  /* template */
  __webpack_require__(1988),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1931:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1601)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(964),
  /* template */
  __webpack_require__(1991),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1932:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1591)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(965),
  /* template */
  __webpack_require__(1980),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7bf4df85",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1933:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1586)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(966),
  /* template */
  __webpack_require__(1975),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1934:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1576)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(967),
  /* template */
  __webpack_require__(1965),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1935:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1577)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(968),
  /* template */
  __webpack_require__(1966),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-35bdad5b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1936:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1582)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(969),
  /* template */
  __webpack_require__(1971),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1937:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1565)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(970),
  /* template */
  __webpack_require__(1954),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0e556aa2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1938:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1585)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(971),
  /* template */
  __webpack_require__(1974),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1939:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1590)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(972),
  /* template */
  __webpack_require__(1979),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1940:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1584)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(973),
  /* template */
  __webpack_require__(1973),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1941:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1571)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(974),
  /* template */
  __webpack_require__(1960),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-26e7bd7a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1942:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1580)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(975),
  /* template */
  __webpack_require__(1969),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3e754a0e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1943:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1609)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(977),
  /* template */
  __webpack_require__(1999),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1944:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1593)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(978),
  /* template */
  __webpack_require__(1982),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1945:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1575)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(979),
  /* template */
  __webpack_require__(1964),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-33661b94",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1946:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1595)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(980),
  /* template */
  __webpack_require__(1985),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1947:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1603)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(981),
  /* template */
  __webpack_require__(1993),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1948:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1570)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(982),
  /* template */
  __webpack_require__(1959),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1949:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1607)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(983),
  /* template */
  __webpack_require__(1997),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1950:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1578)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(985),
  /* template */
  __webpack_require__(1967),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1951:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-checkbox__wrapper",
    class: [_vm.size ? _vm.size : 'm', _vm.checked ? 'checked' : 'unchecked'],
    on: {
      "click": function($event) {
        return _vm.$emit('click', $event)
      }
    }
  }, [_c('svg', {
    attrs: {
      "preserveAspectRatio": "xMidYMid meet",
      "x": "0px",
      "y": "0px",
      "widht": "100%",
      "height": "100%",
      "viewBox": "0 0 56.7 56.7"
    }
  }, [_c('polygon', {
    attrs: {
      "points": "47.9,11.8 44.9,8.8 28.3,25.3 11.8,8.8 8.8,11.8 25.3,28.3 8.8,44.9 11.8,47.9 28.3,31.4 44.9,47.9 \n\t47.9,44.9 31.4,28.3 "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0,0v56.7h56.7V0H0z M53.9,53.9h-51v-51h51V53.9z"
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 1952:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-map__wrapper"
  }, [_c('div', {
    staticClass: "ksm-map__page"
  }, [_c('div', {
    ref: "map-container",
    staticClass: "ksm-map__container"
  }), _vm._v(" "), _c('div', {
    staticClass: "ksm_map_infobox_container ksm-display-none"
  }, [_vm._l((_vm.fensterDataCollection), function(fensterData) {
    return [_c('div', {
      key: fensterData.type + '_' + fensterData.stadtindex,
      staticClass: "ksm-map__fenster",
      class: (!fensterData.visible && (fensterData.infoItem ? !fensterData.infoItem.fixied : true)) || (fensterData.type === 'ortsFenster' && fensterData.infoItems.length < 1) ? 'ksm-display-none' : '',
      attrs: {
        "data-stadtindex": fensterData.type + '_' + fensterData.stadtindex
      },
      on: {
        "mousedown": function($event) {
          return _vm.fensterMouseDown(fensterData, $event)
        }
      }
    }, [_c('div', {
      staticClass: "ksm-map__fenster-header"
    }, [_c('div', {
      staticClass: "ksm-flex-y-center"
    }, [(fensterData.infoItem) ? _c('div', {
      staticClass: "ksm-map__fenster-item-icon",
      style: ('background-color:' + fensterData.infoItem.accor.color)
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "ksm-map__fenster-title"
    }, [_vm._v(_vm._s(fensterData.stadtname))])]), _vm._v(" "), _c('div', {
      staticClass: "ksm-flex"
    }, [(fensterData.type === 'infoFenster') ? _c('div', {
      staticClass: "ksm-flex-y-center",
      staticStyle: {
        "padding": "5px"
      }
    }, [_c('div', {
      staticClass: "ksm-map__fenster-header-arror",
      domProps: {
        "innerHTML": _vm._s(_vm.$_getSvg('arrow-left-2.svg'))
      },
      on: {
        "click": function($event) {
          return _vm.navigatorInfoFenster(fensterData, -1)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "ksm-map__fenster-header-arror",
      domProps: {
        "innerHTML": _vm._s(_vm.$_getSvg('arrow-right-2.svg'))
      },
      on: {
        "click": function($event) {
          return _vm.navigatorInfoFenster(fensterData, 1)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "ksm-map__fenster-close",
      on: {
        "click": function($event) {
          return _vm.closeFenster(fensterData)
        }
      }
    }, [_vm._v("x")])])]), _vm._v(" "), _c('div', {
      staticClass: "ksm-map__fenster-body"
    }, [(fensterData.type === 'ortsFenster') ? _vm._l((fensterData.infoItems), function(infoItem, j) {
      return _c('div', {
        key: infoItem.row.docID + '' + j,
        staticClass: "ksm-map__fenster-item"
      }, [_c('div', {
        staticClass: "ksm-map__fenster-item-icon",
        style: ('background-color:' + infoItem.accor.color)
      }), _vm._v(" "), _c('a', {
        staticStyle: {
          "color": "#000"
        },
        on: {
          "mousedown": function($event) {
            return _vm.startClick($event)
          },
          "click": function($event) {
            return _vm.clickInfoItem(infoItem, $event)
          }
        }
      }, [_vm._v(_vm._s(infoItem.row._datvon) + " " + _vm._s(infoItem.row.ortsname))])])
    }) : _vm._e(), _vm._v(" "), (fensterData.infoItem) ? [_c('div', {
      staticClass: "ksm-flex-1"
    }, [(['Ausstellungen', 'Zeitschriften', 'Publikationen', 'Institution'].indexOf(fensterData.infoItem.row.Kategorie) > -1) ? _c('div', [_vm._v(_vm._s(fensterData.infoItem.row.titel))]) : _c('div', [_vm._v(_vm._s(fensterData.infoItem.row.ortsname))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(fensterData.infoItem.row.doc['113_titel']))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(fensterData.infoItem.row._datvon) + _vm._s(fensterData.infoItem.row._datbis ? (' – ' + fensterData.infoItem.row._datbis) : ''))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(fensterData.infoItem.row.doc['113_personen'] ? ('Personen: ' + fensterData.infoItem.row.doc['113_personen'].map(function (p) { return p.content; }).join('; ')) : ''))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(fensterData.infoItem.row.doc['113_instutionen'] ? ('Institutionen: ' + fensterData.infoItem.row.doc['113_instutionen'].map(function (p) { return p.content; }).join(', ')) : ''))]), _vm._v(" "), _c('div', {
      staticClass: "ksm-hyphens ksm-disable-select",
      staticStyle: {
        "overflow": "auto",
        "margin-top": "5px"
      },
      domProps: {
        "innerHTML": _vm._s(fensterData.infoItem.row.full_113_html)
      }
    })])] : _vm._e()], 2)])]
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "ksm-map__control-btn alle-ortsfenster-schliessen",
    attrs: {
      "title": "Alle Ortsfenster schließen"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('alle-ortsfenster-schliessen.svg'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ksm-map__control-btn alle-infofenster-schliessen",
    attrs: {
      "title": "Alle Infofenster schließen"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('alle-infofenster-schliessen.svg'))
    }
  })])], 2)]), _vm._v(" "), (!_vm.option.hideTimeline) ? _c('div', {
    staticClass: "ksm-map__timeline-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('TimelineView', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sidebarRightList[0].isExpand === true || _vm.sidebarRightList[1].isExpand === true),
      expression: "sidebarRightList[0].isExpand===true|| sidebarRightList[1].isExpand===true"
    }],
    attrs: {
      "splitLayoutResize": _vm.option.splitLayoutResize,
      "activeInfoItem": _vm.activeInfoItem,
      "infoItemList": _vm.timelineViewInput
    },
    on: {
      "clickInfoItem": _vm.clickInfoItem,
      "changeDate": _vm.changeDate
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex",
    staticStyle: {
      "justify-content": "flex-end"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "220px",
      "background-color": "#eee",
      "text-align": "center",
      "padding": "0 5px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://daeh.uni-trier.de/",
      "target": "_blank"
    }
  }, [_vm._v("© Karte 1928 aus Digital Atlas of European Historiography")])])])
}]}

/***/ }),

/***/ 1953:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),

/***/ 1954:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('keep-alive', [_c('div', {
    staticClass: "ksm-flex",
    staticStyle: {
      "background-color": "#fff"
    }
  }, [_c('ModusIndex', {
    attrs: {
      "viewKey": 'werbe'
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1955:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.aligen == 'vertical' ? '' : 'ksm-thumbnail__page--wrapper'
  }, [(_vm.aligen != 'vertical') ? _c('div', {
    staticClass: "ksm-thumbnail__page"
  }, [_c('div', {
    staticStyle: {
      "flex": "0 0 30px",
      "height": "100%"
    }
  }), _vm._v(" "), _vm._l((_vm.seiten), function(s, i) {
    return (s.variante == '') ? _c('img', {
      key: 'h' + i,
      staticClass: "ksm-thumbnail ksm-thumbnail--horizontal",
      class: i == _vm.seiteIdx ? ('active ' + _vm.modus) : _vm.modus,
      style: ('height:' + (_vm.imageHeight ? _vm.imageHeight : 125) + 'px'),
      attrs: {
        "title": s.name,
        "src": s.thumbnailSrc
      },
      on: {
        "click": function($event) {
          return _vm.selectItem(i)
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "0 0 30px",
      "height": "100%"
    }
  })], 2) : _vm._e(), _vm._v(" "), (_vm.aligen == 'vertical') ? _c('div', _vm._l((_vm.seiten), function(s, i) {
    return _c('div', {
      key: 'v' + i,
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('img', {
      staticClass: "ksm-thumbnail ksm-thumbnail--vertical",
      class: i == _vm.seiteIdx ? ('active ' + _vm.modus) : _vm.modus,
      attrs: {
        "src": s.thumbnailSrc
      },
      on: {
        "click": function($event) {
          return _vm.selectItem(i)
        }
      }
    })])
  }), 0) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1956:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "connect-wrapper",
    class: [_vm.rotate ? _vm.rotate : '', _vm.isConnected ? 'isConnected' : ''],
    on: {
      "mousedown": _vm.stopEvent
    }
  }, [_c('div', {
    staticClass: "connect-point"
  }), _vm._v(" "), _c('div', {
    staticClass: "connect-line"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.isConnected ? _vm.$_getIcon('icons8-connected-filled-50.png') : _vm.$_getIcon('icons8-connected-50.png')
    },
    on: {
      "mousedown": _vm.stopEvent,
      "click": _vm.doClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "connect-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "connect-point"
  })])
},staticRenderFns: []}

/***/ }),

/***/ 1957:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.person) ? _c('div', {
    staticClass: "g-person-merz__wrapper",
    class: _vm.modusOption ? (_vm.modusOption.key.replace('b_', '') + 'smodus') : 'default'
  }, [_vm._l((_vm.person.merzItems1), function(it, pi) {
    return [_c('div', {
      key: pi,
      staticClass: "ksm-flex-1"
    }, [_c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(it.merz.name.trim().replace('Merz', 'Merz ')) + "   ")]), _vm._v(" "), _vm._l((it.seiten), function(it2, pi2) {
      return [_vm._v("\n        " + _vm._s(pi2 > 0 ? ' •' : '') + "\n        "), _c('a', {
        key: 's' + pi2,
        class: _vm.isSeiteSelected(it, it2, _vm.person.lemmaID) ? 'ksm-acco-person-expand' : '',
        on: {
          "click": function($event) {
            return _vm.toPath(it, it2, _vm.person.lemmaID)
          }
        }
      }, [_vm._v(_vm._s(it2.name.length > 20 ? it2.name : it2.name.replace(/\s/g, ' ')))])]
    })], 2)]
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1958:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex-column",
    attrs: {
      "id": "ksm-app",
      "lang": "de"
    }
  }, [_c('header-view', {
    staticClass: "ksm-flex-00auto"
  }), _vm._v(" "), _c('keep-alive', {
    attrs: {
      "include": [
        'orteundwege',
        'modusstart',
        'medienOverview',
        'personen',
        'suche' ]
    }
  }, [_c('router-view', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "margin-bottom": "10px"
    }
  })], 1), _vm._v(" "), _c('footer-view', {
    staticClass: "ksm-flex-00auto"
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "ieModal"
    }
  }, [_c('div', {
    staticClass: "ksm-flex-column",
    staticStyle: {
      "padding": "10px",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "text-align": "center",
      "margin": "10px",
      "font-size": "18pt"
    }
  }, [_vm._v("\n        Ihr Browser wird nicht unterstützt\n      ")]), _vm._v(" "), _c('div', [_vm._v("\n        Diese Webseite verwendet moderne Webtechnologien die von aktuellen\n        Browsern unterstützt werden. Mit Internet Explorer kann es zu\n        Verzeichnungen und Überlagerungen kommen.\n      ")]), _vm._v(" "), _c('div', [_vm._v("\n        Bitte verwenden Sie anstatt dessen einen der folgenden Browser:\n      ")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "padding": "10px 20px"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.google.com/intl/de/chrome/",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Google Chrome")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.mozilla.org/de-de/firefox/new/",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Firefox")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.apple.com/safari/",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Safari")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.microsoft.com/windows/microsoft-edge",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Microsoft Edge")])])]), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-00auto",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "5px 20px",
      "background-color": "grey",
      "color": "#fff",
      "display": "inline-block",
      "border-radius": "2px"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('ieModal')
      }
    }
  }, [_vm._v("\n          Schließen\n        ")])])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1959:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex-1 ksm-flex-column",
    staticStyle: {
      "background-color": "#eee"
    }
  }, [_c('div', {
    staticClass: "ksm-flex-1 ksm-flex"
  }, [_c('div', {
    staticClass: "ksm-ursonate_note-wrapper"
  }, [_c('div', {
    staticClass: "ksm-flex-1 ksm-flex-column",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "ksm-flex-column",
    staticStyle: {
      "position": "absolute",
      "height": "100%",
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-00auto ksm-flex"
  }, [_c('div', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.midiData) ? _c('PlayerControls', {
    attrs: {
      "duration": _vm.duration,
      "currentTime": _vm.currentTime,
      "media": _vm.midiData,
      "mediaType": 'midi',
      "mediaName": _vm.meiName
    },
    on: {
      "seekbarChange": _vm.seekbarChange,
      "playPause": _vm.playPause
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(1)], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "ksm-ursonate_note"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex-y-center",
    staticStyle: {
      "position": "absolute",
      "height": "100%",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "ksm-ursonate_player",
    staticStyle: {
      "height": "0px",
      "overflow": "hidden",
      "width": "0px"
    }
  })])
}]}

/***/ }),

/***/ 1960:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex-xy-center"
  }, [_c('h1', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "color": "grey"
    }
  }, [_vm._v("Projektinfo")])])
}]}

/***/ }),

/***/ 1961:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-modus__komposition-wrapper"
  }, [_c('split-layout', {
    attrs: {
      "col": 2,
      "sidebar_right_collapse": false
    }
  }, [_c('div', {
    staticClass: "ksm-texte__modus-main",
    attrs: {
      "slot": "main-content"
    },
    slot: "main-content"
  }, [_vm._t("modusindex-toolbar"), _vm._v(" "), _c('div', {
    staticClass: "ksm-modus__komposition-main"
  }, [_c('div', {
    staticClass: "canvas-container-wrapper"
  }, [_c('div', {
    staticClass: "canvas-container"
  }, [_c('fabric-comp', {
    key: "deep_komposition_1",
    ref: "fabricComp",
    attrs: {
      "modusOption": _vm.modusOption,
      "seiteIdx": _vm.seiteIdx,
      "seiten": _vm.seiten
    },
    on: {
      "eventFromOSDViewer": _vm.updateRightViewer,
      "changePage": _vm.selectPage,
      "imageOpened": _vm.imageOpened
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-xy-center",
    staticStyle: {
      "width": "36px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "1px",
      "height": "100%",
      "background-color": "grey"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fasimily-container"
  }, [_c('fasimile-comp', {
    key: "deep_komposition_2",
    ref: "fasimileComp",
    attrs: {
      "modusOption": _vm.modusOption,
      "seiteIdx": _vm.seiteIdx,
      "seiten": _vm.seiten
    },
    on: {
      "eventFromOSDViewer": _vm.updateLeftViewer,
      "changePage": _vm.selectPage,
      "imageOpened": _vm.imageOpened
    }
  })], 1)])], 2), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-1 furniture",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "slot": "sidebar-2"
    },
    slot: "sidebar-2"
  }, [_c('sidebar-view', {
    attrs: {
      "readonly": "",
      "merz": _vm.merz,
      "modusOption": _vm.modusOption,
      "seiteIdx": _vm.seiteIdx
    },
    on: {
      "imgDragStart": _vm.handleDragStart,
      "imgDragEnd": _vm.handleDragEnd
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1962:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-texte__layout-wrapper"
  }, [_c('div', {
    staticClass: "ksm-flex-1 ksm-flex",
    on: {
      "mousemove": _vm.dragMove,
      "mouseup": _vm.dragStop
    }
  }, [(_vm.cols == 3) ? _c('div', {
    ref: "sidebar-1",
    staticClass: "ksm_texte__layout-sidebar",
    style: (_vm.styleSidebar1)
  }, [_vm._t("sidebar-1")], 2) : _vm._e(), _vm._v(" "), (_vm.cols == 3) ? _c('div', {
    staticClass: "ksm-resizer-wrapper--left"
  }, [_c('div', {
    staticClass: "ksm-resizer",
    staticStyle: {
      "left": "0"
    },
    on: {
      "mousedown": function($event) {
        return _vm.dragStart($event, true)
      }
    }
  }, [_c('div', {
    staticClass: "__pointer",
    class: _vm.modus,
    domProps: {
      "innerHTML": _vm._s(_vm.$_getIcon(_vm.leftCollapse ? 'arrow-right-2.svg' : 'arrow-left-2.svg'))
    },
    on: {
      "click": _vm.setCollapseLeft
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ksm-texte__layout--main"
  }, [_vm._t("main-content", function() {
    return [_vm._v("main slot in layout")]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "ksm-resizer-wrapper"
  }, [_c('div', {
    staticClass: "ksm-resizer",
    class: _vm.rightCollapse ? 'active' : '',
    on: {
      "mousedown": _vm.dragStart
    }
  }, [_c('div', {
    staticClass: "__pointer",
    class: _vm.modus,
    domProps: {
      "innerHTML": _vm._s(_vm.$_getIcon(_vm.rightCollapse ? 'arrow-left-2.svg' : 'arrow-right-2.svg'))
    },
    on: {
      "click": _vm.setCollapseRight
    }
  })])]), _vm._v(" "), _c('div', {
    ref: "sidebar-2",
    staticClass: "ksm_texte__layout-sidebar",
    style: (_vm.styleSidebar2)
  }, [_vm._t("sidebar-2")], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 1963:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "50px",
      "background-color": "#eee"
    }
  }, [_c('h1', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Förderer")]), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "src": _vm.$_getIcon('dfg_logo_schriftzug_blau_foerderung_4c.jpg')
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 1964:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex"
  }, [_c('ModusIndex', {
    attrs: {
      "viewKey": 'texte'
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1965:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex ksm-impressum-page",
    staticStyle: {
      "background-color": "#eee",
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "100%",
      "overflow": "auto"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.htmlText)
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 1966:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex-xy-center"
  }, [_c('h1', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "color": "grey"
    }
  }, [_vm._v("\n\t\tKontakt\t\t\t\n\t")])])
}]}

/***/ }),

/***/ 1967:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex-1 ksm-flex-column",
    staticStyle: {
      "background-color": "#eee"
    }
  }, [_c('div', {
    staticClass: "ksm-flex-1 ksm-flex"
  }, [_c('div', {
    staticClass: "ksm-flex-00auto"
  }, [_c('div', {
    staticClass: "ksm-medien__icon",
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('text.svg'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ksm-ursonate_osd-wrapper ksm-flex"
  }, [(_vm.seite) ? _c('DeepzoomView', {
    key: "deep_ursonate_texte",
    attrs: {
      "modusOption": _vm.modus.option,
      "seiteIdx": parseInt(_vm.localParams.seiteIdx, 10),
      "seiten": _vm.seiten
    },
    on: {
      "changePage": _vm.changeSeite
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-00auto ksm-flex",
    staticStyle: {
      "height": "100px",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "ksm-texte__modus_toolbar"
  }, [_c('div', {
    staticClass: "ksm-texte__merz-select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localParams.seiteIdx),
      expression: "localParams.seiteIdx"
    }],
    staticStyle: {
      "width": "auto"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.localParams, "seiteIdx", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.seiten), function(s, j) {
    return _c('option', {
      key: j,
      domProps: {
        "value": j + ''
      }
    }, [_vm._v(_vm._s(s.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "ksm-ursonate__thumbnail--wrapper"
  }, [(_vm.seiten) ? _c('div', {
    staticClass: "ksm-ursonate__thumbnail"
  }, [_c('Thumbnail', {
    attrs: {
      "seiten": _vm.seiten,
      "seiteIdx": parseInt(_vm.localParams.seiteIdx, 10),
      "aligen": 'horizontal',
      "imageHeight": 75
    },
    on: {
      "selectItem": _vm.changeSeite
    }
  })], 1) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),

/***/ 1968:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lds-ring",
    class: _vm.size ? _vm.size : 'default'
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])
},staticRenderFns: []}

/***/ }),

/***/ 1969:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-suche__page--wrapper"
  }, [_c('div', {
    staticClass: "ksm-suche__page"
  }, [_c('div', {
    staticClass: "ksm-suche__content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKeys),
      expression: "searchKeys"
    }],
    staticStyle: {
      "width": "50em",
      "padding": "5px"
    },
    attrs: {
      "type": "text",
      "autofocus": "true"
    },
    domProps: {
      "value": (_vm.searchKeys)
    },
    on: {
      "keydown": _vm.actionKeydown,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKeys = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "padding": "5px"
    },
    on: {
      "click": _vm.searchStart
    }
  }, [_vm._v("Suche")]), _vm._v(" "), (_vm.showLoading) ? _c('g-loading', {
    attrs: {
      "size": "mini"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.resultText))]), _vm._v(" "), (_vm.resultList) ? _c('div', {
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_vm._l((_vm.resultList), function(it, i) {
    return [_c('div', {
      key: i,
      staticClass: "ksm-flex-1",
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_c('div', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(it.merz.name.trim().replace('Merz', 'Merz ')))]), _vm._v(" "), _vm._l((it.seitenData), function(it2, pi2) {
      return [_c('div', {
        key: 's' + pi2
      }, [_vm._v(_vm._s(it2.seite.name.length > 20 ? it2.seite.name : it2.seite.name.replace(/\s/g, '')))]), _vm._v(" "), _vm._l((it2.hls), function(hl, hli) {
        return _c('div', {
          key: 'h' + hli + '-' + pi2,
          staticStyle: {
            "padding": "0 2em"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              return _vm.toPath(it, it2, hl.key)
            }
          }
        }, [_vm._v(_vm._s(hl.type))]), _vm._v(" "), _c('span', {
          staticClass: "ksm-suche-hl",
          domProps: {
            "innerHTML": _vm._s(hl.val)
          }
        })])
      })]
    })], 2)]
  })], 2) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1970:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-bibliographie__page--wrapper"
  }, [_c('div', {
    staticClass: "ksm-bibliographie__page"
  }, [_c('div', {
    staticClass: "ksm-bibliographie__content"
  }, _vm._l((_vm.bibliographie), function(bibl, key) {
    return _c('div', {
      key: key,
      staticClass: "ksm-bibliographie__categorie"
    }, [_c('div', {
      staticClass: "__title"
    }, [_vm._v(_vm._s(_vm.titles[key]))]), _vm._v(" "), _c('div', {
      staticClass: "__body"
    }, [_vm._l((bibl), function(p, i) {
      return [_c('div', {
        key: 'p' + i,
        staticClass: "ksm-bibliographie__item",
        class: _vm.keyitem == p.keyitem.toLowerCase() ? 'active' : '',
        attrs: {
          "data-keyitem": _vm.getKeyItem(p, this)
        }
      }, [_c('div', {
        staticClass: "__subtitle"
      }, [_vm._v("[" + _vm._s(p.shorttitle) + "]")]), _vm._v(" "), _c('div', {
        staticClass: "__content",
        domProps: {
          "innerHTML": _vm._s(p.bib)
        }
      })])]
    })], 2)])
  }), 0)])])
},staticRenderFns: []}

/***/ }),

/***/ 1971:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex-xy-center"
  }, [_c('h1', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "color": "grey"
    }
  }, [_vm._v("\n   Kunstwerke\n  ")])])
}]}

/***/ }),

/***/ 1972:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.list)
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 1973:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-personen__page--wrapper"
  }, [_c('SplitLayout', {
    attrs: {
      "cols": 2,
      "sidebar_right_width": 'width:40%;'
    }
  }, [_c('div', {
    staticClass: "ksm-texte__modus-main",
    staticStyle: {
      "padding": "50px 10px"
    },
    attrs: {
      "slot": "main-content"
    },
    slot: "main-content"
  }, [_c('div', {
    staticClass: "ksm-flex-1 ksm-flex-x-center"
  }, [_c('div', {
    staticClass: "ksm-sidebar__container",
    staticStyle: {
      "max-width": "600px"
    }
  }, [_c('div', {
    staticClass: "ksm-accordion__header",
    staticStyle: {
      "border-top-color": "transparent",
      "border-bottom": "2px solid rgb(162, 173, 186)"
    }
  }, [_c('div', {
    staticClass: "ksm-flex-1 ksm-flex",
    staticStyle: {
      "align-items": "center",
      "margin-left": "10px"
    }
  }, [_vm._v("Biographie")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.personenText)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "slot": "sidebar-2"
    },
    slot: "sidebar-2"
  }, [(_vm.personenCollection2) ? _c('div', {
    staticClass: "ksm-sidebar__wrapper"
  }, [_c('div', {
    staticClass: "ksm-sidebar__container"
  }, [_c('div', {
    staticClass: "ksm-accordion__header",
    staticStyle: {
      "border-top-color": "transparent",
      "border-bottom": "2px solid rgb(162, 173, 186)"
    }
  }, [_c('div', {
    staticClass: "ksm-flex-1 ksm-flex",
    staticStyle: {
      "align-items": "center",
      "margin-left": "10px"
    }
  }, [_vm._v("Personen")])]), _vm._v(" "), _c('div', {
    ref: "scrollElement",
    staticClass: "ksm-personen__list-container"
  }, [_c('div', {
    staticClass: "ksm-accordion__content"
  }, _vm._l((_vm.personenCollection2), function(p, i) {
    return _c('div', {
      key: 'p' + i,
      attrs: {
        "id": 'pers_' + p.lemmaID
      }
    }, [_c('div', {
      staticClass: "ksm-personen__title ksm-flex-y-center",
      class: _vm.selectedIdx === i ? '__active' : '',
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('div', {
      staticClass: "ksm-personen__content",
      on: {
        "click": function($event) {
          _vm.selectedIdx = i
        }
      }
    }, [_vm._v(_vm._s(p.content))]), _vm._v(" "), (p.text) ? _c('div', {
      staticClass: "ksm-personen__has",
      domProps: {
        "innerHTML": _vm._s(_vm.$_getSvg('id-card.svg'))
      },
      on: {
        "click": function($event) {
          _vm.selectedIdx = i
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(" (" + _vm._s(p.docIds.length) + ")")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "20px",
        "width": "20px"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.$_getIcon(_vm.personenExpandIdx.indexOf(p.lemmaID) > -1 ? 'arrow-down.svg' : 'arrow-right.svg'))
      },
      on: {
        "click": function($event) {
          return _vm.togglePersonItem(p.lemmaID)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ksm-accordion__body",
      class: _vm.personenExpandIdx.indexOf(p.lemmaID) > -1 ? '' : 'ksm-accordion__collapse',
      staticStyle: {
        "background-color": "transparent",
        "border-width": "0",
        "padding": "0 10px"
      }
    }, [_c('g-person-merz', {
      staticStyle: {
        "font-size": "10pt",
        "padding-left": "15px"
      },
      attrs: {
        "person": p
      }
    })], 1)])
  }), 0)])])]) : _vm._e()])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1974:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "ksm-navbar"
  }, [_vm._l((_vm.navList), function(it, i) {
    return [_c('a', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: (it.disable ? _vm.tooltipOption : ''),
        expression: "it.disable?tooltipOption:''"
      }],
      key: i,
      staticClass: "ksm-navitem ksm-link-text",
      class: {
        active: it.names.indexOf(_vm.routeName) > -1,
        disable: it.disable
      },
      on: {
        "click": function($event) {
          return _vm.toPage(it)
        }
      }
    }, [_vm._v(_vm._s(it.label))])]
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1975:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-home__page-wrapper"
  }, [_c('div', {
    staticClass: "ksm-home__page-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "ksm-home__page"
  }, [_c('div', {
    staticClass: "ksm-home__content",
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('schwitters_startseite.svg'))
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 1976:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-modus__untersuchung-wrapper"
  }, [_c('split-layout', {
    attrs: {
      "cols": 2
    }
  }, [_c('div', {
    staticClass: "ksm-texte__modus-main",
    attrs: {
      "slot": "main-content"
    },
    slot: "main-content"
  }, [_vm._t("modusindex-toolbar"), _vm._v(" "), _c('div', {
    staticClass: "ksm-modus__untersuchung-main-wrapper"
  }, [_c('div', {
    staticClass: "ksm-modus__untersuchung-main"
  }, [_c('div', {
    staticClass: "ksm-flex-1"
  }, [_c('deepzoom-view', {
    key: "keep_untersuchung_1",
    attrs: {
      "modusOption": _vm.modusOption,
      "seiteIdx": _vm.seiteIdx,
      "seiten": _vm.seiten
    },
    on: {
      "changePage": _vm.changeSeite
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "ksm-untersuchung-footer"
  }, [_c('foot-thumbnail', {
    attrs: {
      "seiten": _vm.seiten,
      "seiteIdx": _vm.seiteIdx,
      "aligen": 'horizontal'
    },
    on: {
      "selectItem": _vm.changeSeite
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "slot": "sidebar-2"
    },
    slot: "sidebar-2"
  }, [_c('sidebar-view', {
    attrs: {
      "merz": _vm.merz,
      "modusOption": _vm.modusOption,
      "seiteIdx": _vm.seiteIdx
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1977:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-deepzoom__page-wrapper ksm-flex-column"
  }, [_c('div', {
    staticClass: "ksm-fabricview__toolbar"
  }, [(_vm.showColorPicker) ? _c('photoshop-picker', {
    staticStyle: {
      "position": "absolute",
      "z-index": "100"
    },
    on: {
      "ok": _vm.actionOk,
      "cancel": _vm.actionCancel,
      "input": _vm.changeBackgroundColor
    },
    model: {
      value: (_vm.backgroundColor),
      callback: function($$v) {
        _vm.backgroundColor = $$v
      },
      expression: "backgroundColor"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "osdButtonsDiv",
    staticClass: "ksm-disable-select osdButtonsDiv"
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".json",
      "id": "loadSetup"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex"
  }, [_c('div', {
    staticClass: "ksm-fabricview__btn",
    attrs: {
      "title": "Komposition neu"
    },
    on: {
      "click": _vm.resetCanvas
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('komposition-neu.svg'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ksm-fabricview__btn",
    attrs: {
      "title": "Komposition öffnen"
    },
    on: {
      "click": _vm.openFilemanager
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('konfiguration_oeffnen.svg'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ksm-fabricview__btn",
    attrs: {
      "title": "Komposition speichern"
    },
    on: {
      "click": _vm.speichern
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('konfiguration_speichern.svg'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ksm-fabricview__btn",
    attrs: {
      "title": "Komposition exportieren"
    },
    on: {
      "click": _vm.exportieren
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('komposition-exportieren.svg'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ksm-fabricview__btn",
    attrs: {
      "title": "löschen"
    },
    on: {
      "click": _vm.removeObject
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('komposition-loeschen.svg'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ksm-fabricview__btn",
    attrs: {
      "title": "in den vordergrund"
    },
    on: {
      "click": _vm.vordergrundObject
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('ebene-tiefer.svg'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ksm-fabricview__btn",
    attrs: {
      "title": "in den hintergrund"
    },
    on: {
      "click": _vm.hintergrundObject
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('ebene-hoeher.svg'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ksm-fabricview__btn",
    on: {
      "click": function($event) {
        _vm.showColorPicker = true
      }
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('farbe-waehlen.svg'))
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ksm-deepzoom__page ksm-flex-1",
    style: ('background-color:' + _vm.backgroundColor)
  }, [_c('div', {
    staticClass: "ksm-position-absolute ksm-flex"
  }, [_c('div', {
    staticClass: "ksm-deepzoom__body",
    attrs: {
      "id": _vm.containerId
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    ref: "infobox_template",
    staticClass: "ksm-gummi__end-overlay",
    class: _vm.modusOption.key
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "__body"
  })]), _vm._v(" "), _c('div', {
    ref: "popup-menu_template",
    staticClass: "ksm-deepzoom__popupmenu-overlay"
  }, [_vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "__head ksm-flex"
  }, [_c('div', {
    staticClass: "__title ksm-flex-1 ksm-flex"
  }), _vm._v(" "), _c('div', {
    staticClass: "__close-infobox"
  }, [_vm._v("x")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex"
  }, [_c('div', {
    staticClass: "ksm-deepzoom__popupmenu__color-rect"
  }), _vm._v(" "), _c('div', {
    staticClass: "ksm-deepzoom__popup-menuitem"
  })])
}]}

/***/ }),

/***/ 1978:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.mediaType !== 'midi') ? _c('div', {
    staticClass: "ksm-player__controls-row",
    staticStyle: {
      "border-bottom": "0",
      "background-color": "#d9d9da"
    }
  }, [_c('div', {
    staticClass: "ksm-player-btn"
  }), _vm._v(" "), _c('div', {
    staticClass: "ksm-player__row-middle",
    staticStyle: {
      "border": "0",
      "background-color": "#d9d9da",
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "ksm-flex",
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "overflow": "hidden",
      "height": "100%",
      "padding": "0 15px"
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "height": "500",
      "viewBox": "0 0 3000 500",
      "preserveAspectRatio": "xMinYMin meet"
    }
  }, _vm._l((_vm.svgData), function(d, i) {
    return _c('g', {
      key: i
    }, [_c('rect', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: (d.tooltipOpt),
        expression: "d.tooltipOpt"
      }],
      class: d.class,
      attrs: {
        "x": d.x,
        "width": d.width,
        "height": "100%"
      }
    })])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "ksm-player-btn",
    staticStyle: {
      "background-color": "#d9d9da"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ksm-player__controls-row"
  }, [_c('g-play-btn', {
    style: (_vm.playBtnDisable ? 'opacity:0.2' : ''),
    attrs: {
      "isPlaying": _vm.isPlaying
    },
    on: {
      "click": function($event) {
        return _vm.play(1)
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-player__row-middle"
  }, [_c('input', {
    staticClass: "ksm-player__seekbar",
    attrs: {
      "type": "range",
      "value": "0"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "ksm-player-btn ksm-player-btn ksm-player-mute",
    attrs: {
      "type": "button"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(421)
    }
  })])
}]}

/***/ }),

/***/ 1979:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-page-wrapper"
  }, [_c('split-layout', {
    attrs: {
      "cols": _vm.showTextInfo ? 3 : 2,
      "sidebar_left_width": 'width:20% ',
      "sidebar_right_width": 'width:600px;'
    },
    on: {
      "clickCollapse": _vm.clickCollapse,
      "dragStop": _vm.dragStop
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTextInfo),
      expression: "showTextInfo"
    }],
    staticClass: "ksm-flex-1",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "slot": "sidebar-1"
    },
    slot: "sidebar-1"
  }, [_c('SidebarView', {
    attrs: {
      "list": _vm.sidebarLeftList,
      "hiddenToolbar": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ksm-texte__modus-main",
    attrs: {
      "slot": "main-content"
    },
    slot: "main-content"
  }, [(_vm.geoData) ? [_c('MapView', {
    attrs: {
      "geoData": _vm.geoData,
      "option": _vm.mapOption
    },
    on: {
      "inited": _vm.mapInited
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "slot": "sidebar-2"
    },
    slot: "sidebar-2"
  }, [_c('SidebarView', {
    attrs: {
      "list": _vm.sidebarRightList
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1980:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex-xy-center"
  }, [_c('h1', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "color": "grey"
    }
  }, [_vm._v("Hilfe")])])
}]}

/***/ }),

/***/ 1981:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "player-btn",
    class: [_vm.size ? _vm.size : 'm'],
    attrs: {
      "type": "button"
    },
    on: {
      "mousedown": _vm.stopEvent,
      "click": _vm.doClick
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.isPlaying ? _vm.$_getIcon('icons8-pause-24.png') : _vm.$_getIcon('icons8-play-24.png')
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 1982:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-texte__start-wrapper"
  }, [_c('div', {
    staticClass: "ksm-texte__start-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "ksm-texte__start"
  }, [_c('div', {
    staticClass: "ksm-merz-container"
  }, [_c('img', {
    staticClass: "ksm-merz-png",
    attrs: {
      "src": "static/icons/schwitters_hefte_2019_01_p01.png"
    }
  })])])])
}]}

/***/ }),

/***/ 1983:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),

/***/ 1984:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: 'siderbar' + _vm.modusOption.key,
    staticClass: "ksm-sidebar__wrapper"
  }, [_c('div', {
    staticClass: "ksm-sidebar__container",
    style: (_vm.sidebarPageStyle)
  }, [_vm._l((_vm.accordionList), function(it, i) {
    return [_c('div', {
      key: 't' + i,
      staticClass: "ksm-accordion__header",
      style: (i == 0 ? 'border-top-color:transparent' : '')
    }, [(_vm.modusOption.key !== 'ansicht' && _vm.modusOption.key !== 'komposition') ? _c('div', {
      staticStyle: {
        "width": "22px",
        "height": "100%",
        "padding": "3px"
      },
      domProps: {
        "innerHTML": _vm._s(!_vm.showArrow ? '' : _vm.$_getIcon(_vm.openedAccordionId === it.id ? 'arrow-down.svg' : 'arrow-right.svg'))
      },
      on: {
        "click": function($event) {
          return _vm.selectItem(it.id)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "ksm-flex-1 ksm-flex",
      staticStyle: {
        "align-items": "center"
      },
      style: ((_vm.modusOption.key === 'ansicht' || _vm.modusOption.key === 'komposition') ? 'margin-left:10px' : ''),
      on: {
        "click": function($event) {
          return _vm.selectItem(it.id)
        }
      }
    }, [_vm._v(_vm._s(it.label))]), _vm._v(" "), (it.transcriptButtonEnable || it.kategorieButtonEnable) ? _c('div', {
      staticClass: "ksm-accordion__header-tool",
      class: it.id
    }, [(it.transcriptButtonEnable) ? _c('div', {
      staticClass: "ksm-accordion__svg-btn",
      class: it.transcriptButtonChecked ? '__aktiv' : 'inaktiv',
      staticStyle: {
        "width": "40px"
      },
      domProps: {
        "innerHTML": _vm._s(it.transcriptButtonChecked ? _vm.$_getSvg('transkriptionen-aktiv.svg') : _vm.$_getSvg('transkriptionen-inaktiv.svg'))
      },
      on: {
        "click": function($event) {
          it.transcriptButtonChecked = !it.transcriptButtonChecked
        }
      }
    }) : _vm._e(), _vm._v(" "), (it.kategorieButtonEnable) ? _c('div', {
      staticClass: "ksm-accordion__svg-btn",
      class: it.kategorieButtonChecked ? '__aktiv' : 'inaktiv',
      staticStyle: {
        "width": "20px"
      },
      domProps: {
        "innerHTML": _vm._s(it.kategorieButtonChecked ? _vm.$_getSvg('relationen-aktiv.svg') : _vm.$_getSvg('relationen-inaktiv.svg'))
      },
      on: {
        "click": function($event) {
          it.kategorieButtonChecked = !it.kategorieButtonChecked
        }
      }
    }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
      key: 'b' + i,
      staticClass: "ksm-accordion__body",
      class: _vm.openedAccordionId === it.id ? ('ksm-accordion__expand ' + _vm.modusOption.key + 'smodus') : 'ksm-accordion__collapse ' + _vm.modusOption.key + 'smodus',
      on: {
        "click": _vm.handleMouseclick,
        "mouseover": _vm.handleMouseover,
        "mouseout": _vm.handleMouseout
      }
    }, [_c('div', {
      staticClass: "ksm-accordion__content"
    }, [(it.id == 'acco_kommentar') ? _c('div', {
      staticStyle: {
        "padding-bottom": "10px"
      }
    }, _vm._l((_vm.mainKommentar), function(mk, mki) {
      return _c('div', {
        key: mki,
        staticClass: "ksm-accordion__section",
        domProps: {
          "innerHTML": _vm._s(mk)
        }
      })
    }), 0) : _vm._e(), _vm._v(" "), (['acco_uebersetzung', 'acco_relation'].indexOf(it.id) > -1 && _vm.noteHtmlData) ? _c('div', {
      staticStyle: {
        "padding": "10px 0px"
      }
    }, _vm._l((_vm.noteHtmlData[it.id]), function(n, j) {
      return _c('div', {
        key: j,
        domProps: {
          "innerHTML": _vm._s(n)
        }
      })
    }), 0) : _vm._e(), _vm._v(" "), (it.id === 'acco_einzelstellenkommentare' && _vm.noteHtmlData) ? _c('div', _vm._l((_vm.noteHtmlData[it.id]), function(n, j) {
      return _c('div', {
        key: j,
        domProps: {
          "innerHTML": _vm._s(n)
        }
      })
    }), 0) : _vm._e(), _vm._v(" "), (it.id === 'acco_elementebibliothek') ? _c('div', {
      staticClass: "ksm-flex",
      staticStyle: {
        "flex-wrap": "wrap"
      }
    }, _vm._l((_vm.cropImageList), function(obj, oi) {
      return _c('div', {
        key: 'o' + oi,
        staticClass: "ksm-flex-xy-center",
        staticStyle: {
          "padding": "5px",
          "width": "100px",
          "height": "100px",
          "border": "1px solid #fff",
          "margin": "5px"
        },
        attrs: {
          "data-acco": it.id + '#' + obj.id,
          "data-transcript": [obj.id]
        }
      }, [_c('img', {
        staticStyle: {
          "max-width": "100%",
          "max-height": "100%"
        },
        attrs: {
          "data-trid": obj.id,
          "draggable": "true",
          "src": obj.src
        },
        on: {
          "dragstart": _vm.imgDragStart,
          "dragend": _vm.imgDragEnd
        }
      })])
    }), 0) : _vm._e(), _vm._v(" "), (it.id == 'acco_personen') ? _c('div', _vm._l((_vm.personen), function(p, pi) {
      return _c('div', {
        key: pi,
        staticStyle: {
          "margin": "5px 10px"
        }
      }, [_c('div', {
        staticClass: "ksm-flex-y-center",
        attrs: {
          "data-pid": p.lemmaID
        }
      }, [_c('div', {
        staticClass: "div-with-transcript",
        attrs: {
          "data-acco": it.id + '#' + p.lemmaID,
          "data-transcript": p.transcripts.join(',')
        }
      }, [_vm._v(_vm._s(p.content))]), _vm._v(" "), _c('div', {
        staticStyle: {
          "margin": "0 0.2em"
        }
      }, [_vm._v("(" + _vm._s(p.docIds.length) + ")")]), _vm._v(" "), _c('div', {
        staticClass: "ksm-user-circle",
        domProps: {
          "innerHTML": _vm._s(_vm.$_getSvg('id-card.svg'))
        },
        on: {
          "click": function($event) {
            return _vm.gotoPerson(p)
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "ksm-user-arrow",
        domProps: {
          "innerHTML": _vm._s(_vm.$_getIcon(_vm.isAccoPersonExpand(p.lemmaID) ? 'arrow-down.svg' : 'arrow-right.svg'))
        },
        on: {
          "click": function($event) {
            return _vm.togglePersonItem(p.lemmaID)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "ksm-accordion__body",
        class: _vm.isAccoPersonExpand(p.lemmaID) ? '' : 'ksm-accordion__collapse',
        staticStyle: {
          "border-width": "0",
          "padding": "0 10px"
        }
      }, [_c('g-person-merz', {
        staticStyle: {
          "font-size": "10pt",
          "padding-left": "15px"
        },
        attrs: {
          "modusOption": _vm.modusOption,
          "person": p
        }
      })], 1)])
    }), 0) : _vm._e(), _vm._v(" "), (it.id == 'acco_inventarisierung') ? _c('div', _vm._l((_vm.acco_inventarisierung), function(inv, j) {
      return _c('div', {
        key: j,
        staticStyle: {
          "padding": "5px"
        },
        style: (j > 0 ? 'border-top:1px solid #fff' : '')
      }, _vm._l((inv.data), function(inv_d, j_d) {
        return _c('div', {
          key: j_d,
          staticStyle: {
            "margin": "5px 0"
          }
        }, [_c('span', {
          staticStyle: {
            "font-weight": "bold"
          }
        }, [_vm._v(_vm._s(inv_d.label))]), _vm._v(": " + _vm._s(inv_d.value))])
      }), 0)
    }), 0) : _vm._e(), _vm._v(" "), (it.id == 'acco_transkription') ? _c('div', [_c('div', {
      staticStyle: {
        "padding": "5px"
      }
    }, _vm._l((_vm.seite.$_docInfo), function(n, j) {
      return _c('div', {
        key: j,
        domProps: {
          "innerHTML": _vm._s(n._source['98_html'])
        }
      })
    }), 0)]) : _vm._e(), _vm._v(" "), (it.id == 'acco_orte') ? _c('div', {
      staticClass: "ksm-texte__modus-main"
    }, [_vm._l((_vm.orte), function(ort, oi) {
      return _c('div', {
        key: oi,
        staticClass: "div-with-transcript ksm-flex-y-center",
        staticStyle: {
          "margin": "5px 10px"
        },
        attrs: {
          "data-acco": it.id + '#' + ort.ID,
          "data-transcript": ort.transcripts.join(',')
        }
      }, [_vm._v(_vm._s(ort.content))])
    }), _vm._v(" "), (_vm.openedAccordionId === 'acco_orte') ? [(_vm.ortGeoData) ? _c('MapView', {
      attrs: {
        "geoData": _vm.ortGeoData,
        "option": {
          hideTimeline: true,
          zoom: 3
        }
      },
      on: {
        "inited": _vm.mapInited
      }
    }) : _vm._e()] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (it.id == 'acco_themen') ? _c('div', _vm._l((_vm.themen), function(th, j) {
      return _c('div', {
        key: j,
        staticStyle: {
          "padding": "5px"
        }
      }, [_c('div', {
        staticClass: "div-with-transcript ksm-flex-y-center",
        class: th.class + '-hover',
        attrs: {
          "data-acco": it.id + '#' + th.info.ID,
          "data-transcript": th.transcripts.join(',')
        },
        on: {
          "click": function($event) {
            th.checked = !th.checked
          }
        }
      }, [_c('div', {
        class: th.checked ? th.class : '',
        staticStyle: {
          "width": "15px",
          "height": "15px",
          "margin-right": "5px",
          "border": "1px solid #000"
        }
      }), _vm._v("\n                " + _vm._s(th.info.content) + "\n              ")])])
    }), 0) : _vm._e(), _vm._v(" "), (it.id == 'acco_seitenvorschau') ? [_c('Thumbnail', {
      attrs: {
        "seiten": _vm.seiten,
        "seiteIdx": _vm.seiteIdx,
        "aligen": 'vertical'
      },
      on: {
        "selectItem": _vm.selectThumbnail
      }
    })] : _vm._e(), _vm._v(" "), (it.id != 'acco_orte') ? _c('div', {
      staticStyle: {
        "height": "100px"
      }
    }) : _vm._e()], 2)])]
  })], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 1985:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex-1 ksm-flex-column"
  }, [_c('div', {
    staticClass: "ksm-flex-1 ksm-flex"
  }, [_c('div', {
    staticClass: "ksm-flex-00auto"
  }, [_c('div', {
    staticClass: "ksm-medien__icon",
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('audio.svg'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "ksm-media-wrapper"
  }, [_c('div', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "text-align": "center",
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('img', {
    staticClass: "ksm-schallplatten",
    staticStyle: {
      "max-height": "100%",
      "max-width": "100%",
      "bottom": "0"
    },
    attrs: {
      "src": _vm.selected_audio === 'Audio1924' ? _vm.$_getIcon('1923.png') : _vm.$_getIcon('1932.png')
    }
  })])]), _vm._v(" "), _c('audio', {
    staticClass: "ksm-media"
  }, [_c('source', {
    attrs: {
      "src": './static/multimedia/' + _vm.audioSrc,
      "type": "audio/mpeg"
    }
  }), _vm._v("Your browser does not support the audio element.\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-00auto ksm-flex"
  }, [_c('div', {
    staticClass: "ksm-flex-00auto ksm-flex-column"
  }, [_c('div', [_c('div', {
    staticClass: "ksm-medien__audio-select"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected_audio),
      expression: "selected_audio"
    }],
    attrs: {
      "type": "radio",
      "name": "ksm_audio_radio",
      "id": "ksm-radio__audio-1924",
      "value": "Audio1924"
    },
    domProps: {
      "checked": _vm._q(_vm.selected_audio, "Audio1924")
    },
    on: {
      "change": function($event) {
        _vm.selected_audio = "Audio1924"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ksm-radio__audio-1924"
    }
  }, [_vm._v("Originalaufnahme 1924")])]), _vm._v(" "), _c('div', {
    staticClass: "ksm-medien__audio-select"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected_audio),
      expression: "selected_audio"
    }],
    attrs: {
      "type": "radio",
      "name": "ksm_audio_radio",
      "id": "ksm-radio__audio-1932",
      "value": "Audio1932"
    },
    domProps: {
      "checked": _vm._q(_vm.selected_audio, "Audio1932")
    },
    on: {
      "change": function($event) {
        _vm.selected_audio = "Audio1932"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ksm-radio__audio-1932"
    }
  }, [_vm._v("Originalaufnahme 1932")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-1 ksm-flex-column"
  }, [_c('div', {
    staticClass: "ksm-flex-1 ksm-flex"
  }), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-00auto"
  }, [(_vm.media) ? _c('PlayerControls', {
    attrs: {
      "media": _vm.media,
      "mediaType": "audio",
      "mediaName": _vm.selected_audio
    },
    on: {
      "audioChange": _vm.audioChange,
      "playPause": _vm.playPause
    }
  }) : _vm._e()], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 1986:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-sidebar__wrapper"
  }, [_c('div', {
    staticClass: "ksm-sidebar__container"
  }, [_vm._l((_vm.list), function(accor, i) {
    return [_c('div', {
      key: 't' + i,
      staticClass: "ksm-accordion__header",
      style: (i == 0 ? 'border-top-color:transparent' : '')
    }, [_c('div', {
      staticStyle: {
        "width": "22px",
        "height": "100%",
        "padding": "3px"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.$_getIcon(_vm.openedAccordionId === i ? 'arrow-down.svg' : 'arrow-right.svg'))
      },
      on: {
        "click": function($event) {
          return _vm.clickAccordion(accor)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "ksm-flex-1 ksm-flex",
      staticStyle: {
        "align-items": "center"
      },
      on: {
        "click": function($event) {
          return _vm.clickAccordion(accor)
        }
      }
    }, [_vm._v(_vm._s(accor.label))]), _vm._v(" "), (!_vm.hiddenToolbar) ? _c('div', {
      staticClass: "ksm-accordion__header-tool",
      staticStyle: {
        "width": "40px"
      }
    }, [_c('div', {
      staticClass: "ksm-icon-circle",
      style: (accor.checked ? 'background-color:' + accor.color : ''),
      on: {
        "click": function($event) {
          return _vm.clickColorCBX(accor)
        }
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      key: 'b' + i,
      staticClass: "ksm-accordion__body",
      class: accor.isExpand ? 'ksm-accordion__expand' : 'ksm-accordion__collapse'
    }, [_c('div', {
      staticClass: "ksm-orteundwege__accordion-container"
    }, [(accor.isInfoText) ? [_c('div', {
      staticClass: "ksm-hyphens",
      attrs: {
        "lang": "de"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.infoText)
      }
    })] : (accor.id !== 'merzgebiete') ? [_c('table', {
      staticStyle: {
        "width": "100%"
      }
    }, _vm._l((accor.infoItems), function(infoItem, pi) {
      return _c('tr', {
        key: 'infoItem' + pi,
        staticClass: "ksm-orteundwege__accordion-row",
        class: infoItem === _vm.activeInfoItem ? '__' + accor.id + '-active' : '__' + accor.id,
        on: {
          "click": function($event) {
            return _vm.clickInfoItem(infoItem)
          }
        }
      }, [(['holland', 'merzabende'].indexOf(accor.id) > -1) ? [_c('td', [_vm._v(_vm._s(infoItem.row._datvon) + _vm._s(infoItem.row._datbis ? (' – ' + infoItem.row._datbis) : ''))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "min-width": "83pt"
        }
      }, [_vm._v(_vm._s(infoItem.row.stadtname ? infoItem.row.stadtname : infoItem.row.ortsname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(!infoItem.row.stadtname ? '' : infoItem.row.ortsname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(infoItem.row.short_113_html))])] : _vm._e(), _vm._v(" "), (['ausstellung'].indexOf(accor.id) > -1) ? [_c('td', {
        staticStyle: {
          "max-width": "50pt"
        }
      }, [_vm._v(_vm._s(infoItem.row._datvon) + _vm._s(infoItem.row._datbis ? (' – ' + infoItem.row._datbis) : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(infoItem.row.titel))])] : _vm._e(), _vm._v(" "), (['veranstaltung', 'veröffentlichung', 'institutionen'].indexOf(accor.id) > -1) ? [_c('td', [_vm._v(_vm._s(infoItem.row._datvon) + _vm._s(infoItem.row._datbis ? (' – ' + infoItem.row._datbis) : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(infoItem.row.stadtname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(infoItem.row.ortsname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(infoItem.row.titel))])] : _vm._e()], 2)
    }), 0)] : (accor.id === 'merzgebiete') ? _vm._l((accor.merzgebiete), function(mg, mi) {
      return _c('div', {
        key: 'mg' + mi
      }, [_c('div', {
        staticClass: "ksm-flex-y-center"
      }, [_c('div', {
        staticClass: "ksm-orteundwege__merzgebiete-icon",
        style: (mg.checked ? 'background-color:' + mg.color : ''),
        on: {
          "click": function($event) {
            mg.checked = !mg.checked
          }
        }
      }), _vm._v("\n                " + _vm._s(mg.name) + "\n              ")])])
    }) : _vm._e()], 2)])]
  })], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 1987:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-modus__vergleich-wrapper"
  }, [_c('split-layout', {
    attrs: {
      "cols": 3,
      "sidebar_left_collapse": _vm.sidebar_left_collapse,
      "sidebar_right_collapse": _vm.sidebar_right_collapse
    }
  }, [_c('div', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "slot": "sidebar-1"
    },
    slot: "sidebar-1"
  }, [_c('sidebar-view', {
    attrs: {
      "merz": _vm.merz,
      "modusOption": _vm.modusOption,
      "sidebarPageStyle": 'margin: 10px 20px 10px 15px',
      "seiteIdx": _vm.seiteIdx
    },
    on: {
      "changeSeite": _vm.changeSeite
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ksm-texte__modus-main",
    attrs: {
      "slot": "main-content"
    },
    slot: "main-content"
  }, [_vm._t("modusindex-toolbar"), _vm._v(" "), _c('div', {
    staticClass: "ksm-modus__vergleich-main"
  }, [_c('div', {
    staticClass: "ksm-vergleich-content"
  }, [_c('deepzoom-view', {
    key: "deep_vergleich_1",
    attrs: {
      "modusOption": _vm.modusOption,
      "seiteIdx": _vm.seiteIdx,
      "seiten": _vm.seiten
    },
    on: {
      "changePage": _vm.changeSeite
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-xy-center",
    staticStyle: {
      "width": "36px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "1px",
      "height": "100%",
      "background-color": "grey"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ksm-vergleich-content"
  }, [_c('deepzoom-view', {
    key: "deep_vergleich_2",
    attrs: {
      "modusOption": _vm.b_modusOption,
      "seiteIdx": _vm.b_seiteIdx,
      "seiten": _vm.b_seiten
    },
    on: {
      "changePage": _vm.b_changeSeite
    }
  })], 1)])], 2), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "slot": "sidebar-2"
    },
    slot: "sidebar-2"
  }, [_c('sidebar-view', {
    attrs: {
      "merz": _vm.b_merz,
      "modusOption": _vm.b_modusOption,
      "seiteIdx": _vm.b_seiteIdx
    },
    on: {
      "changeSeite": _vm.b_changeSeite
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1988:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "ksm-footer ksm-disable-select",
    style: (_vm.isHome ? '' : 'height:8px')
  }, [_c('div', {
    staticClass: "ksm-footer__main"
  }, [_vm._l((_vm.footItemsLeft), function(it, i) {
    return [(!it.img && !it.png) ? _c('router-link', {
      key: 'r' + i,
      staticClass: "ksm-flex-xy-center ksm-link-text",
      staticStyle: {
        "height": "100%",
        "margin-right": "25px",
        "padding": "0"
      },
      attrs: {
        "to": it.url
      }
    }, [_vm._v(_vm._s(it.label))]) : _c('a', {
      key: 'm' + i,
      staticClass: "ksm-flex-xy-center ksm-link-img",
      staticStyle: {
        "height": "100%",
        "margin-right": "25px",
        "padding": "0"
      },
      attrs: {
        "href": it.url,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "ksm-flex-xy-center"
    }, [(it.img) ? _c('div', {
      style: (it.style),
      domProps: {
        "innerHTML": _vm._s(_vm.$_getSvg(it.img))
      }
    }) : _vm._e(), _vm._v(" "), (it.png) ? _c('div', {
      style: (it.style)
    }, [_c('img', {
      staticStyle: {
        "height": "100%"
      },
      attrs: {
        "src": _vm.$_getIcon(it.png)
      }
    })]) : _vm._e()])])]
  }), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-00auto ksm-flex"
  }, [_vm._l((_vm.footItemsRight), function(it, j) {
    return [(j > 0) ? _c('div', {
      key: 's' + j,
      staticClass: "ksm-flex-xy-center"
    }, [_vm._v("|")]) : _vm._e(), _vm._v(" "), _c('router-link', {
      key: 'b' + j,
      staticClass: "ksm-link-text ksm-flex-xy-center",
      attrs: {
        "to": it.url
      }
    }, [_vm._v(_vm._s(it.label))])]
  })], 2)], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 1989:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex-1 ksm-flex-column"
  }, [_c('div', {
    staticClass: "ksm-texte__colorbar",
    class: 'ksm-texte__colorbar--' + _vm.modus.id
  }), _vm._v(" "), _c('keep-alive', [_c(_vm.modus.id, {
    tag: "component",
    staticClass: "ksm-flex-1",
    attrs: {
      "viewKey": _vm.viewKey
    }
  }, [_c('div', {
    staticClass: "ksm-texte__modus_toolbar",
    attrs: {
      "slot": "modusindex-toolbar"
    },
    slot: "modusindex-toolbar"
  }, [(_vm.modus.id !== 'kompositionsmodus') ? _c('div', {
    staticClass: "ksm-texte__merz-select"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedUrlparmas.merzId),
      expression: "selectedUrlparmas.merzId"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.selectedUrlparmas, "merzId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeMerz]
    }
  }, _vm._l((_vm.merzListe), function(merz, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": merz.id
      }
    }, [_vm._v(_vm._s(merz.name.trim().replace(/^Merz/, 'Merz ')))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "-2px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedUrlparmas.seiteIdx),
      expression: "selectedUrlparmas.seiteIdx"
    }],
    staticStyle: {
      "width": "auto",
      "max-width": "20em"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.selectedUrlparmas, "seiteIdx", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeSeite]
    }
  }, _vm._l((_vm.seiten), function(s, j) {
    return _c('option', {
      key: j,
      domProps: {
        "value": j
      }
    }, [_vm._v(_vm._s(s.name))])
  }), 0)])]) : _c('div', {
    staticClass: "ksm-texte__merz-select"
  }, [_c('div', {
    staticStyle: {
      "margin-left": "-2px",
      "visibility": "hidden"
    }
  }, [_c('select', [_c('option', [_vm._v("Meine Komposition 1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ksm-texte__modus-navigation"
  }, _vm._l((_vm.modusData.modusItems), function(it, i) {
    return _c('div', {
      key: 'nav' + i,
      staticClass: "ksm-texte__modus-navItem",
      class: 'ksm-modus__navi--' + it.id + (it.id == _vm.modus.id ? ' active' : ''),
      attrs: {
        "title": it.label
      },
      domProps: {
        "innerHTML": _vm._s(_vm.$_getSvg(it.img))
      },
      on: {
        "click": function($event) {
          return _vm.changeModus(it)
        }
      }
    })
  }), 0), _vm._v(" "), (_vm.modus.id == 'untersuchungsmodus') ? _c('div', {
    staticClass: "ksm-transparent-slider"
  }, [_c('div', [_c('input', {
    staticClass: "ksm-slider",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "slider1",
      "type": "range",
      "min": "0",
      "max": "100%",
      "step": "1"
    },
    domProps: {
      "value": _vm.transparenzValue
    },
    on: {
      "input": _vm.changeTransparent
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "__text"
  }, [_c('div', [_vm._v("0%")]), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-1 ksm-flex-xy-center"
  }, [_vm._v("Transparenz")]), _vm._v(" "), _c('div', [_vm._v("100%")])])]) : _vm._e(), _vm._v(" "), (_vm.modus.id == 'vergleichsmodus') ? _c('div', {
    staticClass: "ksm-texte__merz-select"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedUrlparmas.b_merzId),
      expression: "selectedUrlparmas.b_merzId"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.selectedUrlparmas, "b_merzId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.b_changeMerz]
    }
  }, _vm._l((_vm.merzListe), function(merz, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": merz.id
      }
    }, [_vm._v(_vm._s(merz.name.trim().replace('Merz', 'Merz ')))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "-2px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedUrlparmas.b_seiteIdx),
      expression: "selectedUrlparmas.b_seiteIdx"
    }],
    staticStyle: {
      "width": "auto",
      "max-width": "20em"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.selectedUrlparmas, "b_seiteIdx", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.b_changeSeite]
    }
  }, _vm._l((_vm.b_seiten), function(s, j) {
    return _c('option', {
      key: j,
      domProps: {
        "value": j
      }
    }, [_vm._v(_vm._s(s.name))])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.modus.id == 'kompositionsmodus') ? _c('div', {
    staticClass: "ksm-texte__merz-select"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedUrlparmas.merzId),
      expression: "selectedUrlparmas.merzId"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.selectedUrlparmas, "merzId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeMerz]
    }
  }, _vm._l((_vm.merzListe), function(merz, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": merz.id
      }
    }, [_vm._v(_vm._s('Merz ' + merz.name.replace('Merz', '').trim()))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "-2px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedUrlparmas.seiteIdx),
      expression: "selectedUrlparmas.seiteIdx"
    }],
    staticStyle: {
      "width": "auto",
      "max-width": "20em"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.selectedUrlparmas, "seiteIdx", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeSeite]
    }
  }, _vm._l((_vm.seiten), function(s, j) {
    return _c('option', {
      key: j,
      domProps: {
        "value": j
      }
    }, [_vm._v(_vm._s(s.name))])
  }), 0)])]) : _vm._e()])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1990:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-deepzoom__page-wrapper ksm-flex-column",
    on: {
      "dblclick": _vm.stopDblClick
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noFacimilie),
      expression: "noFacimilie"
    }],
    staticClass: "ksm-flex-1",
    staticStyle: {
      "position": "relative",
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "ksm-position-absolute"
  }, [_c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "max-height": "100%",
      "max-widht": "100%"
    },
    attrs: {
      "src": _vm.noFacimilie
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.noFacimilie),
      expression: "!noFacimilie"
    }],
    ref: "toolbarDiv",
    staticClass: "toolbarDiv ksm-disable-select ksm-flex-00auto",
    staticStyle: {
      "position": "relative",
      "height": "40px",
      "width": "280px"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.noFacimilie),
      expression: "!noFacimilie"
    }],
    staticClass: "ksm-deepzoom__page ksm-flex-1"
  }, [_c('div', {
    staticClass: "ksm-position-absolute ksm-flex"
  }, [_c('div', {
    staticClass: "ksm-deepzoom__body ksm-flex-1",
    attrs: {
      "id": _vm.containerId
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    ref: "infobox_template",
    staticClass: "ksm-gummi__end-overlay",
    class: _vm.modusOption.key
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "__body ksm-hyphens"
  })]), _vm._v(" "), _c('div', {
    ref: "popup-menu_template",
    staticClass: "ksm-deepzoom__popupmenu-overlay"
  }, [_vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "__head ksm-flex"
  }, [_c('div', {
    staticClass: "__title ksm-flex-1 ksm-flex"
  }), _vm._v(" "), _c('div', {
    staticClass: "__close-infobox"
  }, [_vm._v("x")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex"
  }, [_c('div', {
    staticClass: "ksm-deepzoom__popupmenu__color-rect"
  }), _vm._v(" "), _c('div', {
    staticClass: "ksm-deepzoom__popup-menuitem"
  })])
}]}

/***/ }),

/***/ 1991:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "ksm-header"
  }, [_c('router-link', {
    staticClass: "ksm-header__title ksm-link-img",
    attrs: {
      "tag": "a",
      "to": "/"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('kurt-merz-schwitters-typo.svg'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-1 ksm-flex-column"
  }, [_c('div', {
    staticClass: "ksm-flex-1"
  }), _vm._v(" "), _c('nav-view', {
    staticStyle: {
      "order": "0"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1992:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-wrapper"
  }, [_c('div', {
    staticClass: "ksm-flex-xy-center",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "loading-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "lds-ring",
    class: _vm.size ? _vm.size : 'default'
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])])])
},staticRenderFns: []}

/***/ }),

/***/ 1993:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex-1 ksm-flex-column"
  }, [_c('div', {
    staticClass: "ksm-flex-1 ksm-flex"
  }, [_c('div', {
    staticClass: "ksm-flex-00auto"
  }, [_c('div', {
    staticClass: "ksm-medien__icon",
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('film-neu.svg'))
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-00auto ksm-flex"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-1"
  }, [(_vm.media) ? _c('PlayerControls', {
    attrs: {
      "media": _vm.media,
      "mediaType": "video",
      "mediaName": 'Film',
      "playBtnDisable": _vm.isConnect2
    },
    on: {
      "videoPlaying": _vm.videoPlaying,
      "playPause": _vm.playPause
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex-1 ksm-flex"
  }, [_c('div', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "ksm-media-wrapper"
  }, [_c('video', {
    staticClass: "ksm-media"
  }, [_c('source', {
    attrs: {
      "src": "./static/multimedia/film.mp4",
      "type": "video/mp4"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ksm-medien__audio-select"
  }, [_vm._v("Stummfilm (1929)")])])
}]}

/***/ }),

/***/ 1994:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex",
    staticStyle: {
      "background-color": "#eee",
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "100%",
      "overflow": "auto"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.htmlText)
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 1995:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex-xy-center"
  }, [_c('h1', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "color": "grey"
    }
  }, [_vm._v("Beteiligte")])])
}]}

/***/ }),

/***/ 1996:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-modus__ansicht-wrapper"
  }, [_c('split-layout', {
    attrs: {
      "cols": 2,
      "sidebar_right_width": 'width:20% '
    }
  }, [_c('div', {
    staticClass: "ksm-texte__modus-main",
    attrs: {
      "slot": "main-content"
    },
    slot: "main-content"
  }, [_vm._t("modusindex-toolbar"), _vm._v(" "), _c('div', {
    staticClass: "ksm-modus__ansicht-main-wrapper"
  }, [_c('div', {
    staticClass: "ksm-modus__ansicht-main"
  }, [(_vm.seiteIdx < 1) ? _c('div', {
    staticClass: "ksm-ansicht__einfuehrung"
  }, [_c('div', {
    staticClass: "__title"
  }, [_vm._v("Einführung")]), _vm._v(" "), _c('div', {
    staticClass: "__body ksm-content-font ksm-hyphens",
    class: _vm.modusId,
    staticStyle: {
      "overflow": "auto"
    },
    attrs: {
      "lang": "de"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.einfuehrung)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ksm-ansicht-content"
  }, [_c('deepzoom-view', {
    key: "deep_ansicht_1",
    attrs: {
      "modusOption": _vm.modusOption,
      "seiteIdx": _vm.seiteIdx,
      "seiten": _vm.seiten
    },
    on: {
      "changePage": _vm.changeSeite
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "ksm-ansicht-footer"
  }, [_c('foot-thumbnail', {
    attrs: {
      "seiten": _vm.seiten,
      "seiteIdx": _vm.seiteIdx,
      "aligen": 'horizontal'
    },
    on: {
      "selectItem": _vm.changeSeite
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "slot": "sidebar-2"
    },
    slot: "sidebar-2"
  }, [_c('sidebar-view', {
    attrs: {
      "merz": _vm.merz,
      "modusOption": _vm.modusOption,
      "seiteIdx": _vm.seiteIdx
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1997:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex-1 ksm-flex-column",
    staticStyle: {
      "background-color": "#eee"
    }
  }, [_c('div', {
    staticClass: "ksm-flex-1 ksm-flex"
  }, [_c('div', {
    staticClass: "ksm-flex-00auto"
  }, [_c('div', {
    staticClass: "ksm-medien__icon",
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('noten.svg'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ksm-ursonate_osd-wrapper"
  }, [(_vm.seite && _vm.isReady) ? _c('DeepzoomView', {
    key: "deep_noteview",
    attrs: {
      "modusOption": _vm.modus.option,
      "seiteIdx": parseInt(_vm.localParams.noteIdx, 10),
      "seiten": _vm.seiten
    },
    on: {
      "changePage": _vm.changeSeite
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "ksm-ursonate_note-wrapper"
  }, [_c('div', {
    staticClass: "ksm-flex-1 ksm-flex-column",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "ksm-flex-column",
    staticStyle: {
      "position": "absolute",
      "height": "100%",
      "width": "100%"
    }
  }, [_c('NotenPlayer', {
    attrs: {
      "meiName": _vm.meiName,
      "seite": _vm.seite
    },
    on: {
      "transcriptUpdate": _vm.transcriptUpdate
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ksm-texte__transcript"
  }, _vm._l((_vm.seite._.docInfo), function(s, j) {
    return _c('div', [_c('p', {
      domProps: {
        "innerHTML": _vm._s(s._source['98_html'])
      }
    })])
  }), 0)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-00auto ksm-flex",
    staticStyle: {
      "height": "100px",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "ksm-texte__modus_toolbar"
  }, [_c('div', {
    staticClass: "ksm-texte__merz-select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.groupIdx),
      expression: "groupIdx"
    }],
    staticStyle: {
      "width": "auto"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.groupIdx = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeGroup]
    }
  }, _vm._l((_vm.notenGroup), function(g, gi) {
    return _c('option', {
      key: gi,
      domProps: {
        "value": gi
      }
    }, [_vm._v(_vm._s(g.label))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "ksm-texte__merz-select",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localParams.noteIdx),
      expression: "localParams.noteIdx"
    }],
    staticStyle: {
      "width": "auto"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.localParams, "noteIdx", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.notenGroup[_vm.groupIdx].seiten), function(s, j) {
    return _c('option', {
      key: j,
      domProps: {
        "value": s.idx + ''
      }
    }, [_vm._v(_vm._s(s.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "ksm-ursonate__thumbnail--wrapper"
  }, [(_vm.seiten) ? _c('div', {
    staticClass: "ksm-ursonate__thumbnail"
  }, [_c('Thumbnail', {
    attrs: {
      "seiten": _vm.seiten,
      "seiteIdx": parseInt(_vm.localParams.noteIdx, 10),
      "aligen": 'horizontal',
      "imageHeight": 75
    },
    on: {
      "selectItem": _vm.changeSeite
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ksm-texte__modus_info"
  }, _vm._l((_vm.seite._.docInfo), function(s, j) {
    return _c('div', [_vm._v("\n        Art der Seite: " + _vm._s(s._source["98_artderseite"]) + " "), _c('br'), _vm._v("\n        Format: " + _vm._s(s._source["98_format"]) + " "), _c('br'), _vm._v("\n        Datum: " + _vm._s(s._source["98_datumalternativ"]) + " "), _c('br'), _vm._v("\n        Standort/Eigentümer: " + _vm._s(s._source["98_standorteigen"]) + " "), _c('br'), _vm._v("\n        Signatur Sprengel Museum Hannover: " + _vm._s(s._source["98_KSAsignaturItem"]) + " "), _c('br'), _vm._v("\n        Material/Technik: " + _vm._s(s._source["98_materialtechnik"]) + " "), _c('br')])
  }), 0)])])
},staticRenderFns: []}

/***/ }),

/***/ 1998:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lds-ellipsis"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])
}]}

/***/ }),

/***/ 1999:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-ursonate__page-wrapper"
  }, [_c('div', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isTextMin),
      expression: "isTextMin"
    }],
    staticClass: "ksm-medien__icon-fixed ksm-link--svg2",
    attrs: {
      "title": "Bereich wiederherstellen"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('text.svg'))
    },
    on: {
      "click": function($event) {
        _vm.isTextMin = false
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNotenMin),
      expression: "isNotenMin"
    }],
    staticClass: "ksm-medien__icon-fixed--right ksm-link--svg2",
    attrs: {
      "title": "Bereich wiederherstellen"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('noten.svg'))
    },
    on: {
      "click": function($event) {
        _vm.isNotenMin = false
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAudioMin),
      expression: "isAudioMin"
    }],
    staticClass: "ksm-medien__icon-fixed--bottom ksm-link--svg2",
    attrs: {
      "title": "Bereich wiederherstellen"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('audio.svg'))
    },
    on: {
      "click": function($event) {
        _vm.isAudioMin = false
      }
    }
  }), _vm._v(" "), _c('g-play-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAudioMin),
      expression: "isAudioMin"
    }],
    staticClass: "ksm-medien__icon-fixed--bottom ksm-link--svg2",
    staticStyle: {
      "bottom": "20pt"
    },
    attrs: {
      "isPlaying": _vm.audioIsPlaying
    },
    on: {
      "click": _vm.audioToggle
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isVideoMin),
      expression: "isVideoMin"
    }],
    staticClass: "ksm-medien__icon-fixed--bottom_right ksm-link--svg2",
    attrs: {
      "title": "Bereich wiederherstellen"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('film-neu.svg'))
    },
    on: {
      "click": function($event) {
        _vm.isVideoMin = false
      }
    }
  }), _vm._v(" "), _c('splitpanes', {
    staticClass: "default-theme",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "horizontal": "",
      "watch-slots": "",
      "dbl-click-splitter": false
    },
    on: {
      "resize": _vm.resizeRowTop
    }
  }, [_c('splitpanes', {
    attrs: {
      "watch-slots": "",
      "splitpanes-size": _vm.rowTop,
      "splitpanes-min": "1",
      "dbl-click-splitter": false
    },
    on: {
      "resize": _vm.resizeColumnTopLeft
    }
  }, [_c('div', {
    staticClass: "ksm-ursonate__pane",
    attrs: {
      "splitpanes-size": _vm.columnTopLeft,
      "splitpanes-min": "1"
    }
  }, [_c('div', {
    staticClass: "ksm-ursonate__box-wrapper"
  }, [_c('div', {
    staticClass: "ksm-ursonate__box"
  }, [_c('TextView', {
    attrs: {
      "themaPlaying": _vm.themaPlaying,
      "isConnect1": _vm.isConnect1
    }
  }), _vm._v(" "), _c('OpenCloseButtons', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isNotenMin || !_vm.isAudioMin || !_vm.isVideoMin),
      expression: "!isNotenMin || !isAudioMin || !isVideoMin"
    }],
    attrs: {
      "showMerz24": true
    },
    on: {
      "minimize": function($event) {
        return _vm.minimize('text')
      },
      "fullsize": function($event) {
        return _vm.fullsize('text')
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "ksm-ursonate__pane",
    attrs: {
      "splitpanes-size": 100 - _vm.columnTopLeft,
      "splitpanes-min": "1"
    }
  }, [_c('div', {
    staticClass: "ksm-ursonate__box-wrapper"
  }, [_c('div', {
    staticClass: "ksm-ursonate__box"
  }, [_c('NotenView'), _vm._v(" "), _c('OpenCloseButtons', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isTextMin || !_vm.isAudioMin || !_vm.isVideoMin),
      expression: "!isTextMin  || !isAudioMin || !isVideoMin"
    }],
    on: {
      "minimize": function($event) {
        return _vm.minimize('note')
      },
      "fullsize": function($event) {
        return _vm.fullsize('note')
      }
    }
  })], 1)])])]), _vm._v(" "), _c('splitpanes', {
    attrs: {
      "watch-slots": "",
      "splitpanes-size": 100 - _vm.rowTop,
      "splitpanes-min": "1",
      "dbl-click-splitter": false
    },
    on: {
      "resize": _vm.resizeColumnBottomLeft
    }
  }, [_c('div', {
    staticClass: "ksm-ursonate__pane",
    attrs: {
      "splitpanes-size": _vm.columnBottomLeft,
      "splitpanes-min": "1"
    }
  }, [_c('div', {
    staticClass: "ksm-ursonate__box-wrapper"
  }, [_c('g-connect-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isTextMin && !_vm.isAudioMin),
      expression: "!isTextMin && !isAudioMin"
    }],
    ref: "all_play_btn_1",
    staticStyle: {
      "position": "absolute",
      "top": "-35px",
      "left": "100px",
      "z-index": "300"
    },
    on: {
      "connectClick": _vm.doConnect1
    }
  }), _vm._v(" "), _c('g-connect-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isAudioMin && !_vm.isVideoMin),
      expression: "!isAudioMin && !isVideoMin"
    }],
    ref: "all_play_btn_2",
    staticStyle: {
      "position": "absolute",
      "top": "100px",
      "left": "-5px",
      "z-index": "300"
    },
    attrs: {
      "rotate": "vertical"
    },
    on: {
      "connectClick": _vm.doConnect2
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ksm-ursonate__box ksm-flex-x-center"
  }, [_c('AudioView', {
    attrs: {
      "isConnect2": _vm.isConnect2
    },
    on: {
      "audioChange": _vm.audioChange
    }
  }), _vm._v(" "), _c('OpenCloseButtons', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isTextMin || !_vm.isNotenMin || !_vm.isVideoMin),
      expression: "!isTextMin || !isNotenMin || !isVideoMin"
    }],
    on: {
      "minimize": function($event) {
        return _vm.minimize('audio')
      },
      "fullsize": function($event) {
        return _vm.fullsize('audio')
      }
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ksm-ursonate__pane",
    attrs: {
      "splitpanes-size": 100 - _vm.columnBottomLeft,
      "splitpanes-min": "1"
    }
  }, [_c('div', {
    staticClass: "ksm-ursonate__box-wrapper"
  }, [_c('div', {
    staticClass: "ksm-ursonate__box ksm-flex-x-center"
  }, [_c('FilmView', {
    attrs: {
      "isConnect2": _vm.isConnect2
    }
  }), _vm._v(" "), _c('OpenCloseButtons', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isTextMin || !_vm.isNotenMin || !_vm.isAudioMin),
      expression: "!isTextMin || !isNotenMin || !isAudioMin"
    }],
    on: {
      "minimize": function($event) {
        return _vm.minimize('video')
      },
      "fullsize": function($event) {
        return _vm.fullsize('video')
      }
    }
  })], 1)])])])], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 2000:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),

/***/ 2001:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ev-timeline__wrapper"
  }, [_c('div', {
    staticClass: "ksm-timeline__vonbis-wrapper"
  }, [_c('div', {
    staticStyle: {
      "padding": "0 5px"
    }
  }, [_vm._v("von")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0 5px"
    }
  }, [_c('Datepicker', {
    attrs: {
      "lang": "de",
      "format": _vm.dateVonFormat,
      "value-type": "timestamp",
      "width": "auto",
      "append-to-body": true,
      "placeholder": "",
      "clearable": false,
      "editable": true,
      "input-class": "ksm-timeline__vonbis-item",
      "not-before": _vm.notDayBefore,
      "not-after": _vm.notDayAfter,
      "confirm": true
    },
    on: {
      "change": _vm.changeDatepicker
    },
    model: {
      value: (_vm.vonDatum),
      callback: function($$v) {
        _vm.vonDatum = $$v
      },
      expression: "vonDatum"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0 5px"
    }
  }, [_vm._v("bis")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0 5px"
    }
  }, [_c('Datepicker', {
    attrs: {
      "lang": "de",
      "clearable": false,
      "format": _vm.dateVonFormat,
      "value-type": "timestamp",
      "width": "auto",
      "append-to-body": true,
      "placeholder": "",
      "editable": true,
      "input-class": "ksm-timeline__vonbis-item",
      "not-before": _vm.notDayBefore,
      "not-after": _vm.notDayAfter,
      "confirm": true
    },
    on: {
      "change": _vm.changeDatepicker
    },
    model: {
      value: (_vm.bisDatum),
      callback: function($$v) {
        _vm.bisDatum = $$v
      },
      expression: "bisDatum"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    ref: "svg-container",
    staticClass: "ev-timeline__svg-container",
    style: ('height:' + _vm.height + 'px')
  }, [(_vm.hoverItems) ? _c('span', {
    staticStyle: {
      "width": "0",
      "height": "0",
      "z-index": "2000",
      "position": "absolute"
    },
    style: (_vm.tooltipStyle)
  }, [_c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.tooltipOption),
      expression: "tooltipOption"
    }]
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ev-timeline_zoombtn-wrapper"
  }, [_c('div', {
    staticClass: "ev-timeline_zoombtn",
    class: {
      'zoombtn-disable': _vm.zoomVal >= 50
    },
    on: {
      "click": function($event) {
        return _vm.zoomClick(2);
      }
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('div', {
    staticClass: "ev-timeline_zoombtn",
    class: {
      'zoombtn-disable': _vm.zoomVal <= 1
    },
    on: {
      "click": function($event) {
        return _vm.zoomClick(0.5);
      }
    }
  }, [_vm._v("-")])]), _vm._v(" "), _c('svg', {
    ref: "ev_corr-svg",
    staticClass: "ev-timeline__svg",
    attrs: {
      "width": "100%",
      "preserveAspectRatio": "xMinYMin meet",
      "height": "100%"
    }
  }, [_c('g', {
    ref: "background_container",
    staticClass: "background_container"
  }), _vm._v(" "), _c('g', {
    ref: "content_container",
    staticClass: "content_container"
  }), _vm._v(" "), _c('defs', [_c('clipPath', {
    ref: "clipPath"
  }, [_c('rect', {
    ref: "clipPath_rect"
  })])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 2008:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./1923.png": 904,
	"./1932.png": 905,
	"./Logo_Uni_Trier_typo_neg.svg": 830,
	"./SMH_Logo_SCHWARZ.jpg": 906,
	"./alle-infofenster-schliessen.svg": 831,
	"./alle-ortsfenster-schliessen.svg": 832,
	"./ansichtsmodus.svg": 833,
	"./arrow-down.svg": 834,
	"./arrow-left-2.svg": 835,
	"./arrow-right-2.svg": 836,
	"./arrow-right.svg": 837,
	"./audio.svg": 838,
	"./collapse_down.png": 907,
	"./collapse_right.png": 908,
	"./dfg_logo_schriftzug_blau_foerderung_4c.jpg": 909,
	"./dfg_logo_schriftzug_blau_foerderung_4c.png": 910,
	"./die-reihe-merz-typo.svg": 839,
	"./ebene-hoeher.svg": 840,
	"./ebene-tiefer.svg": 841,
	"./farbe-waehlen.svg": 842,
	"./fenster-fixieren.svg": 843,
	"./film-neu.svg": 844,
	"./film.svg": 845,
	"./first.svg": 846,
	"./first_active.svg": 847,
	"./icons8-connected-50.png": 911,
	"./icons8-connected-filled-50.png": 912,
	"./icons8-pause-24.png": 913,
	"./icons8-play-24.png": 914,
	"./id-card.svg": 848,
	"./kompetenz_logo_2016_neg.svg": 849,
	"./komposition-exportieren.svg": 850,
	"./komposition-loeschen.svg": 851,
	"./komposition-neu.svg": 852,
	"./komposition-speichern-alternativ.svg": 853,
	"./komposition-speichern.svg": 854,
	"./kompositionsmodus.svg": 855,
	"./konfiguration_oeffnen.svg": 856,
	"./konfiguration_speichern.svg": 857,
	"./kurt-merz-schwitters-typo.svg": 858,
	"./kurt-schwitters-typo.svg": 859,
	"./last.svg": 860,
	"./last_active.svg": 861,
	"./lg.ajax-spinner-preloader.gif": 915,
	"./loading.gif": 916,
	"./loud-volume.png": 421,
	"./medien.svg": 862,
	"./merz22.png": 917,
	"./merz23.png": 918,
	"./merz25_dummy.svg": 863,
	"./next.svg": 864,
	"./next_active.svg": 865,
	"./noten.svg": 866,
	"./oeffnen.svg": 867,
	"./personeninfo-anzeigen.svg": 868,
	"./play.svg": 869,
	"./previous.svg": 870,
	"./previous_active.svg": 871,
	"./relation-anzeigen.svg": 872,
	"./relationen-aktiv.svg": 873,
	"./relationen-icon-1-farbe.svg": 874,
	"./relationen-icon-2-farben.svg": 875,
	"./relationen-icon-3-farben.svg": 876,
	"./relationen-icon-4-farben.svg": 877,
	"./relationen-icon-5-farben.svg": 878,
	"./relationen-inaktiv.svg": 879,
	"./relationen-loeschen.svg": 880,
	"./schallplatten.png": 919,
	"./schliessen.svg": 881,
	"./schwitters_hefte_auswahl_RD_web-felder-nr3.svg": 882,
	"./schwitters_hefte_felder.svg": 883,
	"./schwitters_startseite.svg": 884,
	"./seite-vor.svg": 885,
	"./seite-zurueck.svg": 886,
	"./session-importieren.svg": 887,
	"./session-speichern.svg": 888,
	"./sprengel-museum_logo_grau.png": 920,
	"./sprengel_museum_logo_lay.png": 921,
	"./station-erste.svg": 889,
	"./station-letzte.svg": 890,
	"./station-vor.svg": 891,
	"./station-zurueck.svg": 892,
	"./text.svg": 893,
	"./transkriptionen-aktiv.svg": 894,
	"./transkriptionen-inaktiv.svg": 895,
	"./transkriptionen-loeschen.svg": 896,
	"./transskriptionen-anzeigen.svg": 897,
	"./uni-wuppertal_logo_grau.png": 922,
	"./untersuchungsmodus.svg": 898,
	"./user-circle.svg": 899,
	"./user.svg": 900,
	"./vergleichsmodus.svg": 901,
	"./zeitleiste-anzeigen-alternativ.svg": 902,
	"./zeitleiste-anzeigen.svg": 903
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2008;

/***/ }),

/***/ 2009:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./1923.png": 904,
	"./1932.png": 905,
	"./Logo_Uni_Trier_typo_neg.svg": 830,
	"./SMH_Logo_SCHWARZ.jpg": 906,
	"./alle-infofenster-schliessen.svg": 831,
	"./alle-ortsfenster-schliessen.svg": 832,
	"./ansichtsmodus.svg": 833,
	"./arrow-down.svg": 834,
	"./arrow-left-2.svg": 835,
	"./arrow-right-2.svg": 836,
	"./arrow-right.svg": 837,
	"./audio.svg": 838,
	"./collapse_down.png": 907,
	"./collapse_right.png": 908,
	"./dfg_logo_schriftzug_blau_foerderung_4c.jpg": 909,
	"./dfg_logo_schriftzug_blau_foerderung_4c.png": 910,
	"./die-reihe-merz-typo.svg": 839,
	"./ebene-hoeher.svg": 840,
	"./ebene-tiefer.svg": 841,
	"./farbe-waehlen.svg": 842,
	"./fenster-fixieren.svg": 843,
	"./film-neu.svg": 844,
	"./film.svg": 845,
	"./first.svg": 846,
	"./first_active.svg": 847,
	"./icons8-connected-50.png": 911,
	"./icons8-connected-filled-50.png": 912,
	"./icons8-pause-24.png": 913,
	"./icons8-play-24.png": 914,
	"./id-card.svg": 848,
	"./kompetenz_logo_2016_neg.svg": 849,
	"./komposition-exportieren.svg": 850,
	"./komposition-loeschen.svg": 851,
	"./komposition-neu.svg": 852,
	"./komposition-speichern-alternativ.svg": 853,
	"./komposition-speichern.svg": 854,
	"./kompositionsmodus.svg": 855,
	"./konfiguration_oeffnen.svg": 856,
	"./konfiguration_speichern.svg": 857,
	"./kurt-merz-schwitters-typo.svg": 858,
	"./kurt-schwitters-typo.svg": 859,
	"./last.svg": 860,
	"./last_active.svg": 861,
	"./lg.ajax-spinner-preloader.gif": 915,
	"./loading.gif": 916,
	"./loud-volume.png": 421,
	"./medien.svg": 862,
	"./merz22.png": 917,
	"./merz23.png": 918,
	"./merz25_dummy.svg": 863,
	"./next.svg": 864,
	"./next_active.svg": 865,
	"./noten.svg": 866,
	"./oeffnen.svg": 867,
	"./personeninfo-anzeigen.svg": 868,
	"./play.svg": 869,
	"./previous.svg": 870,
	"./previous_active.svg": 871,
	"./relation-anzeigen.svg": 872,
	"./relationen-aktiv.svg": 873,
	"./relationen-icon-1-farbe.svg": 874,
	"./relationen-icon-2-farben.svg": 875,
	"./relationen-icon-3-farben.svg": 876,
	"./relationen-icon-4-farben.svg": 877,
	"./relationen-icon-5-farben.svg": 878,
	"./relationen-inaktiv.svg": 879,
	"./relationen-loeschen.svg": 880,
	"./schallplatten.png": 919,
	"./schliessen.svg": 881,
	"./schwitters_hefte_auswahl_RD_web-felder-nr3.svg": 882,
	"./schwitters_hefte_felder.svg": 883,
	"./schwitters_startseite.svg": 884,
	"./seite-vor.svg": 885,
	"./seite-zurueck.svg": 886,
	"./session-importieren.svg": 887,
	"./session-speichern.svg": 888,
	"./sprengel-museum_logo_grau.png": 920,
	"./sprengel_museum_logo_lay.png": 921,
	"./station-erste.svg": 889,
	"./station-letzte.svg": 890,
	"./station-vor.svg": 891,
	"./station-zurueck.svg": 892,
	"./text.svg": 893,
	"./transkriptionen-aktiv.svg": 894,
	"./transkriptionen-inaktiv.svg": 895,
	"./transkriptionen-loeschen.svg": 896,
	"./transskriptionen-anzeigen.svg": 897,
	"./uni-wuppertal_logo_grau.png": 922,
	"./untersuchungsmodus.svg": 898,
	"./user-circle.svg": 899,
	"./user.svg": 900,
	"./vergleichsmodus.svg": 901,
	"./zeitleiste-anzeigen-alternativ.svg": 902,
	"./zeitleiste-anzeigen.svg": 903
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2009;

/***/ }),

/***/ 2010:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2011:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2012:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2013:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2014:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2015:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(929);
module.exports = __webpack_require__(928);


/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(951),
  /* template */
  __webpack_require__(1953),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return queryPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return postQuery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config_json__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_config_json__);




var queryPromiseCache = {};

var queryPromise = function queryPromise(params) {
  var url = __WEBPACK_IMPORTED_MODULE_1__config_config_json___default.a.APIBaseUrl + params;
  if (queryPromiseCache[url]) {
    return queryPromiseCache[url];
  }
  var promise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    $.ajax({
      url: url,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader("Authorization", __WEBPACK_IMPORTED_MODULE_1__config_config_json___default.a.accesToken);
      },
      method: "GET"
    }).done(function (res) {
      resolve(res);
    }).fail(function (err) {
      reject(err);
    });
  });
  queryPromiseCache[url] = promise;
  return queryPromiseCache[url];
};

var postQuery = function postQuery(params, data) {
  var url = __WEBPACK_IMPORTED_MODULE_1__config_config_json___default.a.APIBaseUrl + params;
  var promise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    $.ajax({
      url: url,
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader("Authorization", __WEBPACK_IMPORTED_MODULE_1__config_config_json___default.a.accesToken);
      },
      format: 'JSON',
      data: data,
      method: 'POST'
    }).done(function (res) {
      resolve(res);
    }).fail(function (err) {
      reject(err);
    });
  });
  queryPromiseCache[url] = promise;
  return queryPromiseCache[url];
};

/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1594)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(956),
  /* template */
  __webpack_require__(1984),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loud-volume.88393e0.png";

/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1589)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(984),
  /* template */
  __webpack_require__(1978),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 424:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 425:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SIDEBAR_MODEL = [{
  id: 'acco_inventarisierung',
  label: 'Informationen',
  fudkeys: [],
  transcriptButtonEnable: false,
  transcriptButtonChecked: false,
  kategorieButtonEnable: false,
  kategorieButtonChecked: false
}, {
  id: 'acco_transkription',
  label: 'Transkription',
  fudkeys: [],
  transcriptButtonEnable: false,
  transcriptButtonChecked: false,
  kategorieButtonEnable: false,
  kategorieButtonChecked: false
}, {
  id: 'acco_einzelstellenkommentare',
  label: 'Einzelstellenkommentare',
  fudkeys: ['WebAnmerkung'],
  transcriptButtonEnable: true,
  transcriptButtonChecked: false,
  kategorieButtonEnable: true,
  kategorieButtonChecked: false
}, {
  id: 'acco_kommentar',
  label: 'Kommentar',
  fudkeys: ['WebAnmerkung'],
  transcriptButtonEnable: false,
  transcriptButtonChecked: false,
  kategorieButtonEnable: false,
  kategorieButtonChecked: false
}, {
  id: 'acco_uebersetzung',
  label: 'Übersetzung',
  fudkeys: ['Übersetzung'],
  transcriptButtonEnable: true,
  transcriptButtonChecked: false,
  kategorieButtonEnable: true,
  kategorieButtonChecked: false
}, {
  id: 'acco_relation',
  label: 'Relation',
  fudkeys: ['WebRelation', 'WebVariante', 'WebRelationMerz', 'WebRelationAvantgarde', 'WebRelationWelt'],
  transcriptButtonEnable: true,
  transcriptButtonChecked: false,
  kategorieButtonEnable: true,
  kategorieButtonChecked: false
}, {
  id: 'acco_orte',
  label: 'Orte',
  fudkeys: ['index_ortsindex_7'],
  transcriptButtonEnable: true,
  transcriptButtonChecked: false,
  kategorieButtonEnable: true,
  kategorieButtonChecked: false
}, {
  id: 'acco_personen',
  label: 'Personen',
  fudkeys: ['index_personenindex_8'],
  transcriptButtonEnable: true,
  transcriptButtonChecked: false,
  kategorieButtonEnable: true,
  kategorieButtonChecked: false
}, {
  id: 'acco_seitenvorschau',
  label: 'Seitenvorschau',
  fudkeys: [],
  transcriptButtonEnable: false,
  transcriptButtonChecked: false,
  kategorieButtonEnable: false,
  kategorieButtonChecked: false
}, {
  id: 'acco_themen',
  label: 'Themen',
  fudkeys: ['index_ursonate_25'],
  transcriptButtonEnable: true,
  transcriptButtonChecked: false,
  kategorieButtonEnable: true,
  kategorieButtonChecked: false
}, {
  id: 'acco_elementebibliothek',
  label: 'Elemente-Bibliothek',
  fudkeys: ['WebAnmerkung', 'Übersetzung', 'WebRelation', 'WebVariante', 'index_personenindex_8', 'WebRelationMerz', 'WebRelationAvantgarde', 'WebRelationWelt'],
  transcriptButtonEnable: false,
  transcriptButtonChecked: false,
  kategorieButtonEnable: false,
  kategorieButtonChecked: false
}];

/* harmony default export */ __webpack_exports__["a"] = (SIDEBAR_MODEL);

/***/ }),

/***/ 426:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_openseadragon_openseadragon_min__ = __webpack_require__(428);


var Overlay = function Overlay(viewer, options) {
  var self = this;
  this._viewer = viewer;
  this._containerWidth = 0;
  this._containerHeight = 0;
  this._canvasdiv = document.createElement("div");
  this._canvasdiv.style.position = "absolute";
  this._canvasdiv.style.left = 0;
  this._canvasdiv.style.top = 0;
  this._canvasdiv.style.width = "100%";
  this._canvasdiv.style.height = "100%";
  this._viewer.canvas.appendChild(this._canvasdiv);

  this._canvas = document.createElement("canvas");
  this._canvasdiv.appendChild(this._canvas);
  this._id = options.id ? options.id : "";

  this.onRedraw = options.onRedraw || function () {};
  this.clearBeforeRedraw = typeof options.clearBeforeRedraw !== "undefined" ? options.clearBeforeRedraw : true;

  this._viewer.addHandler("update-viewport", function () {
    self.resize();
    self._updateCanvas();
  });

  this._viewer.addHandler("open", function () {
    self.resize();
    self._updateCanvas();
  });
};

Overlay.prototype = {
  canvas: function canvas() {
    return this._canvas;
  },

  context2d: function context2d() {
    return this._canvas.getContext("2d");
  },

  clear: function clear() {
    this._canvas.getContext("2d").clearRect(0, 0, this._containerWidth, this._containerHeight);
  },

  resize: function resize() {
    if (this._containerWidth !== this._viewer.container.clientWidth) {
      this._containerWidth = this._viewer.container.clientWidth;
      this._canvasdiv.setAttribute("width", this._containerWidth);
      this._canvas.setAttribute("width", this._containerWidth);
    }

    if (this._containerHeight !== this._viewer.container.clientHeight) {
      this._containerHeight = this._viewer.container.clientHeight;
      this._canvasdiv.setAttribute("height", this._containerHeight);
      this._canvas.setAttribute("height", this._containerHeight);
    }

    this._viewportOrigin = new OpenSeadragon.Point(0, 0);
    var boundsRect = this._viewer.viewport.getBounds(true);
    this._viewportOrigin.x = boundsRect.x;
    this._viewportOrigin.y = boundsRect.y * this.imgAspectRatio;

    this._viewportWidth = boundsRect.width;
    this._viewportHeight = boundsRect.height * this.imgAspectRatio;
    var image1 = this._viewer.world.getItemAt(0);
    if (!image1) {
      return;
    }
    this.imgWidth = image1.source.dimensions.x;
    this.imgHeight = image1.source.dimensions.y;
    this.imgAspectRatio = this.imgWidth / this.imgHeight;
  },
  _updateCanvas: function _updateCanvas() {
    var viewportZoom = this._viewer.viewport.getZoom(true);
    var rotate = this._viewer.viewport.getRotation();
    var image1 = this._viewer.world.getItemAt(0);
    if (!image1) {
      return;
    }
    var zoom = image1.viewportToImageZoom(viewportZoom);

    var x = (this._viewportOrigin.x / this.imgWidth - this._viewportOrigin.x) / this._viewportWidth * this._containerWidth;
    var y = (this._viewportOrigin.y / this.imgHeight - this._viewportOrigin.y) / this._viewportHeight * this._containerHeight;

    if (this.clearBeforeRedraw) this.clear();
    this._canvas.getContext("2d").translate(x, y);
    this._canvas.getContext("2d").scale(zoom, zoom);
    this.onRedraw();
    this._canvas.getContext("2d").setTransform(1, 0, 0, 1, 0, 0);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Overlay);

/***/ }),

/***/ 427:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);





(function webpackUniversalModuleDefinition(root, factory) {
	if ((typeof exports === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(exports)) === 'object' && ( false ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(module)) === 'object') module.exports = factory();else if (typeof define === 'function' && __webpack_require__(927)) define("MIDI", [], factory);else if ((typeof exports === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(exports)) === 'object') exports["MIDI"] = factory();else root["MIDI"] = factory();
})(this, function () {
	return function (modules) {
		var installedModules = {};
		function __webpack_require__(moduleId) {
			if (installedModules[moduleId]) return installedModules[moduleId].exports;
			var module = installedModules[moduleId] = { exports: {},
				id: moduleId,
				loaded: false
			};
			modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
			module.loaded = true;
			return module.exports;
		}
		__webpack_require__.m = modules;
		__webpack_require__.c = installedModules;
		__webpack_require__.p = "";
		return __webpack_require__(0);
	}([function (module, exports, __webpack_require__) {

		module.exports = __webpack_require__(1);
	}, function (module, exports, __webpack_require__) {

		'use strict';

		Object.defineProperty(exports, "__esModule", {
			value: true
		});

		var _root = __webpack_require__(2);

		var _root2 = _interopRequireDefault(_root);

		__webpack_require__(3);

		__webpack_require__(8);

		__webpack_require__(9);

		__webpack_require__(14);

		function _interopRequireDefault(obj) {
			return obj && obj.__esModule ? obj : { default: obj };
		}

		window.MIDI = _root2.default;
		exports.default = _root2.default;
		module.exports = exports['default'];
	}, function (module, exports) {

		"use strict";

		Object.defineProperty(exports, "__esModule", {
			value: true
		});
		exports.default = {};
		module.exports = exports["default"];
	}, function (module, exports, __webpack_require__) {

		'use strict';

		var _typeof = typeof __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default.a === "function" && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol_iterator___default.a) === "symbol" ? function (obj) {
			return typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(obj);
		} : function (obj) {
			return obj && typeof __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(obj);
		};

		var _utils = __webpack_require__(4);

		var _root = __webpack_require__(2);

		var _root2 = _interopRequireDefault(_root);

		function _interopRequireDefault(obj) {
			return obj && obj.__esModule ? obj : { default: obj };
		}

		_root2.default.Soundfont = {};
		_root2.default.DEBUG = true;
		_root2.default.USE_XHR = true;
		_root2.default.soundfontUrl = './soundfont/';

		_root2.default.loadPlugin = function (opts) {
			if (typeof opts === 'function') {
				opts = { onsuccess: opts };
			}

			_root2.default.soundfontUrl = opts.soundfontUrl || _root2.default.soundfontUrl;

			(0, _utils.audioDetect)(function (supports) {
				var hash = window.location.hash;
				var api = '';

				if (supports[opts.api]) {
					api = opts.api;
				} else if (supports[hash.substr(1)]) {
					api = hash.substr(1);
				} else if (supports.webmidi) {
					api = 'webmidi';
				} else if (window.AudioContext) {
					api = 'webaudio';
				} else if (window.Audio) {
					api = 'audiotag';
				}

				if (connect[api]) {
					var audioFormat = void 0;
					if (opts.targetFormat) {
						audioFormat = opts.targetFormat;
					} else {
						audioFormat = supports['audio/ogg'] ? 'ogg' : 'mp3';
					}

					_root2.default.__api = api;
					_root2.default.__audioFormat = audioFormat;
					_root2.default.supports = supports;
					_root2.default.loadResource(opts);
				}
			});
		};

		_root2.default.loadResource = function (opts) {
			var instruments = opts.instruments || opts.instrument || 'acoustic_grand_piano';

			if ((typeof instruments === 'undefined' ? 'undefined' : _typeof(instruments)) !== 'object') {
				if (instruments || instruments === 0) {
					instruments = [instruments];
				} else {
					instruments = [];
				}
			}

			for (var i = 0; i < instruments.length; i++) {
				var instrument = instruments[i];
				if (instrument === +instrument) {
					if (_root2.default.GM.byId[instrument]) {
						instruments[i] = _root2.default.GM.byId[instrument].id;
					}
				}
			}

			opts.format = _root2.default.__audioFormat;
			opts.instruments = instruments;

			connect[_root2.default.__api](opts);
		};

		var connect = {
			webmidi: function webmidi(opts) {
				_root2.default.WebMIDI.connect(opts);
			},
			audiotag: function audiotag(opts) {
				requestQueue(opts, 'AudioTag');
			},
			webaudio: function webaudio(opts) {
				requestQueue(opts, 'WebAudio');
			}
		};

		var requestQueue = function requestQueue(opts, context) {
			var audioFormat = opts.format;
			var instruments = opts.instruments;
			var onprogress = opts.onprogress;
			var onerror = opts.onerror;

			var length = instruments.length;
			var pending = length;
			var waitForEnd = function waitForEnd() {
				if (! --pending) {
					onprogress && onprogress('load', 1.0);
					_root2.default[context].connect(opts);
				}
			};

			for (var i = 0; i < length; i++) {
				var instrumentId = instruments[i];
				if (_root2.default.Soundfont[instrumentId]) {
					waitForEnd();
				} else {
					sendRequest(instruments[i], audioFormat, function (evt, progress) {
						var fileProgress = progress / length;
						var queueProgress = (length - pending) / length;
						onprogress && onprogress('load', fileProgress + queueProgress, instrumentId);
					}, function () {
						waitForEnd();
					}, onerror);
				}
			}
		};

		var sendRequest = function sendRequest(instrumentId, audioFormat, onprogress, _onsuccess, onerror) {
			var soundfontPath = _root2.default.soundfontUrl + instrumentId + '-' + audioFormat + '.js';
			if (_root2.default.USE_XHR) {
				(0, _utils.request)({
					url: soundfontPath,
					format: 'text',
					onerror: onerror,
					onprogress: onprogress,
					onsuccess: function onsuccess(event, responseText) {
						var script = document.createElement('script');
						script.language = 'javascript';
						script.type = 'text/javascript';
						script.text = responseText;
						document.body.appendChild(script);
						_onsuccess();
					}
				});
			} else {
				_utils.loadScript.add({
					url: soundfontPath,
					verify: 'root.Soundfont["' + instrumentId + '"]',
					onerror: onerror,
					onsuccess: function onsuccess() {
						_onsuccess();
					}
				});
			}
		};

		_root2.default.setDefaultPlugin = function (midi) {
			for (var key in midi) {
				_root2.default[key] = midi[key];
			}
		};
	}, function (module, exports, __webpack_require__) {

		'use strict';

		Object.defineProperty(exports, "__esModule", {
			value: true
		});

		var _audioDetect = __webpack_require__(5);

		__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_audioDetect).forEach(function (key) {
			if (key === "default" || key === "__esModule") return;
			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(exports, key, {
				enumerable: true,
				get: function get() {
					return _audioDetect[key];
				}
			});
		});

		var _loadScript = __webpack_require__(6);

		__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_loadScript).forEach(function (key) {
			if (key === "default" || key === "__esModule") return;
			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(exports, key, {
				enumerable: true,
				get: function get() {
					return _loadScript[key];
				}
			});
		});

		var _request = __webpack_require__(7);

		__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_request).forEach(function (key) {
			if (key === "default" || key === "__esModule") return;
			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(exports, key, {
				enumerable: true,
				get: function get() {
					return _request[key];
				}
			});
		});
	}, function (module, exports) {

		'use strict';

		Object.defineProperty(exports, "__esModule", {
			value: true
		});


		var supports = {};
		var pending = 0;
		var canPlayThrough = function canPlayThrough(src) {
			pending++;
			var body = document.body;
			var audio = new window.Audio();
			var mime = src.split(';')[0];
			audio.id = 'audio';
			audio.setAttribute('preload', 'auto');
			audio.setAttribute('audiobuffer', true);
			audio.addEventListener('error', function () {
				body.removeChild(audio);
				supports[mime] = false;
				pending--;
			}, false);
			audio.addEventListener('canplaythrough', function () {
				body.removeChild(audio);
				supports[mime] = true;
				pending--;
			}, false);
			audio.src = 'data:' + src;
			body.appendChild(audio);
		};

		var audioDetect = exports.audioDetect = function audioDetect(onsuccess) {
			if (navigator.requestMIDIAccess) {
				var isNative = Function.prototype.toString.call(navigator.requestMIDIAccess).indexOf('[native code]');
				if (isNative) {
					supports['webmidi'] = true;
				} else {
					for (var n = 0; navigator.plugins.length > n; n++) {
						var plugin = navigator.plugins[n];
						if (plugin.name.indexOf('Jazz-Plugin') >= 0) {
							supports['webmidi'] = true;
						}
					}
				}
			}

			if (typeof window.Audio === 'undefined') {
				return onsuccess({});
			} else {
				supports['audiotag'] = true;
			}

			if (window.AudioContext || window.webkitAudioContext) {
				supports['webaudio'] = true;
			}

			var audio = new window.Audio();
			if (typeof audio.canPlayType === 'undefined') {
				return onsuccess(supports);
			}

			var vorbis = audio.canPlayType('audio/ogg; codecs="vorbis"');
			vorbis = vorbis === 'probably' || vorbis === 'maybe';
			var mpeg = audio.canPlayType('audio/mpeg');
			mpeg = mpeg === 'probably' || mpeg === 'maybe';

			if (!vorbis && !mpeg) {
				onsuccess(supports);
				return;
			}

			if (vorbis) canPlayThrough('audio/ogg;base64,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');
			if (mpeg) canPlayThrough('audio/mpeg;base64,/+MYxAAAAANIAUAAAASEEB/jwOFM/0MM/90b/+RhST//w4NFwOjf///PZu////9lns5GFDv//l9GlUIEEIAAAgIg8Ir/JGq3/+MYxDsLIj5QMYcoAP0dv9HIjUcH//yYSg+CIbkGP//8w0bLVjUP///3Z0x5QCAv/yLjwtGKTEFNRTMuOTeqqqqqqqqqqqqq/+MYxEkNmdJkUYc4AKqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq');

			var time = new Date().getTime();
			var interval = window.setInterval(function () {
				var now = new Date().getTime();
				var maxExecution = now - time > 5000;
				if (!pending || maxExecution) {
					window.clearInterval(interval);
					onsuccess(supports);
				}
			}, 1);
		};
	}, function (module, exports) {

		'use strict';

		Object.defineProperty(exports, "__esModule", {
			value: true
		});

		var _typeof = typeof __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default.a === "function" && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol_iterator___default.a) === "symbol" ? function (obj) {
			return typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(obj);
		} : function (obj) {
			return obj && typeof __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(obj);
		};

		var _globalExists = function _globalExists(path, root) {
			try {
				path = path.split('"').join('').split("'").join('').split(']').join('').split('[').join('.');
				var parts = path.split('.');
				var length = parts.length;
				var object = root || window;
				for (var n = 0; n < length; n++) {
					var key = parts[n];
					if (object[key] == null) {
						return false;
					} else {
						object = object[key];
					}
				}
				return true;
			} catch (e) {
				return false;
			}
		};

		var LoadScript = function LoadScript() {
			this.loaded = {};
			this.loading = {};
			return this;
		};

		LoadScript.prototype.add = function (config) {
			var that = this;
			if (typeof config === 'string') {
				config = { url: config };
			}
			var urls = config.urls;
			if (typeof urls === 'undefined') {
				urls = [{
					url: config.url,
					verify: config.verify
				}];
			}

			var doc = document.getElementsByTagName('head')[0];

			var testElement = function testElement(element, test) {
				if (that.loaded[element.url]) return;
				if (test && _globalExists(test) === false) return;
				that.loaded[element.url] = true;

				if (that.loading[element.url]) that.loading[element.url]();
				delete that.loading[element.url];

				if (element.onsuccess) element.onsuccess();
				if (typeof getNext !== 'undefined') getNext();
			};

			var hasError = false;
			var batchTest = [];
			var addElement = function addElement(element) {
				if (typeof element === 'string') {
					element = {
						url: element,
						verify: config.verify
					};
				}
				if (/([\w\d.\[\]'"])$/.test(element.verify)) {
					var verify = element.test = element.verify;
					if ((typeof verify === 'undefined' ? 'undefined' : _typeof(verify)) === 'object') {
						for (var n = 0; n < verify.length; n++) {
							batchTest.push(verify[n]);
						}
					} else {
						batchTest.push(verify);
					}
				}
				if (that.loaded[element.url]) return;
				var script = document.createElement('script');
				script.onreadystatechange = function () {
					if (this.readyState !== 'loaded' && this.readyState !== 'complete') return;
					testElement(element);
				};
				script.onload = function () {
					testElement(element);
				};
				script.onerror = function () {
					hasError = true;
					delete that.loading[element.url];
					if (_typeof(element.test) === 'object') {
						for (var key in element.test) {
							removeTest(element.test[key]);
						}
					} else {
						removeTest(element.test);
					}
				};
				script.setAttribute('type', 'text/javascript');
				script.setAttribute('src', element.url);
				doc.appendChild(script);
				that.loading[element.url] = function () {};
			};

			var removeTest = function removeTest(test) {
				var ret = [];
				for (var n = 0; n < batchTest.length; n++) {
					if (batchTest[n] === test) continue;
					ret.push(batchTest[n]);
				}
				batchTest = ret;
			};
			var onLoad = function onLoad(element) {
				if (element) {
					testElement(element, element.test);
				} else {
					for (var n = 0; n < urls.length; n++) {
						testElement(urls[n], urls[n].test);
					}
				}
				var istrue = true;
				for (var _n = 0; _n < batchTest.length; _n++) {
					if (_globalExists(batchTest[_n]) === false) {
						istrue = false;
					}
				}
				if (!config.strictOrder && istrue) {
					if (hasError) {
						if (config.error) {
							config.error();
						}
					} else if (config.onsuccess) {
						config.onsuccess();
					}
				} else {
					setTimeout(function () {
						onLoad(element);
					}, 10);
				}
			};

			if (config.strictOrder) {
				var ID = -1;
				var getNext = function getNext() {
					ID++;
					if (!urls[ID]) {
						if (hasError) {
							if (config.error) {
								config.error();
							}
						} else if (config.onsuccess) {
							config.onsuccess();
						}
					} else {
						var element = urls[ID];
						var url = element.url;
						if (that.loading[url]) {
							that.loading[url] = function () {
								if (element.onsuccess) element.onsuccess();
								getNext();
							};
						} else if (!that.loaded[url]) {
							addElement(element);
							onLoad(element);
						} else {
							getNext();
						}
					}
				};
				getNext();
			} else {
				for (var _ID = 0; _ID < urls.length; _ID++) {
					addElement(urls[_ID]);
					onLoad(urls[_ID]);
				}
			}
		};

		var loadScript = exports.loadScript = new LoadScript();
	}, function (module, exports) {

		'use strict';

		Object.defineProperty(exports, "__esModule", {
			value: true
		});
		exports.request = request;


		function request(opts, onsuccess, onerror, onprogress) {
			if (typeof opts === 'string') opts = { url: opts };
			var data = opts.data;
			var url = opts.url;
			var method = opts.method || (opts.data ? 'POST' : 'GET');
			var format = opts.format;
			var headers = opts.headers;
			var responseType = opts.responseType;
			var withCredentials = opts.withCredentials || false;
			var xhr = new window.XMLHttpRequest();
			onsuccess = onsuccess || opts.onsuccess;
			onerror = onerror || opts.onerror;
			onprogress = onprogress || opts.onprogress;
			xhr.open(method, url, true);
			if (headers) {
				for (var type in headers) {
					xhr.setRequestHeader(type, headers[type]);
				}
			} else if (data) {
				xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
			}
			if (format === 'binary') {
				if (xhr.overrideMimeType) {
					xhr.overrideMimeType('text/plain; charset=x-user-defined');
				}
			}
			if (responseType) {
				xhr.responseType = responseType;
			}
			if (withCredentials) {
				xhr.withCredentials = 'true';
			}
			if (onerror && 'onerror' in xhr) {
				xhr.onerror = onerror;
			}
			if (onprogress && xhr.upload && 'onprogress' in xhr.upload) {
				if (data) {
					xhr.upload.onprogress = function (evt) {
						onprogress.call(xhr, evt, evt.loaded / evt.total);
					};
				} else {
					xhr.addEventListener('progress', function (evt) {
						var totalBytes = 0;
						if (evt.lengthComputable) {
							totalBytes = evt.total;
						} else if (xhr.totalBytes) {
							totalBytes = xhr.totalBytes;
						} else {
							var rawBytes = parseInt(xhr.getResponseHeader('Content-Length-Raw'));
							if (isFinite(rawBytes)) {
								xhr.totalBytes = totalBytes = rawBytes;
							} else {
								return;
							}
						}
						onprogress.call(xhr, evt, evt.loaded / totalBytes);
					});
				}
			}

			xhr.onreadystatechange = function (evt) {
				if (xhr.readyState === 4) {
					if (xhr.status === 200 || xhr.status === 304 || xhr.status === 308) {
							if (onsuccess) {
								var res;
								if (format === 'xml') {
									res = evt.target.responseXML;
								} else if (format === 'text') {
									res = evt.target.responseText;
								} else if (format === 'json') {
									try {
										res = JSON.parse(evt.target.response);
									} catch (err) {
										onerror && onerror.call(xhr, evt);
									}
								}
								onsuccess.call(xhr, evt, res);
							}
						} else {
						onerror && onerror.call(xhr, evt);
					}
				}
			};
			xhr.send(data);
			return xhr;
		}
	}, function (module, exports, __webpack_require__) {

		'use strict';

		var _root = __webpack_require__(2);

		var _root2 = _interopRequireDefault(_root);

		function _interopRequireDefault(obj) {
			return obj && obj.__esModule ? obj : { default: obj };
		}

		_root2.default.GM = function (map) {
			var clean = function clean(name) {
				return name.replace(/[^a-z0-9 ]/gi, '').replace(/[ ]/g, '_').toLowerCase();
			};
			var res = {
				byName: {},
				byId: {},
				byCategory: {}
			};
			for (var key in map) {
				var list = map[key];
				for (var n = 0, length = list.length; n < length; n++) {
					var instrument = list[n];
					if (!instrument) continue;
					var num = parseInt(instrument.substr(0, instrument.indexOf(' ')), 10);
					instrument = instrument.replace(num + ' ', '');
					res.byId[--num] = res.byName[clean(instrument)] = res.byCategory[clean(key)] = {
						id: clean(instrument),
						instrument: instrument,
						number: num,
						category: key
					};
				}
			}
			return res;
		}({
			'Piano': ['1 Acoustic Grand Piano', '2 Bright Acoustic Piano', '3 Electric Grand Piano', '4 Honky-tonk Piano', '5 Electric Piano 1', '6 Electric Piano 2', '7 Harpsichord', '8 Clavinet'],
			'Chromatic Percussion': ['9 Celesta', '10 Glockenspiel', '11 Music Box', '12 Vibraphone', '13 Marimba', '14 Xylophone', '15 Tubular Bells', '16 Dulcimer'],
			'Organ': ['17 Drawbar Organ', '18 Percussive Organ', '19 Rock Organ', '20 Church Organ', '21 Reed Organ', '22 Accordion', '23 Harmonica', '24 Tango Accordion'],
			'Guitar': ['25 Acoustic Guitar (nylon)', '26 Acoustic Guitar (steel)', '27 Electric Guitar (jazz)', '28 Electric Guitar (clean)', '29 Electric Guitar (muted)', '30 Overdriven Guitar', '31 Distortion Guitar', '32 Guitar Harmonics'],
			'Bass': ['33 Acoustic Bass', '34 Electric Bass (finger)', '35 Electric Bass (pick)', '36 Fretless Bass', '37 Slap Bass 1', '38 Slap Bass 2', '39 Synth Bass 1', '40 Synth Bass 2'],
			'Strings': ['41 Violin', '42 Viola', '43 Cello', '44 Contrabass', '45 Tremolo Strings', '46 Pizzicato Strings', '47 Orchestral Harp', '48 Timpani'],
			'Ensemble': ['49 String Ensemble 1', '50 String Ensemble 2', '51 Synth Strings 1', '52 Synth Strings 2', '53 Choir Aahs', '54 Voice Oohs', '55 Synth Choir', '56 Orchestra Hit'],
			'Brass': ['57 Trumpet', '58 Trombone', '59 Tuba', '60 Muted Trumpet', '61 French Horn', '62 Brass Section', '63 Synth Brass 1', '64 Synth Brass 2'],
			'Reed': ['65 Soprano Sax', '66 Alto Sax', '67 Tenor Sax', '68 Baritone Sax', '69 Oboe', '70 English Horn', '71 Bassoon', '72 Clarinet'],
			'Pipe': ['73 Piccolo', '74 Flute', '75 Recorder', '76 Pan Flute', '77 Blown Bottle', '78 Shakuhachi', '79 Whistle', '80 Ocarina'],
			'Synth Lead': ['81 Lead 1 (square)', '82 Lead 2 (sawtooth)', '83 Lead 3 (calliope)', '84 Lead 4 (chiff)', '85 Lead 5 (charang)', '86 Lead 6 (voice)', '87 Lead 7 (fifths)', '88 Lead 8 (bass + lead)'],
			'Synth Pad': ['89 Pad 1 (new age)', '90 Pad 2 (warm)', '91 Pad 3 (polysynth)', '92 Pad 4 (choir)', '93 Pad 5 (bowed)', '94 Pad 6 (metallic)', '95 Pad 7 (halo)', '96 Pad 8 (sweep)'],
			'Synth Effects': ['97 FX 1 (rain)', '98 FX 2 (soundtrack)', '99 FX 3 (crystal)', '100 FX 4 (atmosphere)', '101 FX 5 (brightness)', '102 FX 6 (goblins)', '103 FX 7 (echoes)', '104 FX 8 (sci-fi)'],
			'Ethnic': ['105 Sitar', '106 Banjo', '107 Shamisen', '108 Koto', '109 Kalimba', '110 Bagpipe', '111 Fiddle', '112 Shanai'],
			'Percussive': ['113 Tinkle Bell', '114 Agogo', '115 Steel Drums', '116 Woodblock', '117 Taiko Drum', '118 Melodic Tom', '119 Synth Drum'],
			'Sound effects': ['120 Reverse Cymbal', '121 Guitar Fret Noise', '122 Breath Noise', '123 Seashore', '124 Bird Tweet', '125 Telephone Ring', '126 Helicopter', '127 Applause', '128 Gunshot']
		});

		_root2.default.getInstrument = function (channelId) {
			var channel = _root2.default.channels[channelId];
			return channel && channel.instrument;
		};

		_root2.default.setInstrument = function (channelId, program, delay) {
			var channel = _root2.default.channels[channelId];
			if (delay) {
				return setTimeout(function () {
					channel.instrument = program;
				}, delay);
			} else {
				channel.instrument = program;
			}
		};

		_root2.default.getMono = function (channelId) {
			var channel = _root2.default.channels[channelId];
			return channel && channel.mono;
		};

		_root2.default.setMono = function (channelId, truthy, delay) {
			var channel = _root2.default.channels[channelId];
			if (delay) {
				return setTimeout(function () {
					channel.mono = truthy;
				}, delay);
			} else {
				channel.mono = truthy;
			}
		};

		_root2.default.getOmni = function (channelId) {
			var channel = _root2.default.channels[channelId];
			return channel && channel.omni;
		};

		_root2.default.setOmni = function (channelId, truthy, delay) {
			var channel = _root2.default.channels[channelId];
			if (delay) {
				return setTimeout(function () {
					channel.omni = truthy;
				}, delay);
			} else {
				channel.omni = truthy;
			}
		};

		_root2.default.getSolo = function (channelId) {
			var channel = _root2.default.channels[channelId];
			return channel && channel.solo;
		};

		_root2.default.setSolo = function (channelId, truthy, delay) {
			var channel = _root2.default.channels[channelId];
			if (delay) {
				return setTimeout(function () {
					channel.solo = truthy;
				}, delay);
			} else {
				channel.solo = truthy;
			}
		};

		_root2.default.channels = function () {
			var channels = {};
			for (var i = 0; i < 16; i++) {
				channels[i] = {
					instrument: i,
					pitchBend: 0,
					mute: false,
					mono: false,
					omni: false,
					solo: false
				};
			}
			return channels;
		}();

		_root2.default.keyToNote = {};
		_root2.default.noteToKey = {};

		~function () {
			var A0 = 0x15;
			var C8 = 0x6C;
			var number2key = ['C', 'Db', 'D', 'Eb', 'E', 'F', 'Gb', 'G', 'Ab', 'A', 'Bb', 'B'];
			for (var n = A0; n <= C8; n++) {
				var octave = (n - 12) / 12 >> 0;
				var name = number2key[n % 12] + octave;
				_root2.default.keyToNote[name] = n;
				_root2.default.noteToKey[n] = name;
			}
		}();
	}, function (module, exports, __webpack_require__) {

		'use strict';

		var _jasmid = __webpack_require__(10);

		var _root = __webpack_require__(2);

		var _root2 = _interopRequireDefault(_root);

		function _interopRequireDefault(obj) {
			return obj && obj.__esModule ? obj : { default: obj };
		}

		(function () {
			_root2.default.Player = {};
			var player = _root2.default.Player;
			player.currentTime = 0;
			player.endTime = 0;
			player.restart = 0;
			player.playing = false;
			player.timeWarp = 1;
			player.startDelay = 0;
			player.BPM = 120;

			player.start = player.resume = function (onsuccess) {
				if (player.currentTime < -1) {
					player.currentTime = -1;
				}
				startAudio(player.currentTime, null, onsuccess);
			};

			player.pause = function () {
				var tmp = player.restart;
				stopAudio();
				player.restart = tmp;
			};

			player.stop = function () {
				stopAudio();
				player.restart = 0;
				player.currentTime = 0;
			};

			player.addListener = function (onsuccess) {
				onMidiEvent = onsuccess;
			};

			player.removeListener = function () {
				onMidiEvent = undefined;
			};

			player.clearAnimation = function () {
				if (player.animationFrameId) {
					window.cancelAnimationFrame(player.animationFrameId);
				}
			};

			player.setAnimation = function (callback) {
				var currentTime = 0;
				var tOurTime = 0;
				var tTheirTime = 0;

				player.clearAnimation();

				var frame = function frame() {
					player.animationFrameId = window.requestAnimationFrame(frame);

					if (player.endTime === 0) {
						return;
					}
					if (player.playing) {
						currentTime = tTheirTime === player.currentTime ? tOurTime - Date.now() : 0;
						if (player.currentTime === 0) {
							currentTime = 0;
						} else {
							currentTime = player.currentTime - currentTime;
						}
						if (tTheirTime !== player.currentTime) {
							tOurTime = Date.now();
							tTheirTime = player.currentTime;
						}
					} else {
						currentTime = player.currentTime;
					}

					var endTime = player.endTime;

					var total = currentTime / 1000;
					var minutes = total / 60;
					var seconds = total - minutes * 60;
					var t1 = minutes * 60 + seconds;
					var t2 = endTime / 1000;

					if (t2 - t1 < -1.0) {
						return;
					} else {
						callback({
							now: t1,
							end: t2,
							events: noteRegistrar
						});
					}
				};

				window.requestAnimationFrame(frame);
			};

			player.loadMidiFile = function (onsuccess, onprogress, onerror) {
				try {
					player.replayer = new _jasmid.Replayer((0, _jasmid.MidiFile)(player.currentData), player.timeWarp, null, player.BPM);
					player.data = player.replayer.getData();
					player.endTime = getLength();

					_root2.default.loadPlugin({
						onsuccess: onsuccess,
						onprogress: onprogress,
						onerror: onerror
					});
				} catch (event) {
					console.error(event);
					onerror && onerror(event);
				}
			};

			player.loadFile = function (file, onsuccess, onprogress, onerror) {
				player.stop();
				if (file.indexOf('base64,') !== -1) {
					var data = window.atob(file.split(',')[1]);
					player.currentData = data;
					player.loadMidiFile(onsuccess, onprogress, onerror);
				} else {
					var fetch = new window.XMLHttpRequest();
					fetch.open('GET', file);
					fetch.overrideMimeType('text/plain; charset=x-user-defined');
					fetch.onreadystatechange = function () {
						if (this.readyState === 4) {
							if (this.status === 200) {
								var t = this.responseText || '';
								var ff = [];
								var mx = t.length;
								var scc = String.fromCharCode;
								for (var z = 0; z < mx; z++) {
									ff[z] = scc(t.charCodeAt(z) & 255);
								}

								var data = ff.join('');
								player.currentData = data;
								player.loadMidiFile(onsuccess, onprogress, onerror);
							} else {
								onerror && onerror('Unable to load MIDI file');
							}
						}
					};
					fetch.send();
				}
			};

			player.getFileInstruments = function () {
				var instruments = {};
				var programs = {};
				for (var n = 0; n < player.data.length; n++) {
					var event = player.data[n][0].event;
					if (event.type !== 'channel') {
						continue;
					}
					var channel = event.channel;
					switch (event.subtype) {
						case 'controller':
							break;
						case 'programChange':
							programs[channel] = event.programNumber;
							break;
						case 'noteOn':
							var program = programs[channel];
							var gm = _root2.default.GM.byId[isFinite(program) ? program : channel];
							instruments[gm.id] = true;
							break;
					}
				}
				var ret = [];
				for (var key in instruments) {
					ret.push(key);
				}
				return ret;
			};

			var eventQueue = [];
			var queuedTime;
			var startTime = 0;
			var noteRegistrar = {};
			var onMidiEvent;
			var scheduleTracking = function scheduleTracking(channel, note, currentTime, offset, message, velocity, time) {
				return setTimeout(function () {
					var data = {
						channel: channel,
						note: note,
						now: currentTime,
						end: player.endTime,
						message: message,
						velocity: velocity
					};

					if (message === 128) {
						delete noteRegistrar[note];
					} else {
						noteRegistrar[note] = data;
					}
					if (onMidiEvent) {
						onMidiEvent(data);
					}
					player.currentTime = currentTime;

					eventQueue.shift();

					if (eventQueue.length < 1000) {
						startAudio(queuedTime, true);
					} else if (player.currentTime === queuedTime && queuedTime < player.endTime) {
						startAudio(queuedTime, true);
					}
				}, currentTime - offset);
			};

			var getContext = function getContext() {
				if (_root2.default.api === 'webaudio') {
					return _root2.default.WebAudio.getContext();
				} else {
					player.ctx = { currentTime: 0 };
				}
				return player.ctx;
			};

			var getLength = function getLength() {
				var data = player.data;
				var length = data.length;
				var totalTime = 0.5;
				for (var n = 0; n < length; n++) {
					totalTime += data[n][1];
				}
				return totalTime;
			};

			var __now;
			var getNow = function getNow() {
				if (window.performance && window.performance.now) {
					return window.performance.now();
				} else {
					return Date.now();
				}
			};

			var startAudio = function startAudio(currentTime, fromCache, onsuccess) {
				if (!player.replayer) {
					return;
				}
				if (!fromCache) {
					if (typeof currentTime === 'undefined') {
						currentTime = player.restart;
					}

					player.playing && stopAudio();
					player.playing = true;
					player.data = player.replayer.getData();
					player.endTime = getLength();
				}

				var note;
				var offset = 0;
				var messages = 0;
				var data = player.data;
				var ctx = getContext();
				var length = data.length;

				queuedTime = 0.5;

				var foffset = currentTime - player.currentTime;

				if (_root2.default.api !== 'webaudio') {
					var now = getNow();
					__now = __now || now;
					ctx.currentTime = (now - __now) / 1000;
				}

				startTime = ctx.currentTime;

				for (var n = 0; n < length && messages < 100; n++) {
					var obj = data[n];
					if ((queuedTime += obj[1]) <= currentTime) {
						offset = queuedTime;
						continue;
					}

					currentTime = queuedTime - offset;

					var event = obj[0].event;
					if (event.type !== 'channel') {
						continue;
					}

					var channelId = event.channel;
					var channel = _root2.default.channels[channelId];
					var delay = ctx.currentTime + (currentTime + foffset + player.startDelay) / 1000;
					var queueTime = queuedTime - offset + player.startDelay;
					switch (event.subtype) {
						case 'controller':
							_root2.default.setController(channelId, event.controllerType, event.value, delay);
							break;
						case 'programChange':
							_root2.default.programChange(channelId, event.programNumber, delay);
							break;
						case 'pitchBend':
							_root2.default.pitchBend(channelId, event.value, delay);
							break;
						case 'noteOn':
							if (channel.mute) break;
							note = event.noteNumber - (player.MIDIOffset || 0);
							eventQueue.push({
								event: event,
								time: queueTime,
								source: _root2.default.noteOn(channelId, event.noteNumber, event.velocity, delay),
								interval: scheduleTracking(channelId, note, queuedTime + player.startDelay, offset - foffset, 144, event.velocity)
							});
							messages++;
							break;
						case 'noteOff':
							if (channel.mute) break;
							note = event.noteNumber - (player.MIDIOffset || 0);
							eventQueue.push({
								event: event,
								time: queueTime,
								source: _root2.default.noteOff(channelId, event.noteNumber, delay),
								interval: scheduleTracking(channelId, note, queuedTime, offset - foffset, 128, 0)
							});
							break;
						default:
							break;
					}
				}

				onsuccess && onsuccess(eventQueue);
			};

			var stopAudio = function stopAudio() {
				var ctx = getContext();
				player.playing = false;
				player.restart += (ctx.currentTime - startTime) * 1000;

				while (eventQueue.length) {
					var o = eventQueue.pop();
					window.clearInterval(o.interval);
					if (!o.source) continue;
					if (typeof o.source === 'number') {
						window.clearTimeout(o.source);
					} else {
						o.source.disconnect(0);
					}
				}

				for (var key in noteRegistrar) {
					var _o = noteRegistrar[key];
					if (noteRegistrar[key].message === 144 && onMidiEvent) {
						onMidiEvent({
							channel: _o.channel,
							note: _o.note,
							now: _o.now,
							end: _o.end,
							message: 128,
							velocity: _o.velocity
						});
					}
				}

				noteRegistrar = {};
			};
		})();
	}, function (module, exports, __webpack_require__) {

		'use strict';

		Object.defineProperty(exports, "__esModule", {
			value: true
		});

		var _midifile = __webpack_require__(11);

		__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_midifile).forEach(function (key) {
			if (key === "default" || key === "__esModule") return;
			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(exports, key, {
				enumerable: true,
				get: function get() {
					return _midifile[key];
				}
			});
		});

		var _replayer = __webpack_require__(13);

		__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_replayer).forEach(function (key) {
			if (key === "default" || key === "__esModule") return;
			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(exports, key, {
				enumerable: true,
				get: function get() {
					return _replayer[key];
				}
			});
		});
	}, function (module, exports, __webpack_require__) {

		'use strict';

		Object.defineProperty(exports, "__esModule", {
			value: true
		});
		exports.MidiFile = MidiFile;

		var _stream = __webpack_require__(12);

		var _stream2 = _interopRequireDefault(_stream);

		function _interopRequireDefault(obj) {
			return obj && obj.__esModule ? obj : { default: obj };
		}

		function MidiFile(data) {
			var lastEventTypeByte;

			function readChunk(stream) {
				var id = stream.read(4);
				var length = stream.readInt32();
				return {
					'id': id,
					'length': length,
					'data': stream.read(length)
				};
			}

			function readEvent(stream) {
				var event = {};
				event.deltaTime = stream.readVarInt();
				var eventTypeByte = stream.readInt8();
				if ((eventTypeByte & 0xf0) === 0xf0) {
					if (eventTypeByte === 0xff) {
						event.type = 'meta';
						var subtypeByte = stream.readInt8();
						var length = stream.readVarInt();
						switch (subtypeByte) {
							case 0x00:
								event.subtype = 'sequenceNumber';
								if (length !== 2) throw new Error('Expected length for sequenceNumber event is 2, got ' + length);
								event.number = stream.readInt16();
								return event;
							case 0x01:
								event.subtype = 'text';
								event.text = stream.read(length);
								return event;
							case 0x02:
								event.subtype = 'copyrightNotice';
								event.text = stream.read(length);
								return event;
							case 0x03:
								event.subtype = 'trackName';
								event.text = stream.read(length);
								return event;
							case 0x04:
								event.subtype = 'instrumentName';
								event.text = stream.read(length);
								return event;
							case 0x05:
								event.subtype = 'lyrics';
								event.text = stream.read(length);
								return event;
							case 0x06:
								event.subtype = 'marker';
								event.text = stream.read(length);
								return event;
							case 0x07:
								event.subtype = 'cuePoint';
								event.text = stream.read(length);
								return event;
							case 0x20:
								event.subtype = 'midiChannelPrefix';
								if (length !== 1) throw new Error('Expected length for midiChannelPrefix event is 1, got ' + length);
								event.channel = stream.readInt8();
								return event;
							case 0x2f:
								event.subtype = 'endOfTrack';
								if (length !== 0) throw new Error('Expected length for endOfTrack event is 0, got ' + length);
								return event;
							case 0x51:
								event.subtype = 'setTempo';
								if (length !== 3) throw new Error('Expected length for setTempo event is 3, got ' + length);
								event.microsecondsPerBeat = (stream.readInt8() << 16) + (stream.readInt8() << 8) + stream.readInt8();
								return event;
							case 0x54:
								event.subtype = 'smpteOffset';
								if (length !== 5) throw new Error('Expected length for smpteOffset event is 5, got ' + length);
								var hourByte = stream.readInt8();
								event.frameRate = {
									0x00: 24, 0x20: 25, 0x40: 29, 0x60: 30
								}[hourByte & 0x60];
								event.hour = hourByte & 0x1f;
								event.min = stream.readInt8();
								event.sec = stream.readInt8();
								event.frame = stream.readInt8();
								event.subframe = stream.readInt8();
								return event;
							case 0x58:
								event.subtype = 'timeSignature';
								if (length !== 4) throw new Error('Expected length for timeSignature event is 4, got ' + length);
								event.numerator = stream.readInt8();
								event.denominator = Math.pow(2, stream.readInt8());
								event.metronome = stream.readInt8();
								event.thirtyseconds = stream.readInt8();
								return event;
							case 0x59:
								event.subtype = 'keySignature';
								if (length !== 2) throw new Error('Expected length for keySignature event is 2, got ' + length);
								event.key = stream.readInt8(true);
								event.scale = stream.readInt8();
								return event;
							case 0x7f:
								event.subtype = 'sequencerSpecific';
								event.data = stream.read(length);
								return event;
							default:
								event.subtype = 'unknown';
								event.data = stream.read(length);
								return event;
						}
					} else if (eventTypeByte === 0xf0) {
						event.type = 'sysEx';
						var _length = stream.readVarInt();
						event.data = stream.read(_length);
						return event;
					} else if (eventTypeByte === 0xf7) {
						event.type = 'dividedSysEx';
						var _length2 = stream.readVarInt();
						event.data = stream.read(_length2);
						return event;
					} else {
						throw new Error('Unrecognised MIDI event type byte: ' + eventTypeByte);
					}
				} else {
					var param1;
					if ((eventTypeByte & 0x80) === 0) {
						param1 = eventTypeByte;
						eventTypeByte = lastEventTypeByte;
					} else {
						param1 = stream.readInt8();
						lastEventTypeByte = eventTypeByte;
					}
					var eventType = eventTypeByte >> 4;
					event.channel = eventTypeByte & 0x0f;
					event.type = 'channel';
					switch (eventType) {
						case 0x08:
							event.subtype = 'noteOff';
							event.noteNumber = param1;
							event.velocity = stream.readInt8();
							return event;
						case 0x09:
							event.noteNumber = param1;
							event.velocity = stream.readInt8();
							if (event.velocity === 0) {
								event.subtype = 'noteOff';
							} else {
								event.subtype = 'noteOn';
							}
							return event;
						case 0x0a:
							event.subtype = 'noteAftertouch';
							event.noteNumber = param1;
							event.amount = stream.readInt8();
							return event;
						case 0x0b:
							event.subtype = 'controller';
							event.controllerType = param1;
							event.value = stream.readInt8();
							return event;
						case 0x0c:
							event.subtype = 'programChange';
							event.programNumber = param1;
							return event;
						case 0x0d:
							event.subtype = 'channelAftertouch';
							event.amount = param1;
							return event;
						case 0x0e:
							event.subtype = 'pitchBend';
							event.value = param1 + (stream.readInt8() << 7);
							return event;
						default:
							throw new Error('Unrecognised MIDI event type: ' + eventType);
					}
				}
			}

			var stream = (0, _stream2.default)(data);
			var headerChunk = readChunk(stream);
			if (headerChunk.id !== 'MThd' || headerChunk.length !== 6) {
				throw new Error('Bad .mid file - header not found');
			}
			var headerStream = (0, _stream2.default)(headerChunk.data);
			var formatType = headerStream.readInt16();
			var trackCount = headerStream.readInt16();
			var timeDivision = headerStream.readInt16();
			var ticksPerBeat;

			if (timeDivision & 0x8000) {
				throw new Error('Expressing time division in SMTPE frames is not supported yet');
			} else {
				ticksPerBeat = timeDivision;
			}

			var header = {
				'formatType': formatType,
				'trackCount': trackCount,
				'ticksPerBeat': ticksPerBeat
			};
			var tracks = [];
			for (var i = 0; i < header.trackCount; i++) {
				tracks[i] = [];
				var trackChunk = readChunk(stream);
				if (trackChunk.id !== 'MTrk') {
					throw new Error('Unexpected chunk - expected MTrk, got ' + trackChunk.id);
				}
				var trackStream = (0, _stream2.default)(trackChunk.data);
				while (!trackStream.eof()) {
					var event = readEvent(trackStream);
					tracks[i].push(event);
				}
			}

			return {
				'header': header,
				'tracks': tracks
			};
		}
	}, function (module, exports) {

		'use strict';

		Object.defineProperty(exports, "__esModule", {
			value: true
		});

		exports.default = function (str) {
			var position = 0;

			function read(length) {
				var result = str.substr(position, length);
				position += length;
				return result;
			}

			function readInt32() {
				var result = (str.charCodeAt(position) << 24) + (str.charCodeAt(position + 1) << 16) + (str.charCodeAt(position + 2) << 8) + str.charCodeAt(position + 3);
				position += 4;
				return result;
			}

			function readInt16() {
				var result = (str.charCodeAt(position) << 8) + str.charCodeAt(position + 1);
				position += 2;
				return result;
			}

			function readInt8(signed) {
				var result = str.charCodeAt(position);
				if (signed && result > 127) result -= 256;
				position += 1;
				return result;
			}

			function eof() {
				return position >= str.length;
			}

			function readVarInt() {
				var result = 0;
				while (true) {
					var b = readInt8();
					if (b & 0x80) {
						result += b & 0x7f;
						result <<= 7;
					} else {
						return result + b;
					}
				}
			}

			return {
				'eof': eof,
				'read': read,
				'readInt32': readInt32,
				'readInt16': readInt16,
				'readInt8': readInt8,
				'readVarInt': readVarInt
			};
		};

		module.exports = exports['default'];
	}, function (module, exports) {

		'use strict';

		Object.defineProperty(exports, "__esModule", {
			value: true
		});

		var _typeof = typeof __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default.a === "function" && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol_iterator___default.a) === "symbol" ? function (obj) {
			return typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(obj);
		} : function (obj) {
			return obj && typeof __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(obj);
		};

		exports.Replayer = Replayer;
		var clone = function clone(o) {
			if ((typeof o === 'undefined' ? 'undefined' : _typeof(o)) !== 'object') return o;
			if (o === null) return o;
			var ret = typeof o.length === 'number' ? [] : {};
			for (var key in o) {
				ret[key] = clone(o[key]);
			}return ret;
		};

		function Replayer(midiFile, timeWarp, eventProcessor, bpm) {
			var trackStates = [];
			var beatsPerMinute = bpm || 120;
			var bpmOverride = !!bpm;
			var ticksPerBeat = midiFile.header.ticksPerBeat;

			for (var i = 0; i < midiFile.tracks.length; i++) {
				trackStates[i] = {
					'nextEventIndex': 0,
					'ticksToNextEvent': midiFile.tracks[i].length ? midiFile.tracks[i][0].deltaTime : null
				};
			}

			function getNextEvent() {
				var ticksToNextEvent = null;
				var nextEventTrack = null;
				var nextEventIndex = null;

				for (var _i = 0; _i < trackStates.length; _i++) {
					if (trackStates[_i].ticksToNextEvent != null && (ticksToNextEvent == null || trackStates[_i].ticksToNextEvent < ticksToNextEvent)) {
						ticksToNextEvent = trackStates[_i].ticksToNextEvent;
						nextEventTrack = _i;
						nextEventIndex = trackStates[_i].nextEventIndex;
					}
				}
				if (nextEventTrack != null) {
					var nextEvent = midiFile.tracks[nextEventTrack][nextEventIndex];
					if (midiFile.tracks[nextEventTrack][nextEventIndex + 1]) {
						trackStates[nextEventTrack].ticksToNextEvent += midiFile.tracks[nextEventTrack][nextEventIndex + 1].deltaTime;
					} else {
						trackStates[nextEventTrack].ticksToNextEvent = null;
					}
					trackStates[nextEventTrack].nextEventIndex += 1;

					for (var _i2 = 0; _i2 < trackStates.length; _i2++) {
						if (trackStates[_i2].ticksToNextEvent != null) {
							trackStates[_i2].ticksToNextEvent -= ticksToNextEvent;
						}
					}
					return {
						'ticksToEvent': ticksToNextEvent,
						'event': nextEvent,
						'track': nextEventTrack
					};
				} else {
					return null;
				}
			}

			var midiEvent;
			var temporal = [];
			~function processEvents() {
				function processNext() {
					if (!bpmOverride && midiEvent.event.type === 'meta' && midiEvent.event.subtype === 'setTempo') {
						beatsPerMinute = 60000000 / midiEvent.event.microsecondsPerBeat;
					}

					var beatsToGenerate = 0;
					var secondsToGenerate = 0;
					if (midiEvent.ticksToEvent > 0) {
						beatsToGenerate = midiEvent.ticksToEvent / ticksPerBeat;
						secondsToGenerate = beatsToGenerate / (beatsPerMinute / 60);
					}

					var time = secondsToGenerate * 1000 * timeWarp || 0;
					temporal.push([midiEvent, time]);
					midiEvent = getNextEvent();
				}

				midiEvent = getNextEvent();
				if (midiEvent) {
					while (midiEvent) {
						processNext(true);
					}
				}
			}();

			return {
				getData: function getData() {
					return clone(temporal);
				}
			};
		}
	}, function (module, exports, __webpack_require__) {

		'use strict';

		__webpack_require__(15);

		__webpack_require__(16);

		__webpack_require__(17);
	}, function (module, exports, __webpack_require__) {

		'use strict';

		var _root = __webpack_require__(2);

		var _root2 = _interopRequireDefault(_root);

		function _interopRequireDefault(obj) {
			return obj && obj.__esModule ? obj : { default: obj };
		}

		window.Audio && function () {
			var midi = _root2.default.AudioTag = { api: 'audiotag' };
			var noteToKey = {};
			var volume = 127;
			var bufferNid = -1;
			var audioBuffers = [];
			var notesOn = [];
			var notes = {};
			for (var nid = 0; nid < 12; nid++) {
				audioBuffers[nid] = new window.Audio();
			}

			var playChannel = function playChannel(channel, note) {
				if (!_root2.default.channels[channel]) return;
				var instrument = _root2.default.channels[channel].instrument;
				var instrumentId = _root2.default.GM.byId[instrument].id;
				note = notes[note];
				if (note) {
					var instrumentNoteId = instrumentId + '' + note.id;
					var nid = (bufferNid + 1) % audioBuffers.length;
					var audio = audioBuffers[nid];
					notesOn[nid] = instrumentNoteId;
					if (!_root2.default.Soundfont[instrumentId]) {
						if (_root2.default.DEBUG) {
							console.log('404', instrumentId);
						}
						return;
					}
					audio.src = _root2.default.Soundfont[instrumentId][note.id];
					audio.volume = volume / 127;
					audio.play();
					bufferNid = nid;
				}
			};

			var stopChannel = function stopChannel(channel, note) {
				if (!_root2.default.channels[channel]) return;
				var instrument = _root2.default.channels[channel].instrument;
				var instrumentId = _root2.default.GM.byId[instrument].id;
				note = notes[note];
				if (note) {
					var instrumentNoteId = instrumentId + '' + note.id;
					for (var i = 0, len = audioBuffers.length; i < len; i++) {
						var nid = (i + bufferNid + 1) % len;
						var cId = notesOn[nid];
						if (cId && cId === instrumentNoteId) {
							audioBuffers[nid].pause();
							notesOn[nid] = null;
							return;
						}
					}
				}
			};

			midi.audioBuffers = audioBuffers;
			midi.send = function (data, delay) {};
			midi.setController = function (channel, type, value, delay) {};
			midi.setVolume = function (channel, n) {
				volume = n;
			};

			midi.programChange = function (channel, program) {
				_root2.default.channels[channel].instrument = program;
			};

			midi.pitchBend = function (channel, program, delay) {};

			midi.noteOn = function (channel, note, velocity, delay) {
				var id = noteToKey[note];
				if (!notes[id]) return;
				if (delay) {
					return setTimeout(function () {
						playChannel(channel, id);
					}, delay * 1000);
				} else {
					playChannel(channel, id);
				}
			};

			midi.noteOff = function (channel, note, delay) {};

			midi.chordOn = function (channel, chord, velocity, delay) {
				for (var idx = 0; idx < chord.length; idx++) {
					var n = chord[idx];
					var id = noteToKey[n];
					if (!notes[id]) continue;
					if (delay) {
						return setTimeout(function () {
							playChannel(channel, id);
						}, delay * 1000);
					} else {
						playChannel(channel, id);
					}
				}
			};

			midi.chordOff = function (channel, chord, delay) {
				for (var idx = 0; idx < chord.length; idx++) {
					var n = chord[idx];
					var id = noteToKey[n];
					if (!notes[id]) continue;
					if (delay) {
						return setTimeout(function () {
							stopChannel(channel, id);
						}, delay * 1000);
					} else {
						stopChannel(channel, id);
					}
				}
			};

			midi.stopAllNotes = function () {
				for (var nid = 0, length = audioBuffers.length; nid < length; nid++) {
					audioBuffers[nid].pause();
				}
			};

			midi.connect = function (opts) {
				_root2.default.setDefaultPlugin(midi);

				for (var key in _root2.default.keyToNote) {
					noteToKey[_root2.default.keyToNote[key]] = key;
					notes[key] = { id: key };
				}

				opts.onsuccess && opts.onsuccess();
			};
		}();
	}, function (module, exports, __webpack_require__) {

		'use strict';

		var _root = __webpack_require__(2);

		var _root2 = _interopRequireDefault(_root);

		function _interopRequireDefault(obj) {
			return obj && obj.__esModule ? obj : { default: obj };
		}

		function base64ToArrayBuffer(base64) {
			var binaryString = window.atob(base64);
			var len = binaryString.length;
			var bytes = new Uint8Array(len);
			for (var i = 0; i < len; i++) {
				bytes[i] = binaryString.charCodeAt(i);
			}
			return bytes.buffer;
		}

		window.AudioContext && function () {
			var useStreamingBuffer = false;
			var midi = _root2.default.WebAudio = { api: 'webaudio' };
			var ctx;
			var sources = {};
			var effects = {};
			var masterVolume = 127;
			var audioBuffers = {};

			midi.audioBuffers = audioBuffers;
			midi.send = function (data, delay) {};
			midi.setController = function (channelId, type, value, delay) {};

			midi.setVolume = function (channelId, volume, delay) {
				if (delay) {
					setTimeout(function () {
						masterVolume = volume;
					}, delay * 1000);
				} else {
					masterVolume = volume;
				}
			};

			midi.programChange = function (channelId, program, delay) {
				var channel = _root2.default.channels[channelId];
				channel.instrument = program;
			};

			midi.pitchBend = function (channelId, program, delay) {
				var channel = _root2.default.channels[channelId];
				channel.pitchBend = program;
			};

			midi.noteOn = function (channelId, noteId, velocity, delay) {
				delay = delay || 0;

				var channel = _root2.default.channels[channelId];
				var instrument = channel.instrument;
				var bufferId = instrument + '' + noteId;
				var buffer = audioBuffers[bufferId];
				if (!buffer) {
					return;
				}

				if (delay < ctx.currentTime) {
					delay += ctx.currentTime;
				}

				var source;
				if (useStreamingBuffer) {
					source = ctx.createMediaElementSource(buffer);
				} else {
					source = ctx.createBufferSource();
					source.buffer = buffer;
				}

				if (effects) {
					var chain = source;
					for (var key in effects) {
						chain.connect(effects[key].input);
						chain = effects[key];
					}
				}

				var gain = velocity / 127 * (masterVolume / 127) * 2 - 1;
				source.connect(ctx.destination);
				source.playbackRate.value = 1;
				source.gainNode = ctx.createGain();
				source.gainNode.connect(ctx.destination);
				source.gainNode.gain.value = Math.min(1.0, Math.max(-1.0, gain));
				source.connect(source.gainNode);

				if (useStreamingBuffer) {
					if (delay) {
						return setTimeout(function () {
							buffer.currentTime = 0;
							buffer.play();
						}, delay * 1000);
					} else {
						buffer.currentTime = 0;
						buffer.play();
					}
				} else {
					source.start(delay || 0);
				}

				sources[channelId + '' + noteId] = source;

				return source;
			};

			midi.noteOff = function (channelId, noteId, delay) {
				delay = delay || 0;

				var channel = _root2.default.channels[channelId];
				var instrument = channel.instrument;
				var bufferId = instrument + '' + noteId;
				var buffer = audioBuffers[bufferId];
				if (buffer) {
					if (delay < ctx.currentTime) {
						delay += ctx.currentTime;
					}

					var source = sources[channelId + '' + noteId];
					if (source) {
						if (source.gainNode) {
							var gain = source.gainNode.gain;
							gain.linearRampToValueAtTime(gain.value, delay);
							gain.linearRampToValueAtTime(-1.0, delay + 0.3);
						}

						if (useStreamingBuffer) {
							if (delay) {
								setTimeout(function () {
									buffer.pause();
								}, delay * 1000);
							} else {
								buffer.pause();
							}
						} else {
							if (source.noteOff) {
								source.noteOff(delay + 0.5);
							} else {
								source.stop(delay + 0.5);
							}
						}

						delete sources[channelId + '' + noteId];

						return source;
					}
				}
			};

			midi.chordOn = function (channel, chord, velocity, delay) {
				var res = {};
				for (var n = 0, note, len = chord.length; n < len; n++) {
					res[note = chord[n]] = midi.noteOn(channel, note, velocity, delay);
				}
				return res;
			};

			midi.chordOff = function (channel, chord, delay) {
				var res = {};
				for (var n = 0, note, len = chord.length; n < len; n++) {
					res[note = chord[n]] = midi.noteOff(channel, note, delay);
				}
				return res;
			};

			midi.stopAllNotes = function () {
				for (var sid in sources) {
					var delay = 0;
					if (delay < ctx.currentTime) {
						delay += ctx.currentTime;
					}
					var source = sources[sid];
					source.gain.linearRampToValueAtTime(1, delay);
					source.gain.linearRampToValueAtTime(0, delay + 0.3);
					if (source.noteOff) {
						source.noteOff(delay + 0.3);
					} else {
						source.stop(delay + 0.3);
					}
					delete sources[sid];
				}
			};

			midi.setEffects = function (list) {
				if (ctx.tunajs) {
					for (var n = 0; n < list.length; n++) {
						var data = list[n];
						var effect = new ctx.tunajs[data.type](data);
						effect.connect(ctx.destination);
						effects[data.type] = effect;
					}
				} else {
					return console.log('Effects module not installed.');
				}
			};

			midi.connect = function (opts) {
				_root2.default.setDefaultPlugin(midi);
				midi.setContext(ctx || createAudioContext(), opts.onsuccess);
			};

			midi.getContext = function () {
				return ctx;
			};

			midi.setContext = function (newCtx, onload, onprogress, onerror) {
				ctx = newCtx;

				if (typeof window.Tuna !== 'undefined' && !ctx.tunajs) {
					ctx.tunajs = new window.Tuna(ctx);
				}

				var urls = [];
				var notes = _root2.default.keyToNote;
				for (var key in notes) {
					urls.push(key);
				}
				var waitForEnd = function waitForEnd(instrument) {
					for (var _key in bufferPending) {
						if (bufferPending[_key]) return;
					}

					if (onload) {
						onload();
						onload = null;
					}
				};

				var requestAudio = function requestAudio(soundfont, instrumentId, index, key) {
					var url = soundfont[key];
					if (url) {
						bufferPending[instrumentId]++;
						loadAudio(url, function (buffer) {
							buffer.id = key;
							var noteId = _root2.default.keyToNote[key];
							audioBuffers[instrumentId + '' + noteId] = buffer;

							if (--bufferPending[instrumentId] === 0) {
								soundfont.isLoaded = true;
								waitForEnd(instrument);
							}
						}, function (err) {
							console.error(err);
						});
					}
				};

				var bufferPending = {};
				for (var instrument in _root2.default.Soundfont) {
					var soundfont = _root2.default.Soundfont[instrument];
					if (soundfont.isLoaded) {
						continue;
					}

					var synth = _root2.default.GM.byName[instrument];
					var instrumentId = synth.number;

					bufferPending[instrumentId] = 0;

					for (var index = 0; index < urls.length; index++) {
						var _key2 = urls[index];
						requestAudio(soundfont, instrumentId, index, _key2);
					}
				}

				setTimeout(waitForEnd, 1);
			};

			function loadAudio(url, onload, onerror) {
				if (useStreamingBuffer) {
					var audio = new window.Audio();
					audio.src = url;
					audio.controls = false;
					audio.autoplay = false;
					audio.preload = false;
					audio.addEventListener('canplay', function () {
						onload && onload(audio);
					});
					audio.addEventListener('error', function (err) {
						onerror && onerror(err);
					});
					document.body.appendChild(audio);
				} else if (url.indexOf('data:audio') === 0) {
					var base64 = url.split(',')[1];
					var buffer = base64ToArrayBuffer(base64);
					ctx.decodeAudioData(buffer, onload, onerror);
				} else {
					var request = new window.XMLHttpRequest();
					request.open('GET', url, true);
					request.responseType = 'arraybuffer';
					request.onload = function () {
						ctx.decodeAudioData(request.response, onload, onerror);
					};
					request.send();
				}
			}

			function createAudioContext() {
				return new (window.AudioContext || window.webkitAudioContext)();
			}
		}();
	}, function (module, exports, __webpack_require__) {

		'use strict';

		var _root = __webpack_require__(2);

		var _root2 = _interopRequireDefault(_root);

		function _interopRequireDefault(obj) {
			return obj && obj.__esModule ? obj : { default: obj };
		}

		(function () {
			var plugin = null;
			var output = null;
			var midi = _root2.default.WebMIDI = { api: 'webmidi' };
			midi.send = function (data, delay) {
				output.send(data, delay * 1000);
			};

			midi.setController = function (channel, type, value, delay) {
				output.send([channel, type, value], delay * 1000);
			};

			midi.setVolume = function (channel, volume, delay) {
				output.send([0xB0 + channel, 0x07, volume], delay * 1000);
			};

			midi.programChange = function (channel, program, delay) {
				output.send([0xC0 + channel, program], delay * 1000);
			};

			midi.pitchBend = function (channel, program, delay) {
				output.send([0xE0 + channel, program], delay * 1000);
			};

			midi.noteOn = function (channel, note, velocity, delay) {
				output.send([0x90 + channel, note, velocity], delay * 1000);
			};

			midi.noteOff = function (channel, note, delay) {
				output.send([0x80 + channel, note, 0], delay * 1000);
			};

			midi.chordOn = function (channel, chord, velocity, delay) {
				for (var n = 0; n < chord.length; n++) {
					var note = chord[n];
					output.send([0x90 + channel, note, velocity], delay * 1000);
				}
			};

			midi.chordOff = function (channel, chord, delay) {
				for (var n = 0; n < chord.length; n++) {
					var note = chord[n];
					output.send([0x80 + channel, note, 0], delay * 1000);
				}
			};

			midi.stopAllNotes = function () {
				output.cancel();
				for (var channel = 0; channel < 16; channel++) {
					output.send([0xB0 + channel, 0x7B, 0]);
				}
			};

			midi.connect = function (opts) {
				_root2.default.setDefaultPlugin(midi);
				var errFunction = function errFunction(err) {
					if (window.AudioContext) {
						opts.api = 'webaudio';
					} else if (window.Audio) {
						opts.api = 'audiotag';
					} else {
						return err;
					}
					_root2.default.loadPlugin(opts);
				};

				navigator.requestMIDIAccess().then(function (access) {
					plugin = access;
					var pluginOutputs = plugin.outputs;
					if (typeof pluginOutputs === 'function') {
						output = pluginOutputs()[0];
					} else {
						output = pluginOutputs[0];
					}
					if (output === undefined) {
						errFunction();
					} else {
						opts.onsuccess && opts.onsuccess();
					}
				}, errFunction);
			};
		})();
	}]);
});
;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2006)(module)))

/***/ }),

/***/ 428:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);




window.OpenSeadragon = window.OpenSeadragon || function (a) {
  return new OpenSeadragon.Viewer(a);
};"function" == typeof define && __webpack_require__(927) && define(function () {
  return window.OpenSeadragon;
});!function (a) {
  a.version = { versionStr: "<%= osdVersion.versionStr %>", major: parseInt("<%= osdVersion.major %>", 10), minor: parseInt("<%= osdVersion.minor %>", 10), revision: parseInt("<%= osdVersion.revision %>", 10) };var b = { "[object Boolean]": "boolean", "[object Number]": "number", "[object String]": "string", "[object Function]": "function", "[object Array]": "array", "[object Date]": "date", "[object RegExp]": "regexp", "[object Object]": "object" },
      c = Object.prototype.toString,
      d = Object.prototype.hasOwnProperty;a.isFunction = function (b) {
    return "function" === a.type(b);
  };a.isArray = Array.isArray || function (b) {
    return "array" === a.type(b);
  };a.isWindow = function (a) {
    return a && "object" == (typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(a)) && "setInterval" in a;
  };a.type = function (a) {
    return null === a || void 0 === a ? String(a) : b[c.call(a)] || "object";
  };a.isPlainObject = function (b) {
    if (!b || "object" !== OpenSeadragon.type(b) || b.nodeType || a.isWindow(b)) return !1;if (b.constructor && !d.call(b, "constructor") && !d.call(b.constructor.prototype, "isPrototypeOf")) return !1;var c;for (var e in b) {
      c = e;
    }return void 0 === c || d.call(b, c);
  };a.isEmptyObject = function (a) {
    for (var b in a) {
      return !1;
    }return !0;
  };a.freezeObject = function (b) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default.a ? a.freezeObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default.a : a.freezeObject = function (a) {
      return a;
    };return a.freezeObject(b);
  };a.supportsCanvas = function () {
    var b = document.createElement("canvas");return !(!a.isFunction(b.getContext) || !b.getContext("2d"));
  }();a.isCanvasTainted = function (a) {
    var b = !1;try {
      a.getContext("2d").getImageData(0, 0, 1, 1);
    } catch (c) {
      b = !0;
    }return b;
  };a.pixelDensityRatio = function () {
    if (a.supportsCanvas) {
      var b = document.createElement("canvas").getContext("2d");var c = window.devicePixelRatio || 1;var d = b.webkitBackingStorePixelRatio || b.mozBackingStorePixelRatio || b.msBackingStorePixelRatio || b.oBackingStorePixelRatio || b.backingStorePixelRatio || 1;return c / d;
    }return 1;
  }();
}(OpenSeadragon);!function ($) {
  function getOffsetParent(a, b) {
    return b && a != document.body ? document.body : a.offsetParent;
  }$.extend = function () {
    var a,
        b,
        c,
        d,
        e,
        f,
        g = arguments[0] || {},
        h = arguments.length,
        i = !1,
        j = 1;if ("boolean" == typeof g) {
      i = g;g = arguments[1] || {};j = 2;
    }"object" == (typeof g === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(g)) || OpenSeadragon.isFunction(g) || (g = {});if (h === j) {
      g = this;--j;
    }for (; h > j; j++) {
      a = arguments[j];if (null !== a || void 0 !== a) for (b in a) {
        c = g[b];d = a[b];if (g !== d) if (i && d && (OpenSeadragon.isPlainObject(d) || (e = OpenSeadragon.isArray(d)))) {
          if (e) {
            e = !1;f = c && OpenSeadragon.isArray(c) ? c : [];
          } else f = c && OpenSeadragon.isPlainObject(c) ? c : {};g[b] = OpenSeadragon.extend(i, f, d);
        } else void 0 !== d && (g[b] = d);
      }
    }return g;
  };var isIOSDevice = function isIOSDevice() {
    if ("object" != (typeof navigator === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(navigator))) return !1;var a = navigator.userAgent;return "string" != typeof a ? !1 : -1 !== a.indexOf("iPhone") || -1 !== a.indexOf("iPad") || -1 !== a.indexOf("iPod");
  };$.extend($, { DEFAULT_SETTINGS: { xmlPath: null, tileSources: null, tileHost: null, initialPage: 0, crossOriginPolicy: !1, ajaxWithCredentials: !1, panHorizontal: !0, panVertical: !0, constrainDuringPan: !1, wrapHorizontal: !1, wrapVertical: !1, visibilityRatio: .5, minPixelRatio: .5, defaultZoomLevel: 0, minZoomLevel: null, maxZoomLevel: null, homeFillsViewer: !1, clickTimeThreshold: 300, clickDistThreshold: 5, dblClickTimeThreshold: 300, dblClickDistThreshold: 20, springStiffness: 6.5, animationTime: 1.2, gestureSettingsMouse: { scrollToZoom: !0, clickToZoom: !0, dblClickToZoom: !1, pinchToZoom: !1, flickEnabled: !1, flickMinSpeed: 120, flickMomentum: .25, pinchRotate: !1 }, gestureSettingsTouch: { scrollToZoom: !1, clickToZoom: !1, dblClickToZoom: !0, pinchToZoom: !0, flickEnabled: !0, flickMinSpeed: 120, flickMomentum: .25, pinchRotate: !1 }, gestureSettingsPen: { scrollToZoom: !1, clickToZoom: !0, dblClickToZoom: !1, pinchToZoom: !1, flickEnabled: !1, flickMinSpeed: 120, flickMomentum: .25, pinchRotate: !1 }, gestureSettingsUnknown: { scrollToZoom: !1, clickToZoom: !1, dblClickToZoom: !0, pinchToZoom: !0, flickEnabled: !0, flickMinSpeed: 120, flickMomentum: .25, pinchRotate: !1 }, zoomPerClick: 2, zoomPerScroll: 1.2, zoomPerSecond: 1, blendTime: 0, alwaysBlend: !1, autoHideControls: !0, immediateRender: !1, minZoomImageRatio: .9, maxZoomPixelRatio: 1.1, smoothTileEdgesMinZoom: 1.1, iOSDevice: isIOSDevice(), pixelsPerWheelLine: 40, autoResize: !0, preserveImageSizeOnResize: !1, minScrollDeltaTime: 50, showSequenceControl: !0, sequenceControlAnchor: null, preserveViewport: !1, preserveOverlays: !1, navPrevNextWrap: !1, showNavigationControl: !0, navigationControlAnchor: null, showZoomControl: !0, showHomeControl: !0, showFullPageControl: !0, showRotationControl: !1, controlsFadeDelay: 2e3, controlsFadeLength: 1500, mouseNavEnabled: !0, showNavigator: !1, navigatorId: null, navigatorPosition: null, navigatorSizeRatio: .2, navigatorMaintainSizeRatio: !1, navigatorTop: null, navigatorLeft: null, navigatorHeight: null, navigatorWidth: null, navigatorAutoResize: !0, navigatorAutoFade: !0, navigatorRotate: !0, degrees: 0, opacity: 1, compositeOperation: null, placeholderFillStyle: null, showReferenceStrip: !1, referenceStripScroll: "horizontal", referenceStripElement: null, referenceStripHeight: null, referenceStripWidth: null, referenceStripPosition: "BOTTOM_LEFT", referenceStripSizeRatio: .2, collectionRows: 3, collectionColumns: 0, collectionLayout: "horizontal", collectionMode: !1, collectionTileSize: 800, collectionTileMargin: 80, imageLoaderLimit: 0, maxImageCacheCount: 200, timeout: 3e4, useCanvas: !0, prefixUrl: "/images/", navImages: { zoomIn: { REST: "zoomin_rest.png", GROUP: "zoomin_grouphover.png", HOVER: "zoomin_hover.png", DOWN: "zoomin_pressed.png" }, zoomOut: { REST: "zoomout_rest.png", GROUP: "zoomout_grouphover.png", HOVER: "zoomout_hover.png", DOWN: "zoomout_pressed.png" }, home: { REST: "home_rest.png", GROUP: "home_grouphover.png", HOVER: "home_hover.png", DOWN: "home_pressed.png" }, fullpage: { REST: "fullpage_rest.png", GROUP: "fullpage_grouphover.png", HOVER: "fullpage_hover.png", DOWN: "fullpage_pressed.png" }, rotateleft: { REST: "rotateleft_rest.png", GROUP: "rotateleft_grouphover.png", HOVER: "rotateleft_hover.png", DOWN: "rotateleft_pressed.png" }, rotateright: { REST: "rotateright_rest.png", GROUP: "rotateright_grouphover.png", HOVER: "rotateright_hover.png", DOWN: "rotateright_pressed.png" }, previous: { REST: "previous_rest.png", GROUP: "previous_grouphover.png", HOVER: "previous_hover.png", DOWN: "previous_pressed.png" }, next: { REST: "next_rest.png", GROUP: "next_grouphover.png", HOVER: "next_hover.png", DOWN: "next_pressed.png" } }, debugMode: !1, debugGridColor: "#437AB2" }, SIGNAL: "----seadragon----", delegate: function delegate(a, b) {
      return function () {
        var c = arguments;void 0 === c && (c = []);return b.apply(a, c);
      };
    }, BROWSERS: { UNKNOWN: 0, IE: 1, FIREFOX: 2, SAFARI: 3, CHROME: 4, OPERA: 5 }, getElement: function getElement(a) {
      "string" == typeof a && (a = document.getElementById(a));return a;
    }, getElementPosition: function getElementPosition(a) {
      var b,
          c,
          d = new $.Point();a = $.getElement(a);b = "fixed" == $.getElementStyle(a).position;c = getOffsetParent(a, b);for (; c;) {
        d.x += a.offsetLeft;d.y += a.offsetTop;b && (d = d.plus($.getPageScroll()));a = c;b = "fixed" == $.getElementStyle(a).position;c = getOffsetParent(a, b);
      }return d;
    }, getElementOffset: function getElementOffset(a) {
      a = $.getElement(a);var b,
          c,
          d = a && a.ownerDocument,
          e = { top: 0, left: 0 };if (!d) return new $.Point();b = d.documentElement;"undefined" != typeof a.getBoundingClientRect && (e = a.getBoundingClientRect());c = d == d.window ? d : 9 === d.nodeType ? d.defaultView || d.parentWindow : !1;return new $.Point(e.left + (c.pageXOffset || b.scrollLeft) - (b.clientLeft || 0), e.top + (c.pageYOffset || b.scrollTop) - (b.clientTop || 0));
    }, getElementSize: function getElementSize(a) {
      a = $.getElement(a);return new $.Point(a.clientWidth, a.clientHeight);
    }, getElementStyle: document.documentElement.currentStyle ? function (a) {
      a = $.getElement(a);return a.currentStyle;
    } : function (a) {
      a = $.getElement(a);return window.getComputedStyle(a, "");
    }, getCssPropertyWithVendorPrefix: function getCssPropertyWithVendorPrefix(a) {
      var b = {};$.getCssPropertyWithVendorPrefix = function (a) {
        if (void 0 !== b[a]) return b[a];var c = document.createElement("div").style;var d = null;if (void 0 !== c[a]) d = a;else {
          var e = ["Webkit", "Moz", "MS", "O", "webkit", "moz", "ms", "o"];var f = $.capitalizeFirstLetter(a);for (var g = 0; g < e.length; g++) {
            var h = e[g] + f;if (void 0 !== c[h]) {
              d = h;break;
            }
          }
        }b[a] = d;return d;
      };return $.getCssPropertyWithVendorPrefix(a);
    }, capitalizeFirstLetter: function capitalizeFirstLetter(a) {
      return a.charAt(0).toUpperCase() + a.slice(1);
    }, pointInElement: function pointInElement(a, b) {
      a = $.getElement(a);var c = $.getElementOffset(a),
          d = $.getElementSize(a);return b.x >= c.x && b.x < c.x + d.x && b.y < c.y + d.y && b.y >= c.y;
    }, getEvent: function getEvent(a) {
      a ? $.getEvent = function (a) {
        return a;
      } : $.getEvent = function () {
        return window.event;
      };return $.getEvent(a);
    }, getMousePosition: function getMousePosition(a) {
      if ("number" == typeof a.pageX) $.getMousePosition = function (a) {
        var b = new $.Point();a = $.getEvent(a);b.x = a.pageX;b.y = a.pageY;return b;
      };else {
        if ("number" != typeof a.clientX) throw new Error("Unknown event mouse position, no known technique.");$.getMousePosition = function (a) {
          var b = new $.Point();a = $.getEvent(a);b.x = a.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;b.y = a.clientY + document.body.scrollTop + document.documentElement.scrollTop;return b;
        };
      }return $.getMousePosition(a);
    }, getPageScroll: function getPageScroll() {
      var a = document.documentElement || {},
          b = document.body || {};if ("number" == typeof window.pageXOffset) $.getPageScroll = function () {
        return new $.Point(window.pageXOffset, window.pageYOffset);
      };else if (b.scrollLeft || b.scrollTop) $.getPageScroll = function () {
        return new $.Point(document.body.scrollLeft, document.body.scrollTop);
      };else {
        if (!a.scrollLeft && !a.scrollTop) return new $.Point(0, 0);$.getPageScroll = function () {
          return new $.Point(document.documentElement.scrollLeft, document.documentElement.scrollTop);
        };
      }return $.getPageScroll();
    }, setPageScroll: function setPageScroll(a) {
      if ("undefined" != typeof window.scrollTo) $.setPageScroll = function (a) {
        window.scrollTo(a.x, a.y);
      };else {
        var b = $.getPageScroll();if (b.x === a.x && b.y === a.y) return;document.body.scrollLeft = a.x;document.body.scrollTop = a.y;var c = $.getPageScroll();if (c.x !== b.x && c.y !== b.y) {
          $.setPageScroll = function (a) {
            document.body.scrollLeft = a.x;document.body.scrollTop = a.y;
          };return;
        }document.documentElement.scrollLeft = a.x;document.documentElement.scrollTop = a.y;c = $.getPageScroll();if (c.x !== b.x && c.y !== b.y) {
          $.setPageScroll = function (a) {
            document.documentElement.scrollLeft = a.x;document.documentElement.scrollTop = a.y;
          };return;
        }$.setPageScroll = function (a) {};
      }return $.setPageScroll(a);
    }, getWindowSize: function getWindowSize() {
      var a = document.documentElement || {},
          b = document.body || {};if ("number" == typeof window.innerWidth) $.getWindowSize = function () {
        return new $.Point(window.innerWidth, window.innerHeight);
      };else if (a.clientWidth || a.clientHeight) $.getWindowSize = function () {
        return new $.Point(document.documentElement.clientWidth, document.documentElement.clientHeight);
      };else {
        if (!b.clientWidth && !b.clientHeight) throw new Error("Unknown window size, no known technique.");$.getWindowSize = function () {
          return new $.Point(document.body.clientWidth, document.body.clientHeight);
        };
      }return $.getWindowSize();
    }, makeCenteredNode: function makeCenteredNode(a) {
      a = $.getElement(a);var b = [$.makeNeutralElement("div"), $.makeNeutralElement("div"), $.makeNeutralElement("div")];$.extend(b[0].style, { display: "table", height: "100%", width: "100%" });$.extend(b[1].style, { display: "table-row" });$.extend(b[2].style, { display: "table-cell", verticalAlign: "middle", textAlign: "center" });b[0].appendChild(b[1]);b[1].appendChild(b[2]);b[2].appendChild(a);return b[0];
    }, makeNeutralElement: function makeNeutralElement(a) {
      var b = document.createElement(a),
          c = b.style;c.background = "transparent none";c.border = "none";c.margin = "0px";c.padding = "0px";c.position = "static";return b;
    }, now: function now() {
      Date.now ? $.now = Date.now : $.now = function () {
        return new Date().getTime();
      };return $.now();
    }, makeTransparentImage: function makeTransparentImage(a) {
      $.makeTransparentImage = function (a) {
        var b = $.makeNeutralElement("img");b.src = a;return b;
      };$.Browser.vendor == $.BROWSERS.IE && $.Browser.version < 7 && ($.makeTransparentImage = function (a) {
        var b = $.makeNeutralElement("img"),
            c = null;c = $.makeNeutralElement("span");c.style.display = "inline-block";b.onload = function () {
          c.style.width = c.style.width || b.width + "px";c.style.height = c.style.height || b.height + "px";b.onload = null;b = null;
        };b.src = a;c.style.filter = "progid:DXImageTransform.Microsoft.AlphaImageLoader(src='" + a + "', sizingMethod='scale')";return c;
      });return $.makeTransparentImage(a);
    }, setElementOpacity: function setElementOpacity(a, b, c) {
      var d, e;a = $.getElement(a);c && !$.Browser.alpha && (b = Math.round(b));if ($.Browser.opacity) a.style.opacity = 1 > b ? b : "";else if (1 > b) {
        d = Math.round(100 * b);e = "alpha(opacity=" + d + ")";a.style.filter = e;
      } else a.style.filter = "";
    }, setElementTouchActionNone: function setElementTouchActionNone(a) {
      a = $.getElement(a);"undefined" != typeof a.style.touchAction ? a.style.touchAction = "none" : "undefined" != typeof a.style.msTouchAction && (a.style.msTouchAction = "none");
    }, addClass: function addClass(a, b) {
      a = $.getElement(a);a.className ? -1 === (" " + a.className + " ").indexOf(" " + b + " ") && (a.className += " " + b) : a.className = b;
    }, indexOf: function indexOf(a, b, c) {
      Array.prototype.indexOf ? this.indexOf = function (a, b, c) {
        return a.indexOf(b, c);
      } : this.indexOf = function (a, b, c) {
        var d,
            e,
            f = c ? c : 0;if (!a) throw new TypeError();e = a.length;if (0 === e || f >= e) return -1;0 > f && (f = e - Math.abs(f));for (d = f; e > d; d++) {
          if (a[d] === b) return d;
        }return -1;
      };return this.indexOf(a, b, c);
    }, removeClass: function removeClass(a, b) {
      var c,
          d,
          e = [];a = $.getElement(a);c = a.className.split(/\s+/);for (d = 0; d < c.length; d++) {
        c[d] && c[d] !== b && e.push(c[d]);
      }a.className = e.join(" ");
    }, addEvent: function () {
      if (window.addEventListener) return function (a, b, c, d) {
        a = $.getElement(a);a.addEventListener(b, c, d);
      };if (window.attachEvent) return function (a, b, c, d) {
        a = $.getElement(a);a.attachEvent("on" + b, c);
      };throw new Error("No known event model.");
    }(), removeEvent: function () {
      if (window.removeEventListener) return function (a, b, c, d) {
        a = $.getElement(a);a.removeEventListener(b, c, d);
      };if (window.detachEvent) return function (a, b, c, d) {
        a = $.getElement(a);a.detachEvent("on" + b, c);
      };throw new Error("No known event model.");
    }(), cancelEvent: function cancelEvent(a) {
      a = $.getEvent(a);a.preventDefault ? $.cancelEvent = function (a) {
        a.preventDefault();
      } : $.cancelEvent = function (a) {
        a = $.getEvent(a);a.cancel = !0;a.returnValue = !1;
      };$.cancelEvent(a);
    }, stopEvent: function stopEvent(a) {
      a = $.getEvent(a);a.stopPropagation ? $.stopEvent = function (a) {
        a.stopPropagation();
      } : $.stopEvent = function (a) {
        a = $.getEvent(a);a.cancelBubble = !0;
      };$.stopEvent(a);
    }, createCallback: function createCallback(a, b) {
      var c,
          d = [];for (c = 2; c < arguments.length; c++) {
        d.push(arguments[c]);
      }return function () {
        var c,
            e = d.concat([]);for (c = 0; c < arguments.length; c++) {
          e.push(arguments[c]);
        }return b.apply(a, e);
      };
    }, getUrlParameter: function getUrlParameter(a) {
      var b = URLPARAMS[a];return b ? b : null;
    }, getUrlProtocol: function getUrlProtocol(a) {
      var b = a.match(/^([a-z]+:)\/\//i);return null === b ? window.location.protocol : b[1].toLowerCase();
    }, createAjaxRequest: function createAjaxRequest(a) {
      var b;try {
        b = !!new ActiveXObject("Microsoft.XMLHTTP");
      } catch (c) {
        b = !1;
      }if (b) window.XMLHttpRequest ? $.createAjaxRequest = function (a) {
        return a ? new ActiveXObject("Microsoft.XMLHTTP") : new XMLHttpRequest();
      } : $.createAjaxRequest = function () {
        return new ActiveXObject("Microsoft.XMLHTTP");
      };else {
        if (!window.XMLHttpRequest) throw new Error("Browser doesn't support XMLHttpRequest.");$.createAjaxRequest = function () {
          return new XMLHttpRequest();
        };
      }return $.createAjaxRequest(a);
    }, makeAjaxRequest: function makeAjaxRequest(a, b, c) {
      var d;if ($.isPlainObject(a)) {
        b = a.success;c = a.error;d = a.withCredentials;a = a.url;
      }var e = $.getUrlProtocol(a);var f = $.createAjaxRequest("file:" === e);if (!$.isFunction(b)) throw new Error("makeAjaxRequest requires a success callback");f.onreadystatechange = function () {
        if (4 == f.readyState) {
          f.onreadystatechange = function () {};if (200 === f.status || 0 === f.status && "http:" !== e && "https:" !== e) b(f);else {
            $.console.log("AJAX request returned %d: %s", f.status, a);$.isFunction(c) && c(f);
          }
        }
      };d && (f.withCredentials = !0);try {
        f.open("GET", a, !0);f.send(null);
      } catch (g) {
        var h = g.message;var i = $.Browser.vendor == $.BROWSERS.IE && $.Browser.version < 10;i && "undefined" != typeof g.number && -2147024891 == g.number && (h += "\nSee http://msdn.microsoft.com/en-us/library/ms537505(v=vs.85).aspx#xdomain");$.console.log("%s while making AJAX request: %s", g.name, h);f.onreadystatechange = function () {};if (window.XDomainRequest) {
          var j = new XDomainRequest();if (j) {
            j.onload = function (a) {
              $.isFunction(b) && b({ responseText: j.responseText, status: 200, statusText: "OK" });
            };j.onerror = function (a) {
              $.isFunction(c) && c({ responseText: j.responseText, status: 444, statusText: "An error happened. Due to an XDomainRequest deficiency we can not extract any information about this error. Upgrade your browser." });
            };try {
              j.open("GET", a);j.send();
            } catch (k) {
              $.isFunction(c) && c(f, g);
            }
          }
        } else $.isFunction(c) && c(f, g);
      }
    }, jsonp: function jsonp(a) {
      var b,
          c = a.url,
          d = document.head || document.getElementsByTagName("head")[0] || document.documentElement,
          e = a.callbackName || "openseadragon" + $.now(),
          f = window[e],
          g = "$1" + e + "$2",
          h = a.param || "callback",
          i = a.callback;c = c.replace(/(\=)\?(&|$)|\?\?/i, g);c += (/\?/.test(c) ? "&" : "?") + h + "=" + e;window[e] = function (a) {
        if (f) window[e] = f;else try {
          delete window[e];
        } catch (b) {}i && $.isFunction(i) && i(a);
      };b = document.createElement("script");(void 0 !== a.async || !1 !== a.async) && (b.async = "async");a.scriptCharset && (b.charset = a.scriptCharset);b.src = c;b.onload = b.onreadystatechange = function (a, c) {
        if (c || !b.readyState || /loaded|complete/.test(b.readyState)) {
          b.onload = b.onreadystatechange = null;d && b.parentNode && d.removeChild(b);b = void 0;
        }
      };d.insertBefore(b, d.firstChild);
    }, createFromDZI: function createFromDZI() {
      throw "OpenSeadragon.createFromDZI is deprecated, use Viewer.open.";
    }, parseXml: function parseXml(a) {
      if (window.DOMParser) $.parseXml = function (a) {
        var b,
            c = null;b = new DOMParser();c = b.parseFromString(a, "text/xml");return c;
      };else {
        if (!window.ActiveXObject) throw new Error("Browser doesn't support XML DOM.");$.parseXml = function (a) {
          var b = null;b = new ActiveXObject("Microsoft.XMLDOM");b.async = !1;b.loadXML(a);return b;
        };
      }return $.parseXml(a);
    }, parseJSON: function parseJSON(string) {
      window.JSON && window.JSON.parse ? $.parseJSON = window.JSON.parse : $.parseJSON = function (string) {
        return eval("(" + string + ")");
      };return $.parseJSON(string);
    }, imageFormatSupported: function imageFormatSupported(a) {
      a = a ? a : "";return !!FILEFORMATS[a.toLowerCase()];
    } });$.Browser = { vendor: $.BROWSERS.UNKNOWN, version: 0, alpha: !0 };var FILEFORMATS = { bmp: !1, jpeg: !0, jpg: !0, png: !0, tif: !1, wdp: !1 },
      URLPARAMS = {};!function () {
    var a,
        b = (navigator.appName, navigator.appVersion),
        c = navigator.userAgent;switch (navigator.appName) {case "Microsoft Internet Explorer":
        if (window.attachEvent && window.ActiveXObject) {
          $.Browser.vendor = $.BROWSERS.IE;$.Browser.version = parseFloat(c.substring(c.indexOf("MSIE") + 5, c.indexOf(";", c.indexOf("MSIE"))));
        }break;case "Netscape":
        if (window.addEventListener) if (c.indexOf("Firefox") >= 0) {
          $.Browser.vendor = $.BROWSERS.FIREFOX;$.Browser.version = parseFloat(c.substring(c.indexOf("Firefox") + 8));
        } else if (c.indexOf("Safari") >= 0) {
          $.Browser.vendor = c.indexOf("Chrome") >= 0 ? $.BROWSERS.CHROME : $.BROWSERS.SAFARI;$.Browser.version = parseFloat(c.substring(c.substring(0, c.indexOf("Safari")).lastIndexOf("/") + 1, c.indexOf("Safari")));
        } else {
          a = new RegExp("Trident/.*rv:([0-9]{1,}[.0-9]{0,})");if (null !== a.exec(c)) {
            $.Browser.vendor = $.BROWSERS.IE;$.Browser.version = parseFloat(RegExp.$1);
          }
        }break;case "Opera":
        $.Browser.vendor = $.BROWSERS.OPERA;$.Browser.version = parseFloat(b);}var d,
        e,
        f,
        g = window.location.search.substring(1),
        h = g.split("&");for (f = 0; f < h.length; f++) {
      d = h[f];e = d.indexOf("=");e > 0 && (URLPARAMS[d.substring(0, e)] = decodeURIComponent(d.substring(e + 1)));
    }$.Browser.alpha = !($.Browser.vendor == $.BROWSERS.IE && $.Browser.version < 9 || $.Browser.vendor == $.BROWSERS.CHROME && $.Browser.version < 2);$.Browser.opacity = !($.Browser.vendor == $.BROWSERS.IE && $.Browser.version < 9);
  }();var nullfunction = function nullfunction(a) {};$.console = window.console || { log: nullfunction, debug: nullfunction, info: nullfunction, warn: nullfunction, error: nullfunction, assert: nullfunction };!function (a) {
    var b = a.requestAnimationFrame || a.mozRequestAnimationFrame || a.webkitRequestAnimationFrame || a.msRequestAnimationFrame;var c = a.cancelAnimationFrame || a.mozCancelAnimationFrame || a.webkitCancelAnimationFrame || a.msCancelAnimationFrame;if (b && c) {
      $.requestAnimationFrame = function () {
        return b.apply(a, arguments);
      };$.cancelAnimationFrame = function () {
        return c.apply(a, arguments);
      };
    } else {
      var d,
          e = [],
          f = [],
          g = 0;$.requestAnimationFrame = function (a) {
        e.push([++g, a]);d || (d = setInterval(function () {
          if (e.length) {
            var a = $.now();var b = f;f = e;e = b;for (; f.length;) {
              f.shift()[1](a);
            }
          } else {
            clearInterval(d);d = void 0;
          }
        }, 20));return g;
      };$.cancelAnimationFrame = function (a) {
        var b, c;for (b = 0, c = e.length; c > b; b += 1) {
          if (e[b][0] === a) {
            e.splice(b, 1);return;
          }
        }for (b = 0, c = f.length; c > b; b += 1) {
          if (f[b][0] === a) {
            f.splice(b, 1);return;
          }
        }
      };
    }
  }(window);
}(OpenSeadragon);!function (a) {
  var b = { supportsFullScreen: !1, isFullScreen: function isFullScreen() {
      return !1;
    }, getFullScreenElement: function getFullScreenElement() {
      return null;
    }, requestFullScreen: function requestFullScreen() {}, exitFullScreen: function exitFullScreen() {}, cancelFullScreen: function cancelFullScreen() {}, fullScreenEventName: "", fullScreenErrorEventName: "" };if (document.exitFullscreen) {
    b.supportsFullScreen = !0;b.getFullScreenElement = function () {
      return document.fullscreenElement;
    };b.requestFullScreen = function (a) {
      return a.requestFullscreen();
    };b.exitFullScreen = function () {
      document.exitFullscreen();
    };b.fullScreenEventName = "fullscreenchange";b.fullScreenErrorEventName = "fullscreenerror";
  } else if (document.msExitFullscreen) {
    b.supportsFullScreen = !0;b.getFullScreenElement = function () {
      return document.msFullscreenElement;
    };b.requestFullScreen = function (a) {
      return a.msRequestFullscreen();
    };b.exitFullScreen = function () {
      document.msExitFullscreen();
    };b.fullScreenEventName = "MSFullscreenChange";b.fullScreenErrorEventName = "MSFullscreenError";
  } else if (document.webkitExitFullscreen) {
    b.supportsFullScreen = !0;b.getFullScreenElement = function () {
      return document.webkitFullscreenElement;
    };b.requestFullScreen = function (a) {
      return a.webkitRequestFullscreen();
    };b.exitFullScreen = function () {
      document.webkitExitFullscreen();
    };b.fullScreenEventName = "webkitfullscreenchange";b.fullScreenErrorEventName = "webkitfullscreenerror";
  } else if (document.webkitCancelFullScreen) {
    b.supportsFullScreen = !0;b.getFullScreenElement = function () {
      return document.webkitCurrentFullScreenElement;
    };b.requestFullScreen = function (a) {
      return a.webkitRequestFullScreen();
    };b.exitFullScreen = function () {
      document.webkitCancelFullScreen();
    };b.fullScreenEventName = "webkitfullscreenchange";b.fullScreenErrorEventName = "webkitfullscreenerror";
  } else if (document.mozCancelFullScreen) {
    b.supportsFullScreen = !0;b.getFullScreenElement = function () {
      return document.mozFullScreenElement;
    };b.requestFullScreen = function (a) {
      return a.mozRequestFullScreen();
    };b.exitFullScreen = function () {
      document.mozCancelFullScreen();
    };b.fullScreenEventName = "mozfullscreenchange";b.fullScreenErrorEventName = "mozfullscreenerror";
  }b.isFullScreen = function () {
    return null !== b.getFullScreenElement();
  };b.cancelFullScreen = function () {
    a.console.error("cancelFullScreen is deprecated. Use exitFullScreen instead.");b.exitFullScreen();
  };a.extend(a, b);
}(OpenSeadragon);!function (a) {
  a.EventSource = function () {
    this.events = {};
  };a.EventSource.prototype = { addOnceHandler: function addOnceHandler(a, b, c, d) {
      var e = this;d = d || 1;var f = 0;var g = function g(c) {
        f++;f === d && e.removeHandler(a, g);b(c);
      };this.addHandler(a, g, c);
    }, addHandler: function addHandler(b, c, d) {
      var e = this.events[b];e || (this.events[b] = e = []);c && a.isFunction(c) && (e[e.length] = { handler: c, userData: d || null });
    }, removeHandler: function removeHandler(b, c) {
      var d,
          e = this.events[b],
          f = [];if (e && a.isArray(e)) {
        for (d = 0; d < e.length; d++) {
          e[d].handler !== c && f.push(e[d]);
        }this.events[b] = f;
      }
    }, removeAllHandlers: function removeAllHandlers(a) {
      if (a) this.events[a] = [];else for (var b in this.events) {
        this.events[b] = [];
      }
    }, getHandler: function getHandler(a) {
      var b = this.events[a];if (!b || !b.length) return null;b = 1 === b.length ? [b[0]] : Array.apply(null, b);return function (a, c) {
        var d,
            e = b.length;for (d = 0; e > d; d++) {
          if (b[d]) {
            c.eventSource = a;c.userData = b[d].userData;b[d].handler(c);
          }
        }
      };
    }, raiseEvent: function raiseEvent(a, b) {
      var c = this.getHandler(a);if (c) {
        b || (b = {});c(this, b);
      }
    } };
}(OpenSeadragon);!function (a) {
  function b(b) {
    var c,
        d = pa[b.hash],
        e = d.activePointersLists.length;for (c = 0; e > c; c++) {
      if (d.activePointersLists[c].captureCount > 0) {
        a.removeEvent(a.MouseTracker.captureElement, "mousemove", d.mousemovecaptured, !0);a.removeEvent(a.MouseTracker.captureElement, "mouseup", d.mouseupcaptured, !0);a.removeEvent(a.MouseTracker.captureElement, a.MouseTracker.unprefixedPointerEvents ? "pointermove" : "MSPointerMove", d.pointermovecaptured, !0);a.removeEvent(a.MouseTracker.captureElement, a.MouseTracker.unprefixedPointerEvents ? "pointerup" : "MSPointerUp", d.pointerupcaptured, !0);a.removeEvent(a.MouseTracker.captureElement, "touchmove", d.touchmovecaptured, !0);a.removeEvent(a.MouseTracker.captureElement, "touchend", d.touchendcaptured, !0);d.activePointersLists[c].captureCount = 0;
      }
    }for (c = 0; e > c; c++) {
      d.activePointersLists.pop();
    }
  }function c(c) {
    var d,
        e,
        f = pa[c.hash];if (!f.tracking) {
      for (e = 0; e < a.MouseTracker.subscribeEvents.length; e++) {
        d = a.MouseTracker.subscribeEvents[e];a.addEvent(c.element, d, f[d], !1);
      }b(c);f.tracking = !0;
    }
  }function d(c) {
    var d,
        e,
        f = pa[c.hash];if (f.tracking) {
      for (e = 0; e < a.MouseTracker.subscribeEvents.length; e++) {
        d = a.MouseTracker.subscribeEvents[e];a.removeEvent(c.element, d, f[d], !1);
      }b(c);f.tracking = !1;
    }
  }function e(b, c) {
    var d = pa[b.hash];if ("pointerevent" === c) return { upName: a.MouseTracker.unprefixedPointerEvents ? "pointerup" : "MSPointerUp", upHandler: d.pointerupcaptured, moveName: a.MouseTracker.unprefixedPointerEvents ? "pointermove" : "MSPointerMove", moveHandler: d.pointermovecaptured };if ("mouse" === c) return { upName: "mouseup", upHandler: d.mouseupcaptured, moveName: "mousemove", moveHandler: d.mousemovecaptured };if ("touch" === c) return { upName: "touchend", upHandler: d.touchendcaptured, moveName: "touchmove", moveHandler: d.touchmovecaptured };throw new Error("MouseTracker.getCaptureEventParams: Unknown pointer type.");
  }function f(b, c, d) {
    var f,
        g = b.getActivePointersListByType(c);g.captureCount += d || 1;if (1 === g.captureCount) if (a.Browser.vendor === a.BROWSERS.IE && a.Browser.version < 9) b.element.setCapture(!0);else {
      f = e(b, a.MouseTracker.havePointerEvents ? "pointerevent" : c);qa && na(window.top) && a.addEvent(window.top, f.upName, f.upHandler, !0);a.addEvent(a.MouseTracker.captureElement, f.upName, f.upHandler, !0);a.addEvent(a.MouseTracker.captureElement, f.moveName, f.moveHandler, !0);
    }
  }function g(b, c, d) {
    var f,
        g = b.getActivePointersListByType(c);g.captureCount -= d || 1;if (0 === g.captureCount) if (a.Browser.vendor === a.BROWSERS.IE && a.Browser.version < 9) b.element.releaseCapture();else {
      f = e(b, a.MouseTracker.havePointerEvents ? "pointerevent" : c);qa && na(window.top) && a.removeEvent(window.top, f.upName, f.upHandler, !0);a.removeEvent(a.MouseTracker.captureElement, f.moveName, f.moveHandler, !0);a.removeEvent(a.MouseTracker.captureElement, f.upName, f.upHandler, !0);
    }
  }function h(b) {
    var c;if (a.MouseTracker.unprefixedPointerEvents) c = b.pointerType;else switch (b.pointerType) {case 2:
        c = "touch";break;case 3:
        c = "pen";break;case 4:
        c = "mouse";break;default:
        c = "";}return c;
  }function i(b) {
    return a.getMousePosition(b);
  }function j(a, b) {
    return k(i(a), b);
  }function k(b, c) {
    var d = a.getElementOffset(c);return b.minus(d);
  }function l(b, c) {
    return new a.Point((b.x + c.x) / 2, (b.y + c.y) / 2);
  }function m(b, c) {
    b.clickHandler && a.cancelEvent(c);
  }function n(b, c) {
    b.dblClickHandler && a.cancelEvent(c);
  }function o(b, c) {
    var d;if (b.keyDownHandler) {
      c = a.getEvent(c);d = b.keyDownHandler({ eventSource: b, keyCode: c.keyCode ? c.keyCode : c.charCode, ctrl: c.ctrlKey, shift: c.shiftKey, alt: c.altKey, meta: c.metaKey, originalEvent: c, preventDefaultAction: !1, userData: b.userData });d || a.cancelEvent(c);
    }
  }function p(b, c) {
    var d;if (b.keyUpHandler) {
      c = a.getEvent(c);d = b.keyUpHandler({ eventSource: b, keyCode: c.keyCode ? c.keyCode : c.charCode, ctrl: c.ctrlKey, shift: c.shiftKey, alt: c.altKey, meta: c.metaKey, originalEvent: c, preventDefaultAction: !1, userData: b.userData });d || a.cancelEvent(c);
    }
  }function q(b, c) {
    var d;if (b.keyHandler) {
      c = a.getEvent(c);d = b.keyHandler({ eventSource: b, keyCode: c.keyCode ? c.keyCode : c.charCode, ctrl: c.ctrlKey, shift: c.shiftKey, alt: c.altKey, meta: c.metaKey, originalEvent: c, preventDefaultAction: !1, userData: b.userData });d || a.cancelEvent(c);
    }
  }function r(b, c) {
    var d;if (b.focusHandler) {
      c = a.getEvent(c);d = b.focusHandler({ eventSource: b, originalEvent: c, preventDefaultAction: !1, userData: b.userData });d === !1 && a.cancelEvent(c);
    }
  }function s(b, c) {
    var d;if (b.blurHandler) {
      c = a.getEvent(c);d = b.blurHandler({ eventSource: b, originalEvent: c, preventDefaultAction: !1, userData: b.userData });d === !1 && a.cancelEvent(c);
    }
  }function t(a, b) {
    v(a, b, b);
  }function u(b, c) {
    c = a.getEvent(c);var d = { target: c.target || c.srcElement, type: "wheel", shiftKey: c.shiftKey || !1, clientX: c.clientX, clientY: c.clientY, pageX: c.pageX ? c.pageX : c.clientX, pageY: c.pageY ? c.pageY : c.clientY, deltaMode: "MozMousePixelScroll" == c.type ? 0 : 1, deltaX: 0, deltaZ: 0 };"mousewheel" == a.MouseTracker.wheelEventName ? d.deltaY = -1 / a.DEFAULT_SETTINGS.pixelsPerWheelLine * c.wheelDelta : d.deltaY = c.detail;v(b, d, c);
  }function v(b, c, d) {
    var e,
        f = 0;f = c.deltaY < 0 ? 1 : -1;if (b.scrollHandler) {
      e = b.scrollHandler({ eventSource: b, pointerType: "mouse", position: j(c, b.element), scroll: f, shift: c.shiftKey, isTouchEvent: !1, originalEvent: d, preventDefaultAction: !1, userData: b.userData });e === !1 && a.cancelEvent(d);
    }
  }function w(a, b) {
    if (a === b) return !1;for (; b && b !== a;) {
      b = b.parentNode;
    }return b === a;
  }function x(b, c) {
    c = a.getEvent(c);z(b, c);
  }function y(b, c) {
    c = a.getEvent(c);c.currentTarget === c.relatedTarget || w(c.currentTarget, c.relatedTarget) || z(b, c);
  }function z(b, c) {
    var d = { id: a.MouseTracker.mousePointerId, type: "mouse", isPrimary: !0, currentPos: i(c), currentTime: a.now() };ga(b, c, [d]);
  }function A(b, c) {
    c = a.getEvent(c);C(b, c);
  }function B(b, c) {
    c = a.getEvent(c);c.currentTarget === c.relatedTarget || w(c.currentTarget, c.relatedTarget) || C(b, c);
  }function C(b, c) {
    var d = { id: a.MouseTracker.mousePointerId, type: "mouse", isPrimary: !0, currentPos: i(c), currentTime: a.now() };ha(b, c, [d]);
  }function D(b) {
    return a.Browser.vendor === a.BROWSERS.IE && a.Browser.version < 9 ? 1 === b ? 0 : 2 === b ? 2 : 4 === b ? 1 : -1 : b;
  }function E(b, c) {
    var d;c = a.getEvent(c);d = { id: a.MouseTracker.mousePointerId, type: "mouse", isPrimary: !0, currentPos: i(c), currentTime: a.now() };if (ia(b, c, [d], D(c.button))) {
      a.stopEvent(c);f(b, "mouse");
    }(b.clickHandler || b.dblClickHandler || b.pressHandler || b.dragHandler || b.dragEndHandler) && a.cancelEvent(c);
  }function F(a, b) {
    H(a, b);
  }function G(b, c) {
    H(b, c);a.stopEvent(c);
  }function H(b, c) {
    var d;c = a.getEvent(c);d = { id: a.MouseTracker.mousePointerId, type: "mouse", isPrimary: !0, currentPos: i(c), currentTime: a.now() };ja(b, c, [d], D(c.button)) && g(b, "mouse");
  }function I(a, b) {
    K(a, b);
  }function J(b, c) {
    K(b, c);a.stopEvent(c);
  }function K(b, c) {
    var d;c = a.getEvent(c);d = { id: a.MouseTracker.mousePointerId, type: "mouse", isPrimary: !0, currentPos: i(c), currentTime: a.now() };ka(b, c, [d]);
  }function L(a, b, c) {
    var d,
        e = c.getLength(),
        f = [];for (d = 0; e > d; d++) {
      f.push(c.getByIndex(d));
    }if (f.length > 0) {
      ja(a, b, f, 0);c.captureCount = 1;g(a, "touch");ha(a, b, f);
    }
  }function M(b, c) {
    var d,
        e,
        g,
        h,
        j = c.changedTouches.length,
        k = [],
        l = b.getActivePointersListByType("touch");d = a.now();if (l.getLength() > c.touches.length - j) {
      a.console.warn("Tracked touch contact count doesn't match event.touches.length. Removing all tracked touch pointers.");L(b, c, l);
    }for (e = 0; j > e; e++) {
      k.push({ id: c.changedTouches[e].identifier, type: "touch", currentPos: i(c.changedTouches[e]), currentTime: d });
    }ga(b, c, k);for (e = 0; e < oa.length; e++) {
      if (oa[e] !== b && oa[e].isTracking() && w(oa[e].element, b.element)) {
        h = [];for (g = 0; j > g; g++) {
          h.push({ id: c.changedTouches[g].identifier, type: "touch", currentPos: i(c.changedTouches[g]), currentTime: d });
        }ga(oa[e], c, h);
      }
    }if (ia(b, c, k, 0)) {
      a.stopEvent(c);f(b, "touch", j);
    }a.cancelEvent(c);
  }function N(a, b) {
    P(a, b);
  }function O(b, c) {
    P(b, c);a.stopEvent(c);
  }function P(b, c) {
    var d,
        e,
        f,
        h,
        j = c.changedTouches.length,
        k = [];d = a.now();for (e = 0; j > e; e++) {
      k.push({ id: c.changedTouches[e].identifier, type: "touch", currentPos: i(c.changedTouches[e]), currentTime: d });
    }ja(b, c, k, 0) && g(b, "touch", j);ha(b, c, k);for (e = 0; e < oa.length; e++) {
      if (oa[e] !== b && oa[e].isTracking() && w(oa[e].element, b.element)) {
        h = [];for (f = 0; j > f; f++) {
          h.push({ id: c.changedTouches[f].identifier, type: "touch", currentPos: i(c.changedTouches[f]), currentTime: d });
        }ha(oa[e], c, h);
      }
    }a.cancelEvent(c);
  }function Q(a, b) {
    S(a, b);
  }function R(b, c) {
    S(b, c);a.stopEvent(c);
  }function S(b, c) {
    var d,
        e = c.changedTouches.length,
        f = [];for (d = 0; e > d; d++) {
      f.push({ id: c.changedTouches[d].identifier, type: "touch", currentPos: i(c.changedTouches[d]), currentTime: a.now() });
    }ka(b, c, f);a.cancelEvent(c);
  }function T(a, b) {
    var c = (b.changedTouches.length, a.getActivePointersListByType("touch"));L(a, b, c);
  }function U(a, b) {
    b.stopPropagation();b.preventDefault();return !1;
  }function V(a, b) {
    b.stopPropagation();b.preventDefault();return !1;
  }function W(b, c) {
    var d;if (c.currentTarget !== c.relatedTarget && !w(c.currentTarget, c.relatedTarget)) {
      d = { id: c.pointerId, type: h(c), isPrimary: c.isPrimary, currentPos: i(c), currentTime: a.now() };ga(b, c, [d]);
    }
  }function X(b, c) {
    var d;if (c.currentTarget !== c.relatedTarget && !w(c.currentTarget, c.relatedTarget)) {
      d = { id: c.pointerId, type: h(c), isPrimary: c.isPrimary, currentPos: i(c), currentTime: a.now() };ha(b, c, [d]);
    }
  }function Y(b, c) {
    var d;d = { id: c.pointerId, type: h(c), isPrimary: c.isPrimary, currentPos: i(c), currentTime: a.now() };if (ia(b, c, [d], c.button)) {
      a.stopEvent(c);f(b, d.type);
    }(b.clickHandler || b.dblClickHandler || b.pressHandler || b.dragHandler || b.dragEndHandler || b.pinchHandler) && a.cancelEvent(c);
  }function Z(a, b) {
    _(a, b);
  }function $(b, c) {
    var d = b.getActivePointersListByType(h(c));d.getById(c.pointerId) && _(b, c);a.stopEvent(c);
  }function _(b, c) {
    var d;d = { id: c.pointerId, type: h(c), isPrimary: c.isPrimary, currentPos: i(c), currentTime: a.now() };ja(b, c, [d], c.button) && g(b, d.type);
  }function aa(a, b) {
    ca(a, b);
  }function ba(b, c) {
    var d = b.getActivePointersListByType(h(c));d.getById(c.pointerId) && ca(b, c);a.stopEvent(c);
  }function ca(b, c) {
    var d;d = { id: c.pointerId, type: h(c), isPrimary: c.isPrimary, currentPos: i(c), currentTime: a.now() };ka(b, c, [d]);
  }function da(a, b) {
    var c;c = { id: b.pointerId, type: h(b) };la(a, b, [c]);
  }function ea(a, b) {
    b.hasOwnProperty("isPrimary") || (0 === a.getLength() ? b.isPrimary = !0 : b.isPrimary = !1);b.speed = 0;b.direction = 0;b.contactPos = b.currentPos;b.contactTime = b.currentTime;b.lastPos = b.currentPos;b.lastTime = b.currentTime;return a.add(b);
  }function fa(a, b) {
    var c, d;if (a.getById(b.id)) {
      c = a.removeById(b.id);if (!b.hasOwnProperty("isPrimary")) {
        d = a.getPrimary();if (!d) {
          d = a.getByIndex(0);d && (d.isPrimary = !0);
        }
      }
    } else c = a.getLength();return c;
  }function ga(b, c, d) {
    var e,
        f,
        g,
        h,
        i = b.getActivePointersListByType(d[0].type),
        j = d.length;for (e = 0; j > e; e++) {
      f = d[e];g = i.getById(f.id);if (g) {
        g.insideElement = !0;g.lastPos = g.currentPos;g.lastTime = g.currentTime;g.currentPos = f.currentPos;g.currentTime = f.currentTime;f = g;
      } else {
        f.captured = !1;f.insideElementPressed = !1;f.insideElement = !0;ea(i, f);
      }if (b.enterHandler) {
        h = b.enterHandler({ eventSource: b, pointerType: f.type, position: k(f.currentPos, b.element), buttons: i.buttons, pointers: b.getActivePointerCount(), insideElementPressed: f.insideElementPressed, buttonDownAny: 0 !== i.buttons, isTouchEvent: "touch" === f.type, originalEvent: c, preventDefaultAction: !1, userData: b.userData });h === !1 && a.cancelEvent(c);
      }
    }
  }function ha(b, c, d) {
    var e,
        f,
        g,
        h,
        i = (pa[b.hash], b.getActivePointersListByType(d[0].type)),
        j = d.length;for (e = 0; j > e; e++) {
      f = d[e];g = i.getById(f.id);if (g) {
        if (g.captured) {
          g.insideElement = !1;g.lastPos = g.currentPos;g.lastTime = g.currentTime;g.currentPos = f.currentPos;g.currentTime = f.currentTime;
        } else fa(i, g);f = g;
      }if (b.exitHandler) {
        h = b.exitHandler({ eventSource: b, pointerType: f.type, position: k(f.currentPos, b.element), buttons: i.buttons, pointers: b.getActivePointerCount(), insideElementPressed: g ? g.insideElementPressed : !1, buttonDownAny: 0 !== i.buttons, isTouchEvent: "touch" === f.type, originalEvent: c, preventDefaultAction: !1, userData: b.userData });h === !1 && a.cancelEvent(c);
      }
    }
  }function ia(b, c, d, e) {
    var f,
        g,
        h,
        i,
        j = pa[b.hash],
        m = b.getActivePointersListByType(d[0].type),
        n = d.length;"undefined" != typeof c.buttons ? m.buttons = c.buttons : a.Browser.vendor === a.BROWSERS.IE && a.Browser.version < 9 ? 0 === e ? m.buttons += 1 : 1 === e ? m.buttons += 4 : 2 === e ? m.buttons += 2 : 3 === e ? m.buttons += 8 : 4 === e ? m.buttons += 16 : 5 === e && (m.buttons += 32) : 0 === e ? m.buttons |= 1 : 1 === e ? m.buttons |= 4 : 2 === e ? m.buttons |= 2 : 3 === e ? m.buttons |= 8 : 4 === e ? m.buttons |= 16 : 5 === e && (m.buttons |= 32);if (0 !== e) {
      if (b.nonPrimaryPressHandler) {
        f = b.nonPrimaryPressHandler({ eventSource: b, pointerType: d[0].type, position: k(d[0].currentPos, b.element), button: e, buttons: m.buttons, isTouchEvent: "touch" === d[0].type, originalEvent: c, preventDefaultAction: !1, userData: b.userData });f === !1 && a.cancelEvent(c);
      }return !1;
    }for (g = 0; n > g; g++) {
      h = d[g];i = m.getById(h.id);if (i) {
        i.captured = !0;i.insideElementPressed = !0;i.insideElement = !0;i.contactPos = h.currentPos;i.contactTime = h.currentTime;i.lastPos = i.currentPos;i.lastTime = i.currentTime;i.currentPos = h.currentPos;i.currentTime = h.currentTime;h = i;
      } else {
        h.captured = !0;h.insideElementPressed = !0;h.insideElement = !0;ea(m, h);
      }m.contacts++;(b.dragHandler || b.dragEndHandler || b.pinchHandler) && a.MouseTracker.gesturePointVelocityTracker.addPoint(b, h);if (1 === m.contacts) {
        if (b.pressHandler) {
          f = b.pressHandler({ eventSource: b, pointerType: h.type, position: k(h.contactPos, b.element), buttons: m.buttons, isTouchEvent: "touch" === h.type, originalEvent: c, preventDefaultAction: !1, userData: b.userData });f === !1 && a.cancelEvent(c);
        }
      } else if (2 === m.contacts && b.pinchHandler && "touch" === h.type) {
        j.pinchGPoints = m.asArray();j.lastPinchDist = j.currentPinchDist = j.pinchGPoints[0].currentPos.distanceTo(j.pinchGPoints[1].currentPos);j.lastPinchCenter = j.currentPinchCenter = l(j.pinchGPoints[0].currentPos, j.pinchGPoints[1].currentPos);
      }
    }return !0;
  }function ja(b, c, d, e) {
    var f,
        g,
        h,
        i,
        j,
        m,
        n,
        o = pa[b.hash],
        p = b.getActivePointersListByType(d[0].type),
        q = d.length,
        r = !1,
        s = !1;"undefined" != typeof c.buttons ? p.buttons = c.buttons : a.Browser.vendor === a.BROWSERS.IE && a.Browser.version < 9 ? 0 === e ? p.buttons -= 1 : 1 === e ? p.buttons -= 4 : 2 === e ? p.buttons -= 2 : 3 === e ? p.buttons -= 8 : 4 === e ? p.buttons -= 16 : 5 === e && (p.buttons -= 32) : 0 === e ? p.buttons ^= -2 : 1 === e ? p.buttons ^= -5 : 2 === e ? p.buttons ^= -3 : 3 === e ? p.buttons ^= -9 : 4 === e ? p.buttons ^= -17 : 5 === e && (p.buttons ^= -33);if (0 !== e) {
      if (b.nonPrimaryReleaseHandler) {
        f = b.nonPrimaryReleaseHandler({ eventSource: b, pointerType: d[0].type, position: k(d[0].currentPos, b.element), button: e, buttons: p.buttons, isTouchEvent: "touch" === d[0].type, originalEvent: c, preventDefaultAction: !1, userData: b.userData });f === !1 && a.cancelEvent(c);
      }return !1;
    }for (i = 0; q > i; i++) {
      j = d[i];m = p.getById(j.id);if (m) {
        if (m.captured) {
          m.captured = !1;r = !0;s = !0;
        }m.lastPos = m.currentPos;m.lastTime = m.currentTime;m.currentPos = j.currentPos;m.currentTime = j.currentTime;m.insideElement || fa(p, m);g = m.currentPos;h = m.currentTime;if (s) {
          p.contacts--;(b.dragHandler || b.dragEndHandler || b.pinchHandler) && a.MouseTracker.gesturePointVelocityTracker.removePoint(b, m);if (0 === p.contacts) {
            if (b.releaseHandler) {
              f = b.releaseHandler({ eventSource: b, pointerType: m.type, position: k(g, b.element), buttons: p.buttons, insideElementPressed: m.insideElementPressed, insideElementReleased: m.insideElement, isTouchEvent: "touch" === m.type, originalEvent: c, preventDefaultAction: !1, userData: b.userData });f === !1 && a.cancelEvent(c);
            }if (b.dragEndHandler && !m.currentPos.equals(m.contactPos)) {
              f = b.dragEndHandler({ eventSource: b, pointerType: m.type, position: k(m.currentPos, b.element), speed: m.speed, direction: m.direction, shift: c.shiftKey, isTouchEvent: "touch" === m.type, originalEvent: c, preventDefaultAction: !1, userData: b.userData });f === !1 && a.cancelEvent(c);
            }if ((b.clickHandler || b.dblClickHandler) && m.insideElement) {
              n = h - m.contactTime <= b.clickTimeThreshold && m.contactPos.distanceTo(g) <= b.clickDistThreshold;if (b.clickHandler) {
                f = b.clickHandler({ eventSource: b, pointerType: m.type, position: k(m.currentPos, b.element), quick: n, shift: c.shiftKey, isTouchEvent: "touch" === m.type, originalEvent: c, preventDefaultAction: !1, userData: b.userData });f === !1 && a.cancelEvent(c);
              }if (b.dblClickHandler && n) {
                p.clicks++;if (1 === p.clicks) {
                  o.lastClickPos = g;o.dblClickTimeOut = setTimeout(function () {
                    p.clicks = 0;
                  }, b.dblClickTimeThreshold);
                } else if (2 === p.clicks) {
                  clearTimeout(o.dblClickTimeOut);p.clicks = 0;if (o.lastClickPos.distanceTo(g) <= b.dblClickDistThreshold) {
                    f = b.dblClickHandler({ eventSource: b, pointerType: m.type, position: k(m.currentPos, b.element), shift: c.shiftKey, isTouchEvent: "touch" === m.type, originalEvent: c, preventDefaultAction: !1, userData: b.userData });f === !1 && a.cancelEvent(c);
                  }o.lastClickPos = null;
                }
              }
            }
          } else if (2 === p.contacts && b.pinchHandler && "touch" === m.type) {
            o.pinchGPoints = p.asArray();o.lastPinchDist = o.currentPinchDist = o.pinchGPoints[0].currentPos.distanceTo(o.pinchGPoints[1].currentPos);o.lastPinchCenter = o.currentPinchCenter = l(o.pinchGPoints[0].currentPos, o.pinchGPoints[1].currentPos);
          }
        } else if (b.releaseHandler) {
          f = b.releaseHandler({ eventSource: b, pointerType: m.type, position: k(g, b.element), buttons: p.buttons, insideElementPressed: m.insideElementPressed, insideElementReleased: m.insideElement, isTouchEvent: "touch" === m.type, originalEvent: c, preventDefaultAction: !1, userData: b.userData });f === !1 && a.cancelEvent(c);
        }
      }
    }return r;
  }function ka(b, c, d) {
    var e,
        f,
        g,
        h,
        i,
        j,
        m = pa[b.hash],
        n = b.getActivePointersListByType(d[0].type),
        o = d.length;"undefined" != typeof c.buttons && (n.buttons = c.buttons);for (e = 0; o > e; e++) {
      f = d[e];g = n.getById(f.id);if (g) {
        f.hasOwnProperty("isPrimary") && (g.isPrimary = f.isPrimary);g.lastPos = g.currentPos;g.lastTime = g.currentTime;g.currentPos = f.currentPos;g.currentTime = f.currentTime;
      } else {
        f.captured = !1;f.insideElementPressed = !1;f.insideElement = !0;ea(n, f);
      }
    }if (b.stopHandler && "mouse" === d[0].type) {
      clearTimeout(b.stopTimeOut);b.stopTimeOut = setTimeout(function () {
        ma(b, c, d[0].type);
      }, b.stopDelay);
    }if (0 === n.contacts) {
      if (b.moveHandler) {
        j = b.moveHandler({ eventSource: b, pointerType: d[0].type, position: k(d[0].currentPos, b.element), buttons: n.buttons, isTouchEvent: "touch" === d[0].type, originalEvent: c, preventDefaultAction: !1, userData: b.userData });j === !1 && a.cancelEvent(c);
      }
    } else if (1 === n.contacts) {
      if (b.moveHandler) {
        g = n.asArray()[0];j = b.moveHandler({ eventSource: b, pointerType: g.type, position: k(g.currentPos, b.element), buttons: n.buttons, isTouchEvent: "touch" === g.type, originalEvent: c, preventDefaultAction: !1, userData: b.userData });j === !1 && a.cancelEvent(c);
      }if (b.dragHandler) {
        g = n.asArray()[0];i = g.currentPos.minus(g.lastPos);j = b.dragHandler({ eventSource: b, pointerType: g.type, position: k(g.currentPos, b.element), buttons: n.buttons, delta: i, speed: g.speed, direction: g.direction, shift: c.shiftKey, isTouchEvent: "touch" === g.type, originalEvent: c, preventDefaultAction: !1, userData: b.userData });j === !1 && a.cancelEvent(c);
      }
    } else if (2 === n.contacts) {
      if (b.moveHandler) {
        h = n.asArray();j = b.moveHandler({ eventSource: b, pointerType: h[0].type, position: k(l(h[0].currentPos, h[1].currentPos), b.element), buttons: n.buttons, isTouchEvent: "touch" === h[0].type, originalEvent: c, preventDefaultAction: !1, userData: b.userData });j === !1 && a.cancelEvent(c);
      }if (b.pinchHandler && "touch" === d[0].type) {
        i = m.pinchGPoints[0].currentPos.distanceTo(m.pinchGPoints[1].currentPos);if (i != m.currentPinchDist) {
          m.lastPinchDist = m.currentPinchDist;m.currentPinchDist = i;m.lastPinchCenter = m.currentPinchCenter;m.currentPinchCenter = l(m.pinchGPoints[0].currentPos, m.pinchGPoints[1].currentPos);j = b.pinchHandler({ eventSource: b, pointerType: "touch", gesturePoints: m.pinchGPoints, lastCenter: k(m.lastPinchCenter, b.element), center: k(m.currentPinchCenter, b.element), lastDistance: m.lastPinchDist, distance: m.currentPinchDist, shift: c.shiftKey, originalEvent: c, preventDefaultAction: !1, userData: b.userData });j === !1 && a.cancelEvent(c);
        }
      }
    }
  }function la(a, b, c) {
    ja(a, b, c, 0);ha(a, b, c);
  }function ma(a, b, c) {
    a.stopHandler && a.stopHandler({ eventSource: a, pointerType: c, position: j(b, a.element), buttons: a.getActivePointersListByType(c).buttons, isTouchEvent: "touch" === c, originalEvent: b, preventDefaultAction: !1, userData: a.userData });
  }function na(a) {
    try {
      return a.addEventListener && a.removeEventListener;
    } catch (b) {
      return !1;
    }
  }var oa = [];var pa = {};a.MouseTracker = function (b) {
    oa.push(this);var c = arguments;a.isPlainObject(b) || (b = { element: c[0], clickTimeThreshold: c[1], clickDistThreshold: c[2] });this.hash = Math.random();this.element = a.getElement(b.element);this.clickTimeThreshold = b.clickTimeThreshold || a.DEFAULT_SETTINGS.clickTimeThreshold;this.clickDistThreshold = b.clickDistThreshold || a.DEFAULT_SETTINGS.clickDistThreshold;this.dblClickTimeThreshold = b.dblClickTimeThreshold || a.DEFAULT_SETTINGS.dblClickTimeThreshold;this.dblClickDistThreshold = b.dblClickDistThreshold || a.DEFAULT_SETTINGS.dblClickDistThreshold;this.userData = b.userData || null;this.stopDelay = b.stopDelay || 50;this.enterHandler = b.enterHandler || null;this.exitHandler = b.exitHandler || null;this.pressHandler = b.pressHandler || null;this.nonPrimaryPressHandler = b.nonPrimaryPressHandler || null;this.releaseHandler = b.releaseHandler || null;this.nonPrimaryReleaseHandler = b.nonPrimaryReleaseHandler || null;this.moveHandler = b.moveHandler || null;this.scrollHandler = b.scrollHandler || null;this.clickHandler = b.clickHandler || null;this.dblClickHandler = b.dblClickHandler || null;this.dragHandler = b.dragHandler || null;this.dragEndHandler = b.dragEndHandler || null;this.pinchHandler = b.pinchHandler || null;this.stopHandler = b.stopHandler || null;this.keyDownHandler = b.keyDownHandler || null;this.keyUpHandler = b.keyUpHandler || null;this.keyHandler = b.keyHandler || null;this.focusHandler = b.focusHandler || null;this.blurHandler = b.blurHandler || null;var d = this;pa[this.hash] = { click: function click(a) {
        m(d, a);
      }, dblclick: function dblclick(a) {
        n(d, a);
      }, keydown: function keydown(a) {
        o(d, a);
      }, keyup: function keyup(a) {
        p(d, a);
      }, keypress: function keypress(a) {
        q(d, a);
      }, focus: function focus(a) {
        r(d, a);
      }, blur: function blur(a) {
        s(d, a);
      }, wheel: function wheel(a) {
        t(d, a);
      }, mousewheel: function mousewheel(a) {
        u(d, a);
      }, DOMMouseScroll: function DOMMouseScroll(a) {
        u(d, a);
      }, MozMousePixelScroll: function MozMousePixelScroll(a) {
        u(d, a);
      }, mouseenter: function mouseenter(a) {
        x(d, a);
      }, mouseleave: function mouseleave(a) {
        A(d, a);
      }, mouseover: function mouseover(a) {
        y(d, a);
      }, mouseout: function mouseout(a) {
        B(d, a);
      }, mousedown: function mousedown(a) {
        E(d, a);
      }, mouseup: function mouseup(a) {
        F(d, a);
      }, mouseupcaptured: function mouseupcaptured(a) {
        G(d, a);
      }, mousemove: function mousemove(a) {
        I(d, a);
      }, mousemovecaptured: function mousemovecaptured(a) {
        J(d, a);
      }, touchstart: function touchstart(a) {
        M(d, a);
      }, touchend: function touchend(a) {
        N(d, a);
      }, touchendcaptured: function touchendcaptured(a) {
        O(d, a);
      }, touchmove: function touchmove(a) {
        Q(d, a);
      }, touchmovecaptured: function touchmovecaptured(a) {
        R(d, a);
      }, touchcancel: function touchcancel(a) {
        T(d, a);
      }, gesturestart: function gesturestart(a) {
        U(d, a);
      }, gesturechange: function gesturechange(a) {
        V(d, a);
      }, pointerover: function pointerover(a) {
        W(d, a);
      }, MSPointerOver: function MSPointerOver(a) {
        W(d, a);
      }, pointerout: function pointerout(a) {
        X(d, a);
      }, MSPointerOut: function MSPointerOut(a) {
        X(d, a);
      }, pointerdown: function pointerdown(a) {
        Y(d, a);
      }, MSPointerDown: function MSPointerDown(a) {
        Y(d, a);
      }, pointerup: function pointerup(a) {
        Z(d, a);
      }, MSPointerUp: function MSPointerUp(a) {
        Z(d, a);
      }, pointermove: function pointermove(a) {
        aa(d, a);
      }, MSPointerMove: function MSPointerMove(a) {
        aa(d, a);
      }, pointercancel: function pointercancel(a) {
        da(d, a);
      }, MSPointerCancel: function MSPointerCancel(a) {
        da(d, a);
      }, pointerupcaptured: function pointerupcaptured(a) {
        $(d, a);
      }, pointermovecaptured: function pointermovecaptured(a) {
        ba(d, a);
      }, tracking: !1, activePointersLists: [], lastClickPos: null, dblClickTimeOut: null, pinchGPoints: [], lastPinchDist: 0, currentPinchDist: 0, lastPinchCenter: null, currentPinchCenter: null };b.startDisabled || this.setTracking(!0);
  };a.MouseTracker.prototype = { destroy: function destroy() {
      var a;d(this);this.element = null;for (a = 0; a < oa.length; a++) {
        if (oa[a] === this) {
          oa.splice(a, 1);break;
        }
      }pa[this.hash] = null;delete pa[this.hash];
    }, isTracking: function isTracking() {
      return pa[this.hash].tracking;
    }, setTracking: function setTracking(a) {
      a ? c(this) : d(this);return this;
    }, getActivePointersListByType: function getActivePointersListByType(b) {
      var c,
          d,
          e = pa[this.hash],
          f = e.activePointersLists.length;for (c = 0; f > c; c++) {
        if (e.activePointersLists[c].type === b) return e.activePointersLists[c];
      }d = new a.MouseTracker.GesturePointList(b);e.activePointersLists.push(d);return d;
    }, getActivePointerCount: function getActivePointerCount() {
      var a,
          b = pa[this.hash],
          c = b.activePointersLists.length,
          d = 0;for (a = 0; c > a; a++) {
        d += b.activePointersLists[a].getLength();
      }return d;
    }, enterHandler: function enterHandler() {}, exitHandler: function exitHandler() {}, pressHandler: function pressHandler() {}, nonPrimaryPressHandler: function nonPrimaryPressHandler() {}, releaseHandler: function releaseHandler() {}, nonPrimaryReleaseHandler: function nonPrimaryReleaseHandler() {}, moveHandler: function moveHandler() {}, scrollHandler: function scrollHandler() {}, clickHandler: function clickHandler() {}, dblClickHandler: function dblClickHandler() {}, dragHandler: function dragHandler() {}, dragEndHandler: function dragEndHandler() {}, pinchHandler: function pinchHandler() {}, stopHandler: function stopHandler() {}, keyDownHandler: function keyDownHandler() {}, keyUpHandler: function keyUpHandler() {}, keyHandler: function keyHandler() {}, focusHandler: function focusHandler() {}, blurHandler: function blurHandler() {} };a.MouseTracker.gesturePointVelocityTracker = function () {
    var b = [],
        c = 0,
        d = 0;var e = function e(a, b) {
      return a.hash.toString() + b.type + b.id.toString();
    };var f = function f() {
      var c,
          e,
          f,
          g,
          h,
          i,
          j = b.length,
          k = a.now();g = k - d;d = k;for (c = 0; j > c; c++) {
        e = b[c];f = e.gPoint;f.direction = Math.atan2(f.currentPos.y - e.lastPos.y, f.currentPos.x - e.lastPos.x);h = e.lastPos.distanceTo(f.currentPos);e.lastPos = f.currentPos;i = 1e3 * h / (g + 1);f.speed = .75 * i + .25 * f.speed;
      }
    };var g = function g(_g, h) {
      var i = e(_g, h);b.push({ guid: i, gPoint: h, lastPos: h.currentPos });if (1 === b.length) {
        d = a.now();c = window.setInterval(f, 50);
      }
    };var h = function h(a, d) {
      var f,
          g = e(a, d),
          h = b.length;for (f = 0; h > f; f++) {
        if (b[f].guid === g) {
          b.splice(f, 1);h--;0 === h && window.clearInterval(c);break;
        }
      }
    };return { addPoint: g, removePoint: h };
  }();a.MouseTracker.captureElement = document;a.MouseTracker.wheelEventName = a.Browser.vendor == a.BROWSERS.IE && a.Browser.version > 8 || "onwheel" in document.createElement("div") ? "wheel" : void 0 !== document.onmousewheel ? "mousewheel" : "DOMMouseScroll";a.MouseTracker.supportsMouseCapture = function () {
    var b = document.createElement("div");return a.isFunction(b.setCapture) && a.isFunction(b.releaseCapture);
  }();a.MouseTracker.subscribeEvents = ["click", "dblclick", "keydown", "keyup", "keypress", "focus", "blur", a.MouseTracker.wheelEventName];"DOMMouseScroll" == a.MouseTracker.wheelEventName && a.MouseTracker.subscribeEvents.push("MozMousePixelScroll");if (window.PointerEvent && (window.navigator.pointerEnabled || a.Browser.vendor !== a.BROWSERS.IE)) {
    a.MouseTracker.havePointerEvents = !0;a.MouseTracker.subscribeEvents.push("pointerover", "pointerout", "pointerdown", "pointerup", "pointermove", "pointercancel");a.MouseTracker.unprefixedPointerEvents = !0;navigator.maxTouchPoints ? a.MouseTracker.maxTouchPoints = navigator.maxTouchPoints : a.MouseTracker.maxTouchPoints = 0;a.MouseTracker.haveMouseEnter = !1;
  } else if (window.MSPointerEvent && window.navigator.msPointerEnabled) {
    a.MouseTracker.havePointerEvents = !0;a.MouseTracker.subscribeEvents.push("MSPointerOver", "MSPointerOut", "MSPointerDown", "MSPointerUp", "MSPointerMove", "MSPointerCancel");a.MouseTracker.unprefixedPointerEvents = !1;navigator.msMaxTouchPoints ? a.MouseTracker.maxTouchPoints = navigator.msMaxTouchPoints : a.MouseTracker.maxTouchPoints = 0;a.MouseTracker.haveMouseEnter = !1;
  } else {
    a.MouseTracker.havePointerEvents = !1;if (a.Browser.vendor === a.BROWSERS.IE && a.Browser.version < 9) {
      a.MouseTracker.subscribeEvents.push("mouseenter", "mouseleave");a.MouseTracker.haveMouseEnter = !0;
    } else {
      a.MouseTracker.subscribeEvents.push("mouseover", "mouseout");a.MouseTracker.haveMouseEnter = !1;
    }a.MouseTracker.subscribeEvents.push("mousedown", "mouseup", "mousemove");"ontouchstart" in window && a.MouseTracker.subscribeEvents.push("touchstart", "touchend", "touchmove", "touchcancel");"ongesturestart" in window && a.MouseTracker.subscribeEvents.push("gesturestart", "gesturechange");a.MouseTracker.mousePointerId = "legacy-mouse";a.MouseTracker.maxTouchPoints = 10;
  }a.MouseTracker.GesturePointList = function (a) {
    this._gPoints = [];this.type = a;this.buttons = 0;this.contacts = 0;this.clicks = 0;this.captureCount = 0;
  };a.MouseTracker.GesturePointList.prototype = { getLength: function getLength() {
      return this._gPoints.length;
    }, asArray: function asArray() {
      return this._gPoints;
    }, add: function add(a) {
      return this._gPoints.push(a);
    }, removeById: function removeById(a) {
      var b,
          c = this._gPoints.length;for (b = 0; c > b; b++) {
        if (this._gPoints[b].id === a) {
          this._gPoints.splice(b, 1);break;
        }
      }return this._gPoints.length;
    }, getByIndex: function getByIndex(a) {
      return a < this._gPoints.length ? this._gPoints[a] : null;
    }, getById: function getById(a) {
      var b,
          c = this._gPoints.length;for (b = 0; c > b; b++) {
        if (this._gPoints[b].id === a) return this._gPoints[b];
      }return null;
    }, getPrimary: function getPrimary(a) {
      var b,
          c = this._gPoints.length;for (b = 0; c > b; b++) {
        if (this._gPoints[b].isPrimary) return this._gPoints[b];
      }return null;
    } };var qa = function () {
    try {
      return window.self !== window.top;
    } catch (a) {
      return !0;
    }
  }();
}(OpenSeadragon);!function (a) {
  a.ControlAnchor = { NONE: 0, TOP_LEFT: 1, TOP_RIGHT: 2, BOTTOM_RIGHT: 3, BOTTOM_LEFT: 4, ABSOLUTE: 5 };a.Control = function (b, c, d) {
    var e = b.parentNode;if ("number" == typeof c) {
      a.console.error("Passing an anchor directly into the OpenSeadragon.Control constructor is deprecated; please use an options object instead.  Support for this deprecated variant is scheduled for removal in December 2013");c = { anchor: c };
    }c.attachToViewer = "undefined" == typeof c.attachToViewer ? !0 : c.attachToViewer;this.autoFade = "undefined" == typeof c.autoFade ? !0 : c.autoFade;this.element = b;this.anchor = c.anchor;this.container = d;if (this.anchor == a.ControlAnchor.ABSOLUTE) {
      this.wrapper = a.makeNeutralElement("div");this.wrapper.style.position = "absolute";this.wrapper.style.top = "number" == typeof c.top ? c.top + "px" : c.top;this.wrapper.style.left = "number" == typeof c.left ? c.left + "px" : c.left;this.wrapper.style.height = "number" == typeof c.height ? c.height + "px" : c.height;this.wrapper.style.width = "number" == typeof c.width ? c.width + "px" : c.width;this.wrapper.style.margin = "0px";this.wrapper.style.padding = "0px";this.element.style.position = "relative";this.element.style.top = "0px";this.element.style.left = "0px";this.element.style.height = "100%";this.element.style.width = "100%";
    } else {
      this.wrapper = a.makeNeutralElement("div");this.wrapper.style.display = "inline-block";this.anchor == a.ControlAnchor.NONE && (this.wrapper.style.width = this.wrapper.style.height = "100%");
    }this.wrapper.appendChild(this.element);c.attachToViewer ? this.anchor == a.ControlAnchor.TOP_RIGHT || this.anchor == a.ControlAnchor.BOTTOM_RIGHT ? this.container.insertBefore(this.wrapper, this.container.firstChild) : this.container.appendChild(this.wrapper) : e.appendChild(this.wrapper);
  };a.Control.prototype = { destroy: function destroy() {
      this.wrapper.removeChild(this.element);this.container.removeChild(this.wrapper);
    }, isVisible: function isVisible() {
      return "none" != this.wrapper.style.display;
    }, setVisible: function setVisible(b) {
      this.wrapper.style.display = b ? this.anchor == a.ControlAnchor.ABSOLUTE ? "block" : "inline-block" : "none";
    }, setOpacity: function setOpacity(b) {
      this.element[a.SIGNAL] && a.Browser.vendor == a.BROWSERS.IE ? a.setElementOpacity(this.element, b, !0) : a.setElementOpacity(this.wrapper, b, !0);
    } };
}(OpenSeadragon);!function (a) {
  function b(a, b) {
    var c,
        d = a.controls;for (c = d.length - 1; c >= 0; c--) {
      if (d[c].element == b) return c;
    }return -1;
  }a.ControlDock = function (b) {
    var c,
        d,
        e = ["topleft", "topright", "bottomright", "bottomleft"];a.extend(!0, this, { id: "controldock-" + a.now() + "-" + Math.floor(1e6 * Math.random()), container: a.makeNeutralElement("div"), controls: [] }, b);this.container.onsubmit = function () {
      return !1;
    };if (this.element) {
      this.element = a.getElement(this.element);this.element.appendChild(this.container);this.element.style.position = "relative";this.container.style.width = "100%";this.container.style.height = "100%";
    }for (d = 0; d < e.length; d++) {
      c = e[d];this.controls[c] = a.makeNeutralElement("div");this.controls[c].style.position = "absolute";c.match("left") && (this.controls[c].style.left = "0px");c.match("right") && (this.controls[c].style.right = "0px");c.match("top") && (this.controls[c].style.top = "0px");c.match("bottom") && (this.controls[c].style.bottom = "0px");
    }this.container.appendChild(this.controls.topleft);this.container.appendChild(this.controls.topright);this.container.appendChild(this.controls.bottomright);this.container.appendChild(this.controls.bottomleft);
  };a.ControlDock.prototype = { addControl: function addControl(c, d) {
      c = a.getElement(c);var e = null;if (!(b(this, c) >= 0)) {
        switch (d.anchor) {case a.ControlAnchor.TOP_RIGHT:
            e = this.controls.topright;c.style.position = "relative";c.style.paddingRight = "0px";c.style.paddingTop = "0px";break;case a.ControlAnchor.BOTTOM_RIGHT:
            e = this.controls.bottomright;c.style.position = "relative";c.style.paddingRight = "0px";c.style.paddingBottom = "0px";break;case a.ControlAnchor.BOTTOM_LEFT:
            e = this.controls.bottomleft;c.style.position = "relative";c.style.paddingLeft = "0px";c.style.paddingBottom = "0px";break;case a.ControlAnchor.TOP_LEFT:
            e = this.controls.topleft;c.style.position = "relative";c.style.paddingLeft = "0px";c.style.paddingTop = "0px";break;case a.ControlAnchor.ABSOLUTE:
            e = this.container;c.style.margin = "0px";c.style.padding = "0px";break;default:case a.ControlAnchor.NONE:
            e = this.container;c.style.margin = "0px";c.style.padding = "0px";}this.controls.push(new a.Control(c, d, e));c.style.display = "inline-block";
      }
    }, removeControl: function removeControl(c) {
      c = a.getElement(c);var d = b(this, c);if (d >= 0) {
        this.controls[d].destroy();this.controls.splice(d, 1);
      }return this;
    }, clearControls: function clearControls() {
      for (; this.controls.length > 0;) {
        this.controls.pop().destroy();
      }return this;
    }, areControlsEnabled: function areControlsEnabled() {
      var a;for (a = this.controls.length - 1; a >= 0; a--) {
        if (this.controls[a].isVisible()) return !0;
      }return !1;
    }, setControlsEnabled: function setControlsEnabled(a) {
      var b;for (b = this.controls.length - 1; b >= 0; b--) {
        this.controls[b].setVisible(a);
      }return this;
    } };
}(OpenSeadragon);!function (a) {
  a.Placement = a.freezeObject({ CENTER: 0, TOP_LEFT: 1, TOP: 2, TOP_RIGHT: 3, RIGHT: 4, BOTTOM_RIGHT: 5, BOTTOM: 6, BOTTOM_LEFT: 7, LEFT: 8, properties: { 0: { isLeft: !1, isHorizontallyCentered: !0, isRight: !1, isTop: !1, isVerticallyCentered: !0, isBottom: !1 }, 1: { isLeft: !0, isHorizontallyCentered: !1, isRight: !1, isTop: !0, isVerticallyCentered: !1, isBottom: !1 }, 2: { isLeft: !1, isHorizontallyCentered: !0, isRight: !1, isTop: !0, isVerticallyCentered: !1, isBottom: !1 }, 3: { isLeft: !1, isHorizontallyCentered: !1, isRight: !0, isTop: !0, isVerticallyCentered: !1, isBottom: !1 }, 4: { isLeft: !1, isHorizontallyCentered: !1, isRight: !0, isTop: !1, isVerticallyCentered: !0, isBottom: !1 }, 5: { isLeft: !1, isHorizontallyCentered: !1, isRight: !0, isTop: !1, isVerticallyCentered: !1, isBottom: !0 }, 6: { isLeft: !1, isHorizontallyCentered: !0, isRight: !1, isTop: !1, isVerticallyCentered: !1, isBottom: !0 }, 7: { isLeft: !0, isHorizontallyCentered: !1, isRight: !1, isTop: !1, isVerticallyCentered: !1, isBottom: !0 }, 8: { isLeft: !0, isHorizontallyCentered: !1, isRight: !1, isTop: !1, isVerticallyCentered: !0, isBottom: !1 } } });
}(OpenSeadragon);!function (a) {
  function b(b) {
    b = a.getElement(b);return new a.Point(0 === b.clientWidth ? 1 : b.clientWidth, 0 === b.clientHeight ? 1 : b.clientHeight);
  }function c(b, c, d, e) {
    function f(a, b) {
      if (a.ready) d(a);else {
        a.addHandler("ready", function () {
          d(a);
        });a.addHandler("open-failed", function (a) {
          e({ message: a.message, source: b });
        });
      }
    }var g = b;"string" == a.type(c) && (c.match(/\s*<.*/) ? c = a.parseXml(c) : c.match(/\s*[\{\[].*/) && (c = a.parseJSON(c)));setTimeout(function () {
      if ("string" == a.type(c)) {
        c = new a.TileSource({ url: c, crossOriginPolicy: b.crossOriginPolicy, ajaxWithCredentials: b.ajaxWithCredentials, useCanvas: b.useCanvas, success: function success(a) {
            d(a.tileSource);
          } });c.addHandler("open-failed", function (a) {
          e(a);
        });
      } else if (a.isPlainObject(c) || c.nodeType) {
        !c.crossOriginPolicy && b.crossOriginPolicy && (c.crossOriginPolicy = b.crossOriginPolicy);void 0 === c.ajaxWithCredentials && (c.ajaxWithCredentials = b.ajaxWithCredentials);void 0 === c.useCanvas && (c.useCanvas = b.useCanvas);if (a.isFunction(c.getTileUrl)) {
          var h = new a.TileSource(c);h.getTileUrl = c.getTileUrl;d(h);
        } else {
          var i = a.TileSource.determineType(g, c);if (!i) {
            e({ message: "Unable to load TileSource", source: c });return;
          }var j = i.prototype.configure.apply(g, [c]);f(new i(j), c);
        }
      } else f(c, c);
    });
  }function d(b, c) {
    if (c instanceof a.Overlay) return c;var d = null;if (c.element) d = a.getElement(c.element);else {
      var e = c.id ? c.id : "openseadragon-overlay-" + Math.floor(1e7 * Math.random());d = a.getElement(c.id);if (!d) {
        d = document.createElement("a");d.href = "#/overlay/" + e;
      }d.id = e;a.addClass(d, c.className ? c.className : "openseadragon-overlay");
    }var f = c.location;var g = c.width;var h = c.height;if (!f) {
      var i = c.x;var j = c.y;if (void 0 !== c.px) {
        var k = b.viewport.imageToViewportRectangle(new a.Rect(c.px, c.py, g || 0, h || 0));i = k.x;j = k.y;g = void 0 !== g ? k.width : void 0;h = void 0 !== h ? k.height : void 0;
      }f = new a.Point(i, j);
    }var l = c.placement;l && "string" === a.type(l) && (l = a.Placement[c.placement.toUpperCase()]);return new a.Overlay({ element: d, location: f, placement: l, onDraw: c.onDraw, checkResize: c.checkResize, width: g, height: h, rotationMode: c.rotationMode });
  }function e(a, b) {
    var c;for (c = a.length - 1; c >= 0; c--) {
      if (a[c].element === b) return c;
    }return -1;
  }function f(b, c) {
    return a.requestAnimationFrame(function () {
      c(b);
    });
  }function g(b) {
    a.requestAnimationFrame(function () {
      i(b);
    });
  }function h(b) {
    if (b.autoHideControls) {
      b.controlsShouldFade = !0;b.controlsFadeBeginTime = a.now() + b.controlsFadeDelay;window.setTimeout(function () {
        g(b);
      }, b.controlsFadeDelay);
    }
  }function i(b) {
    var c, d, e, f;if (b.controlsShouldFade) {
      c = a.now();d = c - b.controlsFadeBeginTime;e = 1 - d / b.controlsFadeLength;e = Math.min(1, e);e = Math.max(0, e);for (f = b.controls.length - 1; f >= 0; f--) {
        b.controls[f].autoFade && b.controls[f].setOpacity(e);
      }e > 0 && g(b);
    }
  }function j(a) {
    var b;a.controlsShouldFade = !1;for (b = a.controls.length - 1; b >= 0; b--) {
      a.controls[b].setOpacity(1);
    }
  }function k() {
    j(this);
  }function l() {
    h(this);
  }function m(b) {
    if (b.preventDefaultAction || b.ctrl || b.alt || b.meta) return !0;switch (b.keyCode) {case 38:
        b.shift ? this.viewport.zoomBy(1.1) : this.viewport.panBy(this.viewport.deltaPointsFromPixels(new a.Point(0, -40)));this.viewport.applyConstraints();return !1;case 40:
        b.shift ? this.viewport.zoomBy(.9) : this.viewport.panBy(this.viewport.deltaPointsFromPixels(new a.Point(0, 40)));this.viewport.applyConstraints();return !1;case 37:
        this.viewport.panBy(this.viewport.deltaPointsFromPixels(new a.Point(-40, 0)));this.viewport.applyConstraints();return !1;case 39:
        this.viewport.panBy(this.viewport.deltaPointsFromPixels(new a.Point(40, 0)));this.viewport.applyConstraints();return !1;default:
        return !0;}
  }function n(b) {
    if (b.preventDefaultAction || b.ctrl || b.alt || b.meta) return !0;switch (b.keyCode) {case 43:case 61:
        this.viewport.zoomBy(1.1);this.viewport.applyConstraints();return !1;case 45:
        this.viewport.zoomBy(.9);this.viewport.applyConstraints();return !1;case 48:
        this.viewport.goHome();this.viewport.applyConstraints();return !1;case 119:case 87:
        b.shift ? this.viewport.zoomBy(1.1) : this.viewport.panBy(this.viewport.deltaPointsFromPixels(new a.Point(0, -40)));this.viewport.applyConstraints();return !1;case 115:case 83:
        b.shift ? this.viewport.zoomBy(.9) : this.viewport.panBy(this.viewport.deltaPointsFromPixels(new a.Point(0, 40)));this.viewport.applyConstraints();return !1;case 97:
        this.viewport.panBy(this.viewport.deltaPointsFromPixels(new a.Point(-40, 0)));this.viewport.applyConstraints();return !1;case 100:
        this.viewport.panBy(this.viewport.deltaPointsFromPixels(new a.Point(40, 0)));this.viewport.applyConstraints();return !1;default:
        return !0;}
  }function o(a) {
    var b;var c = document.activeElement == this.canvas;c || this.canvas.focus();if (!a.preventDefaultAction && this.viewport && a.quick) {
      b = this.gestureSettingsByDeviceType(a.pointerType);if (b.clickToZoom) {
        this.viewport.zoomBy(a.shift ? 1 / this.zoomPerClick : this.zoomPerClick, this.viewport.pointFromPixel(a.position, !0));this.viewport.applyConstraints();
      }
    }this.raiseEvent("canvas-click", { tracker: a.eventSource, position: a.position, quick: a.quick, shift: a.shift, originalEvent: a.originalEvent });
  }function p(a) {
    var b;if (!a.preventDefaultAction && this.viewport) {
      b = this.gestureSettingsByDeviceType(a.pointerType);if (b.dblClickToZoom) {
        this.viewport.zoomBy(a.shift ? 1 / this.zoomPerClick : this.zoomPerClick, this.viewport.pointFromPixel(a.position, !0));this.viewport.applyConstraints();
      }
    }this.raiseEvent("canvas-double-click", { tracker: a.eventSource, position: a.position, shift: a.shift, originalEvent: a.originalEvent });
  }function q(a) {
    var b;if (!a.preventDefaultAction && this.viewport) {
      b = this.gestureSettingsByDeviceType(a.pointerType);this.panHorizontal || (a.delta.x = 0);this.panVertical || (a.delta.y = 0);this.viewport.panBy(this.viewport.deltaPointsFromPixels(a.delta.negate()), b.flickEnabled);this.constrainDuringPan && this.viewport.applyConstraints();
    }this.raiseEvent("canvas-drag", { tracker: a.eventSource, position: a.position, delta: a.delta, speed: a.speed, direction: a.direction, shift: a.shift, originalEvent: a.originalEvent });
  }function r(b) {
    if (!b.preventDefaultAction && this.viewport) {
      var c = this.gestureSettingsByDeviceType(b.pointerType);if (c.flickEnabled && b.speed >= c.flickMinSpeed) {
        var d = 0;this.panHorizontal && (d = c.flickMomentum * b.speed * Math.cos(b.direction));var e = 0;this.panVertical && (e = c.flickMomentum * b.speed * Math.sin(b.direction));var f = this.viewport.pixelFromPoint(this.viewport.getCenter(!0));var g = this.viewport.pointFromPixel(new a.Point(f.x - d, f.y - e));this.viewport.panTo(g, !1);
      }this.viewport.applyConstraints();
    }this.raiseEvent("canvas-drag-end", { tracker: b.eventSource, position: b.position, speed: b.speed, direction: b.direction, shift: b.shift, originalEvent: b.originalEvent });
  }function s(a) {
    this.raiseEvent("canvas-enter", { tracker: a.eventSource, pointerType: a.pointerType, position: a.position, buttons: a.buttons, pointers: a.pointers, insideElementPressed: a.insideElementPressed, buttonDownAny: a.buttonDownAny, originalEvent: a.originalEvent });
  }function t(a) {
    this.raiseEvent("canvas-exit", { tracker: a.eventSource, pointerType: a.pointerType, position: a.position, buttons: a.buttons, pointers: a.pointers, insideElementPressed: a.insideElementPressed, buttonDownAny: a.buttonDownAny, originalEvent: a.originalEvent });
  }function u(a) {
    this.raiseEvent("canvas-press", { tracker: a.eventSource, pointerType: a.pointerType, position: a.position, insideElementPressed: a.insideElementPressed, insideElementReleased: a.insideElementReleased, originalEvent: a.originalEvent });
  }function v(a) {
    this.raiseEvent("canvas-release", { tracker: a.eventSource, pointerType: a.pointerType, position: a.position, insideElementPressed: a.insideElementPressed, insideElementReleased: a.insideElementReleased, originalEvent: a.originalEvent });
  }function w(a) {
    this.raiseEvent("canvas-nonprimary-press", { tracker: a.eventSource, position: a.position, pointerType: a.pointerType, button: a.button, buttons: a.buttons, originalEvent: a.originalEvent });
  }function x(a) {
    this.raiseEvent("canvas-nonprimary-release", { tracker: a.eventSource, position: a.position, pointerType: a.pointerType, button: a.button, buttons: a.buttons, originalEvent: a.originalEvent });
  }function y(a) {
    var b, c, d, e;if (!a.preventDefaultAction && this.viewport) {
      b = this.gestureSettingsByDeviceType(a.pointerType);
      if (b.pinchToZoom) {
        c = this.viewport.pointFromPixel(a.center, !0);d = this.viewport.pointFromPixel(a.lastCenter, !0);e = d.minus(c);this.panHorizontal || (e.x = 0);this.panVertical || (e.y = 0);this.viewport.zoomBy(a.distance / a.lastDistance, c, !0);this.viewport.panBy(e, !0);this.viewport.applyConstraints();
      }if (b.pinchRotate) {
        var f = Math.atan2(a.gesturePoints[0].currentPos.y - a.gesturePoints[1].currentPos.y, a.gesturePoints[0].currentPos.x - a.gesturePoints[1].currentPos.x);var g = Math.atan2(a.gesturePoints[0].lastPos.y - a.gesturePoints[1].lastPos.y, a.gesturePoints[0].lastPos.x - a.gesturePoints[1].lastPos.x);this.viewport.setRotation(this.viewport.getRotation() + (f - g) * (180 / Math.PI));
      }
    }this.raiseEvent("canvas-pinch", { tracker: a.eventSource, gesturePoints: a.gesturePoints, lastCenter: a.lastCenter, center: a.center, lastDistance: a.lastDistance, distance: a.distance, shift: a.shift, originalEvent: a.originalEvent });return !1;
  }function z(b) {
    var c, d, e, f;e = a.now();f = e - this._lastScrollTime;if (f > this.minScrollDeltaTime) {
      this._lastScrollTime = e;if (!b.preventDefaultAction && this.viewport) {
        c = this.gestureSettingsByDeviceType(b.pointerType);if (c.scrollToZoom) {
          d = Math.pow(this.zoomPerScroll, b.scroll);this.viewport.zoomBy(d, this.viewport.pointFromPixel(b.position, !0));this.viewport.applyConstraints();
        }
      }this.raiseEvent("canvas-scroll", { tracker: b.eventSource, position: b.position, scroll: b.scroll, shift: b.shift, originalEvent: b.originalEvent });if (c && c.scrollToZoom) return !1;
    } else {
      c = this.gestureSettingsByDeviceType(b.pointerType);if (c && c.scrollToZoom) return !1;
    }
  }function A(a) {
    U[this.hash].mouseInside = !0;j(this);this.raiseEvent("container-enter", { tracker: a.eventSource, position: a.position, buttons: a.buttons, pointers: a.pointers, insideElementPressed: a.insideElementPressed, buttonDownAny: a.buttonDownAny, originalEvent: a.originalEvent });
  }function B(a) {
    if (a.pointers < 1) {
      U[this.hash].mouseInside = !1;U[this.hash].animating || h(this);
    }this.raiseEvent("container-exit", { tracker: a.eventSource, position: a.position, buttons: a.buttons, pointers: a.pointers, insideElementPressed: a.insideElementPressed, buttonDownAny: a.buttonDownAny, originalEvent: a.originalEvent });
  }function C(a) {
    D(a);a.isOpen() ? a._updateRequestId = f(a, C) : a._updateRequestId = !1;
  }function D(a) {
    if (!a._opening) {
      if (a.autoResize) {
        var c = b(a.container);var d = U[a.hash].prevContainerSize;if (!c.equals(d)) {
          var e = a.viewport;if (a.preserveImageSizeOnResize) {
            var f = d.x / c.x;var g = e.getZoom() * f;var i = e.getCenter();e.resize(c, !1);e.zoomTo(g, null, !0);e.panTo(i, !0);
          } else {
            var k = e.getBounds();e.resize(c, !0);e.fitBoundsWithConstraints(k, !0);
          }U[a.hash].prevContainerSize = c;U[a.hash].forceRedraw = !0;
        }
      }var l = a.viewport.update();var m = a.world.update() || l;l && a.raiseEvent("viewport-change");a.referenceStrip && (m = a.referenceStrip.update(a.viewport) || m);if (!U[a.hash].animating && m) {
        a.raiseEvent("animation-start");j(a);
      }if (m || U[a.hash].forceRedraw || a.world.needsDraw()) {
        E(a);a._drawOverlays();a.navigator && a.navigator.update(a.viewport);U[a.hash].forceRedraw = !1;m && a.raiseEvent("animation");
      }if (U[a.hash].animating && !m) {
        a.raiseEvent("animation-finish");U[a.hash].mouseInside || h(a);
      }U[a.hash].animating = m;
    }
  }function E(a) {
    a.imageLoader.clear();a.drawer.clear();a.world.draw();a.raiseEvent("update-viewport", {});
  }function F(a, b) {
    return a ? a + b : b;
  }function G() {
    U[this.hash].lastZoomTime = a.now();U[this.hash].zoomFactor = this.zoomPerSecond;U[this.hash].zooming = !0;J(this);
  }function H() {
    U[this.hash].lastZoomTime = a.now();U[this.hash].zoomFactor = 1 / this.zoomPerSecond;U[this.hash].zooming = !0;J(this);
  }function I() {
    U[this.hash].zooming = !1;
  }function J(b) {
    a.requestAnimationFrame(a.delegate(b, K));
  }function K() {
    var b, c, d;if (U[this.hash].zooming && this.viewport) {
      b = a.now();c = b - U[this.hash].lastZoomTime;d = Math.pow(U[this.hash].zoomFactor, c / 1e3);this.viewport.zoomBy(d);this.viewport.applyConstraints();U[this.hash].lastZoomTime = b;J(this);
    }
  }function L() {
    if (this.viewport) {
      U[this.hash].zooming = !1;this.viewport.zoomBy(this.zoomPerClick / 1);this.viewport.applyConstraints();
    }
  }function M() {
    if (this.viewport) {
      U[this.hash].zooming = !1;this.viewport.zoomBy(1 / this.zoomPerClick);this.viewport.applyConstraints();
    }
  }function N() {
    this.buttons.emulateEnter();this.buttons.emulateExit();
  }function O() {
    this.viewport && this.viewport.goHome();
  }function P() {
    this.isFullPage() && !a.isFullScreen() ? this.setFullPage(!1) : this.setFullScreen(!this.isFullPage());this.buttons && this.buttons.emulateExit();this.fullPageButton.element.focus();this.viewport && this.viewport.applyConstraints();
  }function Q() {
    if (this.viewport) {
      var a = this.viewport.getRotation();0 === a ? a = 270 : a -= 90;this.viewport.setRotation(a);
    }
  }function R() {
    if (this.viewport) {
      var a = this.viewport.getRotation();270 === a ? a = 0 : a += 90;this.viewport.setRotation(a);
    }
  }function S() {
    var a = this._sequenceIndex - 1;this.navPrevNextWrap && 0 > a && (a += this.tileSources.length);this.goToPage(a);
  }function T() {
    var a = this._sequenceIndex + 1;this.navPrevNextWrap && a >= this.tileSources.length && (a = 0);this.goToPage(a);
  }var U = {};var V = 1;a.Viewer = function (c) {
    var d,
        e = arguments,
        g = this;a.isPlainObject(c) || (c = { id: e[0], xmlPath: e.length > 1 ? e[1] : void 0, prefixUrl: e.length > 2 ? e[2] : void 0, controls: e.length > 3 ? e[3] : void 0, overlays: e.length > 4 ? e[4] : void 0 });if (c.config) {
      a.extend(!0, c, c.config);delete c.config;
    }a.extend(!0, this, { id: c.id, hash: c.hash || V++, element: null, container: null, canvas: null, overlays: [], overlaysContainer: null, previousBody: [], customControls: [], source: null, drawer: null, world: null, viewport: null, navigator: null, collectionViewport: null, collectionDrawer: null, navImages: null, buttons: null, profiler: null }, a.DEFAULT_SETTINGS, c);if ("undefined" == typeof this.hash) throw new Error("A hash must be defined, either by specifying options.id or options.hash.");"undefined" != typeof U[this.hash] && a.console.warn("Hash " + this.hash + " has already been used.");U[this.hash] = { fsBoundsDelta: new a.Point(1, 1), prevContainerSize: null, animating: !1, forceRedraw: !1, mouseInside: !1, group: null, zooming: !1, zoomFactor: null, lastZoomTime: null, fullPage: !1, onfullscreenchange: null };this._sequenceIndex = 0;this._firstOpen = !0;this._updateRequestId = null;this._loadQueue = [];this.currentOverlays = [];this._lastScrollTime = a.now();a.EventSource.call(this);this.addHandler("open-failed", function (b) {
      var c = a.getString("Errors.OpenFailed", b.eventSource, b.message);g._showMessage(c);
    });a.ControlDock.call(this, c);this.xmlPath && (this.tileSources = [this.xmlPath]);this.element = this.element || document.getElementById(this.id);this.canvas = a.makeNeutralElement("div");this.canvas.className = "openseadragon-canvas";!function (a) {
      a.width = "100%";a.height = "100%";a.overflow = "hidden";a.position = "absolute";a.top = "0px";a.left = "0px";
    }(this.canvas.style);a.setElementTouchActionNone(this.canvas);"" !== c.tabIndex && (this.canvas.tabIndex = void 0 === c.tabIndex ? 0 : c.tabIndex);this.container.className = "openseadragon-container";!function (a) {
      a.width = "100%";a.height = "100%";a.position = "relative";a.overflow = "hidden";a.left = "0px";a.top = "0px";a.textAlign = "left";
    }(this.container.style);this.container.insertBefore(this.canvas, this.container.firstChild);this.element.appendChild(this.container);this.bodyWidth = document.body.style.width;this.bodyHeight = document.body.style.height;this.bodyOverflow = document.body.style.overflow;this.docOverflow = document.documentElement.style.overflow;this.innerTracker = new a.MouseTracker({ element: this.canvas, startDisabled: this.mouseNavEnabled ? !1 : !0, clickTimeThreshold: this.clickTimeThreshold, clickDistThreshold: this.clickDistThreshold, dblClickTimeThreshold: this.dblClickTimeThreshold, dblClickDistThreshold: this.dblClickDistThreshold, keyDownHandler: a.delegate(this, m), keyHandler: a.delegate(this, n), clickHandler: a.delegate(this, o), dblClickHandler: a.delegate(this, p), dragHandler: a.delegate(this, q), dragEndHandler: a.delegate(this, r), enterHandler: a.delegate(this, s), exitHandler: a.delegate(this, t), pressHandler: a.delegate(this, u), releaseHandler: a.delegate(this, v), nonPrimaryPressHandler: a.delegate(this, w), nonPrimaryReleaseHandler: a.delegate(this, x), scrollHandler: a.delegate(this, z), pinchHandler: a.delegate(this, y) });this.outerTracker = new a.MouseTracker({ element: this.container, startDisabled: this.mouseNavEnabled ? !1 : !0, clickTimeThreshold: this.clickTimeThreshold, clickDistThreshold: this.clickDistThreshold, dblClickTimeThreshold: this.dblClickTimeThreshold, dblClickDistThreshold: this.dblClickDistThreshold, enterHandler: a.delegate(this, A), exitHandler: a.delegate(this, B) });this.toolbar && (this.toolbar = new a.ControlDock({ element: this.toolbar }));this.bindStandardControls();U[this.hash].prevContainerSize = b(this.container);this.world = new a.World({ viewer: this });this.world.addHandler("add-item", function (a) {
      g.source = g.world.getItemAt(0).source;U[g.hash].forceRedraw = !0;g._updateRequestId || (g._updateRequestId = f(g, C));
    });this.world.addHandler("remove-item", function (a) {
      g.world.getItemCount() ? g.source = g.world.getItemAt(0).source : g.source = null;U[g.hash].forceRedraw = !0;
    });this.world.addHandler("metrics-change", function (a) {
      g.viewport && g.viewport._setContentBounds(g.world.getHomeBounds(), g.world.getContentFactor());
    });this.world.addHandler("item-index-change", function (a) {
      g.source = g.world.getItemAt(0).source;
    });this.viewport = new a.Viewport({ containerSize: U[this.hash].prevContainerSize, springStiffness: this.springStiffness, animationTime: this.animationTime, minZoomImageRatio: this.minZoomImageRatio, maxZoomPixelRatio: this.maxZoomPixelRatio, visibilityRatio: this.visibilityRatio, wrapHorizontal: this.wrapHorizontal, wrapVertical: this.wrapVertical, defaultZoomLevel: this.defaultZoomLevel, minZoomLevel: this.minZoomLevel, maxZoomLevel: this.maxZoomLevel, viewer: this, degrees: this.degrees, navigatorRotate: this.navigatorRotate, homeFillsViewer: this.homeFillsViewer, margins: this.viewportMargins });this.viewport._setContentBounds(this.world.getHomeBounds(), this.world.getContentFactor());this.imageLoader = new a.ImageLoader({ jobLimit: this.imageLoaderLimit });this.tileCache = new a.TileCache({ maxImageCacheCount: this.maxImageCacheCount });this.drawer = new a.Drawer({ viewer: this, viewport: this.viewport, element: this.canvas, debugGridColor: this.debugGridColor });this.overlaysContainer = a.makeNeutralElement("div");this.canvas.appendChild(this.overlaysContainer);if (!this.drawer.canRotate()) {
      if (this.rotateLeft) {
        d = this.buttons.buttons.indexOf(this.rotateLeft);this.buttons.buttons.splice(d, 1);this.buttons.element.removeChild(this.rotateLeft.element);
      }if (this.rotateRight) {
        d = this.buttons.buttons.indexOf(this.rotateRight);this.buttons.buttons.splice(d, 1);this.buttons.element.removeChild(this.rotateRight.element);
      }
    }this.showNavigator && (this.navigator = new a.Navigator({ id: this.navigatorId, position: this.navigatorPosition, sizeRatio: this.navigatorSizeRatio, maintainSizeRatio: this.navigatorMaintainSizeRatio, top: this.navigatorTop, left: this.navigatorLeft, width: this.navigatorWidth, height: this.navigatorHeight, autoResize: this.navigatorAutoResize, autoFade: this.navigatorAutoFade, prefixUrl: this.prefixUrl, viewer: this, navigatorRotate: this.navigatorRotate, crossOriginPolicy: this.crossOriginPolicy }));this.sequenceMode && this.bindSequenceControls();this.tileSources && this.open(this.tileSources);for (d = 0; d < this.customControls.length; d++) {
      this.addControl(this.customControls[d].id, { anchor: this.customControls[d].anchor });
    }a.requestAnimationFrame(function () {
      h(g);
    });
  };a.extend(a.Viewer.prototype, a.EventSource.prototype, a.ControlDock.prototype, { isOpen: function isOpen() {
      return !!this.world.getItemCount();
    }, openDzi: function openDzi(b) {
      a.console.error("[Viewer.openDzi] this function is deprecated; use Viewer.open() instead.");return this.open(b);
    }, openTileSource: function openTileSource(b) {
      a.console.error("[Viewer.openTileSource] this function is deprecated; use Viewer.open() instead.");return this.open(b);
    }, open: function open(b) {
      var c = this;this.close();if (b) if (this.sequenceMode && a.isArray(b)) {
        if (this.referenceStrip) {
          this.referenceStrip.destroy();this.referenceStrip = null;
        }this.tileSources = b;this._sequenceIndex = Math.max(0, Math.min(this.tileSources.length - 1, this.initialPage));if (this.tileSources.length) {
          this.open(this.tileSources[this._sequenceIndex]);this.showReferenceStrip && (this.referenceStrip = new a.ReferenceStrip({ id: this.referenceStripElement, position: this.referenceStripPosition, sizeRatio: this.referenceStripSizeRatio, scroll: this.referenceStripScroll, height: this.referenceStripHeight, width: this.referenceStripWidth, tileSources: this.tileSources, prefixUrl: this.prefixUrl, viewer: this }));
        }this._updateSequenceButtons(this._sequenceIndex);
      } else {
        a.isArray(b) || (b = [b]);if (b.length) {
          this._opening = !0;var e = b.length;var f = 0;var g = 0;var h;var i = function i() {
            if (f + g === e) if (f) {
              if (c._firstOpen || !c.preserveViewport) {
                c.viewport.goHome(!0);c.viewport.update();
              }c._firstOpen = !1;var a = b[0];a.tileSource && (a = a.tileSource);if (c.overlays && !c.preserveOverlays) for (var i = 0; i < c.overlays.length; i++) {
                c.currentOverlays[i] = d(c, c.overlays[i]);
              }c._drawOverlays();c._opening = !1;c.raiseEvent("open", { source: a });
            } else {
              c._opening = !1;c.raiseEvent("open-failed", h);
            }
          };var j = function j(b) {
            a.isPlainObject(b) && b.tileSource || (b = { tileSource: b });if (void 0 !== b.index) {
              a.console.error("[Viewer.open] setting indexes here is not supported; use addTiledImage instead");delete b.index;
            }void 0 === b.collectionImmediately && (b.collectionImmediately = !0);var d = b.success;b.success = function (a) {
              f++;if (b.tileSource.overlays) for (var e = 0; e < b.tileSource.overlays.length; e++) {
                c.addOverlay(b.tileSource.overlays[e]);
              }d && d(a);i();
            };var e = b.error;b.error = function (a) {
              g++;h || (h = a);e && e(a);i();
            };c.addTiledImage(b);
          };for (var k = 0; k < b.length; k++) {
            j(b[k]);
          }return this;
        }
      }
    }, close: function close() {
      if (!U[this.hash]) return this;this._opening = !1;this.navigator && this.navigator.close();if (!this.preserveOverlays) {
        this.clearOverlays();this.overlaysContainer.innerHTML = "";
      }U[this.hash].animating = !1;this.world.removeAll();this.imageLoader.clear();this.raiseEvent("close");return this;
    }, destroy: function destroy() {
      if (U[this.hash]) {
        this.close();this.clearOverlays();this.overlaysContainer.innerHTML = "";if (this.referenceStrip) {
          this.referenceStrip.destroy();this.referenceStrip = null;
        }if (null !== this._updateRequestId) {
          a.cancelAnimationFrame(this._updateRequestId);this._updateRequestId = null;
        }this.drawer && this.drawer.destroy();this.removeAllHandlers();if (this.element) for (; this.element.firstChild;) {
          this.element.removeChild(this.element.firstChild);
        }this.innerTracker && this.innerTracker.destroy();this.outerTracker && this.outerTracker.destroy();U[this.hash] = null;delete U[this.hash];this.canvas = null;this.container = null;this.element = null;
      }
    }, isMouseNavEnabled: function isMouseNavEnabled() {
      return this.innerTracker.isTracking();
    }, setMouseNavEnabled: function setMouseNavEnabled(a) {
      this.innerTracker.setTracking(a);this.outerTracker.setTracking(a);this.raiseEvent("mouse-enabled", { enabled: a });return this;
    }, areControlsEnabled: function areControlsEnabled() {
      var a,
          b = this.controls.length;for (a = 0; a < this.controls.length; a++) {
        b = b && this.controls[a].isVisibile();
      }return b;
    }, setControlsEnabled: function setControlsEnabled(a) {
      a ? j(this) : h(this);this.raiseEvent("controls-enabled", { enabled: a });return this;
    }, isFullPage: function isFullPage() {
      return U[this.hash].fullPage;
    }, setFullPage: function setFullPage(b) {
      var c,
          d,
          e = document.body,
          f = e.style,
          g = document.documentElement.style,
          h = this;if (b == this.isFullPage()) return this;var i = { fullPage: b, preventDefaultAction: !1 };this.raiseEvent("pre-full-page", i);if (i.preventDefaultAction) return this;if (b) {
        this.elementSize = a.getElementSize(this.element);this.pageScroll = a.getPageScroll();this.elementMargin = this.element.style.margin;this.element.style.margin = "0";this.elementPadding = this.element.style.padding;this.element.style.padding = "0";this.bodyMargin = f.margin;this.docMargin = g.margin;f.margin = "0";g.margin = "0";this.bodyPadding = f.padding;this.docPadding = g.padding;f.padding = "0";g.padding = "0";this.bodyWidth = f.width;this.docWidth = g.width;f.width = "100%";g.width = "100%";this.bodyHeight = f.height;this.docHeight = g.height;f.height = "100%";g.height = "100%";this.previousBody = [];U[this.hash].prevElementParent = this.element.parentNode;U[this.hash].prevNextSibling = this.element.nextSibling;U[this.hash].prevElementWidth = this.element.style.width;U[this.hash].prevElementHeight = this.element.style.height;c = e.childNodes.length;for (d = 0; c > d; d++) {
          this.previousBody.push(e.childNodes[0]);e.removeChild(e.childNodes[0]);
        }if (this.toolbar && this.toolbar.element) {
          this.toolbar.parentNode = this.toolbar.element.parentNode;this.toolbar.nextSibling = this.toolbar.element.nextSibling;e.appendChild(this.toolbar.element);a.addClass(this.toolbar.element, "fullpage");
        }a.addClass(this.element, "fullpage");e.appendChild(this.element);this.element.style.height = a.getWindowSize().y + "px";this.element.style.width = a.getWindowSize().x + "px";this.toolbar && this.toolbar.element && (this.element.style.height = a.getElementSize(this.element).y - a.getElementSize(this.toolbar.element).y + "px");U[this.hash].fullPage = !0;a.delegate(this, A)({});
      } else {
        this.element.style.margin = this.elementMargin;this.element.style.padding = this.elementPadding;f.margin = this.bodyMargin;g.margin = this.docMargin;f.padding = this.bodyPadding;g.padding = this.docPadding;f.width = this.bodyWidth;g.width = this.docWidth;f.height = this.bodyHeight;g.height = this.docHeight;e.removeChild(this.element);c = this.previousBody.length;for (d = 0; c > d; d++) {
          e.appendChild(this.previousBody.shift());
        }a.removeClass(this.element, "fullpage");U[this.hash].prevElementParent.insertBefore(this.element, U[this.hash].prevNextSibling);if (this.toolbar && this.toolbar.element) {
          e.removeChild(this.toolbar.element);a.removeClass(this.toolbar.element, "fullpage");this.toolbar.parentNode.insertBefore(this.toolbar.element, this.toolbar.nextSibling);delete this.toolbar.parentNode;delete this.toolbar.nextSibling;
        }this.element.style.width = U[this.hash].prevElementWidth;this.element.style.height = U[this.hash].prevElementHeight;var j = 0;var k = function k() {
          a.setPageScroll(h.pageScroll);var b = a.getPageScroll();j++;(10 > j && b.x !== h.pageScroll.x || b.y !== h.pageScroll.y) && a.requestAnimationFrame(k);
        };a.requestAnimationFrame(k);U[this.hash].fullPage = !1;a.delegate(this, B)({});
      }this.navigator && this.viewport && this.navigator.update(this.viewport);this.raiseEvent("full-page", { fullPage: b });return this;
    }, setFullScreen: function setFullScreen(b) {
      var c = this;if (!a.supportsFullScreen) return this.setFullPage(b);if (a.isFullScreen() === b) return this;var d = { fullScreen: b, preventDefaultAction: !1 };this.raiseEvent("pre-full-screen", d);if (d.preventDefaultAction) return this;if (b) {
        this.setFullPage(!0);if (!this.isFullPage()) return this;this.fullPageStyleWidth = this.element.style.width;this.fullPageStyleHeight = this.element.style.height;this.element.style.width = "100%";this.element.style.height = "100%";var e = function e() {
          var b = a.isFullScreen();if (!b) {
            a.removeEvent(document, a.fullScreenEventName, e);a.removeEvent(document, a.fullScreenErrorEventName, e);c.setFullPage(!1);if (c.isFullPage()) {
              c.element.style.width = c.fullPageStyleWidth;c.element.style.height = c.fullPageStyleHeight;
            }
          }c.navigator && c.viewport && c.navigator.update(c.viewport);c.raiseEvent("full-screen", { fullScreen: b });
        };a.addEvent(document, a.fullScreenEventName, e);a.addEvent(document, a.fullScreenErrorEventName, e);a.requestFullScreen(document.body);
      } else a.exitFullScreen();return this;
    }, isVisible: function isVisible() {
      return "hidden" != this.container.style.visibility;
    }, setVisible: function setVisible(a) {
      this.container.style.visibility = a ? "" : "hidden";this.raiseEvent("visible", { visible: a });return this;
    }, addTiledImage: function addTiledImage(b) {
      function d(a) {
        for (var c = 0; c < f._loadQueue.length; c++) {
          if (f._loadQueue[c] === g) {
            f._loadQueue.splice(c, 1);break;
          }
        }0 === f._loadQueue.length && e(g);f.raiseEvent("add-item-failed", a);b.error && b.error(a);
      }function e(a) {
        if (f.collectionMode) {
          f.world.arrange({ immediately: a.options.collectionImmediately, rows: f.collectionRows, columns: f.collectionColumns, layout: f.collectionLayout, tileSize: f.collectionTileSize, tileMargin: f.collectionTileMargin });f.world.setAutoRefigureSizes(!0);
        }
      }a.console.assert(b, "[Viewer.addTiledImage] options is required");a.console.assert(b.tileSource, "[Viewer.addTiledImage] options.tileSource is required");a.console.assert(!b.replace || b.index > -1 && b.index < this.world.getItemCount(), "[Viewer.addTiledImage] if options.replace is used, options.index must be a valid index in Viewer.world");var f = this;b.replace && (b.replaceItem = f.world.getItemAt(b.index));this._hideMessage();void 0 === b.placeholderFillStyle && (b.placeholderFillStyle = this.placeholderFillStyle);void 0 === b.opacity && (b.opacity = this.opacity);void 0 === b.compositeOperation && (b.compositeOperation = this.compositeOperation);var g = { options: b };if (a.isArray(b.tileSource)) setTimeout(function () {
        d({ message: "[Viewer.addTiledImage] Sequences can not be added; add them one at a time instead.", source: b.tileSource, options: b });
      });else {
        this._loadQueue.push(g);c(this, b.tileSource, function (b) {
          g.tileSource = b;var c, d, h;for (; f._loadQueue.length;) {
            c = f._loadQueue[0];if (!c.tileSource) break;f._loadQueue.splice(0, 1);if (c.options.replace) {
              var i = f.world.getIndexOfItem(c.options.replaceItem);-1 != i && (c.options.index = i);f.world.removeItem(c.options.replaceItem);
            }d = new a.TiledImage({ viewer: f, source: c.tileSource, viewport: f.viewport, drawer: f.drawer, tileCache: f.tileCache, imageLoader: f.imageLoader, x: c.options.x, y: c.options.y, width: c.options.width, height: c.options.height, fitBounds: c.options.fitBounds, fitBoundsPlacement: c.options.fitBoundsPlacement, clip: c.options.clip, placeholderFillStyle: c.options.placeholderFillStyle, opacity: c.options.opacity, compositeOperation: c.options.compositeOperation, springStiffness: f.springStiffness, animationTime: f.animationTime, minZoomImageRatio: f.minZoomImageRatio, wrapHorizontal: f.wrapHorizontal, wrapVertical: f.wrapVertical, immediateRender: f.immediateRender, blendTime: f.blendTime, alwaysBlend: f.alwaysBlend, minPixelRatio: f.minPixelRatio, smoothTileEdgesMinZoom: f.smoothTileEdgesMinZoom, iOSDevice: f.iOSDevice, crossOriginPolicy: f.crossOriginPolicy, debugMode: f.debugMode });f.collectionMode && f.world.setAutoRefigureSizes(!1);f.world.addItem(d, { index: c.options.index });0 === f._loadQueue.length && e(c);1 !== f.world.getItemCount() || f.preserveViewport || f.viewport.goHome(!0);if (f.navigator) {
              h = a.extend({}, c.options, { replace: !1, originalTiledImage: d, tileSource: c.tileSource });f.navigator.addTiledImage(h);
            }c.options.success && c.options.success({ item: d });
          }
        }, function (a) {
          a.options = b;d(a);
        });
      }
    }, addSimpleImage: function addSimpleImage(b) {
      a.console.assert(b, "[Viewer.addSimpleImage] options is required");a.console.assert(b.url, "[Viewer.addSimpleImage] options.url is required");var c = a.extend({}, b, { tileSource: { type: "image", url: b.url } });delete c.url;this.addTiledImage(c);
    }, addLayer: function addLayer(b) {
      var c = this;a.console.error("[Viewer.addLayer] this function is deprecated; use Viewer.addTiledImage() instead.");var d = a.extend({}, b, { success: function success(a) {
          c.raiseEvent("add-layer", { options: b, drawer: a.item });
        }, error: function error(a) {
          c.raiseEvent("add-layer-failed", a);
        } });this.addTiledImage(d);return this;
    }, getLayerAtLevel: function getLayerAtLevel(b) {
      a.console.error("[Viewer.getLayerAtLevel] this function is deprecated; use World.getItemAt() instead.");return this.world.getItemAt(b);
    }, getLevelOfLayer: function getLevelOfLayer(b) {
      a.console.error("[Viewer.getLevelOfLayer] this function is deprecated; use World.getIndexOfItem() instead.");return this.world.getIndexOfItem(b);
    }, getLayersCount: function getLayersCount() {
      a.console.error("[Viewer.getLayersCount] this function is deprecated; use World.getItemCount() instead.");return this.world.getItemCount();
    }, setLayerLevel: function setLayerLevel(b, c) {
      a.console.error("[Viewer.setLayerLevel] this function is deprecated; use World.setItemIndex() instead.");return this.world.setItemIndex(b, c);
    }, removeLayer: function removeLayer(b) {
      a.console.error("[Viewer.removeLayer] this function is deprecated; use World.removeItem() instead.");return this.world.removeItem(b);
    }, forceRedraw: function forceRedraw() {
      U[this.hash].forceRedraw = !0;return this;
    }, bindSequenceControls: function bindSequenceControls() {
      var b = a.delegate(this, k),
          c = a.delegate(this, l),
          d = a.delegate(this, T),
          e = a.delegate(this, S),
          f = this.navImages,
          g = !0;if (this.showSequenceControl) {
        (this.previousButton || this.nextButton) && (g = !1);this.previousButton = new a.Button({ element: this.previousButton ? a.getElement(this.previousButton) : null, clickTimeThreshold: this.clickTimeThreshold, clickDistThreshold: this.clickDistThreshold, tooltip: a.getString("Tooltips.PreviousPage"), srcRest: F(this.prefixUrl, f.previous.REST), srcGroup: F(this.prefixUrl, f.previous.GROUP), srcHover: F(this.prefixUrl, f.previous.HOVER), srcDown: F(this.prefixUrl, f.previous.DOWN), onRelease: e, onFocus: b, onBlur: c });this.nextButton = new a.Button({ element: this.nextButton ? a.getElement(this.nextButton) : null, clickTimeThreshold: this.clickTimeThreshold, clickDistThreshold: this.clickDistThreshold, tooltip: a.getString("Tooltips.NextPage"), srcRest: F(this.prefixUrl, f.next.REST), srcGroup: F(this.prefixUrl, f.next.GROUP), srcHover: F(this.prefixUrl, f.next.HOVER), srcDown: F(this.prefixUrl, f.next.DOWN), onRelease: d, onFocus: b, onBlur: c });this.navPrevNextWrap || this.previousButton.disable();this.tileSources && this.tileSources.length || this.nextButton.disable();if (g) {
          this.paging = new a.ButtonGroup({ buttons: [this.previousButton, this.nextButton], clickTimeThreshold: this.clickTimeThreshold, clickDistThreshold: this.clickDistThreshold });this.pagingControl = this.paging.element;this.toolbar ? this.toolbar.addControl(this.pagingControl, { anchor: a.ControlAnchor.BOTTOM_RIGHT }) : this.addControl(this.pagingControl, { anchor: this.sequenceControlAnchor || a.ControlAnchor.TOP_LEFT });
        }
      }return this;
    }, bindStandardControls: function bindStandardControls() {
      var b = a.delegate(this, G),
          c = a.delegate(this, I),
          d = a.delegate(this, L),
          e = a.delegate(this, H),
          f = a.delegate(this, M),
          g = a.delegate(this, O),
          h = a.delegate(this, P),
          i = a.delegate(this, Q),
          j = a.delegate(this, R),
          m = a.delegate(this, k),
          n = a.delegate(this, l),
          o = this.navImages,
          p = [],
          q = !0;if (this.showNavigationControl) {
        (this.zoomInButton || this.zoomOutButton || this.homeButton || this.fullPageButton || this.rotateLeftButton || this.rotateRightButton) && (q = !1);if (this.showZoomControl) {
          p.push(this.zoomInButton = new a.Button({ element: this.zoomInButton ? a.getElement(this.zoomInButton) : null, clickTimeThreshold: this.clickTimeThreshold, clickDistThreshold: this.clickDistThreshold, tooltip: a.getString("Tooltips.ZoomIn"), srcRest: F(this.prefixUrl, o.zoomIn.REST), srcGroup: F(this.prefixUrl, o.zoomIn.GROUP), srcHover: F(this.prefixUrl, o.zoomIn.HOVER), srcDown: F(this.prefixUrl, o.zoomIn.DOWN), onPress: b, onRelease: c, onClick: d, onEnter: b, onExit: c, onFocus: m, onBlur: n }));p.push(this.zoomOutButton = new a.Button({ element: this.zoomOutButton ? a.getElement(this.zoomOutButton) : null, clickTimeThreshold: this.clickTimeThreshold, clickDistThreshold: this.clickDistThreshold, tooltip: a.getString("Tooltips.ZoomOut"), srcRest: F(this.prefixUrl, o.zoomOut.REST), srcGroup: F(this.prefixUrl, o.zoomOut.GROUP), srcHover: F(this.prefixUrl, o.zoomOut.HOVER), srcDown: F(this.prefixUrl, o.zoomOut.DOWN), onPress: e, onRelease: c, onClick: f, onEnter: e, onExit: c, onFocus: m, onBlur: n }));
        }this.showHomeControl && p.push(this.homeButton = new a.Button({ element: this.homeButton ? a.getElement(this.homeButton) : null, clickTimeThreshold: this.clickTimeThreshold, clickDistThreshold: this.clickDistThreshold, tooltip: a.getString("Tooltips.Home"), srcRest: F(this.prefixUrl, o.home.REST), srcGroup: F(this.prefixUrl, o.home.GROUP), srcHover: F(this.prefixUrl, o.home.HOVER), srcDown: F(this.prefixUrl, o.home.DOWN), onRelease: g, onFocus: m, onBlur: n }));this.showFullPageControl && p.push(this.fullPageButton = new a.Button({ element: this.fullPageButton ? a.getElement(this.fullPageButton) : null, clickTimeThreshold: this.clickTimeThreshold, clickDistThreshold: this.clickDistThreshold, tooltip: a.getString("Tooltips.FullPage"), srcRest: F(this.prefixUrl, o.fullpage.REST), srcGroup: F(this.prefixUrl, o.fullpage.GROUP), srcHover: F(this.prefixUrl, o.fullpage.HOVER), srcDown: F(this.prefixUrl, o.fullpage.DOWN), onRelease: h, onFocus: m, onBlur: n }));if (this.showRotationControl) {
          p.push(this.rotateLeftButton = new a.Button({ element: this.rotateLeftButton ? a.getElement(this.rotateLeftButton) : null, clickTimeThreshold: this.clickTimeThreshold, clickDistThreshold: this.clickDistThreshold, tooltip: a.getString("Tooltips.RotateLeft"), srcRest: F(this.prefixUrl, o.rotateleft.REST), srcGroup: F(this.prefixUrl, o.rotateleft.GROUP), srcHover: F(this.prefixUrl, o.rotateleft.HOVER), srcDown: F(this.prefixUrl, o.rotateleft.DOWN), onRelease: i, onFocus: m, onBlur: n }));p.push(this.rotateRightButton = new a.Button({ element: this.rotateRightButton ? a.getElement(this.rotateRightButton) : null, clickTimeThreshold: this.clickTimeThreshold, clickDistThreshold: this.clickDistThreshold, tooltip: a.getString("Tooltips.RotateRight"), srcRest: F(this.prefixUrl, o.rotateright.REST), srcGroup: F(this.prefixUrl, o.rotateright.GROUP), srcHover: F(this.prefixUrl, o.rotateright.HOVER), srcDown: F(this.prefixUrl, o.rotateright.DOWN), onRelease: j, onFocus: m, onBlur: n }));
        }if (q) {
          this.buttons = new a.ButtonGroup({ buttons: p, clickTimeThreshold: this.clickTimeThreshold, clickDistThreshold: this.clickDistThreshold });this.navControl = this.buttons.element;this.addHandler("open", a.delegate(this, N));this.toolbar ? this.toolbar.addControl(this.navControl, { anchor: a.ControlAnchor.TOP_LEFT }) : this.addControl(this.navControl, { anchor: this.navigationControlAnchor || a.ControlAnchor.TOP_LEFT });
        }
      }return this;
    }, currentPage: function currentPage() {
      return this._sequenceIndex;
    }, goToPage: function goToPage(a) {
      if (this.tileSources && a >= 0 && a < this.tileSources.length) {
        this.raiseEvent("page", { page: a });this._sequenceIndex = a;this._updateSequenceButtons(a);this.open(this.tileSources[a]);this.referenceStrip && this.referenceStrip.setFocus(a);
      }return this;
    }, addOverlay: function addOverlay(b, c, f, g) {
      var h;h = a.isPlainObject(b) ? b : { element: b, location: c, placement: f, onDraw: g };b = a.getElement(h.element);if (e(this.currentOverlays, b) >= 0) return this;var i = d(this, h);this.currentOverlays.push(i);i.drawHTML(this.overlaysContainer, this.viewport);this.raiseEvent("add-overlay", { element: b, location: h.location, placement: h.placement });return this;
    }, updateOverlay: function updateOverlay(b, c, d) {
      var f;b = a.getElement(b);f = e(this.currentOverlays, b);if (f >= 0) {
        this.currentOverlays[f].update(c, d);U[this.hash].forceRedraw = !0;this.raiseEvent("update-overlay", { element: b, location: c, placement: d });
      }return this;
    }, removeOverlay: function removeOverlay(b) {
      var c;b = a.getElement(b);c = e(this.currentOverlays, b);if (c >= 0) {
        this.currentOverlays[c].destroy();this.currentOverlays.splice(c, 1);U[this.hash].forceRedraw = !0;this.raiseEvent("remove-overlay", { element: b });
      }return this;
    }, clearOverlays: function clearOverlays() {
      for (; this.currentOverlays.length > 0;) {
        this.currentOverlays.pop().destroy();
      }U[this.hash].forceRedraw = !0;this.raiseEvent("clear-overlay", {});return this;
    }, getOverlayById: function getOverlayById(b) {
      var c;b = a.getElement(b);c = e(this.currentOverlays, b);return c >= 0 ? this.currentOverlays[c] : null;
    }, _updateSequenceButtons: function _updateSequenceButtons(a) {
      this.nextButton && (this.tileSources && this.tileSources.length - 1 !== a ? this.nextButton.enable() : this.navPrevNextWrap || this.nextButton.disable());this.previousButton && (a > 0 ? this.previousButton.enable() : this.navPrevNextWrap || this.previousButton.disable());
    }, _showMessage: function _showMessage(b) {
      this._hideMessage();var c = a.makeNeutralElement("div");c.appendChild(document.createTextNode(b));this.messageDiv = a.makeCenteredNode(c);a.addClass(this.messageDiv, "openseadragon-message");this.container.appendChild(this.messageDiv);
    }, _hideMessage: function _hideMessage() {
      var a = this.messageDiv;if (a) {
        a.parentNode.removeChild(a);delete this.messageDiv;
      }
    }, gestureSettingsByDeviceType: function gestureSettingsByDeviceType(a) {
      switch (a) {case "mouse":
          return this.gestureSettingsMouse;case "touch":
          return this.gestureSettingsTouch;case "pen":
          return this.gestureSettingsPen;default:
          return this.gestureSettingsUnknown;}
    }, _drawOverlays: function _drawOverlays() {
      var a,
          b = this.currentOverlays.length;for (a = 0; b > a; a++) {
        this.currentOverlays[a].drawHTML(this.overlaysContainer, this.viewport);
      }
    }, _cancelPendingImages: function _cancelPendingImages() {
      this._loadQueue = [];
    } });
}(OpenSeadragon);!function (a) {
  function b(a) {
    if (a.quick && this.viewer.viewport) {
      this.viewer.viewport.panTo(this.viewport.pointFromPixel(a.position));this.viewer.viewport.applyConstraints();
    }
  }function c(a) {
    if (this.viewer.viewport) {
      this.panHorizontal || (a.delta.x = 0);this.panVertical || (a.delta.y = 0);this.viewer.viewport.panBy(this.viewport.deltaPointsFromPixels(a.delta));
    }
  }function d(a) {
    a.insideElementPressed && this.viewer.viewport && this.viewer.viewport.applyConstraints();
  }function e(a) {
    this.viewer.raiseEvent("navigator-scroll", { tracker: a.eventSource, position: a.position, scroll: a.scroll, shift: a.shift, originalEvent: a.originalEvent });return !1;
  }function f(a, b) {
    a.style.webkitTransform = "rotate(" + b + "deg)";a.style.mozTransform = "rotate(" + b + "deg)";a.style.msTransform = "rotate(" + b + "deg)";a.style.oTransform = "rotate(" + b + "deg)";a.style.transform = "rotate(" + b + "deg)";
  }a.Navigator = function (g) {
    function h(a) {
      f(l.displayRegionContainer, a);
      f(l.displayRegion, -a);l.viewport.setRotation(a);
    }var i,
        j,
        k = g.viewer,
        l = this;if (g.id) {
      this.element = document.getElementById(g.id);g.controlOptions = { anchor: a.ControlAnchor.NONE, attachToViewer: !1, autoFade: !1 };
    } else {
      g.id = "navigator-" + a.now();this.element = a.makeNeutralElement("div");g.controlOptions = { anchor: a.ControlAnchor.TOP_RIGHT, attachToViewer: !0, autoFade: g.autoFade };if (g.position) if ("BOTTOM_RIGHT" == g.position) g.controlOptions.anchor = a.ControlAnchor.BOTTOM_RIGHT;else if ("BOTTOM_LEFT" == g.position) g.controlOptions.anchor = a.ControlAnchor.BOTTOM_LEFT;else if ("TOP_RIGHT" == g.position) g.controlOptions.anchor = a.ControlAnchor.TOP_RIGHT;else if ("TOP_LEFT" == g.position) g.controlOptions.anchor = a.ControlAnchor.TOP_LEFT;else if ("ABSOLUTE" == g.position) {
        g.controlOptions.anchor = a.ControlAnchor.ABSOLUTE;g.controlOptions.top = g.top;g.controlOptions.left = g.left;g.controlOptions.height = g.height;g.controlOptions.width = g.width;
      }
    }this.element.id = g.id;this.element.className += " navigator";g = a.extend(!0, { sizeRatio: a.DEFAULT_SETTINGS.navigatorSizeRatio }, g, { element: this.element, tabIndex: -1, showNavigator: !1, mouseNavEnabled: !1, showNavigationControl: !1, showSequenceControl: !1, immediateRender: !0, blendTime: 0, animationTime: 0, autoResize: g.autoResize, minZoomImageRatio: 1 });g.minPixelRatio = this.minPixelRatio = k.minPixelRatio;a.setElementTouchActionNone(this.element);this.borderWidth = 2;this.fudge = new a.Point(1, 1);this.totalBorderWidths = new a.Point(2 * this.borderWidth, 2 * this.borderWidth).minus(this.fudge);g.controlOptions.anchor != a.ControlAnchor.NONE && !function (a, b) {
      a.margin = "0px";a.border = b + "px solid #555";a.padding = "0px";a.background = "#000";a.opacity = .8;a.overflow = "hidden";
    }(this.element.style, this.borderWidth);this.displayRegion = a.makeNeutralElement("div");this.displayRegion.id = this.element.id + "-displayregion";this.displayRegion.className = "displayregion";!function (a, b) {
      a.position = "relative";a.top = "0px";a.left = "0px";a.fontSize = "0px";a.overflow = "hidden";a.border = b + "px solid #900";a.margin = "0px";a.padding = "0px";a.background = "transparent";a["float"] = "left";a.cssFloat = "left";a.styleFloat = "left";a.zIndex = 999999999;a.cursor = "default";
    }(this.displayRegion.style, this.borderWidth);this.displayRegionContainer = a.makeNeutralElement("div");this.displayRegionContainer.id = this.element.id + "-displayregioncontainer";this.displayRegionContainer.className = "displayregioncontainer";this.displayRegionContainer.style.width = "100%";this.displayRegionContainer.style.height = "100%";k.addControl(this.element, g.controlOptions);this._resizeWithViewer = g.controlOptions.anchor != a.ControlAnchor.ABSOLUTE && g.controlOptions.anchor != a.ControlAnchor.NONE;if (this._resizeWithViewer) {
      if (g.width && g.height) {
        this.element.style.height = "number" == typeof g.height ? g.height + "px" : g.height;this.element.style.width = "number" == typeof g.width ? g.width + "px" : g.width;
      } else {
        i = a.getElementSize(k.element);this.element.style.height = Math.round(i.y * g.sizeRatio) + "px";this.element.style.width = Math.round(i.x * g.sizeRatio) + "px";this.oldViewerSize = i;
      }j = a.getElementSize(this.element);this.elementArea = j.x * j.y;
    }this.oldContainerSize = new a.Point(0, 0);a.Viewer.apply(this, [g]);this.displayRegionContainer.appendChild(this.displayRegion);this.element.getElementsByTagName("div")[0].appendChild(this.displayRegionContainer);if (g.navigatorRotate) {
      var m = g.viewer.viewport ? g.viewer.viewport.getRotation() : g.viewer.degrees || 0;h(m);g.viewer.addHandler("rotate", function (a) {
        h(a.degrees);
      });
    }this.innerTracker.destroy();this.innerTracker = new a.MouseTracker({ element: this.element, dragHandler: a.delegate(this, c), clickHandler: a.delegate(this, b), releaseHandler: a.delegate(this, d), scrollHandler: a.delegate(this, e) });this.addHandler("reset-size", function () {
      l.viewport && l.viewport.goHome(!0);
    });k.world.addHandler("item-index-change", function (a) {
      var b = l.world.getItemAt(a.previousIndex);l.world.setItemIndex(b, a.newIndex);
    });k.world.addHandler("remove-item", function (a) {
      var b = a.item;var c = l._getMatchingItem(b);c && l.world.removeItem(c);
    });this.update(k.viewport);
  };a.extend(a.Navigator.prototype, a.EventSource.prototype, a.Viewer.prototype, { updateSize: function updateSize() {
      if (this.viewport) {
        var b = new a.Point(0 === this.container.clientWidth ? 1 : this.container.clientWidth, 0 === this.container.clientHeight ? 1 : this.container.clientHeight);if (!b.equals(this.oldContainerSize)) {
          this.viewport.resize(b, !0);this.viewport.goHome(!0);this.oldContainerSize = b;this.drawer.clear();this.world.draw();
        }
      }
    }, update: function update(b) {
      var c, d, e, f, g, h;c = a.getElementSize(this.viewer.element);if (this._resizeWithViewer && c.x && c.y && !c.equals(this.oldViewerSize)) {
        this.oldViewerSize = c;if (this.maintainSizeRatio || !this.elementArea) {
          d = c.x * this.sizeRatio;e = c.y * this.sizeRatio;
        } else {
          d = Math.sqrt(this.elementArea * (c.x / c.y));e = this.elementArea / d;
        }this.element.style.width = Math.round(d) + "px";this.element.style.height = Math.round(e) + "px";this.elementArea || (this.elementArea = d * e);this.updateSize();
      }if (b && this.viewport) {
        f = b.getBoundsNoRotate(!0);g = this.viewport.pixelFromPointNoRotate(f.getTopLeft(), !1);h = this.viewport.pixelFromPointNoRotate(f.getBottomRight(), !1).minus(this.totalBorderWidths);var i = this.displayRegion.style;i.display = this.world.getItemCount() ? "block" : "none";i.top = Math.round(g.y) + "px";i.left = Math.round(g.x) + "px";var j = Math.abs(g.x - h.x);var k = Math.abs(g.y - h.y);i.width = Math.round(Math.max(j, 0)) + "px";i.height = Math.round(Math.max(k, 0)) + "px";
      }
    }, addTiledImage: function addTiledImage(b) {
      var c = this;var d = b.originalTiledImage;delete b.original;var e = a.extend({}, b, { success: function success(a) {
          var b = a.item;b._originalForNavigator = d;c._matchBounds(b, d, !0);d.addHandler("bounds-change", function () {
            c._matchBounds(b, d);
          });
        } });return a.Viewer.prototype.addTiledImage.apply(this, [e]);
    }, _getMatchingItem: function _getMatchingItem(a) {
      var b = this.world.getItemCount();var c;for (var d = 0; b > d; d++) {
        c = this.world.getItemAt(d);if (c._originalForNavigator === a) return c;
      }return null;
    }, _matchBounds: function _matchBounds(a, b, c) {
      var d = b.getBounds();a.setPosition(d.getTopLeft(), c);a.setWidth(d.width, c);
    } });
}(OpenSeadragon);!function (a) {
  var b = { Errors: { Dzc: "Sorry, we don't support Deep Zoom Collections!", Dzi: "Hmm, this doesn't appear to be a valid Deep Zoom Image.", Xml: "Hmm, this doesn't appear to be a valid Deep Zoom Image.", ImageFormat: "Sorry, we don't support {0}-based Deep Zoom Images.", Security: "It looks like a security restriction stopped us from loading this Deep Zoom Image.", Status: "This space unintentionally left blank ({0} {1}).", OpenFailed: "Unable to open {0}: {1}" }, Tooltips: { FullPage: "Toggle full page", Home: "Go home", ZoomIn: "Zoom in", ZoomOut: "Zoom out", NextPage: "Next page", PreviousPage: "Previous page", RotateLeft: "Rotate left", RotateRight: "Rotate right" } };a.extend(a, { getString: function getString(c) {
      var d,
          e = c.split("."),
          f = null,
          g = arguments,
          h = b;for (d = 0; d < e.length - 1; d++) {
        h = h[e[d]] || {};
      }f = h[e[d]];if ("string" != typeof f) {
        a.console.debug("Untranslated source string:", c);f = "";
      }return f.replace(/\{\d+\}/g, function (a) {
        var b = parseInt(a.match(/\d+/), 10) + 1;return b < g.length ? g[b] : "";
      });
    }, setString: function setString(a, c) {
      var d,
          e = a.split("."),
          f = b;for (d = 0; d < e.length - 1; d++) {
        f[e[d]] || (f[e[d]] = {});f = f[e[d]];
      }f[e[d]] = c;
    } });
}(OpenSeadragon);!function (a) {
  a.Point = function (a, b) {
    this.x = "number" == typeof a ? a : 0;this.y = "number" == typeof b ? b : 0;
  };a.Point.prototype = { clone: function clone() {
      return new a.Point(this.x, this.y);
    }, plus: function plus(b) {
      return new a.Point(this.x + b.x, this.y + b.y);
    }, minus: function minus(b) {
      return new a.Point(this.x - b.x, this.y - b.y);
    }, times: function times(b) {
      return new a.Point(this.x * b, this.y * b);
    }, divide: function divide(b) {
      return new a.Point(this.x / b, this.y / b);
    }, negate: function negate() {
      return new a.Point(-this.x, -this.y);
    }, distanceTo: function distanceTo(a) {
      return Math.sqrt(Math.pow(this.x - a.x, 2) + Math.pow(this.y - a.y, 2));
    }, apply: function apply(b) {
      return new a.Point(b(this.x), b(this.y));
    }, equals: function equals(b) {
      return b instanceof a.Point && this.x === b.x && this.y === b.y;
    }, rotate: function rotate(b, c) {
      c = c || new a.Point(0, 0);var d;var e;if (b % 90 === 0) {
        var f = b % 360;0 > f && (f += 360);switch (f) {case 0:
            d = 1;e = 0;break;case 90:
            d = 0;e = 1;break;case 180:
            d = -1;e = 0;break;case 270:
            d = 0;e = -1;}
      } else {
        var g = b * Math.PI / 180;d = Math.cos(g);e = Math.sin(g);
      }var h = d * (this.x - c.x) - e * (this.y - c.y) + c.x;var i = e * (this.x - c.x) + d * (this.y - c.y) + c.y;return new a.Point(h, i);
    }, toString: function toString() {
      return "(" + Math.round(100 * this.x) / 100 + "," + Math.round(100 * this.y) / 100 + ")";
    } };
}(OpenSeadragon);!function (a) {
  function b(b) {
    var c,
        d,
        e = b.responseText,
        f = b.status;if (!b) throw new Error(a.getString("Errors.Security"));if (200 !== b.status && 0 !== b.status) {
      f = b.status;c = 404 == f ? "Not Found" : b.statusText;throw new Error(a.getString("Errors.Status", f, c));
    }if (e.match(/\s*<.*/)) try {
      d = b.responseXML && b.responseXML.documentElement ? b.responseXML : a.parseXml(e);
    } catch (g) {
      d = b.responseText;
    } else d = e.match(/\s*[\{\[].*/) ? a.parseJSON(e) : e;return d;
  }a.TileSource = function (b, c, d, e, f, g) {
    var h = this;var i,
        j,
        k = arguments;i = a.isPlainObject(b) ? b : { width: k[0], height: k[1], tileSize: k[2], tileOverlap: k[3], minLevel: k[4], maxLevel: k[5] };a.EventSource.call(this);a.extend(!0, this, i);if (!this.success) for (j = 0; j < arguments.length; j++) {
      if (a.isFunction(arguments[j])) {
        this.success = arguments[j];break;
      }
    }this.success && this.addHandler("ready", function (a) {
      h.success(a);
    });"string" == a.type(arguments[0]) && (this.url = arguments[0]);if (this.url) {
      this.aspectRatio = 1;this.dimensions = new a.Point(10, 10);this._tileWidth = 0;this._tileHeight = 0;this.tileOverlap = 0;this.minLevel = 0;this.maxLevel = 0;this.ready = !1;this.getImageInfo(this.url);
    } else {
      this.ready = !0;this.aspectRatio = i.width && i.height ? i.width / i.height : 1;this.dimensions = new a.Point(i.width, i.height);if (this.tileSize) {
        this._tileWidth = this._tileHeight = this.tileSize;delete this.tileSize;
      } else {
        if (this.tileWidth) {
          this._tileWidth = this.tileWidth;delete this.tileWidth;
        } else this._tileWidth = 0;if (this.tileHeight) {
          this._tileHeight = this.tileHeight;delete this.tileHeight;
        } else this._tileHeight = 0;
      }this.tileOverlap = i.tileOverlap ? i.tileOverlap : 0;this.minLevel = i.minLevel ? i.minLevel : 0;this.maxLevel = void 0 !== i.maxLevel && null !== i.maxLevel ? i.maxLevel : i.width && i.height ? Math.ceil(Math.log(Math.max(i.width, i.height)) / Math.log(2)) : 0;this.success && a.isFunction(this.success) && this.success(this);
    }
  };a.TileSource.prototype = { getTileSize: function getTileSize(b) {
      a.console.error("[TileSource.getTileSize] is deprecated.Use TileSource.getTileWidth() and TileSource.getTileHeight() instead");return this._tileWidth;
    }, getTileWidth: function getTileWidth(a) {
      return this._tileWidth ? this._tileWidth : this.getTileSize(a);
    }, getTileHeight: function getTileHeight(a) {
      return this._tileHeight ? this._tileHeight : this.getTileSize(a);
    }, getLevelScale: function getLevelScale(a) {
      var b,
          c = {};for (b = 0; b <= this.maxLevel; b++) {
        c[b] = 1 / Math.pow(2, this.maxLevel - b);
      }this.getLevelScale = function (a) {
        return c[a];
      };return this.getLevelScale(a);
    }, getNumTiles: function getNumTiles(b) {
      var c = this.getLevelScale(b),
          d = Math.ceil(c * this.dimensions.x / this.getTileWidth(b)),
          e = Math.ceil(c * this.dimensions.y / this.getTileHeight(b));return new a.Point(d, e);
    }, getPixelRatio: function getPixelRatio(b) {
      var c = this.dimensions.times(this.getLevelScale(b)),
          d = 1 / c.x,
          e = 1 / c.y;return new a.Point(d, e);
    }, getClosestLevel: function getClosestLevel(b) {
      var c, d, e;for (c = this.minLevel; c < this.maxLevel; c++) {
        e = this.getNumTiles(c);d = new a.Point(Math.floor(b.x / this.getTileWidth(c)), Math.floor(b.y / this.getTileHeight(c)));if (e.x + 1 >= d.x && e.y + 1 >= d.y) break;
      }return Math.max(0, c - 1);
    }, getTileAtPoint: function getTileAtPoint(b, c) {
      var d = c.times(this.dimensions.x).times(this.getLevelScale(b)),
          e = Math.floor(d.x / this.getTileWidth(b)),
          f = Math.floor(d.y / this.getTileHeight(b));return new a.Point(e, f);
    }, getTileBounds: function getTileBounds(b, c, d) {
      var e = this.dimensions.times(this.getLevelScale(b)),
          f = this.getTileWidth(b),
          g = this.getTileHeight(b),
          h = 0 === c ? 0 : f * c - this.tileOverlap,
          i = 0 === d ? 0 : g * d - this.tileOverlap,
          j = f + (0 === c ? 1 : 2) * this.tileOverlap,
          k = g + (0 === d ? 1 : 2) * this.tileOverlap,
          l = 1 / e.x;j = Math.min(j, e.x - h);k = Math.min(k, e.y - i);return new a.Rect(h * l, i * l, j * l, k * l);
    }, getImageInfo: function getImageInfo(c) {
      var d,
          e,
          f,
          g,
          h,
          i,
          j,
          k = this;if (c) {
        h = c.split("/");i = h[h.length - 1];j = i.lastIndexOf(".");j > -1 && (h[h.length - 1] = i.slice(0, j));
      }e = function e(b) {
        "string" == typeof b && (b = a.parseXml(b));var d = a.TileSource.determineType(k, b, c);if (d) {
          g = d.prototype.configure.apply(k, [b, c]);void 0 === g.ajaxWithCredentials && (g.ajaxWithCredentials = k.ajaxWithCredentials);f = new d(g);k.ready = !0;k.raiseEvent("ready", { tileSource: f });
        } else k.raiseEvent("open-failed", { message: "Unable to load TileSource", source: c });
      };if (c.match(/\.js$/)) {
        d = c.split("/").pop().replace(".js", "");a.jsonp({ url: c, async: !1, callbackName: d, callback: e });
      } else a.makeAjaxRequest({ url: c, withCredentials: this.ajaxWithCredentials, success: function success(a) {
          var c = b(a);e(c);
        }, error: function error(a, b) {
          var d;try {
            d = "HTTP " + a.status + " attempting to load TileSource";
          } catch (e) {
            var f;f = "undefined" != typeof b && b.toString ? b.toString() : "Unknown error";d = f + " attempting to load TileSource";
          }k.raiseEvent("open-failed", { message: d, source: c });
        } });
    }, supports: function supports(a, b) {
      return !1;
    }, configure: function configure(a, b) {
      throw new Error("Method not implemented.");
    }, getTileUrl: function getTileUrl(a, b, c) {
      throw new Error("Method not implemented.");
    }, tileExists: function tileExists(a, b, c) {
      var d = this.getNumTiles(a);return a >= this.minLevel && a <= this.maxLevel && b >= 0 && c >= 0 && b < d.x && c < d.y;
    } };a.extend(!0, a.TileSource.prototype, a.EventSource.prototype);a.TileSource.determineType = function (b, c, d) {
    var e;for (e in OpenSeadragon) {
      if (e.match(/.+TileSource$/) && a.isFunction(OpenSeadragon[e]) && a.isFunction(OpenSeadragon[e].prototype.supports) && OpenSeadragon[e].prototype.supports.call(b, c, d)) return OpenSeadragon[e];
    }a.console.error("No TileSource was able to open %s %s", d, c);
  };
}(OpenSeadragon);!function (a) {
  function b(b, d) {
    if (!d || !d.documentElement) throw new Error(a.getString("Errors.Xml"));var e,
        f,
        g,
        h,
        i,
        j = d.documentElement,
        k = j.localName || j.tagName,
        l = d.documentElement.namespaceURI,
        m = null,
        n = [];if ("Image" == k) try {
      h = j.getElementsByTagName("Size")[0];void 0 === h && (h = j.getElementsByTagNameNS(l, "Size")[0]);m = { Image: { xmlns: "http://schemas.microsoft.com/deepzoom/2008", Url: j.getAttribute("Url"), Format: j.getAttribute("Format"), DisplayRect: null, Overlap: parseInt(j.getAttribute("Overlap"), 10), TileSize: parseInt(j.getAttribute("TileSize"), 10), Size: { Height: parseInt(h.getAttribute("Height"), 10), Width: parseInt(h.getAttribute("Width"), 10) } } };if (!a.imageFormatSupported(m.Image.Format)) throw new Error(a.getString("Errors.ImageFormat", m.Image.Format.toUpperCase()));e = j.getElementsByTagName("DisplayRect");void 0 === e && (e = j.getElementsByTagNameNS(l, "DisplayRect")[0]);for (i = 0; i < e.length; i++) {
        f = e[i];g = f.getElementsByTagName("Rect")[0];void 0 === g && (g = f.getElementsByTagNameNS(l, "Rect")[0]);n.push({ Rect: { X: parseInt(g.getAttribute("X"), 10), Y: parseInt(g.getAttribute("Y"), 10), Width: parseInt(g.getAttribute("Width"), 10), Height: parseInt(g.getAttribute("Height"), 10), MinLevel: parseInt(f.getAttribute("MinLevel"), 10), MaxLevel: parseInt(f.getAttribute("MaxLevel"), 10) } });
      }n.length && (m.Image.DisplayRect = n);return c(b, m);
    } catch (o) {
      throw o instanceof Error ? o : new Error(a.getString("Errors.Dzi"));
    } else {
      if ("Collection" == k) throw new Error(a.getString("Errors.Dzc"));if ("Error" == k) {
        var p = j.getElementsByTagName("Message")[0];var q = p.firstChild.nodeValue;throw new Error(q);
      }
    }throw new Error(a.getString("Errors.Dzi"));
  }function c(b, c) {
    var d,
        e,
        f = c.Image,
        g = f.Url,
        h = f.Format,
        i = f.Size,
        j = f.DisplayRect || [],
        k = parseInt(i.Width, 10),
        l = parseInt(i.Height, 10),
        m = parseInt(f.TileSize, 10),
        n = parseInt(f.Overlap, 10),
        o = [];for (e = 0; e < j.length; e++) {
      d = j[e].Rect;o.push(new a.DisplayRect(parseInt(d.X, 10), parseInt(d.Y, 10), parseInt(d.Width, 10), parseInt(d.Height, 10), parseInt(d.MinLevel, 10), parseInt(d.MaxLevel, 10)));
    }return a.extend(!0, { width: k, height: l, tileSize: m, tileOverlap: n, minLevel: null, maxLevel: null, tilesUrl: g, fileFormat: h, displayRects: o }, c);
  }a.DziTileSource = function (b, c, d, e, f, g, h, i, j) {
    var k, l, m, n;n = a.isPlainObject(b) ? b : { width: arguments[0], height: arguments[1], tileSize: arguments[2], tileOverlap: arguments[3], tilesUrl: arguments[4], fileFormat: arguments[5], displayRects: arguments[6], minLevel: arguments[7], maxLevel: arguments[8] };this._levelRects = {};this.tilesUrl = n.tilesUrl;this.fileFormat = n.fileFormat;this.displayRects = n.displayRects;if (this.displayRects) for (k = this.displayRects.length - 1; k >= 0; k--) {
      l = this.displayRects[k];for (m = l.minLevel; m <= l.maxLevel; m++) {
        this._levelRects[m] || (this._levelRects[m] = []);this._levelRects[m].push(l);
      }
    }a.TileSource.apply(this, [n]);
  };a.extend(a.DziTileSource.prototype, a.TileSource.prototype, { supports: function supports(a, b) {
      var c;a.Image ? c = a.Image.xmlns : a.documentElement && ("Image" == a.documentElement.localName || "Image" == a.documentElement.tagName) && (c = a.documentElement.namespaceURI);return "http://schemas.microsoft.com/deepzoom/2008" == c || "http://schemas.microsoft.com/deepzoom/2009" == c;
    }, configure: function configure(d, e) {
      var f;f = a.isPlainObject(d) ? c(this, d) : b(this, d);if (e && !f.tilesUrl) {
        f.tilesUrl = e.replace(/([^\/]+?)(\.(dzi|xml|js))?\/?(\?.*)?$/, "$1_files/");-1 != e.search(/\.(dzi|xml|js)\?/) ? f.queryParams = e.match(/\?.*/) : f.queryParams = "";
      }return f;
    }, getTileUrl: function getTileUrl(a, b, c) {
      return [this.tilesUrl, a, "/", b, "_", c, ".", this.fileFormat, this.queryParams].join("");
    }, tileExists: function tileExists(a, b, c) {
      var d,
          e,
          f,
          g,
          h,
          i,
          j,
          k = this._levelRects[a];if (!k || !k.length) return !0;for (j = k.length - 1; j >= 0; j--) {
        d = k[j];if (!(a < d.minLevel || a > d.maxLevel)) {
          e = this.getLevelScale(a);f = d.x * e;g = d.y * e;h = f + d.width * e;i = g + d.height * e;f = Math.floor(f / this.tileSize);g = Math.floor(g / this.tileSize);h = Math.ceil(h / this.tileSize);i = Math.ceil(i / this.tileSize);if (b >= f && h > b && c >= g && i > c) return !0;
        }
      }return !1;
    } });
}(OpenSeadragon);!function (a) {
  function b(a) {
    var b = ["http://library.stanford.edu/iiif/image-api/compliance.html#level0", "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level0", "http://iiif.io/api/image/2/level0.json"];var c = -1 != b.indexOf(a[0]);return !c || -1 != a.indexOf("sizeByW");
  }function c(a) {
    var b = [];for (var c = 0; c < a.sizes.length; c++) {
      b.push({ url: a["@id"] + "/full/" + a.sizes[c].width + ",/0/default.jpg", width: a.sizes[c].width, height: a.sizes[c].height });
    }return b.sort(function (a, b) {
      return a.width - b.width;
    });
  }function d(b) {
    if (!b || !b.documentElement) throw new Error(a.getString("Errors.Xml"));var c = b.documentElement,
        d = c.tagName,
        f = null;if ("info" == d) try {
      f = {};e(c, f);return f;
    } catch (g) {
      throw g instanceof Error ? g : new Error(a.getString("Errors.IIIF"));
    }throw new Error(a.getString("Errors.IIIF"));
  }function e(b, c, d) {
    var f, g;if (3 == b.nodeType && d) {
      g = b.nodeValue.trim();g.match(/^\d*$/) && (g = Number(g));if (c[d]) {
        a.isArray(c[d]) || (c[d] = [c[d]]);c[d].push(g);
      } else c[d] = g;
    } else if (1 == b.nodeType) for (f = 0; f < b.childNodes.length; f++) {
      e(b.childNodes[f], c, b.nodeName);
    }
  }a.IIIFTileSource = function (d) {
    a.extend(!0, this, d);if (!(this.height && this.width && this["@id"])) throw new Error("IIIF required parameters not provided.");d.tileSizePerScaleFactor = {};if (this.tile_width && this.tile_height) {
      d.tileWidth = this.tile_width;d.tileHeight = this.tile_height;
    } else if (this.tile_width) d.tileSize = this.tile_width;else if (this.tile_height) d.tileSize = this.tile_height;else if (this.tiles) {
      if (1 == this.tiles.length) {
        d.tileWidth = this.tiles[0].width;d.tileHeight = this.tiles[0].height || this.tiles[0].width;this.scale_factors = this.tiles[0].scaleFactors;
      } else {
        this.scale_factors = [];for (var e = 0; e < this.tiles.length; e++) {
          for (var f = 0; f < this.tiles[e].scaleFactors.length; f++) {
            var g = this.tiles[e].scaleFactors[f];this.scale_factors.push(g);d.tileSizePerScaleFactor[g] = { width: this.tiles[e].width, height: this.tiles[e].height || this.tiles[e].width };
          }
        }
      }
    } else if (b(d.profile)) {
      var h = Math.min(this.height, this.width),
          i = [256, 512, 1024],
          j = [];for (var k = 0; k < i.length; k++) {
        i[k] <= h && j.push(i[k]);
      }j.length > 0 ? d.tileSize = Math.max.apply(null, j) : d.tileSize = h;
    } else if (this.sizes && this.sizes.length > 0) {
      this.emulateLegacyImagePyramid = !0;d.levels = c(this);a.extend(!0, d, { width: d.levels[d.levels.length - 1].width, height: d.levels[d.levels.length - 1].height, tileSize: Math.max(d.height, d.width), tileOverlap: 0, minLevel: 0, maxLevel: d.levels.length - 1 });this.levels = d.levels;
    } else a.console.error("Nothing in the info.json to construct image pyramids from");d.maxLevel || this.emulateLegacyImagePyramid || (this.scale_factors ? d.maxLevel = Math.floor(Math.pow(Math.max.apply(null, this.scale_factors), .5)) : d.maxLevel = Number(Math.ceil(Math.log(Math.max(this.width, this.height), 2))));a.TileSource.apply(this, [d]);
  };a.extend(a.IIIFTileSource.prototype, a.TileSource.prototype, { supports: function supports(a, b) {
      return a.protocol && "http://iiif.io/api/image" == a.protocol ? !0 : !a["@context"] || "http://library.stanford.edu/iiif/image-api/1.1/context.json" != a["@context"] && "http://iiif.io/api/image/1/context.json" != a["@context"] ? a.profile && 0 === a.profile.indexOf("http://library.stanford.edu/iiif/image-api/compliance.html") ? !0 : a.identifier && a.width && a.height ? !0 : a.documentElement && "info" == a.documentElement.tagName && "http://library.stanford.edu/iiif/image-api/ns/" == a.documentElement.namespaceURI ? !0 : !1 : !0;
    }, configure: function configure(b, c) {
      if (a.isPlainObject(b)) {
        if (b["@context"]) return b;b["@context"] = "http://iiif.io/api/image/1.0/context.json";b["@id"] = c.replace("/info.json", "");return b;
      }var e = d(b);e["@context"] = "http://iiif.io/api/image/1.0/context.json";e["@id"] = c.replace("/info.xml", "");return e;
    }, getTileWidth: function getTileWidth(b) {
      if (this.emulateLegacyImagePyramid) return a.TileSource.prototype.getTileWidth.call(this, b);var c = Math.pow(2, this.maxLevel - b);return this.tileSizePerScaleFactor && this.tileSizePerScaleFactor[c] ? this.tileSizePerScaleFactor[c].width : this._tileWidth;
    }, getTileHeight: function getTileHeight(b) {
      if (this.emulateLegacyImagePyramid) return a.TileSource.prototype.getTileHeight.call(this, b);var c = Math.pow(2, this.maxLevel - b);return this.tileSizePerScaleFactor && this.tileSizePerScaleFactor[c] ? this.tileSizePerScaleFactor[c].height : this._tileHeight;
    }, getLevelScale: function getLevelScale(b) {
      if (this.emulateLegacyImagePyramid) {
        var c = NaN;this.levels.length > 0 && b >= this.minLevel && b <= this.maxLevel && (c = this.levels[b].width / this.levels[this.maxLevel].width);return c;
      }return a.TileSource.prototype.getLevelScale.call(this, b);
    }, getNumTiles: function getNumTiles(b) {
      if (this.emulateLegacyImagePyramid) {
        var c = this.getLevelScale(b);return c ? new a.Point(1, 1) : new a.Point(0, 0);
      }return a.TileSource.prototype.getNumTiles.call(this, b);
    }, getTileAtPoint: function getTileAtPoint(b, c) {
      return this.emulateLegacyImagePyramid ? new a.Point(0, 0) : a.TileSource.prototype.getTileAtPoint.call(this, b, c);
    }, getTileUrl: function getTileUrl(a, b, c) {
      if (this.emulateLegacyImagePyramid) {
        var d = null;this.levels.length > 0 && a >= this.minLevel && a <= this.maxLevel && (d = this.levels[a].url);return d;
      }var e,
          f,
          g,
          h,
          i,
          j,
          k,
          l,
          m,
          n,
          o,
          p,
          q = "0",
          r = Math.pow(.5, this.maxLevel - a),
          s = Math.ceil(this.width * r),
          t = Math.ceil(this.height * r);e = this.getTileWidth(a);f = this.getTileHeight(a);g = Math.ceil(e / r);h = Math.ceil(f / r);o = this["@context"].indexOf("/1.0/context.json") > -1 || this["@context"].indexOf("/1.1/context.json") > -1 || this["@context"].indexOf("/1/context.json") > -1 ? "native.jpg" : "default.jpg";if (e > s && f > t) {
        n = s + ",";i = "full";
      } else {
        j = b * g;k = c * h;l = Math.min(g, this.width - j);m = Math.min(h, this.height - k);n = Math.ceil(l * r) + ",";i = [j, k, l, m].join(",");
      }p = [this["@id"], i, n, q, o].join("/");return p;
    } });
}(OpenSeadragon);!function (a) {
  a.OsmTileSource = function (b, c, d, e, f) {
    var g;g = a.isPlainObject(b) ? b : { width: arguments[0], height: arguments[1], tileSize: arguments[2], tileOverlap: arguments[3], tilesUrl: arguments[4] };if (!g.width || !g.height) {
      g.width = 65572864;g.height = 65572864;
    }if (!g.tileSize) {
      g.tileSize = 256;g.tileOverlap = 0;
    }g.tilesUrl || (g.tilesUrl = "http://tile.openstreetmap.org/");g.minLevel = 8;a.TileSource.apply(this, [g]);
  };a.extend(a.OsmTileSource.prototype, a.TileSource.prototype, { supports: function supports(a, b) {
      return a.type && "openstreetmaps" == a.type;
    }, configure: function configure(a, b) {
      return a;
    }, getTileUrl: function getTileUrl(a, b, c) {
      return this.tilesUrl + (a - 8) + "/" + b + "/" + c + ".png";
    } });
}(OpenSeadragon);!function (a) {
  a.TmsTileSource = function (b, c, d, e, f) {
    var g;g = a.isPlainObject(b) ? b : { width: arguments[0], height: arguments[1], tileSize: arguments[2], tileOverlap: arguments[3], tilesUrl: arguments[4] };var h,
        i = 256 * Math.ceil(g.width / 256),
        j = 256 * Math.ceil(g.height / 256);h = i > j ? i / 256 : j / 256;g.maxLevel = Math.ceil(Math.log(h) / Math.log(2)) - 1;g.tileSize = 256;g.width = i;g.height = j;a.TileSource.apply(this, [g]);
  };a.extend(a.TmsTileSource.prototype, a.TileSource.prototype, { supports: function supports(a, b) {
      return a.type && "tiledmapservice" == a.type;
    }, configure: function configure(a, b) {
      return a;
    }, getTileUrl: function getTileUrl(a, b, c) {
      var d = this.getNumTiles(a).y - 1;return this.tilesUrl + a + "/" + b + "/" + (d - c) + ".png";
    } });
}(OpenSeadragon);!function (a) {
  function b(b) {
    var c,
        d,
        e = [];for (d = 0; d < b.length; d++) {
      c = b[d];c.height && c.width && c.url && (c.url.toLowerCase().match(/^.*\.(png|jpg|jpeg|gif)(?:\?.*)?$/) || c.mimetype && c.mimetype.toLowerCase().match(/^.*\/(png|jpg|jpeg|gif)$/)) ? e.push({ url: c.url, width: Number(c.width), height: Number(c.height) }) : a.console.error("Unsupported image format: %s", c.url ? c.url : "<no URL>");
    }return e.sort(function (a, b) {
      return a.height - b.height;
    });
  }function c(b, c) {
    if (!c || !c.documentElement) throw new Error(a.getString("Errors.Xml"));var e,
        f,
        g = c.documentElement,
        h = g.tagName,
        i = null,
        j = [];if ("image" == h) try {
      i = { type: g.getAttribute("type"), levels: [] };j = g.getElementsByTagName("level");for (f = 0; f < j.length; f++) {
        e = j[f];i.levels.push({ url: e.getAttribute("url"), width: parseInt(e.getAttribute("width"), 10), height: parseInt(e.getAttribute("height"), 10) });
      }return d(b, i);
    } catch (k) {
      throw k instanceof Error ? k : new Error("Unknown error parsing Legacy Image Pyramid XML.");
    } else {
      if ("collection" == h) throw new Error("Legacy Image Pyramid Collections not yet supported.");if ("error" == h) throw new Error("Error: " + c);
    }throw new Error("Unknown element " + h);
  }function d(a, b) {
    return b.levels;
  }a.LegacyTileSource = function (c) {
    var d, e, f;a.isArray(c) && (d = { type: "legacy-image-pyramid", levels: c });d.levels = b(d.levels);if (d.levels.length > 0) {
      e = d.levels[d.levels.length - 1].width;f = d.levels[d.levels.length - 1].height;
    } else {
      e = 0;f = 0;a.console.error("No supported image formats found");
    }a.extend(!0, d, { width: e, height: f, tileSize: Math.max(f, e), tileOverlap: 0, minLevel: 0, maxLevel: d.levels.length > 0 ? d.levels.length - 1 : 0 });a.TileSource.apply(this, [d]);this.levels = d.levels;
  };a.extend(a.LegacyTileSource.prototype, a.TileSource.prototype, { supports: function supports(a, b) {
      return a.type && "legacy-image-pyramid" == a.type || a.documentElement && "legacy-image-pyramid" == a.documentElement.getAttribute("type");
    }, configure: function configure(b, e) {
      var f;f = a.isPlainObject(b) ? d(this, b) : c(this, b);return f;
    }, getLevelScale: function getLevelScale(a) {
      var b = NaN;this.levels.length > 0 && a >= this.minLevel && a <= this.maxLevel && (b = this.levels[a].width / this.levels[this.maxLevel].width);return b;
    }, getNumTiles: function getNumTiles(b) {
      var c = this.getLevelScale(b);return c ? new a.Point(1, 1) : new a.Point(0, 0);
    }, getTileAtPoint: function getTileAtPoint(b, c) {
      return new a.Point(0, 0);
    }, getTileUrl: function getTileUrl(a, b, c) {
      var d = null;this.levels.length > 0 && a >= this.minLevel && a <= this.maxLevel && (d = this.levels[a].url);return d;
    } });
}(OpenSeadragon);!function (a) {
  a.ImageTileSource = function (b) {
    b = a.extend({ buildPyramid: !0, crossOriginPolicy: !1, ajaxWithCredentials: !1, useCanvas: !0 }, b);a.TileSource.apply(this, [b]);
  };a.extend(a.ImageTileSource.prototype, a.TileSource.prototype, { supports: function supports(a, b) {
      return a.type && "image" === a.type;
    }, configure: function configure(a, b) {
      return a;
    }, getImageInfo: function getImageInfo(b) {
      var c = this._image = new Image();var d = this;this.crossOriginPolicy && (c.crossOrigin = this.crossOriginPolicy);this.ajaxWithCredentials && (c.useCredentials = this.ajaxWithCredentials);a.addEvent(c, "load", function () {
        d.width = c.naturalWidth;d.height = c.naturalHeight;d.aspectRatio = d.width / d.height;d.dimensions = new a.Point(d.width, d.height);d._tileWidth = d.width;d._tileHeight = d.height;d.tileOverlap = 0;d.minLevel = 0;d.levels = d._buildLevels();d.maxLevel = d.levels.length - 1;d.ready = !0;d.raiseEvent("ready", { tileSource: d });
      });a.addEvent(c, "error", function () {
        d.raiseEvent("open-failed", { message: "Error loading image at " + b, source: b });
      });c.src = b;
    }, getLevelScale: function getLevelScale(a) {
      var b = NaN;a >= this.minLevel && a <= this.maxLevel && (b = this.levels[a].width / this.levels[this.maxLevel].width);return b;
    }, getNumTiles: function getNumTiles(b) {
      var c = this.getLevelScale(b);return c ? new a.Point(1, 1) : new a.Point(0, 0);
    }, getTileAtPoint: function getTileAtPoint(b, c) {
      return new a.Point(0, 0);
    }, getTileUrl: function getTileUrl(a, b, c) {
      var d = null;a >= this.minLevel && a <= this.maxLevel && (d = this.levels[a].url);return d;
    }, getContext2D: function getContext2D(a, b, c) {
      var d = null;a >= this.minLevel && a <= this.maxLevel && (d = this.levels[a].context2D);return d;
    }, _buildLevels: function _buildLevels() {
      var b = [{ url: this._image.src, width: this._image.naturalWidth, height: this._image.naturalHeight }];if (!this.buildPyramid || !a.supportsCanvas || !this.useCanvas) {
        delete this._image;return b;
      }var c = this._image.naturalWidth;var d = this._image.naturalHeight;var e = document.createElement("canvas");var f = e.getContext("2d");e.width = c;e.height = d;f.drawImage(this._image, 0, 0, c, d);b[0].context2D = f;delete this._image;if (a.isCanvasTainted(e)) return b;for (; c >= 2 && d >= 2;) {
        c = Math.floor(c / 2);d = Math.floor(d / 2);var g = document.createElement("canvas");var h = g.getContext("2d");g.width = c;g.height = d;h.drawImage(e, 0, 0, c, d);b.splice(0, 0, { context2D: h, width: c, height: d });e = g;f = h;
      }return b;
    } });
}(OpenSeadragon);!function (a) {
  a.TileSourceCollection = function (b, c, d, e) {
    a.console.error("TileSourceCollection is deprecated; use World instead");
  };
}(OpenSeadragon);!function (a) {
  function b(b) {
    a.requestAnimationFrame(function () {
      c(b);
    });
  }function c(c) {
    var d, e, f;if (c.shouldFade) {
      d = a.now();e = d - c.fadeBeginTime;f = 1 - e / c.fadeLength;f = Math.min(1, f);f = Math.max(0, f);c.imgGroup && a.setElementOpacity(c.imgGroup, f, !0);f > 0 && b(c);
    }
  }function d(c) {
    c.shouldFade = !0;c.fadeBeginTime = a.now() + c.fadeDelay;window.setTimeout(function () {
      b(c);
    }, c.fadeDelay);
  }function e(b) {
    b.shouldFade = !1;b.imgGroup && a.setElementOpacity(b.imgGroup, 1, !0);
  }function f(b, c) {
    if (!b.element.disabled) {
      if (c >= a.ButtonState.GROUP && b.currentState == a.ButtonState.REST) {
        e(b);b.currentState = a.ButtonState.GROUP;
      }if (c >= a.ButtonState.HOVER && b.currentState == a.ButtonState.GROUP) {
        b.imgHover && (b.imgHover.style.visibility = "");b.currentState = a.ButtonState.HOVER;
      }if (c >= a.ButtonState.DOWN && b.currentState == a.ButtonState.HOVER) {
        b.imgDown && (b.imgDown.style.visibility = "");b.currentState = a.ButtonState.DOWN;
      }
    }
  }function g(b, c) {
    if (!b.element.disabled) {
      if (c <= a.ButtonState.HOVER && b.currentState == a.ButtonState.DOWN) {
        b.imgDown && (b.imgDown.style.visibility = "hidden");b.currentState = a.ButtonState.HOVER;
      }if (c <= a.ButtonState.GROUP && b.currentState == a.ButtonState.HOVER) {
        b.imgHover && (b.imgHover.style.visibility = "hidden");b.currentState = a.ButtonState.GROUP;
      }if (c <= a.ButtonState.REST && b.currentState == a.ButtonState.GROUP) {
        d(b);b.currentState = a.ButtonState.REST;
      }
    }
  }a.ButtonState = { REST: 0, GROUP: 1, HOVER: 2, DOWN: 3 };a.Button = function (b) {
    var c = this;a.EventSource.call(this);a.extend(!0, this, { tooltip: null, srcRest: null, srcGroup: null, srcHover: null, srcDown: null, clickTimeThreshold: a.DEFAULT_SETTINGS.clickTimeThreshold, clickDistThreshold: a.DEFAULT_SETTINGS.clickDistThreshold, fadeDelay: 0, fadeLength: 2e3, onPress: null, onRelease: null, onClick: null, onEnter: null, onExit: null, onFocus: null, onBlur: null }, b);this.element = b.element || a.makeNeutralElement("div");if (!b.element) {
      this.imgRest = a.makeTransparentImage(this.srcRest);this.imgGroup = a.makeTransparentImage(this.srcGroup);this.imgHover = a.makeTransparentImage(this.srcHover);this.imgDown = a.makeTransparentImage(this.srcDown);this.imgRest.alt = this.imgGroup.alt = this.imgHover.alt = this.imgDown.alt = this.tooltip;this.element.style.position = "relative";a.setElementTouchActionNone(this.element);this.imgGroup.style.position = this.imgHover.style.position = this.imgDown.style.position = "absolute";this.imgGroup.style.top = this.imgHover.style.top = this.imgDown.style.top = "0px";this.imgGroup.style.left = this.imgHover.style.left = this.imgDown.style.left = "0px";this.imgHover.style.visibility = this.imgDown.style.visibility = "hidden";a.Browser.vendor == a.BROWSERS.FIREFOX && a.Browser.version < 3 && (this.imgGroup.style.top = this.imgHover.style.top = this.imgDown.style.top = "");this.element.appendChild(this.imgRest);this.element.appendChild(this.imgGroup);this.element.appendChild(this.imgHover);this.element.appendChild(this.imgDown);
    }this.addHandler("press", this.onPress);this.addHandler("release", this.onRelease);this.addHandler("click", this.onClick);this.addHandler("enter", this.onEnter);this.addHandler("exit", this.onExit);this.addHandler("focus", this.onFocus);this.addHandler("blur", this.onBlur);this.currentState = a.ButtonState.GROUP;this.fadeBeginTime = null;this.shouldFade = !1;this.element.style.display = "inline-block";this.element.style.position = "relative";this.element.title = this.tooltip;this.tracker = new a.MouseTracker({ element: this.element, clickTimeThreshold: this.clickTimeThreshold, clickDistThreshold: this.clickDistThreshold, enterHandler: function enterHandler(b) {
        if (b.insideElementPressed) {
          f(c, a.ButtonState.DOWN);c.raiseEvent("enter", { originalEvent: b.originalEvent });
        } else b.buttonDownAny || f(c, a.ButtonState.HOVER);
      }, focusHandler: function focusHandler(a) {
        this.enterHandler(a);c.raiseEvent("focus", { originalEvent: a.originalEvent });
      }, exitHandler: function exitHandler(b) {
        g(c, a.ButtonState.GROUP);b.insideElementPressed && c.raiseEvent("exit", { originalEvent: b.originalEvent });
      }, blurHandler: function blurHandler(a) {
        this.exitHandler(a);c.raiseEvent("blur", { originalEvent: a.originalEvent });
      }, pressHandler: function pressHandler(b) {
        f(c, a.ButtonState.DOWN);c.raiseEvent("press", { originalEvent: b.originalEvent });
      }, releaseHandler: function releaseHandler(b) {
        if (b.insideElementPressed && b.insideElementReleased) {
          g(c, a.ButtonState.HOVER);c.raiseEvent("release", { originalEvent: b.originalEvent });
        } else b.insideElementPressed ? g(c, a.ButtonState.GROUP) : f(c, a.ButtonState.HOVER);
      }, clickHandler: function clickHandler(a) {
        a.quick && c.raiseEvent("click", { originalEvent: a.originalEvent });
      }, keyHandler: function keyHandler(a) {
        if (13 === a.keyCode) {
          c.raiseEvent("click", { originalEvent: a.originalEvent });c.raiseEvent("release", { originalEvent: a.originalEvent });return !1;
        }return !0;
      } });g(this, a.ButtonState.REST);
  };a.extend(a.Button.prototype, a.EventSource.prototype, { notifyGroupEnter: function notifyGroupEnter() {
      f(this, a.ButtonState.GROUP);
    }, notifyGroupExit: function notifyGroupExit() {
      g(this, a.ButtonState.REST);
    }, disable: function disable() {
      this.notifyGroupExit();this.element.disabled = !0;a.setElementOpacity(this.element, .2, !0);
    }, enable: function enable() {
      this.element.disabled = !1;a.setElementOpacity(this.element, 1, !0);this.notifyGroupEnter();
    } });
}(OpenSeadragon);!function (a) {
  a.ButtonGroup = function (b) {
    a.extend(!0, this, { buttons: [], clickTimeThreshold: a.DEFAULT_SETTINGS.clickTimeThreshold, clickDistThreshold: a.DEFAULT_SETTINGS.clickDistThreshold, labelText: "" }, b);var c,
        d = this.buttons.concat([]),
        e = this;this.element = b.element || a.makeNeutralElement("div");if (!b.group) {
      this.label = a.makeNeutralElement("label");this.element.style.display = "inline-block";this.element.appendChild(this.label);for (c = 0; c < d.length; c++) {
        this.element.appendChild(d[c].element);
      }
    }a.setElementTouchActionNone(this.element);this.tracker = new a.MouseTracker({ element: this.element, clickTimeThreshold: this.clickTimeThreshold, clickDistThreshold: this.clickDistThreshold, enterHandler: function enterHandler(a) {
        var b;for (b = 0; b < e.buttons.length; b++) {
          e.buttons[b].notifyGroupEnter();
        }
      }, exitHandler: function exitHandler(a) {
        var b;if (!a.insideElementPressed) for (b = 0; b < e.buttons.length; b++) {
          e.buttons[b].notifyGroupExit();
        }
      } });
  };a.ButtonGroup.prototype = { emulateEnter: function emulateEnter() {
      this.tracker.enterHandler({ eventSource: this.tracker });
    }, emulateExit: function emulateExit() {
      this.tracker.exitHandler({ eventSource: this.tracker });
    } };
}(OpenSeadragon);!function (a) {
  a.Rect = function (a, b, c, d, e) {
    this.x = "number" == typeof a ? a : 0;this.y = "number" == typeof b ? b : 0;this.width = "number" == typeof c ? c : 0;this.height = "number" == typeof d ? d : 0;this.degrees = "number" == typeof e ? e : 0;this.degrees = this.degrees % 360;this.degrees < 0 && (this.degrees += 360);var f, g;if (this.degrees >= 270) {
      f = this.getTopRight();this.x = f.x;this.y = f.y;g = this.height;this.height = this.width;this.width = g;this.degrees -= 270;
    } else if (this.degrees >= 180) {
      f = this.getBottomRight();this.x = f.x;this.y = f.y;this.degrees -= 180;
    } else if (this.degrees >= 90) {
      f = this.getBottomLeft();this.x = f.x;this.y = f.y;g = this.height;this.height = this.width;this.width = g;this.degrees -= 90;
    }
  };a.Rect.fromSummits = function (b, c, d) {
    var e = b.distanceTo(c);var f = b.distanceTo(d);var g = c.minus(b);var h = Math.atan(g.y / g.x);g.x < 0 ? h += Math.PI : g.y < 0 && (h += 2 * Math.PI);return new a.Rect(b.x, b.y, e, f, h / Math.PI * 180);
  };a.Rect.prototype = { clone: function clone() {
      return new a.Rect(this.x, this.y, this.width, this.height, this.degrees);
    }, getAspectRatio: function getAspectRatio() {
      return this.width / this.height;
    }, getTopLeft: function getTopLeft() {
      return new a.Point(this.x, this.y);
    }, getBottomRight: function getBottomRight() {
      return new a.Point(this.x + this.width, this.y + this.height).rotate(this.degrees, this.getTopLeft());
    }, getTopRight: function getTopRight() {
      return new a.Point(this.x + this.width, this.y).rotate(this.degrees, this.getTopLeft());
    }, getBottomLeft: function getBottomLeft() {
      return new a.Point(this.x, this.y + this.height).rotate(this.degrees, this.getTopLeft());
    }, getCenter: function getCenter() {
      return new a.Point(this.x + this.width / 2, this.y + this.height / 2).rotate(this.degrees, this.getTopLeft());
    }, getSize: function getSize() {
      return new a.Point(this.width, this.height);
    }, equals: function equals(b) {
      return b instanceof a.Rect && this.x === b.x && this.y === b.y && this.width === b.width && this.height === b.height && this.degrees === b.degrees;
    }, times: function times(b) {
      return new a.Rect(this.x * b, this.y * b, this.width * b, this.height * b, this.degrees);
    }, translate: function translate(b) {
      return new a.Rect(this.x + b.x, this.y + b.y, this.width, this.height, this.degrees);
    }, union: function union(b) {
      var c = this.getBoundingBox();var d = b.getBoundingBox();var e = Math.min(c.x, d.x);var f = Math.min(c.y, d.y);var g = Math.max(c.x + c.width, d.x + d.width);var h = Math.max(c.y + c.height, d.y + d.height);return new a.Rect(e, f, g - e, h - f);
    }, intersection: function intersection(b) {
      function c(b, c, e, f) {
        var g = c.minus(b);var h = f.minus(e);var i = -h.x * g.y + g.x * h.y;if (0 === i) return null;var j = (g.x * (b.y - e.y) - g.y * (b.x - e.x)) / i;var k = (h.x * (b.y - e.y) - h.y * (b.x - e.x)) / i;return j >= -d && 1 - d >= j && k >= -d && 1 - d >= k ? new a.Point(b.x + k * g.x, b.y + k * g.y) : null;
      }var d = 1e-10;var e = [];var f = this.getTopLeft();b.containsPoint(f, d) && e.push(f);var g = this.getTopRight();b.containsPoint(g, d) && e.push(g);var h = this.getBottomLeft();b.containsPoint(h, d) && e.push(h);var i = this.getBottomRight();b.containsPoint(i, d) && e.push(i);var j = b.getTopLeft();this.containsPoint(j, d) && e.push(j);var k = b.getTopRight();this.containsPoint(k, d) && e.push(k);var l = b.getBottomLeft();this.containsPoint(l, d) && e.push(l);var m = b.getBottomRight();this.containsPoint(m, d) && e.push(m);var n = this._getSegments();var o = b._getSegments();for (var p = 0; p < n.length; p++) {
        var q = n[p];for (var r = 0; r < o.length; r++) {
          var s = o[r];var t = c(q[0], q[1], s[0], s[1]);t && e.push(t);
        }
      }if (0 === e.length) return null;var u = e[0].x;var v = e[0].x;var w = e[0].y;var x = e[0].y;for (var y = 1; y < e.length; y++) {
        var z = e[y];z.x < u && (u = z.x);z.x > v && (v = z.x);z.y < w && (w = z.y);z.y > x && (x = z.y);
      }return new a.Rect(u, w, v - u, x - w);
    }, _getSegments: function _getSegments() {
      var a = this.getTopLeft();var b = this.getTopRight();var c = this.getBottomLeft();var d = this.getBottomRight();return [[a, b], [b, d], [d, c], [c, a]];
    }, rotate: function rotate(b, c) {
      b %= 360;if (0 === b) return this.clone();0 > b && (b += 360);c = c || this.getCenter();var d = this.getTopLeft().rotate(b, c);var e = this.getTopRight().rotate(b, c);var f = e.minus(d);var g = Math.atan(f.y / f.x);f.x < 0 ? g += Math.PI : f.y < 0 && (g += 2 * Math.PI);return new a.Rect(d.x, d.y, this.width, this.height, g / Math.PI * 180);
    }, getBoundingBox: function getBoundingBox() {
      if (0 === this.degrees) return this.clone();var b = this.getTopLeft();var c = this.getTopRight();var d = this.getBottomLeft();var e = this.getBottomRight();var f = Math.min(b.x, c.x, d.x, e.x);var g = Math.max(b.x, c.x, d.x, e.x);var h = Math.min(b.y, c.y, d.y, e.y);var i = Math.max(b.y, c.y, d.y, e.y);return new a.Rect(f, h, g - f, i - h);
    }, getIntegerBoundingBox: function getIntegerBoundingBox() {
      var b = this.getBoundingBox();var c = Math.floor(b.x);var d = Math.floor(b.y);var e = Math.ceil(b.width + b.x - c);var f = Math.ceil(b.height + b.y - d);return new a.Rect(c, d, e, f);
    }, containsPoint: function containsPoint(a, b) {
      b = b || 0;var c = this.getTopLeft();var d = this.getTopRight();var e = this.getBottomLeft();var f = d.minus(c);var g = e.minus(c);return (a.x - c.x) * f.x + (a.y - c.y) * f.y >= -b && (a.x - d.x) * f.x + (a.y - d.y) * f.y <= b && (a.x - c.x) * g.x + (a.y - c.y) * g.y >= -b && (a.x - e.x) * g.x + (a.y - e.y) * g.y <= b;
    }, toString: function toString() {
      return "[" + Math.round(100 * this.x) / 100 + ", " + Math.round(100 * this.y) / 100 + ", " + Math.round(100 * this.width) / 100 + "x" + Math.round(100 * this.height) / 100 + ", " + Math.round(100 * this.degrees) / 100 + "deg]";
    } };
}(OpenSeadragon);!function (a) {
  function b(b) {
    var c = Number(this.element.style.marginLeft.replace("px", "")),
        e = Number(this.element.style.marginTop.replace("px", "")),
        f = Number(this.element.style.width.replace("px", "")),
        g = Number(this.element.style.height.replace("px", "")),
        h = a.getElementSize(this.viewer.canvas);this.dragging = !0;if (this.element) if ("horizontal" == this.scroll) {
      if (-b.delta.x > 0) {
        if (c > -(f - h.x)) {
          this.element.style.marginLeft = c + 2 * b.delta.x + "px";d(this, h.x, c + 2 * b.delta.x);
        }
      } else if (-b.delta.x < 0 && 0 > c) {
        this.element.style.marginLeft = c + 2 * b.delta.x + "px";d(this, h.x, c + 2 * b.delta.x);
      }
    } else if (-b.delta.y > 0) {
      if (e > -(g - h.y)) {
        this.element.style.marginTop = e + 2 * b.delta.y + "px";d(this, h.y, e + 2 * b.delta.y);
      }
    } else if (-b.delta.y < 0 && 0 > e) {
      this.element.style.marginTop = e + 2 * b.delta.y + "px";d(this, h.y, e + 2 * b.delta.y);
    }return !1;
  }function c(b) {
    var c = Number(this.element.style.marginLeft.replace("px", "")),
        e = Number(this.element.style.marginTop.replace("px", "")),
        f = Number(this.element.style.width.replace("px", "")),
        g = Number(this.element.style.height.replace("px", "")),
        h = a.getElementSize(this.viewer.canvas);if (this.element) if ("horizontal" == this.scroll) {
      if (b.scroll > 0) {
        if (c > -(f - h.x)) {
          this.element.style.marginLeft = c - 60 * b.scroll + "px";d(this, h.x, c - 60 * b.scroll);
        }
      } else if (b.scroll < 0 && 0 > c) {
        this.element.style.marginLeft = c - 60 * b.scroll + "px";d(this, h.x, c - 60 * b.scroll);
      }
    } else if (b.scroll < 0) {
      if (e > h.y - g) {
        this.element.style.marginTop = e + 60 * b.scroll + "px";d(this, h.y, e + 60 * b.scroll);
      }
    } else if (b.scroll > 0 && 0 > e) {
      this.element.style.marginTop = e + 60 * b.scroll + "px";d(this, h.y, e + 60 * b.scroll);
    }return !1;
  }function d(b, c, d) {
    var e, f, g, h, i, j, k;e = "horizontal" == b.scroll ? b.panelWidth : b.panelHeight;f = Math.ceil(c / e) + 5;g = Math.ceil((Math.abs(d) + c) / e) + 1;f = g - f;f = 0 > f ? 0 : f;for (j = f; g > j && j < b.panels.length; j++) {
      k = b.panels[j];if (!k.activePanel) {
        h = new a.Viewer({ id: k.id, tileSources: [b.viewer.tileSources[j]], element: k, navigatorSizeRatio: b.sizeRatio, showNavigator: !1, mouseNavEnabled: !1, showNavigationControl: !1, showSequenceControl: !1, immediateRender: !0, blendTime: 0, animationTime: 0 });h.displayRegion = a.makeNeutralElement("div");h.displayRegion.id = k.id + "-displayregion";h.displayRegion.className = "displayregion";i = h.displayRegion.style;i.position = "relative";i.top = "0px";i.left = "0px";i.fontSize = "0px";i.overflow = "hidden";i["float"] = "left";i.cssFloat = "left";i.styleFloat = "left";i.zIndex = 999999999;i.cursor = "default";i.width = b.panelWidth - 4 + "px";i.height = b.panelHeight - 4 + "px";h.displayRegion.innerTracker = new a.MouseTracker({ element: h.displayRegion, startDisabled: !0 });k.getElementsByTagName("div")[0].appendChild(h.displayRegion);k.activePanel = !0;
      }
    }
  }function e(a) {
    var b = a.eventSource.element;"horizontal" == this.scroll ? b.style.marginBottom = "0px" : b.style.marginLeft = "0px";return !1;
  }function f(b) {
    var c = b.eventSource.element;"horizontal" == this.scroll ? c.style.marginBottom = "-" + a.getElementSize(c).y / 2 + "px" : c.style.marginLeft = "-" + a.getElementSize(c).x / 2 + "px";return !1;
  }function g(a) {
    if (a.preventDefaultAction || a.ctrl || a.alt || a.meta) return !0;switch (a.keyCode) {case 38:
        c.call(this, { eventSource: this.tracker, position: null, scroll: 1, shift: null });return !1;case 40:
        c.call(this, { eventSource: this.tracker, position: null, scroll: -1, shift: null });return !1;case 37:
        c.call(this, { eventSource: this.tracker, position: null, scroll: -1, shift: null });return !1;case 39:
        c.call(this, { eventSource: this.tracker, position: null, scroll: 1, shift: null });return !1;default:
        return !0;}
  }function h(a) {
    if (a.preventDefaultAction || a.ctrl || a.alt || a.meta) return !0;switch (a.keyCode) {case 61:
        c.call(this, { eventSource: this.tracker, position: null, scroll: 1, shift: null });return !1;case 45:
        c.call(this, { eventSource: this.tracker, position: null, scroll: -1, shift: null });return !1;case 48:case 119:case 87:
        c.call(this, { eventSource: this.tracker, position: null, scroll: 1, shift: null });return !1;case 115:case 83:
        c.call(this, { eventSource: this.tracker, position: null, scroll: -1, shift: null });return !1;case 97:
        c.call(this, { eventSource: this.tracker, position: null, scroll: -1, shift: null });return !1;case 100:
        c.call(this, { eventSource: this.tracker, position: null, scroll: 1, shift: null });return !1;default:
        return !0;}
  }var i = {};a.ReferenceStrip = function (j) {
    var k,
        l,
        m,
        n = this,
        o = j.viewer,
        p = a.getElementSize(o.element);if (!j.id) {
      j.id = "referencestrip-" + a.now();this.element = a.makeNeutralElement("div");this.element.id = j.id;this.element.className = "referencestrip";
    }j = a.extend(!0, { sizeRatio: a.DEFAULT_SETTINGS.referenceStripSizeRatio, position: a.DEFAULT_SETTINGS.referenceStripPosition, scroll: a.DEFAULT_SETTINGS.referenceStripScroll, clickTimeThreshold: a.DEFAULT_SETTINGS.clickTimeThreshold }, j, { element: this.element, showNavigator: !1, mouseNavEnabled: !1, showNavigationControl: !1, showSequenceControl: !1 });a.extend(this, j);i[this.id] = { animating: !1 };this.minPixelRatio = this.viewer.minPixelRatio;l = this.element.style;l.marginTop = "0px";l.marginRight = "0px";l.marginBottom = "0px";l.marginLeft = "0px";l.left = "0px";l.bottom = "0px";l.border = "0px";l.background = "#000";l.position = "relative";a.setElementTouchActionNone(this.element);a.setElementOpacity(this.element, .8);this.viewer = o;this.innerTracker = new a.MouseTracker({ element: this.element, dragHandler: a.delegate(this, b), scrollHandler: a.delegate(this, c), enterHandler: a.delegate(this, e), exitHandler: a.delegate(this, f), keyDownHandler: a.delegate(this, g), keyHandler: a.delegate(this, h) });if (j.width && j.height) {
      this.element.style.width = j.width + "px";this.element.style.height = j.height + "px";o.addControl(this.element, { anchor: a.ControlAnchor.BOTTOM_LEFT });
    } else if ("horizontal" == j.scroll) {
      this.element.style.width = p.x * j.sizeRatio * o.tileSources.length + 12 * o.tileSources.length + "px";this.element.style.height = p.y * j.sizeRatio + "px";o.addControl(this.element, { anchor: a.ControlAnchor.BOTTOM_LEFT });
    } else {
      this.element.style.height = p.y * j.sizeRatio * o.tileSources.length + 12 * o.tileSources.length + "px";this.element.style.width = p.x * j.sizeRatio + "px";o.addControl(this.element, { anchor: a.ControlAnchor.TOP_LEFT });
    }this.panelWidth = p.x * this.sizeRatio + 8;this.panelHeight = p.y * this.sizeRatio + 8;this.panels = [];for (m = 0; m < o.tileSources.length; m++) {
      k = a.makeNeutralElement("div");k.id = this.element.id + "-" + m;k.style.width = n.panelWidth + "px";k.style.height = n.panelHeight + "px";k.style.display = "inline";k.style["float"] = "left";k.style.cssFloat = "left";k.style.styleFloat = "left";k.style.padding = "2px";a.setElementTouchActionNone(k);k.innerTracker = new a.MouseTracker({ element: k, clickTimeThreshold: this.clickTimeThreshold, clickDistThreshold: this.clickDistThreshold, pressHandler: function pressHandler(b) {
          b.eventSource.dragging = a.now();
        }, releaseHandler: function releaseHandler(b) {
          var c = b.eventSource,
              d = c.element.id,
              e = Number(d.split("-")[2]),
              f = a.now();if (b.insideElementPressed && b.insideElementReleased && c.dragging && f - c.dragging < c.clickTimeThreshold) {
            c.dragging = null;o.goToPage(e);
          }
        } });this.element.appendChild(k);k.activePanel = !1;this.panels.push(k);
    }d(this, "vertical" == this.scroll ? p.y : p.x, 0);this.setFocus(0);
  };a.extend(a.ReferenceStrip.prototype, a.EventSource.prototype, a.Viewer.prototype, { setFocus: function setFocus(b) {
      var c,
          f = a.getElement(this.element.id + "-" + b),
          g = a.getElementSize(this.viewer.canvas),
          h = Number(this.element.style.width.replace("px", "")),
          i = Number(this.element.style.height.replace("px", "")),
          j = -Number(this.element.style.marginLeft.replace("px", "")),
          k = -Number(this.element.style.marginTop.replace("px", ""));if (this.currentSelected !== f) {
        this.currentSelected && (this.currentSelected.style.background = "#000");this.currentSelected = f;this.currentSelected.style.background = "#999";if ("horizontal" == this.scroll) {
          c = Number(b) * (this.panelWidth + 3);if (c > j + g.x - this.panelWidth) {
            c = Math.min(c, h - g.x);this.element.style.marginLeft = -c + "px";d(this, g.x, -c);
          } else if (j > c) {
            c = Math.max(0, c - g.x / 2);this.element.style.marginLeft = -c + "px";d(this, g.x, -c);
          }
        } else {
          c = Number(b) * (this.panelHeight + 3);if (c > k + g.y - this.panelHeight) {
            c = Math.min(c, i - g.y);this.element.style.marginTop = -c + "px";d(this, g.y, -c);
          } else if (k > c) {
            c = Math.max(0, c - g.y / 2);this.element.style.marginTop = -c + "px";d(this, g.y, -c);
          }
        }this.currentPage = b;e.call(this, { eventSource: this.innerTracker });
      }
    }, update: function update() {
      if (i[this.id].animating) {
        a.console.log("image reference strip update");return !0;
      }return !1;
    }, destroy: function destroy() {
      this.element && this.element.parentNode.removeChild(this.element);
    } });
}(OpenSeadragon);!function (a) {
  a.DisplayRect = function (b, c, d, e, f, g) {
    a.Rect.apply(this, [b, c, d, e]);this.minLevel = f;this.maxLevel = g;
  };a.extend(a.DisplayRect.prototype, a.Rect.prototype);
}(OpenSeadragon);!function (a) {
  function b(a, b) {
    return (1 - Math.exp(a * -b)) / (1 - Math.exp(-a));
  }a.Spring = function (b) {
    var c = arguments;"object" != (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(b)) && (b = { initial: c.length && "number" == typeof c[0] ? c[0] : void 0, springStiffness: c.length > 1 ? c[1].springStiffness : 5, animationTime: c.length > 1 ? c[1].animationTime : 1.5 });a.console.assert("number" == typeof b.springStiffness && 0 !== b.springStiffness, "[OpenSeadragon.Spring] options.springStiffness must be a non-zero number");a.console.assert("number" == typeof b.animationTime && b.animationTime >= 0, "[OpenSeadragon.Spring] options.animationTime must be a number greater than or equal to 0");if (b.exponential) {
      this._exponential = !0;delete b.exponential;
    }a.extend(!0, this, b);this.current = { value: "number" == typeof this.initial ? this.initial : this._exponential ? 0 : 1, time: a.now() };a.console.assert(!this._exponential || 0 !== this.current.value, "[OpenSeadragon.Spring] value must be non-zero for exponential springs");this.start = { value: this.current.value, time: this.current.time };this.target = { value: this.current.value, time: this.current.time };if (this._exponential) {
      this.start._logValue = Math.log(this.start.value);this.target._logValue = Math.log(this.target.value);this.current._logValue = Math.log(this.current.value);
    }
  };a.Spring.prototype = { resetTo: function resetTo(b) {
      a.console.assert(!this._exponential || 0 !== b, "[OpenSeadragon.Spring.resetTo] target must be non-zero for exponential springs");this.start.value = this.target.value = this.current.value = b;this.start.time = this.target.time = this.current.time = a.now();if (this._exponential) {
        this.start._logValue = Math.log(this.start.value);this.target._logValue = Math.log(this.target.value);this.current._logValue = Math.log(this.current.value);
      }
    }, springTo: function springTo(b) {
      a.console.assert(!this._exponential || 0 !== b, "[OpenSeadragon.Spring.springTo] target must be non-zero for exponential springs");this.start.value = this.current.value;this.start.time = this.current.time;this.target.value = b;this.target.time = this.start.time + 1e3 * this.animationTime;if (this._exponential) {
        this.start._logValue = Math.log(this.start.value);this.target._logValue = Math.log(this.target.value);
      }
    }, shiftBy: function shiftBy(b) {
      this.start.value += b;this.target.value += b;if (this._exponential) {
        a.console.assert(0 !== this.target.value && 0 !== this.start.value, "[OpenSeadragon.Spring.shiftBy] spring value must be non-zero for exponential springs");this.start._logValue = Math.log(this.start.value);this.target._logValue = Math.log(this.target.value);
      }
    }, setExponential: function setExponential(b) {
      this._exponential = b;if (this._exponential) {
        a.console.assert(0 !== this.current.value && 0 !== this.target.value && 0 !== this.start.value, "[OpenSeadragon.Spring.setExponential] spring value must be non-zero for exponential springs");this.start._logValue = Math.log(this.start.value);this.target._logValue = Math.log(this.target.value);this.current._logValue = Math.log(this.current.value);
      }
    }, update: function update() {
      this.current.time = a.now();var c, d;if (this._exponential) {
        c = this.start._logValue;d = this.target._logValue;
      } else {
        c = this.start.value;d = this.target.value;
      }var e = this.current.time >= this.target.time ? d : c + (d - c) * b(this.springStiffness, (this.current.time - this.start.time) / (this.target.time - this.start.time));this._exponential ? this.current.value = Math.exp(e) : this.current.value = e;
    }, isAtTargetValue: function isAtTargetValue() {
      return this.current.value === this.target.value;
    } };
}(OpenSeadragon);!function (a) {
  function b(b) {
    a.extend(!0, this, { timeout: a.DEFAULT_SETTINGS.timeout, jobId: null }, b);this.image = null;
  }function c(a, b, c) {
    var d;a.jobsInProgress--;if ((!a.jobLimit || a.jobsInProgress < a.jobLimit) && a.jobQueue.length > 0) {
      d = a.jobQueue.shift();d.start();a.jobsInProgress++;
    }c(b.image, b.errorMsg);
  }b.prototype = { errorMsg: null, start: function start() {
      var a = this;this.image = new Image();this.crossOriginPolicy !== !1 && (this.image.crossOrigin = this.crossOriginPolicy);this.image.onload = function () {
        a.finish(!0);
      };this.image.onabort = this.image.onerror = function () {
        a.errorMsg = "Image load aborted";a.finish(!1);
      };this.jobId = window.setTimeout(function () {
        a.errorMsg = "Image load exceeded timeout";a.finish(!1);
      }, this.timeout);this.image.src = this.src;
    }, finish: function finish(a) {
      this.image.onload = this.image.onerror = this.image.onabort = null;a || (this.image = null);this.jobId && window.clearTimeout(this.jobId);this.callback(this);
    } };a.ImageLoader = function (b) {
    a.extend(!0, this, { jobLimit: a.DEFAULT_SETTINGS.imageLoaderLimit, jobQueue: [], jobsInProgress: 0 }, b);
  };a.ImageLoader.prototype = { addJob: function addJob(a) {
      var d = this,
          e = function e(b) {
        c(d, b, a.callback);
      },
          f = { src: a.src, crossOriginPolicy: a.crossOriginPolicy, callback: e, abort: a.abort },
          g = new b(f);if (!this.jobLimit || this.jobsInProgress < this.jobLimit) {
        g.start();this.jobsInProgress++;
      } else this.jobQueue.push(g);
    }, clear: function clear() {
      for (var a = 0; a < this.jobQueue.length; a++) {
        var b = this.jobQueue[a];"function" == typeof b.abort && b.abort();
      }this.jobQueue = [];
    } };
}(OpenSeadragon);!function (a) {
  a.Tile = function (a, b, c, d, e, f, g) {
    this.level = a;this.x = b;this.y = c;this.bounds = d;this.exists = e;this.url = f;this.context2D = g;this.loaded = !1;this.loading = !1;this.element = null;this.imgElement = null;this.image = null;this.style = null;this.position = null;this.size = null;this.blendStart = null;this.opacity = null;this.distance = null;this.visibility = null;this.beingDrawn = !1;this.lastTouchTime = 0;
  };a.Tile.prototype = { toString: function toString() {
      return this.level + "/" + this.x + "_" + this.y;
    }, _hasTransparencyChannel: function _hasTransparencyChannel() {
      return !!this.context2D || this.url.match(".png");
    }, drawHTML: function drawHTML(b) {
      if (this.cacheImageRecord) {
        if (this.loaded) {
          if (!this.element) {
            this.element = a.makeNeutralElement("div");this.imgElement = this.cacheImageRecord.getImage().cloneNode();this.imgElement.style.msInterpolationMode = "nearest-neighbor";this.imgElement.style.width = "100%";this.imgElement.style.height = "100%";this.style = this.element.style;this.style.position = "absolute";
          }this.element.parentNode != b && b.appendChild(this.element);this.imgElement.parentNode != this.element && this.element.appendChild(this.imgElement);this.style.top = this.position.y + "px";this.style.left = this.position.x + "px";this.style.height = this.size.y + "px";this.style.width = this.size.x + "px";a.setElementOpacity(this.element, this.opacity);
        } else a.console.warn("Attempting to draw tile %s when it's not yet loaded.", this.toString());
      } else a.console.warn("[Tile.drawHTML] attempting to draw tile %s when it's not cached", this.toString());
    }, drawCanvas: function drawCanvas(b, c, d, e) {
      var f,
          g = this.position.times(a.pixelDensityRatio),
          h = this.size.times(a.pixelDensityRatio);if (this.context2D || this.cacheImageRecord) {
        f = this.context2D || this.cacheImageRecord.getRenderedContext();if (this.loaded && f) {
          b.save();b.globalAlpha = this.opacity;if ("number" == typeof d && 1 !== d) {
            g = g.times(d);h = h.times(d);
          }e instanceof a.Point && (g = g.plus(e));1 === b.globalAlpha && this._hasTransparencyChannel() && b.clearRect(g.x + 1, g.y + 1, h.x - 2, h.y - 2);c({ context: b, tile: this, rendered: f });b.drawImage(f.canvas, 0, 0, f.canvas.width, f.canvas.height, g.x, g.y, h.x, h.y);b.restore();
        } else a.console.warn("Attempting to draw tile %s when it's not yet loaded.", this.toString());
      } else a.console.warn("[Tile.drawCanvas] attempting to draw tile %s when it's not cached", this.toString());
    }, getScaleForEdgeSmoothing: function getScaleForEdgeSmoothing() {
      var b;if (this.cacheImageRecord) b = this.cacheImageRecord.getRenderedContext();else {
        if (!this.context2D) {
          a.console.warn("[Tile.drawCanvas] attempting to get tile scale %s when tile's not cached", this.toString());return 1;
        }b = this.context2D;
      }return b.canvas.width / (this.size.x * a.pixelDensityRatio);
    }, getTranslationForEdgeSmoothing: function getTranslationForEdgeSmoothing(b, c, d) {
      var e = Math.max(1, Math.ceil((d.x - c.x) / 2));var f = Math.max(1, Math.ceil((d.y - c.y) / 2));return new a.Point(e, f).minus(this.position.times(a.pixelDensityRatio).times(b || 1).apply(function (a) {
        return a % 1;
      }));
    }, unload: function unload() {
      this.imgElement && this.imgElement.parentNode && this.imgElement.parentNode.removeChild(this.imgElement);this.element && this.element.parentNode && this.element.parentNode.removeChild(this.element);this.element = null;this.imgElement = null;this.loaded = !1;this.loading = !1;
    } };
}(OpenSeadragon);!function (a) {
  a.OverlayPlacement = a.Placement;a.OverlayRotationMode = a.freezeObject({ NO_ROTATION: 1, EXACT: 2, BOUNDING_BOX: 3 });a.Overlay = function (b, c, d) {
    var e;e = a.isPlainObject(b) ? b : { element: b, location: c, placement: d };this.element = e.element;this.style = e.element.style;this._init(e);
  };a.Overlay.prototype = { _init: function _init(b) {
      this.location = b.location;this.placement = void 0 === b.placement ? a.Placement.TOP_LEFT : b.placement;this.onDraw = b.onDraw;this.checkResize = void 0 === b.checkResize ? !0 : b.checkResize;this.width = void 0 === b.width ? null : b.width;this.height = void 0 === b.height ? null : b.height;this.rotationMode = b.rotationMode || a.OverlayRotationMode.EXACT;if (this.location instanceof a.Rect) {
        this.width = this.location.width;this.height = this.location.height;this.location = this.location.getTopLeft();this.placement = a.Placement.TOP_LEFT;
      }this.scales = null !== this.width && null !== this.height;this.bounds = new a.Rect(this.location.x, this.location.y, this.width, this.height);this.position = this.location;
    }, adjust: function adjust(b, c) {
      var d = a.Placement.properties[this.placement];if (d) {
        d.isHorizontallyCentered ? b.x -= c.x / 2 : d.isRight && (b.x -= c.x);d.isVerticallyCentered ? b.y -= c.y / 2 : d.isBottom && (b.y -= c.y);
      }
    }, destroy: function destroy() {
      var b = this.element;var c = this.style;if (b.parentNode) {
        b.parentNode.removeChild(b);if (b.prevElementParent) {
          c.display = "none";document.body.appendChild(b);
        }
      }this.onDraw = null;c.top = "";c.left = "";c.position = "";null !== this.width && (c.width = "");null !== this.height && (c.height = "");var d = a.getCssPropertyWithVendorPrefix("transformOrigin");var e = a.getCssPropertyWithVendorPrefix("transform");if (d && e) {
        c[d] = "";c[e] = "";
      }
    }, drawHTML: function drawHTML(b, c) {
      var d = this.element;if (d.parentNode !== b) {
        d.prevElementParent = d.parentNode;d.prevNextSibling = d.nextSibling;b.appendChild(d);this.size = a.getElementSize(d);
      }var e = this._getOverlayPositionAndSize(c);var f = e.position;var g = this.size = e.size;var h = e.rotate;if (this.onDraw) this.onDraw(f, g, this.element);else {
        var i = this.style;i.left = f.x + "px";i.top = f.y + "px";null !== this.width && (i.width = g.x + "px");null !== this.height && (i.height = g.y + "px");var j = a.getCssPropertyWithVendorPrefix("transformOrigin");var k = a.getCssPropertyWithVendorPrefix("transform");if (j && k) if (h) {
          i[j] = this._getTransformOrigin();i[k] = "rotate(" + h + "deg)";
        } else {
          i[j] = "";i[k] = "";
        }i.position = "absolute";"none" !== i.display && (i.display = "block");
      }
    }, _getOverlayPositionAndSize: function _getOverlayPositionAndSize(b) {
      var c = b.pixelFromPoint(this.location, !0);var d = this._getSizeInPixels(b);this.adjust(c, d);var e = 0;if (b.degrees && this.rotationMode !== a.OverlayRotationMode.NO_ROTATION) if (this.rotationMode === a.OverlayRotationMode.BOUNDING_BOX && null !== this.width && null !== this.height) {
        var f = new a.Rect(c.x, c.y, d.x, d.y);var g = this._getBoundingBox(f, b.degrees);c = g.getTopLeft();d = g.getSize();
      } else e = b.degrees;return { position: c, size: d, rotate: e };
    }, _getSizeInPixels: function _getSizeInPixels(b) {
      var c = this.size.x;var d = this.size.y;if (null !== this.width || null !== this.height) {
        var e = b.deltaPixelsFromPointsNoRotate(new a.Point(this.width || 0, this.height || 0), !0);null !== this.width && (c = e.x);null !== this.height && (d = e.y);
      }if (this.checkResize && (null === this.width || null === this.height)) {
        var f = this.size = a.getElementSize(this.element);null === this.width && (c = f.x);null === this.height && (d = f.y);
      }return new a.Point(c, d);
    }, _getBoundingBox: function _getBoundingBox(a, b) {
      var c = this._getPlacementPoint(a);return a.rotate(b, c).getBoundingBox();
    }, _getPlacementPoint: function _getPlacementPoint(b) {
      var c = new a.Point(b.x, b.y);var d = a.Placement.properties[this.placement];if (d) {
        d.isHorizontallyCentered ? c.x += b.width / 2 : d.isRight && (c.x += b.width);d.isVerticallyCentered ? c.y += b.height / 2 : d.isBottom && (c.y += b.height);
      }return c;
    }, _getTransformOrigin: function _getTransformOrigin() {
      var b = "";var c = a.Placement.properties[this.placement];if (!c) return b;c.isLeft ? b = "left" : c.isRight && (b = "right");c.isTop ? b += " top" : c.isBottom && (b += " bottom");return b;
    }, update: function update(b, c) {
      var d = a.isPlainObject(b) ? b : { location: b, placement: c };this._init({ location: d.location || this.location, placement: void 0 !== d.placement ? d.placement : this.placement, onDraw: d.onDraw || this.onDraw, checkResize: d.checkResize || this.checkResize, width: void 0 !== d.width ? d.width : this.width, height: void 0 !== d.height ? d.height : this.height, rotationMode: d.rotationMode || this.rotationMode });
    }, getBounds: function getBounds(b) {
      a.console.assert(b, "A viewport must now be passed to Overlay.getBounds.");var c = this.width;var d = this.height;if (null === c || null === d) {
        var e = b.deltaPointsFromPixelsNoRotate(this.size, !0);null === c && (c = e.x);null === d && (d = e.y);
      }var f = this.location.clone();this.adjust(f, new a.Point(c, d));return this._adjustBoundsForRotation(b, new a.Rect(f.x, f.y, c, d));
    }, _adjustBoundsForRotation: function _adjustBoundsForRotation(b, c) {
      if (!b || 0 === b.degrees || this.rotationMode === a.OverlayRotationMode.EXACT) return c;if (this.rotationMode === a.OverlayRotationMode.BOUNDING_BOX) {
        if (null === this.width || null === this.height) return c;var d = this._getOverlayPositionAndSize(b);return b.viewerElementToViewportRectangle(new a.Rect(d.position.x, d.position.y, d.size.x, d.size.y));
      }return c.rotate(-b.degrees, this._getPlacementPoint(c));
    } };
}(OpenSeadragon);!function (a) {
  a.Drawer = function (b) {
    a.console.assert(b.viewer, "[Drawer] options.viewer is required");var c = arguments;a.isPlainObject(b) || (b = { source: c[0], viewport: c[1], element: c[2] });a.console.assert(b.viewport, "[Drawer] options.viewport is required");a.console.assert(b.element, "[Drawer] options.element is required");b.source && a.console.error("[Drawer] options.source is no longer accepted; use TiledImage instead");this.viewer = b.viewer;this.viewport = b.viewport;this.debugGridColor = b.debugGridColor || a.DEFAULT_SETTINGS.debugGridColor;b.opacity && a.console.error("[Drawer] options.opacity is no longer accepted; set the opacity on the TiledImage instead");this.useCanvas = a.supportsCanvas && (this.viewer ? this.viewer.useCanvas : !0);this.container = a.getElement(b.element);this.canvas = a.makeNeutralElement(this.useCanvas ? "canvas" : "div");this.context = this.useCanvas ? this.canvas.getContext("2d") : null;this.sketchCanvas = null;this.sketchContext = null;this.element = this.container;this.container.dir = "ltr";if (this.useCanvas) {
      var d = this._calculateCanvasSize();this.canvas.width = d.x;this.canvas.height = d.y;
    }this.canvas.style.width = "100%";this.canvas.style.height = "100%";this.canvas.style.position = "absolute";a.setElementOpacity(this.canvas, this.opacity, !0);this.container.style.textAlign = "left";this.container.appendChild(this.canvas);
  };a.Drawer.prototype = { addOverlay: function addOverlay(b, c, d, e) {
      a.console.error("drawer.addOverlay is deprecated. Use viewer.addOverlay instead.");this.viewer.addOverlay(b, c, d, e);return this;
    }, updateOverlay: function updateOverlay(b, c, d) {
      a.console.error("drawer.updateOverlay is deprecated. Use viewer.updateOverlay instead.");this.viewer.updateOverlay(b, c, d);return this;
    }, removeOverlay: function removeOverlay(b) {
      a.console.error("drawer.removeOverlay is deprecated. Use viewer.removeOverlay instead.");this.viewer.removeOverlay(b);return this;
    }, clearOverlays: function clearOverlays() {
      a.console.error("drawer.clearOverlays is deprecated. Use viewer.clearOverlays instead.");this.viewer.clearOverlays();return this;
    }, setOpacity: function setOpacity(b) {
      a.console.error("drawer.setOpacity is deprecated. Use tiledImage.setOpacity instead.");var c = this.viewer.world;for (var d = 0; d < c.getItemCount(); d++) {
        c.getItemAt(d).setOpacity(b);
      }return this;
    }, getOpacity: function getOpacity() {
      a.console.error("drawer.getOpacity is deprecated. Use tiledImage.getOpacity instead.");var b = this.viewer.world;var c = 0;for (var d = 0; d < b.getItemCount(); d++) {
        var e = b.getItemAt(d).getOpacity();e > c && (c = e);
      }return c;
    }, needsUpdate: function needsUpdate() {
      a.console.error("[Drawer.needsUpdate] this function is deprecated. Use World.needsDraw instead.");return this.viewer.world.needsDraw();
    }, numTilesLoaded: function numTilesLoaded() {
      a.console.error("[Drawer.numTilesLoaded] this function is deprecated. Use TileCache.numTilesLoaded instead.");return this.viewer.tileCache.numTilesLoaded();
    }, reset: function reset() {
      a.console.error("[Drawer.reset] this function is deprecated. Use World.resetItems instead.");this.viewer.world.resetItems();return this;
    }, update: function update() {
      a.console.error("[Drawer.update] this function is deprecated. Use Drawer.clear and World.draw instead.");this.clear();this.viewer.world.draw();return this;
    }, canRotate: function canRotate() {
      return this.useCanvas;
    }, destroy: function destroy() {
      this.canvas.width = 1;this.canvas.height = 1;this.sketchCanvas = null;this.sketchContext = null;
    }, clear: function clear() {
      this.canvas.innerHTML = "";if (this.useCanvas) {
        var a = this._calculateCanvasSize();if (this.canvas.width != a.x || this.canvas.height != a.y) {
          this.canvas.width = a.x;this.canvas.height = a.y;if (null !== this.sketchCanvas) {
            var b = this._calculateSketchCanvasSize();this.sketchCanvas.width = b.x;this.sketchCanvas.height = b.y;
          }
        }this._clear();
      }
    }, _clear: function _clear(a, b) {
      if (this.useCanvas) {
        var c = this._getContext(a);if (b) c.clearRect(b.x, b.y, b.width, b.height);else {
          var d = c.canvas;c.clearRect(0, 0, d.width, d.height);
        }
      }
    }, viewportToDrawerRectangle: function viewportToDrawerRectangle(b) {
      var c = this.viewport.pixelFromPointNoRotate(b.getTopLeft(), !0);var d = this.viewport.deltaPixelsFromPointsNoRotate(b.getSize(), !0);return new a.Rect(c.x * a.pixelDensityRatio, c.y * a.pixelDensityRatio, d.x * a.pixelDensityRatio, d.y * a.pixelDensityRatio);
    }, drawTile: function drawTile(b, c, d, e, f) {
      a.console.assert(b, "[Drawer.drawTile] tile is required");a.console.assert(c, "[Drawer.drawTile] drawingHandler is required");if (this.useCanvas) {
        var g = this._getContext(d);e = e || 1;b.drawCanvas(g, c, e, f);
      } else b.drawHTML(this.canvas);
    }, _getContext: function _getContext(a) {
      var b = this.context;if (a) {
        if (null === this.sketchCanvas) {
          this.sketchCanvas = document.createElement("canvas");var c = this._calculateSketchCanvasSize();this.sketchCanvas.width = c.x;this.sketchCanvas.height = c.y;this.sketchContext = this.sketchCanvas.getContext("2d");if (0 === this.viewport.getRotation()) {
            var d = this;this.viewer.addHandler("rotate", function e() {
              d.viewer.removeHandler("rotate", e);var a = d._calculateSketchCanvasSize();d.sketchCanvas.width = a.x;d.sketchCanvas.height = a.y;
            });
          }
        }b = this.sketchContext;
      }return b;
    }, saveContext: function saveContext(a) {
      this.useCanvas && this._getContext(a).save();
    }, restoreContext: function restoreContext(a) {
      this.useCanvas && this._getContext(a).restore();
    }, setClip: function setClip(a, b) {
      if (this.useCanvas) {
        var c = this._getContext(b);c.beginPath();c.rect(a.x, a.y, a.width, a.height);c.clip();
      }
    }, drawRectangle: function drawRectangle(a, b, c) {
      if (this.useCanvas) {
        var d = this._getContext(c);d.save();d.fillStyle = b;d.fillRect(a.x, a.y, a.width, a.height);d.restore();
      }
    }, blendSketch: function blendSketch(b, c, d, e) {
      var f = b;a.isPlainObject(f) || (f = { opacity: b, scale: c, translate: d, compositeOperation: e });if (this.useCanvas && this.sketchCanvas) {
        b = f.opacity;e = f.compositeOperation;var g = f.bounds;this.context.save();this.context.globalAlpha = b;e && (this.context.globalCompositeOperation = e);if (g) this.context.drawImage(this.sketchCanvas, g.x, g.y, g.width, g.height, g.x, g.y, g.width, g.height);else {
          c = f.scale || 1;d = f.translate;var h = d instanceof a.Point ? d : new a.Point(0, 0);var i = 0;var j = 0;if (d) {
            var k = this.sketchCanvas.width - this.canvas.width;var l = this.sketchCanvas.height - this.canvas.height;i = Math.round(k / 2);j = Math.round(l / 2);
          }this.context.drawImage(this.sketchCanvas, h.x - i * c, h.y - j * c, (this.canvas.width + 2 * i) * c, (this.canvas.height + 2 * j) * c, -i, -j, this.canvas.width + 2 * i, this.canvas.height + 2 * j);
        }this.context.restore();
      }
    }, drawDebugInfo: function drawDebugInfo(b, c, d) {
      if (this.useCanvas) {
        var e = this.context;e.save();e.lineWidth = 2 * a.pixelDensityRatio;e.font = "small-caps bold " + 13 * a.pixelDensityRatio + "px arial";e.strokeStyle = this.debugGridColor;e.fillStyle = this.debugGridColor;0 !== this.viewport.degrees && this._offsetForRotation(this.viewport.degrees);e.strokeRect(b.position.x * a.pixelDensityRatio, b.position.y * a.pixelDensityRatio, b.size.x * a.pixelDensityRatio, b.size.y * a.pixelDensityRatio);var f = (b.position.x + b.size.x / 2) * a.pixelDensityRatio;var g = (b.position.y + b.size.y / 2) * a.pixelDensityRatio;e.translate(f, g);e.rotate(Math.PI / 180 * -this.viewport.degrees);e.translate(-f, -g);if (0 === b.x && 0 === b.y) {
          e.fillText("Zoom: " + this.viewport.getZoom(), b.position.x * a.pixelDensityRatio, (b.position.y - 30) * a.pixelDensityRatio);e.fillText("Pan: " + this.viewport.getBounds().toString(), b.position.x * a.pixelDensityRatio, (b.position.y - 20) * a.pixelDensityRatio);
        }e.fillText("Level: " + b.level, (b.position.x + 10) * a.pixelDensityRatio, (b.position.y + 20) * a.pixelDensityRatio);e.fillText("Column: " + b.x, (b.position.x + 10) * a.pixelDensityRatio, (b.position.y + 30) * a.pixelDensityRatio);e.fillText("Row: " + b.y, (b.position.x + 10) * a.pixelDensityRatio, (b.position.y + 40) * a.pixelDensityRatio);e.fillText("Order: " + d + " of " + c, (b.position.x + 10) * a.pixelDensityRatio, (b.position.y + 50) * a.pixelDensityRatio);e.fillText("Size: " + b.size.toString(), (b.position.x + 10) * a.pixelDensityRatio, (b.position.y + 60) * a.pixelDensityRatio);e.fillText("Position: " + b.position.toString(), (b.position.x + 10) * a.pixelDensityRatio, (b.position.y + 70) * a.pixelDensityRatio);0 !== this.viewport.degrees && this._restoreRotationChanges();e.restore();
      }
    }, debugRect: function debugRect(b) {
      if (this.useCanvas) {
        var c = this.context;c.save();c.lineWidth = 2 * a.pixelDensityRatio;c.strokeStyle = this.debugGridColor;c.fillStyle = this.debugGridColor;c.strokeRect(b.x * a.pixelDensityRatio, b.y * a.pixelDensityRatio, b.width * a.pixelDensityRatio, b.height * a.pixelDensityRatio);c.restore();
      }
    }, getCanvasSize: function getCanvasSize(b) {
      var c = this._getContext(b).canvas;return new a.Point(c.width, c.height);
    }, _offsetForRotation: function _offsetForRotation(a, b) {
      var c = this.canvas.width / 2;var d = this.canvas.height / 2;var e = this._getContext(b);e.save();e.translate(c, d);e.rotate(Math.PI / 180 * a);e.translate(-c, -d);
    }, _restoreRotationChanges: function _restoreRotationChanges(a) {
      var b = this._getContext(a);b.restore();
    }, _calculateCanvasSize: function _calculateCanvasSize() {
      var b = a.pixelDensityRatio;var c = this.viewport.getContainerSize();return { x: c.x * b, y: c.y * b };
    }, _calculateSketchCanvasSize: function _calculateSketchCanvasSize() {
      var a = this._calculateCanvasSize();if (0 === this.viewport.getRotation()) return a;var b = Math.ceil(Math.sqrt(a.x * a.x + a.y * a.y));return { x: b, y: b };
    } };
}(OpenSeadragon);!function (a) {
  a.Viewport = function (b) {
    var c = arguments;c.length && c[0] instanceof a.Point && (b = { containerSize: c[0], contentSize: c[1], config: c[2] });if (b.config) {
      a.extend(!0, b, b.config);delete b.config;
    }this._margins = a.extend({ left: 0, top: 0, right: 0, bottom: 0 }, b.margins || {});delete b.margins;a.extend(!0, this, { containerSize: null, contentSize: null, zoomPoint: null, viewer: null, springStiffness: a.DEFAULT_SETTINGS.springStiffness, animationTime: a.DEFAULT_SETTINGS.animationTime, minZoomImageRatio: a.DEFAULT_SETTINGS.minZoomImageRatio, maxZoomPixelRatio: a.DEFAULT_SETTINGS.maxZoomPixelRatio, visibilityRatio: a.DEFAULT_SETTINGS.visibilityRatio, wrapHorizontal: a.DEFAULT_SETTINGS.wrapHorizontal, wrapVertical: a.DEFAULT_SETTINGS.wrapVertical, defaultZoomLevel: a.DEFAULT_SETTINGS.defaultZoomLevel, minZoomLevel: a.DEFAULT_SETTINGS.minZoomLevel, maxZoomLevel: a.DEFAULT_SETTINGS.maxZoomLevel, degrees: a.DEFAULT_SETTINGS.degrees, homeFillsViewer: a.DEFAULT_SETTINGS.homeFillsViewer }, b);this._updateContainerInnerSize();this.centerSpringX = new a.Spring({ initial: 0, springStiffness: this.springStiffness, animationTime: this.animationTime });this.centerSpringY = new a.Spring({ initial: 0, springStiffness: this.springStiffness, animationTime: this.animationTime });this.zoomSpring = new a.Spring({ exponential: !0, initial: 1, springStiffness: this.springStiffness, animationTime: this.animationTime });this._oldCenterX = this.centerSpringX.current.value;this._oldCenterY = this.centerSpringY.current.value;this._oldZoom = this.zoomSpring.current.value;this._setContentBounds(new a.Rect(0, 0, 1, 1), 1);this.goHome(!0);this.update();
  };a.Viewport.prototype = { resetContentSize: function resetContentSize(b) {
      a.console.assert(b, "[Viewport.resetContentSize] contentSize is required");a.console.assert(b instanceof a.Point, "[Viewport.resetContentSize] contentSize must be an OpenSeadragon.Point");a.console.assert(b.x > 0, "[Viewport.resetContentSize] contentSize.x must be greater than 0");a.console.assert(b.y > 0, "[Viewport.resetContentSize] contentSize.y must be greater than 0");this._setContentBounds(new a.Rect(0, 0, 1, b.y / b.x), b.x);return this;
    }, setHomeBounds: function setHomeBounds(b, c) {
      a.console.error("[Viewport.setHomeBounds] this function is deprecated; The content bounds should not be set manually.");this._setContentBounds(b, c);
    }, _setContentBounds: function _setContentBounds(b, c) {
      a.console.assert(b, "[Viewport._setContentBounds] bounds is required");a.console.assert(b instanceof a.Rect, "[Viewport._setContentBounds] bounds must be an OpenSeadragon.Rect");a.console.assert(b.width > 0, "[Viewport._setContentBounds] bounds.width must be greater than 0");a.console.assert(b.height > 0, "[Viewport._setContentBounds] bounds.height must be greater than 0");this._contentBoundsNoRotate = b.clone();this._contentSizeNoRotate = this._contentBoundsNoRotate.getSize().times(c);this._contentBounds = b.rotate(this.degrees).getBoundingBox();this._contentSize = this._contentBounds.getSize().times(c);this._contentAspectRatio = this._contentSize.x / this._contentSize.y;this.viewer && this.viewer.raiseEvent("reset-size", { contentSize: this._contentSizeNoRotate.clone(), contentFactor: c, homeBounds: this._contentBoundsNoRotate.clone(), contentBounds: this._contentBounds.clone() });
    }, getHomeZoom: function getHomeZoom() {
      if (this.defaultZoomLevel) return this.defaultZoomLevel;var a = this._contentAspectRatio / this.getAspectRatio();var b;b = this.homeFillsViewer ? a >= 1 ? a : 1 : a >= 1 ? 1 : a;return b / this._contentBounds.width;
    }, getHomeBounds: function getHomeBounds() {
      return this.getHomeBoundsNoRotate().rotate(-this.getRotation());
    }, getHomeBoundsNoRotate: function getHomeBoundsNoRotate() {
      var b = this._contentBounds.getCenter();var c = 1 / this.getHomeZoom();var d = c / this.getAspectRatio();return new a.Rect(b.x - c / 2, b.y - d / 2, c, d);
    }, goHome: function goHome(a) {
      this.viewer && this.viewer.raiseEvent("home", { immediately: a });return this.fitBounds(this.getHomeBounds(), a);
    }, getMinZoom: function getMinZoom() {
      var a = this.getHomeZoom(),
          b = this.minZoomLevel ? this.minZoomLevel : this.minZoomImageRatio * a;return b;
    }, getMaxZoom: function getMaxZoom() {
      var a = this.maxZoomLevel;if (!a) {
        a = this._contentSize.x * this.maxZoomPixelRatio / this._containerInnerSize.x;a /= this._contentBounds.width;
      }return Math.max(a, this.getHomeZoom());
    }, getAspectRatio: function getAspectRatio() {
      return this._containerInnerSize.x / this._containerInnerSize.y;
    }, getContainerSize: function getContainerSize() {
      return new a.Point(this.containerSize.x, this.containerSize.y);
    }, getMargins: function getMargins() {
      return a.extend({}, this._margins);
    }, setMargins: function setMargins(b) {
      a.console.assert("object" === a.type(b), "[Viewport.setMargins] margins must be an object");this._margins = a.extend({ left: 0, top: 0, right: 0, bottom: 0 }, b);this._updateContainerInnerSize();this.viewer && this.viewer.forceRedraw();
    }, getBounds: function getBounds(a) {
      return this.getBoundsNoRotate(a).rotate(-this.getRotation());
    }, getBoundsNoRotate: function getBoundsNoRotate(b) {
      var c = this.getCenter(b);var d = 1 / this.getZoom(b);var e = d / this.getAspectRatio();return new a.Rect(c.x - d / 2, c.y - e / 2, d, e);
    }, getBoundsWithMargins: function getBoundsWithMargins(a) {
      return this.getBoundsNoRotateWithMargins(a).rotate(-this.getRotation(), this.getCenter(a));
    }, getBoundsNoRotateWithMargins: function getBoundsNoRotateWithMargins(a) {
      var b = this.getBoundsNoRotate(a);var c = this._containerInnerSize.x * this.getZoom(a);b.x -= this._margins.left / c;b.y -= this._margins.top / c;b.width += (this._margins.left + this._margins.right) / c;b.height += (this._margins.top + this._margins.bottom) / c;return b;
    }, getCenter: function getCenter(b) {
      var c,
          d,
          e,
          f,
          g,
          h,
          i,
          j,
          k = new a.Point(this.centerSpringX.current.value, this.centerSpringY.current.value),
          l = new a.Point(this.centerSpringX.target.value, this.centerSpringY.target.value);if (b) return k;if (!this.zoomPoint) return l;c = this.pixelFromPoint(this.zoomPoint, !0);d = this.getZoom();e = 1 / d;f = e / this.getAspectRatio();g = new a.Rect(k.x - e / 2, k.y - f / 2, e, f);h = this._pixelFromPoint(this.zoomPoint, g);i = h.minus(c);j = i.divide(this._containerInnerSize.x * d);return l.plus(j);
    }, getZoom: function getZoom(a) {
      return a ? this.zoomSpring.current.value : this.zoomSpring.target.value;
    }, _applyZoomConstraints: function _applyZoomConstraints(a) {
      return Math.max(Math.min(a, this.getMaxZoom()), this.getMinZoom());
    }, _applyBoundaryConstraints: function _applyBoundaryConstraints(b, c) {
      var d = new a.Rect(b.x, b.y, b.width, b.height);if (this.wrapHorizontal) ;else {
        var e = this.visibilityRatio * d.width;var f = d.x + d.width;var g = this._contentBoundsNoRotate.x + this._contentBoundsNoRotate.width;var h = this._contentBoundsNoRotate.x - f + e;var i = g - d.x - e;e > this._contentBoundsNoRotate.width ? d.x += (h + i) / 2 : 0 > i ? d.x += i : h > 0 && (d.x += h);
      }if (this.wrapVertical) ;else {
        var j = this.visibilityRatio * d.height;var k = d.y + d.height;var l = this._contentBoundsNoRotate.y + this._contentBoundsNoRotate.height;var m = this._contentBoundsNoRotate.y - k + j;var n = l - d.y - j;j > this._contentBoundsNoRotate.height ? d.y += (m + n) / 2 : 0 > n ? d.y += n : m > 0 && (d.y += m);
      }this.viewer && this.viewer.raiseEvent("constrain", { immediately: c });return d;
    }, applyConstraints: function applyConstraints(a) {
      var b = this.getZoom();var c = this._applyZoomConstraints(b);b !== c && this.zoomTo(c, this.zoomPoint, a);var d = this.getBoundsNoRotate();var e = this._applyBoundaryConstraints(d, a);(d.x !== e.x || d.y !== e.y || a) && this.fitBounds(e.rotate(-this.getRotation()), a);return this;
    }, ensureVisible: function ensureVisible(a) {
      return this.applyConstraints(a);
    }, _fitBounds: function _fitBounds(b, c) {
      c = c || {};var d = c.immediately || !1;var e = c.constraints || !1;var f = this.getAspectRatio();var g = b.getCenter();var h = new a.Rect(b.x, b.y, b.width, b.height, b.degrees + this.getRotation()).getBoundingBox();h.getAspectRatio() >= f ? h.height = h.width / f : h.width = h.height * f;h.x = g.x - h.width / 2;h.y = g.y - h.height / 2;var i = 1 / h.width;if (e) {
        var j = h.getAspectRatio();var k = this._applyZoomConstraints(i);if (i !== k) {
          i = k;h.width = 1 / i;h.x = g.x - h.width / 2;h.height = h.width / j;h.y = g.y - h.height / 2;
        }h = this._applyBoundaryConstraints(h, d);g = h.getCenter();
      }if (d) {
        this.panTo(g, !0);return this.zoomTo(i, null, !0);
      }this.panTo(this.getCenter(!0), !0);this.zoomTo(this.getZoom(!0), null, !0);var l = this.getBounds();var m = this.getZoom();if (0 === m || Math.abs(i / m - 1) < 1e-8) {
        this.zoomTo(i, !0);return this.panTo(g, d);
      }h = h.rotate(-this.getRotation());var n = h.getTopLeft().times(i).minus(l.getTopLeft().times(m)).divide(i - m);return this.zoomTo(i, n, d);
    }, fitBounds: function fitBounds(a, b) {
      return this._fitBounds(a, { immediately: b, constraints: !1 });
    }, fitBoundsWithConstraints: function fitBoundsWithConstraints(a, b) {
      return this._fitBounds(a, { immediately: b, constraints: !0 });
    }, fitVertically: function fitVertically(b) {
      var c = new a.Rect(this._contentBounds.x + this._contentBounds.width / 2, this._contentBounds.y, 0, this._contentBounds.height);return this.fitBounds(c, b);
    }, fitHorizontally: function fitHorizontally(b) {
      var c = new a.Rect(this._contentBounds.x, this._contentBounds.y + this._contentBounds.height / 2, this._contentBounds.width, 0);return this.fitBounds(c, b);
    }, panBy: function panBy(b, c) {
      var d = new a.Point(this.centerSpringX.target.value, this.centerSpringY.target.value);return this.panTo(d.plus(b), c);
    }, panTo: function panTo(a, b) {
      if (b) {
        this.centerSpringX.resetTo(a.x);this.centerSpringY.resetTo(a.y);
      } else {
        this.centerSpringX.springTo(a.x);this.centerSpringY.springTo(a.y);
      }this.viewer && this.viewer.raiseEvent("pan", { center: a, immediately: b });return this;
    }, zoomBy: function zoomBy(a, b, c) {
      return this.zoomTo(this.zoomSpring.target.value * a, b, c);
    }, zoomTo: function zoomTo(b, c, d) {
      this.zoomPoint = c instanceof a.Point && !isNaN(c.x) && !isNaN(c.y) ? c : null;d ? this.zoomSpring.resetTo(b) : this.zoomSpring.springTo(b);this.viewer && this.viewer.raiseEvent("zoom", { zoom: b, refPoint: c, immediately: d });return this;
    }, setRotation: function setRotation(a) {
      if (!this.viewer || !this.viewer.drawer.canRotate()) return this;a %= 360;0 > a && (a += 360);this.degrees = a;this._setContentBounds(this.viewer.world.getHomeBounds(), this.viewer.world.getContentFactor());this.viewer.forceRedraw();this.viewer.raiseEvent("rotate", { degrees: a });return this;
    }, getRotation: function getRotation() {
      return this.degrees;
    }, resize: function resize(a, b) {
      var c,
          d = this.getBoundsNoRotate(),
          e = d;this.containerSize.x = a.x;this.containerSize.y = a.y;this._updateContainerInnerSize();if (b) {
        c = a.x / this.containerSize.x;e.width = d.width * c;e.height = e.width / this.getAspectRatio();
      }this.viewer && this.viewer.raiseEvent("resize", { newContainerSize: a, maintain: b });return this.fitBounds(e, !0);
    }, _updateContainerInnerSize: function _updateContainerInnerSize() {
      this._containerInnerSize = new a.Point(Math.max(1, this.containerSize.x - (this._margins.left + this._margins.right)), Math.max(1, this.containerSize.y - (this._margins.top + this._margins.bottom)));
    }, update: function update() {
      if (this.zoomPoint) {
        var a = this.pixelFromPoint(this.zoomPoint, !0);this.zoomSpring.update();var b = this.pixelFromPoint(this.zoomPoint, !0);var c = b.minus(a);var d = this.deltaPointsFromPixels(c, !0);this.centerSpringX.shiftBy(d.x);this.centerSpringY.shiftBy(d.y);this.zoomSpring.isAtTargetValue() && (this.zoomPoint = null);
      } else this.zoomSpring.update();this.centerSpringX.update();this.centerSpringY.update();var e = this.centerSpringX.current.value !== this._oldCenterX || this.centerSpringY.current.value !== this._oldCenterY || this.zoomSpring.current.value !== this._oldZoom;this._oldCenterX = this.centerSpringX.current.value;this._oldCenterY = this.centerSpringY.current.value;this._oldZoom = this.zoomSpring.current.value;return e;
    }, deltaPixelsFromPointsNoRotate: function deltaPixelsFromPointsNoRotate(a, b) {
      return a.times(this._containerInnerSize.x * this.getZoom(b));
    }, deltaPixelsFromPoints: function deltaPixelsFromPoints(a, b) {
      return this.deltaPixelsFromPointsNoRotate(a.rotate(this.getRotation()), b);
    }, deltaPointsFromPixelsNoRotate: function deltaPointsFromPixelsNoRotate(a, b) {
      return a.divide(this._containerInnerSize.x * this.getZoom(b));
    }, deltaPointsFromPixels: function deltaPointsFromPixels(a, b) {
      return this.deltaPointsFromPixelsNoRotate(a, b).rotate(-this.getRotation());
    }, pixelFromPointNoRotate: function pixelFromPointNoRotate(a, b) {
      return this._pixelFromPointNoRotate(a, this.getBoundsNoRotate(b));
    }, pixelFromPoint: function pixelFromPoint(a, b) {
      return this._pixelFromPoint(a, this.getBoundsNoRotate(b));
    }, _pixelFromPointNoRotate: function _pixelFromPointNoRotate(b, c) {
      return b.minus(c.getTopLeft()).times(this._containerInnerSize.x / c.width).plus(new a.Point(this._margins.left, this._margins.top));
    }, _pixelFromPoint: function _pixelFromPoint(a, b) {
      return this._pixelFromPointNoRotate(a.rotate(this.getRotation(), this.getCenter(!0)), b);
    }, pointFromPixelNoRotate: function pointFromPixelNoRotate(b, c) {
      var d = this.getBoundsNoRotate(c);return b.minus(new a.Point(this._margins.left, this._margins.top)).divide(this._containerInnerSize.x / d.width).plus(d.getTopLeft());
    }, pointFromPixel: function pointFromPixel(a, b) {
      return this.pointFromPixelNoRotate(a, b).rotate(-this.getRotation(), this.getCenter(!0));
    }, _viewportToImageDelta: function _viewportToImageDelta(b, c) {
      var d = this._contentBoundsNoRotate.width;return new a.Point(b * this._contentSizeNoRotate.x / d, c * this._contentSizeNoRotate.x / d);
    }, viewportToImageCoordinates: function viewportToImageCoordinates(b, c) {
      if (b instanceof a.Point) return this.viewportToImageCoordinates(b.x, b.y);if (this.viewer) {
        var d = this.viewer.world.getItemCount();if (d > 1) a.console.error("[Viewport.viewportToImageCoordinates] is not accurate with multi-image; use TiledImage.viewportToImageCoordinates instead.");else if (1 === d) {
          var e = this.viewer.world.getItemAt(0);return e.viewportToImageCoordinates(b, c, !0);
        }
      }return this._viewportToImageDelta(b - this._contentBoundsNoRotate.x, c - this._contentBoundsNoRotate.y);
    }, _imageToViewportDelta: function _imageToViewportDelta(b, c) {
      var d = this._contentBoundsNoRotate.width;return new a.Point(b / this._contentSizeNoRotate.x * d, c / this._contentSizeNoRotate.x * d);
    }, imageToViewportCoordinates: function imageToViewportCoordinates(b, c) {
      if (b instanceof a.Point) return this.imageToViewportCoordinates(b.x, b.y);if (this.viewer) {
        var d = this.viewer.world.getItemCount();if (d > 1) a.console.error("[Viewport.imageToViewportCoordinates] is not accurate with multi-image; use TiledImage.imageToViewportCoordinates instead.");else if (1 === d) {
          var e = this.viewer.world.getItemAt(0);return e.imageToViewportCoordinates(b, c, !0);
        }
      }var f = this._imageToViewportDelta(b, c);f.x += this._contentBoundsNoRotate.x;f.y += this._contentBoundsNoRotate.y;return f;
    }, imageToViewportRectangle: function imageToViewportRectangle(b, c, d, e) {
      var f = b;f instanceof a.Rect || (f = new a.Rect(b, c, d, e));if (this.viewer) {
        var g = this.viewer.world.getItemCount();if (g > 1) a.console.error("[Viewport.imageToViewportRectangle] is not accurate with multi-image; use TiledImage.imageToViewportRectangle instead.");else if (1 === g) {
          var h = this.viewer.world.getItemAt(0);return h.imageToViewportRectangle(b, c, d, e, !0);
        }
      }var i = this.imageToViewportCoordinates(f.x, f.y);var j = this._imageToViewportDelta(f.width, f.height);return new a.Rect(i.x, i.y, j.x, j.y, f.degrees);
    }, viewportToImageRectangle: function viewportToImageRectangle(b, c, d, e) {
      var f = b;f instanceof a.Rect || (f = new a.Rect(b, c, d, e));if (this.viewer) {
        var g = this.viewer.world.getItemCount();if (g > 1) a.console.error("[Viewport.viewportToImageRectangle] is not accurate with multi-image; use TiledImage.viewportToImageRectangle instead.");else if (1 === g) {
          var h = this.viewer.world.getItemAt(0);return h.viewportToImageRectangle(b, c, d, e, !0);
        }
      }var i = this.viewportToImageCoordinates(f.x, f.y);var j = this._viewportToImageDelta(f.width, f.height);return new a.Rect(i.x, i.y, j.x, j.y, f.degrees);
    }, viewerElementToImageCoordinates: function viewerElementToImageCoordinates(a) {
      var b = this.pointFromPixel(a, !0);return this.viewportToImageCoordinates(b);
    }, imageToViewerElementCoordinates: function imageToViewerElementCoordinates(a) {
      var b = this.imageToViewportCoordinates(a);return this.pixelFromPoint(b, !0);
    }, windowToImageCoordinates: function windowToImageCoordinates(b) {
      a.console.assert(this.viewer, "[Viewport.windowToImageCoordinates] the viewport must have a viewer.");var c = b.minus(a.getElementPosition(this.viewer.element));return this.viewerElementToImageCoordinates(c);
    }, imageToWindowCoordinates: function imageToWindowCoordinates(b) {
      a.console.assert(this.viewer, "[Viewport.imageToWindowCoordinates] the viewport must have a viewer.");var c = this.imageToViewerElementCoordinates(b);return c.plus(a.getElementPosition(this.viewer.element));
    }, viewerElementToViewportCoordinates: function viewerElementToViewportCoordinates(a) {
      return this.pointFromPixel(a, !0);
    }, viewportToViewerElementCoordinates: function viewportToViewerElementCoordinates(a) {
      return this.pixelFromPoint(a, !0);
    }, viewerElementToViewportRectangle: function viewerElementToViewportRectangle(b) {
      return a.Rect.fromSummits(this.pointFromPixel(b.getTopLeft(), !0), this.pointFromPixel(b.getTopRight(), !0), this.pointFromPixel(b.getBottomLeft(), !0));
    }, viewportToViewerElementRectangle: function viewportToViewerElementRectangle(b) {
      return a.Rect.fromSummits(this.pixelFromPoint(b.getTopLeft(), !0), this.pixelFromPoint(b.getTopRight(), !0), this.pixelFromPoint(b.getBottomLeft(), !0));
    }, windowToViewportCoordinates: function windowToViewportCoordinates(b) {
      a.console.assert(this.viewer, "[Viewport.windowToViewportCoordinates] the viewport must have a viewer.");var c = b.minus(a.getElementPosition(this.viewer.element));return this.viewerElementToViewportCoordinates(c);
    }, viewportToWindowCoordinates: function viewportToWindowCoordinates(b) {
      a.console.assert(this.viewer, "[Viewport.viewportToWindowCoordinates] the viewport must have a viewer.");var c = this.viewportToViewerElementCoordinates(b);return c.plus(a.getElementPosition(this.viewer.element));
    }, viewportToImageZoom: function viewportToImageZoom(b) {
      if (this.viewer) {
        var c = this.viewer.world.getItemCount();if (c > 1) a.console.error("[Viewport.viewportToImageZoom] is not accurate with multi-image.");else if (1 === c) {
          var d = this.viewer.world.getItemAt(0);return d.viewportToImageZoom(b);
        }
      }var e = this._contentSizeNoRotate.x;var f = this._containerInnerSize.x;var g = this._contentBoundsNoRotate.width;var h = f / e * g;return b * h;
    }, imageToViewportZoom: function imageToViewportZoom(b) {
      if (this.viewer) {
        var c = this.viewer.world.getItemCount();if (c > 1) a.console.error("[Viewport.imageToViewportZoom] is not accurate with multi-image.");else if (1 === c) {
          var d = this.viewer.world.getItemAt(0);return d.imageToViewportZoom(b);
        }
      }var e = this._contentSizeNoRotate.x;var f = this._containerInnerSize.x;var g = this._contentBoundsNoRotate.width;var h = e / f / g;return b * h;
    } };
}(OpenSeadragon);!function (a) {
  function b(b) {
    b._needsDraw = !1;var d,
        e,
        g,
        h,
        i,
        j,
        l,
        m,
        n = null,
        o = !1,
        q = a.now(),
        r = b.viewport.getBoundsWithMargins(!0),
        s = b.viewport.deltaPixelsFromPointsNoRotate(b.source.getPixelRatio(0), !0).x * b._scaleSpring.current.value,
        t = Math.max(b.source.minLevel, Math.floor(Math.log(b.minZoomImageRatio) / Math.log(2))),
        u = Math.min(Math.abs(b.source.maxLevel), Math.abs(Math.floor(Math.log(s / b.minPixelRatio) / Math.log(2))));for (; b.lastDrawn.length > 0;) {
      d = b.lastDrawn.pop();d.beingDrawn = !1;
    }if (!b.wrapHorizontal && !b.wrapVertical) {
      var v = b.getClippedBounds(!0);var w = r.intersection(v);if (null === w) return;r = w;
    }r = r.getBoundingBox();r.x -= b._xSpring.current.value;r.y -= b._ySpring.current.value;var x = r.getTopLeft();var y = r.getBottomRight();if ((b.wrapHorizontal || !(y.x < 0 || x.x > b._worldWidthCurrent)) && (b.wrapVertical || !(y.y < 0 || x.y > b._worldHeightCurrent))) {
      if (!b.wrapHorizontal) {
        x.x = Math.max(x.x, 0);y.x = Math.min(y.x, b._worldWidthCurrent);
      }if (!b.wrapVertical) {
        x.y = Math.max(x.y, 0);y.y = Math.min(y.y, b._worldHeightCurrent);
      }t = Math.min(t, u);var z;for (e = u; e >= t; e--) {
        z = !1;g = b.viewport.deltaPixelsFromPointsNoRotate(b.source.getPixelRatio(e), !0).x * b._scaleSpring.current.value;if (!o && g >= b.minPixelRatio || e == t) {
          z = !0;o = !0;
        } else if (!o) continue;h = b.viewport.deltaPixelsFromPointsNoRotate(b.source.getPixelRatio(e), !1).x * b._scaleSpring.current.value;i = b.viewport.deltaPixelsFromPointsNoRotate(b.source.getPixelRatio(Math.max(b.source.getClosestLevel(b.viewport.containerSize) - 1, 0)), !1).x * b._scaleSpring.current.value;j = b.immediateRender ? 1 : i;l = Math.min(1, (g - .5) / .5);m = j / Math.abs(j - h);n = c(b, o, z, e, l, m, x, y, q, n);if (k(b.coverage, e)) break;
      }p(b, b.lastDrawn);n && !n.context2D && f(b, n, q);
    }
  }function c(a, b, c, e, f, g, h, i, j, k) {
    var l,
        m,
        o,
        p,
        q,
        r = a.viewport.pixelFromPoint(a.viewport.getCenter());a.viewer && a.viewer.raiseEvent("update-level", { tiledImage: a, havedrawn: b, level: e, opacity: f, visibility: g, topleft: h, bottomright: i, currenttime: j, best: k });o = a.source.getTileAtPoint(e, h.divide(a._scaleSpring.current.value));p = a.source.getTileAtPoint(e, i.divide(a._scaleSpring.current.value));q = a.source.getNumTiles(e);n(a.coverage, e);a.wrapHorizontal || (p.x = Math.min(p.x, q.x - 1));a.wrapVertical || (p.y = Math.min(p.y, q.y - 1));for (l = o.x; l <= p.x; l++) {
      for (m = o.y; m <= p.y; m++) {
        k = d(a, c, b, l, m, e, f, g, r, q, j, k);
      }
    }return k;
  }function d(a, b, c, d, f, g, k, n, p, q, r, s) {
    var t = e(d, f, g, a.source, a.tilesMatrix, r, q, a._worldWidthCurrent, a._worldHeightCurrent),
        u = b;a.viewer && a.viewer.raiseEvent("update-tile", { tiledImage: a, tile: t });m(a.coverage, g, d, f, !1);if (!t.exists) return s;c && !u && (l(a.coverage, g, d, f) ? m(a.coverage, g, d, f, !0) : u = !0);if (!u) return s;i(t, a.source.tileOverlap, a.viewport, p, n, a);if (!t.loaded) if (t.context2D) h(a, t);else {
      var v = a._tileCache.getImageRecord(t.url);if (v) {
        var w = v.getImage();h(a, t, w);
      }
    }if (t.loaded) {
      var x = j(a, t, d, f, g, k, r);x && (a._needsDraw = !0);
    } else t.loading || (s = o(s, t));return s;
  }function e(b, c, d, e, f, g, h, i, j) {
    var k, l, m, n, o, p, q;f[d] || (f[d] = {});f[d][b] || (f[d][b] = {});if (!f[d][b][c]) {
      k = (h.x + b % h.x) % h.x;l = (h.y + c % h.y) % h.y;m = e.getTileBounds(d, k, l);n = e.tileExists(d, k, l);o = e.getTileUrl(d, k, l);p = e.getContext2D ? e.getContext2D(d, k, l) : void 0;m.x += (b - k) / h.x;m.y += j / i * ((c - l) / h.y);f[d][b][c] = new a.Tile(d, b, c, m, n, o, p);
    }q = f[d][b][c];q.lastTouchTime = g;return q;
  }function f(a, b, c) {
    b.loading = !0;a._imageLoader.addJob({ src: b.url, crossOriginPolicy: a.crossOriginPolicy, callback: function callback(d, e) {
        g(a, b, c, d, e);
      }, abort: function abort() {
        b.loading = !1;
      } });
  }function g(b, c, d, e, f) {
    if (e) {
      if (d < b.lastResetTime) {
        a.console.log("Ignoring tile %s loaded before reset: %s", c, c.url);c.loading = !1;
      } else {
        var g = function g() {
          var a = Math.ceil(Math.log(b.source.getTileWidth(c.level)) / Math.log(2));h(b, c, e, a);
        };b._midDraw ? window.setTimeout(g, 1) : g();
      }
    } else {
      a.console.log("Tile %s failed to load: %s - error: %s", c, c.url, f);b.viewer.raiseEvent("tile-load-failed", { tile: c, tiledImage: b, time: d, message: f });c.loading = !1;c.exists = !1;
    }
  }function h(a, b, c, d) {
    function e() {
      g++;return f;
    }function f() {
      g--;if (0 === g) {
        b.loading = !1;b.loaded = !0;b.context2D || a._tileCache.cacheTile({ image: c, tile: b, cutoff: d, tiledImage: a });a._needsDraw = !0;
      }
    }var g = 0;a.viewer.raiseEvent("tile-loaded", { tile: b, tiledImage: a, image: c, getCompletionCallback: e });e()();
  }function i(b, c, d, e, f, g) {
    var h = b.bounds.getTopLeft();h.x *= g._scaleSpring.current.value;h.y *= g._scaleSpring.current.value;h.x += g._xSpring.current.value;h.y += g._ySpring.current.value;var i = b.bounds.getSize();i.x *= g._scaleSpring.current.value;i.y *= g._scaleSpring.current.value;var j = d.pixelFromPointNoRotate(h, !0),
        k = d.pixelFromPointNoRotate(h, !1),
        l = d.deltaPixelsFromPointsNoRotate(i, !0),
        m = d.deltaPixelsFromPointsNoRotate(i, !1),
        n = k.plus(m.divide(2)),
        o = e.distanceTo(n);c || (l = l.plus(new a.Point(1, 1)));b.position = j;b.size = l;b.distance = o;b.visibility = f;
  }function j(a, b, c, d, e, f, g) {
    var h,
        i,
        j = 1e3 * a.blendTime;b.blendStart || (b.blendStart = g);h = g - b.blendStart;i = j ? Math.min(1, h / j) : 1;a.alwaysBlend && (i *= f);b.opacity = i;a.lastDrawn.push(b);if (1 == i) {
      m(a.coverage, e, c, d, !0);a._hasOpaqueTile = !0;
    } else if (j > h) return !0;return !1;
  }function k(a, b, c, d) {
    var e, f, g, h;if (!a[b]) return !1;if (void 0 === c || void 0 === d) {
      e = a[b];for (g in e) {
        if (e.hasOwnProperty(g)) {
          f = e[g];for (h in f) {
            if (f.hasOwnProperty(h) && !f[h]) return !1;
          }
        }
      }return !0;
    }return void 0 === a[b][c] || void 0 === a[b][c][d] || a[b][c][d] === !0;
  }function l(a, b, c, d) {
    return void 0 === c || void 0 === d ? k(a, b + 1) : k(a, b + 1, 2 * c, 2 * d) && k(a, b + 1, 2 * c, 2 * d + 1) && k(a, b + 1, 2 * c + 1, 2 * d) && k(a, b + 1, 2 * c + 1, 2 * d + 1);
  }function m(b, c, d, e, f) {
    if (b[c]) {
      b[c][d] || (b[c][d] = {});b[c][d][e] = f;
    } else a.console.warn("Setting coverage for a tile before its level's coverage has been reset: %s", c);
  }function n(a, b) {
    a[b] = {};
  }function o(a, b) {
    return a ? b.visibility > a.visibility ? b : b.visibility == a.visibility && b.distance < a.distance ? b : a : b;
  }function p(b, c) {
    if (0 !== c.length) {
      var d = c[0];var e = b.opacity < 1 || b.compositeOperation && "source-over" !== b.compositeOperation || !b._isBottomItem() && d._hasTransparencyChannel();var f;var g;var h = b.viewport.getZoom(!0);var i = b.viewportToImageZoom(h);if (i > b.smoothTileEdgesMinZoom && !b.iOSDevice) {
        e = !0;f = d.getScaleForEdgeSmoothing();g = d.getTranslationForEdgeSmoothing(f, b._drawer.getCanvasSize(!1), b._drawer.getCanvasSize(!0));
      }var j;if (e) {
        f || (j = b.viewport.viewportToViewerElementRectangle(b.getClippedBounds(!0)).getIntegerBoundingBox().times(a.pixelDensityRatio));b._drawer._clear(!0, j);
      }0 === b.viewport.degrees || f || b._drawer._offsetForRotation(b.viewport.degrees, e);var k = !1;if (b._clip) {
        b._drawer.saveContext(e);var l = b.imageToViewportRectangle(b._clip, !0);var m = b._drawer.viewportToDrawerRectangle(l);f && (m = m.times(f));g && (m = m.translate(g));b._drawer.setClip(m, e);k = !0;
      }if (b.placeholderFillStyle && b._hasOpaqueTile === !1) {
        var n = b._drawer.viewportToDrawerRectangle(b.getBounds(!0));f && (n = n.times(f));g && (n = n.translate(g));var o = null;o = "function" == typeof b.placeholderFillStyle ? b.placeholderFillStyle(b, b._drawer.context) : b.placeholderFillStyle;b._drawer.drawRectangle(n, o, e);
      }for (var p = c.length - 1; p >= 0; p--) {
        d = c[p];b._drawer.drawTile(d, b._drawingHandler, e, f, g);d.beingDrawn = !0;b.viewer && b.viewer.raiseEvent("tile-drawn", { tiledImage: b, tile: d });
      }k && b._drawer.restoreContext(e);0 === b.viewport.degrees || f || b._drawer._restoreRotationChanges(e);if (e) {
        var r = 0 !== b.viewport.degrees && f;r && b._drawer._offsetForRotation(b.viewport.degrees, !1);b._drawer.blendSketch({ opacity: b.opacity, scale: f, translate: g, compositeOperation: b.compositeOperation, bounds: j });r && b._drawer._restoreRotationChanges(!1);
      }q(b, c);
    }
  }function q(b, c) {
    if (b.debugMode) for (var d = c.length - 1; d >= 0; d--) {
      var e = c[d];try {
        b._drawer.drawDebugInfo(e, c.length, d);
      } catch (f) {
        a.console.error(f);
      }
    }
  }a.TiledImage = function (b) {
    var c = this;a.console.assert(b.tileCache, "[TiledImage] options.tileCache is required");a.console.assert(b.drawer, "[TiledImage] options.drawer is required");a.console.assert(b.viewer, "[TiledImage] options.viewer is required");a.console.assert(b.imageLoader, "[TiledImage] options.imageLoader is required");a.console.assert(b.source, "[TiledImage] options.source is required");a.console.assert(!b.clip || b.clip instanceof a.Rect, "[TiledImage] options.clip must be an OpenSeadragon.Rect if present");a.EventSource.call(this);this._tileCache = b.tileCache;delete b.tileCache;this._drawer = b.drawer;delete b.drawer;this._imageLoader = b.imageLoader;delete b.imageLoader;b.clip instanceof a.Rect && (this._clip = b.clip.clone());delete b.clip;var d = b.x || 0;delete b.x;var e = b.y || 0;delete b.y;this.normHeight = b.source.dimensions.y / b.source.dimensions.x;this.contentAspectX = b.source.dimensions.x / b.source.dimensions.y;var f = 1;if (b.width) {
      f = b.width;delete b.width;if (b.height) {
        a.console.error("specifying both width and height to a tiledImage is not supported");delete b.height;
      }
    } else if (b.height) {
      f = b.height / this.normHeight;delete b.height;
    }var g = b.fitBounds;delete b.fitBounds;var h = b.fitBoundsPlacement || OpenSeadragon.Placement.CENTER;delete b.fitBoundsPlacement;a.extend(!0, this, { viewer: null, tilesMatrix: {}, coverage: {}, lastDrawn: [], lastResetTime: 0, _midDraw: !1, _needsDraw: !0, _hasOpaqueTile: !1, springStiffness: a.DEFAULT_SETTINGS.springStiffness, animationTime: a.DEFAULT_SETTINGS.animationTime, minZoomImageRatio: a.DEFAULT_SETTINGS.minZoomImageRatio, wrapHorizontal: a.DEFAULT_SETTINGS.wrapHorizontal, wrapVertical: a.DEFAULT_SETTINGS.wrapVertical, immediateRender: a.DEFAULT_SETTINGS.immediateRender, blendTime: a.DEFAULT_SETTINGS.blendTime, alwaysBlend: a.DEFAULT_SETTINGS.alwaysBlend, minPixelRatio: a.DEFAULT_SETTINGS.minPixelRatio, smoothTileEdgesMinZoom: a.DEFAULT_SETTINGS.smoothTileEdgesMinZoom, iOSDevice: a.DEFAULT_SETTINGS.iOSDevice, debugMode: a.DEFAULT_SETTINGS.debugMode, crossOriginPolicy: a.DEFAULT_SETTINGS.crossOriginPolicy, placeholderFillStyle: a.DEFAULT_SETTINGS.placeholderFillStyle, opacity: a.DEFAULT_SETTINGS.opacity, compositeOperation: a.DEFAULT_SETTINGS.compositeOperation }, b);this._xSpring = new a.Spring({ initial: d, springStiffness: this.springStiffness, animationTime: this.animationTime });this._ySpring = new a.Spring({ initial: e, springStiffness: this.springStiffness, animationTime: this.animationTime });this._scaleSpring = new a.Spring({ initial: f, springStiffness: this.springStiffness, animationTime: this.animationTime });this._updateForScale();g && this.fitBounds(g, h, !0);this._drawingHandler = function (b) {
      c.viewer.raiseEvent("tile-drawing", a.extend({ tiledImage: c }, b));
    };
  };a.extend(a.TiledImage.prototype, a.EventSource.prototype, { needsDraw: function needsDraw() {
      return this._needsDraw;
    }, reset: function reset() {
      this._tileCache.clearTilesFor(this);this.lastResetTime = a.now();
      this._needsDraw = !0;
    }, update: function update() {
      var a = this._xSpring.current.value;var b = this._ySpring.current.value;var c = this._scaleSpring.current.value;this._xSpring.update();this._ySpring.update();this._scaleSpring.update();if (this._xSpring.current.value !== a || this._ySpring.current.value !== b || this._scaleSpring.current.value !== c) {
        this._updateForScale();this._needsDraw = !0;return !0;
      }return !1;
    }, draw: function draw() {
      if (0 !== this.opacity) {
        this._midDraw = !0;b(this);this._midDraw = !1;
      }
    }, destroy: function destroy() {
      this.reset();
    }, getBounds: function getBounds(b) {
      return b ? new a.Rect(this._xSpring.current.value, this._ySpring.current.value, this._worldWidthCurrent, this._worldHeightCurrent) : new a.Rect(this._xSpring.target.value, this._ySpring.target.value, this._worldWidthTarget, this._worldHeightTarget);
    }, getWorldBounds: function getWorldBounds() {
      a.console.error("[TiledImage.getWorldBounds] is deprecated; use TiledImage.getBounds instead");return this.getBounds();
    }, getClippedBounds: function getClippedBounds(b) {
      var c = this.getBounds(b);if (this._clip) {
        var d = this._worldWidthCurrent / this.source.dimensions.x;var e = this._clip.times(d);c = new a.Rect(c.x + e.x, c.y + e.y, e.width, e.height);
      }return c;
    }, getContentSize: function getContentSize() {
      return new a.Point(this.source.dimensions.x, this.source.dimensions.y);
    }, _viewportToImageDelta: function _viewportToImageDelta(b, c, d) {
      var e = d ? this._scaleSpring.current.value : this._scaleSpring.target.value;return new a.Point(b * (this.source.dimensions.x / e), c * (this.source.dimensions.y * this.contentAspectX / e));
    }, viewportToImageCoordinates: function viewportToImageCoordinates(b, c, d) {
      if (b instanceof a.Point) {
        d = c;c = b.y;b = b.x;
      }return d ? this._viewportToImageDelta(b - this._xSpring.current.value, c - this._ySpring.current.value) : this._viewportToImageDelta(b - this._xSpring.target.value, c - this._ySpring.target.value);
    }, _imageToViewportDelta: function _imageToViewportDelta(b, c, d) {
      var e = d ? this._scaleSpring.current.value : this._scaleSpring.target.value;return new a.Point(b / this.source.dimensions.x * e, c / this.source.dimensions.y / this.contentAspectX * e);
    }, imageToViewportCoordinates: function imageToViewportCoordinates(b, c, d) {
      if (b instanceof a.Point) {
        d = c;c = b.y;b = b.x;
      }var e = this._imageToViewportDelta(b, c);if (d) {
        e.x += this._xSpring.current.value;e.y += this._ySpring.current.value;
      } else {
        e.x += this._xSpring.target.value;e.y += this._ySpring.target.value;
      }return e;
    }, imageToViewportRectangle: function imageToViewportRectangle(b, c, d, e, f) {
      var g = b;g instanceof a.Rect ? f = c : g = new a.Rect(b, c, d, e);var h = this.imageToViewportCoordinates(g.getTopLeft(), f);var i = this._imageToViewportDelta(g.width, g.height, f);return new a.Rect(h.x, h.y, i.x, i.y, g.degrees);
    }, viewportToImageRectangle: function viewportToImageRectangle(b, c, d, e, f) {
      var g = b;b instanceof a.Rect ? f = c : g = new a.Rect(b, c, d, e);var h = this.viewportToImageCoordinates(g.getTopLeft(), f);var i = this._viewportToImageDelta(g.width, g.height, f);return new a.Rect(h.x, h.y, i.x, i.y, g.degrees);
    }, viewerElementToImageCoordinates: function viewerElementToImageCoordinates(a) {
      var b = this.viewport.pointFromPixel(a, !0);return this.viewportToImageCoordinates(b);
    }, imageToViewerElementCoordinates: function imageToViewerElementCoordinates(a) {
      var b = this.imageToViewportCoordinates(a);return this.viewport.pixelFromPoint(b, !0);
    }, windowToImageCoordinates: function windowToImageCoordinates(a) {
      var b = a.minus(OpenSeadragon.getElementPosition(this.viewer.element));return this.viewerElementToImageCoordinates(b);
    }, imageToWindowCoordinates: function imageToWindowCoordinates(a) {
      var b = this.imageToViewerElementCoordinates(a);return b.plus(OpenSeadragon.getElementPosition(this.viewer.element));
    }, viewportToImageZoom: function viewportToImageZoom(a) {
      var b = this._scaleSpring.current.value * this.viewport._containerInnerSize.x / this.source.dimensions.x;return b * a;
    }, imageToViewportZoom: function imageToViewportZoom(a) {
      var b = this._scaleSpring.current.value * this.viewport._containerInnerSize.x / this.source.dimensions.x;return a / b;
    }, setPosition: function setPosition(a, b) {
      var c = this._xSpring.target.value === a.x && this._ySpring.target.value === a.y;if (b) {
        if (c && this._xSpring.current.value === a.x && this._ySpring.current.value === a.y) return;this._xSpring.resetTo(a.x);this._ySpring.resetTo(a.y);this._needsDraw = !0;
      } else {
        if (c) return;this._xSpring.springTo(a.x);this._ySpring.springTo(a.y);this._needsDraw = !0;
      }c || this._raiseBoundsChange();
    }, setWidth: function setWidth(a, b) {
      this._setScale(a, b);
    }, setHeight: function setHeight(a, b) {
      this._setScale(a / this.normHeight, b);
    }, fitBounds: function fitBounds(b, c, d) {
      c = c || a.Placement.CENTER;var e = a.Placement.properties[c];var f = this.contentAspectX;var g = 0;var h = 0;var i = 1;var j = 1;if (this._clip) {
        f = this._clip.getAspectRatio();i = this._clip.width / this.source.dimensions.x;j = this._clip.height / this.source.dimensions.y;if (b.getAspectRatio() > f) {
          g = this._clip.x / this._clip.height * b.height;h = this._clip.y / this._clip.height * b.height;
        } else {
          g = this._clip.x / this._clip.width * b.width;h = this._clip.y / this._clip.width * b.width;
        }
      }if (b.getAspectRatio() > f) {
        var k = b.height / j;var l = 0;e.isHorizontallyCentered ? l = (b.width - b.height * f) / 2 : e.isRight && (l = b.width - b.height * f);this.setPosition(new a.Point(b.x - g + l, b.y - h), d);this.setHeight(k, d);
      } else {
        var m = b.width / i;var n = 0;e.isVerticallyCentered ? n = (b.height - b.width / f) / 2 : e.isBottom && (n = b.height - b.width / f);this.setPosition(new a.Point(b.x - g, b.y - h + n), d);this.setWidth(m, d);
      }
    }, getClip: function getClip() {
      return this._clip ? this._clip.clone() : null;
    }, setClip: function setClip(b) {
      a.console.assert(!b || b instanceof a.Rect, "[TiledImage.setClip] newClip must be an OpenSeadragon.Rect or null");b instanceof a.Rect ? this._clip = b.clone() : this._clip = null;this._needsDraw = !0;
    }, getOpacity: function getOpacity() {
      return this.opacity;
    }, setOpacity: function setOpacity(a) {
      this.opacity = a;this._needsDraw = !0;
    }, getCompositeOperation: function getCompositeOperation() {
      return this.compositeOperation;
    }, setCompositeOperation: function setCompositeOperation(a) {
      this.compositeOperation = a;this._needsDraw = !0;
    }, _setScale: function _setScale(a, b) {
      var c = this._scaleSpring.target.value === a;if (b) {
        if (c && this._scaleSpring.current.value === a) return;this._scaleSpring.resetTo(a);this._updateForScale();this._needsDraw = !0;
      } else {
        if (c) return;this._scaleSpring.springTo(a);this._updateForScale();this._needsDraw = !0;
      }c || this._raiseBoundsChange();
    }, _updateForScale: function _updateForScale() {
      this._worldWidthTarget = this._scaleSpring.target.value;this._worldHeightTarget = this.normHeight * this._scaleSpring.target.value;this._worldWidthCurrent = this._scaleSpring.current.value;this._worldHeightCurrent = this.normHeight * this._scaleSpring.current.value;
    }, _raiseBoundsChange: function _raiseBoundsChange() {
      this.raiseEvent("bounds-change");
    }, _isBottomItem: function _isBottomItem() {
      return this.viewer.world.getItemAt(0) === this;
    } });
}(OpenSeadragon);!function (a) {
  var b = function b(_b) {
    a.console.assert(_b, "[TileCache.cacheTile] options is required");a.console.assert(_b.tile, "[TileCache.cacheTile] options.tile is required");a.console.assert(_b.tiledImage, "[TileCache.cacheTile] options.tiledImage is required");this.tile = _b.tile;this.tiledImage = _b.tiledImage;
  };var c = function c(b) {
    a.console.assert(b, "[ImageRecord] options is required");a.console.assert(b.image, "[ImageRecord] options.image is required");this._image = b.image;this._tiles = [];
  };c.prototype = { destroy: function destroy() {
      this._image = null;this._renderedContext = null;this._tiles = null;
    }, getImage: function getImage() {
      return this._image;
    }, getRenderedContext: function getRenderedContext() {
      if (!this._renderedContext) {
        var a = document.createElement("canvas");a.width = this._image.width;a.height = this._image.height;this._renderedContext = a.getContext("2d");this._renderedContext.drawImage(this._image, 0, 0);this._image = null;
      }return this._renderedContext;
    }, setRenderedContext: function setRenderedContext(b) {
      a.console.error("ImageRecord.setRenderedContext is deprecated. The rendered context should be created by the ImageRecord itself when calling ImageRecord.getRenderedContext.");this._renderedContext = b;
    }, addTile: function addTile(b) {
      a.console.assert(b, "[ImageRecord.addTile] tile is required");this._tiles.push(b);
    }, removeTile: function removeTile(b) {
      for (var c = 0; c < this._tiles.length; c++) {
        if (this._tiles[c] === b) {
          this._tiles.splice(c, 1);return;
        }
      }a.console.warn("[ImageRecord.removeTile] trying to remove unknown tile", b);
    }, getTileCount: function getTileCount() {
      return this._tiles.length;
    } };a.TileCache = function (b) {
    b = b || {};this._maxImageCacheCount = b.maxImageCacheCount || a.DEFAULT_SETTINGS.maxImageCacheCount;this._tilesLoaded = [];this._imagesLoaded = [];this._imagesLoadedCount = 0;
  };a.TileCache.prototype = { numTilesLoaded: function numTilesLoaded() {
      return this._tilesLoaded.length;
    }, cacheTile: function cacheTile(d) {
      a.console.assert(d, "[TileCache.cacheTile] options is required");a.console.assert(d.tile, "[TileCache.cacheTile] options.tile is required");a.console.assert(d.tile.url, "[TileCache.cacheTile] options.tile.url is required");a.console.assert(d.tiledImage, "[TileCache.cacheTile] options.tiledImage is required");var e = d.cutoff || 0;var f = this._tilesLoaded.length;var g = this._imagesLoaded[d.tile.url];if (!g) {
        a.console.assert(d.image, "[TileCache.cacheTile] options.image is required to create an ImageRecord");g = this._imagesLoaded[d.tile.url] = new c({ image: d.image });this._imagesLoadedCount++;
      }g.addTile(d.tile);d.tile.cacheImageRecord = g;if (this._imagesLoadedCount > this._maxImageCacheCount) {
        var h = null;var i = -1;var j = null;var k, l, m, n, o, p;for (var q = this._tilesLoaded.length - 1; q >= 0; q--) {
          p = this._tilesLoaded[q];k = p.tile;if (!(k.level <= e || k.beingDrawn)) if (h) {
            n = k.lastTouchTime;l = h.lastTouchTime;o = k.level;m = h.level;if (l > n || n == l && o > m) {
              h = k;i = q;j = p;
            }
          } else {
            h = k;i = q;j = p;
          }
        }if (h && i >= 0) {
          this._unloadTile(j);f = i;
        }
      }this._tilesLoaded[f] = new b({ tile: d.tile, tiledImage: d.tiledImage });
    }, clearTilesFor: function clearTilesFor(b) {
      a.console.assert(b, "[TileCache.clearTilesFor] tiledImage is required");var c;for (var d = 0; d < this._tilesLoaded.length; ++d) {
        c = this._tilesLoaded[d];if (c.tiledImage === b) {
          this._unloadTile(c);this._tilesLoaded.splice(d, 1);d--;
        }
      }
    }, getImageRecord: function getImageRecord(b) {
      a.console.assert(b, "[TileCache.getImageRecord] url is required");return this._imagesLoaded[b];
    }, _unloadTile: function _unloadTile(b) {
      a.console.assert(b, "[TileCache._unloadTile] tileRecord is required");var c = b.tile;var d = b.tiledImage;c.unload();c.cacheImageRecord = null;var e = this._imagesLoaded[c.url];e.removeTile(c);if (!e.getTileCount()) {
        e.destroy();delete this._imagesLoaded[c.url];this._imagesLoadedCount--;
      }d.viewer.raiseEvent("tile-unloaded", { tile: c, tiledImage: d });
    } };
}(OpenSeadragon);!function (a) {
  a.World = function (b) {
    var c = this;a.console.assert(b.viewer, "[World] options.viewer is required");a.EventSource.call(this);this.viewer = b.viewer;this._items = [];this._needsDraw = !1;this._autoRefigureSizes = !0;this._needsSizesFigured = !1;this._delegatedFigureSizes = function (a) {
      c._autoRefigureSizes ? c._figureSizes() : c._needsSizesFigured = !0;
    };this._figureSizes();
  };a.extend(a.World.prototype, a.EventSource.prototype, { addItem: function addItem(b, c) {
      a.console.assert(b, "[World.addItem] item is required");a.console.assert(b instanceof a.TiledImage, "[World.addItem] only TiledImages supported at this time");c = c || {};if (void 0 !== c.index) {
        var d = Math.max(0, Math.min(this._items.length, c.index));this._items.splice(d, 0, b);
      } else this._items.push(b);this._autoRefigureSizes ? this._figureSizes() : this._needsSizesFigured = !0;this._needsDraw = !0;b.addHandler("bounds-change", this._delegatedFigureSizes);this.raiseEvent("add-item", { item: b });
    }, getItemAt: function getItemAt(b) {
      a.console.assert(void 0 !== b, "[World.getItemAt] index is required");return this._items[b];
    }, getIndexOfItem: function getIndexOfItem(b) {
      a.console.assert(b, "[World.getIndexOfItem] item is required");return a.indexOf(this._items, b);
    }, getItemCount: function getItemCount() {
      return this._items.length;
    }, setItemIndex: function setItemIndex(b, c) {
      a.console.assert(b, "[World.setItemIndex] item is required");a.console.assert(void 0 !== c, "[World.setItemIndex] index is required");var d = this.getIndexOfItem(b);if (c >= this._items.length) throw new Error("Index bigger than number of layers.");if (c !== d && -1 !== d) {
        this._items.splice(d, 1);this._items.splice(c, 0, b);this._needsDraw = !0;this.raiseEvent("item-index-change", { item: b, previousIndex: d, newIndex: c });
      }
    }, removeItem: function removeItem(b) {
      a.console.assert(b, "[World.removeItem] item is required");var c = a.indexOf(this._items, b);if (-1 !== c) {
        b.removeHandler("bounds-change", this._delegatedFigureSizes);b.destroy();this._items.splice(c, 1);this._figureSizes();this._needsDraw = !0;this._raiseRemoveItem(b);
      }
    }, removeAll: function removeAll() {
      this.viewer._cancelPendingImages();var a;for (var b = 0; b < this._items.length; b++) {
        a = this._items[b];a.removeHandler("bounds-change", this._delegatedFigureSizes);a.destroy();
      }var c = this._items;this._items = [];this._figureSizes();this._needsDraw = !0;for (b = 0; b < c.length; b++) {
        a = c[b];this._raiseRemoveItem(a);
      }
    }, resetItems: function resetItems() {
      for (var a = 0; a < this._items.length; a++) {
        this._items[a].reset();
      }
    }, update: function update() {
      var a = !1;for (var b = 0; b < this._items.length; b++) {
        a = this._items[b].update() || a;
      }return a;
    }, draw: function draw() {
      for (var a = 0; a < this._items.length; a++) {
        this._items[a].draw();
      }this._needsDraw = !1;
    }, needsDraw: function needsDraw() {
      for (var a = 0; a < this._items.length; a++) {
        if (this._items[a].needsDraw()) return !0;
      }return this._needsDraw;
    }, getHomeBounds: function getHomeBounds() {
      return this._homeBounds.clone();
    }, getContentFactor: function getContentFactor() {
      return this._contentFactor;
    }, setAutoRefigureSizes: function setAutoRefigureSizes(a) {
      this._autoRefigureSizes = a;if (a & this._needsSizesFigured) {
        this._figureSizes();this._needsSizesFigured = !1;
      }
    }, arrange: function arrange(b) {
      b = b || {};var c = b.immediately || !1;var d = b.layout || a.DEFAULT_SETTINGS.collectionLayout;var e = b.rows || a.DEFAULT_SETTINGS.collectionRows;var f = b.columns || a.DEFAULT_SETTINGS.collectionColumns;var g = b.tileSize || a.DEFAULT_SETTINGS.collectionTileSize;var h = b.tileMargin || a.DEFAULT_SETTINGS.collectionTileMargin;var i = g + h;var j;j = !b.rows && f ? f : Math.ceil(this._items.length / e);var k = 0;var l = 0;var m, n, o, p, q;this.setAutoRefigureSizes(!1);for (var r = 0; r < this._items.length; r++) {
        if (r && r % j === 0) if ("horizontal" === d) {
          l += i;k = 0;
        } else {
          k += i;l = 0;
        }m = this._items[r];n = m.getBounds();o = n.width > n.height ? g : g * (n.width / n.height);p = o * (n.height / n.width);q = new a.Point(k + (g - o) / 2, l + (g - p) / 2);m.setPosition(q, c);m.setWidth(o, c);"horizontal" === d ? k += i : l += i;
      }this.setAutoRefigureSizes(!0);
    }, _figureSizes: function _figureSizes() {
      var b = this._homeBounds ? this._homeBounds.clone() : null;var c = this._contentSize ? this._contentSize.clone() : null;var d = this._contentFactor || 0;if (this._items.length) {
        var e = this._items[0];var f = e.getBounds();this._contentFactor = e.getContentSize().x / f.width;var g = e.getClippedBounds();var h = g.x;var i = g.y;var j = g.x + g.width;var k = g.y + g.height;for (var l = 1; l < this._items.length; l++) {
          e = this._items[l];f = e.getBounds();this._contentFactor = Math.max(this._contentFactor, e.getContentSize().x / f.width);g = e.getClippedBounds();h = Math.min(h, g.x);i = Math.min(i, g.y);j = Math.max(j, g.x + g.width);k = Math.max(k, g.y + g.height);
        }this._homeBounds = new a.Rect(h, i, j - h, k - i);this._contentSize = new a.Point(this._homeBounds.width * this._contentFactor, this._homeBounds.height * this._contentFactor);
      } else {
        this._homeBounds = new a.Rect(0, 0, 1, 1);this._contentSize = new a.Point(1, 1);this._contentFactor = 1;
      }this._contentFactor === d && this._homeBounds.equals(b) && this._contentSize.equals(c) || this.raiseEvent("metrics-change", {});
    }, _raiseRemoveItem: function _raiseRemoveItem(a) {
      this.raiseEvent("remove-item", { item: a });
    } });
}(OpenSeadragon);

/***/ }),

/***/ 830:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 651.969 90.914\" enable-background=\"new 0 0 651.969 90.914\" xml:space=\"preserve\"><g><path fill=\"#FFFFFF\" d=\"M121.919,72.277V29.108h-9.97v40.308c0,7.977-3.554,12.223-10.837,12.223 c-7.367,0-10.662-3.033-10.662-12.223V29.108H80.395v43.255c0,9.623,4.942,17.771,20.717,17.771 C114.291,90.135,121.919,83.287,121.919,72.277\"></path><path fill=\"#FFFFFF\" d=\"M169.329,89.096V56.328c0-8.062-4.68-12.137-11.442-12.137c-4.682,0-8.755,2.081-13.436,6.069 c0-2.342-0.521-4.248-1.562-6.243l-8.667,2.428c1.213,3.121,1.646,5.809,1.646,10.402v32.248h9.363V57.281 c2.861-2.861,6.847-4.941,9.622-4.941c3.641,0,5.027,1.646,5.027,7.629v29.127H169.329z\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#FFFFFF\" d=\"M186.986,38.729c3.554,0,6.414-2.86,6.414-6.328 c0-3.641-2.86-6.414-6.24-6.414c-3.555,0-6.328,2.86-6.328,6.414C180.832,35.869,183.519,38.729,186.986,38.729 M191.84,89.096 V44.191l-9.622,1.734v43.17H191.84z\"></path><path fill=\"#FFFFFF\" d=\"M238.634,45.232h-9.971l-7.28,22.278c-1.647,4.941-2.6,10.143-2.6,10.143h-0.173 c0,0-1.214-5.201-2.687-9.797l-7.629-23.665l-9.795,1.387l15.775,43.69h8.409L238.634,45.232z\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#FFFFFF\" d=\"M277.96,69.764V67.77c0-10.229-1.907-15.602-5.721-19.07 c-3.727-3.381-7.715-4.508-12.05-4.508c-5.548,0-9.881,1.821-13.438,5.895c-3.813,4.334-5.459,9.449-5.459,17.164 c0,14.043,7.802,22.971,20.197,22.971c5.895,0,11.183-1.906,15.777-5.807l-3.727-5.809c-3.295,2.861-6.849,4.334-10.925,4.334 c-8.581,0-10.833-6.414-10.833-12.482v-0.693H277.96z M268.078,62.742h-16.21c0-7.109,2.946-11.355,8.322-11.355 C264.957,51.387,268.078,55.633,268.078,62.742\"></path><path fill=\"#FFFFFF\" d=\"M311.74,44.71c-1.125-0.52-1.993-0.693-3.38-0.693c-4.247,0-7.714,2.254-11.182,7.022 c0-2.428-0.607-4.941-1.647-6.936l-8.756,2.254c0.954,2.688,1.56,6.242,1.56,11.791v30.947h9.536V59.449 c0.867-3.555,4.248-6.502,8.236-6.502c1.041,0,1.732,0.26,2.687,0.605L311.74,44.71z\"></path><path fill=\"#FFFFFF\" d=\"M347.452,75.398c0-5.115-2.341-9.969-11.182-12.223l-5.462-1.387c-4.421-1.127-5.895-2.516-5.895-5.203 c0-3.379,2.6-5.633,6.675-5.633c3.469,0,6.675,1.039,10.749,3.207l3.121-6.588c-3.728-1.995-8.496-3.813-14.476-3.813 c-9.71,0-16.299,5.72-16.299,13.956c0,6.154,3.901,10.662,10.49,12.049l5.287,1.127c4.941,1.039,7.109,2.773,7.109,6.154 c0,3.641-2.948,6.154-7.109,6.154c-4.94,0-10.315-2.338-14.216-4.594l-3.381,6.848c5.635,3.119,11.444,4.854,16.818,4.854 C340.259,90.307,347.452,84.24,347.452,75.398\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#FFFFFF\" d=\"M361.822,38.729c3.554,0,6.415-2.86,6.415-6.328 c0-3.641-2.861-6.414-6.241-6.414c-3.554,0-6.328,2.86-6.328,6.414C355.668,35.869,358.354,38.729,361.822,38.729 M366.678,89.096 V44.191l-9.623,1.734v43.17H366.678z\"></path><path fill=\"#FFFFFF\" d=\"M391.279,32.056l-9.797,2.339c-0.432,3.295-0.432,7.108-0.432,10.837h-4.855v6.588h4.855v27.133 c0,6.24,2.946,11.268,11.441,11.268c2.949,0,5.722-0.605,8.583-1.906l-1.214-5.721c-1.647,0.605-2.775,0.865-4.075,0.865 c-4.16,0-5.374-1.559-5.374-7.021V51.82h8.062l2.513-6.588h-10.488C390.498,40.896,390.844,35.609,391.279,32.056\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#FFFFFF\" d=\"M444.312,84.846c-3.381-2.34-3.902-4.246-3.815-10.141 l0.173-12.57c0.088-6.502,0.088-8.842-0.692-10.748c-1.906-4.768-6.502-7.284-13.351-7.284c-6.587,0-12.048,1.822-18.637,5.983 l4.248,6.848c0,0,6.762-5.027,13.09-5.027c5.2,0,6.067,2.688,6.067,7.715v2.34h-2.947c-14.043,0-21.672,5.115-21.672,15.258 c0,7.627,4.509,13.176,14.564,13.176c4.68,0,8.495-1.387,12.049-5.373c1.04,2.773,3.294,4.854,5.981,5.893L444.312,84.846z M431.223,68.463l-0.172,10.402c-1.908,2.773-4.855,4.594-7.891,4.594c-3.813,0-6.068-2.6-6.068-6.762 c0-5.547,2.861-8.32,12.396-8.32C429.921,68.377,431.223,68.463,431.223,68.463 M439.804,34.483c0-3.382-2.687-6.069-5.808-6.069 c-3.294,0-5.894,2.688-5.894,6.069c0,3.292,2.6,6.066,5.808,6.066C437.117,40.55,439.804,37.775,439.804,34.483 M421.6,34.483 c0-3.382-2.6-6.069-5.808-6.069c-3.207,0-5.81,2.688-5.81,6.069c0,3.292,2.603,6.066,5.81,6.066 C419,40.55,421.6,37.775,421.6,34.483\"></path><path fill=\"#FFFFFF\" d=\"M465.459,32.056l-9.795,2.339c-0.435,3.295-0.435,7.108-0.435,10.837h-4.854v6.588h4.854v27.133 c0,6.24,2.947,11.268,11.443,11.268c2.947,0,5.721-0.605,8.581-1.906l-1.215-5.721c-1.646,0.605-2.771,0.865-4.073,0.865 c-4.16,0-5.374-1.559-5.374-7.021V51.82h8.062l2.516-6.588H464.68C464.68,40.896,465.025,35.609,465.459,32.056\"></path><polygon fill=\"#FFFFFF\" points=\"501.311,35.609 517.263,35.609 517.263,89.096 524.111,89.096 524.111,35.609 540.234,35.609 540.667,29.628 501.311,29.628 \"></polygon><path fill=\"#FFFFFF\" d=\"M542.877,55.807v33.287h6.762V62.047c0-3.555,0.519-4.854,2.514-6.848c1.994-1.994,4.594-3.121,7.195-3.121 c0.692,0,1.475,0.174,1.907,0.348l2.774-7.37c0,0-1.214-0.434-2.341-0.434c-4.421,0-9.016,2.776-12.137,7.196 c0.261-3.641-1.386-7.022-1.386-7.022l-6.764,1.821C541.402,46.617,542.877,49.479,542.877,55.807\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#FFFFFF\" d=\"M568.709,89.094h7.022V44.97l-7.022,1.127V89.094z M567.062,32.66 c0,2.861,2.341,5.202,5.288,5.202s5.286-2.341,5.286-5.288s-2.339-5.289-5.286-5.289S567.062,29.713,567.062,32.66\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#FFFFFF\" d=\"M606.134,84.412c-4.335,0-8.32-1.561-10.749-5.287 c-1.474-2.254-1.994-5.375-1.994-9.449v-1.041h26.96v-0.953c-0.174-10.316-1.214-14.389-4.941-18.203 c-2.948-3.033-7.021-4.682-11.702-4.682c-5.202,0-9.45,1.909-12.917,5.981c-3.642,4.334-5.201,9.016-5.201,16.299 c0,14.303,7.193,22.971,19.157,22.971c5.549,0,10.749-1.906,14.562-5.375l-2.6-4.332C613.675,83.111,610.295,84.412,606.134,84.412 M603.359,50.086c3.294,0,6.328,1.473,7.802,3.812c1.3,2.08,1.906,4.941,1.994,9.623h-19.765 C593.736,54.592,597.205,50.086,603.359,50.086\"></path><path fill=\"#FFFFFF\" d=\"M630.817,55.807v33.287h6.761V62.047c0-3.555,0.52-4.854,2.514-6.848c1.995-1.994,4.594-3.121,7.195-3.121 c0.693,0,1.474,0.174,1.907,0.348l2.774-7.37c0,0-1.214-0.434-2.342-0.434c-4.42,0-9.014,2.776-12.135,7.196 c0.26-3.641-1.389-7.022-1.389-7.022l-6.762,1.821C629.342,46.617,630.817,49.479,630.817,55.807\"></path><path fill=\"#FFFFFF\" d=\"M26.505,79.01C10.375,68.137,0.004,49.99,0.004,28.384h26.501V79.01z M57.901,89.74 c-8.189-0.625-15.898-2.666-22.854-5.9V20.818H0L0.004,0h57.897V89.74z\"></path></g></svg>"

/***/ }),

/***/ 831:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17.008 17.008\" enable-background=\"new 0 0 17.008 17.008\" xml:space=\"preserve\"><g><path fill=\"#27225D\" d=\"M3.492,14.576l1.545-1.545h7.994V5.038l1.545-1.544l-1.061-1.062l-1.545,1.545H3.979v7.992l-1.546,1.546 L3.492,14.576z M11.631,11.631H6.438l5.192-5.192V11.631z M5.379,5.378h5.191l-5.191,5.191V5.378z\"></path><path fill=\"#27225D\" d=\"M0,0v17.009h17.008V0H0z M15.63,15.63H1.379V1.379H15.63V15.63z\"></path></g></svg>"

/***/ }),

/***/ 832:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17.008 17.008\" enable-background=\"new 0 0 17.008 17.008\" xml:space=\"preserve\"><g><path fill=\"#27225D\" d=\"M3.492,14.576l2.1-2.098c0.846,0.625,1.855,0.977,2.928,0.979h0.004c1.322,0,2.565-0.516,3.5-1.451 s1.449-2.179,1.448-3.503c0.001-1.098-0.371-2.104-0.979-2.926l2.084-2.083l-1.061-1.062l-2.085,2.085 C10.611,3.917,9.611,3.551,8.52,3.549c-2.729,0.004-4.95,2.226-4.952,4.954c-0.001,1.066,0.347,2.069,0.965,2.913l-2.1,2.1 L3.492,14.576z M12.071,8.503c0.001,0.951-0.368,1.843-1.038,2.515c-0.67,0.67-1.562,1.039-2.51,1.039v0.699L8.52,12.057 c-0.697,0-1.361-0.203-1.932-0.574l4.907-4.908C11.857,7.131,12.072,7.791,12.071,8.503z M4.968,8.503 C4.969,6.546,6.563,4.951,8.52,4.949c0.705,0.001,1.357,0.214,1.91,0.568l-4.898,4.9C5.167,9.851,4.967,9.193,4.968,8.503z\"></path><path fill=\"#27225D\" d=\"M0,0v17.01h17.008V0H0z M15.63,15.631H1.379V1.379H15.63V15.631z\"></path></g></svg>"

/***/ }),

/***/ 833:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 33.2 21.2\" style=\"enable-background:new 0 0 33.2 21.2;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#062956;} </style><g><g><path class=\"st0\" d=\"M17.2,21.2H0V0h17.2V21.2z M1.2,20H16V1.2H1.2V20z\"></path></g><g><rect x=\"4.3\" y=\"4.6\" class=\"st0\" width=\"8.6\" height=\"1.2\"></rect></g><g><rect x=\"4.3\" y=\"8.2\" class=\"st0\" width=\"8.6\" height=\"1.2\"></rect></g><g><rect x=\"4.3\" y=\"11.8\" class=\"st0\" width=\"8.6\" height=\"1.2\"></rect></g><g><rect x=\"4.3\" y=\"15.4\" class=\"st0\" width=\"8.6\" height=\"1.2\"></rect></g><g><path class=\"st0\" d=\"M33.2,21.2H16V0h17.2V21.2z M17.2,20H32V1.2H17.2V20z\"></path></g><g><rect x=\"20.3\" y=\"4.6\" class=\"st0\" width=\"8.6\" height=\"1.2\"></rect></g><g><rect x=\"20.3\" y=\"8.2\" class=\"st0\" width=\"8.6\" height=\"1.2\"></rect></g><g><rect x=\"20.3\" y=\"11.8\" class=\"st0\" width=\"8.6\" height=\"1.2\"></rect></g><g><rect x=\"20.3\" y=\"15.4\" class=\"st0\" width=\"8.6\" height=\"1.2\"></rect></g></g></svg>"

/***/ }),

/***/ 834:
/***/ (function(module, exports) {

module.exports = "<svg id=\"Layer_1\" style=\"enable-background:new 0 0 512 512;\" version=\"1.1\" viewBox=\"0 0 512 512\" xml:space=\"preserve\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><path fill=\"rgb(102,102,102)\" d=\"M98.9,184.7l1.8,2.1l136,156.5c4.6,5.3,11.5,8.6,19.2,8.6c7.7,0,14.6-3.4,19.2-8.6L411,187.1l2.3-2.6 c1.7-2.5,2.7-5.5,2.7-8.7c0-8.7-7.4-15.8-16.6-15.8v0H112.6v0c-9.2,0-16.6,7.1-16.6,15.8C96,179.1,97.1,182.2,98.9,184.7z\"></path></svg>"

/***/ }),

/***/ 835:
/***/ (function(module, exports) {

module.exports = "<svg enable-background=\"new 0 0 32 32\" id=\"svg2\" version=\"1.1\" viewBox=\"0 0 32 32\" xml:space=\"preserve\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:cc=\"http://creativecommons.org/ns#\" xmlns:dc=\"http://purl.org/dc/elements/1.1/\" xmlns:inkscape=\"http://www.inkscape.org/namespaces/inkscape\" xmlns:rdf=\"http://www.w3.org/1999/02/22-rdf-syntax-ns#\" xmlns:sodipodi=\"http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd\" xmlns:svg=\"http://www.w3.org/2000/svg\"><g id=\"background\"><rect fill=\"none\" height=\"32\" width=\"32\"></rect></g><g id=\"arrow_x5F_left\"><polygon points=\"22,2.001 8,16 22,30 \"></polygon></g></svg>"

/***/ }),

/***/ 836:
/***/ (function(module, exports) {

module.exports = "<svg enable-background=\"new 0 0 32 32\" id=\"svg2\" version=\"1.1\" viewBox=\"0 0 32 32\" xml:space=\"preserve\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:cc=\"http://creativecommons.org/ns#\" xmlns:dc=\"http://purl.org/dc/elements/1.1/\" xmlns:inkscape=\"http://www.inkscape.org/namespaces/inkscape\" xmlns:rdf=\"http://www.w3.org/1999/02/22-rdf-syntax-ns#\" xmlns:sodipodi=\"http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd\" xmlns:svg=\"http://www.w3.org/2000/svg\"><g id=\"background\"><rect fill=\"none\" height=\"32\" width=\"32\"></rect></g><g id=\"arrow_x5F_right\"><polygon points=\"10,2.001 24,16 10,30 \"></polygon></g></svg>"

/***/ }),

/***/ 837:
/***/ (function(module, exports) {

module.exports = "<svg id=\"Layer_1\" style=\"enable-background:new 0 0 512 512;\" version=\"1.1\" viewBox=\"0 0 512 512\" xml:space=\"preserve\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><path fill=\"rgb(102,102,102)\" d=\"M184.7,413.1l2.1-1.8l156.5-136c5.3-4.6,8.6-11.5,8.6-19.2c0-7.7-3.4-14.6-8.6-19.2L187.1,101l-2.6-2.3 C182,97,179,96,175.8,96c-8.7,0-15.8,7.4-15.8,16.6h0v286.8h0c0,9.2,7.1,16.6,15.8,16.6C179.1,416,182.2,414.9,184.7,413.1z\"></path></svg>"

/***/ }),

/***/ 838:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17 17\" style=\"enable-background:new 0 0 17 17;\" xml:space=\"preserve\"><style type=\"text/css\"> .stsadfjka{fill:#092957;} </style><g><path class=\"stsadfjka\" d=\"M0,0v17h17V0H0z M15.6,15.6H1.3V1.3h14.3V15.6z\"></path></g><path class=\"stsadfjka\" d=\"M8.5,2.5c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6C14.4,5.2,11.7,2.5,8.5,2.5z M8.5,9.3C8,9.3,7.7,8.9,7.7,8.5 c0-0.5,0.4-0.8,0.8-0.8c0.5,0,0.8,0.4,0.8,0.8C9.3,9,8.9,9.3,8.5,9.3z\"></path></svg>"

/***/ }),

/***/ 839:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 132.2 11.9\" style=\"enable-background:new 0 0 132.2 11.9;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#988EA9;} </style><g><path class=\"st0\" d=\"M4.4,5.3c0,0.7-0.1,1.4-0.2,2C4.2,7.9,4,8.5,3.7,9.1c-0.4,0.8-0.9,1.4-1.6,2c-0.2,0.2-0.5,0.4-0.9,0.5 c-0.4,0.2-0.8,0.2-1.2,0.2V0.1c0.3,0,0.7,0,1.1,0.1c0.4,0.1,0.7,0.1,0.8,0.2c0.4,0.2,0.7,0.4,1,0.7c0.3,0.2,0.5,0.5,0.7,0.9 c0.3,0.5,0.6,1.1,0.7,1.6C4.4,4,4.4,4.6,4.4,5.3L4.4,5.3z M2.8,3.9C2.8,3.5,2.6,3.1,2.4,2.8C2.2,2.4,2,2.1,1.7,1.8 c0,0-0.1-0.1-0.2-0.1v8c0.1-0.1,0.2-0.1,0.2-0.2C1.9,9.3,2,9.2,2.1,9c0.1-0.2,0.2-0.4,0.3-0.6c0.2-0.5,0.4-1,0.4-1.4S2.9,6,3,5.3 C3,4.7,2.9,4.2,2.8,3.9z\"></path><path class=\"st0\" d=\"M6.3,11.8V0.1h1.5v11.7H6.3z\"></path><path class=\"st0\" d=\"M10.8,11.8V0.1H14v1.4h-1.7v3.4H14v1.4h-1.6v4.1h1.8v1.4H10.8z\"></path><path class=\"st0\" d=\"M23.9,4.3c-0.1,0.3-0.2,0.6-0.4,1c-0.1,0.3-0.3,0.5-0.4,0.7c-0.1,0.2-0.3,0.4-0.5,0.6l1.3,5.2h-1.5l-1.1-4.2 c-0.1,0.1-0.2,0.1-0.3,0.2v4.1h-1.5V0.1H21c0.2,0,0.4,0,0.6,0c0.1,0,0.3,0,0.4,0.1c0.3,0.1,0.6,0.3,0.8,0.5 c0.2,0.2,0.4,0.5,0.6,0.8c0.2,0.3,0.3,0.6,0.4,0.9c0.1,0.3,0.1,0.6,0.1,1C24,3.8,23.9,4.1,23.9,4.3z M22.4,3.4 c0-0.5-0.1-0.9-0.2-1.2c-0.1-0.3-0.4-0.5-0.6-0.6c-0.2-0.1-0.3-0.1-0.5-0.1v4.6c0.2-0.1,0.4-0.2,0.5-0.4c0.2-0.2,0.3-0.3,0.4-0.4 c0.1-0.1,0.2-0.3,0.3-0.5c0.1-0.2,0.2-0.5,0.2-0.6C22.4,3.9,22.4,3.7,22.4,3.4L22.4,3.4z\"></path><path class=\"st0\" d=\"M25.9,11.8V0.1h3.3v1.4h-1.7v3.4h1.6v1.4h-1.6v4.1h1.8v1.4H25.9z\"></path><path class=\"st0\" d=\"M31.5,11.8V0.1h1.5v11.7H31.5z\"></path><path class=\"st0\" d=\"M39,11.8V6.3h-1.4v5.5h-1.5V0.1h1.5v4.8H39V0.1h1.5v11.7H39z\"></path><path class=\"st0\" d=\"M43.6,11.8V0.1h3.3v1.4h-1.7v3.4h1.6v1.4h-1.6v4.1h1.8v1.4H43.6z\"></path><path class=\"st0\" d=\"M56.2,11.8V6.2c0-0.2,0-0.4,0-0.7c0-0.3,0-0.4,0-0.6L56,6.2l-0.8,3.2c0,0.2-0.1,0.3-0.1,0.3c0,0,0-0.1-0.1-0.2 c0,0,0-0.1,0-0.1l-0.8-3.2L53.8,5c0,0.1,0,0.3,0,0.6c0,0.3,0,0.5,0,0.7v5.5h-1.5V0.1h1.5l1.1,4.3c0,0.1,0,0.2,0.1,0.3 c0,0.1,0,0.2,0,0.3c0-0.1,0-0.2,0.1-0.3c0-0.1,0-0.2,0.1-0.3l1.1-4.3h1.5v11.7H56.2z\"></path><path class=\"st0\" d=\"M60.6,11.8V0.1h3.3v1.4h-1.7v3.4h1.6v1.4h-1.6v4.1h1.8v1.4H60.6z\"></path><path class=\"st0\" d=\"M70.5,4.3c-0.1,0.3-0.2,0.6-0.4,1C70,5.6,69.9,5.8,69.8,6c-0.1,0.2-0.3,0.4-0.5,0.6l1.3,5.2h-1.5L68,7.5 c-0.1,0.1-0.2,0.1-0.3,0.2v4.1h-1.5V0.1h1.5c0.2,0,0.4,0,0.6,0c0.1,0,0.3,0,0.4,0.1c0.3,0.1,0.6,0.3,0.8,0.5 c0.2,0.2,0.4,0.5,0.6,0.8c0.2,0.3,0.3,0.6,0.4,0.9c0.1,0.3,0.1,0.6,0.1,1C70.6,3.8,70.6,4.1,70.5,4.3z M69.1,3.4 c0-0.5-0.1-0.9-0.2-1.2c-0.1-0.3-0.4-0.5-0.6-0.6c-0.2-0.1-0.3-0.1-0.5-0.1v4.6c0.2-0.1,0.4-0.2,0.5-0.4c0.2-0.2,0.3-0.3,0.4-0.4 c0.1-0.1,0.2-0.3,0.3-0.5C69,4.5,69,4.3,69.1,4.1C69.1,3.9,69.1,3.7,69.1,3.4L69.1,3.4z\"></path><path class=\"st0\" d=\"M72.2,11.8l2-10.3h-1.8V0.1h3.6l-2,10.3h2.1v1.4H72.2z\"></path><path class=\"st0\" d=\"M83.1,11.8l0-9.1c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.2c0,0,0,0.1-0.1,0.2C83,2.4,83,2.5,83,2.5L82.6,3l-1-0.8 l1.6-2.1h1.4v11.7H83.1z\"></path><path class=\"st0\" d=\"M91.3,4c0,0.5,0,0.9-0.1,1.3C91,6.7,90.7,7.9,90.3,9c-0.2,0.6-0.4,1-0.6,1.4c-0.2,0.4-0.4,0.9-0.7,1.4 l-1.3-0.7c0.3-0.5,0.5-0.9,0.7-1.3s0.4-0.8,0.5-1.3C89,8.4,89,8.2,89.1,8c0.1-0.2,0.1-0.4,0.1-0.5c0,0-0.1,0.1-0.2,0.1 s-0.2,0.1-0.3,0.1c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c-0.4-0.1-0.7-0.4-1.1-1.1C87.2,5.9,87,5.1,87,4c0-0.7,0.1-1.3,0.2-1.8 c0.1-0.5,0.3-0.9,0.5-1.2c0.2-0.3,0.4-0.5,0.7-0.7s0.5-0.2,0.8-0.2c0.3,0,0.5,0.1,0.8,0.2s0.5,0.4,0.7,0.7s0.4,0.7,0.5,1.2 C91.2,2.7,91.3,3.3,91.3,4L91.3,4z M89.6,2.4c-0.1-0.3-0.1-0.5-0.2-0.6c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0-0.2,0.1-0.3,0.2 s-0.1,0.4-0.2,0.6c-0.1,0.5-0.1,1-0.1,1.7c0,0.6,0.1,1.1,0.2,1.5C88.8,6,89,6.2,89.2,6.2c0.2,0,0.3-0.2,0.4-0.7 c0.1-0.5,0.2-1,0.2-1.5C89.8,3.4,89.7,2.9,89.6,2.4z\"></path><path class=\"st0\" d=\"M93,11.8c0-0.6,0-1,0-1.3c0-0.3,0-0.5,0-0.7c0-0.2,0-0.4,0.1-0.7c0.1-0.4,0.2-0.8,0.2-1.1 c0.1-0.3,0.2-0.7,0.5-1.2c0.1-0.3,0.3-0.7,0.5-1.2c0.2-0.4,0.3-0.8,0.4-1l0.1-0.1C94.9,4.3,95,4,95.1,3.8c0.1-0.2,0.1-0.5,0.1-0.7 c0-0.4-0.2-0.8-0.5-1.1c-0.2-0.2-0.6-0.4-1.1-0.5L93.8,0c0.3,0,0.7,0.1,1,0.3c0.3,0.1,0.6,0.3,0.8,0.5c0.3,0.3,0.5,0.6,0.7,1 c0.2,0.4,0.3,0.8,0.3,1.3c0,0.4-0.1,0.7-0.2,1.1c-0.1,0.4-0.2,0.8-0.4,1.2c-0.1,0.3-0.3,0.6-0.5,1.1c-0.2,0.4-0.3,0.8-0.5,1l0,0.1 c-0.2,0.4-0.3,0.7-0.4,1c-0.1,0.2-0.1,0.5-0.2,0.9c0,0.3-0.1,0.6-0.1,1.1h2.2v1.4H93z\"></path><path class=\"st0\" d=\"M101,4.2L101,4.2c0.1,0,0.1,0,0.1-0.1c0,0,0.1,0,0.1,0c0.4,0,0.8,0.3,1.1,1c0.3,0.7,0.5,1.5,0.5,2.7 c0,0.7-0.1,1.3-0.2,1.8s-0.3,0.9-0.5,1.2c-0.2,0.3-0.4,0.6-0.7,0.7c-0.3,0.1-0.5,0.2-0.8,0.2c-0.5,0-0.9-0.2-1.3-0.6 c-0.4-0.4-0.6-1-0.8-1.9l1.5-0.2c0,0.3,0.1,0.6,0.2,0.8s0.2,0.3,0.3,0.3c0.1,0,0.2-0.1,0.3-0.2s0.1-0.4,0.2-0.6s0.1-0.5,0.1-0.8 c0-0.3,0-0.6,0-0.9c0-0.6-0.1-1.1-0.2-1.5c-0.1-0.5-0.3-0.7-0.5-0.7c-0.1,0-0.1,0-0.2,0.1l0,0.1l-1.3-0.4l1.6-4h-2V0.1h4.1L101,4.2 z\"></path><path class=\"st0\" d=\"M109.3,6.8h-4.1V5.2h4.1V6.8z\"></path><path class=\"st0\" d=\"M112.3,11.8l0-9.1c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.2c0,0,0,0.1-0.1,0.2c0,0.1-0.1,0.1-0.1,0.2L111.8,3 l-1-0.8l1.6-2.1h1.4v11.7H112.3z\"></path><path class=\"st0\" d=\"M120.5,4c0,0.5,0,0.9-0.1,1.3c-0.2,1.3-0.5,2.6-0.9,3.7c-0.2,0.6-0.4,1-0.6,1.4c-0.2,0.4-0.4,0.9-0.7,1.4 l-1.3-0.7c0.3-0.5,0.5-0.9,0.7-1.3c0.2-0.4,0.4-0.8,0.5-1.3c0.1-0.2,0.1-0.4,0.2-0.5c0.1-0.2,0.1-0.4,0.1-0.5c0,0-0.1,0.1-0.2,0.1 s-0.2,0.1-0.3,0.1c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c-0.4-0.1-0.7-0.4-1.1-1.1c-0.3-0.6-0.5-1.5-0.5-2.5c0-0.7,0.1-1.3,0.2-1.8 c0.1-0.5,0.3-0.9,0.5-1.2s0.4-0.5,0.7-0.7s0.5-0.2,0.8-0.2s0.5,0.1,0.8,0.2s0.5,0.4,0.7,0.7c0.2,0.3,0.4,0.7,0.5,1.2 S120.5,3.3,120.5,4L120.5,4z M118.8,2.4c-0.1-0.3-0.1-0.5-0.2-0.6c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0-0.2,0.1-0.3,0.2 c-0.1,0.2-0.1,0.4-0.2,0.6c-0.1,0.5-0.1,1-0.1,1.7c0,0.6,0.1,1.1,0.2,1.5c0.1,0.5,0.3,0.7,0.5,0.7c0.2,0,0.3-0.2,0.5-0.7 c0.1-0.5,0.2-1,0.2-1.5C119,3.4,118.9,2.9,118.8,2.4z\"></path><path class=\"st0\" d=\"M124.8,4.2L124.8,4.2c0.1,0,0.1,0,0.1-0.1c0,0,0.1,0,0.1,0c0.4,0,0.8,0.3,1.1,1c0.3,0.7,0.5,1.5,0.5,2.7 c0,0.7-0.1,1.3-0.2,1.8s-0.3,0.9-0.5,1.2c-0.2,0.3-0.4,0.6-0.7,0.7c-0.3,0.1-0.5,0.2-0.8,0.2c-0.5,0-0.9-0.2-1.3-0.6 c-0.4-0.4-0.6-1-0.8-1.9l1.5-0.2c0,0.3,0.1,0.6,0.2,0.8s0.2,0.3,0.3,0.3c0.1,0,0.2-0.1,0.3-0.2s0.1-0.4,0.2-0.6S125,9,125,8.7 c0-0.3,0-0.6,0-0.9c0-0.6-0.1-1.1-0.2-1.5c-0.1-0.5-0.3-0.7-0.5-0.7c-0.1,0-0.1,0-0.2,0.1l0,0.1l-1.3-0.4l1.6-4h-2V0.1h4.1 L124.8,4.2z\"></path><path class=\"st0\" d=\"M128.5,11.8c0-0.6,0-1,0-1.3c0-0.3,0-0.5,0-0.7c0-0.2,0-0.4,0.1-0.7c0.1-0.4,0.2-0.8,0.2-1.1 c0.1-0.3,0.2-0.7,0.5-1.2c0.1-0.3,0.3-0.7,0.5-1.2c0.2-0.4,0.3-0.8,0.4-1l0.1-0.1c0.1-0.3,0.2-0.6,0.3-0.8c0.1-0.2,0.1-0.5,0.1-0.7 c0-0.4-0.1-0.8-0.4-1.1c-0.2-0.2-0.6-0.4-1.1-0.5l0.2-1.4c0.3,0,0.7,0.1,1,0.3c0.3,0.1,0.6,0.3,0.8,0.5c0.3,0.3,0.5,0.6,0.7,1 c0.2,0.4,0.3,0.8,0.3,1.3c0,0.4-0.1,0.7-0.2,1.1s-0.2,0.8-0.4,1.2c-0.1,0.3-0.3,0.6-0.5,1.1c-0.2,0.4-0.3,0.8-0.5,1l0,0.1 c-0.2,0.4-0.3,0.7-0.4,1c-0.1,0.2-0.1,0.5-0.2,0.9c0,0.3-0.1,0.6-0.1,1.1h2.2v1.4H128.5z\"></path></g></svg>"

/***/ }),

/***/ 840:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17 17\" style=\"enable-background:new 0 0 17 17;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#242958;} </style><g><path class=\"st0\" d=\"M12.8,4.2V0H0v12.8h4.2V17H17V4.2H12.8z M1.4,11.4v-10h10v2.8H4.2v7.2H1.4z M15.6,15.6h-10v-10h10V15.6z\"></path><polygon class=\"st0\" points=\"9.9,14.1 11.3,14.1 11.3,11.3 14.1,11.3 14.1,9.9 11.3,9.9 11.3,7.1 9.9,7.1 9.9,9.9 7.1,9.9 7.1,11.3 9.9,11.3 \"></polygon></g></svg>"

/***/ }),

/***/ 841:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17 17\" style=\"enable-background:new 0 0 17 17;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#242958;} </style><g><path class=\"st0\" d=\"M12.8,4.2V0H0v12.8h4.2V17H17V4.2H12.8z M1.4,11.4v-10h10v2.8H4.2v7.2H1.4z M15.6,15.6h-10v-10h10V15.6z\"></path><rect x=\"7.1\" y=\"9.9\" class=\"st0\" width=\"7\" height=\"1.4\"></rect></g></svg>"

/***/ }),

/***/ 842:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 23 18.5\" style=\"enable-background:new 0 0 23 18.5;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#242958;} </style><g><path class=\"st0\" d=\"M11.5,18.5c-3.3,0-4.8-2.7-4.8-4.7c0-0.8,0-1.5-2.2-1.5c-2,0-4.5-0.8-4.5-4.6C0,5,3.5,0,10.1,0 C18.2,0,23,3.6,23,9.7C23,16.2,16.8,18.5,11.5,18.5z M10.1,1.5c-5.6,0-8.6,4.1-8.6,6.1c0,2.2,0.9,3.1,3,3.1c2.6,0,3.7,1,3.7,3 c0,0.8,0.6,3.2,3.3,3.2c1.7,0,10-0.4,10-7.3C21.5,2.3,13.5,1.5,10.1,1.5z\"></path></g><circle class=\"st0\" cx=\"11.3\" cy=\"13.9\" r=\"1.5\"></circle><circle class=\"st0\" cx=\"17.3\" cy=\"6.5\" r=\"1.5\"></circle><circle class=\"st0\" cx=\"12.6\" cy=\"4.6\" r=\"1.5\"></circle><circle class=\"st0\" cx=\"7.7\" cy=\"4.7\" r=\"1.5\"></circle><circle class=\"st0\" cx=\"4.3\" cy=\"8.1\" r=\"1.5\"></circle></svg>"

/***/ }),

/***/ 843:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17.008 17.008\" enable-background=\"new 0 0 17.008 17.008\" xml:space=\"preserve\"><g><path fill=\"#27225D\" d=\"M0,0v17.008h17.008V0H0z M15.629,15.629H1.378V1.378h14.25V15.629z\"></path><path fill=\"#27225D\" d=\"M5.725,14.633c0.464,0.192,2.778-4.856,3.581-6.646c1.163,0.116,2.313-0.518,2.784-1.653 c0.574-1.387-0.085-2.979-1.473-3.556c-1.389-0.573-2.98,0.086-3.555,1.473C6.587,5.397,6.964,6.675,7.89,7.412 C7.188,9.255,5.263,14.441,5.725,14.633z\"></path></g></svg>"

/***/ }),

/***/ 844:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17 17\" style=\"enable-background:new 0 0 17 17;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#092957;} </style><g><path class=\"st0\" d=\"M0,0v17h17V0H0z M15.6,15.6H1.4V1.4h14.2V15.6z\"></path></g><path class=\"st0\" d=\"M2.8,2.7v11.5h11.5V2.7H2.8z M4,5.5V4.1h1.4v1.4H4z M6.5,5.5V4.1h1.4v1.4H6.5z M9.1,5.5V4.1h1.4v1.4H9.1z M11.7,5.5V4.1H13v1.4H11.7z M4,12.9v-1.4h1.4v1.4H4z M6.5,12.9v-1.4h1.4v1.4H6.5z M9.1,12.9v-1.4h1.4v1.4H9.1z M11.7,12.9v-1.4H13 v1.4H11.7z\"></path></svg>"

/***/ }),

/***/ 845:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 21 21\" style=\"enable-background:new 0 0 21 21;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#092957;} </style><g><path class=\"st0\" d=\"M21,21H0V0h21V21z M1.2,19.8h18.6V1.2H1.2V19.8z\"></path></g><g><g><path class=\"st0\" d=\"M10.5,18.5c-4.4,0-8-3.6-8-8c0-4.4,3.6-8,8-8s8,3.6,8,8C18.5,14.9,14.9,18.5,10.5,18.5z M10.5,3.8 c-3.7,0-6.8,3-6.8,6.8c0,3.7,3,6.8,6.8,6.8c3.7,0,6.8-3,6.8-6.8C17.3,6.8,14.3,3.8,10.5,3.8z\"></path></g></g><path class=\"st0\" d=\"M9.2,15.3l5-4.4c0.1-0.1,0.1-0.1,0.1-0.2c0.1-0.2,0.1-0.3,0-0.5c0-0.1-0.1-0.1-0.1-0.2l-5-4.4 c-0.2-0.2-0.6-0.2-0.9,0C8.2,5.8,8.1,6,8.1,6.1h0v0c0,0,0,0,0,0v8.7c0,0,0,0,0,0c0,0.2,0.1,0.3,0.2,0.4C8.5,15.6,8.9,15.6,9.2,15.3z \"></path></svg>"

/***/ }),

/***/ 846:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 19.842 19.843\" style=\"enable-background:new 0 0 19.842 19.843;\" xml:space=\"preserve\"><g><path style=\"fill:#C5C5C5;\" d=\"M16.869,16.348v-2.005L9.924,9.926l6.945-4.422V3.497l-10.42,6.43L16.869,16.348z M18.85,0H0.992 C0.445,0,0,0.446,0,0.992v17.858c0,0.546,0.445,0.992,0.992,0.992H18.85c0.547,0,0.992-0.446,0.992-0.992V0.992 C19.842,0.446,19.396,0,18.85,0z M18.85,18.156c0,0.382-0.312,0.694-0.693,0.694H1.686c-0.381,0-0.693-0.312-0.693-0.694V1.688 c0-0.382,0.312-0.694,0.693-0.694h16.471c0.381,0,0.693,0.312,0.693,0.694V18.156z M3.598,16.3h1.701V3.544H3.598V16.3z\"></path></g></svg>"

/***/ }),

/***/ 847:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 19.842 19.844\" enable-background=\"new 0 0 19.842 19.844\" xml:space=\"preserve\"><g><path fill=\"#5588CC\" d=\"M16.869,16.347v-2.004L9.924,9.926l6.945-4.422V3.496l-10.42,6.43L16.869,16.347z M18.85,0H0.992 C0.445,0,0,0.446,0,0.992v17.859c0,0.545,0.445,0.992,0.992,0.992H18.85c0.547,0,0.992-0.447,0.992-0.992V0.992 C19.842,0.446,19.396,0,18.85,0z M18.85,18.156c0,0.383-0.312,0.695-0.693,0.695H1.686c-0.381,0-0.693-0.312-0.693-0.695V1.687 c0-0.382,0.312-0.694,0.693-0.694h16.471c0.381,0,0.693,0.312,0.693,0.694V18.156z M3.598,16.301h1.701V3.544H3.598V16.301z\"></path></g></svg>"

/***/ }),

/***/ 848:
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 576 512\"><path d=\"M528 32H48C21.5 32 0 53.5 0 80v16h576V80c0-26.5-21.5-48-48-48zM0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V128H0v304zm352-232c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zM176 192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM67.1 396.2C75.5 370.5 99.6 352 128 352h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.9-5.2 19.8-15.6 19.8H82.7c-10.4 0-18.8-10-15.6-19.8z\"></path></svg>"

/***/ }),

/***/ 849:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 311.811 69.56\" enable-background=\"new 0 0 311.811 69.56\" xml:space=\"preserve\"><g><path fill=\"#FFFFFF\" d=\"M65.167,13.712l2.291-2.706l2.79-2.084l2.987-1.837l2.947-1.653l2.909-1.421l3.489-0.41l2.103-1.087 c0,0,0.767-1.12,0.737-1.302c-0.029-0.183-1.483-0.229-1.483-0.229l-2.492-0.626l-3.851,0.56l-4.073-0.568l-4.077,0.487 l-4.163,0.401l-3.23-0.2l-2.28-0.676l-1.943,0.684l-1.238,0.499l0.099,1.378l2.156,0.438l3.22,0.428l1.778,1.565l0.545,1.962 l-2.186,1.941l-1.811,2.469l-2.389,1.922l-1.946,2.428l-2.436,1.905l-1.892,2.491l-2.568,1.256l-1.445,1.957l-2.106,1.524 l-2.327,1.582l-2.023,1.968l-2.18,1.771l-1.332,0.396l-0.189-1.592l-0.425-2.393l0.091-2.396l0.338-2.394l-0.699-2.394l0.485-2.394 l0.368-2.396l-0.43-2.394l-0.063-3.09l0.314-3.17l1.546-1.766l2.397-0.415l2.96-0.473l1.898-1.253l-0.256-1.087L45.42,0 l-1.254,0.007L43.263,0.48l-2.008,0.138l-2.78-0.465l-2.756,0.453l-2.78-0.5l-3.464,0.208l-4.195-0.275l-4.166,0.423l-2.349,0.091 c0,0-0.99-0.6-1.236-0.528C17.282,0.1,16.54,1.184,16.54,1.184l0.324,1.053l1.698,0.99l2.909,0.591l2.297,0.734l0.816,2.288 l1.043,2.952l-0.523,3.037l-0.006,2.914l0.056,2.913l0.62,2.914l-0.746,2.911l0.061,2.915l0.508,2.913l0.293,2.912l-0.62,2.913 l0.636,2.913l-0.885,2.914l0.983,2.913l-0.744,2.913l0.448,2.913l0.023,2.913l-0.04,2.913l-0.291,3l-1.091,2.944l-0.385,2.545 l-2.435,0.631l-3.025-0.07l-1.972,1.316l0.127,1.245l0.97,0.812l1.173,0.261l0.893-0.454l2.488,0.288l3.623-0.568l3.594,0.148 l3.365-0.277l3.114,0.711l3.199-0.555l3.191,0.921l1.935-0.549l1.277,0.59l0.695-1.4l0.022-1.002l-1.846-0.617l-2.836-1.186 l-2.18-0.74l-1.193-1.674l-0.742-2.977l0.129-3.064l-0.107-2.355l-0.353-2.357l0.692-2.354l-0.587-2.357l0.537-2.357l0.111-2.355 l-0.758-2.355l0.684-2.224l0.74-1.058l1.525,0.761l2.716,2.525l2.805,2.422l2.362,2.822l2.471,2.729l2.486,2.711l2.778,2.446 l1.927,3.224l2.711,2.507l2.136,3.223l1.39,2.409l-1.804,0.726l-3.036,1.033l-2.68,0.562l0.122,1.399l1.058,1.021l2.88-0.187 l3.336,0.08l2.644-0.734l2.673,0.273l2.656-0.373l2.761-0.011l2.803,0.588l2.82-0.064l2.808,0.412l2.843,0.023l2.506-0.761 l1.429-0.535l0.191-1.086l-0.671-1.249l-2.282,0.345l-2.528-1.189l-1.872-1.425l-2.277-1.127l-1.712-1.711l-1.301-2.136 l-1.848-1.532l-1.479-1.871l-2.166-1.231l-1.635-1.727l-1.473-1.877l-1.521-1.835l-1.212-2.121l-1.608-1.754l-2.191-1.205 l-1.227-2.108L58.8,40.006l-1.513-1.84L55.83,36.27l-1.457-1.892l-1.807-1.565l-1.452-1.898l-2.162-1.505l1.004-2.204l2.017-3.197 l3.468-2.541l3.264-2.774l2.96-3.123L65.167,13.712z\"></path><rect y=\"10.115\" fill=\"#FFFFFF\" width=\"7.044\" height=\"7.044\"></rect><rect y=\"24.205\" fill=\"#FFFFFF\" width=\"7.044\" height=\"7.044\"></rect><rect y=\"38.295\" fill=\"#FFFFFF\" width=\"7.044\" height=\"7.043\"></rect><rect y=\"52.384\" fill=\"#FFFFFF\" width=\"7.044\" height=\"7.043\"></rect><rect x=\"13.918\" y=\"10.115\" fill=\"#FFFFFF\" width=\"7.044\" height=\"7.044\"></rect><rect x=\"13.918\" y=\"24.205\" fill=\"#FFFFFF\" width=\"7.044\" height=\"7.044\"></rect><rect x=\"13.918\" y=\"38.295\" fill=\"#FFFFFF\" width=\"7.044\" height=\"7.043\"></rect><rect x=\"13.918\" y=\"52.384\" fill=\"#FFFFFF\" width=\"7.044\" height=\"7.043\"></rect><rect x=\"27.837\" y=\"10.115\" fill=\"#FFFFFF\" width=\"7.044\" height=\"7.044\"></rect><rect x=\"27.837\" y=\"24.205\" fill=\"#FFFFFF\" width=\"7.044\" height=\"7.044\"></rect><rect x=\"27.837\" y=\"38.295\" fill=\"#FFFFFF\" width=\"7.044\" height=\"7.043\"></rect><rect x=\"27.837\" y=\"52.384\" fill=\"#FFFFFF\" width=\"7.044\" height=\"7.043\"></rect><rect x=\"41.755\" y=\"10.115\" fill=\"#FFFFFF\" width=\"7.044\" height=\"7.044\"></rect><rect x=\"41.755\" y=\"24.205\" fill=\"#FFFFFF\" width=\"7.044\" height=\"7.044\"></rect><rect x=\"41.755\" y=\"38.295\" fill=\"#FFFFFF\" width=\"7.044\" height=\"7.043\"></rect><rect x=\"41.755\" y=\"52.384\" fill=\"#FFFFFF\" width=\"7.044\" height=\"7.043\"></rect><polygon fill=\"#FFFFFF\" points=\"89.389,52.379 87.84,52.379 87.84,41.182 84.688,41.182 84.688,39.809 92.559,39.809 92.559,41.182 89.389,41.182 \"></polygon><path fill=\"#FFFFFF\" d=\"M92.837,42.942h1.48v1.407h0.036c0.422-0.896,0.985-1.654,2.041-1.654c0.299,0,0.511,0.035,0.651,0.105 v1.443c-0.14-0.018-0.317-0.068-0.793-0.068c-0.738,0-1.935,0.668-1.935,2.234v5.968h-1.48V42.942z\"></path><path fill=\"#FFFFFF\" d=\"M98.425,39.807h1.479v1.691h-1.479V39.807z M98.425,42.941h1.479v9.437h-1.479V42.941z\"></path><path fill=\"#FFFFFF\" d=\"M103.272,47.836c0,1.444,0,3.627,1.812,3.627c1.409,0,1.603-1.479,1.603-2.183h1.479 c0,1.004-0.599,3.345-3.169,3.345c-2.305,0-3.273-1.603-3.273-4.842c0-2.359,0.457-5.088,3.362-5.088 c2.888,0,3.151,2.518,3.151,4.543v0.598H103.272z M106.687,46.674v-0.51c0-1.057-0.334-2.307-1.638-2.307 c-1.549,0-1.726,1.901-1.726,2.465v0.352H106.687z\"></path><path fill=\"#FFFFFF\" d=\"M110.006,42.942h1.48v1.407h0.035c0.422-0.896,0.985-1.654,2.042-1.654c0.299,0,0.511,0.035,0.65,0.105 v1.443c-0.14-0.018-0.316-0.068-0.792-0.068c-0.738,0-1.935,0.668-1.935,2.234v5.968h-1.48V42.942z\"></path><path fill=\"#FFFFFF\" d=\"M127.542,48.065c-0.141,2.376-1.075,4.56-3.822,4.56c-3.573,0-4.048-3.363-4.048-6.531 c0-3.17,0.581-6.532,4.048-6.532c2.572,0,3.646,1.443,3.716,3.909h-1.621c-0.035-1.428-0.493-2.641-2.095-2.641 c-2.148,0-2.428,2.358-2.428,5.264c0,2.904,0.28,5.264,2.428,5.264c1.884,0,2.149-1.762,2.202-3.292H127.542z\"></path><path fill=\"#FFFFFF\" d=\"M130.633,47.836c0,1.444,0,3.627,1.812,3.627c1.408,0,1.603-1.479,1.603-2.183h1.478 c0,1.004-0.598,3.345-3.17,3.345c-2.305,0-3.273-1.603-3.273-4.842c0-2.359,0.459-5.088,3.363-5.088c2.888,0,3.15,2.518,3.15,4.543 v0.598H130.633z M134.048,46.674v-0.51c0-1.057-0.335-2.307-1.638-2.307c-1.549,0-1.725,1.901-1.725,2.465v0.352H134.048z\"></path><path fill=\"#FFFFFF\" d=\"M137.368,42.942h1.409v1.108h0.035c0.386-0.863,1.372-1.355,2.289-1.355c2.48,0,2.48,1.884,2.48,2.992v6.69 h-1.478v-6.513c0-0.723-0.053-1.902-1.392-1.902c-0.791,0-1.865,0.528-1.865,1.902v6.513h-1.479V42.942z\"></path><path fill=\"#FFFFFF\" d=\"M146.241,40.195h1.479v2.746h1.637v1.163h-1.637v6.056c0,0.758,0.194,1.056,0.968,1.056 c0.317,0,0.492-0.034,0.65-0.052v1.215c-0.193,0.035-0.579,0.105-1.197,0.105c-1.53,0-1.9-0.635-1.9-1.866v-6.514h-1.374v-1.163 h1.374V40.195z\"></path><path fill=\"#FFFFFF\" d=\"M151.802,47.836c0,1.444,0,3.627,1.814,3.627c1.407,0,1.601-1.479,1.601-2.183h1.479 c0,1.004-0.6,3.345-3.168,3.345c-2.307,0-3.274-1.603-3.274-4.842c0-2.359,0.456-5.088,3.362-5.088c2.887,0,3.15,2.518,3.15,4.543 v0.598H151.802z M155.217,46.674v-0.51c0-1.057-0.333-2.307-1.636-2.307c-1.551,0-1.727,1.901-1.727,2.465v0.352H155.217z\"></path><path fill=\"#FFFFFF\" d=\"M158.537,42.942h1.479v1.407h0.035c0.422-0.896,0.986-1.654,2.043-1.654c0.297,0,0.51,0.035,0.65,0.105 v1.443c-0.141-0.018-0.318-0.068-0.791-0.068c-0.74,0-1.938,0.668-1.938,2.234v5.968h-1.479V42.942z\"></path><path fill=\"#FFFFFF\" d=\"M168.766,44.104h-1.371v-1.161h1.371v-1.11c0-1.426,0.617-2.164,2.045-2.164h1.072v1.267h-0.688 c-0.633,0-0.949,0.247-0.949,0.897v1.11h1.619v1.161h-1.619v8.275h-1.48V44.104z\"></path><path fill=\"#FFFFFF\" d=\"M176.068,42.695c2.73,0,3.398,2.307,3.398,4.965s-0.686,4.965-3.398,4.965 c-2.727,0-3.396-2.307-3.396-4.965S173.359,42.695,176.068,42.695 M177.918,47.66c0-2.043-0.301-3.803-1.885-3.803 c-1.494,0-1.812,1.76-1.812,3.803s0.301,3.803,1.812,3.803C177.602,51.463,177.918,49.703,177.918,47.66\"></path><path fill=\"#FFFFFF\" d=\"M181.168,42.942h1.479v1.407h0.035c0.424-0.896,0.986-1.654,2.043-1.654c0.299,0,0.512,0.035,0.652,0.105 v1.443c-0.141-0.018-0.318-0.068-0.793-0.068c-0.74,0-1.938,0.668-1.938,2.234v5.968h-1.479V42.942z\"></path><path fill=\"#FFFFFF\" d=\"M191.17,39.807h3.361c3.91,0,4.402,2.818,4.402,6.287c0,3.169-0.793,6.285-4.242,6.285h-3.521V39.807z M192.719,51.11h1.619c2.678,0,2.977-2.745,2.977-4.999c0-2.43-0.158-5.035-2.977-5.035h-1.619V51.11z\"></path><path fill=\"#FFFFFF\" d=\"M201.057,39.807h1.48v1.691h-1.48V39.807z M201.057,42.941h1.48v9.437h-1.48V42.941z\"></path><path fill=\"#FFFFFF\" d=\"M210.904,51.779c0,2.817-1.303,3.839-3.205,3.839c-0.582,0-2.852,0-3.1-2.36h1.48 c0.07,0.863,0.738,1.197,1.514,1.197c1.9,0,1.83-1.461,1.83-2.111v-1.234h-0.035c-0.316,0.793-1.197,1.27-2.129,1.27 c-2.746,0-2.922-3.469-2.922-4.719c0-2.553,0.686-4.965,3.08-4.965c1.021,0,1.848,0.704,2.041,1.443h0.035v-1.196h1.41V51.779z M205.885,47.66c0,1.531,0.23,3.449,1.709,3.449c1.602,0,1.92-1.512,1.92-3.449c0-1.83-0.318-3.698-1.902-3.698 C206.238,43.962,205.885,45.406,205.885,47.66\"></path><path fill=\"#FFFFFF\" d=\"M213,39.807h1.48v1.691H213V39.807z M213,42.941h1.48v9.437H213V42.941z\"></path><path fill=\"#FFFFFF\" d=\"M217.225,40.195h1.48v2.746h1.635v1.163h-1.635v6.056c0,0.758,0.193,1.056,0.969,1.056 c0.316,0,0.49-0.034,0.65-0.052v1.215c-0.195,0.035-0.58,0.105-1.197,0.105c-1.531,0-1.902-0.635-1.902-1.866v-6.514h-1.373v-1.163 h1.373V40.195z\"></path><path fill=\"#FFFFFF\" d=\"M221.592,45.795c0-2.149,0.914-3.1,3.168-3.1c2.871,0,2.871,1.725,2.871,2.711v5.264 c0,0.389,0,0.758,0.457,0.758c0.193,0,0.281-0.035,0.352-0.088v1.057c-0.105,0.018-0.494,0.087-0.861,0.087 c-0.564,0-1.268,0-1.338-1.214h-0.035c-0.477,0.844-1.393,1.355-2.271,1.355c-1.76,0-2.572-1.058-2.572-2.747 c0-1.32,0.564-2.236,1.779-2.605l1.99-0.599c1.074-0.334,1.074-0.633,1.074-1.425c0-0.881-0.529-1.392-1.516-1.392 c-1.619,0-1.619,1.514-1.619,1.85v0.088H221.592z M226.15,47.237c-0.543,0.581-1.848,0.704-2.518,1.108 c-0.475,0.301-0.721,0.67-0.721,1.498c0,0.95,0.336,1.619,1.338,1.619c0.969,0,1.9-0.827,1.9-1.795V47.237z\"></path><rect x=\"229.926\" y=\"39.807\" fill=\"#FFFFFF\" width=\"1.479\" height=\"12.571\"></rect><polygon fill=\"#FFFFFF\" points=\"246,52.379 244.451,52.379 244.451,46.322 240.135,46.322 240.135,52.379 238.588,52.379 238.588,39.809 240.135,39.809 240.135,44.949 244.451,44.949 244.451,39.809 246,39.809 \"></polygon><path fill=\"#FFFFFF\" d=\"M254.494,52.379h-1.406V51.27h-0.035c-0.389,0.861-1.375,1.355-2.289,1.355 c-2.482,0-2.482-1.884-2.482-2.992v-6.69h1.479v6.513c0,0.723,0.053,1.902,1.389,1.902c0.795,0,1.869-0.528,1.869-1.902v-6.513 h1.477V52.379z\"></path><path fill=\"#FFFFFF\" d=\"M256.623,42.942h1.408v1.108h0.033c0.389-0.863,1.373-1.355,2.289-1.355c1.092,0,1.744,0.422,2.043,1.497 c0.422-0.828,1.268-1.497,2.238-1.497c2.479,0,2.479,1.884,2.479,2.992v6.69h-1.477v-6.513c0-0.723-0.053-1.902-1.268-1.902 c-0.689,0-1.762,0.422-1.762,1.902v6.513h-1.479v-6.513c0-0.723-0.053-1.902-1.268-1.902c-0.688,0-1.762,0.422-1.762,1.902v6.513 h-1.477V42.942z\"></path><path fill=\"#FFFFFF\" d=\"M269.062,45.795c0-2.149,0.914-3.1,3.168-3.1c2.871,0,2.871,1.725,2.871,2.711v5.264 c0,0.389,0,0.758,0.455,0.758c0.195,0,0.283-0.035,0.354-0.088v1.057c-0.105,0.018-0.494,0.087-0.861,0.087 c-0.564,0-1.27,0-1.34-1.214h-0.035c-0.477,0.844-1.391,1.355-2.271,1.355c-1.76,0-2.57-1.058-2.57-2.747 c0-1.32,0.564-2.236,1.779-2.605l1.988-0.599c1.074-0.334,1.074-0.633,1.074-1.425c0-0.881-0.529-1.392-1.514-1.392 c-1.619,0-1.619,1.514-1.619,1.85v0.088H269.062z M273.621,47.237c-0.545,0.581-1.848,0.704-2.518,1.108 c-0.475,0.301-0.721,0.67-0.721,1.498c0,0.95,0.334,1.619,1.336,1.619c0.971,0,1.902-0.827,1.902-1.795V47.237z\"></path><path fill=\"#FFFFFF\" d=\"M277.352,42.942h1.41v1.108h0.035c0.389-0.863,1.373-1.355,2.289-1.355c2.482,0,2.482,1.884,2.482,2.992 v6.69h-1.48v-6.513c0-0.723-0.051-1.902-1.391-1.902c-0.791,0-1.865,0.528-1.865,1.902v6.513h-1.48V42.942z\"></path><path fill=\"#FFFFFF\" d=\"M285.658,39.807h1.479v1.691h-1.479V39.807z M285.658,42.941h1.479v9.437h-1.479V42.941z\"></path><path fill=\"#FFFFFF\" d=\"M289.881,40.195h1.48v2.746H293v1.163h-1.639v6.056c0,0.758,0.193,1.056,0.969,1.056 c0.316,0,0.492-0.034,0.652-0.052v1.215c-0.195,0.035-0.582,0.105-1.197,0.105c-1.533,0-1.904-0.635-1.904-1.866v-6.514h-1.371 v-1.163h1.371V40.195z\"></path><path fill=\"#FFFFFF\" d=\"M294.371,39.807h1.477v1.691h-1.477V39.807z M294.371,42.941h1.477v9.437h-1.477V42.941z\"></path><path fill=\"#FFFFFF\" d=\"M299.215,47.836c0,1.444,0,3.627,1.814,3.627c1.408,0,1.602-1.479,1.602-2.183h1.479 c0,1.004-0.6,3.345-3.168,3.345c-2.307,0-3.273-1.603-3.273-4.842c0-2.359,0.455-5.088,3.361-5.088c2.887,0,3.15,2.518,3.15,4.543 v0.598H299.215z M302.631,46.674v-0.51c0-1.057-0.334-2.307-1.637-2.307c-1.549,0-1.727,1.901-1.727,2.465v0.352H302.631z\"></path><path fill=\"#FFFFFF\" d=\"M310.104,45.706c0-1.196-0.316-1.849-1.391-1.849c-0.477,0-1.531,0.123-1.531,1.444 c0,1.108,1.16,1.319,2.322,1.708c1.145,0.387,2.307,0.791,2.307,2.658c0,1.988-1.285,2.957-3.045,2.957 c-3.203,0-3.238-2.377-3.238-3.345h1.479c0,1.144,0.316,2.183,1.76,2.183c0.477,0,1.568-0.229,1.568-1.566 c0-1.268-1.162-1.533-2.309-1.919c-1.143-0.388-2.322-0.723-2.322-2.676c0-1.761,1.371-2.606,3.01-2.606 c2.748,0,2.852,1.902,2.869,3.011H310.104z\"></path><polygon fill=\"#FFFFFF\" points=\"90.402,11.128 90.402,19.183 90.458,19.183 95.585,11.128 99.978,11.128 94.515,19.747 100.599,31.24 96.035,31.24 91.894,22.985 90.402,25.268 90.402,31.24 86.346,31.24 86.346,11.128 \"></polygon><path fill=\"#FFFFFF\" d=\"M107.16,15.69c4.675-0.084,5.972,2.704,5.972,7.971c0,5.183-1.521,7.973-5.972,7.973 c-4.676,0.084-5.972-2.705-5.972-7.973C101.188,18.479,102.709,15.69,107.16,15.69 M107.16,28.986c1.577,0,2.085-1.549,2.085-5.325 c0-3.773-0.508-5.322-2.085-5.322c-1.915,0-2.085,2.224-2.085,5.322C105.075,26.761,105.246,28.986,107.16,28.986\"></path><path fill=\"#FFFFFF\" d=\"M115.905,16.086h3.717v1.548h0.058c0.985-1.38,2.196-1.944,3.83-1.944c1.775,0,3.07,0.874,3.493,2.423 h0.056c0.593-1.605,2-2.423,3.831-2.423c2.564,0,3.775,1.606,3.775,4.536v11.013h-3.888V20.648c0-1.268-0.424-1.973-1.521-1.973 c-1.24,0-2.028,0.846-2.028,2.593v9.971h-3.887V20.648c0-1.268-0.423-1.973-1.521-1.973c-1.24,0-2.028,0.846-2.028,2.593v9.971 h-3.887V16.086z\"></path><path fill=\"#FFFFFF\" d=\"M138.226,16.086h3.72v1.604h0.057c0.845-1.408,1.914-2,3.435-2c3.185,0,4.648,2.338,4.648,7.971 c0,5.635-1.464,7.973-4.648,7.973c-1.464,0-2.449-0.592-3.267-1.803h-0.057v6.365h-3.888V16.086z M144.171,28.648 c1.689,0,2.028-1.69,2.028-4.986c0-3.294-0.339-4.985-2.028-4.985c-1.719,0-2.058,1.691-2.058,4.985 C142.114,26.958,142.453,28.648,144.171,28.648\"></path><path fill=\"#FFFFFF\" d=\"M156.366,24.254v1.211c0,1.773,0.479,3.521,1.914,3.521c1.297,0,1.834-0.986,2.059-2.845h3.492 c-0.141,3.52-1.83,5.493-5.492,5.493c-5.634,0-5.86-4.338-5.86-8.113c0-4.056,0.788-7.831,6.028-7.831 c4.535,0,5.549,3.042,5.549,7.69v0.873H156.366z M160.338,21.944c-0.086-2.311-0.367-3.605-1.973-3.605c-1.548,0-2,1.605-2,3.014 v0.592H160.338z\"></path><path fill=\"#FFFFFF\" d=\"M167.754,11.747h3.889v4.339h2.254v2.647h-2.254v8.197c0,1.183,0.252,1.662,1.379,1.662 c0.311,0,0.621-0.027,0.875-0.056v2.705c-0.846,0.084-1.635,0.169-2.537,0.169c-3.041,0-3.605-0.93-3.605-4.001v-8.675h-1.971 v-2.647h1.971V11.747z\"></path><path fill=\"#FFFFFF\" d=\"M179.439,24.254v1.211c0,1.773,0.479,3.521,1.914,3.521c1.295,0,1.832-0.986,2.059-2.845h3.492 c-0.143,3.52-1.832,5.493-5.494,5.493c-5.633,0-5.859-4.338-5.859-8.113c0-4.056,0.789-7.831,6.029-7.831 c4.535,0,5.549,3.042,5.549,7.69v0.873H179.439z M183.412,21.944c-0.086-2.311-0.367-3.605-1.975-3.605 c-1.547,0-1.998,1.605-1.998,3.014v0.592H183.412z\"></path><path fill=\"#FFFFFF\" d=\"M189.877,16.086h3.719v1.775h0.057c0.816-1.495,2.225-2.171,3.857-2.171c2.422,0,3.859,1.324,3.859,4.31 v11.239h-3.887v-10.45c0-1.521-0.508-2.113-1.66-2.113c-1.326,0-2.059,0.817-2.059,2.507v10.056h-3.887V16.086z\"></path><polygon fill=\"#FFFFFF\" points=\"203.91,28.254 209.967,19.241 204.193,19.241 204.193,16.086 214.559,16.086 214.559,19.071 208.502,28.085 214.559,28.085 214.559,31.24 203.91,31.24 \"></polygon><polygon fill=\"#FFFFFF\" points=\"216.738,28.254 222.793,19.241 217.018,19.241 217.018,16.086 227.385,16.086 227.385,19.071 221.328,28.085 227.385,28.085 227.385,31.24 216.738,31.24 \"></polygon><path fill=\"#FFFFFF\" d=\"M233.299,24.254v1.211c0,1.773,0.48,3.521,1.918,3.521c1.295,0,1.83-0.986,2.055-2.845h3.494 c-0.141,3.52-1.832,5.493-5.494,5.493c-5.635,0-5.859-4.338-5.859-8.113c0-4.056,0.789-7.831,6.029-7.831 c4.535,0,5.549,3.042,5.549,7.69v0.873H233.299z M237.271,21.944c-0.084-2.311-0.365-3.605-1.971-3.605 c-1.551,0-2.002,1.605-2.002,3.014v0.592H237.271z\"></path><path fill=\"#FFFFFF\" d=\"M243.738,16.086h3.717v1.775h0.057c0.818-1.495,2.227-2.171,3.861-2.171c2.422,0,3.857,1.324,3.857,4.31 v11.239h-3.887v-10.45c0-1.521-0.508-2.113-1.662-2.113c-1.324,0-2.055,0.817-2.055,2.507v10.056h-3.889V16.086z\"></path><path fill=\"#FFFFFF\" d=\"M259.562,11.747h3.885v4.339h2.254v2.647h-2.254v8.197c0,1.183,0.256,1.662,1.381,1.662 c0.311,0,0.619-0.027,0.873-0.056v2.705c-0.846,0.084-1.633,0.169-2.533,0.169c-3.043,0-3.605-0.93-3.605-4.001v-8.675h-1.975 v-2.647h1.975V11.747z\"></path><path fill=\"#FFFFFF\" d=\"M268.211,16.086h3.719v2.027h0.057c0.789-1.465,1.889-2.423,3.492-2.423c0.227,0,0.48,0.029,0.705,0.057 v3.719c-0.395-0.028-0.816-0.057-1.213-0.057c-1.352,0-2.871,0.704-2.871,2.732v9.098h-3.889V16.086z\"></path><path fill=\"#FFFFFF\" d=\"M285.598,29.465h-0.057c-0.816,1.493-2.225,2.169-3.857,2.169c-2.422,0-3.861-1.324-3.861-4.31V16.086 h3.889v10.45c0,1.521,0.508,2.113,1.662,2.113c1.324,0,2.057-0.817,2.057-2.507V16.086h3.887V31.24h-3.719V29.465z\"></path><path fill=\"#FFFFFF\" d=\"M292.855,16.086h3.721v1.548h0.057c0.984-1.38,2.195-1.944,3.83-1.944c1.773,0,3.07,0.874,3.494,2.423 h0.055c0.592-1.605,2.002-2.423,3.832-2.423c2.562,0,3.773,1.606,3.773,4.536v11.013h-3.889V20.648c0-1.268-0.42-1.973-1.52-1.973 c-1.238,0-2.029,0.846-2.029,2.593v9.971h-3.889V20.648c0-1.268-0.42-1.973-1.52-1.973c-1.238,0-2.027,0.846-2.027,2.593v9.971 h-3.889V16.086z\"></path></g></svg>"

/***/ }),

/***/ 850:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 14.1 17\" style=\"enable-background:new 0 0 14.1 17;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#242958;} </style><g><polygon class=\"st0\" points=\"11.5,15.6 1.4,15.6 1.4,1.4 11.5,1.4 11.5,3.9 12.9,3.9 12.9,0 0,0 0,17 12.9,17 12.9,13.1 11.5,13.1 \"></polygon><polygon class=\"st0\" points=\"9.9,12.7 14.1,8.5 9.9,4.3 8.9,5.3 11.4,7.8 4.5,7.8 4.5,9.2 11.4,9.2 8.9,11.7 \"></polygon></g></svg>"

/***/ }),

/***/ 851:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 16.5 17\" style=\"enable-background:new 0 0 16.5 17;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#242958;} </style><g><path class=\"st0\" d=\"M14.7,5.3l-1.4,1.1v5.4l-4-3.3l7.2-6l-0.9-1.1l-0.9,0.8V0H1.8v2.2L0.9,1.5L0,2.5l7.2,6l-4,3.3V6.5L1.8,5.3V13 L0,14.5l0.9,1.1l7.4-6.1l7.4,6.1l0.9-1.1L14.7,13V5.3z M3.2,3.4v-2h10.1v2L8.3,7.6L3.2,3.4z\"></path><polygon class=\"st0\" points=\"13.3,15.6 3.2,15.6 3.2,14.9 1.8,16.1 1.8,17 14.7,17 14.7,16.1 13.3,14.9 \"></polygon></g></svg>"

/***/ }),

/***/ 852:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 12.9 17\" style=\"enable-background:new 0 0 12.9 17;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#092957;} </style><path class=\"st0\" d=\"M0,0v17h12.9V0H0z M11.5,15.6H1.4V1.4h10.1V15.6z\"></path></svg>"

/***/ }),

/***/ 853:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 12.9 17\" style=\"enable-background:new 0 0 12.9 17;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#092957;} </style><polygon class=\"st0\" points=\"2.3,9.5 6.4,13.7 10.6,9.5 9.6,8.5 7.1,11 7.1,4.1 5.8,4.1 5.8,11 3.3,8.5 \"></polygon><path class=\"st0\" d=\"M0,0v17h12.9V0H0z M11.5,15.6H1.4V1.4h10.1V15.6z\"></path></svg>"

/***/ }),

/***/ 854:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 12.9 17\" style=\"enable-background:new 0 0 12.9 17;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#242958;} </style><g><polygon class=\"st0\" points=\"10.8,6.2 9.8,5.2 5.2,9.8 3.1,7.7 2.1,8.7 5.2,11.8 \"></polygon><path class=\"st0\" d=\"M0,0v17h12.9V0H0z M11.5,15.6H1.4V1.4h10.1V15.6z\"></path></g></svg>"

/***/ }),

/***/ 855:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 37.2 21.2\" style=\"enable-background:new 0 0 37.2 21.2;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#062956;} </style><g><rect x=\"4.3\" y=\"15.4\" class=\"st0\" width=\"8.6\" height=\"1.2\"></rect></g><g><path class=\"st0\" d=\"M32.9,5.8h-1V4.6h1V5.8z M31,5.8h-1V4.6h1V5.8z M29.1,5.8h-1V4.6h1V5.8z M27.2,5.8h-1V4.6h1V5.8z M25.3,5.8h-1 V4.6h1V5.8z\"></path></g><g><rect x=\"24.3\" y=\"8.2\" class=\"st0\" width=\"8.6\" height=\"1.2\"></rect></g><g><rect x=\"24.3\" y=\"11.8\" class=\"st0\" width=\"8.6\" height=\"1.2\"></rect></g><g><rect x=\"24.3\" y=\"15.4\" class=\"st0\" width=\"8.6\" height=\"1.2\"></rect></g><path class=\"st0\" d=\"M16,7.4V20H1.2V1.2H16v3.1c0.4-0.1,0.8-0.2,1.2-0.2V0H0v21.2h17.2V7.1C16.8,7.2,16.4,7.2,16,7.4z\"></path><path class=\"st0\" d=\"M20,0v3.7c0.4,0,0.8,0,1.2,0V1.2H36V20H21.2V6.7c-0.4,0-0.8,0-1.2,0v14.5h17.2V0H20z\"></path><g><path class=\"st0\" d=\"M10.6,10.2l-1-0.6c3-5,9.4-5,13.2-5v1.2C17.9,5.8,13.1,6.1,10.6,10.2z\"></path></g><g><polygon class=\"st0\" points=\"8.2,6.7 14,10.3 7.4,14.5 \"></polygon></g></svg>"

/***/ }),

/***/ 856:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17.008 17.008\" enable-background=\"new 0 0 17.008 17.008\" xml:space=\"preserve\"><g><path fill=\"#222A56\" d=\"M16.319,17.008H0.689C0.309,17.008,0,16.699,0,16.318V4.922c0-0.381,0.309-0.689,0.689-0.689 s0.689,0.309,0.689,0.689v10.707H15.63V4.922c0-0.381,0.309-0.689,0.689-0.689c0.38,0,0.688,0.309,0.688,0.689v11.396 C17.008,16.699,16.699,17.008,16.319,17.008z\"></path></g><g><path fill=\"#222A56\" d=\"M13.832,1.5H3.533c-0.414,0-0.75-0.336-0.75-0.75S3.119,0,3.533,0h10.299c0.414,0,0.75,0.336,0.75,0.75 S14.246,1.5,13.832,1.5z\"></path></g><path fill=\"#222A56\" d=\"M14.049,9.837L9.17,4.251C9.106,4.187,9.029,4.137,8.945,4.102c-0.168-0.069-0.357-0.069-0.525,0 C8.336,4.137,8.259,4.187,8.195,4.251L3.316,9.837c-0.269,0.27-0.269,0.706,0,0.975c0.125,0.125,0.287,0.187,0.451,0.195v0.004 h0.021c0.01,0,0.02,0,0.03,0h9.727c0.005,0,0.011,0.003,0.015,0.003c0.178,0,0.354-0.067,0.488-0.202 C14.317,10.543,14.317,10.106,14.049,9.837z\"></path></svg>"

/***/ }),

/***/ 857:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17.008 17.008\" enable-background=\"new 0 0 17.008 17.008\" xml:space=\"preserve\"><g><path fill=\"#222A56\" d=\"M16.319,17.008H0.689C0.309,17.008,0,16.699,0,16.318V4.922c0-0.381,0.309-0.689,0.689-0.689 s0.689,0.309,0.689,0.689v10.707H15.63V4.922c0-0.381,0.309-0.689,0.689-0.689c0.38,0,0.688,0.309,0.688,0.689v11.396 C17.008,16.699,16.699,17.008,16.319,17.008z\"></path></g><g><path fill=\"#222A56\" d=\"M3.533,9.514h10.299c0.414,0,0.75,0.336,0.75,0.75s-0.336,0.75-0.75,0.75H3.533 c-0.414,0-0.75-0.336-0.75-0.75S3.119,9.514,3.533,9.514z\"></path></g><path fill=\"#222A56\" d=\"M3.316,1.177l4.879,5.586C8.259,6.827,8.336,6.877,8.42,6.912c0.168,0.069,0.357,0.069,0.525,0 C9.029,6.877,9.106,6.827,9.17,6.763l4.879-5.586c0.269-0.27,0.269-0.706,0-0.975c-0.125-0.125-0.287-0.187-0.451-0.195V0.003 h-0.021c-0.01,0-0.02,0-0.03,0H3.819C3.814,0.003,3.809,0,3.805,0C3.627,0,3.451,0.067,3.316,0.202 C3.048,0.471,3.048,0.907,3.316,1.177z\"></path></svg>"

/***/ }),

/***/ 858:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 211.7 22\" style=\"enable-background:new 0 0 211.7 22;\" xml:space=\"preserve\"><style type=\"text/css\"> .st00{fill:#9894AD;} .st11{fill:#FFFFFF;} </style><g><path class=\"st00\" d=\"M62,21.6V11.5c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2L60,17.4c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2v10.2h-2.8V0.3h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8v21.4H62z\"></path><path class=\"st00\" d=\"M69.8,21.6V0.3h6v2.5h-3.1v6.3h3v2.5h-3v7.6H76v2.5H69.8z\"></path><path class=\"st00\" d=\"M88.7,8.1c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5H86l-1.9-7.8 c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8V0.3h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8s0.8,0.8,1.1,1.4 c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C88.8,7,88.8,7.6,88.7,8.1z M86,6.3c0-0.9-0.1-1.6-0.4-2.2 c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8c0.2-0.3,0.3-0.6,0.5-0.9 c0.2-0.4,0.3-0.8,0.4-1.2C86,7.2,86.1,6.8,86,6.3L86,6.3z\"></path><path class=\"st00\" d=\"M91.6,21.6l3.6-18.8h-3.4V0.3h6.7l-3.6,18.9h3.9v2.5H91.6z\"></path></g><g><path class=\"st11\" d=\"M5.9,21.6l-2.8-8.5l-0.4-1.6c0,0.2,0,0.4,0,0.7c0,0.3,0,0.6,0,0.8v8.5H0V0.3h2.8l0,6.3c0,0.2,0,0.5,0,0.8 c0,0.3,0,0.5,0,0.7c0-0.2,0.1-0.4,0.2-0.7C3,7,3.1,6.8,3.2,6.6c1.4-4,2.1-6.2,2.1-6.3l2.8,0L4.8,9.7l4.1,12H5.9z\"></path><path class=\"st11\" d=\"M19.7,14.2c0,1.2,0,2.2-0.1,3.1c-0.1,0.8-0.2,1.6-0.5,2.3c-0.3,0.7-0.7,1.2-1.2,1.6c-0.6,0.4-1.3,0.6-2.2,0.6 c-0.9,0-1.6-0.2-2.2-0.6s-1-0.9-1.2-1.6c-0.3-0.7-0.4-1.4-0.5-2.3c-0.1-0.8-0.1-1.9-0.1-3.1v-14h2.8v14.6c0,1.5,0.1,2.6,0.2,3.3 c0.2,0.6,0.5,1,1,1s0.9-0.3,1-1c0.2-0.6,0.2-1.7,0.2-3.3V0.3h2.8L19.7,14.2L19.7,14.2z\"></path><path class=\"st11\" d=\"M32.8,8.1c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8l-1.9-7.8 c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8V0.3h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2C30,0.7,30.5,1,30.9,1.3 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7C32.9,5,32.9,5.6,33,6.3C33,7,32.9,7.6,32.8,8.1z M30.2,6.3 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 s0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C30.2,7.2,30.2,6.8,30.2,6.3L30.2,6.3z\"></path><path class=\"st11\" d=\"M40.7,2.8v18.8h-2.8V2.8h-2.7V0.3h8.2v2.5H40.7z\"></path><path class=\"st11\" d=\"M114.9,17.5c-0.2,0.5-0.4,1-0.8,1.4c-0.4,0.5-0.8,0.9-1.3,1.3c-0.5,0.4-1,0.8-1.6,1.1c-0.5,0.3-1,0.5-1.5,0.7 l-1.1-2.4c0.8-0.3,1.6-0.7,2.3-1.2c0.7-0.5,1.1-1,1.3-1.6c0.2-0.7,0.4-1.4,0.4-1.9c0-0.6-0.1-1.2-0.4-1.8s-0.7-1.3-1.4-2.2 c-0.9-1.1-1.5-2.1-1.9-2.9c-0.4-0.8-0.6-1.6-0.6-2.4c0-0.6,0.1-1.2,0.3-1.9c0.1-0.3,0.3-0.6,0.6-1s0.6-0.8,1-1.2 c0.4-0.4,0.8-0.7,1.2-1c0.4-0.3,0.8-0.5,1.1-0.5l1.1,2.1c-0.4,0.2-0.9,0.5-1.5,0.9c-0.5,0.5-0.9,0.9-1,1.4C111,4.8,111,5.2,111,5.6 c0,0.6,0.1,1.1,0.4,1.6c0.3,0.5,0.8,1.2,1.5,2.1c0,0,0.1,0.1,0.2,0.3c0.8,1,1.4,2,1.7,2.8c0.4,0.9,0.5,1.7,0.5,2.6 C115.4,15.7,115.3,16.6,114.9,17.5L114.9,17.5z\"></path><path class=\"st11\" d=\"M125.4,2.6c-0.4,0.1-0.6,0.2-0.9,0.3c-0.2,0.1-0.5,0.2-0.8,0.4c-0.5,0.3-0.9,0.6-1.2,0.9 c-0.3,0.3-0.6,0.7-0.8,1.1c-0.4,0.9-0.7,1.6-0.9,2.2c-0.2,0.6-0.3,1.4-0.3,2.3c0,1.2,0.1,2.2,0.2,3.1c0.2,0.9,0.4,1.8,0.8,2.6 c0.3,0.7,0.8,1.4,1.4,2.1c0.6,0.7,1.1,1.2,1.6,1.5l0.8,0.6l-1.5,2.2l-0.7-0.5c-0.7-0.5-1.5-1.2-2.2-2c-0.7-0.8-1.3-1.7-1.8-2.6 c-0.5-1.1-0.8-2.2-1.1-3.2c-0.2-1.1-0.3-2.3-0.3-3.7c0-1.2,0.2-2.2,0.4-3.1s0.7-1.8,1.3-2.9c0.4-0.6,0.8-1.1,1.2-1.5 c0.4-0.4,1-0.8,1.7-1.2c0.4-0.3,0.8-0.5,1.2-0.6c0.4-0.1,0.8-0.2,1.4-0.4L125.4,2.6L125.4,2.6z\"></path><path class=\"st11\" d=\"M133.5,21.6V11.6H131v10.1h-2.8V0.3h2.8v8.8h2.5V0.3h2.8v21.4H133.5z\"></path><path class=\"st11\" d=\"M150,21.6h-2.6l-1.1-6.4l-0.2-2.1l-0.2,2.1l-1,6.4h-2.7l-1.5-21.4h2.7l0.7,10c0,0.4,0,0.8,0,1.2 c0,0.4,0,0.8,0,1l0.4-2.2l1.5-6.8v0c0-0.3,0.1-0.5,0.1-0.5c0,0,0.1,0.1,0.1,0.4v0.1l1.5,6.8l0.4,2.2c0-0.2,0-0.6,0-1 c0-0.5,0-0.9,0.1-1.2l0.7-10h2.7L150,21.6z\"></path><path class=\"st11\" d=\"M156.1,21.6V0.3h2.8v21.4H156.1z\"></path><path class=\"st11\" d=\"M168.2,2.8v18.8h-2.8V2.8h-2.7V0.3h8.2v2.5H168.2z\"></path><path class=\"st11\" d=\"M178.2,2.8v18.8h-2.8V2.8h-2.7V0.3h8.2v2.5H178.2z\"></path><path class=\"st11\" d=\"M184,21.6V0.3h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3v2.5H184z\"></path><path class=\"st11\" d=\"M201.8,8.1c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8V0.3h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C202,7,202,7.6,201.8,8.1z M199.2,6.3 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 s0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C199.2,7.2,199.3,6.8,199.2,6.3L199.2,6.3z\"></path><path class=\"st11\" d=\"M211.3,17.5c-0.2,0.5-0.4,1-0.8,1.4c-0.4,0.5-0.8,0.9-1.3,1.3c-0.5,0.4-1,0.8-1.6,1.1c-0.5,0.3-1,0.5-1.5,0.7 l-1.1-2.4c0.8-0.3,1.6-0.7,2.3-1.2c0.7-0.5,1.1-1,1.3-1.6c0.2-0.7,0.4-1.4,0.4-1.9c0-0.6-0.1-1.2-0.4-1.8c-0.3-0.6-0.7-1.3-1.4-2.2 c-0.9-1.1-1.5-2.1-1.9-2.9c-0.4-0.8-0.6-1.6-0.6-2.4c0-0.6,0.1-1.2,0.3-1.9c0.1-0.3,0.3-0.6,0.6-1c0.3-0.4,0.6-0.8,1-1.2 s0.8-0.7,1.2-1c0.4-0.3,0.8-0.5,1.1-0.5l1.1,2.1c-0.4,0.2-0.9,0.5-1.5,0.9c-0.5,0.5-0.9,0.9-1,1.4c-0.1,0.4-0.2,0.8-0.2,1.2 c0,0.6,0.1,1.1,0.4,1.6s0.8,1.2,1.5,2.1c0,0,0.1,0.1,0.2,0.3c0.8,1,1.4,2,1.7,2.8c0.4,0.9,0.5,1.7,0.5,2.6 C211.7,15.7,211.6,16.6,211.3,17.5L211.3,17.5z\"></path></g></svg>"

/***/ }),

/***/ 859:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 159.5 22\" style=\"enable-background:new 0 0 159.5 22;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#FFFFFF;} </style><g><path class=\"st0\" d=\"M5.9,21.6l-2.8-8.5l-0.4-1.6c0,0.2,0,0.4,0,0.7c0,0.3,0,0.6,0,0.8v8.5H0V0.3h2.8l0,6.3c0,0.2,0,0.5,0,0.8 c0,0.3,0,0.5,0,0.7c0-0.2,0.1-0.4,0.2-0.7C3,7,3.1,6.8,3.2,6.6c1.4-4,2.1-6.2,2.1-6.3l2.8,0L4.8,9.7l4.1,12H5.9z\"></path><path class=\"st0\" d=\"M19.7,14.2c0,1.2,0,2.2-0.1,3.1c-0.1,0.8-0.2,1.6-0.5,2.3c-0.3,0.7-0.7,1.2-1.2,1.6c-0.6,0.4-1.3,0.6-2.2,0.6 c-0.9,0-1.6-0.2-2.2-0.6c-0.6-0.4-1-0.9-1.2-1.6c-0.3-0.7-0.4-1.4-0.5-2.3c-0.1-0.8-0.1-1.9-0.1-3.1v-14h2.8v14.6 c0,1.5,0.1,2.6,0.2,3.3c0.2,0.6,0.5,1,1,1c0.5,0,0.9-0.3,1-1c0.2-0.6,0.2-1.7,0.2-3.3V0.3h2.8L19.7,14.2L19.7,14.2z\"></path><path class=\"st0\" d=\"M32.8,8.1c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8l-1.9-7.8 c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8V0.3h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2C30,0.7,30.5,1,30.9,1.3 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7C32.9,5,32.9,5.6,33,6.3C33,7,32.9,7.6,32.8,8.1z M30.2,6.3 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C30.2,7.2,30.2,6.8,30.2,6.3L30.2,6.3z\"></path><path class=\"st0\" d=\"M40.7,2.8v18.8h-2.8V2.8h-2.7V0.3h8.2v2.5H40.7z\"></path><path class=\"st0\" d=\"M62.7,17.5c-0.2,0.5-0.4,1-0.8,1.4c-0.4,0.5-0.8,0.9-1.3,1.3c-0.5,0.4-1,0.8-1.6,1.1c-0.5,0.3-1,0.5-1.5,0.7 l-1.1-2.4c0.8-0.3,1.6-0.7,2.3-1.2c0.7-0.5,1.1-1,1.3-1.6c0.2-0.7,0.4-1.4,0.4-1.9c0-0.6-0.1-1.2-0.4-1.8c-0.3-0.6-0.7-1.3-1.4-2.2 c-0.9-1.1-1.5-2.1-1.9-2.9c-0.4-0.8-0.6-1.6-0.6-2.4c0-0.6,0.1-1.2,0.3-1.9c0.1-0.3,0.3-0.6,0.6-1c0.3-0.4,0.6-0.8,1-1.2 c0.4-0.4,0.8-0.7,1.2-1C59.7,0.3,60,0.1,60.3,0l1.1,2.1C61,2.3,60.5,2.6,60,3.1c-0.5,0.5-0.9,0.9-1,1.4c-0.1,0.4-0.2,0.8-0.2,1.2 c0,0.6,0.1,1.1,0.4,1.6c0.3,0.5,0.8,1.2,1.5,2.1c0,0,0.1,0.1,0.2,0.3c0.8,1,1.4,2,1.7,2.8c0.4,0.9,0.5,1.7,0.5,2.6 C63.2,15.7,63.1,16.6,62.7,17.5L62.7,17.5z\"></path><path class=\"st0\" d=\"M73.2,2.6c-0.4,0.1-0.6,0.2-0.9,0.3c-0.2,0.1-0.5,0.2-0.8,0.4c-0.5,0.3-0.9,0.6-1.2,0.9 c-0.3,0.3-0.6,0.7-0.8,1.1c-0.4,0.9-0.7,1.6-0.9,2.2c-0.2,0.6-0.3,1.4-0.3,2.3c0,1.2,0.1,2.2,0.2,3.1c0.2,0.9,0.4,1.8,0.8,2.6 c0.3,0.7,0.8,1.4,1.4,2.1c0.6,0.7,1.1,1.2,1.6,1.5l0.8,0.6l-1.5,2.2L71,21.4c-0.7-0.5-1.5-1.2-2.2-2c-0.7-0.8-1.3-1.7-1.8-2.6 c-0.5-1.1-0.8-2.2-1.1-3.2c-0.2-1.1-0.3-2.3-0.3-3.7c0-1.2,0.2-2.2,0.4-3.1c0.2-0.9,0.7-1.8,1.3-2.9c0.4-0.6,0.8-1.1,1.2-1.5 c0.4-0.4,1-0.8,1.6-1.2c0.4-0.3,0.8-0.5,1.2-0.6c0.4-0.1,0.8-0.2,1.4-0.4L73.2,2.6L73.2,2.6z\"></path><path class=\"st0\" d=\"M81.3,21.6V11.6h-2.5v10.1H76V0.3h2.8v8.8h2.5V0.3h2.8v21.4H81.3z\"></path><path class=\"st0\" d=\"M97.8,21.6h-2.6l-1.1-6.4l-0.2-2.1l-0.2,2.1l-1,6.4H90L88.5,0.3h2.7l0.7,10c0,0.4,0,0.8,0,1.2c0,0.4,0,0.8,0,1 l0.4-2.2l1.5-6.8v0c0-0.3,0.1-0.5,0.1-0.5C94,3,94,3.1,94,3.4v0.1l1.5,6.8l0.4,2.2c0-0.2,0-0.6,0-1c0-0.5,0-0.9,0.1-1.2l0.7-10h2.7 L97.8,21.6z\"></path><path class=\"st0\" d=\"M103.9,21.6V0.3h2.8v21.4H103.9z\"></path><path class=\"st0\" d=\"M116,2.8v18.8h-2.8V2.8h-2.7V0.3h8.2v2.5H116z\"></path><path class=\"st0\" d=\"M126,2.8v18.8h-2.8V2.8h-2.7V0.3h8.2v2.5H126z\"></path><path class=\"st0\" d=\"M131.8,21.6V0.3h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3v2.5H131.8z\"></path><path class=\"st0\" d=\"M149.6,8.1c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5H147l-1.9-7.8 c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8V0.3h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C149.8,7,149.8,7.6,149.6,8.1z M147,6.3 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C147,7.2,147,6.8,147,6.3L147,6.3z\"></path><path class=\"st0\" d=\"M159.1,17.5c-0.2,0.5-0.4,1-0.8,1.4c-0.4,0.5-0.8,0.9-1.3,1.3c-0.5,0.4-1,0.8-1.6,1.1c-0.5,0.3-1,0.5-1.5,0.7 l-1.1-2.4c0.8-0.3,1.6-0.7,2.3-1.2c0.7-0.5,1.1-1,1.3-1.6c0.2-0.7,0.4-1.4,0.4-1.9c0-0.6-0.1-1.2-0.4-1.8c-0.3-0.6-0.7-1.3-1.4-2.2 c-0.9-1.1-1.5-2.1-1.9-2.9c-0.4-0.8-0.6-1.6-0.6-2.4c0-0.6,0.1-1.2,0.3-1.9c0.1-0.3,0.3-0.6,0.6-1c0.3-0.4,0.6-0.8,1-1.2 c0.4-0.4,0.8-0.7,1.2-1c0.4-0.3,0.8-0.5,1.1-0.5l1.1,2.1c-0.4,0.2-0.9,0.5-1.5,0.9c-0.5,0.5-0.9,0.9-1,1.4 c-0.1,0.4-0.2,0.8-0.2,1.2c0,0.6,0.1,1.1,0.4,1.6c0.3,0.5,0.8,1.2,1.5,2.1c0,0,0.1,0.1,0.2,0.3c0.8,1,1.4,2,1.7,2.8 c0.4,0.9,0.5,1.7,0.5,2.6C159.5,15.7,159.4,16.6,159.1,17.5L159.1,17.5z\"></path></g></svg>"

/***/ }),

/***/ 860:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 19.844 19.843\" style=\"enable-background:new 0 0 19.844 19.843;\" xml:space=\"preserve\"><g><path style=\"fill:#C5C5C5;\" d=\"M18.852,0H0.992C0.447,0,0,0.446,0,0.992v17.858c0,0.546,0.447,0.992,0.992,0.992h17.859 c0.545,0,0.992-0.446,0.992-0.992V0.992C19.844,0.446,19.396,0,18.852,0z M18.852,18.155c0,0.382-0.312,0.694-0.695,0.694H1.688 c-0.383,0-0.695-0.312-0.695-0.694V1.687c0-0.382,0.312-0.694,0.695-0.694h16.469c0.383,0,0.695,0.312,0.695,0.694V18.155z M2.975,5.5L9.92,9.917l-6.945,4.422v2.007l10.42-6.43L2.975,3.495V5.5z M14.545,16.299h1.701V3.543h-1.701V16.299z\"></path></g></svg>"

/***/ }),

/***/ 861:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 19.842 19.844\" enable-background=\"new 0 0 19.842 19.844\" xml:space=\"preserve\"><g><path fill=\"#5588CC\" d=\"M18.852,0H0.992C0.447,0,0,0.446,0,0.992V18.85c0,0.546,0.447,0.992,0.992,0.992h17.859 c0.545,0,0.992-0.446,0.992-0.992V0.992C19.844,0.446,19.396,0,18.852,0z M18.852,18.155c0,0.382-0.312,0.694-0.695,0.694H1.688 c-0.383,0-0.695-0.312-0.695-0.694V1.686c0-0.382,0.312-0.694,0.695-0.694h16.469c0.383,0,0.695,0.312,0.695,0.694V18.155z M2.975,5.5L9.92,9.916l-6.945,4.423v2.007l10.42-6.43L2.975,3.495V5.5z M14.545,16.299h1.701V3.543h-1.701V16.299z\"></path></g></svg>"

/***/ }),

/***/ 862:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17.1 17.1\" style=\"enable-background:new 0 0 17.1 17.1;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#092957;} </style><g><path class=\"st0\" d=\"M7.2,7.2H0V0h7.2V7.2z M1.6,5.7h4.2V1.5H1.6V5.7z\"></path></g><g><path class=\"st0\" d=\"M17.1,7.2H9.9V0h7.2V7.2z M11.4,5.7h4.2V1.5h-4.2V5.7z\"></path></g><g><path class=\"st0\" d=\"M7.2,17.1H0V9.9h7.2V17.1z M1.6,15.6h4.2v-4.2H1.6V15.6z\"></path></g><g><path class=\"st0\" d=\"M17.1,17.1H9.9V9.9h7.2V17.1z M11.4,15.6h4.2v-4.2h-4.2V15.6z\"></path></g></svg>"

/***/ }),

/***/ 863:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 81.646 128.227\" enable-background=\"new 0 0 81.646 128.227\" xml:space=\"preserve\"><g><path fill=\"red\" d=\"M0,0v128.227h81.646V0H0z M78.195,124.777H3.451V3.45h74.744V124.777z\"></path><path fill=\"red\" d=\"M23.233,42.155c0-0.33-0.012-0.731-0.033-1.204c-0.021-0.474-0.044-0.819-0.065-1.04l0.527,2.244 l1.552,5.874c0.021,0.022,0.043,0.066,0.065,0.132c0.066,0.221,0.11,0.33,0.132,0.33c0.066,0,0.132-0.153,0.198-0.462l1.551-5.874 l0.562-2.244c-0.022,0.221-0.045,0.566-0.066,1.04c-0.022,0.473-0.033,0.874-0.033,1.204v10.164h2.838V30.935h-2.771l-2.046,7.854 c-0.045,0.11-0.088,0.292-0.132,0.545c-0.045,0.253-0.078,0.457-0.1,0.61c-0.021-0.153-0.049-0.341-0.082-0.561 s-0.072-0.418-0.115-0.595l-2.079-7.854h-2.739v21.384h2.838V42.155z\"></path><polygon fill=\"red\" points=\"41.118,49.811 37.818,49.811 37.818,42.253 40.788,42.253 40.788,39.746 37.818,39.746 37.818,33.476 40.953,33.476 40.953,30.935 34.98,30.935 34.98,52.319 41.118,52.319 \"></polygon><path fill=\"red\" d=\"M47.422,44.828c0.11-0.065,0.297-0.165,0.562-0.297l1.946,7.788h2.806l-2.344-9.471 c0.352-0.352,0.638-0.704,0.858-1.057c0.22-0.352,0.45-0.78,0.693-1.287c0.308-0.659,0.521-1.248,0.643-1.765 s0.182-1.095,0.182-1.732c-0.021-0.748-0.099-1.381-0.23-1.898c-0.132-0.517-0.363-1.072-0.693-1.666 c-0.352-0.594-0.731-1.072-1.139-1.436s-0.919-0.644-1.534-0.842c-0.264-0.109-0.518-0.176-0.759-0.197 c-0.242-0.022-0.583-0.033-1.023-0.033h-2.805v21.384h2.838V44.828z M47.422,33.476c0.308,0,0.615,0.065,0.924,0.198 c0.528,0.176,0.924,0.561,1.188,1.154c0.285,0.572,0.429,1.299,0.429,2.179l0.033,0.032c0,0.462-0.033,0.864-0.1,1.205 c-0.065,0.341-0.187,0.731-0.362,1.171c-0.154,0.375-0.319,0.688-0.495,0.94c-0.177,0.254-0.407,0.523-0.693,0.809 c-0.264,0.309-0.572,0.562-0.924,0.76V33.476z\"></path><polygon fill=\"red\" points=\"62.239,52.319 62.239,49.811 58.378,49.811 61.976,30.935 55.31,30.935 55.31,33.476 58.675,33.476 55.078,52.319 \"></polygon><path fill=\"red\" d=\"M39.684,92.315v-2.508h-4.092c0-0.813,0.032-1.463,0.099-1.947c0.109-0.638,0.236-1.166,0.38-1.584 c0.143-0.418,0.379-1.012,0.709-1.782l0.066-0.165c0.22-0.506,0.506-1.133,0.857-1.881c0.418-0.88,0.727-1.551,0.924-2.013 c0.309-0.792,0.556-1.519,0.743-2.178c0.187-0.66,0.28-1.32,0.28-1.98c0-0.858-0.16-1.639-0.479-2.343 c-0.319-0.704-0.754-1.309-1.304-1.815c-0.418-0.374-0.919-0.671-1.501-0.891c-0.583-0.22-1.194-0.374-1.832-0.462l-0.396,2.508 c0.989,0.22,1.672,0.539,2.046,0.957c0.55,0.55,0.825,1.232,0.825,2.046c0,0.462-0.066,0.919-0.198,1.369 c-0.132,0.451-0.319,0.952-0.562,1.502l-0.099,0.264c-0.154,0.375-0.418,0.969-0.792,1.782c-0.418,0.858-0.737,1.562-0.957,2.112 c-0.396,0.924-0.677,1.639-0.842,2.145c-0.165,0.507-0.313,1.167-0.445,1.98c-0.088,0.506-0.144,0.93-0.165,1.271 s-0.033,0.742-0.033,1.204c0,0.528,0.022,1.331,0.066,2.409H39.684z\"></path><path fill=\"red\" d=\"M46.283,89.708c-0.221,0-0.413-0.187-0.578-0.561s-0.291-0.869-0.379-1.485l-2.772,0.265 c0.242,1.54,0.698,2.679,1.37,3.415c0.671,0.737,1.446,1.105,2.326,1.105c0.506,0,0.99-0.132,1.452-0.396 c0.462-0.265,0.88-0.688,1.254-1.271s0.671-1.342,0.891-2.277c0.22-0.935,0.33-2.051,0.33-3.35c0-1.188-0.104-2.211-0.313-3.069 c-0.209-0.857-0.489-1.556-0.842-2.095c-0.352-0.539-0.737-0.936-1.154-1.188c-0.418-0.253-0.848-0.379-1.287-0.379 c-0.286,0-0.501,0.049-0.644,0.148c-0.144,0.099-0.27,0.214-0.38,0.346l0.363-5.444h3.168v-2.541h-5.379L42.95,81.854h2.31 c0.11-0.242,0.236-0.435,0.38-0.577c0.143-0.144,0.347-0.215,0.61-0.215c0.33,0.022,0.594,0.457,0.792,1.304 s0.297,1.776,0.297,2.788c0,1.188-0.094,2.244-0.28,3.168C46.871,89.246,46.613,89.708,46.283,89.708z\"></path></g></svg>"

/***/ }),

/***/ 864:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 19.842 19.843\" style=\"enable-background:new 0 0 19.842 19.843;\" xml:space=\"preserve\"><g><path style=\"fill:#C5C5C5;\" d=\"M18.85,0H0.992C0.445,0,0,0.446,0,0.992v17.858c0,0.546,0.445,0.992,0.992,0.992H18.85 c0.547,0,0.992-0.446,0.992-0.992V0.992C19.842,0.446,19.396,0,18.85,0z M18.85,18.156c0,0.382-0.312,0.694-0.693,0.694H1.686 c-0.381,0-0.693-0.312-0.693-0.694V1.688c0-0.382,0.312-0.694,0.693-0.694h16.471c0.381,0,0.693,0.312,0.693,0.694V18.156z M5.1,5.504l7.654,4.422L5.1,14.343v2.005l11.129-6.421L5.1,3.497V5.504z\"></path></g></svg>"

/***/ }),

/***/ 865:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 19.842 19.844\" enable-background=\"new 0 0 19.842 19.844\" xml:space=\"preserve\"><g><path fill=\"#5588CC\" d=\"M18.85,0H0.992C0.445,0,0,0.446,0,0.992V18.85c0,0.546,0.445,0.992,0.992,0.992H18.85 c0.547,0,0.992-0.446,0.992-0.992V0.992C19.842,0.446,19.396,0,18.85,0z M18.85,18.156c0,0.382-0.312,0.694-0.693,0.694H1.686 c-0.381,0-0.693-0.312-0.693-0.694V1.687c0-0.382,0.312-0.694,0.693-0.694h16.471c0.381,0,0.693,0.312,0.693,0.694V18.156z M5.1,5.504l7.654,4.422L5.1,14.343v2.005l11.129-6.422L5.1,3.496V5.504z\"></path></g></svg>"

/***/ }),

/***/ 866:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17 17\" style=\"enable-background:new 0 0 17 17;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#092957;} </style><g><path class=\"st0\" d=\"M0,0v17h17V0H0z M15.6,15.7H1.3V1.4h14.3V15.7z\"></path></g><g><path class=\"st0\" d=\"M2.7,3.9v1.4h5.5V3.9H2.7z\"></path></g><g><path class=\"st0\" d=\"M2.7,7.8v1.4h5.5V7.8H2.7z\"></path></g><g><path class=\"st0\" d=\"M11.1,3.9v1.4h3V3.9H11.1z\"></path></g><g><path class=\"st0\" d=\"M11.1,7.8v1.4h3V7.8H11.1z\"></path></g><g><path class=\"st0\" d=\"M11.1,11.8v1.4h3v-1.4H11.1z\"></path></g><g><g><path class=\"st0\" d=\"M10.3,2.7H9.1v7.6c-0.8-0.3-1.9-0.4-3-0.1c-2,0.5-3.3,1.9-3,3.1c0.3,1.2,2.2,1.8,4.1,1.3c1.8-0.5,3-1.6,3-2.7 V2.7H10.3z\"></path></g></g></svg>"

/***/ }),

/***/ 867:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17 17\" style=\"enable-background:new 0 0 17 17;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#092957;} </style><polygon class=\"st0\" points=\"14,9 14,2.9 7.9,2.9 7.9,4.4 11.5,4.4 8.6,7.2 9.7,8.3 12.5,5.4 12.5,9 \"></polygon><polygon class=\"st0\" points=\"5.4,12.5 8.3,9.7 7.2,8.6 4.4,11.5 4.4,7.9 2.9,7.9 2.9,14 9,14 9,12.5 \"></polygon><g><path class=\"st0\" d=\"M0,0v17h17V0H0z M15.6,15.6H1.3V1.3h14.3V15.6z\"></path></g></svg>"

/***/ }),

/***/ 868:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17.008 17.008\" enable-background=\"new 0 0 17.008 17.008\" xml:space=\"preserve\"><g><path fill=\"#27225D\" d=\"M0,0v17.008h17.008V0H0z M15.63,15.629H1.378V1.378H15.63V15.629z\"></path><circle fill=\"#27225D\" cx=\"8.504\" cy=\"4.949\" r=\"2.377\"></circle><path fill=\"#27225D\" d=\"M8.519,7.326c-3.211,0-3.765,3.41-3.765,6.903h7.529C12.283,10.736,11.729,7.326,8.519,7.326z\"></path></g></svg>"

/***/ }),

/***/ 869:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 21 21\" style=\"enable-background:new 0 0 21 21;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#092957;} </style><g><path class=\"st0\" d=\"M21,21H0V0h21V21z M1.2,19.8h18.6V1.2H1.2V19.8z\"></path></g><g><g><path class=\"st0\" d=\"M10.5,18.5c-4.4,0-8-3.6-8-8c0-4.4,3.6-8,8-8s8,3.6,8,8C18.5,14.9,14.9,18.5,10.5,18.5z M10.5,3.8 c-3.7,0-6.8,3-6.8,6.8c0,3.7,3,6.8,6.8,6.8c3.7,0,6.8-3,6.8-6.8C17.3,6.8,14.3,3.8,10.5,3.8z\"></path></g></g><path class=\"st0\" d=\"M9.2,15.3l5-4.4c0.1-0.1,0.1-0.1,0.1-0.2c0.1-0.2,0.1-0.3,0-0.5c0-0.1-0.1-0.1-0.1-0.2l-5-4.4 c-0.2-0.2-0.6-0.2-0.9,0C8.2,5.8,8.1,6,8.1,6.1c0,0,0,8.8,0,8.8c0,0.2,0.1,0.3,0.2,0.4C8.5,15.6,8.9,15.6,9.2,15.3z\"></path></svg>"

/***/ }),

/***/ 870:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 19.844 19.843\" style=\"enable-background:new 0 0 19.844 19.843;\" xml:space=\"preserve\"><g><path style=\"fill:#C5C5C5;\" d=\"M18.852,0H0.992C0.447,0,0,0.446,0,0.992v17.858c0,0.546,0.447,0.992,0.992,0.992h17.859 c0.545,0,0.992-0.446,0.992-0.992V0.992C19.844,0.446,19.396,0,18.852,0z M18.852,18.156c0,0.382-0.312,0.694-0.695,0.694H1.688 c-0.383,0-0.695-0.312-0.695-0.694V1.688c0-0.382,0.312-0.694,0.695-0.694h16.469c0.383,0,0.695,0.312,0.695,0.694V18.156z M14.742,16.348v-2.005L7.088,9.926l7.654-4.422V3.497L3.613,9.926L14.742,16.348z\"></path></g></svg>"

/***/ }),

/***/ 871:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 19.842 19.844\" enable-background=\"new 0 0 19.842 19.844\" xml:space=\"preserve\"><g><path fill=\"#5588CC\" d=\"M18.852,0H0.992C0.447,0,0,0.446,0,0.992V18.85c0,0.546,0.447,0.992,0.992,0.992h17.859 c0.545,0,0.992-0.446,0.992-0.992V0.992C19.844,0.446,19.396,0,18.852,0z M18.852,18.156c0,0.382-0.312,0.694-0.695,0.694H1.688 c-0.383,0-0.695-0.312-0.695-0.694V1.687c0-0.382,0.312-0.694,0.695-0.694h16.469c0.383,0,0.695,0.312,0.695,0.694V18.156z M14.742,16.347v-2.005L7.088,9.926l7.654-4.422V3.496L3.613,9.926L14.742,16.347z\"></path></g></svg>"

/***/ }),

/***/ 872:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 19.2 21.2\" style=\"enable-background:new 0 0 19.2 21.2;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#062956;stroke:#062956;stroke-width:1.2;stroke-miterlimit:10;} .st1{fill:none;stroke:#062956;stroke-width:1.2;stroke-miterlimit:10;} </style><rect x=\"0.6\" y=\"0.6\" class=\"st1\" width=\"18\" height=\"20\"></rect><rect x=\"5\" y=\"6\" class=\"st0\" width=\"8\" height=\"8\"></rect></svg>"

/***/ }),

/***/ 873:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17 17\" style=\"enable-background:new 0 0 17 17;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#FFFFFF;} </style><g id=\"Ebene_1\"></g><g id=\"Ebene_2\"></g><g id=\"Ebene_3\"><path class=\"st0\" d=\"M0,0v17h17V0H0z M15.9,15.9H1.1V1.1h14.7V15.9z\"></path><rect x=\"4\" y=\"4\" class=\"st0\" width=\"9.1\" height=\"9.1\"></rect></g></svg>"

/***/ }),

/***/ 874:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17.5 17.5\" style=\"enable-background:new 0 0 17.5 17.5;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#FFFFFF;} .st1{fill:#009033;} </style><g id=\"Ebene_1\"><rect class=\"st0\" width=\"17.5\" height=\"17.5\"></rect><rect x=\"0.5\" y=\"0.5\" class=\"st1\" width=\"16.5\" height=\"16.5\"></rect></g><g id=\"Ebene_2\"></g><g id=\"Ebene_3\"></g></svg>"

/***/ }),

/***/ 875:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17.5 17.5\" style=\"enable-background:new 0 0 17.5 17.5;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#FFFFFF;} .st1{fill:#009033;} .st2{fill:#0066BB;} </style><g id=\"Ebene_1\"><rect class=\"st0\" width=\"17.5\" height=\"17.5\"></rect><rect x=\"0.5\" y=\"0.5\" class=\"st1\" width=\"8\" height=\"16.5\"></rect><rect x=\"9\" y=\"0.5\" class=\"st2\" width=\"8\" height=\"16.5\"></rect></g><g id=\"Ebene_2\"></g><g id=\"Ebene_3\"></g></svg>"

/***/ }),

/***/ 876:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17.5 17.5\" style=\"enable-background:new 0 0 17.5 17.5;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#FFFFFF;} .st1{fill:#009033;} .st2{fill:#F29400;} .st3{fill:#931177;} </style><g id=\"Ebene_1\"><rect class=\"st0\" width=\"17.5\" height=\"17.5\"></rect><polygon class=\"st1\" points=\"0.5,17 0.5,0.5 8.5,0.5 8.5,4.3 4.2,4.3 4.2,13.3 8.5,13.3 8.5,17 \"></polygon><polygon class=\"st2\" points=\"17,17 9,17 9,13.3 13.3,13.3 13.3,4.3 9,4.3 9,0.5 17,0.5 \"></polygon><rect x=\"4.8\" y=\"4.8\" class=\"st3\" width=\"8\" height=\"8\"></rect></g><g id=\"Ebene_2\"></g><g id=\"Ebene_3\"></g></svg>"

/***/ }),

/***/ 877:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17.5 17.5\" style=\"enable-background:new 0 0 17.5 17.5;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#FFFFFF;} .st1{fill:#009033;} .st2{fill:#FFDC00;} .st3{fill:#0066BB;} .st4{fill:#F29400;} </style><g id=\"Ebene_1\"><rect y=\"0\" class=\"st0\" width=\"17.5\" height=\"17.5\"></rect><rect x=\"9\" y=\"0.5\" class=\"st1\" width=\"8\" height=\"8\"></rect><rect x=\"0.5\" y=\"0.5\" class=\"st2\" width=\"8\" height=\"8\"></rect><rect x=\"0.5\" y=\"9\" class=\"st3\" width=\"8\" height=\"8\"></rect><rect x=\"9\" y=\"9\" class=\"st4\" width=\"8\" height=\"8\"></rect></g><g id=\"Ebene_2\"></g><g id=\"Ebene_3\"></g></svg>"

/***/ }),

/***/ 878:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17.5 17.5\" style=\"enable-background:new 0 0 17.5 17.5;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#FFFFFF;} .st1{fill:#009033;} .st2{fill:#FFDC00;} .st3{fill:#0066BB;} .st4{fill:#F29400;} .st5{fill:#931177;} </style><g id=\"Ebene_1\"><rect y=\"0\" class=\"st0\" width=\"17.5\" height=\"17.5\"></rect><polygon class=\"st1\" points=\"13.3,8.5 17,8.5 17,0.5 9,0.5 9,4.3 13.3,4.3 \"></polygon><polygon class=\"st2\" points=\"8.5,4.3 8.5,0.5 0.5,0.5 0.5,8.5 4.3,8.5 4.3,4.3 \"></polygon><polygon class=\"st3\" points=\"4.3,9 0.5,9 0.5,17 8.5,17 8.5,13.3 4.3,13.3 \"></polygon><polygon class=\"st4\" points=\"9,13.3 9,17 17,17 17,9 13.3,9 13.3,13.3 \"></polygon><rect x=\"4.8\" y=\"4.8\" class=\"st5\" width=\"8\" height=\"8\"></rect></g><g id=\"Ebene_2\"></g><g id=\"Ebene_3\"></g></svg>"

/***/ }),

/***/ 879:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17 17\" style=\"enable-background:new 0 0 17 17;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#FFFFFF;} </style><g id=\"Ebene_1\"></g><g id=\"Ebene_2\"></g><g id=\"Ebene_3\"><path class=\"st0\" d=\"M0,0v17h17V0H0z M15.9,15.9H1.1V1.1h14.7V15.9z\"></path><path class=\"st0\" d=\"M4,4V13H13V4H4z M11.9,11.9H5.1V5.1h6.8V11.9z\"></path></g></svg>"

/***/ }),

/***/ 880:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17.008 17.008\" enable-background=\"new 0 0 17.008 17.008\" xml:space=\"preserve\"><path fill=\"#222A56\" d=\"M0,0v17.008h17.008V0H0z M15.874,15.025l-2.835-2.836V3.968H4.817L1.982,1.133h13.892V15.025z M5.103,5.951 l5.954,5.953H5.103V5.951z M5.951,5.102h5.954v5.955L5.951,5.102z M1.134,1.982l2.834,2.834v8.223h8.223l2.835,2.834H1.134V1.982z\"></path></svg>"

/***/ }),

/***/ 881:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17 17\" style=\"enable-background:new 0 0 17 17;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#092957;} </style><polygon class=\"st0\" points=\"13.8,4.2 12.8,3.2 8.5,7.5 4.2,3.2 3.1,4.2 6.2,7.4 7.4,8.5 3.1,12.8 4.2,13.9 8.5,9.6 12.8,13.9 13.8,12.8 9.5,8.5 \"></polygon><g><path class=\"st0\" d=\"M0,0v17h17V0H0z M15.6,15.6H1.3V1.3h14.3V15.6z\"></path></g></svg>"

/***/ }),

/***/ 882:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 1059.19 563.8\" style=\"enable-background:new 0 0 1059.19 563.8;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#E42522;} .st1{opacity:0.4;} .st2{fill:#FFFFFF;} </style><g><defs><rect id=\"SVGID_1_\" y=\"341.4\" width=\"140.9\" height=\"117.9\"></rect></defs><use xlink:href=\"#SVGID_1_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_2_\"><use xlink:href=\"#SVGID_1_\" style=\"overflow:visible;\"></use></clipPath></g><g><defs><rect id=\"SVGID_3_\" x=\"153.7\" y=\"341.6\" width=\"116.9\" height=\"151\"></rect></defs><use xlink:href=\"#SVGID_3_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_4_\"><use xlink:href=\"#SVGID_3_\" style=\"overflow:visible;\"></use></clipPath></g><g><defs><rect id=\"SVGID_5_\" x=\"283.4\" y=\"341.5\" width=\"89.1\" height=\"138\"></rect></defs><use xlink:href=\"#SVGID_5_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_6_\"><use xlink:href=\"#SVGID_5_\" style=\"overflow:visible;\"></use></clipPath></g><g><defs><rect id=\"SVGID_7_\" x=\"386.9\" y=\"423\" width=\"92\" height=\"140.9\"></rect></defs><use xlink:href=\"#SVGID_7_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_8_\"><use xlink:href=\"#SVGID_7_\" style=\"overflow:visible;\"></use></clipPath></g><g><defs><rect id=\"SVGID_9_\" x=\"493.7\" y=\"423\" width=\"178.2\" height=\"120.8\"></rect></defs><use xlink:href=\"#SVGID_9_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_10_\"><use xlink:href=\"#SVGID_9_\" style=\"overflow:visible;\"></use></clipPath></g><g><defs><rect id=\"SVGID_11_\" x=\"385.6\" y=\"147.1\" width=\"209.3\" height=\"262.8\"></rect></defs><use xlink:href=\"#SVGID_11_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_12_\"><use xlink:href=\"#SVGID_11_\" style=\"overflow:visible;\"></use></clipPath></g><g><defs><rect id=\"SVGID_13_\" x=\"898.4\" y=\"196.4\" width=\"101\" height=\"128.2\"></rect></defs><use xlink:href=\"#SVGID_13_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_14_\"><use xlink:href=\"#SVGID_13_\" style=\"overflow:visible;\"></use></clipPath></g><g><defs><rect id=\"SVGID_15_\" x=\"16.1\" y=\"0.3\" width=\"81.6\" height=\"128.2\"></rect></defs><use xlink:href=\"#SVGID_15_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_16_\"><use xlink:href=\"#SVGID_15_\" style=\"overflow:visible;\"></use></clipPath></g><rect x=\"686.1\" y=\"384.4\" id=\"SVGID_st22_\" class=\"st0\" width=\"81.6\" height=\"128.2\"></rect><rect x=\"782.3\" y=\"384.4\" id=\"SVGID_st23_\" class=\"st0\" width=\"81.6\" height=\"128.2\"></rect><rect x=\"977\" y=\"384.4\" id=\"SVGID_st25_\" class=\"st0\" width=\"81.6\" height=\"128.2\"></rect><rect x=\"756.9\" class=\"st0\" id=\"SVGID_st10_\" width=\"81.6\" height=\"128.2\"></rect><g><defs><rect id=\"SVGID_17_\" x=\"16.1\" y=\"143.2\" width=\"81.7\" height=\"128.2\"></rect></defs><use xlink:href=\"#SVGID_17_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_18_\"><use xlink:href=\"#SVGID_17_\" style=\"overflow:visible;\"></use></clipPath></g><g><defs><rect id=\"SVGID_19_\" x=\"513.6\" y=\"0.2\" width=\"81.7\" height=\"128.2\"></rect></defs><use xlink:href=\"#SVGID_19_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_20_\"><use xlink:href=\"#SVGID_19_\" style=\"overflow:visible;\"></use></clipPath></g><g><defs><rect id=\"SVGID_21_\" x=\"608.7\" y=\"0.2\" width=\"135.1\" height=\"181.1\"></rect></defs><use xlink:href=\"#SVGID_21_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_22_\"><use xlink:href=\"#SVGID_21_\" style=\"overflow:visible;\"></use></clipPath></g><g><defs><rect id=\"SVGID_23_\" x=\"608.9\" y=\"196.4\" width=\"134\" height=\"174.2\"></rect></defs><use xlink:href=\"#SVGID_23_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_24_\"><use xlink:href=\"#SVGID_23_\" style=\"overflow:visible;\"></use></clipPath></g><g><defs><rect id=\"SVGID_25_\" x=\"758\" y=\"196.5\" width=\"126.5\" height=\"167.3\"></rect></defs><use xlink:href=\"#SVGID_25_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_26_\"><use xlink:href=\"#SVGID_25_\" style=\"overflow:visible;\"></use></clipPath></g><g><defs><rect id=\"SVGID_27_\" x=\"386.5\" y=\"0.4\" width=\"85.1\" height=\"133.4\"></rect></defs><use xlink:href=\"#SVGID_27_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_28_\"><use xlink:href=\"#SVGID_27_\" style=\"overflow:visible;\"></use></clipPath></g><g><defs><rect id=\"SVGID_29_\" x=\"111.7\" y=\"0.4\" width=\"260.5\" height=\"327.8\"></rect></defs><use xlink:href=\"#SVGID_29_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_30_\"><use xlink:href=\"#SVGID_29_\" style=\"overflow:visible;\"></use></clipPath></g><g class=\"st1\" id=\"SVGID_st10_g\"><path class=\"st2\" d=\"M784,53V42.8c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2V53h-2.8V31.6h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8V53H784z\"></path><path class=\"st2\" d=\"M791.7,53V31.6h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3V53H791.7z\"></path><path class=\"st2\" d=\"M809.6,39.4c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5H807 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3V53h-2.8V31.6h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 s0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C809.8,38.3,809.8,38.9,809.6,39.4z M807,37.7 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 s0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C807,38.6,807,38.2,807,37.7L807,37.7z\"></path><path class=\"st2\" d=\"M812.5,53l3.6-18.8h-3.4v-2.5h6.7l-3.6,18.9h3.9V53H812.5z\"></path><path class=\"st2\" d=\"M791.1,93l0-16.8c0-0.1,0-0.3,0-0.5c0-0.2,0.1-0.3,0.1-0.4c0,0.1-0.1,0.2-0.1,0.4S791,76,790.9,76l-0.7,1 l-1.9-1.5l3-3.9h2.5V93H791.1z\"></path><path class=\"st2\" d=\"M806.8,81.6c0,1.5-0.1,3-0.2,4.3c-0.1,1.3-0.3,2.5-0.7,3.6c-0.3,1.1-0.8,2-1.4,2.6c-0.6,0.6-1.3,1-2.2,1 c-0.9,0-1.6-0.3-2.2-1c-0.6-0.7-1-1.5-1.4-2.6c-0.3-1.1-0.5-2.3-0.7-3.6s-0.2-2.8-0.2-4.3c0-1.5,0.1-2.8,0.2-4 c0.2-1.2,0.4-2.3,0.7-3.2c0.3-0.9,0.8-1.6,1.4-2.1c0.6-0.5,1.3-0.8,2.1-0.8c0.8,0,1.5,0.3,2.1,0.8c0.6,0.5,1,1.2,1.4,2.1 c0.3,0.9,0.6,2,0.7,3.2C806.7,78.7,806.8,80.1,806.8,81.6L806.8,81.6z M804,81.7c0-4.9-0.5-7.4-1.6-7.5c-1.1,0-1.6,2.5-1.6,7.5 c0,1.2,0,2.4,0.1,3.4c0.1,1.1,0.2,2,0.4,2.9c0.2,0.8,0.3,1.5,0.5,1.9c0.2,0.5,0.4,0.7,0.5,0.7c0.2,0,0.4-0.2,0.6-0.7 c0.2-0.5,0.4-1.1,0.5-1.9c0.2-0.8,0.3-1.8,0.4-2.9C803.9,84,804,82.8,804,81.7L804,81.7z\"></path></g><g class=\"st1\" id=\"SVGID_15_g\"><path class=\"st2\" d=\"M43.2,53V42.8c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9C41.1,49,41,49.2,41,49.2 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2V53H36V31.6h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9H46V53H43.2z\"></path><path class=\"st2\" d=\"M50.8,53V31.6h6v2.5h-3.1v6.3h3v2.5h-3v7.6H57V53H50.8z\"></path><path class=\"st2\" d=\"M68.8,39.4c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1L69,53h-2.8l-1.9-7.8 c-0.3,0.1-0.5,0.2-0.6,0.3V53h-2.8V31.6h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C69,38.3,68.9,38.9,68.8,39.4z M66.2,37.7 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C66.2,38.6,66.2,38.2,66.2,37.7L66.2,37.7z\"></path><path class=\"st2\" d=\"M71.7,53l3.6-18.8H72v-2.5h6.7L75,50.5h3.9V53H71.7z\"></path><path class=\"st2\" d=\"M56.3,93l0-16.8c0-0.1,0-0.3,0-0.5c0-0.2,0.1-0.3,0.1-0.4c0,0.1-0.1,0.2-0.1,0.4S56.2,76,56.1,76l-0.7,1 l-1.9-1.5l3-3.9h2.5V93H56.3z\"></path></g><g class=\"st1\" id=\"SVGID_17_g\"><path class=\"st2\" d=\"M43.2,196.5v-10.2c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2v10.2H36v-21.4h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9H46v21.4H43.2z\"></path><path class=\"st2\" d=\"M50.8,196.5v-21.4h6v2.5h-3.1v6.3h3v2.5h-3v7.6H57v2.5H50.8z\"></path><path class=\"st2\" d=\"M68.8,182.9c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8v-21.4h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C69,181.8,68.9,182.4,68.8,182.9z M66.2,181.2 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C66.2,182.1,66.2,181.7,66.2,181.2L66.2,181.2z\"></path><path class=\"st2\" d=\"M71.7,196.5l3.6-18.8H72v-2.5h6.7L75,194h3.9v2.5H71.7z\"></path><path class=\"st2\" d=\"M53.8,236.5c0-1.1-0.1-1.9-0.1-2.4c0-0.5,0-0.9,0-1.2c0-0.3,0.1-0.8,0.2-1.3c0.1-0.8,0.3-1.5,0.4-2 c0.2-0.5,0.4-1.2,0.8-2.1c0.2-0.5,0.5-1.3,1-2.1c0.4-0.8,0.6-1.4,0.8-1.8l0.1-0.3c0.2-0.5,0.4-1.1,0.6-1.5c0.1-0.5,0.2-0.9,0.2-1.4 c0-0.8-0.3-1.5-0.8-2c-0.4-0.4-1.1-0.7-2-1l0.4-2.5c0.6,0.1,1.2,0.2,1.8,0.5c0.6,0.2,1.1,0.5,1.5,0.9c0.5,0.5,1,1.1,1.3,1.8 c0.3,0.7,0.5,1.5,0.5,2.3c0,0.7-0.1,1.3-0.3,2c-0.2,0.7-0.4,1.4-0.7,2.2c-0.2,0.5-0.5,1.1-0.9,2c-0.4,0.7-0.6,1.4-0.9,1.9l-0.1,0.2 c-0.3,0.8-0.6,1.4-0.7,1.8c-0.1,0.4-0.3,0.9-0.4,1.6c-0.1,0.5-0.1,1.1-0.1,1.9h4.1v2.5H53.8z\"></path></g><g class=\"st1\" id=\"SVGID_1_g\"><path class=\"st2\" d=\"M56.7,390.5v-10.2c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2v10.2h-2.8v-21.4h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8v21.4H56.7z\"></path><path class=\"st2\" d=\"M64.3,390.5v-21.4h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3v2.5H64.3z\"></path><path class=\"st2\" d=\"M82.3,376.9c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8v-21.4h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.2,0.2,1.9C82.5,375.8,82.4,376.4,82.3,376.9z M79.7,375.2 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C79.7,376.1,79.7,375.7,79.7,375.2L79.7,375.2z\"></path><path class=\"st2\" d=\"M85.2,390.5l3.6-18.8h-3.4v-2.5h6.7L88.5,388h3.9v2.5H85.2z\"></path><path class=\"st2\" d=\"M49.6,430.5l0-16.8c0-0.1,0-0.3,0-0.5c0-0.2,0.1-0.3,0.1-0.4c0,0.1-0.1,0.2-0.1,0.4c-0.1,0.2-0.1,0.3-0.2,0.3 l-0.7,1l-1.9-1.5l3-3.9h2.5v21.4H49.6z\"></path><path class=\"st2\" d=\"M63,424.3v6.2h-2.7v-6.2H56l3.1-15.4l2.4,0.5L59,421.8h1.3v-2.4H63v2.4h1.4v2.5H63z\"></path><path class=\"st2\" d=\"M69.9,430.9l-2.5-0.4l3.5-21.7l2.5,0.4L69.9,430.9z\"></path><path class=\"st2\" d=\"M79.2,430.5l0-16.8c0-0.1,0-0.3,0-0.5c0-0.2,0.1-0.3,0.1-0.4c0,0.1-0.1,0.2-0.1,0.4c-0.1,0.2-0.1,0.3-0.2,0.3 l-0.7,1l-1.9-1.5l3-3.9h2.5v21.4H79.2z\"></path><path class=\"st2\" d=\"M93.1,426.7c-0.2,0.9-0.5,1.7-0.9,2.3c-0.4,0.6-0.8,1-1.3,1.3c-0.5,0.3-0.9,0.4-1.5,0.4 c-0.9,0-1.7-0.4-2.3-1.1c-0.7-0.7-1.1-1.9-1.4-3.4l2.8-0.3c0.1,0.6,0.2,1.1,0.4,1.5s0.4,0.6,0.6,0.6c0.3,0,0.6-0.5,0.8-1.4 c0.2-0.9,0.3-2,0.3-3.2c0-1-0.1-1.9-0.3-2.8c-0.2-0.8-0.5-1.3-0.8-1.3c-0.3,0-0.5,0.1-0.6,0.2c-0.1,0.1-0.3,0.3-0.4,0.6h-2.3 l0.8-10.9h5.4v2.5h-3.2l-0.4,5.4c0.1-0.1,0.2-0.2,0.4-0.3c0.1-0.1,0.4-0.1,0.6-0.1c0.4,0,0.9,0.1,1.3,0.4c0.4,0.3,0.8,0.6,1.2,1.2 c0.4,0.5,0.6,1.2,0.8,2.1c0.2,0.9,0.3,1.9,0.3,3.1C93.4,424.6,93.3,425.7,93.1,426.7z\"></path></g><g class=\"st1\" id=\"SVGID_3_g\"><path class=\"st2\" d=\"M198.4,396.2V386c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2v10.2h-2.8v-21.4h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8v21.4H198.4z\"></path><path class=\"st2\" d=\"M206,396.2v-21.4h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3v2.5H206z\"></path><path class=\"st2\" d=\"M224,382.6c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3v7.5H216v-21.4h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.2,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C224.2,381.5,224.1,382.1,224,382.6z M221.4,380.9 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2S221.4,381.3,221.4,380.9L221.4,380.9z\"></path><path class=\"st2\" d=\"M226.9,396.2l3.6-18.8h-3.4v-2.5h6.7l-3.6,18.9h3.9v2.5H226.9z\"></path><path class=\"st2\" d=\"M191.9,436.2l0-16.8c0-0.1,0-0.3,0-0.5c0-0.2,0.1-0.3,0.1-0.4c0,0.1-0.1,0.2-0.1,0.4c-0.1,0.2-0.1,0.3-0.2,0.3 l-0.7,1l-1.9-1.5l3-3.9h2.5v21.4H191.9z\"></path><path class=\"st2\" d=\"M206,432.4c-0.2,0.9-0.5,1.7-0.9,2.3c-0.4,0.6-0.8,1-1.2,1.3s-0.9,0.4-1.5,0.4c-0.5,0-1-0.1-1.5-0.4 c-0.5-0.3-0.9-0.7-1.3-1.3s-0.7-1.3-0.9-2.3c-0.2-0.9-0.3-2.1-0.3-3.3c0-0.8,0.1-1.7,0.2-2.5c0.4-2.5,0.9-4.7,1.6-6.7 c0.4-1,0.7-1.9,1-2.6c0.3-0.7,0.8-1.6,1.3-2.6l2.4,1.3c-0.5,0.9-1,1.7-1.3,2.4c-0.3,0.7-0.6,1.5-1,2.4c-0.1,0.4-0.3,0.8-0.4,1.5 c-0.1,0.2-0.1,0.4-0.2,0.5c0.1,0,0.2-0.1,0.3-0.2c0.2-0.1,0.4-0.1,0.6-0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.7,0.2,1.4,0.8,1.9,2 c0.6,1.2,0.9,2.7,0.9,4.6C206.3,430.3,206.2,431.4,206,432.4z M203.5,429c0-1-0.1-1.9-0.3-2.8c-0.2-0.8-0.5-1.3-0.8-1.3 c-0.4,0-0.6,0.4-0.8,1.3c-0.2,0.8-0.3,1.8-0.3,2.8c0,1.1,0.1,2.1,0.3,3.1c0.2,1,0.5,1.5,0.9,1.5c0.2,0,0.3-0.1,0.5-0.4 c0.1-0.3,0.3-0.6,0.3-1.1c0.1-0.4,0.2-0.9,0.2-1.5C203.5,430.1,203.6,429.5,203.5,429L203.5,429z\"></path><path class=\"st2\" d=\"M212,436.6l-2.5-0.4l3.5-21.7l2.5,0.4L212,436.6z\"></path><path class=\"st2\" d=\"M221.2,436.2l0-16.8c0-0.1,0-0.3,0-0.5c0-0.2,0.1-0.3,0.1-0.4c0,0.1-0.1,0.2-0.1,0.4c-0.1,0.2-0.1,0.3-0.2,0.3 l-0.7,1l-1.9-1.5l3-3.9h2.5v21.4H221.2z\"></path><path class=\"st2\" d=\"M230.3,436.4l-2.5-0.5l3.9-18.6H228v-2.5h6.8L230.3,436.4z\"></path></g><g class=\"st1\" id=\"SVGID_5_g\"><path class=\"st2\" d=\"M314.2,396.2V386c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2v10.2H307v-21.4h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8v21.4H314.2z\"></path><path class=\"st2\" d=\"M321.8,396.2v-21.4h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3v2.5H321.8z\"></path><path class=\"st2\" d=\"M339.8,382.6c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8v-21.4h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.2,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C340,381.5,339.9,382.1,339.8,382.6z M337.2,380.9 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2S337.2,381.3,337.2,380.9L337.2,380.9z\"></path><path class=\"st2\" d=\"M342.7,396.2l3.6-18.8h-3.4v-2.5h6.7l-3.6,18.9h3.9v2.5H342.7z\"></path><path class=\"st2\" d=\"M307.1,436.2l0-16.8c0-0.1,0-0.3,0-0.5c0-0.2,0.1-0.3,0.1-0.4c0,0.1-0.1,0.2-0.1,0.4c-0.1,0.2-0.1,0.3-0.2,0.3 l-0.7,1l-1.9-1.5l3-3.9h2.5v21.4H307.1z\"></path><path class=\"st2\" d=\"M322,429c0,2.4-0.4,4.2-1.1,5.5c-0.7,1.2-1.7,1.9-3,1.9c-1.2,0-2.2-0.6-2.9-1.9c-0.8-1.2-1.2-3.1-1.2-5.5 c0-1.3,0.1-2.4,0.4-3.3c0.3-0.9,0.7-1.7,1.1-2.2c-0.7-1-1-2.2-1-3.6c0-1.6,0.3-2.8,1-3.7c0.7-0.9,1.5-1.4,2.5-1.4 c1,0,1.9,0.5,2.5,1.4c0.7,0.9,1,2.2,1,3.7c0,1.5-0.3,2.7-1,3.6c0.5,0.6,0.8,1.3,1.1,2.2C321.9,426.6,322,427.7,322,429L322,429z M318.8,426.2c-0.2-0.8-0.5-1.3-0.8-1.3c-0.4,0-0.7,0.4-0.9,1.3c-0.2,0.8-0.3,1.8-0.3,2.8c0,1.1,0.1,2.1,0.3,3.1 c0.2,1,0.5,1.5,0.9,1.5c0.2,0,0.3-0.1,0.5-0.4c0.1-0.3,0.3-0.6,0.4-1.1c0.1-0.5,0.2-1,0.2-1.5c0.1-0.5,0.1-1,0.1-1.6 C319.1,428,319,427,318.8,426.2z M318.7,418c-0.2-0.5-0.4-0.8-0.7-0.8c-0.3,0-0.5,0.3-0.7,0.8c-0.2,0.5-0.3,1.1-0.3,1.8 c0,0.6,0.1,1.2,0.3,1.7c0.2,0.5,0.4,0.8,0.7,0.8c0.3,0,0.5-0.3,0.7-0.8c0.2-0.5,0.3-1.1,0.3-1.7S318.9,418.5,318.7,418z\"></path><path class=\"st2\" d=\"M327.4,436.6l-2.5-0.4l3.5-21.7l2.5,0.4L327.4,436.6z\"></path><path class=\"st2\" d=\"M336.7,436.2l0-16.8c0-0.1,0-0.3,0-0.5c0-0.2,0.1-0.3,0.1-0.4c0,0.1-0.1,0.2-0.1,0.4c-0.1,0.2-0.1,0.3-0.2,0.3 l-0.7,1l-1.9-1.5l3-3.9h2.5v21.4H336.7z\"></path><path class=\"st2\" d=\"M351.1,422c0,0.9-0.1,1.7-0.2,2.4c-0.4,2.4-0.9,4.7-1.6,6.8c-0.4,1-0.7,1.9-1.1,2.6c-0.4,0.7-0.8,1.6-1.4,2.5 l-2.3-1.3c0.5-0.9,1-1.7,1.3-2.4c0.3-0.7,0.6-1.5,1-2.4c0.1-0.3,0.2-0.7,0.3-1s0.2-0.7,0.2-1c-0.1,0-0.2,0.1-0.3,0.2 s-0.4,0.1-0.6,0.1c0,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c-0.7-0.2-1.4-0.8-1.9-2c-0.6-1.2-0.9-2.7-0.9-4.6c0-1.3,0.1-2.4,0.3-3.4 c0.2-0.9,0.5-1.7,0.9-2.3c0.4-0.6,0.8-1,1.2-1.3c0.5-0.3,0.9-0.4,1.5-0.4c0.5,0,1,0.1,1.5,0.4s0.9,0.7,1.3,1.3 c0.4,0.6,0.7,1.3,0.9,2.3C350.9,419.6,351,420.7,351.1,422L351.1,422z M348,418.9c-0.1-0.5-0.2-0.9-0.4-1.1 c-0.1-0.3-0.3-0.4-0.5-0.4c-0.2,0-0.3,0.1-0.5,0.4c-0.1,0.3-0.3,0.7-0.4,1.1c-0.2,0.9-0.3,1.9-0.3,3c0,1,0.1,1.9,0.3,2.8 c0.2,0.8,0.5,1.3,0.8,1.3s0.6-0.4,0.8-1.3c0.2-0.8,0.3-1.8,0.3-2.8C348.3,420.9,348.2,419.8,348,418.9z\"></path></g><g class=\"st1\" id=\"SVGID_7_g\"><path class=\"st2\" d=\"M419.1,473.8v-10.2c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2v10.2h-2.8v-21.4h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8v21.4H419.1z\"></path><path class=\"st2\" d=\"M426.8,473.8v-21.4h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3v2.5H426.8z\"></path><path class=\"st2\" d=\"M444.7,460.2c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8v-21.4h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.2,0.2,1.9C444.9,459.1,444.9,459.7,444.7,460.2z M442.1,458.5 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C442.1,459.4,442.1,459,442.1,458.5L442.1,458.5z\"></path><path class=\"st2\" d=\"M447.6,473.8l3.6-18.8h-3.4v-2.5h6.7l-3.6,18.9h3.9v2.5H447.6z\"></path><path class=\"st2\" d=\"M423.7,513.8c0-1.1-0.1-1.9-0.1-2.4c0-0.5,0-0.9,0-1.2s0.1-0.8,0.2-1.3c0.1-0.8,0.3-1.5,0.4-2 c0.2-0.5,0.4-1.2,0.8-2.1c0.2-0.5,0.5-1.3,1-2.1c0.4-0.8,0.6-1.4,0.8-1.8l0.1-0.3c0.2-0.5,0.4-1.1,0.6-1.5c0.1-0.5,0.2-0.9,0.2-1.4 c0-0.8-0.3-1.5-0.8-2c-0.4-0.4-1.1-0.7-2-1l0.4-2.5c0.6,0.1,1.2,0.2,1.8,0.5s1.1,0.5,1.5,0.9c0.5,0.5,1,1.1,1.3,1.8 c0.3,0.7,0.5,1.5,0.5,2.3c0,0.7-0.1,1.3-0.3,2c-0.2,0.7-0.4,1.4-0.7,2.2c-0.2,0.5-0.5,1.1-0.9,2c-0.4,0.7-0.6,1.4-0.9,1.9l-0.1,0.2 c-0.3,0.8-0.6,1.4-0.7,1.8s-0.3,0.9-0.4,1.6c-0.1,0.5-0.1,1.1-0.1,1.9h4.1v2.5H423.7z\"></path><path class=\"st2\" d=\"M442.3,502.4c0,1.5-0.1,3-0.2,4.3c-0.1,1.3-0.3,2.5-0.7,3.6c-0.3,1.1-0.8,2-1.4,2.6c-0.6,0.6-1.3,1-2.2,1 s-1.6-0.3-2.2-1c-0.6-0.7-1-1.5-1.4-2.6c-0.3-1.1-0.5-2.3-0.7-3.6c-0.1-1.3-0.2-2.8-0.2-4.3c0-1.5,0.1-2.8,0.2-4 c0.2-1.2,0.4-2.3,0.7-3.2c0.3-0.9,0.8-1.6,1.4-2.1s1.3-0.8,2.1-0.8c0.8,0,1.5,0.3,2.1,0.8c0.6,0.5,1,1.2,1.4,2.1 c0.3,0.9,0.6,2,0.7,3.2C442.2,499.5,442.3,500.9,442.3,502.4L442.3,502.4z M439.5,502.4c0-4.9-0.5-7.4-1.6-7.5 c-1.1,0-1.6,2.5-1.6,7.5c0,1.2,0,2.4,0.1,3.4s0.2,2,0.4,2.9c0.2,0.8,0.3,1.5,0.5,1.9c0.2,0.5,0.4,0.7,0.5,0.7 c0.2,0,0.4-0.2,0.6-0.7c0.2-0.5,0.4-1.1,0.5-1.9c0.2-0.8,0.3-1.8,0.4-2.9C439.4,504.8,439.5,503.6,439.5,502.4L439.5,502.4z\"></path></g><g class=\"st1\" id=\"SVGID_9_g\"><path class=\"st2\" d=\"M569,473.8v-10.2c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2v10.2h-2.8v-21.4h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8v21.4H569z\"></path><path class=\"st2\" d=\"M576.7,473.8v-21.4h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3v2.5H576.7z\"></path><path class=\"st2\" d=\"M594.6,460.2c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5H592 L590,466c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8v-21.4h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.2,0.2,1.9C594.8,459.1,594.8,459.7,594.6,460.2z M592,458.5 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C592,459.4,592.1,459,592,458.5L592,458.5z\"></path><path class=\"st2\" d=\"M597.5,473.8l3.6-18.8h-3.4v-2.5h6.7l-3.6,18.9h3.9v2.5H597.5z\"></path><path class=\"st2\" d=\"M575,513.8c0-1.1-0.1-1.9-0.1-2.4c0-0.5,0-0.9,0-1.2c0-0.3,0.1-0.8,0.2-1.3c0.1-0.8,0.3-1.5,0.4-2 c0.2-0.5,0.4-1.2,0.8-2.1c0.2-0.5,0.5-1.3,1-2.1c0.4-0.8,0.6-1.4,0.8-1.8l0.1-0.3c0.2-0.5,0.4-1.1,0.6-1.5c0.1-0.5,0.2-0.9,0.2-1.4 c0-0.8-0.3-1.5-0.8-2c-0.4-0.4-1.1-0.7-2-1l0.4-2.5c0.6,0.1,1.2,0.2,1.8,0.5s1.1,0.5,1.5,0.9c0.5,0.5,1,1.1,1.3,1.8 s0.5,1.5,0.5,2.3c0,0.7-0.1,1.3-0.3,2c-0.2,0.7-0.4,1.4-0.7,2.2c-0.2,0.5-0.5,1.1-0.9,2c-0.4,0.7-0.6,1.4-0.9,1.9l-0.1,0.2 c-0.3,0.8-0.6,1.4-0.7,1.8c-0.1,0.4-0.3,0.9-0.4,1.6c-0.1,0.5-0.1,1.1-0.1,1.9h4.1v2.5H575z\"></path><path class=\"st2\" d=\"M587.3,513.8l0-16.8c0-0.1,0-0.3,0-0.5c0-0.2,0.1-0.3,0.1-0.4c0,0.1-0.1,0.2-0.1,0.4c-0.1,0.2-0.1,0.3-0.2,0.3 l-0.7,1l-1.9-1.5l3-3.9h2.5v21.4H587.3z\"></path></g><g class=\"st1\" id=\"SVGID_11_g\"><path class=\"st2\" d=\"M479.9,255.5v-10.2c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2v10.2h-2.8v-21.4h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8v21.4H479.9z\"></path><path class=\"st2\" d=\"M487.5,255.5v-21.4h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3v2.5H487.5z\"></path><path class=\"st2\" d=\"M505.5,241.9c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8v-21.4h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C505.7,240.8,505.6,241.4,505.5,241.9z M502.9,240.2 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C502.9,241.1,502.9,240.7,502.9,240.2L502.9,240.2z\"></path><path class=\"st2\" d=\"M508.4,255.5l3.6-18.8h-3.4v-2.5h6.7l-3.6,18.9h3.9v2.5H508.4z\"></path><path class=\"st2\" d=\"M497.1,291.7c-0.2,0.9-0.5,1.7-0.9,2.3c-0.4,0.6-0.8,1-1.3,1.3c-0.5,0.3-0.9,0.4-1.5,0.4 c-0.9,0-1.7-0.4-2.3-1.1c-0.7-0.7-1.1-1.9-1.4-3.4l2.8-0.3c0.1,0.6,0.2,1.1,0.4,1.5s0.4,0.6,0.6,0.6c0.3,0,0.6-0.5,0.8-1.4 c0.2-0.9,0.3-2,0.3-3.2c0-1-0.1-1.9-0.3-2.8c-0.2-0.8-0.5-1.3-0.8-1.3c-0.3,0-0.5,0.1-0.6,0.2c-0.1,0.1-0.3,0.3-0.4,0.6h-2.3 l0.8-10.9h5.4v2.5h-3.2l-0.4,5.4c0.1-0.1,0.2-0.2,0.4-0.3c0.1-0.1,0.4-0.1,0.6-0.1c0.4,0,0.9,0.1,1.3,0.4c0.4,0.3,0.8,0.6,1.2,1.2 c0.4,0.5,0.6,1.2,0.8,2.1c0.2,0.9,0.3,1.9,0.3,3.1C497.4,289.6,497.3,290.7,497.1,291.7z\"></path></g><g class=\"st1\" id=\"SVGID_23_g\"><path class=\"st2\" d=\"M662.5,255.5v-10.2c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2v10.2h-2.8v-21.4h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8v21.4H662.5z\"></path><path class=\"st2\" d=\"M670.1,255.5v-21.4h6v2.5H673v6.3h3v2.5h-3v7.6h3.3v2.5H670.1z\"></path><path class=\"st2\" d=\"M688.1,241.9c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8v-21.4h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 s0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C688.3,240.8,688.2,241.4,688.1,241.9z M685.5,240.2 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 s0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C685.5,241.1,685.5,240.7,685.5,240.2L685.5,240.2z\"></path><path class=\"st2\" d=\"M691,255.5l3.6-18.8h-3.4v-2.5h6.7l-3.6,18.9h3.9v2.5H691z\"></path><path class=\"st2\" d=\"M670.4,288.3c0,2.4-0.4,4.2-1.1,5.5c-0.7,1.2-1.7,1.9-3,1.9c-1.2,0-2.2-0.6-2.9-1.9c-0.8-1.2-1.2-3.1-1.2-5.5 c0-1.3,0.1-2.4,0.4-3.3c0.3-0.9,0.7-1.7,1.1-2.2c-0.7-1-1-2.2-1-3.6c0-1.6,0.3-2.8,1-3.7c0.7-0.9,1.5-1.4,2.5-1.4 c1,0,1.9,0.5,2.5,1.4c0.7,0.9,1,2.2,1,3.7c0,1.5-0.3,2.7-1,3.6c0.5,0.5,0.8,1.3,1.1,2.2C670.2,285.9,670.4,287,670.4,288.3 L670.4,288.3z M667.2,285.5c-0.2-0.8-0.5-1.3-0.8-1.3c-0.4,0-0.7,0.4-0.9,1.3c-0.2,0.8-0.3,1.8-0.3,2.8c0,1.1,0.1,2.1,0.3,3.1 c0.2,1,0.5,1.5,0.9,1.5c0.2,0,0.3-0.1,0.5-0.4c0.1-0.3,0.3-0.6,0.4-1.1c0.1-0.5,0.2-1,0.2-1.5c0.1-0.5,0.1-1,0.1-1.6 C667.5,287.3,667.4,286.4,667.2,285.5z M667.1,277.3c-0.2-0.5-0.4-0.8-0.7-0.8s-0.5,0.3-0.7,0.8c-0.2,0.5-0.3,1.1-0.3,1.8 c0,0.6,0.1,1.2,0.3,1.7s0.4,0.8,0.7,0.8c0.3,0,0.5-0.3,0.7-0.8c0.2-0.5,0.3-1.1,0.3-1.7C667.3,278.4,667.3,277.8,667.1,277.3z\"></path><path class=\"st2\" d=\"M675.8,295.9l-2.5-0.4l3.5-21.7l2.5,0.4L675.8,295.9z\"></path><path class=\"st2\" d=\"M690.2,281.3c0,0.9-0.1,1.7-0.2,2.4c-0.4,2.4-0.9,4.7-1.6,6.8c-0.4,1-0.7,1.9-1.1,2.6 c-0.4,0.7-0.8,1.6-1.4,2.5l-2.3-1.3c0.5-0.9,1-1.7,1.3-2.4c0.3-0.7,0.6-1.5,1-2.4c0.1-0.3,0.2-0.7,0.3-1c0.1-0.3,0.2-0.7,0.2-1 c-0.1,0-0.2,0.1-0.3,0.2s-0.4,0.1-0.6,0.1c0,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c-0.7-0.2-1.4-0.8-1.9-2c-0.6-1.2-0.9-2.7-0.9-4.6 c0-1.3,0.1-2.4,0.3-3.4c0.2-0.9,0.5-1.7,0.9-2.3s0.8-1,1.2-1.3c0.5-0.3,0.9-0.4,1.5-0.4s1,0.1,1.5,0.4c0.5,0.3,0.9,0.7,1.3,1.3 c0.4,0.6,0.7,1.3,0.9,2.3C690,278.9,690.1,280,690.2,281.3L690.2,281.3z M687.1,278.3c-0.1-0.5-0.2-0.9-0.4-1.1 c-0.1-0.3-0.3-0.4-0.5-0.4c-0.2,0-0.3,0.1-0.5,0.4c-0.1,0.3-0.3,0.7-0.4,1.1c-0.2,0.9-0.3,1.9-0.3,3c0,1,0.1,1.9,0.3,2.8 s0.5,1.3,0.8,1.3c0.4,0,0.6-0.4,0.8-1.3c0.2-0.8,0.3-1.8,0.3-2.8C687.4,280.2,687.3,279.2,687.1,278.3z\"></path></g><g class=\"st1\" id=\"SVGID_25_g\"><path class=\"st2\" d=\"M809.3,255.5v-10.2c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2v10.2h-2.8v-21.4h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8v21.4H809.3z\"></path><path class=\"st2\" d=\"M817,255.5v-21.4h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3v2.5H817z\"></path><path class=\"st2\" d=\"M834.9,241.9c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8v-21.4h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C835.1,240.8,835.1,241.4,834.9,241.9z M832.3,240.2 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 s0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C832.3,241.1,832.4,240.7,832.3,240.2L832.3,240.2z\"></path><path class=\"st2\" d=\"M837.8,255.5l3.6-18.8h-3.4v-2.5h6.7l-3.6,18.9h3.9v2.5H837.8z\"></path><path class=\"st2\" d=\"M817.9,295.5l0-16.8c0-0.1,0-0.3,0-0.5c0-0.2,0.1-0.3,0.1-0.4c0,0.1-0.1,0.2-0.1,0.4c-0.1,0.2-0.1,0.3-0.2,0.3 l-0.7,1l-1.9-1.5l3-3.9h2.5v21.4H817.9z\"></path><path class=\"st2\" d=\"M827,295.5l0-16.8c0-0.1,0-0.3,0-0.5c0-0.2,0.1-0.3,0.1-0.4c0,0.1-0.1,0.2-0.1,0.4c-0.1,0.2-0.1,0.3-0.2,0.3 l-0.7,1l-1.9-1.5l3-3.9h2.5v21.4H827z\"></path></g><g class=\"st1\" id=\"SVGID_13_g\"><path class=\"st2\" d=\"M935.1,255.5v-10.2c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2v10.2h-2.8v-21.4h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8v21.4H935.1z\"></path><path class=\"st2\" d=\"M942.8,255.5v-21.4h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3v2.5H942.8z\"></path><path class=\"st2\" d=\"M960.8,241.9c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8v-21.4h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C961,240.8,960.9,241.4,960.8,241.9z M958.1,240.2 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 s0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C958.1,241.1,958.2,240.7,958.1,240.2L958.1,240.2z\"></path><path class=\"st2\" d=\"M963.7,255.5l3.6-18.8h-3.4v-2.5h6.7L967,253h3.9v2.5H963.7z\"></path><path class=\"st2\" d=\"M943.4,295.5l0-16.8c0-0.1,0-0.3,0-0.5c0-0.2,0.1-0.3,0.1-0.4c0,0.1-0.1,0.2-0.1,0.4c-0.1,0.2-0.1,0.3-0.2,0.3 l-0.7,1l-1.9-1.5l3-3.9h2.5v21.4H943.4z\"></path><path class=\"st2\" d=\"M950.1,295.5c0-1.1-0.1-1.9-0.1-2.4c0-0.5,0-0.9,0-1.2c0-0.3,0.1-0.8,0.2-1.3c0.1-0.8,0.3-1.5,0.4-2 c0.2-0.5,0.4-1.2,0.8-2.1c0.2-0.5,0.5-1.3,1-2.1c0.4-0.8,0.6-1.4,0.8-1.8l0.1-0.3c0.2-0.5,0.4-1.1,0.6-1.5c0.1-0.5,0.2-0.9,0.2-1.4 c0-0.8-0.3-1.5-0.8-2c-0.4-0.4-1.1-0.7-2-1l0.4-2.5c0.6,0.1,1.2,0.2,1.8,0.5c0.6,0.2,1.1,0.5,1.5,0.9c0.5,0.5,1,1.1,1.3,1.8 s0.5,1.5,0.5,2.3c0,0.7-0.1,1.3-0.3,2c-0.2,0.7-0.4,1.4-0.7,2.2c-0.2,0.5-0.5,1.1-0.9,2c-0.4,0.7-0.6,1.4-0.9,1.9l-0.1,0.2 c-0.3,0.8-0.6,1.4-0.7,1.8c-0.1,0.4-0.3,0.9-0.4,1.6c-0.1,0.5-0.1,1.1-0.1,1.9h4.1v2.5H950.1z\"></path></g><g class=\"st1\" id=\"SVGID_29_g\"><path class=\"st2\" d=\"M228.2,157v-10.2c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2V157H221v-21.4h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8V157H228.2z\"></path><path class=\"st2\" d=\"M235.8,157v-21.4h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3v2.5H235.8z\"></path><path class=\"st2\" d=\"M253.8,143.4c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8v-21.4h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C254,142.3,253.9,142.9,253.8,143.4z M251.2,141.7 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C251.2,142.6,251.2,142.2,251.2,141.7L251.2,141.7z\"></path><path class=\"st2\" d=\"M256.7,157l3.6-18.8h-3.4v-2.5h6.7l-3.6,18.9h3.9v2.5H256.7z\"></path><path class=\"st2\" d=\"M242.6,183.2L242.6,183.2c0.1-0.1,0.2-0.1,0.2-0.1c0.1,0,0.1,0,0.2,0c0.7,0,1.4,0.6,2,1.8 c0.6,1.2,0.9,2.8,0.9,4.9c0,1.3-0.1,2.4-0.3,3.3c-0.2,0.9-0.5,1.7-0.9,2.3c-0.4,0.6-0.8,1-1.3,1.3c-0.5,0.3-0.9,0.4-1.5,0.4 c-0.9,0-1.6-0.4-2.3-1.1c-0.7-0.7-1.1-1.9-1.4-3.4l2.8-0.3c0.1,0.6,0.2,1.1,0.4,1.5c0.2,0.4,0.4,0.6,0.6,0.6c0.2,0,0.3-0.1,0.5-0.4 c0.1-0.3,0.3-0.6,0.3-1.1c0.1-0.4,0.2-0.9,0.2-1.5c0-0.5,0.1-1.1,0.1-1.6c0-1-0.1-1.9-0.3-2.8c-0.2-0.8-0.5-1.3-0.8-1.3 c-0.1,0-0.3,0.1-0.4,0.2l-0.1,0.1l-2.4-0.7l3-7.3h-3.7v-2.5h7.5L242.6,183.2z\"></path></g><g class=\"st1\" id=\"SVGID_27_g\"><path class=\"st2\" d=\"M415.3,53V42.8c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2V53H408V31.6h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8V53H415.3z\"></path><path class=\"st2\" d=\"M422.9,53V31.6h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3V53H422.9z\"></path><path class=\"st2\" d=\"M440.9,39.4c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1L441,53h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3V53h-2.8V31.6h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C441.1,38.3,441,38.9,440.9,39.4z M438.3,37.7 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C438.3,38.6,438.3,38.2,438.3,37.7L438.3,37.7z\"></path><path class=\"st2\" d=\"M443.8,53l3.6-18.8H444v-2.5h6.7l-3.6,18.9h3.9V53H443.8z\"></path><path class=\"st2\" d=\"M431.7,86.8V93h-2.7v-6.2h-4.4l3.1-15.4l2.4,0.5l-2.5,12.4h1.3v-2.4h2.7v2.4h1.4v2.5H431.7z\"></path></g><g class=\"st1\" id=\"SVGID_19_g\"><path class=\"st2\" d=\"M540.6,53V42.8c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2V53h-2.8V31.6h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8V53H540.6z\"></path><path class=\"st2\" d=\"M548.3,53V31.6h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3V53H548.3z\"></path><path class=\"st2\" d=\"M566.3,39.4c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3V53h-2.8V31.6h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C566.5,38.3,566.4,38.9,566.3,39.4z M563.7,37.7 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C563.7,38.6,563.7,38.2,563.7,37.7L563.7,37.7z\"></path><path class=\"st2\" d=\"M569.2,53l3.6-18.8h-3.4v-2.5h6.7l-3.6,18.9h3.9V53H569.2z\"></path><path class=\"st2\" d=\"M557.9,89.2c-0.2,0.9-0.5,1.7-0.9,2.3c-0.4,0.6-0.8,1-1.2,1.3c-0.5,0.3-0.9,0.4-1.5,0.4c-0.5,0-1-0.1-1.5-0.4 c-0.5-0.3-0.9-0.7-1.3-1.3c-0.4-0.6-0.7-1.3-0.9-2.3c-0.2-0.9-0.3-2.1-0.3-3.3c0-0.8,0.1-1.7,0.2-2.5c0.4-2.5,0.9-4.7,1.6-6.7 c0.4-1,0.7-1.9,1-2.6c0.3-0.7,0.8-1.6,1.3-2.6l2.4,1.3c-0.5,0.9-1,1.7-1.3,2.4c-0.3,0.7-0.6,1.5-1,2.4c-0.1,0.4-0.3,0.8-0.4,1.5 c-0.1,0.2-0.1,0.4-0.2,0.5c0.1,0,0.2-0.1,0.3-0.2c0.2-0.1,0.4-0.1,0.6-0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.7,0.2,1.4,0.8,1.9,2 s0.9,2.7,0.9,4.6C558.2,87.1,558.1,88.3,557.9,89.2z M555.4,85.8c0-1-0.1-1.9-0.3-2.8c-0.2-0.8-0.5-1.3-0.8-1.3 c-0.4,0-0.6,0.4-0.8,1.3c-0.2,0.8-0.3,1.8-0.3,2.8c0,1.1,0.1,2.1,0.3,3.1c0.2,1,0.5,1.5,0.9,1.5c0.2,0,0.3-0.1,0.5-0.4 c0.1-0.3,0.3-0.6,0.3-1.1c0.1-0.4,0.2-0.9,0.2-1.5C555.4,86.9,555.5,86.4,555.4,85.8L555.4,85.8z\"></path></g><g class=\"st1\" id=\"SVGID_21_g\"><path class=\"st2\" d=\"M662.5,53V42.8c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2V53h-2.8V31.6h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8V53H662.5z\"></path><path class=\"st2\" d=\"M670.1,53V31.6h6v2.5H673v6.3h3v2.5h-3v7.6h3.3V53H670.1z\"></path><path class=\"st2\" d=\"M688.1,39.4c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3V53h-2.8V31.6h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 s0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C688.3,38.3,688.2,38.9,688.1,39.4z M685.5,37.7 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 s0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C685.5,38.6,685.5,38.2,685.5,37.7L685.5,37.7z\"></path><path class=\"st2\" d=\"M691,53l3.6-18.8h-3.4v-2.5h6.7l-3.6,18.9h3.9V53H691z\"></path><path class=\"st2\" d=\"M675.3,93.2l-2.5-0.5l3.9-18.6H673v-2.5h6.8L675.3,93.2z\"></path></g><g class=\"st1\" id=\"SVGID_st22_g\"><path class=\"st2\" d=\"M713.6,437.3v-10.2c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2v10.2h-2.8v-21.4h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8v21.4H713.6z\"></path><path class=\"st2\" d=\"M721.3,437.3v-21.4h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3v2.5H721.3z\"></path><path class=\"st2\" d=\"M739.3,423.7c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3s-0.5,0.7-0.9,1.1l2.3,9.5h-2.8l-1.9-7.8 c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8v-21.4h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.2,0.7,1.7c0.1,0.5,0.2,1.2,0.2,1.9C739.4,422.6,739.4,423.2,739.3,423.7z M736.6,422 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C736.6,422.9,736.7,422.5,736.6,422L736.6,422z\"></path><path class=\"st2\" d=\"M742.2,437.3l3.6-18.8h-3.4v-2.5h6.7l-3.6,18.9h3.9v2.5H742.2z\"></path><path class=\"st2\" d=\"M719.2,477.3c0-1.1-0.1-1.9-0.1-2.4c0-0.5,0-0.9,0-1.2s0.1-0.8,0.2-1.3c0.1-0.8,0.3-1.5,0.4-2 c0.2-0.5,0.4-1.2,0.8-2.1c0.2-0.5,0.5-1.3,1-2.1c0.4-0.8,0.6-1.4,0.8-1.8l0.1-0.3c0.2-0.5,0.4-1.1,0.6-1.5c0.1-0.5,0.2-0.9,0.2-1.4 c0-0.8-0.3-1.5-0.8-2c-0.4-0.4-1.1-0.7-2-1l0.4-2.5c0.6,0.1,1.2,0.2,1.8,0.5c0.6,0.2,1.1,0.5,1.5,0.9c0.5,0.5,1,1.1,1.3,1.8 c0.3,0.7,0.5,1.5,0.5,2.3c0,0.7-0.1,1.3-0.3,2c-0.2,0.7-0.4,1.4-0.7,2.2c-0.2,0.5-0.5,1.1-0.9,2c-0.4,0.7-0.6,1.4-0.9,1.9l-0.1,0.2 c-0.3,0.8-0.6,1.4-0.7,1.8c-0.1,0.4-0.3,0.9-0.4,1.6c-0.1,0.5-0.1,1.1-0.1,1.9h4.1v2.5H719.2z\"></path><path class=\"st2\" d=\"M729.2,477.3c0-1.1-0.1-1.9-0.1-2.4c0-0.5,0-0.9,0-1.2s0.1-0.8,0.2-1.3c0.1-0.8,0.3-1.5,0.4-2 c0.2-0.5,0.4-1.2,0.8-2.1c0.2-0.5,0.5-1.3,1-2.1c0.4-0.8,0.6-1.4,0.8-1.8l0.1-0.3c0.2-0.5,0.4-1.1,0.6-1.5c0.1-0.5,0.2-0.9,0.2-1.4 c0-0.8-0.3-1.5-0.8-2c-0.4-0.4-1.1-0.7-2-1l0.4-2.5c0.6,0.1,1.2,0.2,1.8,0.5c0.6,0.2,1.1,0.5,1.5,0.9c0.5,0.5,1,1.1,1.3,1.8 c0.3,0.7,0.5,1.5,0.5,2.3c0,0.7-0.1,1.3-0.3,2c-0.2,0.7-0.4,1.4-0.7,2.2c-0.2,0.5-0.5,1.1-0.9,2c-0.4,0.7-0.6,1.4-0.9,1.9l-0.1,0.2 c-0.3,0.8-0.6,1.4-0.7,1.8c-0.1,0.4-0.3,0.9-0.4,1.6c-0.1,0.5-0.1,1.1-0.1,1.9h4.1v2.5H729.2z\"></path></g><g class=\"st1\" id=\"SVGID_st23_g\"><path class=\"st2\" d=\"M809.9,437.3v-10.2c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2v10.2h-2.8v-21.4h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8v21.4H809.9z\"></path><path class=\"st2\" d=\"M817.6,437.3v-21.4h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3v2.5H817.6z\"></path><path class=\"st2\" d=\"M835.6,423.7c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8v-21.4h2.8c0.4,0,0.8,0,1,0s0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8s0.8,0.8,1.1,1.4 c0.3,0.6,0.6,1.2,0.7,1.7c0.1,0.5,0.2,1.2,0.2,1.9C835.7,422.6,835.7,423.2,835.6,423.7z M832.9,422c0-0.9-0.1-1.6-0.4-2.2 c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8c0.2-0.3,0.3-0.6,0.5-0.9 c0.2-0.4,0.3-0.8,0.4-1.2C832.9,422.9,833,422.5,832.9,422L832.9,422z\"></path><path class=\"st2\" d=\"M838.5,437.3l3.6-18.8h-3.4v-2.5h6.7l-3.6,18.9h3.9v2.5H838.5z\"></path><path class=\"st2\" d=\"M815.1,477.3c0-1.1-0.1-1.9-0.1-2.4c0-0.5,0-0.9,0-1.2s0.1-0.8,0.2-1.3c0.1-0.8,0.3-1.5,0.4-2 c0.2-0.5,0.4-1.2,0.8-2.1c0.2-0.5,0.5-1.3,1-2.1c0.4-0.8,0.6-1.4,0.8-1.8l0.1-0.3c0.2-0.5,0.4-1.1,0.6-1.5c0.1-0.5,0.2-0.9,0.2-1.4 c0-0.8-0.3-1.5-0.8-2c-0.4-0.4-1.1-0.7-2-1l0.4-2.5c0.6,0.1,1.2,0.2,1.8,0.5c0.6,0.2,1.1,0.5,1.5,0.9c0.5,0.5,1,1.1,1.3,1.8 s0.5,1.5,0.5,2.3c0,0.7-0.1,1.3-0.3,2c-0.2,0.7-0.4,1.4-0.7,2.2c-0.2,0.5-0.5,1.1-0.9,2c-0.4,0.7-0.6,1.4-0.9,1.9l-0.1,0.2 c-0.3,0.8-0.6,1.4-0.7,1.8c-0.1,0.4-0.3,0.9-0.4,1.6c-0.1,0.5-0.1,1.1-0.1,1.9h4.1v2.5H815.1z\"></path><path class=\"st2\" d=\"M829.2,463.6L829.2,463.6c0.1-0.1,0.2-0.1,0.2-0.1c0.1,0,0.1,0,0.2,0c0.7,0,1.4,0.6,2,1.8 c0.6,1.2,0.9,2.8,0.9,4.9c0,1.3-0.1,2.4-0.3,3.3c-0.2,0.9-0.5,1.7-0.9,2.3c-0.4,0.6-0.8,1-1.3,1.3c-0.5,0.3-0.9,0.4-1.5,0.4 c-0.9,0-1.6-0.4-2.3-1.1c-0.7-0.7-1.1-1.9-1.4-3.4l2.8-0.3c0.1,0.6,0.2,1.1,0.4,1.5s0.4,0.6,0.6,0.6c0.2,0,0.3-0.1,0.5-0.4 c0.1-0.3,0.3-0.6,0.3-1.1c0.1-0.4,0.2-0.9,0.2-1.5c0-0.5,0.1-1.1,0.1-1.6c0-1-0.1-1.9-0.3-2.8c-0.2-0.8-0.5-1.3-0.8-1.3 c-0.1,0-0.3,0.1-0.4,0.2l-0.1,0.1l-2.4-0.7l3-7.3H825v-2.5h7.5L829.2,463.6z\"></path></g><g class=\"st1\" id=\"SVGID_st25_g\"><g transform=\"translate(977,384)\"><path class=\"st2\" d=\"M23.233,42.155c0-0.33-0.012-0.731-0.033-1.204c-0.021-0.474-0.044-0.819-0.065-1.04l0.527,2.244 l1.552,5.874c0.021,0.022,0.043,0.066,0.065,0.132c0.066,0.221,0.11,0.33,0.132,0.33c0.066,0,0.132-0.153,0.198-0.462l1.551-5.874 l0.562-2.244c-0.022,0.221-0.045,0.566-0.066,1.04c-0.022,0.473-0.033,0.874-0.033,1.204v10.164h2.838V30.935h-2.771l-2.046,7.854 c-0.045,0.11-0.088,0.292-0.132,0.545c-0.045,0.253-0.078,0.457-0.1,0.61c-0.021-0.153-0.049-0.341-0.082-0.561 s-0.072-0.418-0.115-0.595l-2.079-7.854h-2.739v21.384h2.838V42.155z\"></path><polygon class=\"st2\" points=\"41.118,49.811 37.818,49.811 37.818,42.253 40.788,42.253 40.788,39.746 37.818,39.746 37.818,33.476 40.953,33.476 40.953,30.935 34.98,30.935 34.98,52.319 41.118,52.319 \"></polygon><path class=\"st2\" d=\"M47.422,44.828c0.11-0.065,0.297-0.165,0.562-0.297l1.946,7.788h2.806l-2.344-9.471 c0.352-0.352,0.638-0.704,0.858-1.057c0.22-0.352,0.45-0.78,0.693-1.287c0.308-0.659,0.521-1.248,0.643-1.765 s0.182-1.095,0.182-1.732c-0.021-0.748-0.099-1.381-0.23-1.898c-0.132-0.517-0.363-1.072-0.693-1.666 c-0.352-0.594-0.731-1.072-1.139-1.436s-0.919-0.644-1.534-0.842c-0.264-0.109-0.518-0.176-0.759-0.197 c-0.242-0.022-0.583-0.033-1.023-0.033h-2.805v21.384h2.838V44.828z M47.422,33.476c0.308,0,0.615,0.065,0.924,0.198 c0.528,0.176,0.924,0.561,1.188,1.154c0.285,0.572,0.429,1.299,0.429,2.179l0.033,0.032c0,0.462-0.033,0.864-0.1,1.205 c-0.065,0.341-0.187,0.731-0.362,1.171c-0.154,0.375-0.319,0.688-0.495,0.94c-0.177,0.254-0.407,0.523-0.693,0.809 c-0.264,0.309-0.572,0.562-0.924,0.76V33.476z\"></path><polygon class=\"st2\" points=\"62.239,52.319 62.239,49.811 58.378,49.811 61.976,30.935 55.31,30.935 55.31,33.476 58.675,33.476 55.078,52.319 \"></polygon><path class=\"st2\" d=\"M39.684,92.315v-2.508h-4.092c0-0.813,0.032-1.463,0.099-1.947c0.109-0.638,0.236-1.166,0.38-1.584 c0.143-0.418,0.379-1.012,0.709-1.782l0.066-0.165c0.22-0.506,0.506-1.133,0.857-1.881c0.418-0.88,0.727-1.551,0.924-2.013 c0.309-0.792,0.556-1.519,0.743-2.178c0.187-0.66,0.28-1.32,0.28-1.98c0-0.858-0.16-1.639-0.479-2.343 c-0.319-0.704-0.754-1.309-1.304-1.815c-0.418-0.374-0.919-0.671-1.501-0.891c-0.583-0.22-1.194-0.374-1.832-0.462l-0.396,2.508 c0.989,0.22,1.672,0.539,2.046,0.957c0.55,0.55,0.825,1.232,0.825,2.046c0,0.462-0.066,0.919-0.198,1.369 c-0.132,0.451-0.319,0.952-0.562,1.502l-0.099,0.264c-0.154,0.375-0.418,0.969-0.792,1.782c-0.418,0.858-0.737,1.562-0.957,2.112 c-0.396,0.924-0.677,1.639-0.842,2.145c-0.165,0.507-0.313,1.167-0.445,1.98c-0.088,0.506-0.144,0.93-0.165,1.271 s-0.033,0.742-0.033,1.204c0,0.528,0.022,1.331,0.066,2.409H39.684z\"></path><path class=\"st2\" d=\"M46.283,89.708c-0.221,0-0.413-0.187-0.578-0.561s-0.291-0.869-0.379-1.485l-2.772,0.265 c0.242,1.54,0.698,2.679,1.37,3.415c0.671,0.737,1.446,1.105,2.326,1.105c0.506,0,0.99-0.132,1.452-0.396 c0.462-0.265,0.88-0.688,1.254-1.271s0.671-1.342,0.891-2.277c0.22-0.935,0.33-2.051,0.33-3.35c0-1.188-0.104-2.211-0.313-3.069 c-0.209-0.857-0.489-1.556-0.842-2.095c-0.352-0.539-0.737-0.936-1.154-1.188c-0.418-0.253-0.848-0.379-1.287-0.379 c-0.286,0-0.501,0.049-0.644,0.148c-0.144,0.099-0.27,0.214-0.38,0.346l0.363-5.444h3.168v-2.541h-5.379L42.95,81.854h2.31 c0.11-0.242,0.236-0.435,0.38-0.577c0.143-0.144,0.347-0.215,0.61-0.215c0.33,0.022,0.594,0.457,0.792,1.304 s0.297,1.776,0.297,2.788c0,1.188-0.094,2.244-0.28,3.168C46.871,89.246,46.613,89.708,46.283,89.708z\"></path></g></g><rect x=\"854.1\" y=\"0\" id=\"SVGID_st131_\" class=\"st0\" width=\"172.5\" height=\"83.4\"></rect><rect x=\"854.1\" y=\"89.1\" id=\"SVGID_st132_\" class=\"st0\" width=\"172.5\" height=\"83.4\"></rect><rect x=\"878.7\" y=\"384.2\" id=\"SVGID_st241_\" class=\"st0\" width=\"83.4\" height=\"56.1\"></rect><rect x=\"878.7\" y=\"445.9\" id=\"SVGID_st242_\" class=\"st0\" width=\"83.4\" height=\"56.1\"></rect><g class=\"st1\" id=\"SVGID_st241_g\"><path class=\"st2\" d=\"M894.5,411.3v-10.2c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2v10.2h-2.8v-21.4h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8v21.4H894.5z\"></path><path class=\"st2\" d=\"M902.1,411.3v-21.4h6v2.5H905v6.3h3v2.5h-3v7.6h3.3v2.5H902.1z\"></path><path class=\"st2\" d=\"M920.1,397.7c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8v-21.4h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.2,0.2,1.9C920.3,396.6,920.2,397.2,920.1,397.7z M917.5,396 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 s0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C917.5,396.9,917.5,396.5,917.5,396L917.5,396z\"></path><path class=\"st2\" d=\"M923,411.3l3.6-18.8h-3.4v-2.5h6.7l-3.6,18.9h3.9v2.5H923z\"></path><path class=\"st2\" d=\"M938.5,411.3c0-1.1-0.1-1.9-0.1-2.4c0-0.5,0-0.9,0-1.2c0-0.3,0.1-0.8,0.2-1.3c0.1-0.8,0.3-1.5,0.4-2 c0.2-0.5,0.4-1.2,0.8-2.1c0.2-0.5,0.5-1.3,1-2.1c0.4-0.8,0.6-1.4,0.8-1.8l0.1-0.3c0.2-0.5,0.4-1.1,0.6-1.5c0.1-0.5,0.2-0.9,0.2-1.4 c0-0.8-0.3-1.5-0.8-2c-0.4-0.4-1.1-0.7-2-1l0.4-2.5c0.6,0.1,1.2,0.2,1.8,0.5s1.1,0.5,1.5,0.9c0.5,0.5,1,1.1,1.3,1.8 c0.3,0.7,0.5,1.5,0.5,2.3c0,0.7-0.1,1.3-0.3,2c-0.2,0.7-0.4,1.4-0.7,2.2c-0.2,0.5-0.5,1.1-0.9,2c-0.4,0.7-0.6,1.4-0.9,1.9l-0.1,0.2 c-0.3,0.8-0.6,1.4-0.7,1.8c-0.1,0.4-0.3,0.9-0.4,1.6c-0.1,0.5-0.1,1.1-0.1,1.9h4.1v2.5H938.5z\"></path><path class=\"st2\" d=\"M954.2,405.1v6.2h-2.7v-6.2h-4.4l3.1-15.4l2.4,0.5l-2.5,12.4h1.3v-2.4h2.7v2.4h1.4v2.5H954.2z\"></path><path class=\"st2\" d=\"M892.4,429.2c0,1,0,1.8-0.1,2.5c-0.1,0.7-0.2,1.3-0.4,1.9s-0.6,1-1,1.3c-0.5,0.3-1.1,0.5-1.8,0.5 c-0.7,0-1.3-0.2-1.8-0.5c-0.5-0.3-0.8-0.8-1-1.3s-0.4-1.2-0.4-1.9c-0.1-0.7-0.1-1.5-0.1-2.5v-11.4h2.3v11.9c0,1.3,0.1,2.2,0.2,2.7 s0.4,0.8,0.8,0.8s0.7-0.3,0.8-0.8s0.2-1.4,0.2-2.7v-11.9h2.3L892.4,429.2L892.4,429.2z\"></path><path class=\"st2\" d=\"M902.1,424.2c-0.1,0.4-0.3,0.9-0.5,1.4c-0.2,0.4-0.4,0.8-0.6,1.1s-0.4,0.6-0.7,0.9l1.9,7.7h-2.3l-1.6-6.4 c-0.2,0.1-0.4,0.2-0.5,0.2v6.1h-2.3v-17.5h2.3c0.4,0,0.6,0,0.8,0c0.2,0,0.4,0.1,0.6,0.2c0.5,0.2,0.9,0.4,1.3,0.7 c0.3,0.3,0.6,0.7,0.9,1.2c0.3,0.5,0.5,0.9,0.6,1.4c0.1,0.4,0.2,0.9,0.2,1.6C902.3,423.3,902.2,423.8,902.1,424.2z M900,422.8 c0-0.7-0.1-1.3-0.4-1.8c-0.2-0.5-0.5-0.8-1-0.9c-0.3-0.1-0.5-0.2-0.8-0.2v6.9c0.3-0.2,0.5-0.4,0.8-0.6c0.2-0.2,0.4-0.5,0.6-0.7 c0.1-0.2,0.3-0.5,0.4-0.8c0.1-0.4,0.2-0.7,0.3-1C900,423.5,900,423.2,900,422.8L900,422.8z\"></path><path class=\"st2\" d=\"M910.2,431.9c-0.1,0.4-0.3,0.8-0.6,1.2s-0.7,0.7-1.1,1.1s-0.8,0.6-1.3,0.9c-0.4,0.3-0.9,0.4-1.2,0.6l-0.9-2 c0.7-0.3,1.3-0.6,1.9-1c0.6-0.4,0.9-0.8,1.1-1.3c0.2-0.6,0.3-1.1,0.3-1.5c0-0.5-0.1-1-0.3-1.5c-0.2-0.5-0.6-1.1-1.1-1.8 c-0.7-0.9-1.2-1.7-1.6-2.3c-0.3-0.6-0.5-1.3-0.5-2c0-0.5,0.1-1,0.2-1.6c0.1-0.2,0.2-0.5,0.5-0.8c0.2-0.3,0.5-0.6,0.9-1 s0.7-0.6,1-0.8c0.3-0.2,0.6-0.4,0.9-0.4l0.9,1.8c-0.4,0.1-0.8,0.4-1.2,0.7c-0.4,0.4-0.7,0.7-0.8,1.1c-0.1,0.3-0.2,0.7-0.2,0.9 c0,0.5,0.1,0.9,0.4,1.3c0.2,0.4,0.7,1,1.2,1.7c0,0,0.1,0.1,0.2,0.2c0.6,0.8,1.1,1.6,1.4,2.3s0.4,1.4,0.4,2.1 C910.6,430.4,910.5,431.1,910.2,431.9L910.2,431.9z\"></path><path class=\"st2\" d=\"M919.9,425.9c0,1.3,0,2.4-0.1,3.5c-0.1,1.1-0.3,2.1-0.5,3c-0.3,0.9-0.6,1.6-1.1,2.2c-0.5,0.5-1.1,0.8-1.8,0.8 s-1.3-0.3-1.8-0.8c-0.5-0.5-0.8-1.3-1.1-2.2c-0.3-0.9-0.4-1.9-0.5-3c-0.1-1.1-0.1-2.3-0.1-3.5c0-1.2,0.1-2.3,0.2-3.3 c0.1-1,0.3-1.9,0.6-2.6s0.7-1.3,1.1-1.8c0.5-0.4,1-0.6,1.7-0.6c0.7,0,1.2,0.2,1.7,0.6c0.5,0.4,0.8,1,1.1,1.7 c0.3,0.7,0.5,1.6,0.6,2.6S919.9,424.7,919.9,425.9L919.9,425.9z M917.6,426c0-4.1-0.4-6.1-1.3-6.2c-0.9,0-1.3,2-1.3,6.1 c0,1,0,1.9,0.1,2.8c0.1,0.9,0.2,1.7,0.3,2.4c0.1,0.7,0.3,1.2,0.4,1.6c0.2,0.4,0.3,0.6,0.4,0.6c0.2,0,0.3-0.2,0.5-0.6 s0.3-0.9,0.4-1.6c0.1-0.7,0.2-1.5,0.3-2.4C917.6,427.9,917.6,426.9,917.6,426L917.6,426z\"></path><path class=\"st2\" d=\"M927.4,435.3l-1.9-8.2l-0.4-2c0,0.2,0,0.5,0.1,0.9c0,0.4,0,0.8,0,1v8.3h-2.2v-17.5h2.2l1.9,7.6l0.5,2 c0-0.2,0-0.5-0.1-0.9c0-0.4,0-0.8,0-1.1v-7.7h2.2v17.5H927.4z\"></path><path class=\"st2\" d=\"M938,435.3l-0.4-3.3h-1.9l-0.4,3.3H933l2.5-17.5h2.3l2.5,17.5H938z M936.8,425l-0.2-2.2l-0.2,2.2l-0.5,4.9h1.3 L936.8,425z\"></path><path class=\"st2\" d=\"M946.4,419.9v15.4h-2.3v-15.4h-2.2v-2.1h6.7v2.1H946.4z\"></path><path class=\"st2\" d=\"M951.1,435.3v-17.5h4.9v2.1h-2.6v5.1h2.4v2.1h-2.4v6.2h2.7v2.1H951.1z\"></path></g><g class=\"st1\" id=\"SVGID_st242_g\"><path class=\"st2\" d=\"M906.3,460V488h28.1V460H906.3z M932.8,486.4h-24.9v-24.9h24.9V486.4z\"></path><path class=\"st2\" d=\"M920.4,484.6c5.9,0,10.6-4.8,10.6-10.6c0-5.9-4.8-10.6-10.6-10.6c-5.9,0-10.6,4.8-10.6,10.6 C909.7,479.8,914.5,484.6,920.4,484.6z M920.4,465c5,0,9,4,9,9c0,5-4,9-9,9c-5,0-9-4.1-9-9C911.3,469,915.4,465,920.4,465z\"></path><path class=\"st2\" d=\"M918.6,480.4l6.7-5.8c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.2,0.1-0.4,0-0.6c0-0.1-0.1-0.2-0.2-0.3l-6.7-5.8 c-0.3-0.3-0.8-0.3-1.2,0c-0.1,0.1-0.2,0.3-0.2,0.5c0,0,0,11.7,0,11.7c0,0.2,0.1,0.4,0.2,0.6C917.7,480.7,918.2,480.7,918.6,480.4z\"></path></g><g class=\"st1\" id=\"SVGID_st132_g\"><path class=\"st2\" d=\"M926.3,116.8v28.1h28.1v-28.1H926.3z M952.8,143.2h-24.9v-24.9h24.9V143.2z\"></path><path class=\"st2\" d=\"M940.3,141.4c5.9,0,10.6-4.8,10.6-10.6c0-5.9-4.8-10.6-10.6-10.6c-5.9,0-10.6,4.8-10.6,10.6 C929.7,136.7,934.5,141.4,940.3,141.4z M940.3,121.8c5,0,9,4,9,9c0,5-4,9-9,9c-5,0-9-4.1-9-9C931.3,125.8,935.4,121.8,940.3,121.8z \"></path><path class=\"st2\" d=\"M938.5,137.2l6.7-5.8c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.2,0.1-0.4,0-0.6c0-0.1-0.1-0.2-0.2-0.3l-6.7-5.8 c-0.3-0.3-0.8-0.3-1.2,0c-0.1,0.1-0.2,0.3-0.2,0.5c0,0,0,11.7,0,11.7c0,0.2,0.1,0.4,0.2,0.6C937.7,137.5,938.2,137.5,938.5,137.2z\"></path></g><g class=\"st1\" id=\"SVGID_st131_g\"><path class=\"st2\" d=\"M926.6,37.6V27.5c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2v10.2h-2.8V16.2h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8v21.4H926.6z\"></path><path class=\"st2\" d=\"M934.2,37.6V16.2h6v2.5h-3.1V25h3v2.5h-3v7.6h3.3v2.5H934.2z\"></path><path class=\"st2\" d=\"M952.2,24c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8l-1.9-7.8 c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8V16.2h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C952.4,22.9,952.3,23.5,952.2,24z M949.6,22.3 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C949.6,23.2,949.6,22.8,949.6,22.3L949.6,22.3z\"></path><path class=\"st2\" d=\"M955.1,37.6l3.6-18.8h-3.4v-2.5h6.7l-3.6,18.9h3.9v2.5H955.1z\"></path><path class=\"st2\" d=\"M934.3,68.6l0-16.8c0-0.1,0-0.3,0-0.5c0-0.2,0.1-0.3,0.1-0.4c0,0.1-0.1,0.2-0.1,0.4s-0.1,0.3-0.2,0.3l-0.7,1 l-1.9-1.5l3-3.9h2.5v21.4H934.3z\"></path><path class=\"st2\" d=\"M945.4,54.9L945.4,54.9c0.1-0.1,0.2-0.1,0.2-0.1c0.1,0,0.1,0,0.2,0c0.7,0,1.4,0.6,2,1.8 c0.6,1.2,0.9,2.8,0.9,4.9c0,1.3-0.1,2.4-0.3,3.3c-0.2,0.9-0.5,1.7-0.9,2.3c-0.4,0.6-0.8,1-1.3,1.3c-0.5,0.3-0.9,0.4-1.5,0.4 c-0.9,0-1.6-0.4-2.3-1.1c-0.7-0.7-1.1-1.9-1.4-3.4l2.8-0.3c0.1,0.6,0.2,1.1,0.4,1.5c0.2,0.4,0.4,0.6,0.6,0.6c0.2,0,0.3-0.1,0.5-0.4 c0.1-0.3,0.3-0.6,0.3-1.1c0.1-0.4,0.2-0.9,0.2-1.5c0-0.5,0.1-1.1,0.1-1.6c0-1-0.1-1.9-0.3-2.8c-0.2-0.8-0.5-1.3-0.8-1.3 c-0.1,0-0.3,0.1-0.4,0.2l-0.1,0.1l-2.4-0.7l3-7.3h-3.7v-2.5h7.5L945.4,54.9z\"></path></g></svg>"

/***/ }),

/***/ 883:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 1026.6 563.8\" style=\"enable-background:new 0 0 1026.6 563.8;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#E42522;} .st1{opacity:0.4;} .st2{fill:#FFFFFF; } </style><g><defs><rect id=\"SVGID_1_\" x=\"854.1\" width=\"172.5\" height=\"172.5\"></rect></defs><use xlink:href=\"#SVGID_1_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_2_\"><use xlink:href=\"#SVGID_1_\" style=\"overflow:visible;\"></use></clipPath></g><g><defs><rect id=\"SVGID_3_\" y=\"341.4\" width=\"140.9\" height=\"117.9\"></rect></defs><use xlink:href=\"#SVGID_3_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_4_\"><use xlink:href=\"#SVGID_3_\" style=\"overflow:visible;\"></use></clipPath></g><g><defs><rect id=\"SVGID_5_\" x=\"153.7\" y=\"341.6\" width=\"116.9\" height=\"151\"></rect></defs><use xlink:href=\"#SVGID_5_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_6_\"><use xlink:href=\"#SVGID_5_\" style=\"overflow:visible;\"></use></clipPath></g><g><defs><rect id=\"SVGID_7_\" x=\"283.4\" y=\"341.5\" width=\"89.1\" height=\"138\"></rect></defs><use xlink:href=\"#SVGID_7_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_8_\"><use xlink:href=\"#SVGID_7_\" style=\"overflow:visible;\"></use></clipPath></g><g><defs><rect id=\"SVGID_9_\" x=\"386.9\" y=\"423\" width=\"92\" height=\"140.9\"></rect></defs><use xlink:href=\"#SVGID_9_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_10_\"><use xlink:href=\"#SVGID_9_\" style=\"overflow:visible;\"></use></clipPath></g><g><defs><rect id=\"SVGID_11_\" x=\"493.7\" y=\"423\" width=\"178.2\" height=\"120.8\"></rect></defs><use xlink:href=\"#SVGID_11_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_12_\"><use xlink:href=\"#SVGID_11_\" style=\"overflow:visible;\"></use></clipPath></g><g><defs><rect id=\"SVGID_13_\" x=\"878.7\" y=\"384.2\" width=\"83.4\" height=\"117.9\"></rect></defs><use xlink:href=\"#SVGID_13_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_14_\"><use xlink:href=\"#SVGID_13_\" style=\"overflow:visible;\"></use></clipPath></g><g><defs><rect id=\"SVGID_15_\" x=\"385.6\" y=\"147.1\" width=\"209.3\" height=\"262.8\"></rect></defs><use xlink:href=\"#SVGID_15_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_16_\"><use xlink:href=\"#SVGID_15_\" style=\"overflow:visible;\"></use></clipPath></g><g><defs><rect id=\"SVGID_17_\" x=\"898.4\" y=\"196.4\" width=\"101\" height=\"128.2\"></rect></defs><use xlink:href=\"#SVGID_17_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_18_\"><use xlink:href=\"#SVGID_17_\" style=\"overflow:visible;\"></use></clipPath></g><g><defs><rect id=\"SVGID_19_\" x=\"16.1\" y=\"0.3\" width=\"81.6\" height=\"128.2\"></rect></defs><use xlink:href=\"#SVGID_19_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_20_\"><use xlink:href=\"#SVGID_19_\" style=\"overflow:visible;\"></use></clipPath></g><rect x=\"686.1\" y=\"384.4\" id=\"SVGID_st22_\" class=\"st0\" width=\"81.6\" height=\"128.2\"></rect><rect x=\"782.3\" y=\"384.4\" id=\"SVGID_st23_\" class=\"st0\" width=\"81.6\" height=\"128.2\"></rect><rect x=\"756.9\" class=\"st0\" id=\"SVGID_st10_\" width=\"81.6\" height=\"128.2\"></rect><g><defs><rect id=\"SVGID_21_\" x=\"16.1\" y=\"143.2\" width=\"81.7\" height=\"128.2\"></rect></defs><use xlink:href=\"#SVGID_21_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_22_\"><use xlink:href=\"#SVGID_21_\" style=\"overflow:visible;\"></use></clipPath></g><g><defs><rect id=\"SVGID_23_\" x=\"513.6\" y=\"0.2\" width=\"81.7\" height=\"128.2\"></rect></defs><use xlink:href=\"#SVGID_23_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_24_\"><use xlink:href=\"#SVGID_23_\" style=\"overflow:visible;\"></use></clipPath></g><g><defs><rect id=\"SVGID_25_\" x=\"608.7\" y=\"0.2\" width=\"135.1\" height=\"181.1\"></rect></defs><use xlink:href=\"#SVGID_25_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_26_\"><use xlink:href=\"#SVGID_25_\" style=\"overflow:visible;\"></use></clipPath></g><g><defs><rect id=\"SVGID_27_\" x=\"608.9\" y=\"196.4\" width=\"134\" height=\"174.2\"></rect></defs><use xlink:href=\"#SVGID_27_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_28_\"><use xlink:href=\"#SVGID_27_\" style=\"overflow:visible;\"></use></clipPath></g><g><defs><rect id=\"SVGID_29_\" x=\"758\" y=\"196.5\" width=\"126.5\" height=\"167.3\"></rect></defs><use xlink:href=\"#SVGID_29_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_30_\"><use xlink:href=\"#SVGID_29_\" style=\"overflow:visible;\"></use></clipPath></g><g><defs><rect id=\"SVGID_31_\" x=\"386.5\" y=\"0.4\" width=\"85.1\" height=\"133.4\"></rect></defs><use xlink:href=\"#SVGID_31_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_32_\"><use xlink:href=\"#SVGID_31_\" style=\"overflow:visible;\"></use></clipPath></g><g><defs><rect id=\"SVGID_33_\" x=\"111.7\" y=\"0.4\" width=\"260.5\" height=\"327.8\"></rect></defs><use xlink:href=\"#SVGID_33_\" style=\"overflow:visible;fill:#E42522;\"></use><clipPath id=\"SVGID_34_\"><use xlink:href=\"#SVGID_33_\" style=\"overflow:visible;\"></use></clipPath></g><g class=\"st1\" id=\"SVGID_st10_g\"><path class=\"st2\" d=\"M784,53V42.8c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2V53h-2.8V31.6h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8V53H784z\"></path><path class=\"st2\" d=\"M791.7,53V31.6h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3V53H791.7z\"></path><path class=\"st2\" d=\"M809.6,39.4c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5H807 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3V53h-2.8V31.6h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 s0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C809.8,38.3,809.8,38.9,809.6,39.4z M807,37.7 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 s0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C807,38.6,807,38.2,807,37.7L807,37.7z\"></path><path class=\"st2\" d=\"M812.5,53l3.6-18.8h-3.4v-2.5h6.7l-3.6,18.9h3.9V53H812.5z\"></path><path class=\"st2\" d=\"M791.1,93l0-16.8c0-0.1,0-0.3,0-0.5c0-0.2,0.1-0.3,0.1-0.4c0,0.1-0.1,0.2-0.1,0.4S791,76,790.9,76l-0.7,1 l-1.9-1.5l3-3.9h2.5V93H791.1z\"></path><path class=\"st2\" d=\"M806.8,81.6c0,1.5-0.1,3-0.2,4.3c-0.1,1.3-0.3,2.5-0.7,3.6c-0.3,1.1-0.8,2-1.4,2.6c-0.6,0.6-1.3,1-2.2,1 c-0.9,0-1.6-0.3-2.2-1c-0.6-0.7-1-1.5-1.4-2.6c-0.3-1.1-0.5-2.3-0.7-3.6s-0.2-2.8-0.2-4.3c0-1.5,0.1-2.8,0.2-4 c0.2-1.2,0.4-2.3,0.7-3.2c0.3-0.9,0.8-1.6,1.4-2.1c0.6-0.5,1.3-0.8,2.1-0.8c0.8,0,1.5,0.3,2.1,0.8c0.6,0.5,1,1.2,1.4,2.1 c0.3,0.9,0.6,2,0.7,3.2C806.7,78.7,806.8,80.1,806.8,81.6L806.8,81.6z M804,81.7c0-4.9-0.5-7.4-1.6-7.5c-1.1,0-1.6,2.5-1.6,7.5 c0,1.2,0,2.4,0.1,3.4c0.1,1.1,0.2,2,0.4,2.9c0.2,0.8,0.3,1.5,0.5,1.9c0.2,0.5,0.4,0.7,0.5,0.7c0.2,0,0.4-0.2,0.6-0.7 c0.2-0.5,0.4-1.1,0.5-1.9c0.2-0.8,0.3-1.8,0.4-2.9C803.9,84,804,82.8,804,81.7L804,81.7z\"></path></g><g class=\"st1\" id=\"SVGID_15_g\"><path class=\"st2\" d=\"M926.6,53V42.8c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2V53h-2.8V31.6h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8V53H926.6z\"></path><path class=\"st2\" d=\"M934.2,53V31.6h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3V53H934.2z\"></path><path class=\"st2\" d=\"M952.2,39.4c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3V53h-2.8V31.6h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C952.4,38.3,952.3,38.9,952.2,39.4z M949.6,37.7 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C949.6,38.6,949.6,38.2,949.6,37.7L949.6,37.7z\"></path><path class=\"st2\" d=\"M955.1,53l3.6-18.8h-3.4v-2.5h6.7l-3.6,18.9h3.9V53H955.1z\"></path><path class=\"st2\" d=\"M934.3,93l0-16.8c0-0.1,0-0.3,0-0.5c0-0.2,0.1-0.3,0.1-0.4c0,0.1-0.1,0.2-0.1,0.4s-0.1,0.3-0.2,0.3l-0.7,1 l-1.9-1.5l3-3.9h2.5V93H934.3z\"></path><path class=\"st2\" d=\"M945.4,79.2L945.4,79.2c0.1-0.1,0.2-0.1,0.2-0.1c0.1,0,0.1,0,0.2,0c0.7,0,1.4,0.6,2,1.8 c0.6,1.2,0.9,2.8,0.9,4.9c0,1.3-0.1,2.4-0.3,3.3c-0.2,0.9-0.5,1.7-0.9,2.3c-0.4,0.6-0.8,1-1.3,1.3c-0.5,0.3-0.9,0.4-1.5,0.4 c-0.9,0-1.6-0.4-2.3-1.1c-0.7-0.7-1.1-1.9-1.4-3.4l2.8-0.3c0.1,0.6,0.2,1.1,0.4,1.5c0.2,0.4,0.4,0.6,0.6,0.6c0.2,0,0.3-0.1,0.5-0.4 c0.1-0.3,0.3-0.6,0.3-1.1c0.1-0.4,0.2-0.9,0.2-1.5c0-0.5,0.1-1.1,0.1-1.6c0-1-0.1-1.9-0.3-2.8c-0.2-0.8-0.5-1.3-0.8-1.3 c-0.1,0-0.3,0.1-0.4,0.2l-0.1,0.1l-2.4-0.7l3-7.3h-3.7v-2.5h7.5L945.4,79.2z\"></path></g><g class=\"st1\" id=\"SVGID_19_g\"><path class=\"st2\" d=\"M43.2,53V42.8c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9C41.1,49,41,49.2,41,49.2 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2V53H36V31.6h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9H46V53H43.2z\"></path><path class=\"st2\" d=\"M50.8,53V31.6h6v2.5h-3.1v6.3h3v2.5h-3v7.6H57V53H50.8z\"></path><path class=\"st2\" d=\"M68.8,39.4c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1L69,53h-2.8l-1.9-7.8 c-0.3,0.1-0.5,0.2-0.6,0.3V53h-2.8V31.6h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C69,38.3,68.9,38.9,68.8,39.4z M66.2,37.7 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C66.2,38.6,66.2,38.2,66.2,37.7L66.2,37.7z\"></path><path class=\"st2\" d=\"M71.7,53l3.6-18.8H72v-2.5h6.7L75,50.5h3.9V53H71.7z\"></path><path class=\"st2\" d=\"M56.3,93l0-16.8c0-0.1,0-0.3,0-0.5c0-0.2,0.1-0.3,0.1-0.4c0,0.1-0.1,0.2-0.1,0.4S56.2,76,56.1,76l-0.7,1 l-1.9-1.5l3-3.9h2.5V93H56.3z\"></path></g><g class=\"st1\" id=\"SVGID_21_g\"><path class=\"st2\" d=\"M43.2,196.5v-10.2c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2v10.2H36v-21.4h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9H46v21.4H43.2z\"></path><path class=\"st2\" d=\"M50.8,196.5v-21.4h6v2.5h-3.1v6.3h3v2.5h-3v7.6H57v2.5H50.8z\"></path><path class=\"st2\" d=\"M68.8,182.9c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8v-21.4h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C69,181.8,68.9,182.4,68.8,182.9z M66.2,181.2 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C66.2,182.1,66.2,181.7,66.2,181.2L66.2,181.2z\"></path><path class=\"st2\" d=\"M71.7,196.5l3.6-18.8H72v-2.5h6.7L75,194h3.9v2.5H71.7z\"></path><path class=\"st2\" d=\"M53.8,236.5c0-1.1-0.1-1.9-0.1-2.4c0-0.5,0-0.9,0-1.2c0-0.3,0.1-0.8,0.2-1.3c0.1-0.8,0.3-1.5,0.4-2 c0.2-0.5,0.4-1.2,0.8-2.1c0.2-0.5,0.5-1.3,1-2.1c0.4-0.8,0.6-1.4,0.8-1.8l0.1-0.3c0.2-0.5,0.4-1.1,0.6-1.5c0.1-0.5,0.2-0.9,0.2-1.4 c0-0.8-0.3-1.5-0.8-2c-0.4-0.4-1.1-0.7-2-1l0.4-2.5c0.6,0.1,1.2,0.2,1.8,0.5c0.6,0.2,1.1,0.5,1.5,0.9c0.5,0.5,1,1.1,1.3,1.8 c0.3,0.7,0.5,1.5,0.5,2.3c0,0.7-0.1,1.3-0.3,2c-0.2,0.7-0.4,1.4-0.7,2.2c-0.2,0.5-0.5,1.1-0.9,2c-0.4,0.7-0.6,1.4-0.9,1.9l-0.1,0.2 c-0.3,0.8-0.6,1.4-0.7,1.8c-0.1,0.4-0.3,0.9-0.4,1.6c-0.1,0.5-0.1,1.1-0.1,1.9h4.1v2.5H53.8z\"></path></g><g class=\"st1\" id=\"SVGID_3_g\"><path class=\"st2\" d=\"M56.7,390.5v-10.2c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2v10.2h-2.8v-21.4h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8v21.4H56.7z\"></path><path class=\"st2\" d=\"M64.3,390.5v-21.4h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3v2.5H64.3z\"></path><path class=\"st2\" d=\"M82.3,376.9c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8v-21.4h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.2,0.2,1.9C82.5,375.8,82.4,376.4,82.3,376.9z M79.7,375.2 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C79.7,376.1,79.7,375.7,79.7,375.2L79.7,375.2z\"></path><path class=\"st2\" d=\"M85.2,390.5l3.6-18.8h-3.4v-2.5h6.7L88.5,388h3.9v2.5H85.2z\"></path><path class=\"st2\" d=\"M49.6,430.5l0-16.8c0-0.1,0-0.3,0-0.5c0-0.2,0.1-0.3,0.1-0.4c0,0.1-0.1,0.2-0.1,0.4c-0.1,0.2-0.1,0.3-0.2,0.3 l-0.7,1l-1.9-1.5l3-3.9h2.5v21.4H49.6z\"></path><path class=\"st2\" d=\"M63,424.3v6.2h-2.7v-6.2H56l3.1-15.4l2.4,0.5L59,421.8h1.3v-2.4H63v2.4h1.4v2.5H63z\"></path><path class=\"st2\" d=\"M69.9,430.9l-2.5-0.4l3.5-21.7l2.5,0.4L69.9,430.9z\"></path><path class=\"st2\" d=\"M79.2,430.5l0-16.8c0-0.1,0-0.3,0-0.5c0-0.2,0.1-0.3,0.1-0.4c0,0.1-0.1,0.2-0.1,0.4c-0.1,0.2-0.1,0.3-0.2,0.3 l-0.7,1l-1.9-1.5l3-3.9h2.5v21.4H79.2z\"></path><path class=\"st2\" d=\"M93.1,426.7c-0.2,0.9-0.5,1.7-0.9,2.3c-0.4,0.6-0.8,1-1.3,1.3c-0.5,0.3-0.9,0.4-1.5,0.4 c-0.9,0-1.7-0.4-2.3-1.1c-0.7-0.7-1.1-1.9-1.4-3.4l2.8-0.3c0.1,0.6,0.2,1.1,0.4,1.5s0.4,0.6,0.6,0.6c0.3,0,0.6-0.5,0.8-1.4 c0.2-0.9,0.3-2,0.3-3.2c0-1-0.1-1.9-0.3-2.8c-0.2-0.8-0.5-1.3-0.8-1.3c-0.3,0-0.5,0.1-0.6,0.2c-0.1,0.1-0.3,0.3-0.4,0.6h-2.3 l0.8-10.9h5.4v2.5h-3.2l-0.4,5.4c0.1-0.1,0.2-0.2,0.4-0.3c0.1-0.1,0.4-0.1,0.6-0.1c0.4,0,0.9,0.1,1.3,0.4c0.4,0.3,0.8,0.6,1.2,1.2 c0.4,0.5,0.6,1.2,0.8,2.1c0.2,0.9,0.3,1.9,0.3,3.1C93.4,424.6,93.3,425.7,93.1,426.7z\"></path></g><g class=\"st1\" id=\"SVGID_5_g\"><path class=\"st2\" d=\"M198.4,396.2V386c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2v10.2h-2.8v-21.4h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8v21.4H198.4z\"></path><path class=\"st2\" d=\"M206,396.2v-21.4h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3v2.5H206z\"></path><path class=\"st2\" d=\"M224,382.6c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3v7.5H216v-21.4h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.2,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C224.2,381.5,224.1,382.1,224,382.6z M221.4,380.9 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2S221.4,381.3,221.4,380.9L221.4,380.9z\"></path><path class=\"st2\" d=\"M226.9,396.2l3.6-18.8h-3.4v-2.5h6.7l-3.6,18.9h3.9v2.5H226.9z\"></path><path class=\"st2\" d=\"M191.9,436.2l0-16.8c0-0.1,0-0.3,0-0.5c0-0.2,0.1-0.3,0.1-0.4c0,0.1-0.1,0.2-0.1,0.4c-0.1,0.2-0.1,0.3-0.2,0.3 l-0.7,1l-1.9-1.5l3-3.9h2.5v21.4H191.9z\"></path><path class=\"st2\" d=\"M206,432.4c-0.2,0.9-0.5,1.7-0.9,2.3c-0.4,0.6-0.8,1-1.2,1.3s-0.9,0.4-1.5,0.4c-0.5,0-1-0.1-1.5-0.4 c-0.5-0.3-0.9-0.7-1.3-1.3s-0.7-1.3-0.9-2.3c-0.2-0.9-0.3-2.1-0.3-3.3c0-0.8,0.1-1.7,0.2-2.5c0.4-2.5,0.9-4.7,1.6-6.7 c0.4-1,0.7-1.9,1-2.6c0.3-0.7,0.8-1.6,1.3-2.6l2.4,1.3c-0.5,0.9-1,1.7-1.3,2.4c-0.3,0.7-0.6,1.5-1,2.4c-0.1,0.4-0.3,0.8-0.4,1.5 c-0.1,0.2-0.1,0.4-0.2,0.5c0.1,0,0.2-0.1,0.3-0.2c0.2-0.1,0.4-0.1,0.6-0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.7,0.2,1.4,0.8,1.9,2 c0.6,1.2,0.9,2.7,0.9,4.6C206.3,430.3,206.2,431.4,206,432.4z M203.5,429c0-1-0.1-1.9-0.3-2.8c-0.2-0.8-0.5-1.3-0.8-1.3 c-0.4,0-0.6,0.4-0.8,1.3c-0.2,0.8-0.3,1.8-0.3,2.8c0,1.1,0.1,2.1,0.3,3.1c0.2,1,0.5,1.5,0.9,1.5c0.2,0,0.3-0.1,0.5-0.4 c0.1-0.3,0.3-0.6,0.3-1.1c0.1-0.4,0.2-0.9,0.2-1.5C203.5,430.1,203.6,429.5,203.5,429L203.5,429z\"></path><path class=\"st2\" d=\"M212,436.6l-2.5-0.4l3.5-21.7l2.5,0.4L212,436.6z\"></path><path class=\"st2\" d=\"M221.2,436.2l0-16.8c0-0.1,0-0.3,0-0.5c0-0.2,0.1-0.3,0.1-0.4c0,0.1-0.1,0.2-0.1,0.4c-0.1,0.2-0.1,0.3-0.2,0.3 l-0.7,1l-1.9-1.5l3-3.9h2.5v21.4H221.2z\"></path><path class=\"st2\" d=\"M230.3,436.4l-2.5-0.5l3.9-18.6H228v-2.5h6.8L230.3,436.4z\"></path></g><g class=\"st1\" id=\"SVGID_7_g\"><path class=\"st2\" d=\"M314.2,396.2V386c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2v10.2H307v-21.4h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8v21.4H314.2z\"></path><path class=\"st2\" d=\"M321.8,396.2v-21.4h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3v2.5H321.8z\"></path><path class=\"st2\" d=\"M339.8,382.6c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8v-21.4h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.2,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C340,381.5,339.9,382.1,339.8,382.6z M337.2,380.9 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2S337.2,381.3,337.2,380.9L337.2,380.9z\"></path><path class=\"st2\" d=\"M342.7,396.2l3.6-18.8h-3.4v-2.5h6.7l-3.6,18.9h3.9v2.5H342.7z\"></path><path class=\"st2\" d=\"M307.1,436.2l0-16.8c0-0.1,0-0.3,0-0.5c0-0.2,0.1-0.3,0.1-0.4c0,0.1-0.1,0.2-0.1,0.4c-0.1,0.2-0.1,0.3-0.2,0.3 l-0.7,1l-1.9-1.5l3-3.9h2.5v21.4H307.1z\"></path><path class=\"st2\" d=\"M322,429c0,2.4-0.4,4.2-1.1,5.5c-0.7,1.2-1.7,1.9-3,1.9c-1.2,0-2.2-0.6-2.9-1.9c-0.8-1.2-1.2-3.1-1.2-5.5 c0-1.3,0.1-2.4,0.4-3.3c0.3-0.9,0.7-1.7,1.1-2.2c-0.7-1-1-2.2-1-3.6c0-1.6,0.3-2.8,1-3.7c0.7-0.9,1.5-1.4,2.5-1.4 c1,0,1.9,0.5,2.5,1.4c0.7,0.9,1,2.2,1,3.7c0,1.5-0.3,2.7-1,3.6c0.5,0.6,0.8,1.3,1.1,2.2C321.9,426.6,322,427.7,322,429L322,429z M318.8,426.2c-0.2-0.8-0.5-1.3-0.8-1.3c-0.4,0-0.7,0.4-0.9,1.3c-0.2,0.8-0.3,1.8-0.3,2.8c0,1.1,0.1,2.1,0.3,3.1 c0.2,1,0.5,1.5,0.9,1.5c0.2,0,0.3-0.1,0.5-0.4c0.1-0.3,0.3-0.6,0.4-1.1c0.1-0.5,0.2-1,0.2-1.5c0.1-0.5,0.1-1,0.1-1.6 C319.1,428,319,427,318.8,426.2z M318.7,418c-0.2-0.5-0.4-0.8-0.7-0.8c-0.3,0-0.5,0.3-0.7,0.8c-0.2,0.5-0.3,1.1-0.3,1.8 c0,0.6,0.1,1.2,0.3,1.7c0.2,0.5,0.4,0.8,0.7,0.8c0.3,0,0.5-0.3,0.7-0.8c0.2-0.5,0.3-1.1,0.3-1.7S318.9,418.5,318.7,418z\"></path><path class=\"st2\" d=\"M327.4,436.6l-2.5-0.4l3.5-21.7l2.5,0.4L327.4,436.6z\"></path><path class=\"st2\" d=\"M336.7,436.2l0-16.8c0-0.1,0-0.3,0-0.5c0-0.2,0.1-0.3,0.1-0.4c0,0.1-0.1,0.2-0.1,0.4c-0.1,0.2-0.1,0.3-0.2,0.3 l-0.7,1l-1.9-1.5l3-3.9h2.5v21.4H336.7z\"></path><path class=\"st2\" d=\"M351.1,422c0,0.9-0.1,1.7-0.2,2.4c-0.4,2.4-0.9,4.7-1.6,6.8c-0.4,1-0.7,1.9-1.1,2.6c-0.4,0.7-0.8,1.6-1.4,2.5 l-2.3-1.3c0.5-0.9,1-1.7,1.3-2.4c0.3-0.7,0.6-1.5,1-2.4c0.1-0.3,0.2-0.7,0.3-1s0.2-0.7,0.2-1c-0.1,0-0.2,0.1-0.3,0.2 s-0.4,0.1-0.6,0.1c0,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c-0.7-0.2-1.4-0.8-1.9-2c-0.6-1.2-0.9-2.7-0.9-4.6c0-1.3,0.1-2.4,0.3-3.4 c0.2-0.9,0.5-1.7,0.9-2.3c0.4-0.6,0.8-1,1.2-1.3c0.5-0.3,0.9-0.4,1.5-0.4c0.5,0,1,0.1,1.5,0.4s0.9,0.7,1.3,1.3 c0.4,0.6,0.7,1.3,0.9,2.3C350.9,419.6,351,420.7,351.1,422L351.1,422z M348,418.9c-0.1-0.5-0.2-0.9-0.4-1.1 c-0.1-0.3-0.3-0.4-0.5-0.4c-0.2,0-0.3,0.1-0.5,0.4c-0.1,0.3-0.3,0.7-0.4,1.1c-0.2,0.9-0.3,1.9-0.3,3c0,1,0.1,1.9,0.3,2.8 c0.2,0.8,0.5,1.3,0.8,1.3s0.6-0.4,0.8-1.3c0.2-0.8,0.3-1.8,0.3-2.8C348.3,420.9,348.2,419.8,348,418.9z\"></path></g><g class=\"st1\" id=\"SVGID_9_g\"><path class=\"st2\" d=\"M419.1,473.8v-10.2c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2v10.2h-2.8v-21.4h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8v21.4H419.1z\"></path><path class=\"st2\" d=\"M426.8,473.8v-21.4h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3v2.5H426.8z\"></path><path class=\"st2\" d=\"M444.7,460.2c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8v-21.4h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.2,0.2,1.9C444.9,459.1,444.9,459.7,444.7,460.2z M442.1,458.5 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C442.1,459.4,442.1,459,442.1,458.5L442.1,458.5z\"></path><path class=\"st2\" d=\"M447.6,473.8l3.6-18.8h-3.4v-2.5h6.7l-3.6,18.9h3.9v2.5H447.6z\"></path><path class=\"st2\" d=\"M423.7,513.8c0-1.1-0.1-1.9-0.1-2.4c0-0.5,0-0.9,0-1.2s0.1-0.8,0.2-1.3c0.1-0.8,0.3-1.5,0.4-2 c0.2-0.5,0.4-1.2,0.8-2.1c0.2-0.5,0.5-1.3,1-2.1c0.4-0.8,0.6-1.4,0.8-1.8l0.1-0.3c0.2-0.5,0.4-1.1,0.6-1.5c0.1-0.5,0.2-0.9,0.2-1.4 c0-0.8-0.3-1.5-0.8-2c-0.4-0.4-1.1-0.7-2-1l0.4-2.5c0.6,0.1,1.2,0.2,1.8,0.5s1.1,0.5,1.5,0.9c0.5,0.5,1,1.1,1.3,1.8 c0.3,0.7,0.5,1.5,0.5,2.3c0,0.7-0.1,1.3-0.3,2c-0.2,0.7-0.4,1.4-0.7,2.2c-0.2,0.5-0.5,1.1-0.9,2c-0.4,0.7-0.6,1.4-0.9,1.9l-0.1,0.2 c-0.3,0.8-0.6,1.4-0.7,1.8s-0.3,0.9-0.4,1.6c-0.1,0.5-0.1,1.1-0.1,1.9h4.1v2.5H423.7z\"></path><path class=\"st2\" d=\"M442.3,502.4c0,1.5-0.1,3-0.2,4.3c-0.1,1.3-0.3,2.5-0.7,3.6c-0.3,1.1-0.8,2-1.4,2.6c-0.6,0.6-1.3,1-2.2,1 s-1.6-0.3-2.2-1c-0.6-0.7-1-1.5-1.4-2.6c-0.3-1.1-0.5-2.3-0.7-3.6c-0.1-1.3-0.2-2.8-0.2-4.3c0-1.5,0.1-2.8,0.2-4 c0.2-1.2,0.4-2.3,0.7-3.2c0.3-0.9,0.8-1.6,1.4-2.1s1.3-0.8,2.1-0.8c0.8,0,1.5,0.3,2.1,0.8c0.6,0.5,1,1.2,1.4,2.1 c0.3,0.9,0.6,2,0.7,3.2C442.2,499.5,442.3,500.9,442.3,502.4L442.3,502.4z M439.5,502.4c0-4.9-0.5-7.4-1.6-7.5 c-1.1,0-1.6,2.5-1.6,7.5c0,1.2,0,2.4,0.1,3.4s0.2,2,0.4,2.9c0.2,0.8,0.3,1.5,0.5,1.9c0.2,0.5,0.4,0.7,0.5,0.7 c0.2,0,0.4-0.2,0.6-0.7c0.2-0.5,0.4-1.1,0.5-1.9c0.2-0.8,0.3-1.8,0.4-2.9C439.4,504.8,439.5,503.6,439.5,502.4L439.5,502.4z\"></path></g><g class=\"st1\" id=\"SVGID_11_g\"><path class=\"st2\" d=\"M569,473.8v-10.2c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2v10.2h-2.8v-21.4h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8v21.4H569z\"></path><path class=\"st2\" d=\"M576.7,473.8v-21.4h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3v2.5H576.7z\"></path><path class=\"st2\" d=\"M594.6,460.2c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5H592 L590,466c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8v-21.4h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.2,0.2,1.9C594.8,459.1,594.8,459.7,594.6,460.2z M592,458.5 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C592,459.4,592.1,459,592,458.5L592,458.5z\"></path><path class=\"st2\" d=\"M597.5,473.8l3.6-18.8h-3.4v-2.5h6.7l-3.6,18.9h3.9v2.5H597.5z\"></path><path class=\"st2\" d=\"M575,513.8c0-1.1-0.1-1.9-0.1-2.4c0-0.5,0-0.9,0-1.2c0-0.3,0.1-0.8,0.2-1.3c0.1-0.8,0.3-1.5,0.4-2 c0.2-0.5,0.4-1.2,0.8-2.1c0.2-0.5,0.5-1.3,1-2.1c0.4-0.8,0.6-1.4,0.8-1.8l0.1-0.3c0.2-0.5,0.4-1.1,0.6-1.5c0.1-0.5,0.2-0.9,0.2-1.4 c0-0.8-0.3-1.5-0.8-2c-0.4-0.4-1.1-0.7-2-1l0.4-2.5c0.6,0.1,1.2,0.2,1.8,0.5s1.1,0.5,1.5,0.9c0.5,0.5,1,1.1,1.3,1.8 s0.5,1.5,0.5,2.3c0,0.7-0.1,1.3-0.3,2c-0.2,0.7-0.4,1.4-0.7,2.2c-0.2,0.5-0.5,1.1-0.9,2c-0.4,0.7-0.6,1.4-0.9,1.9l-0.1,0.2 c-0.3,0.8-0.6,1.4-0.7,1.8c-0.1,0.4-0.3,0.9-0.4,1.6c-0.1,0.5-0.1,1.1-0.1,1.9h4.1v2.5H575z\"></path><path class=\"st2\" d=\"M587.3,513.8l0-16.8c0-0.1,0-0.3,0-0.5c0-0.2,0.1-0.3,0.1-0.4c0,0.1-0.1,0.2-0.1,0.4c-0.1,0.2-0.1,0.3-0.2,0.3 l-0.7,1l-1.9-1.5l3-3.9h2.5v21.4H587.3z\"></path></g><g class=\"st1\" id=\"SVGID_15_g\"><path class=\"st2\" d=\"M479.9,255.5v-10.2c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2v10.2h-2.8v-21.4h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8v21.4H479.9z\"></path><path class=\"st2\" d=\"M487.5,255.5v-21.4h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3v2.5H487.5z\"></path><path class=\"st2\" d=\"M505.5,241.9c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8v-21.4h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C505.7,240.8,505.6,241.4,505.5,241.9z M502.9,240.2 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C502.9,241.1,502.9,240.7,502.9,240.2L502.9,240.2z\"></path><path class=\"st2\" d=\"M508.4,255.5l3.6-18.8h-3.4v-2.5h6.7l-3.6,18.9h3.9v2.5H508.4z\"></path><path class=\"st2\" d=\"M497.1,291.7c-0.2,0.9-0.5,1.7-0.9,2.3c-0.4,0.6-0.8,1-1.3,1.3c-0.5,0.3-0.9,0.4-1.5,0.4 c-0.9,0-1.7-0.4-2.3-1.1c-0.7-0.7-1.1-1.9-1.4-3.4l2.8-0.3c0.1,0.6,0.2,1.1,0.4,1.5s0.4,0.6,0.6,0.6c0.3,0,0.6-0.5,0.8-1.4 c0.2-0.9,0.3-2,0.3-3.2c0-1-0.1-1.9-0.3-2.8c-0.2-0.8-0.5-1.3-0.8-1.3c-0.3,0-0.5,0.1-0.6,0.2c-0.1,0.1-0.3,0.3-0.4,0.6h-2.3 l0.8-10.9h5.4v2.5h-3.2l-0.4,5.4c0.1-0.1,0.2-0.2,0.4-0.3c0.1-0.1,0.4-0.1,0.6-0.1c0.4,0,0.9,0.1,1.3,0.4c0.4,0.3,0.8,0.6,1.2,1.2 c0.4,0.5,0.6,1.2,0.8,2.1c0.2,0.9,0.3,1.9,0.3,3.1C497.4,289.6,497.3,290.7,497.1,291.7z\"></path></g><g class=\"st1\" id=\"SVGID_27_g\"><path class=\"st2\" d=\"M662.5,255.5v-10.2c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2v10.2h-2.8v-21.4h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8v21.4H662.5z\"></path><path class=\"st2\" d=\"M670.1,255.5v-21.4h6v2.5H673v6.3h3v2.5h-3v7.6h3.3v2.5H670.1z\"></path><path class=\"st2\" d=\"M688.1,241.9c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8v-21.4h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 s0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C688.3,240.8,688.2,241.4,688.1,241.9z M685.5,240.2 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 s0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C685.5,241.1,685.5,240.7,685.5,240.2L685.5,240.2z\"></path><path class=\"st2\" d=\"M691,255.5l3.6-18.8h-3.4v-2.5h6.7l-3.6,18.9h3.9v2.5H691z\"></path><path class=\"st2\" d=\"M670.4,288.3c0,2.4-0.4,4.2-1.1,5.5c-0.7,1.2-1.7,1.9-3,1.9c-1.2,0-2.2-0.6-2.9-1.9c-0.8-1.2-1.2-3.1-1.2-5.5 c0-1.3,0.1-2.4,0.4-3.3c0.3-0.9,0.7-1.7,1.1-2.2c-0.7-1-1-2.2-1-3.6c0-1.6,0.3-2.8,1-3.7c0.7-0.9,1.5-1.4,2.5-1.4 c1,0,1.9,0.5,2.5,1.4c0.7,0.9,1,2.2,1,3.7c0,1.5-0.3,2.7-1,3.6c0.5,0.5,0.8,1.3,1.1,2.2C670.2,285.9,670.4,287,670.4,288.3 L670.4,288.3z M667.2,285.5c-0.2-0.8-0.5-1.3-0.8-1.3c-0.4,0-0.7,0.4-0.9,1.3c-0.2,0.8-0.3,1.8-0.3,2.8c0,1.1,0.1,2.1,0.3,3.1 c0.2,1,0.5,1.5,0.9,1.5c0.2,0,0.3-0.1,0.5-0.4c0.1-0.3,0.3-0.6,0.4-1.1c0.1-0.5,0.2-1,0.2-1.5c0.1-0.5,0.1-1,0.1-1.6 C667.5,287.3,667.4,286.4,667.2,285.5z M667.1,277.3c-0.2-0.5-0.4-0.8-0.7-0.8s-0.5,0.3-0.7,0.8c-0.2,0.5-0.3,1.1-0.3,1.8 c0,0.6,0.1,1.2,0.3,1.7s0.4,0.8,0.7,0.8c0.3,0,0.5-0.3,0.7-0.8c0.2-0.5,0.3-1.1,0.3-1.7C667.3,278.4,667.3,277.8,667.1,277.3z\"></path><path class=\"st2\" d=\"M675.8,295.9l-2.5-0.4l3.5-21.7l2.5,0.4L675.8,295.9z\"></path><path class=\"st2\" d=\"M690.2,281.3c0,0.9-0.1,1.7-0.2,2.4c-0.4,2.4-0.9,4.7-1.6,6.8c-0.4,1-0.7,1.9-1.1,2.6 c-0.4,0.7-0.8,1.6-1.4,2.5l-2.3-1.3c0.5-0.9,1-1.7,1.3-2.4c0.3-0.7,0.6-1.5,1-2.4c0.1-0.3,0.2-0.7,0.3-1c0.1-0.3,0.2-0.7,0.2-1 c-0.1,0-0.2,0.1-0.3,0.2s-0.4,0.1-0.6,0.1c0,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c-0.7-0.2-1.4-0.8-1.9-2c-0.6-1.2-0.9-2.7-0.9-4.6 c0-1.3,0.1-2.4,0.3-3.4c0.2-0.9,0.5-1.7,0.9-2.3s0.8-1,1.2-1.3c0.5-0.3,0.9-0.4,1.5-0.4s1,0.1,1.5,0.4c0.5,0.3,0.9,0.7,1.3,1.3 c0.4,0.6,0.7,1.3,0.9,2.3C690,278.9,690.1,280,690.2,281.3L690.2,281.3z M687.1,278.3c-0.1-0.5-0.2-0.9-0.4-1.1 c-0.1-0.3-0.3-0.4-0.5-0.4c-0.2,0-0.3,0.1-0.5,0.4c-0.1,0.3-0.3,0.7-0.4,1.1c-0.2,0.9-0.3,1.9-0.3,3c0,1,0.1,1.9,0.3,2.8 s0.5,1.3,0.8,1.3c0.4,0,0.6-0.4,0.8-1.3c0.2-0.8,0.3-1.8,0.3-2.8C687.4,280.2,687.3,279.2,687.1,278.3z\"></path></g><g class=\"st1\" id=\"SVGID_29_g\"><path class=\"st2\" d=\"M809.3,255.5v-10.2c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2v10.2h-2.8v-21.4h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8v21.4H809.3z\"></path><path class=\"st2\" d=\"M817,255.5v-21.4h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3v2.5H817z\"></path><path class=\"st2\" d=\"M834.9,241.9c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8v-21.4h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C835.1,240.8,835.1,241.4,834.9,241.9z M832.3,240.2 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 s0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C832.3,241.1,832.4,240.7,832.3,240.2L832.3,240.2z\"></path><path class=\"st2\" d=\"M837.8,255.5l3.6-18.8h-3.4v-2.5h6.7l-3.6,18.9h3.9v2.5H837.8z\"></path><path class=\"st2\" d=\"M817.9,295.5l0-16.8c0-0.1,0-0.3,0-0.5c0-0.2,0.1-0.3,0.1-0.4c0,0.1-0.1,0.2-0.1,0.4c-0.1,0.2-0.1,0.3-0.2,0.3 l-0.7,1l-1.9-1.5l3-3.9h2.5v21.4H817.9z\"></path><path class=\"st2\" d=\"M827,295.5l0-16.8c0-0.1,0-0.3,0-0.5c0-0.2,0.1-0.3,0.1-0.4c0,0.1-0.1,0.2-0.1,0.4c-0.1,0.2-0.1,0.3-0.2,0.3 l-0.7,1l-1.9-1.5l3-3.9h2.5v21.4H827z\"></path></g><g class=\"st1\" id=\"SVGID_17_g\"><path class=\"st2\" d=\"M935.1,255.5v-10.2c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2v10.2h-2.8v-21.4h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8v21.4H935.1z\"></path><path class=\"st2\" d=\"M942.8,255.5v-21.4h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3v2.5H942.8z\"></path><path class=\"st2\" d=\"M960.8,241.9c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8v-21.4h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C961,240.8,960.9,241.4,960.8,241.9z M958.1,240.2 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 s0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C958.1,241.1,958.2,240.7,958.1,240.2L958.1,240.2z\"></path><path class=\"st2\" d=\"M963.7,255.5l3.6-18.8h-3.4v-2.5h6.7L967,253h3.9v2.5H963.7z\"></path><path class=\"st2\" d=\"M943.4,295.5l0-16.8c0-0.1,0-0.3,0-0.5c0-0.2,0.1-0.3,0.1-0.4c0,0.1-0.1,0.2-0.1,0.4c-0.1,0.2-0.1,0.3-0.2,0.3 l-0.7,1l-1.9-1.5l3-3.9h2.5v21.4H943.4z\"></path><path class=\"st2\" d=\"M950.1,295.5c0-1.1-0.1-1.9-0.1-2.4c0-0.5,0-0.9,0-1.2c0-0.3,0.1-0.8,0.2-1.3c0.1-0.8,0.3-1.5,0.4-2 c0.2-0.5,0.4-1.2,0.8-2.1c0.2-0.5,0.5-1.3,1-2.1c0.4-0.8,0.6-1.4,0.8-1.8l0.1-0.3c0.2-0.5,0.4-1.1,0.6-1.5c0.1-0.5,0.2-0.9,0.2-1.4 c0-0.8-0.3-1.5-0.8-2c-0.4-0.4-1.1-0.7-2-1l0.4-2.5c0.6,0.1,1.2,0.2,1.8,0.5c0.6,0.2,1.1,0.5,1.5,0.9c0.5,0.5,1,1.1,1.3,1.8 s0.5,1.5,0.5,2.3c0,0.7-0.1,1.3-0.3,2c-0.2,0.7-0.4,1.4-0.7,2.2c-0.2,0.5-0.5,1.1-0.9,2c-0.4,0.7-0.6,1.4-0.9,1.9l-0.1,0.2 c-0.3,0.8-0.6,1.4-0.7,1.8c-0.1,0.4-0.3,0.9-0.4,1.6c-0.1,0.5-0.1,1.1-0.1,1.9h4.1v2.5H950.1z\"></path></g><g class=\"st1\" id=\"SVGID_33_g\"><path class=\"st2\" d=\"M228.2,157v-10.2c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2V157H221v-21.4h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8V157H228.2z\"></path><path class=\"st2\" d=\"M235.8,157v-21.4h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3v2.5H235.8z\"></path><path class=\"st2\" d=\"M253.8,143.4c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8v-21.4h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C254,142.3,253.9,142.9,253.8,143.4z M251.2,141.7 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C251.2,142.6,251.2,142.2,251.2,141.7L251.2,141.7z\"></path><path class=\"st2\" d=\"M256.7,157l3.6-18.8h-3.4v-2.5h6.7l-3.6,18.9h3.9v2.5H256.7z\"></path><path class=\"st2\" d=\"M242.6,183.2L242.6,183.2c0.1-0.1,0.2-0.1,0.2-0.1c0.1,0,0.1,0,0.2,0c0.7,0,1.4,0.6,2,1.8 c0.6,1.2,0.9,2.8,0.9,4.9c0,1.3-0.1,2.4-0.3,3.3c-0.2,0.9-0.5,1.7-0.9,2.3c-0.4,0.6-0.8,1-1.3,1.3c-0.5,0.3-0.9,0.4-1.5,0.4 c-0.9,0-1.6-0.4-2.3-1.1c-0.7-0.7-1.1-1.9-1.4-3.4l2.8-0.3c0.1,0.6,0.2,1.1,0.4,1.5c0.2,0.4,0.4,0.6,0.6,0.6c0.2,0,0.3-0.1,0.5-0.4 c0.1-0.3,0.3-0.6,0.3-1.1c0.1-0.4,0.2-0.9,0.2-1.5c0-0.5,0.1-1.1,0.1-1.6c0-1-0.1-1.9-0.3-2.8c-0.2-0.8-0.5-1.3-0.8-1.3 c-0.1,0-0.3,0.1-0.4,0.2l-0.1,0.1l-2.4-0.7l3-7.3h-3.7v-2.5h7.5L242.6,183.2z\"></path></g><g class=\"st1\" id=\"SVGID_31_g\"><path class=\"st2\" d=\"M415.3,53V42.8c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2V53H408V31.6h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8V53H415.3z\"></path><path class=\"st2\" d=\"M422.9,53V31.6h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3V53H422.9z\"></path><path class=\"st2\" d=\"M440.9,39.4c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1L441,53h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3V53h-2.8V31.6h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C441.1,38.3,441,38.9,440.9,39.4z M438.3,37.7 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C438.3,38.6,438.3,38.2,438.3,37.7L438.3,37.7z\"></path><path class=\"st2\" d=\"M443.8,53l3.6-18.8H444v-2.5h6.7l-3.6,18.9h3.9V53H443.8z\"></path><path class=\"st2\" d=\"M431.7,86.8V93h-2.7v-6.2h-4.4l3.1-15.4l2.4,0.5l-2.5,12.4h1.3v-2.4h2.7v2.4h1.4v2.5H431.7z\"></path></g><g class=\"st1\" id=\"SVGID_23_g\"><path class=\"st2\" d=\"M540.6,53V42.8c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2V53h-2.8V31.6h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8V53H540.6z\"></path><path class=\"st2\" d=\"M548.3,53V31.6h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3V53H548.3z\"></path><path class=\"st2\" d=\"M566.3,39.4c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3V53h-2.8V31.6h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C566.5,38.3,566.4,38.9,566.3,39.4z M563.7,37.7 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C563.7,38.6,563.7,38.2,563.7,37.7L563.7,37.7z\"></path><path class=\"st2\" d=\"M569.2,53l3.6-18.8h-3.4v-2.5h6.7l-3.6,18.9h3.9V53H569.2z\"></path><path class=\"st2\" d=\"M557.9,89.2c-0.2,0.9-0.5,1.7-0.9,2.3c-0.4,0.6-0.8,1-1.2,1.3c-0.5,0.3-0.9,0.4-1.5,0.4c-0.5,0-1-0.1-1.5-0.4 c-0.5-0.3-0.9-0.7-1.3-1.3c-0.4-0.6-0.7-1.3-0.9-2.3c-0.2-0.9-0.3-2.1-0.3-3.3c0-0.8,0.1-1.7,0.2-2.5c0.4-2.5,0.9-4.7,1.6-6.7 c0.4-1,0.7-1.9,1-2.6c0.3-0.7,0.8-1.6,1.3-2.6l2.4,1.3c-0.5,0.9-1,1.7-1.3,2.4c-0.3,0.7-0.6,1.5-1,2.4c-0.1,0.4-0.3,0.8-0.4,1.5 c-0.1,0.2-0.1,0.4-0.2,0.5c0.1,0,0.2-0.1,0.3-0.2c0.2-0.1,0.4-0.1,0.6-0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.7,0.2,1.4,0.8,1.9,2 s0.9,2.7,0.9,4.6C558.2,87.1,558.1,88.3,557.9,89.2z M555.4,85.8c0-1-0.1-1.9-0.3-2.8c-0.2-0.8-0.5-1.3-0.8-1.3 c-0.4,0-0.6,0.4-0.8,1.3c-0.2,0.8-0.3,1.8-0.3,2.8c0,1.1,0.1,2.1,0.3,3.1c0.2,1,0.5,1.5,0.9,1.5c0.2,0,0.3-0.1,0.5-0.4 c0.1-0.3,0.3-0.6,0.3-1.1c0.1-0.4,0.2-0.9,0.2-1.5C555.4,86.9,555.5,86.4,555.4,85.8L555.4,85.8z\"></path></g><g class=\"st1\" id=\"SVGID_25_g\"><path class=\"st2\" d=\"M662.5,53V42.8c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2V53h-2.8V31.6h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8V53H662.5z\"></path><path class=\"st2\" d=\"M670.1,53V31.6h6v2.5H673v6.3h3v2.5h-3v7.6h3.3V53H670.1z\"></path><path class=\"st2\" d=\"M688.1,39.4c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3V53h-2.8V31.6h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 s0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.1,0.7,1.7c0.1,0.5,0.2,1.1,0.2,1.9C688.3,38.3,688.2,38.9,688.1,39.4z M685.5,37.7 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 s0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C685.5,38.6,685.5,38.2,685.5,37.7L685.5,37.7z\"></path><path class=\"st2\" d=\"M691,53l3.6-18.8h-3.4v-2.5h6.7l-3.6,18.9h3.9V53H691z\"></path><path class=\"st2\" d=\"M675.3,93.2l-2.5-0.5l3.9-18.6H673v-2.5h6.8L675.3,93.2z\"></path></g><g class=\"st1\" id=\"SVGID_st22_g\"><path class=\"st2\" d=\"M713.6,437.3v-10.2c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2v10.2h-2.8v-21.4h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8v21.4H713.6z\"></path><path class=\"st2\" d=\"M721.3,437.3v-21.4h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3v2.5H721.3z\"></path><path class=\"st2\" d=\"M739.3,423.7c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3s-0.5,0.7-0.9,1.1l2.3,9.5h-2.8l-1.9-7.8 c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8v-21.4h2.8c0.4,0,0.8,0,1,0c0.2,0,0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8 c0.4,0.4,0.8,0.8,1.1,1.4c0.3,0.6,0.6,1.2,0.7,1.7c0.1,0.5,0.2,1.2,0.2,1.9C739.4,422.6,739.4,423.2,739.3,423.7z M736.6,422 c0-0.9-0.1-1.6-0.4-2.2c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8 c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.4,0.3-0.8,0.4-1.2C736.6,422.9,736.7,422.5,736.6,422L736.6,422z\"></path><path class=\"st2\" d=\"M742.2,437.3l3.6-18.8h-3.4v-2.5h6.7l-3.6,18.9h3.9v2.5H742.2z\"></path><path class=\"st2\" d=\"M719.2,477.3c0-1.1-0.1-1.9-0.1-2.4c0-0.5,0-0.9,0-1.2s0.1-0.8,0.2-1.3c0.1-0.8,0.3-1.5,0.4-2 c0.2-0.5,0.4-1.2,0.8-2.1c0.2-0.5,0.5-1.3,1-2.1c0.4-0.8,0.6-1.4,0.8-1.8l0.1-0.3c0.2-0.5,0.4-1.1,0.6-1.5c0.1-0.5,0.2-0.9,0.2-1.4 c0-0.8-0.3-1.5-0.8-2c-0.4-0.4-1.1-0.7-2-1l0.4-2.5c0.6,0.1,1.2,0.2,1.8,0.5c0.6,0.2,1.1,0.5,1.5,0.9c0.5,0.5,1,1.1,1.3,1.8 c0.3,0.7,0.5,1.5,0.5,2.3c0,0.7-0.1,1.3-0.3,2c-0.2,0.7-0.4,1.4-0.7,2.2c-0.2,0.5-0.5,1.1-0.9,2c-0.4,0.7-0.6,1.4-0.9,1.9l-0.1,0.2 c-0.3,0.8-0.6,1.4-0.7,1.8c-0.1,0.4-0.3,0.9-0.4,1.6c-0.1,0.5-0.1,1.1-0.1,1.9h4.1v2.5H719.2z\"></path><path class=\"st2\" d=\"M729.2,477.3c0-1.1-0.1-1.9-0.1-2.4c0-0.5,0-0.9,0-1.2s0.1-0.8,0.2-1.3c0.1-0.8,0.3-1.5,0.4-2 c0.2-0.5,0.4-1.2,0.8-2.1c0.2-0.5,0.5-1.3,1-2.1c0.4-0.8,0.6-1.4,0.8-1.8l0.1-0.3c0.2-0.5,0.4-1.1,0.6-1.5c0.1-0.5,0.2-0.9,0.2-1.4 c0-0.8-0.3-1.5-0.8-2c-0.4-0.4-1.1-0.7-2-1l0.4-2.5c0.6,0.1,1.2,0.2,1.8,0.5c0.6,0.2,1.1,0.5,1.5,0.9c0.5,0.5,1,1.1,1.3,1.8 c0.3,0.7,0.5,1.5,0.5,2.3c0,0.7-0.1,1.3-0.3,2c-0.2,0.7-0.4,1.4-0.7,2.2c-0.2,0.5-0.5,1.1-0.9,2c-0.4,0.7-0.6,1.4-0.9,1.9l-0.1,0.2 c-0.3,0.8-0.6,1.4-0.7,1.8c-0.1,0.4-0.3,0.9-0.4,1.6c-0.1,0.5-0.1,1.1-0.1,1.9h4.1v2.5H729.2z\"></path></g><g class=\"st1\" id=\"SVGID_st23_g\"><path class=\"st2\" d=\"M809.9,437.3v-10.2c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2v10.2h-2.8v-21.4h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8v21.4H809.9z\"></path><path class=\"st2\" d=\"M817.6,437.3v-21.4h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3v2.5H817.6z\"></path><path class=\"st2\" d=\"M835.6,423.7c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8v-21.4h2.8c0.4,0,0.8,0,1,0s0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8s0.8,0.8,1.1,1.4 c0.3,0.6,0.6,1.2,0.7,1.7c0.1,0.5,0.2,1.2,0.2,1.9C835.7,422.6,835.7,423.2,835.6,423.7z M832.9,422c0-0.9-0.1-1.6-0.4-2.2 c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8c0.2-0.3,0.3-0.6,0.5-0.9 c0.2-0.4,0.3-0.8,0.4-1.2C832.9,422.9,833,422.5,832.9,422L832.9,422z\"></path><path class=\"st2\" d=\"M838.5,437.3l3.6-18.8h-3.4v-2.5h6.7l-3.6,18.9h3.9v2.5H838.5z\"></path><path class=\"st2\" d=\"M815.1,477.3c0-1.1-0.1-1.9-0.1-2.4c0-0.5,0-0.9,0-1.2s0.1-0.8,0.2-1.3c0.1-0.8,0.3-1.5,0.4-2 c0.2-0.5,0.4-1.2,0.8-2.1c0.2-0.5,0.5-1.3,1-2.1c0.4-0.8,0.6-1.4,0.8-1.8l0.1-0.3c0.2-0.5,0.4-1.1,0.6-1.5c0.1-0.5,0.2-0.9,0.2-1.4 c0-0.8-0.3-1.5-0.8-2c-0.4-0.4-1.1-0.7-2-1l0.4-2.5c0.6,0.1,1.2,0.2,1.8,0.5c0.6,0.2,1.1,0.5,1.5,0.9c0.5,0.5,1,1.1,1.3,1.8 s0.5,1.5,0.5,2.3c0,0.7-0.1,1.3-0.3,2c-0.2,0.7-0.4,1.4-0.7,2.2c-0.2,0.5-0.5,1.1-0.9,2c-0.4,0.7-0.6,1.4-0.9,1.9l-0.1,0.2 c-0.3,0.8-0.6,1.4-0.7,1.8c-0.1,0.4-0.3,0.9-0.4,1.6c-0.1,0.5-0.1,1.1-0.1,1.9h4.1v2.5H815.1z\"></path><path class=\"st2\" d=\"M829.2,463.6L829.2,463.6c0.1-0.1,0.2-0.1,0.2-0.1c0.1,0,0.1,0,0.2,0c0.7,0,1.4,0.6,2,1.8 c0.6,1.2,0.9,2.8,0.9,4.9c0,1.3-0.1,2.4-0.3,3.3c-0.2,0.9-0.5,1.7-0.9,2.3c-0.4,0.6-0.8,1-1.3,1.3c-0.5,0.3-0.9,0.4-1.5,0.4 c-0.9,0-1.6-0.4-2.3-1.1c-0.7-0.7-1.1-1.9-1.4-3.4l2.8-0.3c0.1,0.6,0.2,1.1,0.4,1.5s0.4,0.6,0.6,0.6c0.2,0,0.3-0.1,0.5-0.4 c0.1-0.3,0.3-0.6,0.3-1.1c0.1-0.4,0.2-0.9,0.2-1.5c0-0.5,0.1-1.1,0.1-1.6c0-1-0.1-1.9-0.3-2.8c-0.2-0.8-0.5-1.3-0.8-1.3 c-0.1,0-0.3,0.1-0.4,0.2l-0.1,0.1l-2.4-0.7l3-7.3H825v-2.5h7.5L829.2,463.6z\"></path></g><g class=\"st1\" id=\"SVGID_13_g\"><path class=\"st2\" d=\"M906.6,437.3v-10.2c0-0.3,0-0.7,0-1.2c0-0.5,0-0.8,0.1-1l-0.6,2.2l-1.6,5.9c-0.1,0.3-0.1,0.5-0.2,0.5 c0,0-0.1-0.1-0.1-0.3c0-0.1,0-0.1-0.1-0.1l-1.6-5.9l-0.5-2.2c0,0.2,0,0.6,0.1,1c0,0.5,0,0.9,0,1.2v10.2h-2.8v-21.4h2.7l2.1,7.9 c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5l2-7.9h2.8v21.4H906.6z\"></path><path class=\"st2\" d=\"M914.2,437.3v-21.4h6v2.5h-3.1v6.3h3v2.5h-3v7.6h3.3v2.5H914.2z\"></path><path class=\"st2\" d=\"M932.2,423.7c-0.1,0.5-0.3,1.1-0.6,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.4-0.5,0.7-0.9,1.1l2.3,9.5h-2.8 l-1.9-7.8c-0.3,0.1-0.5,0.2-0.6,0.3v7.5h-2.8v-21.4h2.8c0.4,0,0.8,0,1,0s0.5,0.1,0.8,0.2c0.6,0.2,1.1,0.5,1.5,0.8s0.8,0.8,1.1,1.4 c0.3,0.6,0.6,1.2,0.7,1.7c0.1,0.5,0.2,1.2,0.2,1.9C932.4,422.6,932.3,423.2,932.2,423.7z M929.6,422c0-0.9-0.1-1.6-0.4-2.2 c-0.3-0.6-0.7-1-1.2-1.2c-0.3-0.1-0.6-0.2-0.9-0.2v8.4c0.4-0.2,0.7-0.5,0.9-0.8c0.3-0.3,0.5-0.6,0.7-0.8c0.2-0.3,0.3-0.6,0.5-0.9 c0.2-0.4,0.3-0.8,0.4-1.2C929.6,422.9,929.6,422.5,929.6,422L929.6,422z\"></path><path class=\"st2\" d=\"M935.1,437.3l3.6-18.8h-3.4v-2.5h6.7l-3.6,18.9h3.9v2.5H935.1z\"></path><path class=\"st2\" d=\"M912,477.3c0-1.1-0.1-1.9-0.1-2.4c0-0.5,0-0.9,0-1.2c0-0.3,0.1-0.8,0.2-1.3c0.1-0.8,0.3-1.5,0.4-2 c0.2-0.5,0.4-1.2,0.8-2.1c0.2-0.5,0.5-1.3,1-2.1c0.4-0.8,0.6-1.4,0.8-1.8l0.1-0.3c0.2-0.5,0.4-1.1,0.6-1.5c0.1-0.5,0.2-0.9,0.2-1.4 c0-0.8-0.3-1.5-0.8-2c-0.4-0.4-1.1-0.7-2-1l0.4-2.5c0.6,0.1,1.2,0.2,1.8,0.5c0.6,0.2,1.1,0.5,1.5,0.9c0.6,0.5,1,1.1,1.3,1.8 c0.3,0.7,0.5,1.5,0.5,2.3c0,0.7-0.1,1.3-0.3,2s-0.4,1.4-0.7,2.2c-0.2,0.5-0.5,1.1-0.9,2c-0.4,0.7-0.6,1.4-0.9,1.9l-0.1,0.2 c-0.3,0.8-0.6,1.4-0.7,1.8c-0.1,0.4-0.3,0.9-0.4,1.6c-0.1,0.5-0.1,1.1-0.1,1.9h4.1v2.5H912z\"></path><path class=\"st2\" d=\"M927.7,471.1v6.2H925v-6.2h-4.4l3.1-15.4l2.4,0.5l-2.5,12.4h1.3v-2.4h2.7v2.4h1.4v2.5H927.7z\"></path></g></svg>"

/***/ }),

/***/ 884:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 902.7 524.1\" style=\"enable-background:new 0 0 902.7 524.1;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#C59B6D;} .st1{fill:#886B49;} .st2{fill:#D53D12;} .st3{fill:#8C2B06;} .st4{fill:#666666;} .st5{fill:#E6E6E6;} </style><g id=\"text\"><g><path class=\"st0\" d=\"M393.1,132.8l-0.2,1.9l-0.8,2.8l-1.7,3.2l-1.1,1.4l-1.5,1.6l-1.7,1.6l-1.9,1.4l-2.1,1.7l-2.2,1l-3.3,1.7 l-1.1-2.4l-1.2-2.4l-1-2.2l2.6-1.4l2-0.9l1.9-1.2l2.1-2.1l1.2-1.3l1.1-1.7l0.5-2.9l0.4-2.9l-0.3-2l-0.3-2.1l-0.7-1.9l-1.2-2 l-1.6-1.7l-1.4-2.3l-2-3l-1.6-1.5l-1.4-2.5l-1.2-2.7l-0.8-1.5l-0.4-1.8l-0.1-2.3v-2.3l0.3-2.2l0.4-2.1l0.9-1.5l0.7-1.7l1.5-1.6 l1.5-1.8l2-1.4l1.6-1.6l2-1l1.8-0.7l0.8,2.3l1.4,2l1.1,2.1l-1.6,0.8l-2.1,1.5l-1.7,1.7l-1.4,1.3l-0.7,1.7l-0.4,2.5l-0.1,2.7 l0.7,2.4l1.2,2.3l1.8,2.4l1.3,1.7l1.6,1.4l2,2.8l1.4,2.8l0.8,1.9l1.3,1.8l0.8,3.9l0.2,3.1L393.1,132.8z\"></path><path class=\"st0\" d=\"M422.2,92.5l-2.7,1.1l-0.9,0.5l-1.4,0.6l-2.4,2.1l-1.7,1.2l-1.1,1.3l-0.7,1.7l-1.3,1.8l-0.9,1.9l-0.8,3.4 l-0.7,2.5l0.1,1.7l-0.2,2.3l-0.2,2.9l0.5,2.9l0.3,2.2l0.4,2.2l0.4,1.8l0.3,1.9l0.7,1.9l0.8,1.5l1.6,2.3l1.6,2.7l1.4,1.7l1.9,1.6 l1.5,1.5l1.1,1.2l2.3,1.5l-1.5,2.2l-1.4,2.3l-1.5,2.4l-2.1-1.6l-2.3-2l-2-1.8l-1.8-2.1l-2.1-1.8l-1.8-3.3l-2.2-3l-0.7-2.3 l-1.1-2.2l-0.8-2.5l-0.2-2.7l-0.6-2.3l-0.2-2.4l-0.1-3.2l-0.4-3.6v-2.7l0.7-2.6l0.3-2.1l0.2-2.2l0.7-1.5l0.8-2.1l0.9-2.6l1.6-2.2 l1.6-2.6l1.6-1.7l1.7-1.6l1.5-1.5l2.2-0.9l1.6-1.3l1.3-0.6l1.3-0.3l1.7-0.6l2-0.3l0.5,2.5l0.5,2.5l0.4,2.6L422.2,92.5z\"></path><path class=\"st0\" d=\"M454.2,93.8l0.1,2.7l0.2,2.7l0.1,2.7l-0.2,2.7l0.1,2.7l-0.3,2.7l0.1,2.7l-0.1,2.7l0.1,2.7l0.2,2.7v2.7v2.7 l0.1,2.7v2.7l-0.2,2.7l-0.1,2.7l0.1,2.7l-0.2,2.7l0.4,2.7l-0.2,2.7v2.5l-2.8,0.3l-2.9-0.4L446,150l-0.2-2.8v-2.7v-2.8l0.2-2.8 v-2.8l-0.2-2.7l0.2-2.8l-0.1-2.8l0.4-2.8l-0.5-2.7l0.2-2.7h-2.5l-2.6,0.1l-2.4-0.2l-0.1,2.8l-0.1,2.7l0.3,2.8l-0.3,2.8v2.8 l-0.1,2.7l0.1,2.8l-0.1,2.8v2.8v2.7l0.2,2.7l-2.9,0.1l-2.8,0.3l-3-0.3v-2.7l-0.1-2.7l-0.1-2.7l0.1-2.7l0.5-2.7l-0.1-2.7l-0.2-2.7 l0.1-2.7l-0.2-2.7l0.3-2.7l-0.4-2.7v-2.7v-2.7l0.4-2.7l-0.2-2.7l-0.1-2.7v-2.7l0.2-2.7l-0.2-2.7l0.4-2.7l-0.3-2.7l0.2-2.7 l-0.4-2.7l0.2-2.7h2.9l2.8,0.3l2.7-0.3v2.7l0.2,2.6l-0.1,2.7l-0.1,2.7l0.4,2.6l-0.1,2.7l-0.1,2.7l-0.1,2.7v2.6l0.1,2.7l2.5-0.2 l2.6,0.2h2.5l-0.1-2.7l0.2-2.6l0.1-2.7l-0.5-2.7l0.5-2.7l-0.3-2.6l0.3-2.7L446,91v-2.6V86l2.8-0.4l2.9,0.2h2.6l0.1,2.7l0.4,2.7 L454.2,93.8z\"></path><path class=\"st0\" d=\"M500.2,88.5l-0.2,2.7v2.7l-0.2,2.7l-0.2,2.7l-0.5,2.7l-0.1,2.7l-0.2,2.7l-0.2,2.7l-0.1,2.7l-0.3,2.7l-0.1,2.7 l-0.4,2.7v2.7l-0.4,2.7v2.7l-0.2,2.7l-0.2,2.7l-0.1,2.7l-0.2,2.7l-0.3,2.7l-0.4,2.7l0.2,2.7l-0.4,2.8h-2.6l-2.7,0.1l-2.4-0.2 l-0.4-2.8l-0.5-2.8l-0.4-2.8l-0.6-2.8l-0.4-2.8l-0.6-2.7l-0.2-2.8l-0.5-3.2l-0.7-3.1l-0.3,3.1l0.1,3.2l-0.9,2.8l-0.3,2.8l-0.2,2.8 l-0.7,2.7l-0.1,2.9l-0.6,2.7l-0.6,2.8l-2.7,0.2l-2.8-0.3l-2.7,0.1v-2.7l-0.6-2.7V142l-0.4-2.7v-2.7l-0.1-2.7l-0.5-2.7l-0.1-2.7 l0.2-2.7l-0.6-2.7l-0.1-2.7l-0.2-2.7l-0.2-2.7v-2.7l-0.3-2.7v-2.7l-0.4-2.7l-0.1-2.7l-0.4-2.7l0.1-2.7l-0.5-2.7v-2.7v-2.7 l-0.4-2.8h2.8l2.7,0.3l3-0.2v2.7l0.3,2.8l0.1,2.7l0.2,2.8l0.1,2.7l0.1,2.8l0.4,2.7l0.1,2.8l0.3,2.7l-0.2,2.8l0.6,2.7l-0.2,2.1 l0.1,2.4l0.1,1.8l-0.1,0.5l0.7-2.2l0.1-2.3l0.7-2.3l0.6-2.5l0.1-2.7l1-2.5l0.5-2.5l0.3-2.6l0.9-2.5l0.3-2.7l0.5-2.5l0.2-0.6 l0.2-0.3l0.1-0.5l0.1,0.3l0.1,0.4l0.3,0.7l0.3,2.6l0.5,2.6l0.6,2.5l0.4,2.6l0.8,2.5l0.4,2.6l1,2.5l0.4,2.6l0.3,2.3l0.3,2.3 l0.5,2.2v-0.5l0.1-1.7l-0.1-2.5l0.1-2.1l0.3-2.8l0.5-2.7v-2.7l-0.1-2.8l0.3-2.7l0.3-2.8l0.3-2.7l0.1-2.8l0.2-2.7l0.4-2.7V86 l2.7-0.1l2.7-0.3l2.8,0.2L500.2,88.5z\"></path><path class=\"st0\" d=\"M520,120.6v2.7l-0.1,2.7l-0.1,2.7l-0.2,2.7l0.1,2.7l0.2,2.7v2.7l-0.1,2.7l-0.1,2.7l0.1,2.7v2.7l-2.9-0.2 l-2.8-0.1l-2.8,0.3l0.1-2.7l-0.2-2.7L511,142l0.1-2.7l-0.2-2.7l0.1-2.7v-2.7l0.3-2.7l-0.1-2.7l-0.3-2.7l0.3-2.7l-0.1-2.7l0.3-2.7 l-0.4-2.7l0.3-2.7l-0.1-2.7l0.2-2.7l-0.2-2.7l-0.1-2.7l0.2-2.7l-0.1-2.7l0.2-2.7l-0.1-2.7l-0.1-2.7h2.9l2.8,0.2l2.8-0.2l-0.1,2.7 l0.5,2.7l-0.2,2.7l0.2,2.7l-0.5,2.7v2.7l0.2,2.7l-0.2,2.7v2.7v2.7l0.5,2.7v2.7L520,120.6z\"></path><path class=\"st0\" d=\"M554.7,93.3h-2.7l-2.7,0.4l-2.6-0.3l-0.1,2.7l-0.2,2.7l0.1,2.8l0.4,2.7l-0.3,2.7l0.1,2.7l-0.1,2.7l-0.1,2.8 l-0.1,2.7l-0.1,2.7l0.2,2.7l-0.1,2.7l0.4,2.7v2.8l-0.4,2.7v2.7v2.7v2.7v2.8v2.7l0.2,2.7l-2.8-0.2l-2.9,0.2h-2.9l0.4-2.7v-2.7 l-0.2-2.8l-0.3-2.7l0.2-2.7l-0.2-2.7l-0.1-2.7l0.2-2.8l0.2-2.7l-0.1-2.7l0.1-2.7l-0.3-2.7l0.4-2.7l0.1-2.8l-0.4-2.7l0.1-2.7 l0.2-2.7l-0.5-2.7l0.1-2.8l0.4-2.7l-0.2-3l-2.7,0.1l-2.7,0.4l-2.9-0.2l0.3-2.6l-0.2-2.5l0.1-2.8l2.7,0.4l2.8-0.2l2.7-0.1l2.8-0.1 h2.7l2.8,0.3h2.7h2.8l2.7-0.1v2.6l0.1,2.5L554.7,93.3z\"></path><path class=\"st0\" d=\"M583.9,93.3h-2.7l-2.7,0.4l-2.6-0.3l-0.1,2.7l-0.2,2.7l0.1,2.8l0.4,2.7l-0.3,2.7l0.1,2.7l-0.1,2.7l-0.1,2.8 l-0.1,2.7l-0.1,2.7l0.2,2.7l-0.1,2.7l0.4,2.7v2.8l-0.4,2.7v2.7v2.7v2.7v2.8v2.7l0.2,2.7l-2.8-0.2l-2.9,0.2h-2.9l0.4-2.7v-2.7 l-0.2-2.8l-0.3-2.7l0.2-2.7l-0.2-2.7l-0.1-2.7l0.2-2.8l0.2-2.7l-0.1-2.7l0.1-2.7l-0.3-2.7l0.4-2.7l0.1-2.8l-0.4-2.7l0.1-2.7 l0.2-2.7l-0.5-2.7l0.1-2.8l0.4-2.7l-0.2-3l-2.7,0.1l-2.7,0.4l-2.9-0.2l0.3-2.6l-0.2-2.5l0.1-2.8l2.7,0.4l2.8-0.2l2.7-0.1l2.8-0.1 h2.7l2.8,0.3h2.7h2.8l2.7-0.1v2.6l0.1,2.5L583.9,93.3z\"></path><path class=\"st0\" d=\"M610.6,147.5l0.2,2.3l-2.7,0.3h-2.6l-2.7-0.3l-2.6,0.1l-2.7,0.3L595,150h-2.6v-2.7l-0.3-2.7l0.3-2.7l0.1-2.7 l-0.4-2.7l0.1-2.7v-2.7l0.1-2.7l0.2-2.7l-0.4-2.7l0.4-2.7l-0.2-2.7l0.2-2.7v-2.7l0.1-2.7l-0.4-2.7l0.1-2.7l0.2-2.7v-2.7l-0.4-2.7 l0.4-2.7v-2.7l-0.4-2.7l0.2-2.5l2.6-0.3l2.6,0.2l2.6,0.1l2.5-0.2h2.6l2.6,0.2l2.5-0.2l0.1,2.6l-0.1,2.5l0.1,2.4h-2.4l-2.3,0.1 l-2.4,0.1h-2.5l0.3,2.7l-0.1,2.7l-0.3,2.7l0.4,2.8l-0.2,2.7l0.2,2.7l-0.2,2.7h3l3,0.3l3.1-0.3v2.5l0.1,2.6l-0.2,2.5l-3,0.2l-3-0.1 l-3.2-0.1l0.2,2.5l-0.2,2.6l0.3,2.5l-0.1,2.6l0.2,2.5l-0.3,2.6l0.3,2.5l-0.4,2.6l0.2,2.3h2.5l2.5,0.3l2.5-0.3l2.5,0.2l0.1,2.5 L610.6,147.5z\"></path><path class=\"st0\" d=\"M645.1,106.5l-0.4,2.3l-0.6,2.1l-0.5,1.6l-0.9,2l-1.1,2.6l-1,1.6l-1.4,1.7l-1,1.3l0.3,2.7l1,2.5l0.5,2.6 l0.5,2.7l0.7,2.6l0.8,2.5l0.9,2.6l0.6,2.6l0.4,2.7l0.7,2.6l0.6,2.3l-2.8,0.3l-2.9,0.2l-2.9-0.2l-0.6-2.6l-0.4-2.7l-1-2.5l-0.6-2.7 l-0.5-2.6l-0.6-2.7l-0.7-2.6l-0.6-2.6l-0.8-2.6l-0.2,0.2h-0.4l-0.6,0.4l-0.4,0.2l-0.3,0.1l0.1,2.5v2.5v2.6l0.2,2.5L629,140 l0.1,2.5L629,145l0.1,2.5l0.1,2.6l-2.9,0.1l-2.8-0.4l-2.8,0.2l0.1-2.7l-0.2-2.7l0.2-2.7l-0.4-2.7l0.2-2.7l-0.1-2.7l0.2-2.7 l-0.2-2.7l0.3-2.7l-0.3-2.7l0.1-2.7l-0.2-2.7v-2.7l0.2-2.7l-0.1-2.7l0.3-2.7l-0.2-2.7l0.1-2.7l-0.1-2.7l0.2-2.7l-0.1-2.7l0.1-2.7 l-0.3-2.7l0.1-2.8l2.8,0.1l2.9-0.2l2.8,0.3l2.7-0.1l1,0.2l1.8,0.3l2.4,1.5l2.1,1l1.7,1.7l0.8,1.3l1.1,1.6l0.7,1.3l0.6,1.4l0.8,2 l0.1,1.6l0.4,2.1l0.3,2.4L645.1,106.5z M637,104.1l-0.1-1.6l-0.2-2.7l-0.6-1.2l-0.5-1.2l-1.7-2.2l-0.7-0.9L632,94l-1.1-0.4 l-0.7-0.2h-0.8H629l0.4,2.6l-0.1,2.5l-0.1,2.6l-0.2,2.5l0.1,2.6v2.6l0.1,2.5v2.6v2.5l-0.1,2.5l0.8-0.1l0.7-0.9l0.5-0.5l0.7-0.9 l2.2-2.3l0.7-1.1l1-1.6l0.6-2.2l0.5-1.4l0.3-2.1L637,104.1z\"></path><path class=\"st0\" d=\"M673.2,132.8l-0.2,1.9l-0.8,2.8l-1.7,3.2l-1.1,1.4l-1.5,1.6l-1.7,1.6l-1.9,1.4l-2.1,1.7l-2.2,1l-3.3,1.7 l-1.1-2.4l-1.2-2.4l-1-2.2l2.6-1.4l2-0.9l1.9-1.2l2.1-2.1l1.2-1.3l1.1-1.7l0.5-2.9l0.4-2.9l-0.3-2l-0.3-2.1l-0.7-1.9l-1.2-2 l-1.6-1.7l-1.4-2.3l-2-3l-1.6-1.5l-1.4-2.5l-1.2-2.7l-0.8-1.5l-0.4-1.8l-0.1-2.3v-2.3l0.3-2.2l0.4-2.1l0.9-1.5l0.7-1.7l1.5-1.6 l1.5-1.8l2-1.4l1.6-1.6l2-1l1.8-0.7l0.8,2.3l1.4,2l1.1,2.1l-1.6,0.8l-2.1,1.5l-1.7,1.7l-1.4,1.3l-0.7,1.7l-0.4,2.5l-0.1,2.7 l0.7,2.4l1.2,2.3l1.8,2.4l1.3,1.7l1.6,1.4l2,2.8l1.4,2.8l0.8,1.9l1.3,1.8l0.8,3.9l0.2,3.1L673.2,132.8z\"></path></g><g><path class=\"st1\" d=\"M438.5,266.9l0.1,3l-0.3,2.8l-2.6,0.9l-2.6,0.9l-2.6,0.6l-2.5,1.2l-2.6,0.7l-2.6,1.1l-2.6,0.7l-2.7,0.6 l-2.6,0.8l-2.5,1.1l-2.3,0.6l-2.4,0.6h0.3l1.3-0.2l1.6-0.1l1.5,0.2l2.6-0.3l2.6,0.4l2.6-0.3h2.6l2.5,0.2l2.6-0.2l2.6,0.2l2.6,0.1 l2.6-0.2h2.3l0.5,2.8l-0.5,2.9l0.3,2.7l-2.7,0.3l-2.7-0.2h-2.7l-2.7-0.3l-2.7,0.3l-2.7,0.1l-2.7-0.1l-2.7-0.3h-2.7l-2.7,0.5 l-2.7-0.1l-2.7-0.2l-2.7-0.1l-2.7,0.1l-2.7-0.1l-2.7,0.2l-2.7-0.1l-2.7,0.3l-2.7-0.5l-2.7,0.5l-2.7-0.4l-2.7,0.4l-2.7-0.3 l-2.9,0.1l0.3-2.8v-2.9l-0.1-2.9l2.7,0.2l2.8-0.2l2.7-0.1l2.8,0.5h2.7l2.8-0.4l2.7,0.1l1.4,0.1h1.5l1.2,0.2l-1.2-0.6l-1.6-0.5 l-1.3-0.4l-2.9-1l-3-0.9l-3.1-1l-3.2-0.9l-2.8-1.2l-2.9-0.9l-1.1-0.5l-0.2-2.8l-0.2-2.8l0.3-2.9l2.6,0.9l2.6,0.8l2.5,1.2l2.5,1.1 l2.7,0.6l2.6,0.9l2.5,1.1l2.7,0.7l2.6,0.9l2.5,1l2.5,0.7l2.7-0.6l2.7-0.7l2.5-1l2.6-0.8l2.6-1l2.6-0.8l2.5-1.1l2.6-0.8l2.7-0.7 l2.4-1.3l2.7-0.9l2.6-0.6l2.5-1.1l2.8-0.7L438.5,266.9z\"></path><path class=\"st1\" d=\"M424.6,231.5l2.9,0.4l2.4,0.3l2.2,0.8l1.9,0.9l1.8,1.8l1.2,1.3l1,1.6l0.7,2.3v2.9l-0.1,2.7l-0.8,2.4l-0.6,1.7 l-1.3,1.4l-1.6,1.5l-2.2,0.9l-2.1,0.6l-1.6,0.6l-2.2,0.3l-2.3-0.1l-2.7-0.1l-2.6,0.4H416l-2.6,0.1l-2.7-0.1l-2.6-0.2l-2.7,0.1 l-2.6,0.3h-2.7l-2.6-0.3l-2.7,0.3h-2.6l-2.6-0.4l-2.7,0.1l-2.6,0.1l-2.7,0.2l-2.6-0.4l-2.7,0.4l-2.8-0.2l0.1-2.9l0.1-2.8v-2.8 l2.6-0.3h2.6l2.6,0.4l2.6-0.4l2.6,0.4l2.6-0.4l2.6,0.1h2.6h2.5l2.6-0.1l2.6,0.2l2.6-0.1l2.6,0.3l2.6-0.3l2.6,0.1l2.6-0.1l2.6,0.3 h3.2l3.2-0.2l2.6-0.4l1.6-0.4l1.2-1l0.6-0.9l0.6-1.1l-0.5-1.2l-0.6-0.8l-1.2-1.1l-1.7-0.6l-2.9,0.1h-3h-3.1l-2.6-0.1l-2.6,0.1 l-2.6-0.2l-2.6,0.1l-2.6-0.3l-2.6,0.1l-2.6-0.2l-2.6,0.5h-2.5l-2.6-0.2l-2.6-0.2l-2.6,0.2l-2.6-0.1h-2.6l-2.6,0.2h-2.6l-2.7-0.1 l0.4-2.9l-0.1-2.8l-0.2-2.9h2.6l2.7-0.2l2.6,0.2l2.7-0.1l2.6-0.1l2.7,0.4l2.6,0.1l2.6-0.4l2.7-0.1l2.6,0.2l2.7-0.2l2.6,0.3 l2.7,0.1l2.6-0.2l2.7,0.1l2.6-0.1l3.2,0.3l2.5-0.5L424.6,231.5z\"></path><path class=\"st1\" d=\"M394.8,192.4l2.3,0.4l2.1,0.6l1.6,0.5l2,0.9l2.6,1.1l1.6,1l1.7,1.4l1.3,1l2.7-0.3l2.5-1l2.6-0.5l2.7-0.5 l2.6-0.7l2.5-0.8l2.6-0.9l2.6-0.6l2.7-0.4l2.6-0.7l2.3-0.6l0.3,2.8l0.2,2.9l-0.2,2.9l-2.6,0.6l-2.7,0.4l-2.5,1l-2.7,0.6l-2.6,0.5 l-2.7,0.6l-2.6,0.7l-2.6,0.6l-2.6,0.8l0.2,0.2v0.4l0.4,0.6l0.2,0.4l0.1,0.3l2.5-0.1h2.5h2.6l2.5-0.2l2.5,0.3l2.5-0.1l2.6,0.1 l2.5-0.1l2.6-0.1l0.1,2.9l-0.4,2.8l0.2,2.8l-2.7-0.1l-2.7,0.2l-2.7-0.2l-2.7,0.4l-2.7-0.2l-2.7,0.1l-2.7-0.2l-2.7,0.2l-2.7-0.3 l-2.7,0.3l-2.7-0.1l-2.7,0.2h-2.7l-2.7-0.2l-2.7,0.1l-2.7-0.3l-2.7,0.2l-2.7-0.1l-2.7,0.1l-2.7-0.2l-2.7,0.1l-2.7-0.1l-2.7,0.3 l-2.8-0.1l0.1-2.8l-0.2-2.9l0.3-2.8l-0.1-2.7l0.2-1l0.3-1.8l1.5-2.4l1-2.1l1.7-1.7l1.3-0.8l1.6-1.1l1.3-0.7l1.4-0.6l2-0.8l1.6-0.1 l2.1-0.4l2.4-0.3L394.8,192.4z M392.4,200.6l-1.6,0.1l-2.7,0.2l-1.2,0.6l-1.2,0.5l-2.2,1.7l-0.9,0.7l-0.4,1.2l-0.4,1.1l-0.2,0.7 v0.8v0.4l2.6-0.4l2.5,0.1l2.6,0.1l2.5,0.2l2.6-0.1h2.6l2.5-0.1h2.6h2.5l2.5,0.1l-0.1-0.8l-0.9-0.7l-0.5-0.5l-0.9-0.7l-2.3-2.2 l-1.1-0.7l-1.6-1l-2.2-0.6l-1.4-0.5l-2.1-0.3L392.4,200.6z\"></path><path class=\"st1\" d=\"M381.6,161.7v2.7l0.4,2.7l-0.3,2.6l2.7,0.1l2.7,0.2l2.8-0.1l2.7-0.4l2.7,0.3l2.7-0.1l2.7,0.1l2.8,0.1l2.7,0.1 l2.7,0.1l2.7-0.2l2.7,0.1l2.7-0.4h2.8l2.7,0.4h2.7h2.7h2.7h2.8h2.7l2.7-0.2l-0.2,2.8l0.2,2.9v2.9l-2.7-0.4h-2.7l-2.8,0.2l-2.7,0.3 l-2.7-0.2l-2.7,0.2l-2.7,0.1l-2.8-0.2l-2.7-0.2l-2.7,0.1l-2.7-0.1l-2.7,0.3l-2.7-0.4l-2.8-0.1l-2.7,0.4l-2.7-0.1l-2.7-0.2 l-2.7,0.5l-2.8-0.1l-2.7-0.4l-3,0.2l0.1,2.7l0.4,2.7l-0.2,2.9l-2.6-0.3l-2.5,0.2l-2.8-0.1l0.4-2.7l-0.2-2.8l-0.1-2.7l-0.1-2.8 v-2.7l0.3-2.8v-2.7v-2.8l-0.1-2.7h2.6l2.5-0.1L381.6,161.7z\"></path></g><g><g><path class=\"st2\" d=\"M470.8,185.1l-0.1,1.1l0.1,1.2l-0.1,1.4l-0.3,1.4l-0.2,1l-0.5,1.2l-0.4,1.2l-0.6,1l-0.6,1.7l-1.2,1.3 l-0.6,0.7l-0.7,0.7l-0.8,0.8l-0.7,0.6l-1.1,0.9l-0.8,0.4l-0.9,0.3l-0.9,0.4h-0.8l-1.6,0.3l0.1-1.3l0.2-1.3l-0.2-1.3v-1.4l0.1-1.3 l0.1-1.3l-0.1-1.3l0-1.3v-1.3V189l0.1-1.3v-1.3v-1.3l-0.1-1.3l0.1-1.3l-0.2-1.3l0.2-1.4l-0.2-1.3l0.1-1.3l0.2-1.3l-0.1-1.3l0-1.3 l-0.1-1.4l0.2-1.3l-0.1-1.4l1,0.2l1-0.1l1.2,0.2l1.2,0.3l1,0.3l1.5,0.7l1.2,1.3l0.5,0.5l0.5,0.5l0.5,0.6l0.5,0.8l0.6,1.1l0.6,1.1 l0.5,0.9l0.2,1l0.2,1.5l0.4,1.9l0.1,1l0,1.1l0.1,0.1L470.8,185.1z M466.6,184.9l0-0.9l0.1-1.3l-0.1-1.3l-0.4-1.9l-0.4-1.3 l-0.4-0.6l-0.4-0.7l-0.5-0.8l-0.3-0.9l-0.9-0.8l-0.5-0.5l-0.5-0.3l0.1,1.3l-0.1,1.3v1.3l-0.1,1.3l0.2,1.3l-0.1,1.3l0.1,1.3 l-0.2,1.4v1.3v1.3v1.3l0.1,1.3l0,1.3l0.1,1.3v1.3l-0.2,1.3l0.2,1.3l0.2-0.2l0.2-0.2l0.2-0.2l0.2-0.1l1-1.5l0.6-0.9l0.2-0.7 l0.6-1.5l0.5-1.8l0.2-0.8l0.2-0.7l0.1-0.8l0.1-1.2L466.6,184.9z\"></path><path class=\"st2\" d=\"M481.4,187v1.4l-0.1,1.4l0,1.4l-0.1,1.4l0.1,1.4l0.1,1.4v1.4l0,1.4l-0.1,1.4l0.1,1.4v1.4l-1.5-0.1l-1.4-0.1 L477,202l0.1-1.4l-0.1-1.4l-0.1-1.4l0.1-1.4l-0.1-1.4l0.1-1.4v-1.4l0.2-1.4l-0.1-1.4l-0.2-1.4l0.2-1.4l0-1.4l0.2-1.4l-0.2-1.4 l0.2-1.4l-0.1-1.4l0.1-1.4l-0.1-1.4l0-1.4l0.1-1.4l-0.1-1.4l0.1-1.4l-0.1-1.4l-0.1-1.4h1.5l1.4,0.1l1.4-0.1l-0.1,1.4l0.3,1.4 l-0.1,1.4l0.1,1.4l-0.3,1.4v1.4l0.1,1.4l-0.1,1.4v1.4v1.4l0.3,1.4v1.4L481.4,187z\"></path><path class=\"st2\" d=\"M499.8,200.8l0.1,1.2l-1.4,0.2h-1.3l-1.4-0.2l-1.3,0.1l-1.4,0.2l-1.3-0.1h-1.3v-1.4l-0.2-1.4l0.2-1.4 l0.1-1.4l-0.2-1.4l0.1-1.4v-1.4l0-1.4l0.1-1.4l-0.2-1.4l0.2-1.4l-0.1-1.4l0.1-1.4V183l0-1.4l-0.2-1.4l0-1.4l0.1-1.4v-1.4 l-0.2-1.4l0.2-1.4v-1.4l-0.2-1.4l0.1-1.3l1.3-0.2l1.3,0.1l1.3,0.1l1.3-0.1h1.3l1.3,0.1l1.3-0.1l0.1,1.3l-0.1,1.3l0.1,1.2h-1.2 l-1.2,0.1l-1.2,0.1h-1.3l0.2,1.4l-0.1,1.4l-0.2,1.4l0.2,1.4l-0.1,1.4l0.1,1.4l-0.1,1.4h1.5l1.5,0.2l1.6-0.2v1.3l0.1,1.3l-0.1,1.3 l-1.5,0.1l-1.5-0.1l-1.6-0.1l0.1,1.3l-0.1,1.3l0.2,1.3l0,1.3l0.1,1.3l-0.2,1.3l0.2,1.3l-0.2,1.3l0.1,1.2h1.3l1.3,0.2l1.3-0.2 l1.3,0.1l0.1,1.3L499.8,200.8z\"></path><path class=\"st2\" d=\"M532,179.9l-0.2,1.2l-0.3,1.1l-0.3,0.8l-0.5,1l-0.6,1.3l-0.5,0.8l-0.7,0.9l-0.5,0.7l0.2,1.4l0.5,1.3l0.3,1.3 l0.3,1.4l0.4,1.3l0.4,1.3l0.5,1.3l0.3,1.3l0.2,1.4l0.4,1.3l0.3,1.2l-1.4,0.2l-1.5,0.1l-1.5-0.1l-0.3-1.3l-0.2-1.4l-0.5-1.3 l-0.3-1.4l-0.3-1.3l-0.3-1.4l-0.4-1.3l-0.3-1.3l-0.4-1.3l-0.1,0.1h-0.2l-0.3,0.2l-0.2,0.1l-0.2,0.1l0.1,1.3v1.3v1.3l0.1,1.3 l-0.2,1.3l0.1,1.3l-0.1,1.3l0.1,1.3l0.1,1.3l-1.5,0.1l-1.4-0.2l-1.4,0.1l0.1-1.4l-0.1-1.4l0.1-1.4l-0.2-1.4l0.1-1.4l0-1.4 l0.1-1.4l-0.1-1.4l0.2-1.4l-0.2-1.4l0-1.4l-0.1-1.4v-1.4l0.1-1.4l0-1.4l0.2-1.4l-0.1-1.4l0.1-1.4l-0.1-1.4l0.1-1.4l-0.1-1.4 l0.1-1.4l-0.2-1.4l0-1.4l1.4,0.1l1.5-0.1l1.4,0.2l1.4-0.1l0.5,0.1l0.9,0.2l1.2,0.8l1.1,0.5l0.9,0.9l0.4,0.7l0.6,0.8l0.4,0.7 l0.3,0.7l0.4,1l0.1,0.8l0.2,1.1l0.2,1.2L532,179.9z M527.9,178.7l-0.1-0.8l-0.1-1.4l-0.3-0.6l-0.3-0.6l-0.9-1.1l-0.4-0.5 l-0.6-0.2l-0.6-0.2l-0.4-0.1H524h-0.2l0.2,1.3l-0.1,1.3l0,1.3l-0.1,1.3l0.1,1.3v1.3l0.1,1.3v1.3v1.3l-0.1,1.3l0.4-0.1l0.4-0.5 l0.3-0.3l0.4-0.5l1.1-1.2l0.4-0.6l0.5-0.8l0.3-1.1l0.3-0.7l0.2-1.1L527.9,178.7z\"></path><path class=\"st2\" d=\"M548.1,200.8l0.1,1.2l-1.4,0.2h-1.3l-1.4-0.2l-1.3,0.1l-1.4,0.2l-1.3-0.1h-1.3v-1.4l-0.2-1.4l0.2-1.4 l0.1-1.4l-0.2-1.4l0.1-1.4v-1.4l0-1.4l0.1-1.4l-0.2-1.4l0.2-1.4l-0.1-1.4l0.1-1.4V183l0-1.4l-0.2-1.4l0-1.4l0.1-1.4v-1.4 l-0.2-1.4l0.2-1.4v-1.4l-0.2-1.4l0.1-1.3l1.3-0.2l1.3,0.1l1.3,0.1l1.3-0.1h1.3l1.3,0.1l1.3-0.1l0.1,1.3l-0.1,1.3l0.1,1.2h-1.2 l-1.2,0.1l-1.2,0.1h-1.3l0.2,1.4l-0.1,1.4l-0.2,1.4l0.2,1.4l-0.1,1.4l0.1,1.4l-0.1,1.4h1.5l1.5,0.2l1.6-0.2v1.3l0.1,1.3l-0.1,1.3 l-1.5,0.1l-1.5-0.1l-1.6-0.1l0.1,1.3l-0.1,1.3l0.2,1.3l0,1.3l0.1,1.3l-0.2,1.3l0.2,1.3l-0.2,1.3l0.1,1.2h1.3l1.3,0.2l1.3-0.2 l1.3,0.1l0.1,1.3L548.1,200.8z\"></path><path class=\"st2\" d=\"M559.2,187v1.4l-0.1,1.4l0,1.4l-0.1,1.4l0.1,1.4l0.1,1.4v1.4l0,1.4l-0.1,1.4l0.1,1.4v1.4l-1.5-0.1l-1.4-0.1 l-1.4,0.2l0.1-1.4l-0.1-1.4l-0.1-1.4l0.1-1.4l-0.1-1.4l0.1-1.4v-1.4l0.2-1.4l-0.1-1.4l-0.2-1.4l0.2-1.4l0-1.4l0.2-1.4l-0.2-1.4 l0.2-1.4l-0.1-1.4l0.1-1.4l-0.1-1.4l0-1.4l0.1-1.4l-0.1-1.4l0.1-1.4l-0.1-1.4l-0.1-1.4h1.5l1.4,0.1l1.4-0.1l-0.1,1.4l0.3,1.4 l-0.1,1.4l0.1,1.4l-0.3,1.4v1.4l0.1,1.4l-0.1,1.4v1.4v1.4l0.3,1.4v1.4L559.2,187z\"></path><path class=\"st2\" d=\"M580.7,173.4l0.1,1.4l0.1,1.4l0.1,1.4l-0.1,1.4l0.1,1.4l-0.2,1.4l0.1,1.4l-0.1,1.4l0.1,1.4l0.1,1.4v1.4v1.4 l0.1,1.4v1.4l-0.1,1.4l0,1.4l0,1.4l-0.1,1.4l0.2,1.4l-0.1,1.4v1.3l-1.4,0.2l-1.5-0.2l-1.4,0.2l-0.1-1.4v-1.4v-1.4l0.1-1.4V195 l-0.1-1.4l0.1-1.4l-0.1-1.4l0.2-1.4l-0.3-1.4l0.1-1.4h-1.3l-1.3,0.1l-1.2-0.1l0,1.4l-0.1,1.4l0.2,1.4l-0.2,1.4v1.4l-0.1,1.4 l0.1,1.4l-0.1,1.4v1.4v1.4l0.1,1.4l-1.5,0.1l-1.4,0.2l-1.5-0.2v-1.4l-0.1-1.4l-0.1-1.4l0.1-1.4l0.3-1.4l0-1.4l-0.1-1.4l0.1-1.4 l-0.1-1.4l0.2-1.4l-0.2-1.4v-1.4v-1.4l0.2-1.4l-0.1-1.4l0-1.4v-1.4l0.1-1.4l-0.1-1.4l0.2-1.4l-0.2-1.4l0.1-1.4l-0.2-1.4l0.1-1.4 h1.5l1.4,0.2l1.4-0.2v1.4l0.1,1.3l-0.1,1.4l-0.1,1.4l0.2,1.3l-0.1,1.4l0,1.4l-0.1,1.4v1.3l0.1,1.4l1.3-0.1l1.3,0.1h1.3l-0.1-1.4 l0.1-1.3l0.1-1.4l-0.3-1.4l0.3-1.4l-0.2-1.3l0.2-1.4l-0.1-1.4v-1.3v-1.3l1.4-0.2l1.5,0.1h1.3l0.1,1.4l0.2,1.4L580.7,173.4z\"></path><path class=\"st2\" d=\"M599.1,200.8l0.1,1.2l-1.4,0.2h-1.3l-1.4-0.2l-1.3,0.1l-1.4,0.2l-1.3-0.1h-1.3v-1.4l-0.2-1.4l0.2-1.4 l0.1-1.4l-0.2-1.4l0.1-1.4v-1.4l0-1.4l0.1-1.4l-0.2-1.4l0.2-1.4l-0.1-1.4l0.1-1.4V183l0-1.4l-0.2-1.4l0-1.4l0.1-1.4v-1.4 l-0.2-1.4l0.2-1.4v-1.4l-0.2-1.4l0.1-1.3l1.3-0.2l1.3,0.1l1.3,0.1l1.3-0.1h1.3l1.3,0.1l1.3-0.1l0.1,1.3l-0.1,1.3l0.1,1.2h-1.2 l-1.2,0.1l-1.2,0.1h-1.3l0.2,1.4l-0.1,1.4l-0.2,1.4l0.2,1.4l-0.1,1.4l0.1,1.4l-0.1,1.4h1.5l1.5,0.2l1.6-0.2v1.3l0.1,1.3l-0.1,1.3 l-1.5,0.1l-1.5-0.1l-1.6-0.1l0.1,1.3l-0.1,1.3l0.2,1.3l0,1.3l0.1,1.3l-0.2,1.3l0.2,1.3l-0.2,1.3l0.1,1.2h1.3l1.3,0.2l1.3-0.2 l1.3,0.1l0.1,1.3L599.1,200.8z\"></path><path class=\"st2\" d=\"M634.4,199.3v1.4l-0.1,1.4l-1.5-0.1l-1.4,0.2L630,202v-1.3l-0.1-1.3l0.1-1.3l0-1.3v-1.3l0-1.3v-1.3l-0.1-1.3 l0.2-1.3v-1.3l-0.2-1.3l0.2-1.3l-0.1-1.1l0.2-1.2l0.1-0.9l0.1-0.3l-0.4,1.2l-0.4,1.1l-0.2,1.2l-0.5,1.3l-0.3,1.3l-0.2,1.3 l-0.5,1.2l-0.3,1.3l-0.4,1.3l-0.3,1.3l-0.2,0.4l-0.1,0.2l-0.1,0.1l-0.1-0.1l-0.1-0.2l-0.1-0.4l-0.4-1.3l-0.4-1.3l-0.2-1.3 l-0.4-1.3l-0.4-1.3l-0.4-1.3l-0.2-1.3l-0.4-1.2l-0.3-1.1l-0.3-1.2v0.3l0.1,0.9l0.1,1.2l0.1,1.1l-0.1,1.3l0,1.3l0.1,1.3l-0.1,1.3 l-0.1,1.3l0.1,1.3v1.3l0.1,1.3l-0.2,1.3l0.1,1.3v1.3l0,1.3l-1.5,0.2h-1.4l-1.6-0.1v-1.4l0.1-1.4l-0.1-1.4l0.2-1.4l-0.2-1.4 l0.1-1.4v-1.4v-1.4l-0.1-1.4l0.2-1.4l-0.1-1.4l0.1-1.4l-0.1-1.4l0.2-1.4l-0.1-1.4v-1.4l-0.1-1.4l0.2-1.4l-0.3-1.4l0.1-1.4 l0.2-1.4l-0.2-1.4l0.3-1.4l-0.2-1.4l1.4,0.1h1.4h1.4l0.4,1.4l0.5,1.3l0.2,1.4l0.4,1.3l0.5,1.3l0.3,1.4l0.5,1.3l0.3,1.4l0.4,1.3 l0.1,0.2v0.4l0.3,1.1v0.2l0.1-0.2l0.2-1l0.1-0.4l0.1-0.3l0.5-1.3l0.3-1.4l0.3-1.4l0.5-1.3l0.2-1.4l0.6-1.3l0.2-1.4l0.3-1.4 l0.5-1.3h1.4l1.4-0.1h1.5l0,1.4l-0.3,1.4l0.2,1.4l-0.1,1.4v1.4l0,1.4l0.1,1.4v1.4l-0.2,1.4l0,1.4l0.2,1.4l-0.1,1.4v1.4l-0.1,1.4 v1.4l0.2,1.4l-0.2,1.4l0.3,1.4v1.4l0,1.4l0,1.4L634.4,199.3z\"></path><path class=\"st2\" d=\"M652.8,200.8l0.1,1.2l-1.4,0.2h-1.3l-1.4-0.2l-1.3,0.1l-1.4,0.2l-1.3-0.1h-1.3v-1.4l-0.2-1.4l0.2-1.4 l0.1-1.4l-0.2-1.4l0.1-1.4v-1.4l0-1.4l0.1-1.4l-0.2-1.4l0.2-1.4l-0.1-1.4l0.1-1.4V183l0-1.4l-0.2-1.4l0-1.4l0.1-1.4v-1.4 l-0.2-1.4l0.2-1.4v-1.4l-0.2-1.4l0.1-1.3l1.3-0.2l1.3,0.1l1.3,0.1l1.3-0.1h1.3l1.3,0.1l1.3-0.1l0.1,1.3l-0.1,1.3l0.1,1.2h-1.2 l-1.2,0.1l-1.2,0.1h-1.3l0.2,1.4l-0.1,1.4l-0.2,1.4l0.2,1.4l-0.1,1.4l0.1,1.4l-0.1,1.4h1.5l1.5,0.2l1.6-0.2v1.3l0.1,1.3l-0.1,1.3 l-1.5,0.1l-1.5-0.1l-1.6-0.1l0.1,1.3l-0.1,1.3l0.2,1.3l0,1.3l0.1,1.3l-0.2,1.3l0.2,1.3l-0.2,1.3l0.1,1.2h1.3l1.3,0.2l1.3-0.2 l1.3,0.1l0.1,1.3L652.8,200.8z\"></path><path class=\"st2\" d=\"M671.9,179.9l-0.2,1.2l-0.3,1.1l-0.3,0.8l-0.5,1l-0.6,1.3l-0.5,0.8l-0.7,0.9l-0.5,0.7l0.2,1.4l0.5,1.3 l0.3,1.3l0.3,1.4l0.4,1.3l0.4,1.3l0.5,1.3l0.3,1.3l0.2,1.4l0.4,1.3l0.3,1.2l-1.4,0.2l-1.5,0.1l-1.5-0.1l-0.3-1.3l-0.2-1.4 l-0.5-1.3l-0.3-1.4l-0.3-1.3l-0.3-1.4l-0.4-1.3l-0.3-1.3l-0.4-1.3l-0.1,0.1h-0.2l-0.3,0.2l-0.2,0.1l-0.2,0.1l0.1,1.3v1.3v1.3 l0.1,1.3l-0.2,1.3l0.1,1.3l-0.1,1.3l0.1,1.3l0.1,1.3l-1.5,0.1l-1.4-0.2l-1.4,0.1l0.1-1.4l-0.1-1.4l0.1-1.4l-0.2-1.4l0.1-1.4 l0-1.4l0.1-1.4l-0.1-1.4l0.2-1.4l-0.2-1.4l0-1.4l-0.1-1.4v-1.4l0.1-1.4l0-1.4l0.2-1.4l-0.1-1.4l0.1-1.4l-0.1-1.4l0.1-1.4 l-0.1-1.4l0.1-1.4l-0.2-1.4l0-1.4l1.4,0.1l1.5-0.1l1.4,0.2l1.4-0.1l0.5,0.1l0.9,0.2l1.2,0.8l1.1,0.5l0.9,0.9l0.4,0.7l0.6,0.8 l0.4,0.7l0.3,0.7l0.4,1l0.1,0.8l0.2,1.1l0.2,1.2L671.9,179.9z M667.8,178.7l-0.1-0.8l-0.1-1.4l-0.3-0.6l-0.3-0.6l-0.9-1.1 l-0.4-0.5l-0.6-0.2l-0.6-0.2l-0.4-0.1h-0.4h-0.2l0.2,1.3l-0.1,1.3l0,1.3l-0.1,1.3l0.1,1.3v1.3l0.1,1.3v1.3v1.3l-0.1,1.3l0.4-0.1 l0.4-0.5l0.3-0.3l0.4-0.5l1.1-1.2l0.4-0.6l0.5-0.8l0.3-1.1l0.3-0.7l0.2-1.1L667.8,178.7z\"></path><path class=\"st2\" d=\"M687.7,202.1l-1.4,0.1l-1.4-0.3l-1.4,0.1l-1.4,0.1l-1.4,0.1l-1.4-0.2L678,202l0.2-1.3l0.5-1.3l0.1-1.3 l0.4-1.3l0.1-1.4l0.4-1.3l0.3-1.3l0.3-1.3l0.3-1.3l0.1-1.4l0.5-1.3l0.1-1.3l0.2-1.4l0.4-1.3l0.4-1.3l0.1-1.4l0.5-1.3l0.2-1.3 l0.2-1.3l0.3-1.3l0.2-1.3l0.3-1.2l-1.3-0.2l-1.3,0.2l-1.3-0.2l-1.3,0.1l-0.1-1.3l0-1.3l0.1-1.2l1.3-0.2h1.3l1.3,0.1l1.3,0.1h1.3 l1.3-0.1l1.3,0.1l1.4,0.1l-0.5,1.3l-0.1,1.3l-0.2,1.3l-0.3,1.3l-0.4,1.3l-0.2,1.3l-0.3,1.3l-0.3,1.3l-0.2,1.3l-0.3,1.3l-0.2,1.3 l-0.3,1.3l-0.4,1.3l-0.2,1.3l-0.4,1.3l-0.2,1.3l-0.2,1.3l-0.4,1.3l-0.2,1.3l-0.3,1.3l0,1.3l-0.4,1.3l1.5-0.2l1.5,0.2l1.5-0.1h1.4 v1.3l0.1,1.3v1.2L687.7,202.1z\"></path><path class=\"st2\" d=\"M714.9,191.1l-0.1,1.4l0.1,1.4l-0.1,1.4l-0.2,1.4l0.2,1.4l0.1,1.4l-0.2,1.4l0.1,1.3l-1.4,0.2H712l-1.5-0.1 l0.2-1.4l0-1.3l-0.2-1.4v-1.4l0-1.4l-0.1-1.3l0.1-1.4l0-1.4l0.1-1.4l-0.2-1.3l0.1-1.4l0-1.4l0.1-1.4v-1.3l0.1-1.4l-0.2-1.4v-1.4 l0.2-1.3l-0.1-1.4l0.2-0.7l-0.2-0.1l0.2-0.5l0-0.2l-0.3,1.1l-1.1,1.3l-1-0.8l-1.1-0.6l-1-0.9l0.9-0.9l0.7-1.1l0.9-0.9l0.8-1 l0.6-1.1l0.9-1l1.3,0.2h1.3l1.2-0.1l0.2,1.4l0.1,1.4l-0.1,1.4l-0.1,1.4l0.1,1.4v1.4l-0.1,1.4l0.2,1.4l-0.2,1.4l-0.1,1.4l0.3,1.4 l0.1,1.4l-0.2,1.4l0.2,1.4l0.1,1.4L714.9,191.1z\"></path><path class=\"st2\" d=\"M733.2,181.8l0.1,0.8l-0.1,0.8l-0.2,0.7l-0.3,1.3l-0.1,1.3l-0.3,1.3l-0.3,1.7l-0.5,1.1l-0.4,1.2l-0.3,1.4 l-0.4,1.2l-0.6,1.2l-0.4,1.2l-0.5,0.8l-0.2,0.9l-0.7,1l-0.5,1.2l-0.9,1.6l-1.3-0.6l-1.2-0.7l-1.3-0.8l1-1.4l0.7-1.3l0.6-1.2 l0.3-0.7l0.4-0.9l0.4-1l0.2-0.8l0.6-1.2l0-0.8l0.3-0.6l0.1-0.5l-0.1,0.1l-0.4,0.2l-0.4,0.2l-1.1,0.1l-1.1-0.7l-1.1-0.9l-0.8-1.4 l-0.5-1.4l-0.5-1.4l-0.3-1l-0.1-1.1l0-1.2l-0.2-1.2l0.1-1.3v-1.4l0.4-1.3l0-1.2l0.3-1.1l0.4-1.1l0.8-1.2l0.9-1.3l0.7-0.6l0.9-0.5 l0.8-0.3h0.9l0.9,0.1l0.8,0.2l0.9,0.5l0.6,0.6l1.1,1l0.7,1.4l0.4,1.6l0.6,1.5L733,178l0.2,1.2v1.2l0.1,0.8L733.2,181.8z M729,180.3l0.1-1.3l-0.2-1.2l-0.3-2l-0.3-0.9l-0.3-0.7l-0.4-0.8l-0.3-0.1l-0.2-0.2l-0.2,0.2l-0.2,0.2l-0.4,0.7l-0.3,0.8 l-0.2,0.8l-0.2,1.1l-0.1,1.1l-0.2,1.2l0.1,1.2l0,1.1l-0.2,1l0.5,1.7l0.1,0.8l0.3,0.7l0.5,0.8l0.3,0.2h0.2l0.3,0.1l0.3-0.2 l0.5-0.8l0.3-1l0.2-1.2l0.4-1.3L729,180.3z\"></path><path class=\"st2\" d=\"M749,202.1h-1.3l-1.3-0.2l-1.3,0.1l-1.3,0.1l-1.3,0.1l-1.3-0.1l-1.3,0.1l-1.3-0.1v-1.4l0.1-0.8l-0.2-1.8 l0.1-1.1l0.2-0.9l0.1-1.5l0.4-1.5l0.2-1.2l0.4-1l0.4-1.1l0.7-1.6l0.3-0.9l0.3-0.4l0.4-1l0.5-1l0.4-0.7l0.6-1.4l0.4-0.7l0-0.2 l0.2-0.2l0.5-1.2l0.3-0.9l0.1-1.1l0.2-1.3l0.1-0.8l-0.3-1l-0.4-0.7l-0.5-0.8l-0.8-0.6l-0.6-0.3l-1-0.4l-0.8-0.1l0.2-1.3l0.2-1.3 l0.3-1.4l1.1,0.4l1.3,0.2l1,0.4l0.9,0.7l0.8,0.6l1.1,1.3l1.1,1.5l0.3,0.9l0.2,0.9l0.2,0.9v1l0.1,1l-0.3,1.1l-0.2,0.7l-0.2,0.8 l-0.5,1.3l-0.6,1.5l-0.4,0.8l-0.4,0.8l-0.7,1.5l-0.7,1.5l-0.4,0.7l-0.4,0.7L744,191l-0.4,1.4l-0.3,0.8l-0.2,1.2l-0.2,0.9l-0.2,1 l0,0.5l-0.1,0.9l0.1,0.6l1.3-0.1l1.3-0.1l1.2-0.1l1.3,0.2l1.2-0.1l0.1,1.3l0.1,1.3L749,202.1z\"></path><path class=\"st2\" d=\"M767.1,192.4l-0.1,1.3l-0.3,1.4l-0.4,1.6l-0.4,1.6l-0.7,1.2l-0.9,1.4l-0.7,0.6l-0.9,0.4l-0.8,0.4l-0.9,0.1 l-0.8-0.1l-0.8-0.2l-0.7-0.5l-0.7-0.5l-0.9-0.7l-0.7-1l-0.4-1l-0.3-0.9l-0.4-0.9l-0.3-1.4l1.4-0.2l1.4-0.3l1.5-0.1l0.2,1l0.3,1.1 l0.3,0.5l0.4,0.4l0.2,0.1l0.2,0.1l0.2-0.1l0.3-0.2l0.5-0.7l0.2-0.8l0.2-0.9l0.2-1.1l0.3-1.1l-0.1-1.2v-1.2l0.1-1l-0.2-1.1 l-0.2-1.7l-0.3-0.8l-0.3-0.7l-0.4-0.8l-0.3-0.2l-0.2-0.1l-0.6,0.3l-0.1,0.2l-1.2-0.4l-1.2-0.2l-1.3-0.5l0.6-1.2l0.7-1.2l0.5-1.3 l0.3-1.3l0.7-1.2l0.4-1.3l0.6-1.2l0.5-1.2l0.5-1.2l-1.4-0.1h-1.4l-1.4,0.1l-1.5-0.1l0.1-1.3v-1.3l-0.1-1.2h1.4l1.5-0.2h1.4 l1.4,0.1l1.4,0.1l1.5-0.2h1.4l1.4,0.1l-0.4,1.4l-0.6,1.3l-0.7,1.3l-0.6,1.3l-0.4,1.4l-0.6,1.3l-0.5,1.3l-0.5,1.3l-0.7,1.3 l0.2-0.1l0.7-0.1l0.8,0.2l0.8,1l0.9,1.1l0.7,1.2l0.5,1.6l0.2,1.6l0.2,1.2l0.1,1.3l0.3,1.2L767.1,192.4z\"></path><path class=\"st2\" d=\"M783.4,187.4l-1.4-0.1l-1.4,0.1l-1.4,0.1l-1.4-0.2h-1.4l-1.4,0.1h-1.4l0.1-1.2l-0.2-1.2l0-1.1l1.4-0.2 l1.4,0.2l1.4-0.2l1.4,0.1h1.4l1.4,0.2l1.4-0.2l1.4,0.1l-0.1,1.2l0.1,1.2v1L783.4,187.4z\"></path><path class=\"st2\" d=\"M797.1,191.1l-0.1,1.4l0.1,1.4l-0.1,1.4l-0.2,1.4l0.2,1.4l0.1,1.4l-0.2,1.4l0.1,1.3l-1.4,0.2h-1.4l-1.5-0.1 l0.2-1.4l0-1.3l-0.2-1.4v-1.4l0-1.4l-0.1-1.3l0.1-1.4l0-1.4l0.1-1.4l-0.2-1.3l0.1-1.4l0-1.4l0.1-1.4v-1.3l0.1-1.4l-0.2-1.4v-1.4 l0.2-1.3l-0.1-1.4l0.2-0.7l-0.2-0.1l0.2-0.5l0-0.2l-0.3,1.1l-1.1,1.3l-1-0.8l-1.1-0.6l-1-0.9l0.9-0.9l0.7-1.1l0.9-0.9l0.8-1 l0.6-1.1l0.9-1l1.3,0.2h1.3l1.2-0.1l0.2,1.4l0.1,1.4l-0.1,1.4l-0.1,1.4l0.1,1.4v1.4l-0.1,1.4l0.2,1.4l-0.2,1.4l-0.1,1.4l0.3,1.4 l0.1,1.4L797,187l0.2,1.4l0.1,1.4L797.1,191.1z\"></path><path class=\"st2\" d=\"M815.4,181.8l0.1,0.8l-0.1,0.8l-0.2,0.7l-0.3,1.3l-0.1,1.3l-0.3,1.3l-0.3,1.7l-0.5,1.1l-0.4,1.2l-0.3,1.4 l-0.4,1.2l-0.6,1.2l-0.4,1.2l-0.5,0.8l-0.2,0.9l-0.7,1l-0.5,1.2l-0.9,1.6l-1.3-0.6l-1.2-0.7l-1.3-0.8l1-1.4l0.7-1.3l0.6-1.2 l0.3-0.7l0.4-0.9l0.4-1l0.2-0.8l0.6-1.2l0-0.8l0.3-0.6l0.1-0.5l-0.1,0.1l-0.4,0.2l-0.4,0.2l-1.1,0.1l-1.1-0.7l-1.1-0.9l-0.8-1.4 l-0.5-1.4l-0.5-1.4l-0.3-1l-0.1-1.1l0-1.2l-0.2-1.2l0.1-1.3v-1.4l0.4-1.3l0-1.2l0.3-1.1l0.4-1.1l0.8-1.2l0.9-1.3l0.7-0.6l0.9-0.5 l0.8-0.3h0.9l0.9,0.1l0.8,0.2l0.9,0.5l0.6,0.6l1.1,1l0.7,1.4l0.4,1.6l0.6,1.5l-0.1,1.8l0.2,1.2v1.2l0.1,0.8L815.4,181.8z M811.2,180.3l0.1-1.3l-0.2-1.2l-0.3-2l-0.3-0.9l-0.3-0.7l-0.4-0.8l-0.3-0.1l-0.2-0.2l-0.2,0.2l-0.2,0.2l-0.4,0.7l-0.3,0.8 l-0.2,0.8l-0.2,1.1l-0.1,1.1l-0.2,1.2l0.1,1.2l0,1.1l-0.2,1l0.5,1.7l0.1,0.8l0.3,0.7l0.5,0.8l0.3,0.2h0.2l0.3,0.1l0.3-0.2 l0.5-0.8l0.3-1l0.2-1.2l0.4-1.3L811.2,180.3z\"></path><path class=\"st2\" d=\"M833.2,192.4l-0.1,1.3l-0.3,1.4l-0.4,1.6l-0.4,1.6l-0.7,1.2l-0.9,1.4l-0.7,0.6l-0.9,0.4l-0.8,0.4l-0.9,0.1 l-0.8-0.1l-0.8-0.2l-0.7-0.5l-0.7-0.5l-0.9-0.7l-0.7-1l-0.4-1l-0.3-0.9l-0.4-0.9l-0.3-1.4l1.4-0.2l1.4-0.3l1.5-0.1l0.2,1l0.3,1.1 l0.3,0.5l0.4,0.4l0.2,0.1l0.2,0.1l0.2-0.1l0.3-0.2l0.5-0.7l0.2-0.8l0.2-0.9l0.2-1.1l0.3-1.1l-0.1-1.2v-1.2l0.1-1l-0.2-1.1 l-0.2-1.7l-0.3-0.8l-0.3-0.7l-0.4-0.8l-0.3-0.2l-0.2-0.1l-0.6,0.3l-0.1,0.2l-1.2-0.4l-1.2-0.2l-1.3-0.5l0.6-1.2l0.7-1.2l0.5-1.3 l0.3-1.3l0.7-1.2l0.4-1.3l0.6-1.2l0.5-1.2l0.5-1.2l-1.4-0.1h-1.4l-1.4,0.1l-1.5-0.1l0.1-1.3v-1.3l-0.1-1.2h1.4l1.5-0.2h1.4 l1.4,0.1l1.4,0.1l1.5-0.2h1.4l1.4,0.1l-0.4,1.4l-0.6,1.3l-0.7,1.3l-0.6,1.3l-0.4,1.4l-0.6,1.3l-0.5,1.3l-0.5,1.3l-0.7,1.3 l0.2-0.1l0.7-0.1l0.8,0.2l0.8,1l0.9,1.1l0.7,1.2l0.5,1.6l0.2,1.6l0.2,1.2l0.1,1.3l0.3,1.2L833.2,192.4z\"></path><path class=\"st2\" d=\"M849.9,202.1h-1.3l-1.3-0.2L846,202l-1.3,0.1l-1.3,0.1l-1.3-0.1l-1.3,0.1l-1.3-0.1v-1.4l0.1-0.8l-0.2-1.8 l0.1-1.1l0.2-0.9l0.1-1.5l0.4-1.5l0.2-1.2l0.4-1l0.4-1.1l0.7-1.6l0.3-0.9l0.3-0.4l0.4-1l0.5-1l0.4-0.7l0.6-1.4l0.4-0.7l0-0.2 l0.2-0.2l0.5-1.2l0.3-0.9l0.1-1.1l0.2-1.3l0.1-0.8l-0.3-1l-0.4-0.7l-0.5-0.8l-0.8-0.6l-0.6-0.3l-1-0.4l-0.8-0.1l0.2-1.3l0.2-1.3 l0.3-1.4l1.1,0.4l1.3,0.2l1,0.4l0.9,0.7l0.8,0.6l1.1,1.3l1.1,1.5l0.3,0.9l0.2,0.9l0.2,0.9v1l0.1,1l-0.3,1.1l-0.2,0.7l-0.2,0.8 l-0.5,1.3l-0.6,1.5l-0.4,0.8l-0.4,0.8l-0.7,1.5l-0.7,1.5l-0.4,0.7l-0.4,0.7l-0.6,1.2l-0.4,1.4l-0.3,0.8l-0.2,1.2l-0.2,0.9l-0.2,1 l0,0.5l-0.1,0.9l0.1,0.6l1.3-0.1l1.3-0.1l1.2-0.1l1.3,0.2l1.2-0.1l0.1,1.3l0.1,1.3L849.9,202.1z\"></path></g></g><g><g><path class=\"st3\" d=\"M6.7,335H3.4L0,309.5h3.3l1.6,14.1l0.2,3.1l0.2-3.1l1.6-14.1h3.3L6.7,335z\"></path><path class=\"st3\" d=\"M24.6,321.3c0,1.8-0.1,3.6-0.2,5.2c-0.1,1.6-0.4,3.1-0.8,4.4c-0.4,1.3-0.9,2.4-1.6,3.2 c-0.7,0.8-1.6,1.2-2.6,1.2c-1,0-1.9-0.4-2.6-1.2c-0.7-0.8-1.2-1.9-1.6-3.2c-0.4-1.3-0.6-2.8-0.8-4.4c-0.1-1.6-0.2-3.3-0.2-5.1 c0-1.8,0.1-3.4,0.3-4.8c0.2-1.5,0.5-2.7,0.9-3.8c0.4-1.1,1-1.9,1.6-2.6c0.7-0.6,1.5-0.9,2.5-0.9c1,0,1.8,0.3,2.5,0.9 c0.7,0.6,1.2,1.5,1.6,2.5c0.4,1.1,0.7,2.4,0.9,3.8C24.5,317.9,24.6,319.6,24.6,321.3L24.6,321.3z M21.2,321.4 c0-5.9-0.6-8.9-1.8-9c-1.3,0-1.9,3-1.9,8.9c0,1.4,0.1,2.8,0.2,4.1c0.1,1.3,0.2,2.4,0.4,3.4s0.4,1.8,0.6,2.3 c0.2,0.6,0.4,0.8,0.6,0.8c0.2,0,0.5-0.3,0.7-0.8c0.2-0.6,0.4-1.3,0.6-2.3c0.2-1,0.3-2.1,0.4-3.4 C21.1,324.2,21.2,322.8,21.2,321.4L21.2,321.4z\"></path><path class=\"st3\" d=\"M36.7,335l-2.8-12l-0.6-2.9c0,0.3,0.1,0.7,0.1,1.3c0,0.6,0.1,1.1,0.1,1.5V335h-3.3v-25.5h3.1l2.8,11.1l0.7,3 c0-0.3-0.1-0.7-0.1-1.2c0-0.6-0.1-1.1-0.1-1.6v-11.2h3.2V335H36.7z\"></path><path class=\"st3\" d=\"M60.9,335v-12h-3v12h-3.4v-25.5h3.4V320h3v-10.5h3.3V335H60.9z\"></path><path class=\"st3\" d=\"M79.8,321.3c0,1.8-0.1,3.6-0.2,5.2c-0.1,1.6-0.4,3.1-0.8,4.4c-0.4,1.3-0.9,2.4-1.6,3.2 c-0.7,0.8-1.6,1.2-2.6,1.2c-1,0-1.9-0.4-2.6-1.2c-0.7-0.8-1.2-1.9-1.6-3.2c-0.4-1.3-0.6-2.8-0.8-4.4c-0.1-1.6-0.2-3.3-0.2-5.1 c0-1.8,0.1-3.4,0.3-4.8c0.2-1.5,0.5-2.7,0.9-3.8c0.4-1.1,1-1.9,1.6-2.6c0.7-0.6,1.5-0.9,2.5-0.9c1,0,1.8,0.3,2.5,0.9 c0.7,0.6,1.2,1.5,1.6,2.5c0.4,1.1,0.7,2.4,0.9,3.8C79.7,317.9,79.8,319.6,79.8,321.3L79.8,321.3z M76.4,321.4 c0-5.9-0.6-8.9-1.8-9c-1.3,0-1.9,3-1.9,8.9c0,1.4,0.1,2.8,0.2,4.1c0.1,1.3,0.2,2.4,0.4,3.4s0.4,1.8,0.6,2.3 c0.2,0.6,0.4,0.8,0.6,0.8c0.2,0,0.5-0.3,0.7-0.8c0.2-0.6,0.4-1.3,0.6-2.3c0.2-1,0.3-2.1,0.4-3.4 C76.3,324.2,76.4,322.8,76.4,321.4L76.4,321.4z\"></path><path class=\"st3\" d=\"M85.3,335v-25.5h3.4V332h3.9v3H85.3z\"></path><path class=\"st3\" d=\"M97.5,335v-25.5h3.4V332h3.9v3H97.5z\"></path><path class=\"st3\" d=\"M116.6,335l-0.6-4.8h-2.7l-0.6,4.8h-3.4l3.7-25.5h3.4L120,335H116.6z M114.9,319.9l-0.2-3.1l-0.2,3.1 l-0.7,7.2h1.9L114.9,319.9z\"></path><path class=\"st3\" d=\"M131.1,335l-2.8-12l-0.6-2.9c0,0.3,0.1,0.7,0.1,1.3c0,0.6,0.1,1.1,0.1,1.5V335h-3.3v-25.5h3.1l2.8,11.1 l0.7,3c0-0.3-0.1-0.7-0.1-1.2c0-0.6-0.1-1.1-0.1-1.6v-11.2h3.2V335H131.1z\"></path><path class=\"st3\" d=\"M149.5,320.9c0,1.6-0.1,3.1-0.3,4.3c-0.2,1.3-0.6,2.6-1.3,3.9c-0.8,1.7-2,3.1-3.5,4.4 c-0.5,0.4-1.2,0.8-2,1.2c-0.8,0.3-1.7,0.5-2.6,0.5v-25.7c0.7,0,1.5,0.1,2.4,0.2c0.8,0.1,1.4,0.3,1.8,0.5c0.8,0.4,1.5,0.9,2.1,1.5 c0.6,0.5,1.1,1.2,1.5,1.9c0.7,1.2,1.2,2.3,1.5,3.5S149.5,319.3,149.5,320.9L149.5,320.9z M146,317.7c-0.2-0.8-0.5-1.6-0.9-2.3 c-0.4-0.8-1-1.5-1.7-2.2c-0.1-0.1-0.2-0.1-0.4-0.2v17.4c0.2-0.2,0.3-0.3,0.5-0.4c0.3-0.3,0.6-0.7,0.8-1.1 c0.3-0.4,0.5-0.8,0.6-1.2c0.5-1.1,0.8-2.2,0.9-3.1c0.1-1,0.2-2.2,0.3-3.6C146.3,319.6,146.2,318.5,146,317.7z\"></path><path class=\"st3\" d=\"M173.9,320.9c0,1.6-0.1,3.1-0.3,4.3c-0.2,1.3-0.6,2.6-1.3,3.9c-0.8,1.7-2,3.1-3.5,4.4 c-0.5,0.4-1.2,0.8-2,1.2c-0.8,0.3-1.7,0.5-2.6,0.5v-25.7c0.7,0,1.5,0.1,2.4,0.2c0.8,0.1,1.4,0.3,1.8,0.5c0.8,0.4,1.5,0.9,2.1,1.5 c0.6,0.5,1.1,1.2,1.5,1.9c0.7,1.2,1.2,2.3,1.5,3.5S173.9,319.3,173.9,320.9L173.9,320.9z M170.4,317.7c-0.2-0.8-0.5-1.6-0.9-2.3 c-0.4-0.8-1-1.5-1.7-2.2c-0.1-0.1-0.2-0.1-0.4-0.2v17.4c0.2-0.2,0.3-0.3,0.5-0.4c0.3-0.3,0.6-0.7,0.8-1.1 c0.3-0.4,0.5-0.8,0.6-1.2c0.5-1.1,0.8-2.2,0.9-3.1c0.1-1,0.2-2.2,0.3-3.6C170.7,319.6,170.6,318.5,170.4,317.7z\"></path><path class=\"st3\" d=\"M185.3,335l-0.6-4.8H182l-0.6,4.8H178l3.7-25.5h3.4l3.6,25.5H185.3z M183.6,319.9l-0.2-3.1l-0.2,3.1 l-0.7,7.2h1.9L183.6,319.9z\"></path><path class=\"st3\" d=\"M203,320.9c0,1.6-0.1,3.1-0.3,4.3c-0.2,1.3-0.6,2.6-1.3,3.9c-0.8,1.7-2,3.1-3.5,4.4c-0.5,0.4-1.2,0.8-2,1.2 c-0.8,0.3-1.7,0.5-2.6,0.5v-25.7c0.7,0,1.5,0.1,2.4,0.2c0.8,0.1,1.4,0.3,1.8,0.5c0.8,0.4,1.5,0.9,2.1,1.5 c0.6,0.5,1.1,1.2,1.5,1.9c0.7,1.2,1.2,2.3,1.5,3.5S203,319.3,203,320.9L203,320.9z M199.4,317.7c-0.2-0.8-0.5-1.6-0.9-2.3 c-0.4-0.8-1-1.5-1.7-2.2c-0.1-0.1-0.2-0.1-0.4-0.2v17.4c0.2-0.2,0.3-0.3,0.5-0.4c0.3-0.3,0.6-0.7,0.8-1.1 c0.3-0.4,0.5-0.8,0.6-1.2c0.5-1.1,0.8-2.2,0.9-3.1c0.1-1,0.2-2.2,0.3-3.6C199.7,319.6,199.6,318.5,199.4,317.7z\"></path><path class=\"st3\" d=\"M214.4,335l-0.6-4.8H211l-0.6,4.8H207l3.7-25.5h3.4l3.6,25.5H214.4z M212.6,319.9l-0.2-3.1l-0.2,3.1 l-0.7,7.2h1.9L212.6,319.9z\"></path><path class=\"st3\" d=\"M241,327.6c0,0.9-0.1,1.7-0.2,2.3c-0.1,0.6-0.4,1.3-0.8,2.2c-0.3,0.6-0.7,1-1.1,1.4 c-0.4,0.4-0.9,0.7-1.4,0.9c-0.7,0.3-1.6,0.5-2.8,0.5h-3.4v-25.5h3.4l0.1,0c0.6,0,1.2,0,1.6,0.1c0.4,0.1,0.8,0.2,1.3,0.4 c1.4,0.7,2.3,1.9,2.7,3.6c0.1,0.7,0.2,1.3,0.2,1.8c0,1.1-0.3,2.2-0.9,3.5c-0.4,0.9-1,1.7-1.9,2.3c0.4,0.4,1,0.9,1.6,1.7l0.2,0.2 c0.4,0.6,0.8,1.3,1.1,2.1S241.1,326.9,241,327.6L241,327.6z M236.1,312.7c-0.3-0.1-0.7-0.2-1.3-0.2h-0.2v7.6l0.4-0.3 c0.3-0.2,0.6-0.5,0.9-0.9c0.3-0.5,0.6-0.9,0.8-1.3c0.3-0.8,0.5-1.5,0.5-2.1c0-0.3-0.1-0.7-0.2-1.2 C237,313.5,236.7,313,236.1,312.7z M237.7,327.6c0-0.4-0.1-0.9-0.2-1.4c-0.1-0.5-0.3-0.9-0.5-1.2l-0.2-0.3 c-0.3-0.5-0.7-1-0.9-1.3c-0.3-0.3-0.7-0.7-1.1-1v9.4c0.5,0,0.9-0.1,1.1-0.2c0.6-0.2,1-0.6,1.3-1.1c0.3-0.5,0.5-1,0.5-1.4 C237.7,328.8,237.7,328.3,237.7,327.6L237.7,327.6z\"></path><path class=\"st3\" d=\"M246.7,335v-25.5h3.4V335H246.7z\"></path><path class=\"st3\" d=\"M262.9,330c-0.2,0.6-0.5,1.1-0.9,1.7c-0.4,0.6-1,1.1-1.6,1.6c-0.6,0.5-1.2,0.9-1.9,1.3 c-0.6,0.4-1.2,0.6-1.8,0.8l-1.3-2.9c1-0.4,1.9-0.8,2.7-1.4c0.8-0.6,1.3-1.2,1.5-1.9c0.3-0.9,0.4-1.6,0.4-2.2 c0-0.7-0.2-1.4-0.5-2.1c-0.3-0.7-0.9-1.6-1.7-2.6c-1-1.3-1.8-2.5-2.3-3.4c-0.5-0.9-0.7-1.9-0.7-2.9c0-0.7,0.1-1.5,0.4-2.3 c0.1-0.3,0.3-0.7,0.7-1.2c0.3-0.5,0.8-0.9,1.2-1.4c0.5-0.5,1-0.9,1.5-1.2s0.9-0.5,1.3-0.6l1.3,2.6c-0.5,0.2-1.1,0.5-1.8,1.1 c-0.6,0.5-1,1.1-1.2,1.6c-0.2,0.5-0.2,1-0.2,1.4c0,0.7,0.2,1.4,0.5,1.9s1,1.4,1.8,2.5c0.1,0.1,0.1,0.2,0.2,0.3 c0.9,1.2,1.6,2.4,2.1,3.4c0.4,1,0.6,2,0.6,3.1C263.5,327.9,263.3,328.9,262.9,330L262.9,330z\"></path><path class=\"st3\" d=\"M276.7,335l4.3-22.5h-4v-3h7.9l-4.3,22.5h4.6v3H276.7z\"></path><path class=\"st3\" d=\"M299.9,326.1c0,1.4,0,2.6-0.1,3.6c-0.1,1-0.3,1.9-0.6,2.7c-0.3,0.8-0.8,1.5-1.5,1.9 c-0.7,0.5-1.6,0.7-2.7,0.7c-1.1,0-1.9-0.2-2.6-0.7s-1.2-1.1-1.5-1.9c-0.3-0.8-0.5-1.7-0.6-2.7c-0.1-1-0.1-2.2-0.1-3.6v-16.6h3.4 v17.4c0,1.8,0.1,3.1,0.3,3.9c0.2,0.8,0.6,1.1,1.2,1.1s1-0.4,1.2-1.1c0.2-0.8,0.3-2.1,0.3-3.9v-17.4h3.4L299.9,326.1L299.9,326.1z \"></path><path class=\"st3\" d=\"M315.2,318.8c-0.1,0.6-0.4,1.3-0.8,2.1c-0.3,0.6-0.6,1.1-0.8,1.5c-0.3,0.4-0.6,0.8-1,1.3l2.8,11.3h-3.3 l-2.3-9.3c-0.3,0.2-0.5,0.3-0.7,0.4v8.9h-3.4v-25.5h3.3c0.5,0,0.9,0,1.2,0s0.6,0.1,0.9,0.2c0.7,0.2,1.3,0.6,1.8,1s0.9,1,1.4,1.7 c0.4,0.7,0.7,1.4,0.8,2c0.2,0.6,0.2,1.4,0.3,2.3C315.5,317.5,315.4,318.1,315.2,318.8z M312.1,316.7c0-1-0.2-1.9-0.5-2.6 c-0.3-0.7-0.8-1.2-1.4-1.4c-0.4-0.2-0.7-0.2-1.1-0.2v10.1c0.4-0.2,0.8-0.5,1.1-0.9c0.3-0.3,0.6-0.7,0.8-1s0.4-0.7,0.6-1.1 c0.2-0.5,0.4-1,0.4-1.4C312.1,317.8,312.2,317.3,312.1,316.7L312.1,316.7z\"></path><path class=\"st3\" d=\"M339.6,326.1c0,1.4,0,2.6-0.1,3.6c-0.1,1-0.3,1.9-0.6,2.7c-0.3,0.8-0.8,1.5-1.5,1.9 c-0.7,0.5-1.6,0.7-2.7,0.7c-1.1,0-1.9-0.2-2.6-0.7s-1.2-1.1-1.5-1.9c-0.3-0.8-0.5-1.7-0.6-2.7c-0.1-1-0.1-2.2-0.1-3.6v-16.6h3.4 v17.4c0,1.8,0.1,3.1,0.3,3.9c0.2,0.8,0.6,1.1,1.2,1.1s1-0.4,1.2-1.1c0.2-0.8,0.3-2.1,0.3-3.9v-17.4h3.4L339.6,326.1L339.6,326.1z \"></path><path class=\"st3\" d=\"M355,318.8c-0.1,0.6-0.4,1.3-0.8,2.1c-0.3,0.6-0.6,1.1-0.8,1.5c-0.3,0.4-0.6,0.8-1,1.3l2.8,11.3h-3.3 l-2.3-9.3c-0.3,0.2-0.5,0.3-0.7,0.4v8.9h-3.4v-25.5h3.3c0.5,0,0.9,0,1.2,0s0.6,0.1,0.9,0.2c0.7,0.2,1.3,0.6,1.8,1s0.9,1,1.4,1.7 c0.4,0.7,0.7,1.4,0.8,2c0.2,0.6,0.2,1.4,0.3,2.3C355.2,317.5,355.2,318.1,355,318.8z M351.9,316.7c0-1-0.2-1.9-0.5-2.6 c-0.3-0.7-0.8-1.2-1.4-1.4c-0.4-0.2-0.7-0.2-1.1-0.2v10.1c0.4-0.2,0.8-0.5,1.1-0.9c0.3-0.3,0.6-0.7,0.8-1s0.4-0.7,0.6-1.1 c0.2-0.5,0.4-1,0.4-1.4C351.9,317.8,351.9,317.3,351.9,316.7L351.9,316.7z\"></path><path class=\"st3\" d=\"M368,330c-0.2,0.6-0.5,1.1-0.9,1.7c-0.4,0.6-1,1.1-1.6,1.6c-0.6,0.5-1.2,0.9-1.9,1.3 c-0.6,0.4-1.2,0.6-1.8,0.8l-1.3-2.9c1-0.4,1.9-0.8,2.7-1.4c0.8-0.6,1.3-1.2,1.5-1.9c0.3-0.9,0.4-1.6,0.4-2.2 c0-0.7-0.2-1.4-0.5-2.1c-0.3-0.7-0.9-1.6-1.7-2.6c-1-1.3-1.8-2.5-2.3-3.4c-0.5-0.9-0.7-1.9-0.7-2.9c0-0.7,0.1-1.5,0.4-2.3 c0.1-0.3,0.3-0.7,0.7-1.2c0.3-0.5,0.8-0.9,1.2-1.4c0.5-0.5,1-0.9,1.5-1.2s0.9-0.5,1.3-0.6l1.3,2.6c-0.5,0.2-1.1,0.5-1.8,1.1 c-0.6,0.5-1,1.1-1.2,1.6c-0.2,0.5-0.2,1-0.2,1.4c0,0.7,0.2,1.4,0.5,1.9s1,1.4,1.8,2.5c0.1,0.1,0.1,0.2,0.2,0.3 c0.9,1.2,1.6,2.4,2.1,3.4c0.4,1,0.6,2,0.6,3.1C368.5,327.9,368.4,328.9,368,330L368,330z\"></path><path class=\"st3\" d=\"M383.2,321.3c0,1.8-0.1,3.6-0.2,5.2c-0.1,1.6-0.4,3.1-0.8,4.4c-0.4,1.3-0.9,2.4-1.6,3.2 c-0.7,0.8-1.6,1.2-2.6,1.2c-1,0-1.9-0.4-2.6-1.2c-0.7-0.8-1.2-1.9-1.6-3.2c-0.4-1.3-0.6-2.8-0.8-4.4c-0.1-1.6-0.2-3.3-0.2-5.1 c0-1.8,0.1-3.4,0.3-4.8c0.2-1.5,0.5-2.7,0.9-3.8c0.4-1.1,1-1.9,1.6-2.6c0.7-0.6,1.5-0.9,2.5-0.9c1,0,1.8,0.3,2.5,0.9 c0.7,0.6,1.2,1.5,1.6,2.5c0.4,1.1,0.7,2.4,0.9,3.8C383.2,317.9,383.3,319.6,383.2,321.3L383.2,321.3z M379.9,321.4 c0-5.9-0.6-8.9-1.8-9c-1.3,0-1.9,3-1.9,8.9c0,1.4,0.1,2.8,0.2,4.1c0.1,1.3,0.2,2.4,0.4,3.4s0.4,1.8,0.6,2.3 c0.2,0.6,0.4,0.8,0.6,0.8c0.2,0,0.5-0.3,0.7-0.8c0.2-0.6,0.4-1.3,0.6-2.3c0.2-1,0.3-2.1,0.4-3.4 C379.8,324.2,379.9,322.8,379.9,321.4L379.9,321.4z\"></path><path class=\"st3\" d=\"M395.4,335l-2.8-12l-0.6-2.9c0,0.3,0.1,0.7,0.1,1.3c0,0.6,0.1,1.1,0.1,1.5V335h-3.3v-25.5h3.1l2.8,11.1 l0.7,3c0-0.3-0.1-0.7-0.1-1.2c0-0.6-0.1-1.1-0.1-1.6v-11.2h3.2V335H395.4z\"></path><path class=\"st3\" d=\"M410.5,335l-0.6-4.8h-2.7l-0.6,4.8h-3.4l3.7-25.5h3.4l3.6,25.5H410.5z M408.8,319.9l-0.2-3.1l-0.2,3.1 l-0.7,7.2h1.9L408.8,319.9z\"></path><path class=\"st3\" d=\"M422.9,312.5V335h-3.3v-22.5h-3.2v-3h9.7v3H422.9z\"></path><path class=\"st3\" d=\"M431.4,335v-25.5h7.1v3h-3.7v7.5h3.5v3h-3.5v9h3.9v3H431.4z\"></path></g></g><g><g><path class=\"st4\" d=\"M32.6,249.1H17.2c-0.5,0-1.1,0-1.8,0c-0.7,0-1.2-0.1-1.6-0.1l3.4,0.8l8.9,2.4c0.5,0.1,0.7,0.2,0.7,0.3 c0,0-0.2,0.1-0.5,0.2c-0.1,0-0.2,0.1-0.2,0.1l-8.9,2.3l-3.4,0.8c0.3,0,0.9-0.1,1.6-0.1c0.7,0,1.3,0,1.8,0h15.4v4.3H0.2v-4.1 l11.9-3.2c0.3-0.1,0.6-0.1,0.9-0.2c0.3,0,0.6-0.1,0.9-0.1c-0.2,0-0.5-0.1-0.9-0.2c-0.4-0.1-0.7-0.1-0.8-0.2L0.2,249v-4.2h32.4 V249.1z\"></path><path class=\"st4\" d=\"M32.6,235.6H0.2v-9h3.9v4.8h9.5v-4.5h3.8v4.5h11.5v-5h3.8V235.6z\"></path><path class=\"st4\" d=\"M12.1,206.4c0.8,0.2,1.7,0.5,2.7,1c0.8,0.4,1.4,0.7,1.9,1.1c0.5,0.3,1.1,0.8,1.6,1.3l14.4-3.5v4.2l-11.8,3 c0.2,0.4,0.3,0.7,0.4,0.8h11.4v4.3H0.2v-4.3c0-0.7,0-1.2,0-1.5c0-0.4,0.1-0.8,0.3-1.1c0.3-0.9,0.7-1.7,1.3-2.3 c0.5-0.6,1.3-1.2,2.2-1.7c0.9-0.5,1.7-0.8,2.5-1c0.8-0.2,1.7-0.3,2.9-0.4C10.4,206.2,11.3,206.2,12.1,206.4z M9.4,210.4 c-1.3,0-2.4,0.2-3.3,0.6c-0.9,0.4-1.5,1-1.8,1.8c-0.2,0.5-0.3,0.9-0.3,1.4h12.8c-0.3-0.5-0.7-1-1.1-1.4c-0.4-0.4-0.8-0.8-1.2-1 c-0.4-0.3-0.9-0.5-1.4-0.8c-0.7-0.3-1.3-0.4-1.8-0.5C10.8,210.4,10.2,210.4,9.4,210.4L9.4,210.4z\"></path><path class=\"st4\" d=\"M32.6,198.9l-28.5-5.4v5.1H0.2v-10.1l28.6,5.4V188h3.8V198.9z\"></path><path class=\"st4\" d=\"M32.6,166.3v4l-9.8,1.6l-3.1,0.4l3.1,0.3l9.8,1.6v4.1l-32.4,2.3v-4.1l15.1-1c0.6,0,1.2-0.1,1.9-0.1 c0.6,0,1.2,0,1.5,0l-3.4-0.6l-10.2-2.2H5c-0.5-0.1-0.7-0.1-0.7-0.2c0,0,0.2-0.1,0.6-0.2h0.1l10.2-2.2l3.4-0.6 c-0.3,0-0.9,0-1.6-0.1c-0.7,0-1.3-0.1-1.8-0.1l-15.1-1v-4L32.6,166.3z\"></path><path class=\"st4\" d=\"M32.6,155.6H0.2v-9h3.9v4.8h9.5v-4.5h3.8v4.5h11.5v-5h3.8V155.6z\"></path><path class=\"st4\" d=\"M12.1,126.4c0.8,0.2,1.7,0.5,2.7,1c0.8,0.4,1.4,0.7,1.9,1.1c0.5,0.3,1.1,0.8,1.6,1.3l14.4-3.5v4.2l-11.8,2.9 c0.2,0.4,0.3,0.7,0.4,0.9h11.4v4.3H0.2v-4.2c0-0.7,0-1.2,0-1.5c0-0.4,0.1-0.8,0.3-1.1c0.3-0.9,0.7-1.7,1.3-2.3 c0.5-0.6,1.3-1.2,2.2-1.7c0.9-0.5,1.7-0.8,2.5-1c0.8-0.2,1.7-0.3,2.9-0.4C10.4,126.1,11.3,126.2,12.1,126.4z M9.4,130.4 c-1.3,0-2.4,0.2-3.3,0.6c-0.9,0.4-1.5,1-1.8,1.8c-0.2,0.5-0.3,0.9-0.3,1.4h12.8c-0.3-0.5-0.7-1-1.1-1.4c-0.4-0.4-0.8-0.8-1.2-1.1 c-0.4-0.3-0.9-0.5-1.4-0.8c-0.7-0.3-1.3-0.4-1.8-0.5C10.8,130.4,10.2,130.3,9.4,130.4L9.4,130.4z\"></path><path class=\"st4\" d=\"M23.3,104.1c1.2,0,2.2,0.1,3,0.2c0.8,0.2,1.7,0.5,2.8,1.1c0.7,0.4,1.3,0.9,1.8,1.4c0.5,0.5,0.9,1.1,1.2,1.7 c0.4,0.8,0.6,2,0.6,3.5v4.3H0.2V112l0-0.1c0-0.8,0.1-1.5,0.1-2c0.1-0.5,0.3-1.1,0.6-1.6c0.9-1.8,2.4-2.9,4.5-3.4 c0.8-0.2,1.6-0.2,2.4-0.2c1.4,0,2.9,0.4,4.5,1.1c1.1,0.5,2.1,1.3,2.9,2.4c0.5-0.6,1.2-1.2,2.2-2.1l0.2-0.2c0.8-0.6,1.7-1,2.7-1.4 C21.4,104.2,22.4,104,23.3,104.1L23.3,104.1z M4.3,110.3c-0.2,0.3-0.2,0.9-0.2,1.6v0.2h9.7l-0.4-0.4c-0.2-0.3-0.6-0.7-1.2-1.1 c-0.6-0.4-1.1-0.8-1.7-1.1c-1-0.4-1.9-0.6-2.7-0.6c-0.4,0-0.9,0.1-1.5,0.2C5.4,109.2,4.7,109.6,4.3,110.3z M23.3,108.3 c-0.5,0-1.1,0.1-1.8,0.2c-0.6,0.2-1.1,0.4-1.5,0.6l-0.4,0.3c-0.7,0.4-1.2,0.8-1.6,1.2c-0.4,0.4-0.9,0.8-1.2,1.4h11.9 c0-0.6-0.1-1.1-0.2-1.3c-0.3-0.7-0.8-1.3-1.5-1.7c-0.7-0.4-1.2-0.6-1.7-0.7C24.8,108.3,24.2,108.3,23.3,108.3L23.3,108.3z\"></path><path class=\"st4\" d=\"M32.6,94H0.2v-9h3.9v4.8h9.5v-4.5h3.8v4.5h11.5v-5h3.8V94z\"></path></g></g><g><g><path class=\"st4\" d=\"M895.3,137.6l1.5,0.2l1.2,0.2l1.1,0.4l1,0.5l0.9,0.9l0.6,0.6l0.5,0.8l0.3,1.1v1.5l0,1.4l-0.4,1.2l-0.3,0.9 l-0.6,0.7l-0.8,0.8L899,149l-1,0.3l-0.8,0.3l-1.1,0.2l-1.2,0l-1.3-0.1l-1.3,0.2h-1.4l-1.3,0l-1.4,0l-1.3-0.1l-1.3,0l-1.3,0.2H883 l-1.3-0.2l-1.3,0.2H879l-1.3-0.2l-1.3,0l-1.3,0l-1.4,0.1l-1.3-0.2L871,150l-1.4-0.1l0-1.5l0-1.4v-1.4l1.3-0.2h1.3l1.3,0.2 l1.3-0.2l1.3,0.2l1.3-0.2l1.3,0h1.3h1.2l1.3,0l1.3,0.1l1.3-0.1l1.3,0.2l1.3-0.2l1.3,0.1l1.3-0.1l1.3,0.2h1.6l1.6-0.1l1.3-0.2 l0.8-0.2l0.6-0.5l0.3-0.5l0.3-0.5l-0.2-0.6l-0.3-0.4l-0.6-0.5l-0.8-0.3l-1.5,0.1h-1.5h-1.5l-1.3-0.1l-1.3,0.1l-1.3-0.1l-1.3,0 l-1.3-0.1l-1.3,0l-1.3-0.1l-1.3,0.2h-1.2l-1.3-0.1l-1.3-0.1l-1.3,0.1l-1.3,0h-1.3l-1.3,0.1H871l-1.3,0l0.2-1.5l0-1.4l-0.1-1.5 h1.3l1.4-0.1l1.3,0.1l1.4,0l1.3-0.1l1.3,0.2l1.3,0l1.3-0.2l1.3-0.1l1.3,0.1l1.3-0.1l1.3,0.2l1.3,0l1.3-0.1l1.4,0l1.3,0l1.6,0.1 l1.2-0.2L895.3,137.6z\"></path><path class=\"st4\" d=\"M880.2,116.5l1.1,0.2l1.1,0.3l0.8,0.2l1,0.5l1.3,0.5l0.8,0.5l0.9,0.7l0.6,0.5l1.4-0.1l1.2-0.5l1.3-0.2 l1.4-0.2l1.3-0.3l1.2-0.4l1.3-0.4l1.3-0.3l1.3-0.2l1.3-0.4l1.2-0.3l0.2,1.4l0.1,1.4l-0.1,1.5l-1.3,0.3l-1.3,0.2l-1.2,0.5 l-1.4,0.3l-1.3,0.2l-1.3,0.3L893,123l-1.3,0.3l-1.3,0.4l0.1,0.1v0.2l0.2,0.3l0.1,0.2l0.1,0.2l1.2,0h1.2h1.3l1.2-0.1l1.2,0.2 l1.2,0l1.3,0l1.2,0l1.3,0l0,1.5l-0.2,1.4l0.1,1.4l-1.4,0l-1.3,0.1l-1.4-0.1l-1.3,0.2l-1.4-0.1l-1.3,0l-1.4-0.1l-1.3,0.1l-1.4-0.1 l-1.3,0.1l-1.4,0l-1.3,0.1h-1.4l-1.3-0.1l-1.4,0l-1.3-0.1l-1.3,0.1l-1.4,0l-1.3,0l-1.4-0.1l-1.3,0l-1.4,0l-1.3,0.1l-1.4,0l0-1.4 l-0.1-1.4l0.1-1.4l0-1.4l0.1-0.5l0.1-0.9l0.8-1.2l0.5-1l0.9-0.9l0.6-0.4l0.8-0.5l0.6-0.3l0.7-0.3l1-0.4l0.8,0l1.1-0.2l1.2-0.2 L880.2,116.5z M879,120.6l-0.8,0l-1.3,0.1l-0.6,0.3l-0.6,0.2l-1.1,0.8l-0.5,0.4l-0.2,0.6l-0.2,0.5l-0.1,0.4v0.4v0.2l1.3-0.2 l1.2,0l1.3,0.1l1.2,0.1l1.3,0h1.3l1.2,0h1.3h1.2l1.3,0l-0.1-0.4l-0.4-0.3l-0.2-0.2l-0.5-0.4l-1.2-1.1l-0.5-0.4l-0.8-0.5l-1.1-0.3 l-0.7-0.2l-1-0.1L879,120.6z\"></path><path class=\"st4\" d=\"M893.5,98.5l0.9,0.1l1.4,0.4l1.6,0.9l0.7,0.5l0.8,0.8l0.8,0.9l0.7,0.9l0.8,1.1l0.5,1.1l0.9,1.7l-1.2,0.5 l-1.2,0.6l-1.1,0.5l-0.7-1.3l-0.5-1l-0.6-1l-1-1l-0.6-0.6l-0.9-0.6l-1.5-0.2l-1.5-0.2l-1,0.1l-1,0.2l-1,0.3l-1,0.6l-0.8,0.8 l-1.2,0.7l-1.5,1l-0.8,0.8l-1.2,0.7l-1.4,0.6l-0.8,0.4l-0.9,0.2l-1.2,0h-1.2l-1.1-0.2l-1.1-0.2l-0.8-0.5l-0.8-0.4l-0.8-0.8 l-0.9-0.8l-0.7-1l-0.8-0.8l-0.5-1l-0.3-0.9l1.1-0.4l1-0.7l1.1-0.5l0.4,0.8l0.8,1.1l0.9,0.8l0.6,0.7l0.9,0.4l1.2,0.2l1.3,0 l1.2-0.4l1.2-0.6l1.2-0.9l0.8-0.6l0.7-0.8l1.4-1l1.4-0.7l1-0.4l0.9-0.7l2-0.4l1.5-0.1L893.5,98.5z\"></path><path class=\"st4\" d=\"M884.9,77.9h1.5l1.4,0.1l1.1,0.1l1.1-0.1l1.5,0.2l1.5,0.1l1.6,0.2l1.3,0.5l1.3,0.3l1.3,0.5l1.3,0.8l1.5,0.9 l0.5,0.6l0.5,0.9l0.2,0.9l0.2,0.9l-0.1,0.9l-0.3,0.8l-0.5,0.8l-0.5,0.7l-1.2,0.8l-1.5,0.8l-1.7,0.8l-1.8,0.2l-1.2,0.2l-1.2,0.1 l-1.2,0.2l-1.2,0.1l-1.4,0.2l-1.3-0.1h-1.4l-1.3,0.3l-1.5,0L882,91l-1.5,0l-1.2,0.1l-1.2-0.2l-1.2-0.1l-1.5-0.4l-1.8-0.6 l-1.4-0.9l-1.2-0.9l-0.5-0.8l-0.5-0.9l-0.2-0.9l-0.2-1l0.2-1l0.2-0.9l0.4-0.8l0.6-0.8l1.1-1l1.5-0.6L875,79l1.6-0.4l1.1-0.4 l1.2-0.2l1.2-0.1l1-0.1l1.1,0.1l1.4-0.2L884.9,77.9z M883.6,82.3l-1.3,0l-1.4,0l-1.2,0.2l-1.2,0l-1,0.1l-1,0.2l-0.8,0.1l-0.8,0.4 l-1,0.6l-0.4,0.3v0.3v0.4l0.2,0.4l1.1,0.5l0.9,0.3l1,0.1l1.2,0.4l1.2,0l1.2,0.2l1.5,0.1l1.5,0l1.5,0h1.3h1.3l1.3-0.1l1.3-0.2 l1.2-0.1l1.2,0l1.2-0.3l1.2-0.2l1.1-0.3l1.4-0.4l0.8-0.5l0.2-0.2v-0.2v-0.1l-0.2-0.2l-0.9-0.5l-0.9-0.2l-1-0.2L894,83l-1.5-0.5 l-1.7,0l-1.7-0.1h-1.9l-1.2-0.1l-1.2,0l0.1,0L883.6,82.3z\"></path><path class=\"st4\" d=\"M900.8,57.3h1.3l0.1,1.4v1.3l-0.1,1.3l-1.2,0.4l-1.3,0.1l-1.2,0.4l-1.3,0.2l-1.2,0.4l-1.3,0.2l-1.2,0.5 l-1.3,0.1l-1.2,0.2l-1.2,0.4l-1.2,0.5l-1.3,0.2l-1.2,0.1l-1.2,0.2l-1.2,0.4h0.2l0.8-0.1l0.8-0.1l0.7,0.1l1.1-0.1l1.3,0.1l1.2-0.1 h1.3l1.2,0.2l1.3-0.1l1.2,0.1l1.3-0.2l1.3,0.2l1.2-0.1l1.3,0.1l1.2,0.1l1.3-0.1l0.1,1.4v1.4l-0.1,1.5l-1.4-0.2h-1.3l-1.4,0.2 l-1.3,0l-1.4-0.1l-1.3,0l-1.4-0.1l-1.3,0.1H890h-1.3h-1.4l-1.3,0l-1.4,0.2l-1.3-0.2l-1.4,0l-1.3,0l-1.3,0.1h-1.4l-1.3-0.2 l-1.4,0.1h-1.3l-1.4-0.1l-1.3,0.2l-1.4-0.1l0-1.4l-0.1-1.3l0.1-1.5l1.3-0.2l1.4-0.2l1.2-0.4l1.3-0.2l1.3-0.4l1.2-0.4l1.3-0.3 l1.3-0.3l1.2-0.4l1.3-0.4l1.3-0.2l1.2-0.4l1.2-0.1l1.2-0.4l-0.2-0.1l-1.2,0.1l-1,0.1l-1.2-0.1l-1.3,0.1h-1.3l-1.3,0.2l-1.3-0.1 l-1.3,0l-1.2-0.1l-1.3-0.1l-1.3,0.1l-1.3,0l-1.3,0.1l-1.3-0.1l0.1-1.4l0.1-1.4l-0.2-1.2l1.4-0.2l1.3,0.2l1.4-0.2l1.3,0.1l1.4-0.1 l1.3,0.2l1.4-0.1l1.3,0.1l1.3-0.2l1.4,0.2l1.3,0h1.4l1.3-0.1l1.4,0l1.3,0.1l1.4-0.1l1.3-0.1l1.4,0.2l1.3-0.1h1.4l1.3-0.1h1.4 L900.8,57.3z\"></path><path class=\"st4\" d=\"M902.1,37.2l0.2,1.5l-0.1,1.4l-1.2,0.3l-1.3,0l-1.2,0.3l-1.2,0.1l-1.2,0.2V42l-0.2,1.2l0.1,1.1l1.2,0.2 l1.2,0l1.2,0.1l1.2,0.1l1.1,0.2l0.1,1.5v1.4l0,1.4l-1.3-0.2l-1.3-0.1l-1.3-0.3l-1.3-0.1l-1.3-0.2l-1.2-0.3l-1.3,0l-1.2-0.3 l-1.3-0.2l-1.3-0.1l-1.3-0.1l-1.3-0.1l-1.3-0.4H884l-1.3-0.4l-1.3,0.1l-1.3-0.2l-1.2-0.3l-1.3-0.1l-1.3-0.1l-1.2-0.2l-1.3-0.2 l-1.3-0.1L871,45l-1.4-0.2l0.1-1.5l0-1.4v-1.5l1.3-0.3l1.3-0.1l1.2-0.2l1.3-0.1l1.2-0.2l1.3-0.1l1.3-0.3h1.3l1.2-0.2l1.3-0.1 l1.3-0.3l1.3-0.1l1.3-0.3l1.3-0.2l1.3-0.1l1.3-0.1l1.3-0.2l1.2-0.2l1.3-0.1l1.3-0.2l1.3-0.1l1.3-0.1l1.3-0.2l1.3-0.1l1.3-0.3 L902.1,37.2z M890.9,41.6h-1.3l-1.4,0.1l-1.3,0l-1.3,0.1l-1.3,0.2l-1.3,0.2l-1.3,0.1h-1.3l-1.3,0.2h1.3l1.3,0.2l1.3,0l1.3,0.2 l1.3,0l1.3,0.1l1.2,0.3l1.4,0l1.3,0.2l1.2,0.1l0-1.2v-1.2L890.9,41.6z\"></path><path class=\"st4\" d=\"M873.6,17.8v1.4l0.2,1.4l-0.1,1.3l1.3,0l1.4,0.1l1.4,0l1.4-0.2l1.3,0.1l1.4,0l1.3,0l1.4,0.1l1.4,0l1.3,0.1 l1.4-0.1l1.3,0l1.3-0.2h1.4L894,22h1.3h1.4h1.3h1.4h1.3l1.4-0.1l-0.1,1.4l0.1,1.5v1.4l-1.4-0.2h-1.3l-1.4,0.1l-1.3,0.1l-1.4-0.1 l-1.3,0.1l-1.4,0l-1.4-0.1l-1.3-0.1l-1.3,0l-1.4,0l-1.3,0.1l-1.4-0.2l-1.4,0l-1.3,0.2l-1.4,0l-1.3-0.1l-1.4,0.2l-1.4,0L875,26 l-1.5,0.1l0,1.4l0.2,1.4l-0.1,1.5l-1.3-0.1l-1.2,0.1l-1.4,0l0.2-1.4l-0.1-1.4l0-1.4l0-1.4v-1.4l0.1-1.4v-1.4v-1.4l0-1.4h1.3 l1.2-0.1L873.6,17.8z\"></path><path class=\"st4\" d=\"M900.9,0.5l1.1-0.1l0.2,1.4V3l-0.2,1.4l0.1,1.3l0.1,1.4l-0.1,1.3v1.3h-1.4l-1.3,0.1l-1.4-0.1l-1.3-0.1 l-1.4,0.2l-1.3,0h-1.4l-1.3-0.1L890,9.6l-1.3,0.2l-1.4-0.2L886,9.7l-1.4-0.1h-1.3l-1.4,0l-1.3,0.2l-1.3-0.1l-1.4-0.1h-1.3 l-1.4,0.2l-1.3-0.2h-1.4l-1.3,0.2l-1.2-0.1l-0.2-1.3l0.1-1.3l0.1-1.3l-0.1-1.2V3.2l0.1-1.3l-0.1-1.2l1.3,0l1.2,0l1.2,0v1.2 l0.1,1.2l0,1.2v1.2l1.3-0.2l1.4,0.1l1.3,0.1l1.4-0.2l1.3,0.1l1.4-0.1l1.3,0.1V3.9l0.2-1.5l-0.2-1.6h1.2l1.3,0l1.2,0.1l0.1,1.5 l0,1.5l0,1.6l1.2-0.1l1.3,0.1l1.2-0.1l1.3,0l1.2-0.1l1.3,0.2l1.2-0.2l1.3,0.2l1.2-0.1V4.1l0.2-1.2l-0.2-1.3l0.1-1.2l1.2-0.1 L900.9,0.5z\"></path></g></g><g><g><path class=\"st4\" d=\"M672.2,511.7v1.3l0.2,1.4l-0.2,1.3l1.3,0l1.4,0.1l1.4-0.1l1.3-0.2l1.4,0.1l1.3,0l1.4,0l1.4,0l1.4,0.1l1.3,0 l1.4-0.1l1.3,0.1l1.4-0.2h1.4l1.4,0.2h1.3h1.4h1.3h1.4h1.4l1.3-0.1l-0.1,1.4l0.1,1.5v1.5l-1.3-0.2h-1.4l-1.4,0.1l-1.3,0.2 L694,520l-1.3,0.1l-1.4,0l-1.4-0.1l-1.4-0.1l-1.3,0l-1.4,0l-1.3,0.2l-1.4-0.2l-1.4,0l-1.4,0.2l-1.3-0.1l-1.4-0.1l-1.3,0.2l-1.4,0 l-1.4-0.2l-1.5,0.1l0.1,1.4l0.2,1.3l-0.1,1.5L671,524l-1.2,0.1l-1.4,0l0.2-1.4l-0.1-1.4l0-1.4l0-1.4v-1.4l0.2-1.4v-1.3V513 l-0.1-1.3h1.3l1.2,0L672.2,511.7z\"></path><path class=\"st4\" d=\"M699.6,495.6l1.2-0.1l0.1,1.4v1.3l-0.1,1.4l0,1.3l0.1,1.3l-0.1,1.3v1.3h-1.3l-1.4,0.2l-1.3-0.2l-1.4,0 l-1.3,0.2l-1.4-0.1h-1.3l-1.4,0l-1.3-0.1l-1.4,0.2l-1.3-0.2l-1.4,0.1l-1.3-0.1h-1.4l-1.3-0.1l-1.4,0.2l-1.3,0l-1.4-0.1h-1.3 l-1.4,0.2l-1.3-0.2h-1.4l-1.3,0.2l-1.2-0.1l-0.2-1.3l0.1-1.3l0-1.3l-0.1-1.2v-1.3l0.1-1.3l-0.1-1.2l1.3-0.1l1.2,0.1l1.2-0.1v1.2 l0,1.2l0,1.2v1.2l1.3-0.2l1.4,0l1.3,0.2l1.4-0.2l1.4,0.1l1.3-0.1l1.4,0.1V499l0.1-1.5l-0.1-1.5h1.2l1.3,0l1.2,0.1l0.1,1.5l0,1.5 l0,1.6l1.2-0.1l1.3,0.1l1.2-0.2l1.3,0.1l1.2-0.1l1.3,0.2l1.2-0.2l1.3,0.2l1.2-0.1v-1.2l0.2-1.3l-0.2-1.2l0.1-1.2l1.2,0 L699.6,495.6z\"></path><path class=\"st4\" d=\"M700.8,476.8v1.4l0,1.4l-1.2,0.3l-1.2,0.2l-1.2,0.5l-1.2,0.2l-1.2,0.2l-1.2,0.4l-1.3,0.2l-1.2,0.4l-0.3,0.1 h-0.4l-1.2,0.1l-0.2,0h0.2l1.2,0.2l0.4,0l0.3,0l1.3,0.2l1.2,0.5l1.2,0.2l1.2,0.4l1.2,0.2l1.2,0.3l1.2,0.4l1.3,0.3l-0.2,1.4 l0.1,1.5l0,1.4l-1.3-0.5l-1.3-0.3l-1.3-0.2l-1.4-0.3l-1.2-0.5l-1.3-0.2l-1.4-0.3l-1.3-0.4L689,486l-1.3-0.2l-1.4-0.2L685,485 l-1.3-0.3l-1.3,0.3l-1.3,0.2l-1.2,0.5l-1.2,0.4l-1.3,0.2l-1.3,0.3l-1.3,0.2l-1.2,0.4l-1.2,0.5l-1.3,0.4l-1.2,0.2l-1.2,0.3 l-0.2-1.4l0.2-1.4l-0.1-1.4l1.4-0.4l1.4-0.3l1.3-0.4l1.4-0.2l1.4-0.5l1.4-0.2l0.5,0l0.4-0.1l1.1-0.1h0.2l-0.2,0l-1.1-0.1 l-0.4-0.2l-0.4-0.1l-1.4-0.2l-1.4-0.4l-1.3-0.5l-1.5-0.2l-1.4-0.3l-1.5-0.2l0-1.4l-0.1-1.3l0.2-1.5l1.2,0.4l1.2,0.3l1.2,0.3 l1.2,0.5l1.2,0.4l1.2,0.4l1.3,0.2l1.3,0.2l1.2,0.4l1.2,0.3l1.2,0.4l1.2,0.2l1.3-0.3l1.4-0.2l1.3-0.4l1.3-0.4l1.3-0.4l1.3-0.2 l1.4-0.3l1.3-0.5l1.3-0.2l1.3-0.5l1.3-0.4l1.4-0.3l1.3-0.3L700.8,476.8z\"></path><path class=\"st4\" d=\"M672.2,457.5v1.3l0.2,1.4l-0.2,1.3l1.3,0l1.4,0.1l1.4-0.1l1.3-0.2l1.4,0.1l1.3,0l1.4,0l1.4,0l1.4,0.1l1.3,0 l1.4-0.1l1.3,0.1l1.4-0.2h1.4l1.4,0.2h1.3h1.4h1.3h1.4h1.4l1.3-0.1l-0.1,1.4l0.1,1.5v1.5l-1.3-0.2h-1.4l-1.4,0.1l-1.3,0.2 l-1.4-0.1l-1.3,0.1l-1.4,0l-1.4-0.1l-1.4-0.1l-1.3,0.1l-1.4-0.1l-1.3,0.2l-1.4-0.2l-1.4,0l-1.4,0.2l-1.3,0l-1.4-0.1l-1.3,0.2 l-1.4,0l-1.4-0.2l-1.5,0.1l0.1,1.3l0.2,1.3l-0.1,1.5l-1.3-0.1l-1.2,0.1l-1.4,0l0.2-1.4l-0.1-1.4l0-1.4l0-1.4V463l0.2-1.4v-1.3 v-1.4l-0.1-1.3h1.3l1.2,0L672.2,457.5z\"></path><path class=\"st4\" d=\"M699.6,441.4l1.2-0.1l0.1,1.4v1.3l-0.1,1.4l0,1.3l0.1,1.3l-0.1,1.3v1.3h-1.3l-1.4,0.1l-1.3-0.1l-1.4,0 l-1.3,0.2l-1.4,0h-1.3l-1.4,0l-1.3-0.1l-1.4,0.2l-1.3-0.2l-1.4,0.1l-1.3-0.1h-1.4l-1.3-0.1l-1.4,0.2l-1.3,0l-1.4-0.1h-1.3 l-1.4,0.2l-1.3-0.2h-1.4l-1.3,0.2l-1.2-0.1l-0.2-1.3l0.1-1.3l0-1.3l-0.1-1.2v-1.3l0.1-1.3l-0.1-1.2l1.3-0.1l1.2,0.1l1.2-0.1v1.2 l0,1.2l0,1.2v1.2l1.3-0.2l1.4,0l1.3,0.2l1.4-0.2l1.4,0.1l1.3-0.1l1.4,0.1v-1.5l0.1-1.5l-0.1-1.5h1.2l1.3,0l1.2,0.1l0.1,1.5l0,1.5 l0,1.6l1.2-0.1l1.3,0.1l1.2-0.2l1.3,0.1l1.2-0.1l1.3,0.2l1.2-0.2l1.3,0.2l1.2-0.1V445l0.2-1.3l-0.2-1.2l0.1-1.2l1.2,0 L699.6,441.4z\"></path></g></g><g><g><path class=\"st4\" d=\"M302.1,418.6l0,1l-0.2,0.9l-0.4,0.8l-0.2,0.8l-0.6,1l-0.5,0.8l-0.5,0.8l-0.6,0.7l-0.6,0.6l-0.6,0.6l-1,0.6 l-0.9,0.7l-0.9,0.6l-1,0.4l0.2,1.3v1.4l-0.1,1.3l0,1.4l-0.1,1.4l0.1,1.4l-0.1,1.4l0,1.4l0.1,1.3l-1.5,0l-1.4-0.1l-1.5,0.1l0-1.3 l-0.1-1.4V437l0.2-1.4l-0.2-1.3l0.2-1.4l-0.2-1.3l0.2-1.4v-1.3l-0.2-1.4l0.1-1.3l-0.1-1.4l0-1.3l0-1.4l0.2-1.3l-0.1-1.4l0-1.3 l0-1.4l0.1-1.3V414l-0.2-1.3l0.1-1.4l0-1.3v-1.2l1.5-0.2l1.4,0.1h1.5h1.4l0.4,0.1l0.9,0.2l1.2,0.6l1.1,0.5l0.7,0.8l0.5,0.6 l0.6,0.8l0.4,0.8l0.3,0.7l0.3,0.8l0.2,1.5l0.1,1.2v0L302.1,418.6z M298.1,417.3l-0.1-0.8v-0.8l-0.2-0.4l-0.4-1l-0.8-1l-0.4-0.3 l-0.6-0.4l-0.4-0.1l-0.3-0.2l-0.7,0l-0.1,1.3l-0.1,1.3v1.3v1.3v1.2l0.1,1.3l-0.1,1.3l0.2,1.3l-0.1,1.2h0.2l0.1-0.2l0.2-0.2 l0.7-0.6l0.9-1.1l0.4-0.6l0.6-1l0.5-0.8l0.1-0.5l0.1-1V417.3z\"></path><path class=\"st4\" d=\"M318.2,439.8l0.1,1.2l-1.4,0.1h-1.3l-1.4-0.1l-1.3,0l-1.4,0.1l-1.3-0.1H309v-1.3l-0.1-1.4l0.1-1.3l0.1-1.4 l-0.2-1.3l0-1.4v-1.3l0.1-1.4l0.1-1.3l-0.2-1.4l0.2-1.3l-0.1-1.4l0.1-1.3v-1.4l0-1.3l-0.2-1.4l0.1-1.3l0.1-1.4v-1.3l-0.2-1.4 l0.2-1.3v-1.4l-0.2-1.3l0.1-1.2l1.3-0.2l1.3,0.1l1.3,0l1.3-0.1h1.3l1.3,0.1l1.2-0.1l0,1.3l0,1.2l0,1.2h-1.2l-1.2,0l-1.2,0h-1.3 l0.2,1.4l-0.1,1.3l-0.1,1.3l0.2,1.4l-0.1,1.4l0.1,1.3l-0.1,1.4h1.5l1.5,0.1l1.6-0.1v1.2l0,1.3l-0.1,1.2l-1.5,0.1l-1.5,0l-1.6,0 l0.1,1.2l-0.1,1.3l0.1,1.2l0,1.3l0.1,1.2l-0.2,1.3l0.2,1.2l-0.2,1.3l0.1,1.2h1.2l1.2,0.2l1.2-0.2l1.2,0.1l0.1,1.2L318.2,439.8z\"></path><path class=\"st4\" d=\"M338.7,419.1l-0.2,1.2l-0.3,1l-0.2,0.8l-0.5,1l-0.5,1.3l-0.5,0.8l-0.7,0.8l-0.5,0.7l0.1,1.3l0.5,1.2l0.2,1.3 l0.2,1.3l0.4,1.3l0.4,1.2l0.5,1.3l0.3,1.3l0.2,1.3l0.4,1.3l0.3,1.1l-1.4,0.2l-1.5,0.1l-1.5-0.1l-0.3-1.3l-0.2-1.4l-0.5-1.2 l-0.3-1.3l-0.2-1.3l-0.3-1.3l-0.4-1.3l-0.3-1.3l-0.4-1.3l-0.1,0.1h-0.2l-0.3,0.2l-0.2,0.1l-0.1,0l0,1.2v1.2v1.3l0.1,1.2l-0.1,1.2 l0,1.3l0,1.3l0,1.2l0.1,1.3l-1.5,0l-1.4-0.2l-1.4,0.1l0.1-1.3l-0.1-1.4l0.1-1.3l-0.2-1.4l0.1-1.3l-0.1-1.4l0.1-1.3l-0.1-1.4 l0.2-1.3l-0.2-1.4l0.1-1.3l-0.1-1.4v-1.3l0.1-1.4l-0.1-1.3l0.2-1.4l-0.1-1.3l0-1.4l0-1.3l0.1-1.4l-0.1-1.3l0.1-1.4l-0.2-1.3 l0.1-1.4l1.4,0l1.5-0.1l1.4,0.2l1.4-0.1l0.5,0.1l0.9,0.1l1.2,0.8l1.1,0.5l0.9,0.9l0.4,0.7l0.6,0.8l0.3,0.6l0.3,0.7l0.4,1l0.1,0.8 l0.2,1l0.1,1.2L338.7,419.1z M334.6,417.9l0-0.8l-0.1-1.4l-0.3-0.6l-0.2-0.6l-0.9-1.1l-0.4-0.5l-0.6-0.2l-0.5-0.2l-0.4-0.1h-0.4 h-0.2l0.2,1.3l-0.1,1.2l0,1.3l-0.1,1.2l0,1.3v1.3l0.1,1.2v1.3v1.2l-0.1,1.2l0.4,0l0.3-0.5l0.2-0.2l0.4-0.5l1.1-1.2l0.4-0.5 l0.5-0.8l0.3-1.1l0.2-0.7l0.1-1L334.6,417.9z\"></path><path class=\"st4\" d=\"M356.7,432.4l-0.1,1l-0.4,1.4l-0.9,1.6l-0.5,0.7l-0.8,0.8l-0.9,0.8l-1,0.7l-1,0.9l-1.1,0.5l-1.7,0.8 l-0.5-1.2l-0.6-1.2l-0.5-1.1l1.3-0.7l1-0.5l0.9-0.6l1.1-1.1l0.6-0.6l0.5-0.9l0.2-1.5l0.2-1.4l-0.1-1l-0.2-1l-0.3-1l-0.6-1 l-0.8-0.8l-0.7-1.2l-1-1.5l-0.8-0.8l-0.7-1.2l-0.6-1.4l-0.4-0.8l-0.2-0.9l-0.1-1.2V416l0.1-1.1l0.2-1l0.5-0.8l0.3-0.9l0.8-0.8 l0.8-0.9l1-0.7l0.8-0.8l1-0.5l0.9-0.3l0.4,1.1l0.7,1l0.5,1.1l-0.8,0.4l-1.1,0.8l-0.9,0.9l-0.7,0.7l-0.3,0.8l-0.2,1.2l0,1.4 l0.3,1.2l0.6,1.2l0.9,1.2l0.6,0.8l0.8,0.7l1,1.4l0.7,1.4l0.4,0.9l0.7,0.9l0.4,2l0.1,1.5L356.7,432.4z\"></path><path class=\"st4\" d=\"M377.4,423.7v1.5l-0.1,1.4l-0.1,1.1l0.1,1.1l-0.2,1.6l-0.1,1.5l-0.2,1.5l-0.5,1.3L376,436l-0.5,1.3l-0.8,1.3 l-0.9,1.5l-0.6,0.6l-0.9,0.4l-0.9,0.2l-0.9,0.2l-0.9,0l-0.8-0.3l-0.8-0.5l-0.7-0.5l-0.8-1.2l-0.8-1.5l-0.8-1.7l-0.2-1.8l-0.2-1.2 l-0.1-1.1l-0.2-1.2l-0.1-1.2l-0.2-1.4l0.1-1.3v-1.4l-0.3-1.3l0-1.5l0.4-1.5l0-1.5l-0.1-1.2l0.2-1.2l0.1-1.2l0.4-1.5l0.6-1.8 l0.9-1.4l0.9-1.2l0.8-0.5l0.9-0.5l0.9-0.2l1-0.2l1,0.2l0.9,0.2l0.8,0.5l0.8,0.5l1,1.2l0.6,1.4l0.5,1.5l0.4,1.5l0.4,1.1l0.2,1.2 l0.1,1.2l0.1,1l-0.1,1.1l0.2,1.3L377.4,423.7z M373,422.4l0-1.3l0-1.4l-0.2-1.2l0-1.2l-0.1-1.1l-0.2-1l-0.1-0.8l-0.4-0.8l-0.6-1 l-0.3-0.4h-0.3h-0.4l-0.4,0.2l-0.5,1l-0.3,0.9l-0.1,0.9l-0.4,1.2l0,1.2l-0.2,1.2l-0.1,1.5l0,1.5l0,1.6v1.3v1.3l0.1,1.3l0.2,1.3 l0.1,1.2l0,1.2l0.3,1.2l0.2,1.2l0.3,1.1l0.4,1.4l0.5,0.8l0.2,0.2h0.2h0.1l0.2-0.2l0.5-0.9l0.2-0.9l0.2-1l0.4-1.5l0.5-1.5l0-1.7 l0.1-1.7v-1.8l0.1-1.2l0-1.2l0,0L373,422.4z\"></path><path class=\"st4\" d=\"M398.7,439.7v1.3l-1.4,0.1h-1.3l-1.3-0.1l-0.4-1.2l-0.1-1.3l-0.4-1.2l-0.2-1.3l-0.4-1.2l-0.2-1.3l-0.5-1.2 l-0.1-1.3l-0.2-1.3l-0.4-1.2l-0.5-1.2l-0.2-1.3l-0.1-1.2l-0.2-1.2l-0.4-1.2v0.2l0.1,0.8l0.1,0.9l-0.1,0.6l0.1,1.1l-0.1,1.3 l0.1,1.2v1.3l-0.2,1.2l0.1,1.3l-0.1,1.2l0.2,1.3l-0.2,1.3l0.1,1.2l-0.1,1.3l-0.1,1.2l0.1,1.3l-1.4,0.1h-1.4l-1.5-0.1l0.2-1.3 v-1.4l-0.2-1.3l0-1.4l0.1-1.3l0-1.4l0.1-1.3l-0.1-1.4v-1.3v-1.4v-1.3l0-1.4l-0.2-1.3l0.2-1.4l0-1.3l0-1.4l-0.1-1.3v-1.4l0.2-1.3 l-0.1-1.4v-1.3l0.1-1.4l-0.2-1.3l0.1-1.4l1.4,0l1.3-0.1l1.5,0.1l0.2,1.3l0.2,1.4l0.4,1.2l0.2,1.3l0.4,1.3l0.4,1.2l0.3,1.3 l0.3,1.3l0.4,1.2l0.4,1.3l0.2,1.3l0.4,1.2l0.1,1.2l0.4,1.2l0.1-0.2l-0.1-1.2l-0.1-1l0.1-1.2l-0.1-1.3v-1.3l-0.2-1.3l0.1-1.3 l0-1.3l0.1-1.2l0.1-1.3l-0.1-1.3l0-1.3l-0.1-1.3l0.1-1.4l1.4,0.1l1.4,0.1l1.2-0.2l0.2,1.4l-0.2,1.3l0.2,1.4l-0.1,1.3l0.1,1.4 l-0.2,1.3l0.1,1.4l-0.1,1.3l0.2,1.4l-0.2,1.3l0,1.4v1.3l0.1,1.4l0,1.3l-0.1,1.4l0.1,1.3l0.1,1.4l-0.2,1.3l0.1,1.4v1.3l0.1,1.4 v1.3L398.7,439.7z\"></path><path class=\"st4\" d=\"M418.1,439.8l0.1,1.2l-1.4,0.1h-1.3l-1.4-0.1l-1.3,0l-1.4,0.1l-1.3-0.1h-1.3v-1.3l-0.1-1.4l0.1-1.3l0.1-1.4 l-0.2-1.3l0-1.4v-1.3l0.1-1.4l0.1-1.3l-0.2-1.4l0.2-1.3l-0.1-1.4l0.1-1.3v-1.4l0-1.3l-0.2-1.4l0.1-1.3l0.1-1.4v-1.3l-0.2-1.4 l0.2-1.3v-1.4l-0.2-1.3l0.1-1.2l1.3-0.2l1.3,0.1l1.3,0l1.3-0.1h1.3l1.3,0.1l1.2-0.1l0,1.3l0,1.2l0,1.2h-1.2l-1.2,0l-1.2,0h-1.3 l0.2,1.4l-0.1,1.3l-0.1,1.3l0.2,1.4l-0.1,1.4l0.1,1.3l-0.1,1.4h1.5l1.5,0.1l1.6-0.1v1.2l0,1.3l-0.1,1.2l-1.5,0.1l-1.5,0l-1.6,0 l0.1,1.2l-0.1,1.3l0.1,1.2l0,1.3l0.1,1.2l-0.2,1.3l0.2,1.2l-0.2,1.3l0.1,1.2h1.2l1.2,0.2l1.2-0.2l1.2,0.1l0.1,1.2L418.1,439.8z\"></path><path class=\"st4\" d=\"M438.5,439.7v1.3l-1.4,0.1h-1.3l-1.3-0.1l-0.4-1.2l-0.1-1.3l-0.4-1.2l-0.2-1.3l-0.4-1.2l-0.2-1.3l-0.5-1.2 l-0.1-1.3l-0.2-1.3l-0.4-1.2l-0.5-1.2l-0.2-1.3l-0.1-1.2l-0.2-1.2l-0.4-1.2v0.2l0.1,0.8l0.1,0.9l-0.1,0.6l0.1,1.1l-0.1,1.3 l0.1,1.2v1.3l-0.2,1.2l0.1,1.3l-0.1,1.2l0.2,1.3l-0.2,1.3l0.1,1.2l-0.1,1.3l-0.1,1.2l0.1,1.3l-1.4,0.1h-1.4L426,441l0.2-1.3v-1.4 L426,437l0-1.4l0.1-1.3l0-1.4l0.1-1.3l-0.1-1.4v-1.3v-1.4v-1.3l0-1.4l-0.2-1.3l0.2-1.4l0-1.3l0-1.4l-0.1-1.3v-1.4l0.2-1.3 l-0.1-1.4v-1.3l0.1-1.4l-0.2-1.3l0.1-1.4l1.4,0l1.3-0.1l1.5,0.1l0.2,1.3l0.2,1.4l0.4,1.2l0.2,1.3l0.4,1.3l0.4,1.2l0.3,1.3 l0.3,1.3l0.4,1.2l0.4,1.3l0.2,1.3l0.4,1.2l0.1,1.2l0.4,1.2l0.1-0.2l-0.1-1.2l-0.1-1l0.1-1.2l-0.1-1.3v-1.3l-0.2-1.3l0.1-1.3 l0-1.3l0.1-1.2l0.1-1.3l-0.1-1.3l0-1.3l-0.1-1.3l0.1-1.4l1.4,0.1l1.4,0.1l1.2-0.2l0.2,1.4l-0.2,1.3l0.2,1.4l-0.1,1.3l0.1,1.4 l-0.2,1.3l0.1,1.4l-0.1,1.3l0.2,1.4l-0.2,1.3l0,1.4v1.3l0.1,1.4l0,1.3l-0.1,1.4l0.1,1.3l0.1,1.4l-0.2,1.3l0.1,1.4v1.3l0.1,1.4 v1.3L438.5,439.7z\"></path></g></g><g><g><path class=\"st4\" d=\"M225.3,429.5l0,1.5l-0.1,1.4l-1.3,0.5l-1.3,0.5l-1.3,0.3l-1.2,0.6l-1.3,0.4l-1.3,0.5l-1.3,0.4l-1.4,0.3 l-1.3,0.4l-1.2,0.6l-1.2,0.3l-1.2,0.3h0.1l0.6-0.1l0.8-0.1l0.8,0.1l1.3-0.2l1.3,0.2l1.3-0.2h1.3l1.2,0.1l1.3-0.1l1.3,0.1l1.3,0 l1.3-0.1h1.2l0.2,1.4l-0.2,1.5l0.1,1.4l-1.4,0.1l-1.4-0.1h-1.4l-1.4-0.2l-1.4,0.2l-1.4,0l-1.4,0l-1.4-0.2h-1.4l-1.4,0.2l-1.4,0 l-1.4-0.1l-1.4-0.1l-1.4,0.1l-1.4-0.1l-1.3,0.1l-1.4,0l-1.4,0.1l-1.4-0.2l-1.4,0.2l-1.4-0.2l-1.4,0.2l-1.4-0.1l-1.5,0l0.1-1.4 v-1.5l0-1.5l1.4,0.1l1.4-0.1l1.4,0l1.4,0.2h1.4l1.4-0.2l1.4,0.1l0.7,0h0.8l0.6,0.1l-0.6-0.3l-0.8-0.2l-0.6-0.2l-1.5-0.5l-1.5-0.5 l-1.6-0.5l-1.6-0.5l-1.4-0.6l-1.5-0.5l-0.5-0.2l-0.1-1.4l-0.1-1.4l0.1-1.5l1.3,0.5l1.3,0.4l1.2,0.6l1.3,0.5l1.4,0.3l1.3,0.5 l1.2,0.5l1.4,0.4l1.3,0.5l1.2,0.5l1.2,0.3l1.4-0.3l1.4-0.4l1.2-0.5l1.3-0.4l1.3-0.5l1.3-0.4l1.2-0.5l1.3-0.4l1.4-0.3l1.2-0.7 l1.4-0.5l1.3-0.3l1.2-0.5l1.4-0.4L225.3,429.5z\"></path><path class=\"st4\" d=\"M218.3,407.6l1.5,0.2l1.2,0.2l1.1,0.4l1,0.5l0.9,0.9l0.6,0.6l0.5,0.8l0.4,1.1v1.5l0,1.4l-0.4,1.2l-0.3,0.9 l-0.6,0.7l-0.8,0.8l-1.1,0.5l-1,0.3l-0.8,0.3l-1.1,0.2l-1.1,0l-1.4-0.1l-1.3,0.2H214l-1.3,0l-1.4,0l-1.3-0.1l-1.4,0l-1.3,0.2H206 l-1.3-0.2l-1.4,0.2h-1.3l-1.3-0.2l-1.4,0l-1.3,0l-1.4,0.1l-1.3-0.2l-1.4,0.2l-1.4-0.1l0-1.5l0.1-1.4v-1.4l1.3-0.2h1.3l1.3,0.2 l1.3-0.2l1.3,0.2l1.3-0.2l1.3,0h1.3h1.2l1.3,0l1.3,0.1l1.3-0.1l1.3,0.2l1.3-0.2l1.3,0.1l1.3-0.1l1.3,0.2h1.6l1.6-0.1l1.3-0.2 l0.8-0.2l0.6-0.5l0.3-0.5l0.3-0.5l-0.2-0.6l-0.3-0.4l-0.6-0.5l-0.9-0.3l-1.4,0.1h-1.5h-1.6l-1.3-0.1l-1.3,0.1l-1.3-0.1l-1.3,0 l-1.3-0.1l-1.3,0l-1.3-0.1l-1.3,0.2h-1.2l-1.3-0.1l-1.3-0.1l-1.3,0.1l-1.3,0h-1.3l-1.3,0.1h-1.3l-1.4,0l0.2-1.5l0-1.4l-0.1-1.5 h1.3l1.4-0.1l1.3,0.1l1.4,0l1.3-0.1l1.4,0.2l1.3,0l1.3-0.2l1.4-0.1l1.3,0.1l1.4-0.1l1.3,0.2l1.4,0l1.3-0.1l1.4,0l1.3,0l1.6,0.1 l1.2-0.2L218.3,407.6z\"></path><path class=\"st4\" d=\"M223.9,385.3h1.3l0.1,1.3v1.3l-0.1,1.3l-1.2,0.4l-1.3,0.1l-1.2,0.4l-1.3,0.2l-1.3,0.4l-1.3,0.2l-1.2,0.5 l-1.3,0.2l-1.2,0.2l-1.2,0.3l-1.2,0.5l-1.3,0.2l-1.2,0.1l-1.2,0.2l-1.2,0.4h0.2l0.8-0.1l0.9-0.1l0.6,0l1.1-0.1l1.3,0.1l1.2-0.1 h1.3l1.2,0.2l1.3-0.2l1.2,0.2l1.3-0.2l1.3,0.2l1.2-0.1l1.3,0.1l1.2,0.1l1.3-0.1l0.1,1.4v1.3l-0.1,1.5l-1.4-0.2h-1.4l-1.4,0.2 l-1.4-0.1l-1.4-0.1l-1.4,0l-1.4,0l-1.4,0.1h-1.4h-1.4h-1.4l-1.4,0l-1.4,0.2l-1.4-0.2l-1.4,0l-1.3,0l-1.4,0.1h-1.4l-1.4-0.2 l-1.4,0h-1.4l-1.4,0l-1.4,0.1l-1.4,0l-0.1-1.3l-0.1-1.3l0.1-1.5l1.3-0.2l1.4-0.2l1.2-0.5l1.3-0.2l1.3-0.4l1.2-0.3l1.3-0.3 l1.3-0.4l1.3-0.3l1.3-0.4l1.3-0.2l1.2-0.3l1.2-0.2l1.2-0.4l-0.2,0l-1.1,0.1l-1,0.1l-1.2-0.1l-1.3,0h-1.3l-1.3,0.2l-1.3-0.1 l-1.3,0l-1.2-0.2l-1.3,0l-1.3,0l-1.3,0.1l-1.3,0.1l-1.4-0.1l0.1-1.4l0.1-1.4l-0.1-1.2l1.4-0.2l1.4,0.2l1.4-0.1l1.4,0.1l1.4-0.1 l1.4,0.2l1.4-0.1l1.4,0.1l1.3-0.2l1.4,0.2l1.4-0.1h1.4l1.4-0.1l1.4,0l1.4,0l1.4,0l1.4-0.1l1.4,0.2l1.4,0h1.4l1.4-0.1h1.4 L223.9,385.3z\"></path><path class=\"st4\" d=\"M216.6,367.9l0.9,0.1l1.4,0.4l1.6,0.9l0.7,0.5l0.8,0.8l0.8,0.9l0.7,0.9l0.9,1.1l0.5,1.1l0.9,1.7l-1.2,0.5 l-1.2,0.6l-1.1,0.5l-0.7-1.3l-0.5-1l-0.6-1l-1-1l-0.6-0.6l-0.9-0.6l-1.5-0.2l-1.5-0.2l-1,0.1l-1.1,0.2l-0.9,0.3l-1,0.6l-0.9,0.8 l-1.2,0.7l-1.5,1l-0.8,0.8l-1.2,0.7l-1.4,0.6l-0.8,0.4l-0.9,0.2l-1.2,0h-1.1l-1.1-0.2l-1.1-0.2l-0.8-0.5l-0.9-0.4l-0.8-0.8 l-0.9-0.8l-0.7-1l-0.8-0.8l-0.5-1l-0.4-0.9l1.2-0.4l1-0.7l1-0.6l0.4,0.8l0.8,1l0.9,0.8l0.6,0.7l0.9,0.4l1.2,0.2l1.4,0.1l1.2-0.4 l1.1-0.6l1.2-0.9l0.9-0.6l0.7-0.8l1.4-1l1.4-0.7l1-0.4l0.9-0.7l2-0.4l1.6-0.1L216.6,367.9z\"></path><path class=\"st4\" d=\"M196.6,350.7v1.3l0.2,1.4l-0.1,1.3l1.4,0l1.4,0.1l1.4-0.1l1.4-0.2l1.4,0.1l1.4,0l1.4,0l1.4,0l1.4,0.1l1.4,0 l1.3-0.1l1.4,0.1l1.4-0.2h1.4l1.4,0.2h1.4h1.4h1.4h1.4h1.4l1.4-0.1l-0.1,1.4l0.1,1.5v1.5l-1.4-0.2h-1.4l-1.4,0.1l-1.4,0.2 l-1.4-0.1l-1.4,0.1l-1.4,0l-1.4-0.1L213,359l-1.4,0.1l-1.3-0.1l-1.4,0.2l-1.4-0.2l-1.4,0l-1.4,0.2l-1.4,0l-1.4-0.1l-1.4,0.2 l-1.4,0l-1.4-0.2l-1.5,0.1l0,1.3l0.2,1.3l-0.1,1.5l-1.3-0.1l-1.2,0.1l-1.4,0l0.2-1.4l-0.1-1.4l-0.1-1.4l0-1.4v-1.4l0.1-1.4v-1.3 v-1.4l0-1.3h1.3l1.2,0L196.6,350.7z\"></path><path class=\"st4\" d=\"M239.2,425.8l1.4,0.1h1.4l1.4,0.1l1.4,0.1l1.4,0.2l1.4,0.1l1.4,0.1l1.3,0.1l1.4,0.1l1.4,0.1l1.4,0l1.4,0.2 h1.4l1.4,0.2h1.4l1.4,0.1l1.4,0.1l1.4,0l1.4,0.1l1.4,0.2l1.4,0.2l1.4-0.1l1.4,0.2v1.3l0.1,1.3l-0.1,1.2l-1.4,0.2l-1.4,0.2 l-1.4,0.2l-1.4,0.3l-1.4,0.2l-1.4,0.3l-1.4,0.1l-1.6,0.2l-1.6,0.4l1.6,0.1l1.6,0l1.4,0.5l1.4,0.1l1.4,0.1l1.4,0.3l1.5,0.1 l1.4,0.3l1.4,0.3l0.1,1.3l-0.1,1.4l0,1.4h-1.4l-1.4,0.3h-1.4l-1.4,0.2h-1.4l-1.4,0l-1.4,0.2l-1.4,0l-1.4-0.1l-1.4,0.3l-1.4,0 l-1.4,0.1l-1.4,0.1h-1.4l-1.4,0.1h-1.3l-1.4,0.2l-1.4,0.1l-1.4,0.2l-1.4,0l-1.4,0.2h-1.4h-1.4l-1.4,0.2v-1.4l0.2-1.3l-0.1-1.5 h1.4l1.4-0.2l1.4,0l1.4-0.1l1.4,0l1.4,0l1.4-0.2l1.4,0l1.4-0.2l1.4,0.1l1.4-0.3l1.1,0.1l1.2,0l0.9,0l0.2,0l-1.1-0.4l-1.1,0 l-1.2-0.3l-1.2-0.3l-1.4-0.1l-1.2-0.5l-1.2-0.2l-1.3-0.1l-1.2-0.5l-1.4-0.2l-1.2-0.2l-0.3-0.1l-0.1-0.1l-0.3,0l0.2,0l0.2,0 l0.4-0.2l1.3-0.1l1.3-0.2l1.2-0.3l1.3-0.2l1.2-0.4l1.3-0.2l1.2-0.5l1.3-0.2l1.2-0.1l1.1-0.2l1.1-0.2h-0.2l-0.9,0l-1.2,0l-1.1,0 l-1.4-0.2l-1.4-0.2h-1.4l-1.4,0l-1.4-0.1l-1.4-0.2l-1.4-0.1l-1.4-0.1l-1.4-0.1l-1.4-0.2h-1.3l-0.1-1.3l-0.1-1.4l0.1-1.4 L239.2,425.8z\"></path><path class=\"st4\" d=\"M269,408.1l1.1-0.1l0.1,1.4v1.3l-0.1,1.4l0.1,1.3l0.1,1.3l-0.1,1.3v1.3h-1.4l-1.4,0.1l-1.4-0.1l-1.4,0 l-1.4,0.2l-1.4,0h-1.4l-1.4,0l-1.4-0.1l-1.4,0.2l-1.4-0.2l-1.4,0.1l-1.4-0.1h-1.4l-1.4-0.1l-1.3,0.2l-1.4,0l-1.4-0.1h-1.4 l-1.4,0.2l-1.4-0.2h-1.4l-1.4,0.2l-1.2-0.1l-0.2-1.3l0.1-1.3l0.1-1.3l-0.1-1.2v-1.3l0.1-1.3l-0.1-1.2l1.3-0.1l1.2,0.1l1.2-0.1 v1.2l0.1,1.2l0,1.2v1.2l1.4-0.2l1.4,0l1.4,0.2l1.4-0.2l1.4,0.1l1.4-0.1l1.4,0.1v-1.5l0.1-1.5l-0.1-1.5h1.2l1.3,0l1.2,0.1l0.1,1.5 l0,1.5l-0.1,1.6l1.2-0.1l1.3,0.1l1.2-0.2l1.3,0.1l1.2-0.1l1.3,0.2l1.2-0.2l1.3,0.2l1.1-0.1v-1.2l0.2-1.3l-0.2-1.2l0.1-1.2l1.2,0 L269,408.1z\"></path><path class=\"st4\" d=\"M248.3,388.2l1.1,0.2l1.1,0.3l0.8,0.2l1,0.5l1.3,0.5l0.8,0.5l0.9,0.7l0.6,0.5l1.4-0.1l1.3-0.5l1.3-0.3 l1.4-0.2l1.3-0.3l1.2-0.4l1.3-0.4l1.3-0.3l1.4-0.2l1.3-0.4l1.2-0.3l0.1,1.4l0.1,1.5l-0.1,1.4l-1.3,0.3l-1.4,0.2l-1.2,0.5 l-1.4,0.3l-1.3,0.2l-1.4,0.3l-1.3,0.3l-1.3,0.3l-1.3,0.4l0.1,0.1v0.2l0.2,0.3l0.1,0.2l0.1,0.2l1.2,0h1.2h1.3l1.2-0.1l1.2,0.2 l1.2,0l1.3,0l1.2,0l1.3,0l0.1,1.5l-0.2,1.4l0.1,1.4l-1.4,0l-1.4,0.1l-1.4-0.1l-1.4,0.2l-1.4-0.1l-1.4,0l-1.4-0.1l-1.4,0.1 l-1.4-0.1l-1.4,0.1l-1.4,0l-1.4,0.1h-1.4l-1.4-0.1l-1.4,0l-1.3-0.1l-1.4,0.1l-1.4,0l-1.4,0l-1.4-0.1l-1.4,0l-1.4,0l-1.4,0.1 l-1.4,0l0.1-1.4l-0.1-1.4l0.1-1.4l0-1.4l0.1-0.5l0.1-0.9l0.8-1.2l0.5-1l0.9-0.9l0.6-0.4l0.8-0.5l0.6-0.3l0.7-0.3l1-0.4l0.8,0 l1.1-0.2l1.2-0.2L248.3,388.2z M247.1,392.3l-0.8,0l-1.4,0.1l-0.6,0.3l-0.6,0.2l-1.1,0.8l-0.5,0.3l-0.2,0.6l-0.2,0.5l-0.1,0.4 v0.4v0.2l1.3-0.2l1.2,0l1.3,0.1l1.2,0.1l1.3,0h1.3l1.2,0h1.3h1.2l1.3,0l-0.1-0.4l-0.4-0.3l-0.2-0.2l-0.5-0.4l-1.1-1.1l-0.6-0.4 l-0.8-0.5l-1.1-0.3l-0.7-0.2l-1.1-0.1L247.1,392.3z\"></path><path class=\"st4\" d=\"M270.3,368.5l0,1.5l-0.1,1.4l-1.3,0.5l-1.3,0.5l-1.3,0.3l-1.2,0.6l-1.3,0.4l-1.3,0.5l-1.3,0.4l-1.4,0.3 l-1.3,0.4l-1.2,0.6l-1.2,0.3l-1.2,0.3h0.1l0.6-0.1l0.8-0.1l0.8,0.1l1.3-0.2l1.3,0.2l1.3-0.2h1.3l1.2,0.1l1.3-0.1l1.3,0.1l1.3,0 l1.3-0.1h1.2l0.2,1.4l-0.2,1.5l0.1,1.4l-1.4,0.1l-1.4-0.1h-1.4l-1.4-0.2l-1.4,0.2l-1.4,0l-1.4,0l-1.4-0.2h-1.4l-1.4,0.2l-1.4,0 l-1.4-0.1l-1.4-0.1l-1.4,0.1l-1.4-0.1l-1.3,0.1l-1.4,0l-1.4,0.1l-1.4-0.2l-1.4,0.2l-1.4-0.2l-1.4,0.2l-1.4-0.1l-1.5,0l0.1-1.4 v-1.5l0-1.5l1.4,0.1l1.4-0.1l1.4,0l1.4,0.2h1.4l1.4-0.2l1.4,0.1l0.7,0h0.8l0.6,0.1l-0.6-0.3l-0.8-0.2l-0.6-0.2l-1.5-0.5l-1.5-0.5 l-1.6-0.5l-1.6-0.5l-1.4-0.6l-1.5-0.5l-0.5-0.2l-0.1-1.4l-0.1-1.4l0.1-1.5l1.3,0.5l1.3,0.4l1.2,0.6l1.3,0.5l1.4,0.3l1.3,0.5 l1.2,0.5l1.4,0.4l1.3,0.5l1.2,0.5l1.2,0.3l1.4-0.3l1.4-0.4l1.2-0.5l1.3-0.4l1.3-0.5l1.3-0.4l1.2-0.5l1.3-0.4l1.4-0.3l1.2-0.7 l1.4-0.5l1.3-0.3l1.2-0.5l1.4-0.4L270.3,368.5z\"></path><path class=\"st4\" d=\"M269,350.2l1.1-0.1l0.1,1.4v1.3l-0.1,1.4l0.1,1.3l0.1,1.3l-0.1,1.3v1.3h-1.4l-1.4,0.2l-1.4-0.2l-1.4,0 l-1.4,0.2l-1.4-0.1h-1.4l-1.4,0l-1.4-0.1l-1.4,0.2l-1.4-0.2l-1.4,0.1l-1.4-0.1h-1.4l-1.4-0.1l-1.3,0.2l-1.4,0l-1.4-0.1h-1.4 l-1.4,0.2l-1.4-0.2h-1.4l-1.4,0.2l-1.2-0.1l-0.2-1.3l0.1-1.3l0.1-1.3l-0.1-1.2v-1.3l0.1-1.3l-0.1-1.2l1.3-0.1l1.2,0.1l1.2-0.1 v1.2l0.1,1.2l0,1.2v1.2l1.4-0.2l1.4,0l1.4,0.2l1.4-0.2l1.4,0.1l1.4-0.1l1.4,0.1v-1.5l0.1-1.5l-0.1-1.5h1.2l1.3,0l1.2,0.1l0.1,1.5 l0,1.5l-0.1,1.6l1.2-0.1l1.3,0.1l1.2-0.2l1.3,0.1l1.2-0.1l1.3,0.2l1.2-0.2l1.3,0.2l1.1-0.1v-1.2l0.2-1.3l-0.2-1.2l0.1-1.2l1.2,0 L269,350.2z\"></path></g></g><g><g><path class=\"st4\" d=\"M684.8,304.1l-0.1,1.3v1.4l-0.1,1.3l-0.1,1.4l-0.2,1.3l-0.1,1.4l-0.1,1.3l-0.1,1.4l-0.1,1.3l-0.1,1.4l0,1.3 l-0.2,1.4v1.3l-0.2,1.4v1.3l-0.1,1.4l-0.1,1.3l0,1.4l-0.1,1.3l-0.2,1.4l-0.2,1.3l0.1,1.4l-0.2,1.4h-1.3l-1.3,0l-1.2-0.1l-0.2-1.4 l-0.2-1.4l-0.2-1.4l-0.3-1.4l-0.2-1.4l-0.3-1.4l-0.1-1.4l-0.2-1.6l-0.4-1.5l-0.1,1.5l0,1.6l-0.5,1.4l-0.1,1.4l-0.1,1.4l-0.3,1.4 l-0.1,1.5l-0.3,1.3l-0.3,1.4l-1.3,0.1l-1.4-0.1l-1.4,0v-1.3l-0.3-1.4v-1.3l-0.2-1.4v-1.3l0-1.4l-0.2-1.3l0-1.4l0.1-1.3l-0.3-1.4 l0-1.3l-0.1-1.4l-0.1-1.3v-1.4l-0.1-1.3v-1.4l-0.2-1.3l-0.1-1.4l-0.2-1.3l0-1.4l-0.2-1.3v-1.4v-1.3l-0.2-1.4h1.4l1.3,0.2l1.5-0.1 v1.4l0.2,1.4l0,1.3l0.1,1.4l0,1.3l0,1.4l0.2,1.3l0,1.4l0.2,1.4l-0.1,1.4l0.3,1.4l-0.1,1l0,1.2l0,0.9l0,0.2l0.4-1.1l0-1.2l0.3-1.1 l0.3-1.2l0.1-1.4l0.5-1.2l0.2-1.2l0.1-1.3l0.5-1.2l0.2-1.4l0.2-1.2l0.1-0.3l0.1-0.2l0-0.2l0,0.2l0,0.2l0.2,0.3l0.1,1.3l0.2,1.3 l0.3,1.2l0.2,1.3l0.4,1.2l0.2,1.3l0.5,1.2l0.2,1.3l0.1,1.1l0.2,1.2l0.2,1.1V321l0-0.9l0-1.2l0-1l0.2-1.4l0.2-1.3v-1.4l0-1.4 l0.1-1.3l0.2-1.4l0.1-1.3l0.1-1.4l0.1-1.3l0.2-1.4v-1.3l1.3,0l1.4-0.2l1.4,0.1L684.8,304.1z\"></path><path class=\"st4\" d=\"M702.8,333.9l0.1,1.2l-1.4,0.1h-1.3l-1.4-0.1l-1.3,0l-1.3,0.1l-1.3-0.1h-1.3v-1.3l-0.1-1.4l0.1-1.3l0-1.4 l-0.2-1.3l0-1.4v-1.3l0-1.4l0.1-1.3l-0.2-1.4l0.2-1.3l-0.1-1.4l0.1-1.3v-1.4l0.1-1.3l-0.2-1.4l0-1.3l0.1-1.4v-1.3l-0.2-1.4 l0.2-1.3v-1.4l-0.2-1.3l0.1-1.2l1.3-0.2l1.3,0.1l1.3,0l1.2-0.1h1.3l1.3,0.1l1.2-0.1l0.1,1.3l-0.1,1.2l0.1,1.2h-1.2l-1.2,0l-1.2,0 h-1.2l0.2,1.4l0,1.3l-0.2,1.3l0.2,1.4l-0.1,1.4l0.1,1.3l-0.1,1.4h1.5l1.5,0.1l1.5-0.1v1.2l0,1.3l-0.1,1.2l-1.5,0.1l-1.5,0l-1.6,0 l0.1,1.2l-0.1,1.3l0.2,1.2l-0.1,1.3l0.1,1.2l-0.2,1.3l0.2,1.2l-0.2,1.3l0.1,1.2h1.2l1.3,0.2l1.2-0.2l1.2,0.1l0,1.2L702.8,333.9z\"></path><path class=\"st4\" d=\"M722.3,332.6l0,1.4l-0.1,1.2l-1.5,0.1l-1.2-0.5l-0.8-0.2l-0.8-0.3l-0.8-0.5l-0.8-0.6l-1.3-1.2l-1.2-1.5 l-0.6-0.7l-0.5-0.7l-0.5-0.7l-0.3-0.9l-0.6-0.9l-0.3-1.1l-0.3-1l-0.2-1l-0.2-1.1l-0.2-1.2l-0.2-1.9l0-1l0-1.1l0-1.4l0.1-1.4 l0.1-1.2l0.3-1.1l0.2-0.9l0.5-1.1l0.5-1l0.5-1.1l1-1.2l1-0.9l1-0.9l0.9-0.7l0.9-0.5l0.7-0.2l1.2-0.5l0.9-0.3l0.8-0.2l1-0.1 l0.2,1.2l0.2,1.3l0.2,1.2l-0.6,0.2l-0.8,0.1l-0.8,0.2l-1,0.4L718,308l-1.2,0.8l-0.7,0.8l-0.5,0.9l-0.7,1.5l-0.5,1.5l-0.3,1.3v1 l-0.2,1.4l0.2,1.5l0,1.5l0.2,1l0.3,1l0.2,1.8l0.3,1.1l0.3,0.7l0.3,0.8l0.5,0.9l0.8,0.8l0.4,0.5l0.6,0.5l0.1-1.3l0-1.3v-1.3l0-1.3 v-1.3l0-1.3l-0.1-1.3l0-1.3v-1.4l0.1-1.2l1.4-0.2l1.4,0.2l1.3,0l0.2,1.3l0,1.4l0,1.3l0,1.4l-0.1,1.4v1.4l0.2,1.4l-0.2,1.3 l0.2,1.4l0,1.3l0.1,1.4L722.3,332.6z\"></path><path class=\"st4\" d=\"M740.3,333.9l0.1,1.2l-1.4,0.1h-1.3l-1.4-0.1l-1.3,0l-1.3,0.1l-1.3-0.1h-1.3v-1.3l-0.2-1.4l0.2-1.3l0-1.4 l-0.2-1.3l0.1-1.4v-1.3l0-1.4l0.1-1.3l-0.2-1.4l0.2-1.3l-0.1-1.4l0.1-1.3v-1.4l0.1-1.3l-0.2-1.4l0-1.3l0.1-1.4v-1.3l-0.2-1.4 l0.2-1.3v-1.4l-0.2-1.3l0.1-1.2l1.3-0.2l1.3,0.1l1.3,0l1.2-0.1h1.3l1.3,0.1l1.2-0.1l0.1,1.3l-0.1,1.2l0.1,1.2H739l-1.2,0l-1.2,0 h-1.2l0.2,1.4l0,1.3l-0.2,1.3l0.2,1.4l-0.1,1.4l0.1,1.3l-0.1,1.4h1.5l1.5,0.1l1.5-0.1v1.2l0,1.3l-0.1,1.2l-1.5,0.1l-1.5,0l-1.6,0 l0.1,1.2l-0.1,1.3l0.2,1.2l-0.1,1.3l0.1,1.2l-0.2,1.3l0.2,1.2l-0.2,1.3l0.1,1.2h1.2l1.3,0.2l1.2-0.2l1.2,0.1l0,1.2L740.3,333.9z\"></path></g></g><g><g><path class=\"st4\" d=\"M685.3,234.4h-1.5l-1.4-0.1l-1.1-0.1l-1.1,0.1l-1.6-0.2l-1.5-0.1l-1.5-0.2l-1.3-0.5L673,233l-1.3-0.5 l-1.3-0.8l-1.5-0.9l-0.6-0.6l-0.4-0.9l-0.2-0.8l-0.2-0.9l0-0.9l0.3-0.8l0.5-0.8l0.5-0.6l1.2-0.8l1.5-0.8l1.7-0.8l1.8-0.2l1.2-0.2 l1.1-0.1l1.2-0.2l1.2-0.1l1.4-0.2l1.3,0.1h1.4l1.3-0.3l1.5,0l1.5,0.3l1.5,0.1l1.2-0.1l1.2,0.2l1.2,0.1l1.5,0.4l1.8,0.6l1.4,0.9 l1.2,0.9l0.5,0.8l0.5,0.9l0.2,0.9l0.2,1l-0.2,1l-0.2,0.9l-0.5,0.8l-0.5,0.8l-1.2,1l-1.4,0.6l-1.5,0.5l-1.5,0.3l-1.1,0.4l-1.2,0.2 l-1.2,0l-1,0.1l-1.1-0.1l-1.3,0.2L685.3,234.4z M686.6,230l1.3,0l1.4,0l1.2-0.2l1.2,0l1.1-0.2l1-0.2l0.8-0.1l0.8-0.4l1-0.6 l0.4-0.3v-0.3v-0.3l-0.2-0.4l-1-0.5l-0.9-0.3l-0.9-0.1l-1.2-0.4l-1.2,0l-1.2-0.2l-1.5,0l-1.5,0l-1.6,0H684h-1.3l-1.3,0l-1.3,0.2 l-1.2,0l-1.2,0l-1.2,0.3l-1.2,0.2l-1.1,0.3l-1.4,0.3l-0.8,0.5l-0.2,0.2v0.1v0.2l0.2,0.2l0.9,0.5l0.9,0.2l1,0.2l1.5,0.3l1.5,0.5 l1.7,0l1.7,0.2h1.8l1.2,0l1.2,0l0,0L686.6,230z\"></path><path class=\"st4\" d=\"M690,254.3l-1.2-0.2l-1-0.3l-0.8-0.2l-1-0.5l-1.3-0.5l-0.8-0.5l-0.8-0.7l-0.7-0.5L681,251l-1.2,0.5l-1.3,0.3 l-1.3,0.2l-1.3,0.3l-1.2,0.4l-1.3,0.4l-1.3,0.3l-1.3,0.2l-1.3,0.4l-1.1,0.3l-0.2-1.4l-0.1-1.5l0.1-1.4l1.3-0.3l1.4-0.2l1.2-0.5 l1.3-0.3l1.3-0.2l1.3-0.3l1.3-0.3l1.3-0.3l1.3-0.4l-0.1-0.1v-0.2l-0.2-0.3l-0.1-0.2l0-0.2l-1.2,0h-1.2h-1.3l-1.2,0.1l-1.2-0.2 l-1.3,0l-1.3,0l-1.2,0l-1.3,0l0-1.5l0.2-1.4L668,242l1.3,0l1.4-0.1l1.3,0.1l1.4-0.2l1.3,0.1l1.4,0l1.3,0.1l1.4-0.1l1.3,0.1 l1.4-0.1l1.3,0l1.4-0.1h1.3l1.4,0.1l1.3,0l1.4,0.1l1.3-0.1l1.4,0l1.3,0l1.4,0.1l1.3,0l1.4,0l1.3-0.1l1.4,0l0,1.4l0.1,1.4 l-0.2,1.4l0.1,1.4l-0.1,0.5l-0.1,0.9l-0.8,1.2l-0.5,1l-0.9,0.9l-0.7,0.4l-0.8,0.5l-0.6,0.3l-0.7,0.3l-1,0.4l-0.8,0l-1,0.2 l-1.2,0.2L690,254.3z M691.2,250.2l0.8,0l1.4-0.1l0.6-0.3l0.6-0.2l1.1-0.8l0.5-0.3l0.2-0.6l0.2-0.5l0.1-0.4v-0.4v-0.2l-1.3,0.2 l-1.2,0l-1.3-0.1l-1.2-0.1l-1.3,0h-1.3l-1.2,0h-1.3h-1.2l-1.2,0l0,0.4l0.5,0.3l0.2,0.2l0.5,0.4l1.2,1.1l0.5,0.4l0.8,0.5l1.1,0.3 l0.7,0.2l1,0.1L691.2,250.2z\"></path><path class=\"st4\" d=\"M696.6,272.9v-1.3l-0.2-1.4l0.2-1.3l-1.4,0l-1.3-0.1l-1.4,0.1l-1.3,0.2l-1.4-0.1l-1.3,0l-1.4,0l-1.4,0 l-1.4-0.1l-1.3,0l-1.4,0.1l-1.3-0.1l-1.4,0.2h-1.4l-1.4-0.2h-1.3h-1.4h-1.3h-1.4h-1.4l-1.3,0.1l0.1-1.4L668,266v-1.5l1.3,0.2h1.4 l1.4-0.1l1.3-0.2l1.4,0.1l1.3-0.1l1.4,0l1.4,0.1l1.4,0.1l1.3-0.1l1.4,0.1l1.3-0.2l1.4,0.2l1.4,0l1.4-0.2l1.3,0l1.4,0.1l1.3-0.2 l1.4,0l1.3,0.2l1.5-0.1l-0.1-1.3l-0.2-1.3l0.1-1.5l1.3,0.1l1.2-0.1l1.4,0l-0.2,1.4l0.1,1.4l0,1.4l0,1.4v1.4l-0.2,1.4v1.3v1.4 l0.1,1.3h-1.3l-1.2,0L696.6,272.9z\"></path><path class=\"st4\" d=\"M669.3,289.4l-1.2,0.1l-0.1-1.4v-1.3l0.1-1.4l0-1.3l-0.1-1.3l0.1-1.3v-1.3h1.3l1.4-0.2l1.3,0.2l1.4,0 l1.3-0.2l1.4,0.1h1.3l1.4,0l1.3,0.1l1.4-0.2l1.3,0.2l1.4-0.1l1.3,0.1h1.4l1.3,0.1l1.4-0.2l1.3,0l1.4,0.1h1.3l1.4-0.2l1.3,0.2h1.4 l1.3-0.2l1.2,0.1l0.2,1.3l-0.1,1.3l0,1.3l0.1,1.2v1.3l-0.1,1.3l0.1,1.2l-1.3,0.1l-1.2-0.1l-1.2,0.1v-1.2l0-1.2l0-1.2v-1.2 l-1.4,0.2l-1.3,0l-1.3-0.2l-1.4,0.2l-1.4-0.1l-1.3,0.1l-1.4-0.1v1.5l-0.1,1.5l0.1,1.5h-1.2l-1.3,0l-1.2-0.1l-0.1-1.5l0-1.5l0-1.6 l-1.2,0.1l-1.3-0.1l-1.2,0.2l-1.3-0.1l-1.2,0.1l-1.3-0.2l-1.2,0.2l-1.3-0.2l-1.2,0.1v1.2l-0.2,1.3l0.2,1.2l-0.1,1.2l-1.2,0 L669.3,289.4z\"></path></g></g></g><g id=\"bildrahmen\"><rect x=\"52.7\" y=\"85.7\" class=\"st5\" width=\"302.6\" height=\"204.7\"></rect><rect x=\"691.1\" class=\"st5\" width=\"158.9\" height=\"150\"></rect><rect x=\"458\" y=\"220.9\" class=\"st5\" width=\"191\" height=\"302.6\"></rect></g></svg>"

/***/ }),

/***/ 885:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17 17\" style=\"enable-background:new 0 0 17 17;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#092957;} </style><g><path class=\"st0\" d=\"M0,0v17h17V0H0z M15.6,15.6H1.3V1.3h14.3V15.6z\"></path></g><polygon class=\"st0\" points=\"4.9,13.6 4.9,3.4 13.7,8.5 \"></polygon></svg>"

/***/ }),

/***/ 886:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17 17\" style=\"enable-background:new 0 0 17 17;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#092957;} </style><g><path class=\"st0\" d=\"M17,17V0H0v17H17z M1.3,1.3h14.3v14.3H1.3V1.3z\"></path></g><polygon class=\"st0\" points=\"12,3.3 12,13.6 3.2,8.5 \"></polygon></svg>"

/***/ }),

/***/ 887:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 12.9 17\" style=\"enable-background:new 0 0 12.9 17;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#092957;} </style><path class=\"st0\" d=\"M0,0v17h12.9V0h-1.4v15.6H1.4V0H0z\"></path><polygon class=\"st0\" points=\"10.6,7.2 6.4,3.1 2.3,7.2 3.3,8.2 5.8,5.7 5.8,12.7 7.1,12.7 7.1,5.7 9.6,8.2 \"></polygon></svg>"

/***/ }),

/***/ 888:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 12.9 17\" style=\"enable-background:new 0 0 12.9 17;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#092957;} </style><polygon class=\"st0\" points=\"2.3,8.8 6.4,13 10.6,8.8 9.6,7.8 7.1,10.3 7.1,3.3 5.8,3.3 5.8,10.3 3.3,7.8 \"></polygon><path class=\"st0\" d=\"M0,0v17h12.9V0h-1.4v15.6H1.4V0H0z\"></path></svg>"

/***/ }),

/***/ 889:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17 17\" style=\"enable-background:new 0 0 17 17;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#092957;} </style><g><path class=\"st0\" d=\"M5.2,4.2H3.8v8.5h1.4V4.2z\"></path></g><g><path class=\"st0\" d=\"M17,17V0H0v17H17z M1.4,1.3h14.3v14.3H1.4V1.3z\"></path></g><polygon class=\"st0\" points=\"13.3,4.4 13.3,12.5 6.2,8.5 \"></polygon></svg>"

/***/ }),

/***/ 890:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17 17\" style=\"enable-background:new 0 0 17 17;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#092957;} </style><g><path class=\"st0\" d=\"M11.9,12.8h1.4V4.3h-1.4V12.8z\"></path></g><g><path class=\"st0\" d=\"M0,0v17h17V0H0z M15.7,15.6H1.4V1.3h14.3V15.6z\"></path></g><polygon class=\"st0\" points=\"3.8,12.6 3.8,4.4 10.9,8.5 \"></polygon></svg>"

/***/ }),

/***/ 891:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17 17\" style=\"enable-background:new 0 0 17 17;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#092957;} </style><g><path class=\"st0\" d=\"M0,0v17h17V0H0z M15.7,15.6H1.4V1.3h14.3V15.6z\"></path></g><polygon class=\"st0\" points=\"5.8,12.6 5.8,4.4 12.9,8.5 \"></polygon></svg>"

/***/ }),

/***/ 892:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17 17\" style=\"enable-background:new 0 0 17 17;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#092957;} </style><g><path class=\"st0\" d=\"M17,17V0H0v17H17z M1.4,1.3h14.3v14.3H1.4V1.3z\"></path></g><polygon class=\"st0\" points=\"11.2,4.4 11.2,12.5 4.1,8.5 \"></polygon></svg>"

/***/ }),

/***/ 893:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17 17\" style=\"enable-background:new 0 0 17 17;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#092957;} </style><g><path class=\"st0\" d=\"M4.2,6.2v1.4h8.5V6.2H4.2z\"></path></g><g><path class=\"st0\" d=\"M4.2,3.1v1.4h8.5V3.1H4.2z\"></path></g><g><path class=\"st0\" d=\"M4.2,9.4v1.4h8.5V9.4H4.2z\"></path></g><g><path class=\"st0\" d=\"M4.2,12.5v1.4h8.5v-1.4H4.2z\"></path></g><g><path class=\"st0\" d=\"M0,0v17h17V0C17,0,0,0,0,0z M15.6,15.6H1.3V1.3h14.3V15.6z\"></path></g></svg>"

/***/ }),

/***/ 894:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 31.7 20.4\" style=\"enable-background:new 0 0 31.7 20.4;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#FFFFFF;} </style><g id=\"Ebene_1\"></g><g id=\"Ebene_2\"></g><g id=\"Ebene_3\"><path class=\"st0\" d=\"M3.1,11.3V17h4v-5.7H3.1z\"></path><path class=\"st0\" d=\"M3.1,3.4v5.7h4V3.4H3.1z\"></path><path class=\"st0\" d=\"M9.3,3.4v9.1h4V3.4H9.3z\"></path><path class=\"st0\" d=\"M18.4,11.3V17h10.2v-5.7H18.4z\"></path><path class=\"st0\" d=\"M18.4,3.4v5.7h10.2V3.4H18.4z\"></path><path class=\"st0\" d=\"M0,0v20.4h31.7V0H0z M15.3,19.3H1.1V1.1h14.2V19.3z M30.6,19.3H16.4V1.1h14.2V19.3z\"></path></g></svg>"

/***/ }),

/***/ 895:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 31.7 20.4\" style=\"enable-background:new 0 0 31.7 20.4;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#FFFFFF;} </style><g id=\"Ebene_1\"></g><g id=\"Ebene_2\"></g><g id=\"Ebene_3\"><path class=\"st0\" d=\"M3.1,11.3V17h4v-5.7H3.1z M6,15.9H4.3v-3.4H6V15.9z\"></path><path class=\"st0\" d=\"M3.1,3.4v5.7h4V3.4H3.1z M6,7.9H4.3V4.5H6V7.9z\"></path><path class=\"st0\" d=\"M9.3,3.4v9.1h4V3.4H9.3z M12.2,11.3h-1.7V4.5h1.7V11.3z\"></path><path class=\"st0\" d=\"M18.4,11.3V17h10.2v-5.7H18.4z M27.5,15.9h-7.9v-3.4h7.9V15.9z\"></path><path class=\"st0\" d=\"M18.4,3.4v5.7h10.2V3.4H18.4z M27.5,7.9h-7.9V4.5h7.9V7.9z\"></path><path class=\"st0\" d=\"M0,0v20.4h31.7V0H0z M15.3,19.3H1.1V1.1h14.2V19.3z M30.6,19.3H16.4V1.1h14.2V19.3z\"></path></g></svg>"

/***/ }),

/***/ 896:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 31.748 20.408\" enable-background=\"new 0 0 31.748 20.408\" xml:space=\"preserve\"><g><path fill=\"#222A56\" d=\"M3.118,17.008h3.969v-5.669H3.118V17.008z M4.252,12.475h1.701v3.398H4.252V12.475z\"></path><path fill=\"#222A56\" d=\"M28.636,3.402H18.433v5.669h10.203V3.402z M27.501,7.937h-7.936V4.537h7.936V7.937z\"></path><path fill=\"#222A56\" d=\"M0,0v20.408h31.748V0H0z M30.615,1.135v17.437l-2.54-1.563h0.562v-5.669h-9.774l-2.414-1.485V1.135H30.615z M19.566,13.182l4.374,2.691h-4.374V13.182z M20.707,12.475h6.795v3.398H26.23L20.707,12.475z M15.3,9.146l-1.985-1.221V3.402 H9.346v2.08l-2.259-1.39v-0.69H5.964L2.279,1.135H15.3V9.146z M10.479,7.59l1.701,1.047v2.702h-1.701V7.59z M10.479,6.181V4.537 h1.701v2.69L10.479,6.181z M4.252,4.537h1.266l0.435,0.268v3.132H4.252V4.537z M1.134,19.275V1.839l2.54,1.563H3.118v5.669h3.969 V5.502l2.259,1.391v5.582h3.969V9.334l1.985,1.223v8.719H1.134z M16.448,11.264l1.985,1.221v4.523h7.352l3.685,2.268H16.448V11.264 z\"></path></g></svg>"

/***/ }),

/***/ 897:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 33.2 21.2\" style=\"enable-background:new 0 0 33.2 21.2;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#062956;stroke:#062956;stroke-width:1.2;stroke-miterlimit:10;} .st1{fill:none;stroke:#062956;stroke-width:1.2;stroke-miterlimit:10;} </style><rect x=\"4.3\" y=\"12.4\" class=\"st0\" width=\"2.6\" height=\"3.6\"></rect><rect x=\"0.6\" y=\"0.6\" class=\"st1\" width=\"16\" height=\"20\"></rect><rect x=\"16.6\" y=\"0.6\" class=\"st1\" width=\"16\" height=\"20\"></rect><rect x=\"20.3\" y=\"5.2\" class=\"st0\" width=\"8.6\" height=\"3.6\"></rect><rect x=\"20.3\" y=\"12.4\" class=\"st0\" width=\"8.6\" height=\"3.6\"></rect><rect x=\"4.3\" y=\"5.2\" class=\"st0\" width=\"2.6\" height=\"3.6\"></rect><rect x=\"10.3\" y=\"5.2\" class=\"st0\" width=\"2.6\" height=\"7.2\"></rect></svg>"

/***/ }),

/***/ 898:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 33.2 21.2\" style=\"enable-background:new 0 0 33.2 21.2;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#062956;} </style><g><path class=\"st0\" d=\"M17.2,21.2H0V0h17.2V21.2z M1.2,20H16V1.2H1.2V20z\"></path></g><g><rect x=\"4.3\" y=\"4.6\" class=\"st0\" width=\"8.6\" height=\"1.2\"></rect></g><g><rect x=\"4.3\" y=\"8.2\" class=\"st0\" width=\"8.6\" height=\"1.2\"></rect></g><g><rect x=\"4.3\" y=\"11.8\" class=\"st0\" width=\"8.6\" height=\"1.2\"></rect></g><g><rect x=\"4.3\" y=\"15.4\" class=\"st0\" width=\"8.6\" height=\"1.2\"></rect></g><g><path class=\"st0\" d=\"M33.2,21.2H16V0h17.2V21.2z M17.2,20H32V1.2H17.2V20z\"></path></g><g><rect x=\"20.3\" y=\"4.6\" class=\"st0\" width=\"8.6\" height=\"1.2\"></rect></g><g><rect x=\"21.7\" y=\"8.6\" class=\"st0\" width=\"7.2\" height=\"1.2\"></rect></g><g><rect x=\"21.7\" y=\"11.4\" class=\"st0\" width=\"7.2\" height=\"1.2\"></rect></g><path class=\"st0\" d=\"M26.1,12.5l4.4,4.4c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.4-0.2,0.5l-0.7,0.7c-0.1,0.1-0.3,0.2-0.5,0.2h0 c-0.2,0-0.4-0.1-0.5-0.2l-4.4-4.4\"></path><g><path class=\"st0\" d=\"M22.5,15c-2.4,0-4.4-2-4.4-4.4c0-2.4,2-4.4,4.4-4.4c2.4,0,4.4,2,4.4,4.4C26.8,13,24.9,15,22.5,15z M22.5,7.4 c-1.7,0-3.2,1.4-3.2,3.2s1.4,3.2,3.2,3.2c1.7,0,3.2-1.4,3.2-3.2S24.2,7.4,22.5,7.4z\"></path></g></svg>"

/***/ }),

/***/ 899:
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 496 512\"><path d=\"M248 104c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96zm0 144c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-240C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-49.7 0-95.1-18.3-130.1-48.4 14.9-23 40.4-38.6 69.6-39.5 20.8 6.4 40.6 9.6 60.5 9.6s39.7-3.1 60.5-9.6c29.2 1 54.7 16.5 69.6 39.5-35 30.1-80.4 48.4-130.1 48.4zm162.7-84.1c-24.4-31.4-62.1-51.9-105.1-51.9-10.2 0-26 9.6-57.6 9.6-31.5 0-47.4-9.6-57.6-9.6-42.9 0-80.6 20.5-105.1 51.9C61.9 339.2 48 299.2 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 43.2-13.9 83.2-37.3 115.9z\"></path></svg>"

/***/ }),

/***/ 900:
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"><path d=\"M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z\"></path></svg>"

/***/ }),

/***/ 901:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 37.2 21.2\" style=\"enable-background:new 0 0 37.2 21.2;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{fill:#062956;} </style><g><path class=\"st0\" d=\"M17.2,21.2H0V0h17.2V21.2z M1.2,20H16V1.2H1.2V20z\"></path></g><g><rect x=\"4.3\" y=\"4.6\" class=\"st0\" width=\"8.6\" height=\"1.2\"></rect></g><g><rect x=\"24.3\" y=\"4.6\" class=\"st0\" width=\"8.6\" height=\"1.2\"></rect></g><g><path class=\"st0\" d=\"M37.2,21.2H20V0h17.2V21.2z M21.2,20H36V1.2H21.2V20z\"></path></g><g><rect x=\"24.3\" y=\"15.4\" class=\"st0\" width=\"8.6\" height=\"1.2\"></rect></g><g><rect x=\"4.3\" y=\"15.4\" class=\"st0\" width=\"8.6\" height=\"1.2\"></rect></g><polygon class=\"st0\" points=\"4.3,11.9 8.2,11.9 8.2,14 13.9,10.6 8.2,7.2 8.2,9.3 4.3,9.3 \"></polygon><polygon class=\"st0\" points=\"32.9,9.3 29,9.3 29,7.2 23.3,10.6 29,14 29,11.9 32.9,11.9 \"></polygon></svg>"

/***/ }),

/***/ 902:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17.008 17.008\" enable-background=\"new 0 0 17.008 17.008\" xml:space=\"preserve\"><g><path fill=\"#27225D\" d=\"M8.691,7.529L6.404,3.567C6.225,3.257,5.828,3.149,5.516,3.33C5.206,3.509,5.099,3.906,5.279,4.218 l2.28,3.95C7.542,8.215,7.54,8.266,7.53,8.314L4.641,9.98c-0.311,0.18-0.417,0.577-0.238,0.889 c0.121,0.208,0.339,0.325,0.564,0.325c0.109,0,0.222-0.028,0.324-0.087l2.876-1.659c0.106,0.038,0.217,0.068,0.336,0.068 c0.561,0,1.012-0.454,1.012-1.013C9.516,8.012,9.158,7.62,8.691,7.529z\"></path><path fill=\"#27225D\" d=\"M8.503,0C3.815,0,0,3.814,0,8.504s3.815,8.504,8.503,8.504c4.69,0,8.504-3.814,8.504-8.504 S13.193,0,8.503,0z M12.648,14.387l-0.395-0.684l-1.125,0.65l0.395,0.683c-0.733,0.34-1.529,0.563-2.369,0.639v-1.667H7.853v1.667 c-0.842-0.075-1.639-0.3-2.372-0.641l0.394-0.682l-1.125-0.65l-0.394,0.682c-0.673-0.476-1.259-1.062-1.735-1.735l0.683-0.394 l-0.65-1.125l-0.682,0.394c-0.34-0.732-0.563-1.529-0.639-2.369h1.668V7.854H1.333c0.075-0.84,0.299-1.636,0.639-2.368l0.681,0.393 l0.65-1.125L2.621,4.359C3.097,3.687,3.684,3.1,4.356,2.624L4.75,3.307l1.125-0.65L5.481,1.974 c0.733-0.341,1.531-0.565,2.372-0.641V3h1.301V1.333c0.84,0.075,1.637,0.299,2.369,0.639l-0.395,0.684l1.125,0.65l0.396-0.685 c0.673,0.477,1.26,1.063,1.736,1.736L13.7,4.753l0.65,1.125l0.685-0.396c0.341,0.733,0.564,1.53,0.64,2.371h-1.669v1.301h1.669 c-0.075,0.841-0.3,1.639-0.641,2.372l-0.686-0.396l-0.65,1.125l0.687,0.396C13.908,13.324,13.321,13.911,12.648,14.387z\"></path></g></svg>"

/***/ }),

/***/ 903:
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Ebene_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 17.008 17.008\" enable-background=\"new 0 0 17.008 17.008\" xml:space=\"preserve\"><g><path fill=\"#27225D\" d=\"M17.008,17.008V0H0v17.008H17.008z M1.378,1.378h14.25v14.251H1.378V1.378z\"></path></g><g><path fill=\"#27225D\" d=\"M8.504,2.051c-3.559,0-6.453,2.895-6.453,6.453s2.895,6.453,6.453,6.453s6.453-2.895,6.453-6.453 S12.062,2.051,8.504,2.051z M11.648,12.951L11.25,12.26l-0.866,0.5l0.399,0.691c-0.551,0.255-1.148,0.423-1.779,0.48v-1.511h-1 v1.511c-0.631-0.058-1.229-0.226-1.778-0.479l0.398-0.692l-0.866-0.5l-0.398,0.691c-0.504-0.357-0.945-0.798-1.303-1.303 l0.691-0.399l-0.501-0.865l-0.69,0.399c-0.255-0.551-0.423-1.148-0.48-1.779h1.51v-1h-1.51c0.058-0.631,0.226-1.229,0.48-1.779 l0.691,0.399l0.5-0.865L4.057,5.359c0.357-0.505,0.798-0.944,1.302-1.303l0.399,0.691l0.866-0.5L6.225,3.557 c0.551-0.255,1.148-0.423,1.779-0.48v1.511h1V3.076c0.631,0.058,1.229,0.226,1.779,0.48l-0.399,0.691l0.866,0.5l0.399-0.69 c0.504,0.357,0.944,0.798,1.302,1.302L12.26,5.759l0.5,0.865l0.691-0.399c0.255,0.551,0.423,1.148,0.48,1.779H12.42v1h1.512 c-0.058,0.631-0.226,1.229-0.48,1.778l-0.689-0.398l-0.501,0.865l0.69,0.399C12.594,12.152,12.153,12.593,11.648,12.951z\"></path><path fill=\"#27225D\" d=\"M8.693,7.833l-1.62-2.808c-0.14-0.239-0.446-0.323-0.683-0.183C6.15,4.98,6.068,5.286,6.207,5.525 L7.82,8.321L5.777,9.5c-0.239,0.138-0.321,0.443-0.184,0.683c0.094,0.16,0.262,0.25,0.434,0.25c0.086,0,0.172-0.021,0.25-0.067 l2.057-1.187c0.056,0.014,0.109,0.034,0.17,0.034c0.393,0,0.709-0.317,0.709-0.709C9.213,8.18,8.991,7.918,8.693,7.833z\"></path></g></svg>"

/***/ }),

/***/ 904:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1923.11643d8.png";

/***/ }),

/***/ 905:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1932.6c32f7e.png";

/***/ }),

/***/ 906:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/SMH_Logo_SCHWARZ.4378290.jpg";

/***/ }),

/***/ 907:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 908:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAArCAYAAADhXXHAAAAABGdBTUEAALGOfPtRkwAAACBjSFJNAACHDwAAjA8AAP1SAACBQAAAfXkAAOmLAAA85QAAGcxzPIV3AAAKL2lDQ1BJQ0MgUHJvZmlsZQAASMedlndUVNcWh8+9d3qhzTDSGXqTLjCA9C4gHQRRGGYGGMoAwwxNbIioQEQREQFFkKCAAaOhSKyIYiEoqGAPSBBQYjCKqKhkRtZKfHl57+Xl98e939pn73P32XuftS4AJE8fLi8FlgIgmSfgB3o401eFR9Cx/QAGeIABpgAwWempvkHuwUAkLzcXerrICfyL3gwBSPy+ZejpT6eD/0/SrFS+AADIX8TmbE46S8T5Ik7KFKSK7TMipsYkihlGiZkvSlDEcmKOW+Sln30W2VHM7GQeW8TinFPZyWwx94h4e4aQI2LER8QFGVxOpohvi1gzSZjMFfFbcWwyh5kOAIoktgs4rHgRm4iYxA8OdBHxcgBwpLgvOOYLFnCyBOJDuaSkZvO5cfECui5Lj25qbc2ge3IykzgCgaE/k5XI5LPpLinJqUxeNgCLZ/4sGXFt6aIiW5paW1oamhmZflGo/7r4NyXu7SK9CvjcM4jW94ftr/xS6gBgzIpqs+sPW8x+ADq2AiB3/w+b5iEAJEV9a7/xxXlo4nmJFwhSbYyNMzMzjbgclpG4oL/rfzr8DX3xPSPxdr+Xh+7KiWUKkwR0cd1YKUkpQj49PZXJ4tAN/zzE/zjwr/NYGsiJ5fA5PFFEqGjKuLw4Ubt5bK6Am8Kjc3n/qYn/MOxPWpxrkSj1nwA1yghI3aAC5Oc+gKIQARJ5UNz13/vmgw8F4psXpjqxOPefBf37rnCJ+JHOjfsc5xIYTGcJ+RmLa+JrCdCAACQBFcgDFaABdIEhMANWwBY4AjewAviBYBAO1gIWiAfJgA8yQS7YDApAEdgF9oJKUAPqQSNoASdABzgNLoDL4Dq4Ce6AB2AEjIPnYAa8AfMQBGEhMkSB5CFVSAsygMwgBmQPuUE+UCAUDkVDcRAPEkK50BaoCCqFKqFaqBH6FjoFXYCuQgPQPWgUmoJ+hd7DCEyCqbAyrA0bwwzYCfaGg+E1cBycBufA+fBOuAKug4/B7fAF+Dp8Bx6Bn8OzCECICA1RQwwRBuKC+CERSCzCRzYghUg5Uoe0IF1IL3ILGUGmkXcoDIqCoqMMUbYoT1QIioVKQ21AFaMqUUdR7age1C3UKGoG9QlNRiuhDdA2aC/0KnQcOhNdgC5HN6Db0JfQd9Dj6DcYDIaG0cFYYTwx4ZgEzDpMMeYAphVzHjOAGcPMYrFYeawB1g7rh2ViBdgC7H7sMew57CB2HPsWR8Sp4sxw7rgIHA+XhyvHNeHO4gZxE7h5vBReC2+D98Oz8dn4Enw9vgt/Az+OnydIE3QIdoRgQgJhM6GC0EK4RHhIeEUkEtWJ1sQAIpe4iVhBPE68QhwlviPJkPRJLqRIkpC0k3SEdJ50j/SKTCZrkx3JEWQBeSe5kXyR/Jj8VoIiYSThJcGW2ChRJdEuMSjxQhIvqSXpJLlWMkeyXPKk5A3JaSm8lLaUixRTaoNUldQpqWGpWWmKtKm0n3SydLF0k/RV6UkZrIy2jJsMWyZf5rDMRZkxCkLRoLhQWJQtlHrKJco4FUPVoXpRE6hF1G+o/dQZWRnZZbKhslmyVbJnZEdoCE2b5kVLopXQTtCGaO+XKC9xWsJZsmNJy5LBJXNyinKOchy5QrlWuTty7+Xp8m7yifK75TvkHymgFPQVAhQyFQ4qXFKYVqQq2iqyFAsVTyjeV4KV9JUCldYpHVbqU5pVVlH2UE5V3q98UXlahabiqJKgUqZyVmVKlaJqr8pVLVM9p/qMLkt3oifRK+g99Bk1JTVPNaFarVq/2ry6jnqIep56q/ojDYIGQyNWo0yjW2NGU1XTVzNXs1nzvhZei6EVr7VPq1drTltHO0x7m3aH9qSOnI6XTo5Os85DXbKug26abp3ubT2MHkMvUe+A3k19WN9CP16/Sv+GAWxgacA1OGAwsBS91Hopb2nd0mFDkqGTYYZhs+GoEc3IxyjPqMPohbGmcYTxbuNe408mFiZJJvUmD0xlTFeY5pl2mf5qpm/GMqsyu21ONnc332jeaf5ymcEyzrKDy+5aUCx8LbZZdFt8tLSy5Fu2WE5ZaVpFW1VbDTOoDH9GMeOKNdra2Xqj9WnrdzaWNgKbEza/2BraJto22U4u11nOWV6/fMxO3Y5pV2s3Yk+3j7Y/ZD/ioObAdKhzeOKo4ch2bHCccNJzSnA65vTC2cSZ79zmPOdi47Le5bwr4urhWuja7ybjFuJW6fbYXd09zr3ZfcbDwmOdx3lPtKe3527PYS9lL5ZXo9fMCqsV61f0eJO8g7wrvZ/46Pvwfbp8Yd8Vvnt8H67UWslb2eEH/Lz89vg98tfxT/P/PgAT4B9QFfA00DQwN7A3iBIUFdQU9CbYObgk+EGIbogwpDtUMjQytDF0Lsw1rDRsZJXxqvWrrocrhHPDOyOwEaERDRGzq91W7109HmkRWRA5tEZnTdaaq2sV1iatPRMlGcWMOhmNjg6Lbor+wPRj1jFnY7xiqmNmWC6sfaznbEd2GXuKY8cp5UzE2sWWxk7G2cXtiZuKd4gvj5/munAruS8TPBNqEuYS/RKPJC4khSW1JuOSo5NP8WR4ibyeFJWUrJSBVIPUgtSRNJu0vWkzfG9+QzqUvia9U0AV/Uz1CXWFW4WjGfYZVRlvM0MzT2ZJZ/Gy+rL1s3dkT+S453y9DrWOta47Vy13c+7oeqf1tRugDTEbujdqbMzfOL7JY9PRzYTNiZt/yDPJK817vSVsS1e+cv6m/LGtHlubCyQK+AXD22y31WxHbedu799hvmP/jk+F7MJrRSZF5UUfilnF174y/ariq4WdsTv7SyxLDu7C7OLtGtrtsPtoqXRpTunYHt897WX0ssKy13uj9l4tX1Zes4+wT7hvpMKnonO/5v5d+z9UxlfeqXKuaq1Wqt5RPXeAfWDwoOPBlhrlmqKa94e4h+7WetS212nXlR/GHM44/LQ+tL73a8bXjQ0KDUUNH4/wjowcDTza02jV2Nik1FTSDDcLm6eORR67+Y3rN50thi21rbTWouPguPD4s2+jvx064X2i+yTjZMt3Wt9Vt1HaCtuh9uz2mY74jpHO8M6BUytOdXfZdrV9b/T9kdNqp6vOyJ4pOUs4m3924VzOudnzqeenL8RdGOuO6n5wcdXF2z0BPf2XvC9duex++WKvU++5K3ZXTl+1uXrqGuNax3XL6+19Fn1tP1j80NZv2d9+w+pG503rm10DywfODjoMXrjleuvyba/b1++svDMwFDJ0dzhyeOQu++7kvaR7L+9n3J9/sOkh+mHhI6lH5Y+VHtf9qPdj64jlyJlR19G+J0FPHoyxxp7/lP7Th/H8p+Sn5ROqE42TZpOnp9ynbj5b/Wz8eerz+emCn6V/rn6h++K7Xxx/6ZtZNTP+kv9y4dfiV/Kvjrxe9rp71n/28ZvkN/NzhW/l3x59x3jX+z7s/cR85gfsh4qPeh+7Pnl/eriQvLDwG/eE8/s3BCkeAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAwUlEQVRYR+3TMQrDMBSDYaf36Jqt9+/YtXO3rjlIiksEHmNb0iPwfgjx+CHs5fl67+Ui3Y7/JUqsqsSqSqyqxKoaxn6+23HyNbVsBTvRlGvgAtPurGNl+gNToulYpEDLsIgJlmNrrJUtWDSLtmLRKDoEi3rBodhaz8rh2Md6/39nCsWeRaIQbM+abVbsKBJZsLNIJMcykEiGZa3ZRscqkIiGVSIRBatGoimsY822YawTiegPTFliVSVWVWJVJVZTKT9+mj+W9aIALAAAAABJRU5ErkJggg=="

/***/ }),

/***/ 909:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dfg_logo_schriftzug_blau_foerderung_4c.ce34580.jpg";

/***/ }),

/***/ 910:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dfg_logo_schriftzug_blau_foerderung_4c.92dcd68.png";

/***/ }),

/***/ 911:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAL6SURBVGhD7Zm5i9VQFMYjKgqKiriAoIKVjWDhBnbaOY1L57512lkpWqiIjVPIMGIrY+c/ILbi0qidWiqIChZqKbh9v7x34BASs92b9yLvgx+Te/OSe7+5S05OkokmaqyDYvfgsL86JH6I72ITFX0UI4GJP2Kaij6qyMQR0ZtpVmTiqPgpmGYbqOhai8T8wWGp/jUSmKD+KhVdabW4Jd4LGv8lXorzYqHI09iZ2CE+ChoGOvfblR+LVcJr7EzsFN8EDT8S2wUjsEzsF+8E514JMzN2Jui0mbgv8tbFWvFamJmzYqQmtogbYnlaSpJtosyEyZsxRjYStwUNPRN7xddhucyEyZv5ImyadT6d1om3ggaNqiZM2Wl2TnRiYqu4KzCBvBlGZKWoq7xpFn0kbgoaovN5Zp4LWzN15M18EtmtObjoJGsithm/NUfTHkFjXZhpco9KYou13cn+xjTzgIrQIuzwzwkWNp2NYWa9IMLlHvzzgmmXyHvY0clYZmYE119PSwGUHYnscyKWmTOCa++lpZZaIz6LIhOmGGYuCa67k5ZaiviHmz0UZU/skGbmiSeCa05Q0VYfBDcjNK+iKmZ4DpWZuSj4LbNhCRVttFhwM0Lsoje6PLU1c0HwG2KufVS01QLB6ylvdrwU1VFTM97EKSpC6YXgxgfSUj3VNeNNBFkXXiQKuDmvpzxx64pOlsVmnL8yPMbEMRFcrA0SBTRC2BDLjJngpSqaiEIJ4GKbeSNsmkVTV2aeCpJ5UWUhQ2wzJDWiyeedSBS0MXNZcH3WzAoRNNLNKps8azPN/BbLmjAz0ddGUQbQtuU6ZrwJsup+mlUNgRqpShrTIuMyM97EcSqGIgzaPDiMo6q52Ow02yi8iGItHOe6k6IzVTVh8mZ4AZsVpwUG2E6pJ2YLGjuVqa4JE0EliQLOZyFPNSU6k309pfE6JrzIxl8Tc4KRYT0sFZ2p6UiMnfhKSvql1yZM/mN8b014HRa9N4FsmvXahGkkH+Mn+j+UJH8BToCCMdTmL6wAAAAASUVORK5CYII="

/***/ }),

/***/ 912:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAANzSURBVGhD1Zo9SytBFIYnESwU1MoYsVcUQSsV/A9Bsc1fEGwTsBNrsRU/UydijFWso7GRFFra+gFBQfws5s679+y9iZndmdmdlewDB3fWMec87s7s7JAEF7CYkUgk6Og/SfoZC25ubqQSIDYilUqFzc7OUksCbq1u5/T0lPf29mIIeAf17VrK5bJaAkH9u5KTkxMtCdC1IjoSGxsb1PsXRd7e3vj39ze1/Dk+PjaSAJGKPDw88LW1NT42NuYkF1Mnn5mZ4dvb2/zr64t6tRNEAkQmcnl5yUdGRqSFIBYXF/nT0xP1/kupVAokASIRubi44IODg9JCWgNXx5UpFouBJYB1kXq9riXhBmR2dnZCSYBQIo1Gg+dyOf78/Oy0r66ujCR0QyUBAosgwerqqvNzfn6eV6tVPjQ01FaAjdCRAIFEWhONj4+3tW2GrgQwFrm+vu5IGIWMiQQwFllfX5cmthnDw8POM8gEYxEMbIwJJIzytpqcnDSSCTRGzs/Ppcltx9TU1L8ZUYWxCKZY1exk80qtrKxQZn+MRLDs0H1O2JTBP0+FtkitVjN+2NmSyefzVIU3WiImVyKKyGazVIk3ys2Hx8dHlslk2MvLC535ffr6+ujIG6XI5uYmu7+/p1ZwxG1GR+YsLCzQkQ90ZTwZHR2VXu4gEWTMpFIp/vr6StV44yuC11PZh4cJE5menh5eqVSoGn98RfA6KksQNnRkILG7u0uVqFHeWtPT09JEYcNPBhL7+/tUgR5Kka2tLWkyGyGTgcTh4SFl10cp8vn5yefm5joSRhGQKBQKlNkMpQgQzxJnNSpLbjMmJia0F4k/0RIBWFLblPEaI+KZwT8+PiirPtoi4ODgQJo8aPyUcdvY1DBFWwTzuWrLxkborHRlaIlEIYGBjTHRei4Myr+OSuLo6KjttRm7k2HwFdGRwFpIdt4rIIGx5vL+/s5vb2+pFRxPER0JbNmYzGaQ2Nvbowx2kYroSrjoyCSTSaO1kykdIqYSLs1mk4sXMGn/dDrtfG6UtH1h4OzsjC0tLTGx6qUznQgJlsvlqNVJvV5n5XKZ3d3dsYGBAeelaHl5mfX391OPiHB0BEGvRLfgiKDIOEsAUaO88Nbodgkg6pQX70YcJICoVS6AiIsEEPXGXwLgO0MovAPxOzqKB9INurhJMMbYH1N/v9StrnJDAAAAAElFTkSuQmCC"

/***/ }),

/***/ 913:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABISURBVEhL7cyxCQAADAJB91866W1ugOTA6sG826bW1EkH6qQDddKBOulAnXSgTjpQJx2okw7USQfqpAN10oE66UCddKD+bkgWwiZvkelZ0CwAAAAASUVORK5CYII="

/***/ }),

/***/ 914:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAABuwAAAbsBOuzj4gAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAEJSURBVEiJ7ZK9SsRAFIXPiDGFYL2llS9g5ztY+Qy5EwJZFB/AYKOgjWRTmJ/GtGvnI4iFYGej2FmksrBYwkC412obWXZ2dkm1+7X33PPNhQE2rDdENA7DcH+Vji3L/ISZP4noLo7jvT4EAOABGBpjPrTWlCTJIjtOgikDEblvmuY1CIKjPgQAABE5VEo9E9FDFEUDW17NGxKRWPYnAG59379K09TMCjhf8I9dABfGmHet9XEfginbzLzTh+BXRE4BHBRF8TjTvGQxAxh5nneZZdnPvOAyghdmHpZl+bZI2EXwDeA8z/MxANvvchIYANdt297UdT1xeJBdoJR66rrurKqqL9fiDWvEHwSaV4CutlgsAAAAAElFTkSuQmCC"

/***/ }),

/***/ 915:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lg.ajax-spinner-preloader.344f3a2.gif";

/***/ }),

/***/ 916:
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,R0lGODlhEAAQAPIAAP///0G5zNHt8nLK2EG5zInT36Hc5a3g6CH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="

/***/ }),

/***/ 917:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 918:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 919:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/schallplatten.91d24b3.png";

/***/ }),

/***/ 920:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 921:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sprengel_museum_logo_lay.a44d389.png";

/***/ }),

/***/ 922:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/uni-wuppertal_logo_grau.b341c3a.png";

/***/ }),

/***/ 923:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1564)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(938),
  /* template */
  __webpack_require__(1952),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 924:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(952),
  /* template */
  __webpack_require__(1983),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 925:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1599)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(955),
  /* template */
  __webpack_require__(1989),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 926:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1596)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(976),
  /* template */
  __webpack_require__(1986),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 928:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(1910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_css_animate_min_css__ = __webpack_require__(1562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_css_animate_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_css_animate_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vendor_openseadragon_openseadragon_min__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vendor_midi_js__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_mixin_plugin__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_js_modal__ = __webpack_require__(1909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_comps_g_plugin__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_v_tooltip__ = __webpack_require__(1907);









__WEBPACK_IMPORTED_MODULE_6__vendor_midi_js__["MIDI"].loadPlugin({
  soundfontUrl: "./static/soundfont/",
  instrument: "acoustic_grand_piano",
  onsuccess: function onsuccess() {}
});


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7__utils_mixin_plugin__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_js_modal___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_comps_g_plugin__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_v_tooltip__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (to.name === 'texte-modus' || to.name === 'werbe-modus') {
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit("updateModusDataByUrl", to);
  }
  next();
});

__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.eventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();
document.addEventListener('keydown', function (event) {
  __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.eventBus.$emit('keydown', event);
});

__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('setOSDToolTips', OpenSeadragon);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_3__App___default.a
  }
});

/***/ }),

/***/ 930:
/***/ (function(module, exports) {

module.exports = {"AppVersion":"1.0.0","APIBaseUrl":"http://chost22.zim.uni-wuppertal.de/fudapi/api/schwitters/","accesToken":"Bearer fgNbt60U9R7TbbEgqmi55BO4mb8Um1Xb0UpSbUw9"}

/***/ }),

/***/ 935:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_Head_vue__ = __webpack_require__(1931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_Head_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_Head_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Footer_vue__ = __webpack_require__(1930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_Footer_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    "header-view": __WEBPACK_IMPORTED_MODULE_0__views_Head_vue___default.a,
    "footer-view": __WEBPACK_IMPORTED_MODULE_1__views_Footer_vue___default.a
  },
  mounted: function mounted() {
    this.$store.dispatch("fetchMerzAndPersonData");
    this.$store.dispatch("fetchBibliographie");
    var ieVer = this.detectIE();
    if (ieVer && ieVer < 12) {
      this.$modal.show("ieModal");
    }
  },
  methods: {
    detectIE: function detectIE() {
      var ua = window.navigator.userAgent;

      var msie = ua.indexOf("MSIE ");
      if (msie > 0) {
        return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
      }

      var trident = ua.indexOf("Trident/");
      if (trident > 0) {
        var rv = ua.indexOf("rv:");
        return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
      }

      var edge = ua.indexOf("Edge/");
      if (edge > 0) {
        return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
      }

      return false;
    }
  }
});

/***/ }),

/***/ 936:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_openseadragon_canvasOverlay__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operators__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(216);





__webpack_require__(1000);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    seiten: {
      type: Array
    },
    seiteIdx: {
      type: Number
    },
    modusOption: {
      type: Object
    }
  },
  data: function data() {
    return {
      stopDobbledrawTranscripts: false,
      inChangingMerz: false,
      openedSeite: null,
      accordionidTranscriptMap: null,
      transcripts: [],
      mouseRelatedTranscriptIDs: null,
      mouseTargetAccoItems: [],
      mouseTargetTranscripts: null,
      markedTranscriptList: [],
      markedTranscripts: [],
      zIndex: 2000
    };
  },

  watch: {
    seiten: function seiten() {
      if (this.viewer) {
        this.inChangingMerz = true;
        this.viewer.clearOverlays();
        if (this.$svgRootG) {
          this.$svgRootG.selectAll("*").remove();
        }
        this.viewer.drawer.clear();
        var seite = this.seite;
        var idx = 0;
        if (seite && seite.idx) {
          idx = seite.idx;
        }
        this.viewer.open(this.tiles);
        this.viewer.goToPage(idx);
      }
    },
    seite: function seite(_seite, oldSeite) {
      if (!_seite) {
        return;
      }

      if (this.inChangingMerz) {
        this.inChangingMerz = false;
        return;
      }
      if (this.viewer) {
        this.viewer.clearOverlays();
      }
      if (this.stopDobbledrawTranscripts) {
        this.stopDobbledrawTranscripts = false;
        return;
      }

      this._openPage(_seite.idx);
    },
    checkedTranscriptIDs: function checkedTranscriptIDs(ids) {
      var data = this._getTranscriptByIDs(ids);
      this._drawCanvasOverlayers(this.canvasoverlay_checked, data);
    },
    mouseTargetAccoItems: function mouseTargetAccoItems(data) {
      if (this.isKomposition) {
        return;
      }
      this.$store.state.eventBus.$emit(["mouseover.transcripts", this.modusOption.viewKey, this.modusOption.key].join("-"), data);
    },
    mouseRelatedTranscriptIDs: function mouseRelatedTranscriptIDs(ids) {
      if (this.isKomposition) {
        return;
      }
      var data = this._getTranscriptByIDs(ids);
      this._drawCanvasOverlayers(this.canvasoverlay_mouseover, data);
    },
    markedTranscriptList: function markedTranscriptList(list) {
      var ids = [];
      this.markedTranscriptList.forEach(function (arr) {
        ids = ids.concat(arr);
      });
      var data = this._getTranscriptByIDs(ids);
      this.markedTranscripts = data;
      this._drawCanvasOverlayers(this.canvasoverlay_marked, data);
    },
    transparenz: function transparenz(val) {
      if (this.modusOption.key === "untersuchung") {
        this._setTransparent();
      }
    },
    checkedTranscriptKategorieMap: function checkedTranscriptKategorieMap(a) {
      this._drawColorRect();
      this._setPopupBox(a);
    }
  },

  mounted: function mounted() {
    var vue = this;
    var opt = this.modusOption;
    this.$store.state.eventBus.$on(["mouseover.sidebar", opt.viewKey, opt.key].join("-"), function (ids) {
      vue._drawCanvasOverlayers(vue.canvasoverlay_mouseover, vue._getTranscriptByIDs(ids));
    });
    this.$store.state.eventBus.$on(["marknote.sidebar", opt.viewKey, opt.key].join("-"), function (ids) {
      vue._drawCanvasOverlayers(vue.canvasoverlay_checked, vue._getTranscriptByIDs(ids));
    });
    this.$store.state.eventBus.$on("keydown", function (event) {
      if (event.ctrlKey) {
        if (event.keyCode === 39) {
          var idx = vue.seiteIdx;
          if (idx < vue.seiten.length - 1) {
            vue.$emit("changePage", idx + 1);
          }
        } else if (event.keyCode === 37) {
          var _idx = vue.seiteIdx;
          if (_idx > 0) {
            vue.$emit("changePage", _idx - 1);
          }
        }
      }
    });

    this.$store.state.eventBus.$on(["mouseclick.sidebar", opt.viewKey, opt.key].join("-"), function (ids) {
      var trs = ids.split(",");
      vue._updatemarkedTranscriptList(trs, trs);
    });

    this._initViewer();
  },

  computed: {
    noFacimilie: function noFacimilie() {
      var merzId = this.$route.query.merzId;
      if (merzId === "Merz22") {
        return this.$_getIcon("merz22.png");
      } else if (merzId === "Merz23") {
        return this.$_getIcon("merz23.png");
      }
    },
    OSDTooltips: function OSDTooltips() {
      return this.$store.state["OSDTooltips"];
    },
    checkedTranscriptAccordionIDs: function checkedTranscriptAccordionIDs() {
      var out = [];
      this.modusOption.accordionList.forEach(function (item) {
        if (item.transcriptButtonChecked) {
          out.push(item.id);
        }
      });
      return out;
    },
    checkedKategorieAccordionIDs: function checkedKategorieAccordionIDs() {
      var out = [];
      this.modusOption.accordionList.forEach(function (item) {
        if (item.kategorieButtonChecked) {
          out.push(item.id);
        }
      });
      return out;
    },
    checkedTranscriptIDs: function checkedTranscriptIDs() {
      var map = this.accordionidTranscriptMap;
      if (!map) {
        return;
      }
      var out = [];
      this.checkedTranscriptAccordionIDs.forEach(function (c) {
        var group = map[c];
        if (group) {
          group.forEach(function (item) {
            out = out.concat(item.ids);
          });
        }
      });
      return out;
    },
    checkedTranscriptKategorieMap: function checkedTranscriptKategorieMap() {
      var map = this.accordionidTranscriptMap;
      if (!map) {
        return;
      }
      var out = {};
      var accoIds = this.checkedKategorieAccordionIDs;
      var list = [];
      var allTrs = this.transcripts;

      var idsObj = {};
      accoIds.forEach(function (ac) {
        var items = map[ac];
        if (items) {
          items.forEach(function (item, i) {
            var ids = item.ids;
            if (ids.length < 1) {
              return;
            }
            var trs = allTrs.filter(function (tr) {
              return ids.indexOf(tr.id) > -1;
            });
            trs.sort(function (a, b) {
              return a.x * a.x + a.y * a.y - (b.x * b.x + b.y * b.y);
            });
            ids.forEach(function (id) {
              idsObj[id] = true;
            });

            out[trs[0].id] = {
              accoItems: [{
                acco: ac,
                accoItemIdx: i,
                first: true
              }],
              data: trs[0]
            };

            list.push({
              acco: ac,
              ids: ids,
              trs: trs,
              accoItemIdx: i
            });
          });
        }
      });

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(idsObj).forEach(function (id) {
        list.forEach(function (li, i) {
          var acco = li.acco,
              ids = li.ids,
              trs = li.trs,
              accoItemIdx = li.accoItemIdx;

          var outItem = out[id];
          if (ids.indexOf(id) < 0) {
            return;
          }

          if (outItem) {
            if (outItem.data === null) {
              outItem.data = trs.find(function (tr) {
                return tr.id === id;
              });
            }
            var has = outItem.accoItems.find(function (oi) {
              return oi.acco === acco && accoItemIdx === accoItemIdx;
            });
            if (has) {
              return;
            } else {
              outItem.accoItems.push({
                acco: acco,
                accoItemIdx: accoItemIdx
              });
            }
          } else {
            return;

            out[id] = {
              accoItems: [{
                acco: acco,
                accoItemIdx: accoItemIdx,
                first: true
              }],
              data: null
            };
          }
        });
      });

      var out2 = {};
      for (var id in out) {
        if (out[id].data !== null) {
          out2[id] = out[id];
        }
      }

      return out2;
    },
    seite: function seite() {
      if (this.seiteIdx != undefined && this.seiten) {
        return this.seiten[this.seiteIdx];
      }
    },
    docs: function docs() {
      if (!this.seite) {
        return;
      }
      return this.seite.$_docInfo;
    },
    tiles: function tiles() {
      if (!this.seiten) {
        return;
      }
      return this.seiten.map(function (d) {
        return d.deepSrc;
      });
    },
    containerId: function containerId() {
      return this.$_getRandomId();
    },
    transparenz: function transparenz() {
      var t = this.modusOption.transparenz;
      return t !== undefined ? t / 100 : 1;
    },
    isUntersuchung: function isUntersuchung() {
      return this.modusOption.key === "untersuchung";
    },
    isKomposition: function isKomposition() {
      return this.modusOption.key === "komposition";
    }
  },

  methods: {
    stopDblClick: function stopDblClick(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    _removeAllDraggableElement: function _removeAllDraggableElement() {
      var divs = document.body.querySelectorAll(".ksm-komposition__draggable-div");
      if (divs) {
        [].forEach.call(divs, function (d) {
          document.body.removeChild(d);
        });
      }
    },
    _createDraggableDiv: function _createDraggableDiv(div, ctx, x, y, w, h, trID) {
      var bound = div.getBoundingClientRect();
      var dragDiv = document.createElement("div");
      dragDiv.className = "ksm-komposition__draggable-div";
      dragDiv.setAttribute("data-trid", trID);
      dragDiv.style.left = bound.left + "px";
      dragDiv.style.top = bound.top + "px";
      dragDiv.style.width = bound.width + "px";
      dragDiv.style.height = bound.height + "px";
      dragDiv.classList.add("dragging");
      var imgData = ctx.getImageData(x, y, w, h);
      var imgCanvas = document.createElement("canvas");
      imgCanvas.setAttribute("id", "_temp_canvas");
      imgCanvas.width = w;
      imgCanvas.height = h;
      imgCanvas.getContext("2d").putImageData(imgData, 0, 0);
      dragDiv.appendChild(imgCanvas);
      document.body.appendChild(dragDiv);
      return dragDiv;
    },
    _drawDraggleTranscripts: function _drawDraggleTranscripts(trs) {
      var viewer = this.viewer;
      viewer.clearOverlays();
      var _drag = document.body.querySelector(".ksm-komposition__draggable-div.dragging");
      if (_drag) {}

      if (!trs) {
        return;
      }

      var vue = this;
      var viewport = viewer.viewport;
      var ctx = viewer.drawer.context;

      trs.forEach(function (tr) {
        var pos = viewport.imageToViewerElementCoordinates(new OpenSeadragon.Point(tr.x, tr.y));
        var viewportZoom = viewport.getZoom(true);
        var rotate = viewport.getRotation();
        var image1 = viewer.world.getItemAt(0);
        var zoom = image1.viewportToImageZoom(viewportZoom);

        var _ref = [Number(pos.x), Number(pos.y), tr.w * zoom, tr.h * zoom],
            x = _ref[0],
            y = _ref[1],
            w = _ref[2],
            h = _ref[3];


        if (x < 0 || y < 0 || w <= 0 || h <= 0) {
          return;
        }
        var div = document.createElement("div");
        div.className = "ksm-komposition__focus-transcript";
        var trID = tr.id;
        new OpenSeadragon.MouseTracker({
          element: div,
          moveHandler: function moveHandler(e) {
            var dragDiv = document.body.querySelector(".ksm-komposition__draggable-div.dragging");

            if (dragDiv && this.userData) {
              var left = e.originalEvent.clientX - this.userData.startPoint.x + "px";
              var top = e.originalEvent.clientY - this.userData.startPoint.y + "px";
              __WEBPACK_IMPORTED_MODULE_4_d3__["a" /* select */](dragDiv).style("left", left).style("top", top);
            }
          },
          clickHandler: function clickHandler(e) {
            if (e.originalEvent.ctrlKey) {
              return;
              vue._removeAllDraggableElement();
              var dragDiv = vue._createDraggableDiv(div, ctx, x, y, w, h, trID);
              dragDiv.classList.add("ksm-komposition__fly-div");
              vue.$emit("eventFromOSDViewer", {
                type: "transcript-double-click",
                data: trs,
                dragDiv: dragDiv
              });

              e.preventDefaultAction = true;
              e.originalEvent.stopPropagation();
              e.originalEvent.preventDefault();
            }
          },
          dblClickHandler: function dblClickHandler(e) {
            return;
            vue._removeAllDraggableElement();
            var dragDiv = vue._createDraggableDiv(div, ctx, x, y, w, h, trID);
            dragDiv.classList.add("ksm-komposition__fly-div");
            vue.$emit("eventFromOSDViewer", {
              type: "transcript-double-click",
              data: trs,
              dragDiv: dragDiv
            });

            e.preventDefaultAction = true;
            e.originalEvent.stopPropagation();
            e.originalEvent.preventDefault();
          },
          dragHandler: function dragHandler(e) {
            if (this.userData) {
              return;
            }
            this.userData = {
              startPoint: e.position
            };
            var dragDiv = vue._createDraggableDiv(div, ctx, x, y, w, h, trID);
          },
          releaseHandler: function releaseHandler(e) {
            this.userData = null;

            var dragDiv = document.body.querySelector(".ksm-komposition__draggable-div");
            dragDiv && vue.$emit("eventFromOSDViewer", {
              type: "dragTranscriptElementEnd",
              div: dragDiv,
              event: e.originalEvent
            });
          },
          dragEndHandler: function dragEndHandler(e) {
            this.userData = null;
            var dragDiv = document.body.querySelector(".ksm-komposition__draggable-div");

            dragDiv && vue.$emit("eventFromOSDViewer", {
              type: "dragEnd",
              div: dragDiv,
              event: e.originalEvent
            });
          }
        }).setTracking(true);

        viewer.addOverlay({
          element: div,
          px: tr.x,
          py: tr.y,
          width: tr.w,
          height: tr.h
        });
      });
    },
    _getTranscriptByIDs: function _getTranscriptByIDs(ids) {
      if (!this.transcripts || !ids) {
        return;
      }

      return this.transcripts.filter(function (tr) {
        return ids.indexOf(tr.id) > -1;
      });
    },
    _getTargetAccoItems: function _getTargetAccoItems(id) {
      var map = this.accordionidTranscriptMap;
      if (!map) {
        return;
      }
      var out = [];

      var _loop = function _loop(k) {
        var accoItems = map[k];
        accoItems.forEach(function (item) {
          if (item.ids.indexOf(id) > -1) {
            out.push({
              accoID: k,
              accoItemIdx: item.ID,
              ids: item.ids
            });
          }
        });
      };

      for (var k in map) {
        _loop(k);
      }
      return out;
    },
    _getRelatedTranscriptIDs: function _getRelatedTranscriptIDs(id) {
      var out = [];
      this.mouseTargetAccoItems.forEach(function (item) {
        out = out.concat(item.ids);
      });
      return out;
    },
    updateDataForCurrentView: function updateDataForCurrentView(seite) {
      var currentMap = {};
      var idList = [];
      var map = seite.$_accoId_transcript_mapping;
      if (map) {
        this.modusOption.accordionList.forEach(function (accordion) {
          var trs = [];
          accordion.fudkeys.forEach(function (k) {
            var arr = map[k];
            if (arr) {
              trs = trs.concat(arr);
              arr.forEach(function (ar) {
                idList = idList.concat(ar.ids);
              });
            }
          });
          currentMap[accordion.id] = trs;
        });
      }
      var _filterTranscripts = [];
      if (this.isKomposition || this.modusOption.key === "simple") {
        seite.$_allTranscripts.forEach(function (it) {
          _filterTranscripts = _filterTranscripts.concat(it.transcripts);
        });
      } else {
        seite.$_allTranscripts.forEach(function (it) {
          var tmp = it.transcripts.filter(function (tr) {
            return idList.indexOf(tr.id) > -1;
          });
          _filterTranscripts = _filterTranscripts.concat(tmp);
        });
      }
      this.transcripts = _filterTranscripts;
      this.accordionidTranscriptMap = currentMap;
      this.markedTranscriptList = [];
    },
    _setTransparent: function _setTransparent() {
      this._drawCanvasOverlayers(this.canvasoverlay_marked, this.markedTranscripts);
    },
    _isPointInTranscript: function _isPointInTranscript(tr, imagePoint) {
      var x = tr.x,
          y = tr.y,
          w = tr.w,
          h = tr.h;

      return imagePoint.x >= x && imagePoint.x <= x + w && imagePoint.y >= y && imagePoint.y <= y + h;
    },
    _openPage: function _openPage(idx) {
      var vue = this;
      setTimeout(function () {
        vue.viewer.goToPage(idx);
      }, 300);
    },
    _getTranscriptsUnderMouse: function _getTranscriptsUnderMouse(pos) {
      if (!pos) {
        return;
      }
      var viewport = this.viewer.viewport;
      var imagePoint = viewport.viewportToImageCoordinates(viewport.pointFromPixel(pos));
      var _isPointInTranscript = this._isPointInTranscript;
      var trs = this.transcripts.filter(function (tr) {
        return _isPointInTranscript(tr, imagePoint);
      });
      if (trs && trs.length > 1) {
        trs.sort(function (a, b) {
          return a.x < b.x && a.y < b.y && a.x + a.w > b.x + b.w && a.y + a.h > b.y + b.h;
        });
        return [trs[0]];
      }
      return trs;
    },
    _canvasClick: function _canvasClick(event) {
      var vue = this;
      if (!vue.isUntersuchung && vue.modusOption.key !== "vergleich" && vue.modusOption.key !== "b_vergleich") {
        return;
      }

      var popup = this.$el.querySelector(".ksm-deepzoom__popupmenu-overlay");
      var target = event.originalEvent.target;
      if (target.classList.contains("kategorie-rect")) {
        if (popup) {
          this.viewer.removeOverlay(popup);
        }
        return vue._createMenu(event);
      } else if (target.classList.contains("ksm-deepzoom__popup-menuitem")) {
        if (popup) {
          this.viewer.removeOverlay(popup);
        }
        var menuItem = target;
        return vue._openInfoBox({
          gummiID: menuItem.getAttribute("data-gummi-id"),
          accoID: menuItem.getAttribute("data-acco-id"),
          accoItemIdx: menuItem.getAttribute("data-accoitem-idx")
        }, event);
      } else {
        while (target) {
          if (target.classList && target.classList.contains("ksm-deepzoom__popupmenu-overlay")) {
            return;
          }
          target = target.parentNode;
        }
      }

      if (popup) {
        this.viewer.removeOverlay(popup);
      }

      var relatedIDs = vue.mouseRelatedTranscriptIDs;
      vue.$store.state.eventBus.$emit(["mouseclick.transcripts", vue.modusOption.viewKey, vue.modusOption.key].join("-"), relatedIDs);

      var targetTrs = this.mouseTargetTranscripts;
      var targetTrIDs = targetTrs ? targetTrs.map(function (tr) {
        return tr.id;
      }) : [];
      this._updatemarkedTranscriptList(targetTrIDs, relatedIDs);
    },
    _updatemarkedTranscriptList: function _updatemarkedTranscriptList(targetTrIDs, relatedIDs) {
      var vue = this;
      var markedTranscriptList = vue.markedTranscriptList;
      var makeMark = true;
      if (targetTrIDs) {
        markedTranscriptList.forEach(function (arr, i) {
          targetTrIDs.forEach(function (tr_id) {
            if (arr.indexOf(tr_id) > -1) {
              markedTranscriptList.splice(i, 1);
              makeMark = false;
            }
          });
        });
      }

      if (makeMark) {
        markedTranscriptList.push(relatedIDs);
      }
    },
    _drawColorRect: function _drawColorRect() {
      var _this = this;

      var map = this.checkedTranscriptKategorieMap;
      var vue = this;
      var viewer = this.viewer;
      var currentOverlays = this.viewer.currentOverlays;
      var list = this.$el.querySelectorAll(".ksm-gummi__start-overlay");
      list.forEach(function (el) {
        _this.viewer.removeOverlay(el);
      });
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(map).forEach(function (trID) {
        var tr = map[trID].data;
        var el = document.createElement("div");
        el.setAttribute("data-tr-id", trID);
        el.className = "ksm-gummi__start-overlay";
        vue._drawOneColorRect(el, tr, map[trID].accoItems);
      });
    },
    _createInfoBox: function _createInfoBox(infoFensterData, event) {
      var _this2 = this;

      var gummiID = infoFensterData.gummiID,
          accoItemIdx = infoFensterData.accoItemIdx,
          accoID = infoFensterData.accoID;

      var vue = this;
      var viewer = this.viewer;

      var viewport = viewer.viewport;
      var trID = gummiID.split("#")[1];
      var accordion = vue.modusOption.accordionList.find(function (ac) {
        return ac.id === accoID;
      });

      var start_overlay = this.$el.querySelector('.ksm-gummi__start-overlay[data-tr-id="' + trID + '"]');
      if (!start_overlay) {
        return;
      }

      var fudkeys = accordion.fudkeys;

      var obj = vue.accordionidTranscriptMap[accoID].find(function (obj, idx) {
        return obj.ids.indexOf(trID) > -1 && Number(accoItemIdx) === Number(idx);
      });

      var innerHTML = "";
      if (accoID === "acco_personen" || accoID === "acco_orte") {
        var pers = vue.$store.getters["modus/getSeiteDataExtendInfo"](vue.seite, accoID.replace("acco_", ""));
        if (!pers) {
          return;
        }
        pers.forEach(function (p) {
          if (p.transcripts && p.transcripts.length > 0) {
            p.$_html = '<span style="border:1px solid transparent; padding:2px; margin:2px" class="div-with-transcript" data-transcript="';
            p.$_html += p.transcripts.join(",");
            p.$_html += '">' + p.content + "</span>";
            if (p.transcripts.indexOf(gummiID.split("#")[1]) > -1) {
              innerHTML = p.$_html;
            }
          } else {
            p.$html = p.content;
          }
        });
      } else {
        this.seite.$_docInfo.forEach(function (doc) {
          var notes = doc._source.notes;
          notes && notes.filter(function (n) {
            return fudkeys.indexOf(n.category) > -1 && Number(n.ID) === Number(obj.ID);
          }).forEach(function (n) {
            var cat = n.category;
            var div = _this2.$_getNewHtmlElement(n.html, vue.merz, doc, true);
            div.classList.add("ksm-accordion__section");
            innerHTML = div.innerHTML;
          });
        });
      }

      var template = vue.$refs["infobox_template"];
      var infobox = template.cloneNode(true);
      this.zIndex++;
      infobox.style.zIndex = this.zIndex;

      infobox.setAttribute("data-gummi-id", gummiID);
      infobox.setAttribute("data-accoid", accoID);
      infobox.querySelector(".__close-infobox").addEventListener("click", function () {
        viewer.removeOverlay(infobox);
        var line = vue.$el.querySelector('.ksm-gummi__line[data-gummi-id="' + gummiID + '"]');
        __WEBPACK_IMPORTED_MODULE_4_d3__["a" /* select */](line).remove();
      });
      infobox.querySelector(".__title").innerHTML = '<div class="ksm-deepzoom__popupmenu__color-rect ' + accoID + ' _bg"></div><div>' + accordion.label + "</div>";
      infobox.querySelector(".__body").innerHTML = innerHTML;
      new OpenSeadragon.MouseTracker({
        element: infobox,
        clickHandler: function clickHandler(e) {
          var _target = e.originalEvent.target;
          if (_target.tagName.toLowerCase() !== "a") {
            _target = _target.closest("a");
          }

          if (_target && _target.getAttribute("href")) {
            vue.$router.push({
              path: _target.getAttribute("href").replace("#/", "/")
            });
          }
        },
        pressHandler: function pressHandler(e) {
          var infoBoxs = vue.$el.querySelectorAll(".ksm-gummi__end-overlay.dragging");
          if (infoBoxs) {
            infoBoxs.forEach(function (ib) {
              if (ib !== infobox) {
                ib.classList.remove("dragging");
              }
            });
          }
          infobox.classList.add("dragging");
          vue.zIndex++;
          infobox.style.zIndex = vue.zIndex;

          var line = vue.$el.querySelector('.ksm-gummi__line[data-gummi-id="' + gummiID + '"]');
          var lines = vue.$el.querySelectorAll(".ksm-gummi__line.dragging");
          if (lines) {
            lines.forEach(function (l) {
              if (l !== line) {
                l.classList.remove("dragging");
              }
            });
          }

          line.classList.add("dragging");
          this.userData = {
            startPoint: viewport.pointFromPixel(e.position)
          };
        },

        dragHandler: function dragHandler(e) {
          var pointFromPixel = viewport.pointFromPixel(e.position);
          var ol = viewer.getOverlayById(infobox);
          var bounds = ol.getBounds(viewport);
          var newPoint = new OpenSeadragon.Point(bounds.x + pointFromPixel.x - this.userData.startPoint.x, bounds.y + pointFromPixel.y - this.userData.startPoint.y);
          viewer.updateOverlay(infobox, newPoint);
          vue._resetLineEnd(infobox);
          infoFensterData.position = {
            x: newPoint.x,
            y: newPoint.y
          };
        }
      }).setTracking(true);

      if (infoFensterData.position === undefined) {
        var containerSize = viewport.containerSize;
        var imageSize = viewer.world.getItemAt(0).getContentSize();
        var imagePoint = viewport.viewportToImageCoordinates(viewport.pointFromPixel(event.position, false));

        var infoBoxs = vue.$el.querySelectorAll(".ksm-gummi__end-overlay");
        var len = infoBoxs ? infoBoxs.length + 1 : 1;
        var initPixel = void 0;
        if (imageSize.x / 2 < imagePoint.x) {
          initPixel = new OpenSeadragon.Point(containerSize.x - 10 * len - 200, 10 * len);
        } else {
          initPixel = new OpenSeadragon.Point(10 * len, 10 * len);
        }
        initPixel.y = event.position.y - 10;
        var point = viewport.pointFromPixel(initPixel, false);
        infoFensterData.position = {
          x: point.x,
          y: point.y
        };
        vue.$store.commit("modus/updatePopupBoxList", {
          modusOption: vue.modusOption,
          data: infoFensterData
        });
      }

      this.viewer.addOverlay({
        element: infobox,
        x: infoFensterData.position.x,
        y: infoFensterData.position.y
      });

      vue._createLine(infobox);
    },
    _createLine: function _createLine(infobox) {
      var vue = this;
      var viewer = this.viewer;
      var viewport = viewer.viewport;
      var gummiID = infobox.getAttribute("data-gummi-id");
      var accoID = infobox.getAttribute("data-accoid");
      var tr_id = gummiID.split("#")[1];
      var start_overlay = this.$el.querySelector('.ksm-gummi__start-overlay[data-tr-id="' + tr_id + '"]');

      var line = this.$svgRootG.append("line").attr("class", "ksm-gummi__line").attr("stroke-width", viewport.imageToViewportCoordinates(new OpenSeadragon.Point(20, 0)).x).attr("data-gummi-id", gummiID).attr("data-accoid", accoID);

      var circle = this.$svgRootG.append("circle").attr("class", "ksm-gummi__start-circle").attr("data-gummi-id", gummiID);

      vue._redrawOneLine({
        start: start_overlay,
        circle: circle,
        line: line,
        end: infobox
      });
    },
    _redrawAllLine: function _redrawAllLine() {
      if (this.stopRedrawAllLine) {
        this.stopRedrawAllLine = false;
        return;
      }

      var viewerContanier = this.viewerContanier;

      var vue = this;
      var end_overlays = viewerContanier.querySelectorAll(".ksm-gummi__end-overlay[data-gummi-id]");

      if (end_overlays) {
        end_overlays.forEach(function (end) {
          var gummiID = end.getAttribute("data-gummi-id");
          var start = viewerContanier.querySelector('.ksm-gummi__start-overlay[data-tr-id="' + gummiID.split("#")[1] + '"]');
          var circle = viewerContanier.querySelector('.ksm-gummi__start-circle[data-gummi-id="' + gummiID + '"]');
          var line = viewerContanier.querySelector('.ksm-gummi__line[data-gummi-id="' + gummiID + '"]');

          vue._redrawOneLine({
            start: start,
            circle: __WEBPACK_IMPORTED_MODULE_4_d3__["a" /* select */](circle),
            line: __WEBPACK_IMPORTED_MODULE_4_d3__["a" /* select */](line),
            end: end
          });
        });
      }
    },
    _redrawOneLine: function _redrawOneLine(_ref2) {
      var start = _ref2.start,
          end = _ref2.end,
          line = _ref2.line,
          circle = _ref2.circle;

      this._resetLineStart(start, line, circle);
      this._resetLineEnd(end, line);
    },
    _resetLineStart: function _resetLineStart(start_overlay, line, circle) {
      if (!start_overlay) {
        return;
      }
      var ol = this.viewer.getOverlayById(start_overlay);
      if (!ol) {
        return;
      }
      var bounds = ol.getBounds(this.viewer.viewport);
      var zoom = this.viewer.viewport.getZoom();

      line.attr("x1", Number(bounds.x)).attr("y1", Number(bounds.y)).attr("stroke-width", bounds.width / 20);
      circle.attr("cx", Number(bounds.x)).attr("cy", Number(bounds.y)).attr("r", bounds.width / 10).attr("stroke-width", bounds.width / 20);
    },
    _resetLineEnd: function _resetLineEnd(end_overlay, line) {
      if (!end_overlay) {
        return;
      }
      var viewer = this.viewer;
      var gummiID = end_overlay.getAttribute("data-gummi-id");
      var ol = viewer.getOverlayById(end_overlay);
      if (!ol) {
        return;
      }
      var bounds = ol.getBounds(viewer.viewport);

      if (!line) {
        line = this.$el.querySelector('.ksm-gummi__line[data-gummi-id="' + gummiID + '"]');
        line = __WEBPACK_IMPORTED_MODULE_4_d3__["a" /* select */](line);
      }
      line.attr("x2", Number(bounds.x) + Number(bounds.width / 2)).attr("y2", Number(bounds.y) + Number(bounds.height / 2));
    },
    _getPointDifference: function _getPointDifference(x1, y1, x2, y2) {
      var viewport = this.viewer.viewport;
      var offset1 = viewport.pointFromPixel(new OpenSeadragon.Point(x1, y1), false);
      var offset2 = viewport.pointFromPixel(new OpenSeadragon.Point(x2, y2), false);
      return {
        x: Number(offset2.x) - Number(offset1.x),
        y: Number(offset2.y) - Number(offset1.y)
      };
    },
    _createPointByPixel: function _createPointByPixel(x, y) {
      return this.viewer.viewport.pointFromPixel(new OpenSeadragon.Point(), false);
    },
    _openInfoBox: function _openInfoBox(infoFensterData, event) {
      var gummiID = infoFensterData.gummiID;

      var infoboxs = this.$el.querySelectorAll(".ksm-gummi__end-overlay");
      var opened = false;
      if (infoboxs) {
        infoboxs.forEach(function (ibox) {
          if (ibox.getAttribute("data-gummi-id") === gummiID) {
            opened = true;
            return;
          }
        });
      }
      if (opened) {
        return;
      }

      this._createInfoBox(infoFensterData, event);
    },
    _setPopupBox: function _setPopupBox(checkedTranscriptKategorieMap) {
      if (!this.accordionidTranscriptMap || !this.modusOption.popupBoxList) {
        return;
      }
      var vue = this;
      var trIds = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(checkedTranscriptKategorieMap);
      var _modusOption$urlparam = this.modusOption.urlparams,
          merzId = _modusOption$urlparam.merzId,
          seiteIdx = _modusOption$urlparam.seiteIdx;

      var _createInfoBox = this._createInfoBox;
      this.modusOption.popupBoxList.filter(function (p) {
        return p.merzId === merzId && p.seiteIdx === seiteIdx;
      }).forEach(function (d) {
        var tr_id = d.gummiID.split("#")[1];
        if (trIds.indexOf(tr_id) > -1 && !vue.$el.querySelector('[data-gummi-id="' + d.gummiID + '"')) {
          _createInfoBox(d);
        }
      });

      var checkedKategorieAccordionIDs = this.checkedKategorieAccordionIDs;
      var lines = this.$el.querySelectorAll("*[data-gummi-id]");
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(lines), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var l = _step.value;

          var gummi_id = l.getAttribute("data-gummi-id");
          var accoID = l.getAttribute("data-accoid");
          var tr_id = gummi_id.split("#")[1];
          if (trIds.indexOf(tr_id) < 0 || checkedKategorieAccordionIDs.indexOf(accoID) < 0) {
            l.classList.add("ksm-gummi-hide");
          } else {
            l.classList.remove("ksm-gummi-hide");
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    _getMenuPosition: function _getMenuPosition(pos) {
      var _ref3 = [pos.x, pos.y],
          px = _ref3[0],
          py = _ref3[1];
      var _viewer$viewport$cont = this.viewer.viewport.containerSize,
          x = _viewer$viewport$cont.x,
          y = _viewer$viewport$cont.y;
      var w = 200,
          h = 100;


      if (x - px > w && y - py > h) {
        return "bottom";
      } else if (x - px > w && y - py < h) {
        return "top";
      } else if (x - px < w && y - py < h) {
        return "left-top";
      } else if (x - px < w && y - py > h) {
        return "left";
      }
    },
    _createMenu: function _createMenu(event) {
      var rect = event.originalEvent.target;
      var div = rect.parentNode.parentNode.parentNode;
      var trID = div.getAttribute("data-tr-id");
      var obj = this.checkedTranscriptKategorieMap[trID];
      var vue = this;
      var tr = obj.data;
      var el = document.createElement("div");
      var accordionList = vue.modusOption.accordionList;

      if (obj.accoItems.length === 1) {
        var item = obj.accoItems[0];
        this._openInfoBox({
          accoItemIdx: item.accoItemIdx,
          accoID: item.acco,
          gummiID: "0#" + trID
        }, event);
        return;
      }

      var pos = this._getMenuPosition(event.position);
      obj.accoItems.forEach(function (item, i) {
        var accoId = item.acco;
        var ac = accordionList.find(function (ac) {
          return ac.id === accoId;
        });
        var div2 = document.createElement("div");
        var div3 = document.createElement("div");
        var div4 = document.createElement("div");
        div2.appendChild(div3);
        div2.appendChild(div4);
        div2.className = "ksm-flex";
        div3.className = "ksm-deepzoom__popupmenu__color-rect " + accoId + " _bg";
        div4.className = "ksm-deepzoom__popup-menuitem";
        div4.setAttribute("data-gummi-id", i + "#" + trID);
        div4.setAttribute("data-acco-id", accoId);
        div4.setAttribute("data-accoItem-idx", item.accoItemIdx);
        div4.innerHTML = ac.label;
        el.appendChild(div2);
      });
      el.className = "ksm-deepzoom__popupmenu-overlay __" + pos;
      this.viewer.addOverlay({
        element: el,
        px: tr.x,
        py: tr.y
      });
    },
    _drawOneColorRect: function _drawOneColorRect(el, tr, accoItems) {
      if (accoItems.length < 0) {
        return;
      }

      var accoArr = accoItems.filter(function (ac, i, self) {
        return accoItems.indexOf(ac) === i;
      });
      var g = __WEBPACK_IMPORTED_MODULE_4_d3__["a" /* select */](el).append("svg").attr("class", "svg-overlay").attr("width", "100%").attr("height", "100%").append("g");

      switch (accoArr.length) {
        case 1:
          accoArr.forEach(function (ac, i) {
            g.append("rect").attr("width", "100%").attr("height", "100%").attr("class", "kategorie-rect  " + ac.acco);
          });
          break;

        case 2:
          accoArr.forEach(function (ac, i) {
            g.append("rect").attr("width", "50%").attr("height", "100%").attr("x", function () {
              return i == 0 ? 0 : "50%";
            }).attr("class", "kategorie-rect " + ac.acco);
          });
          break;

        case 3:
          accoArr.forEach(function (ac, i) {
            g.append("rect").attr("width", "50%").attr("height", function () {
              if (i == 2) {
                return "60%";
              } else {
                return "100%";
              }
            }).attr("x", function () {
              if (i == 0) {
                return "0";
              } else if (i == 1) {
                return "50%";
              } else if (i == 2) {
                return "30%";
              }
            }).attr("y", function () {
              if (i == 2) {
                return "20%";
              } else {
                return "0";
              }
            }).attr("class", "kategorie-rect " + ac.acco);
          });
          break;

        case 4:
          accoArr.forEach(function (ac, i) {
            g.append("rect").attr("width", "50%").attr("height", "50%").attr("x", function () {
              if (i == 0) {
                return "0";
              } else if (i == 1) {
                return "50%";
              } else if (i == 2) {
                return "0";
              } else if (i == 3) {
                return "50%";
              }
            }).attr("y", function () {
              if (i == 0) {
                return "0";
              } else if (i == 1) {
                return "0";
              } else if (i == 2) {
                return "50%";
              } else if (i == 3) {
                return "50%";
              }
            }).attr("class", "kategorie-rect " + ac.acco);
          });
          break;

        case 5:
          accoArr.forEach(function (ac, i) {
            g.append("rect").attr("width", "50%").attr("height", function () {
              if (i == 5) {
                return "60%";
              } else {
                return "50%";
              }
            }).attr("x", function () {
              if (i == 0) {
                return "0";
              } else if (i == 1) {
                return "50%";
              } else if (i == 2) {
                return "0";
              } else if (i == 3) {
                return "50%";
              } else if (i == 4) {
                return "30%";
              }
            }).attr("y", function () {
              if (i == 0) {
                return "0";
              } else if (i == 1) {
                return "0";
              } else if (i == 2) {
                return "50%";
              } else if (i == 3) {
                return "50%";
              } else if (i == 4) {
                return "20%";
              }
            }).attr("class", "kategorie-rect " + ac.acco);
          });
          break;
      }

      this.viewer.addOverlay({
        element: el,
        px: tr.x,
        py: tr.y
      });
    },
    _drawCanvasOverlayers: function _drawCanvasOverlayers(canvasOverlay, data) {
      if (!this.openedSeite) {
        return;
      }

      if (!data) {
        data = [];
      }

      var vue = this;
      var isMarked = canvasOverlay === this.canvasoverlay_marked;
      canvasOverlay.resize();
      canvasOverlay.onRedraw = function () {
        var ctx = canvasOverlay.context2d();
        if (isMarked) {
          if (vue.isUntersuchung) {
            ctx.fillStyle = "#eee";
            ctx.globalAlpha = vue.transparenz;
            ctx.fillRect(0, 0, canvasOverlay.imgWidth, canvasOverlay.imgHeight);
            ctx.globalAlpha = 1;
          }
          ctx.strokeStyle = "rgba(153,0,0,7)";
        } else {
          ctx.fillStyle = "rgba(153,0,0,0.3)";
        }
        data.forEach(function (d) {
          if (d.$_color) {
            ctx.globalAlpha = 0.6;

            ctx.fillStyle = d.$_color;
            ctx.fillRect(d.x, d.y, d.w, d.h);
            return;
          }
          if (isMarked) {
            ctx.clearRect(d.x, d.y, d.w, d.h);
            ctx.lineWidth = "4";
            ctx.strokeRect(d.x, d.y, d.w, d.h);
          } else {
            ctx.fillRect(d.x, d.y, d.w, d.h);
          }
        });
      };
      canvasOverlay.resize();
      canvasOverlay._updateCanvas();
    },
    _getTranslate: function _getTranslate(element) {
      var style = getComputedStyle(element);
      var regExp = "/matrix((d+,s){4}(d+),s(d+)/i";
      var result = style.transform.match(regExp);
      if (result) {
        return {
          x: parseInt(result[2], 10),
          y: parseInt(result[3], 10)
        };
      } else {
        return {
          x: 0,
          y: 0
        };
      }
    },
    _initViewer: function _initViewer() {
      var _this3 = this;

      var tiles = this.tiles;
      var vue = this;
      var id = this.containerId;
      var viewerContanier = vue.$el.querySelector("#" + id);
      var toolbarDiv = vue.$el.querySelector(".toolbarDiv");
      vue.viewerContanier = viewerContanier;

      if (!toolbarDiv || !viewerContanier) {
        return;
      }

      var isKomposition = this.isKomposition;
      var viewer = new OpenSeadragon({
        element: viewerContanier,
        prefixUrl: "./static/openseadragon_images/",
        tileSources: tiles,
        initialPage: vue.seiteIdx,
        toolbar: toolbarDiv,
        showRotationControl: isKomposition ? false : true,
        showSequenceControl: isKomposition ? false : true,
        autoHideControls: false,

        gestureSettingsTouch: {
          pinchRotate: true
        },
        sequenceMode: true
      });

      if (isKomposition) {
        viewer.setControlsEnabled(false);
      }
      viewer.gestureSettingsMouse.clickToZoom = false;
      viewer.addHandler("open", function (event) {
        var _curr = vue.tiles[vue.viewer.currentPage()];
        if (_curr.indexOf("que_06842362_Bl.2v, Bl.3r") > -1 || _curr.indexOf("que_06842362_Bl.3v, Cvin") > -1) {
          viewer.viewport.setRotation(-180);
        } else {
          viewer.viewport.setRotation(0);
        }
        viewer.clearOverlays();
        if (vue.$svgRootG) {
          vue.$svgRootG.selectAll("*").remove();
        }

        var openedSeite = vue.seiten.find(function (s) {
          return s.deepSrc === event.source;
        });

        vue.openedSeite = openedSeite;
        if (openedSeite.$_allTranscripts) {
          vue.updateDataForCurrentView(openedSeite);
          vue.$emit("imageOpened");
          return;
        }

        vue.$store.dispatch("fechtSeiteDocs", openedSeite).then(function (res) {
          if (vue.modusOption.key === "ansicht") {
            return;
          }
          if (openedSeite.$_allTranscripts) {
            vue.updateDataForCurrentView(openedSeite);
          }

          vue.$emit("imageOpened");
        });
        if (vue.isUntersuchung) {
          vue._setTransparent();
        }
      });

      viewer.addHandler("canvas-click", function (e) {
        vue._canvasClick(e);
      });

      viewer.addHandler("zoom", function () {
        vue._removeAllDraggableElement();
        vue._redrawAllLine();
        vue.$emit("eventFromOSDViewer", {
          type: "zoom",
          zoom: viewer.viewport.getZoom(),
          center: viewer.viewport.getCenter()
        });
      });

      viewer.addHandler("canvas-drag", function () {
        vue.$emit("eventFromOSDViewer", {
          type: "canvas-drag",
          zoom: viewer.viewport.getZoom(),
          center: viewer.viewport.getCenter()
        });
      });

      var mousemoveSubject = new __WEBPACK_IMPORTED_MODULE_5_rxjs__["a" /* Subject */]();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs__["b" /* from */])(mousemoveSubject).pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_rxjs_operators__["a" /* map */])(function (pos) {
        return vue._getTranscriptsUnderMouse(pos);
      })).pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_rxjs_operators__["b" /* debounceTime */])(15)).pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_rxjs_operators__["c" /* distinctUntilChanged */])(function (a, b) {
        if (a === b) {
          return true;
        }

        if (a && b && a.length === b.length) {
          var has = true;
          b.forEach(function (d, i) {
            if (a[i].id !== d.id) {
              has = false;
            }
          });
          return has;
        }
      })).subscribe(function (trs) {
        vue.mouseTargetTranscripts = trs;
        vue.mouseRelatedTranscriptIDs = [];
        vue.mouseTargetAccoItems = [];
        if (isKomposition && vue.modusOption.viewKey !== "ursonate_noten") {
          vue._drawDraggleTranscripts(trs);
          vue.$store.state.eventBus.$emit(["mouseover.transcripts.komposition", _this3.modusOption.viewKey, _this3.modusOption.key].join("-"), trs);
          return;
        }
        trs && trs.forEach(function (tr) {
          vue.mouseTargetAccoItems = vue._getTargetAccoItems(tr.id);
          vue.mouseRelatedTranscriptIDs = vue.mouseRelatedTranscriptIDs.concat(vue._getRelatedTranscriptIDs(tr.id));
        });
      });

      viewerContanier.addEventListener("mouseout", function () {
        mousemoveSubject.next(null);
      });
      this.mouseTracker = new OpenSeadragon.MouseTracker({
        element: viewerContanier,
        moveHandler: function moveHandler(e) {
          if (!vue.openedSeite) {
            return;
          }
          mousemoveSubject.next(e.position);
        },
        keyDownHandler: function keyDownHandler(e) {
          viewer.setMouseNavEnabled(false);
        },
        keyUpHandler: function keyUpHandler(e) {
          viewer.setMouseNavEnabled(true);
        }
      }).setTracking(true);

      if (!isKomposition) {
        viewer.previousButton.addHandler("click", function (e) {
          var idx = vue.seiteIdx;
          if (idx > 0) {
            vue.stopDobbledrawTranscripts = true;
            vue.$emit("changePage", idx - 1);
          }
        });

        viewer.nextButton.addHandler("click", function (e) {
          var idx = vue.seiteIdx;
          if (idx < vue.seiten.length - 1) {
            vue.stopDobbledrawTranscripts = true;
            vue.$emit("changePage", idx + 1);
          }
        });
      }

      vue.canvasoverlay_checked = new __WEBPACK_IMPORTED_MODULE_2__utils_openseadragon_canvasOverlay__["a" /* default */](viewer, {
        clearBeforeRedraw: true,
        id: "checked"
      });
      vue.canvasoverlay_mouseover = new __WEBPACK_IMPORTED_MODULE_2__utils_openseadragon_canvasOverlay__["a" /* default */](viewer, {
        clearBeforeRedraw: true,
        id: "mouseover"
      });
      vue.canvasoverlay_marked = new __WEBPACK_IMPORTED_MODULE_2__utils_openseadragon_canvasOverlay__["a" /* default */](viewer, {
        clearBeforeRedraw: true,
        id: "marked"
      });

      var updateViewportSubject = new __WEBPACK_IMPORTED_MODULE_5_rxjs__["a" /* Subject */]();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs__["b" /* from */])(updateViewportSubject).pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_rxjs_operators__["b" /* debounceTime */])(500)).subscribe(function (e) {
        vue.$emit("updateViewport");
      });

      viewer.addHandler("update-viewport", function (e) {
        updateViewportSubject.next(e);
      });

      this.$svgRootG = __WEBPACK_IMPORTED_MODULE_4_d3__["a" /* select */](viewer.svgOverlay().node());
      this.viewer = viewer;
    }
  }
});

/***/ }),

/***/ 937:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_openseadragon_canvasOverlay__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_openseadragon_fabricjs_overlay__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_openseadragon_fabricjs_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__utils_openseadragon_fabricjs_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_fabric__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_fabric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_fabric__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_color__ = __webpack_require__(1908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rxjs_operators__ = __webpack_require__(819);

















/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    seiten: {
      type: Array
    },
    seiteIdx: {
      type: Number
    },
    modusOption: {
      type: Object
    }
  },
  components: {
    "photoshop-picker": __WEBPACK_IMPORTED_MODULE_9_vue_color__["Photoshop"]
  },
  data: function data() {
    return {
      stopDobbledrawTranscripts: false,
      inChangingMerz: false,
      openedSeite: null,
      transcripts: [],
      mouseRelatedTranscriptIDs: null,
      mouseTargetTranscripts: null,
      showColorPicker: false,
      backgroundColor: "#CBBBA2",
      backgroundColorBak: "#CBBBA2",
      hasImage: false
    };
  },

  watch: {
    seiten: function seiten() {
      if (this.hasImage) {
        return;
      }

      if (this.viewer) {
        this.inChangingMerz = true;
        this.viewer.open(this.tiles);
      }
    },
    seite: function seite(_seite, oldSeite) {
      if (this.hasImage) {
        return;
      }

      if (!_seite) {
        return;
      }
      if (this.inChangingMerz) {
        this.inChangingMerz = false;
        return;
      }
      if (this.viewer) {
        this.viewer.clearOverlays();
      }
      if (this.stopDobbledrawTranscripts) {
        this.stopDobbledrawTranscripts = false;
        return;
      }
      this._openPage(_seite.idx);
    }
  },
  mounted: function mounted() {
    this._initViewer();
    var vue = this;
    $("#loadSetup").on("change", function (e) {
      var file = e.target.files[0];
      if (file) {
        vue.clickLoadBtn(file);
      }
    }).on("click", function () {
      this.value = null;
    });
  },

  computed: {
    seite: function seite() {
      if (this.seiteIdx != undefined && this.seiten) {
        return this.seiten[this.seiteIdx];
      }
    },
    docs: function docs() {
      if (!this.seite) {
        return;
      }
      return this.seite.$_docInfo;
    },
    tiles: function tiles() {
      if (!this.seiten) {
        return;
      }
      return this.seiten.map(function (d) {
        return d.deepSrc;
      });
    },
    containerId: function containerId() {
      return this.$_getRandomId();
    },
    isKomposition: function isKomposition() {
      return this.modusOption.key === "komposition";
    }
  },
  methods: {
    openFilemanager: function openFilemanager() {
      if (!window.File || !window.FileReader || !window.FileList || !window.Blob) {
        alert("Your browser does not support load local file.");
        return;
      }

      $("#loadSetup").trigger("click");
    },
    clickLoadBtn: function clickLoadBtn(file) {
      if (!file) {
        return;
      }

      var reader = new FileReader();
      var vue = this;
      reader.onloadend = function (e) {
        vue.loadFromJSON(JSON.parse(reader.result));
      };
      reader.readAsText(file);
    },
    loadFromJSON: function loadFromJSON(json) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var map, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, imgObj, _imgObj$id$split, _imgObj$id$split2, trID, fileName, att, res, canvas;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                map = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default.a();
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 4;
                _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(json.objects);

              case 6:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 25;
                  break;
                }

                imgObj = _step.value;
                _imgObj$id$split = imgObj.id.split("#"), _imgObj$id$split2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_imgObj$id$split, 2), trID = _imgObj$id$split2[0], fileName = _imgObj$id$split2[1];

                if (map.get(fileName)) {
                  _context.next = 18;
                  break;
                }

                _context.next = 12;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__api__["a" /* queryPromise */])("attachment/" + fileName);

              case 12:
                att = _context.sent;

                if (!att) {
                  _context.next = 17;
                  break;
                }

                map.set(fileName, att.tag);
                _context.next = 18;
                break;

              case 17:
                return _context.abrupt("continue", 22);

              case 18:
                _context.next = 20;
                return _this.$store.dispatch("fetchtranscriptCropImg", {
                  id: trID,
                  tag: map.get(fileName)
                });

              case 20:
                res = _context.sent;

                imgObj.src = "data:Image/png;base64," + res;

              case 22:
                _iteratorNormalCompletion = true;
                _context.next = 6;
                break;

              case 25:
                _context.next = 31;
                break;

              case 27:
                _context.prev = 27;
                _context.t0 = _context["catch"](4);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 31:
                _context.prev = 31;
                _context.prev = 32;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 34:
                _context.prev = 34;

                if (!_didIteratorError) {
                  _context.next = 37;
                  break;
                }

                throw _iteratorError;

              case 37:
                return _context.finish(34);

              case 38:
                return _context.finish(31);

              case 39:
                canvas = _this.fabricjsOverlay.fabricCanvas();

                canvas.loadFromJSON(json, function () {
                  canvas.renderAll();
                });

              case 41:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[4, 27, 31, 39], [32,, 34, 38]]);
      }))();
    },
    resetCanvas: function resetCanvas() {
      var canvas = this.fabricjsOverlay.fabricCanvas();
      canvas.clear();
      this._setBackground();
    },
    speichern: function speichern() {
      var canvas = this.fabricjsOverlay.fabricCanvas();
      var json = canvas.toJSON(["id"]);
      json.objects.forEach(function (obj) {
        obj.src = "";
      });

      var fileName = "komposition_";

      fileName += new Date().toISOString().replace("T", "_").split(".")[0];
      fileName += ".json";

      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(json);
      var textFileAsBlob = new Blob([data], {
        type: "text/json"
      });

      if ("msSaveOrOpenBlob" in navigator) {
        navigator.msSaveOrOpenBlob(textFileAsBlob, fileName);
      } else {
        var downloadLink = document.createElement("a");
        downloadLink.download = fileName;
        downloadLink.innerHTML = "Download File";
        downloadLink.href = window.URL.createObjectURL(textFileAsBlob);
        downloadLink.onclick = function (e) {
          document.body.removeChild(e.target);
        };
        downloadLink.style.display = "none";
        document.body.appendChild(downloadLink);
        downloadLink.click();
      }
    },
    exportieren: function exportieren() {
      var fabricCanvas = this.fabricjsOverlay.fabricCanvas();
      $("<a>").attr({
        href: fabricCanvas.toDataURL(),
        download: new Date().toISOString().replace("T", "_").split(".")[0] + ".png"
      })[0].click();
    },
    changeBackgroundColor: function changeBackgroundColor(color) {
      this.backgroundColor = color.hex;
      this._setBackground();
    },
    actionOk: function actionOk() {
      this.showColorPicker = false;
      this.backgroundColorBak = this.backgroundColor;
    },
    actionCancel: function actionCancel() {
      this.showColorPicker = false;
      this.backgroundColor = this.backgroundColorBak;
      this._setBackground();
    },
    hintergrundObject: function hintergrundObject() {
      var fabricCanvas = this.fabricjsOverlay.fabricCanvas();
      var active = fabricCanvas.getActiveObject();
      if (active) {
        fabricCanvas.sendToBack(active);
        fabricCanvas.discardActiveObject();
        fabricCanvas.renderAll();
      }
    },
    vordergrundObject: function vordergrundObject() {
      var fabricCanvas = this.fabricjsOverlay.fabricCanvas();
      var active = fabricCanvas.getActiveObject();
      if (active) {
        fabricCanvas.bringToFront(active);
        fabricCanvas.discardActiveObject();
        fabricCanvas.renderAll();
      }
    },
    removeObject: function removeObject() {
      var fabricCanvas = this.fabricjsOverlay.fabricCanvas();
      var active = fabricCanvas.getActiveObject();
      if (active) {
        fabricCanvas.remove(active);
      }
    },
    _setImageBorder: function _setImageBorder() {
      if (!this.fabricjsOverlay) {
        return;
      }
    },
    _setBackground: function _setBackground() {
      if (!this.fabricjsOverlay) {
        return;
      }
      this.fabricjsOverlay.fabricCanvas().setBackgroundColor(this.backgroundColor);
      this.fabricjsOverlay.fabricCanvas().renderAll();
      return;
    },
    _openPage: function _openPage(idx) {
      var vue = this;
      setTimeout(function () {
        vue.viewer.goToPage(idx);
      }, 300);
    },
    _initViewer: function _initViewer() {
      var tiles = this.tiles;
      var vue = this;
      var viewerContanier = vue.$el.querySelector("#" + this.containerId);
      vue.viewerContanier = viewerContanier;

      var isKomposition = this.isKomposition;
      var viewer = new OpenSeadragon({
        element: viewerContanier,
        prefixUrl: "./static/openseadragon_images/",
        tileSources: tiles,
        initialPage: vue.seiteIdx,
        toolbar: vue.$refs.osdButtonsDiv,
        showRotationControl: isKomposition ? false : true,
        autoHideControls: false,
        showSequenceControl: false,
        minZoomImageRatio: 0.2,
        gestureSettingsTouch: {
          pinchRotate: true
        },
        sequenceMode: true
      });

      viewer.setControlsEnabled(false);

      viewer.gestureSettingsMouse.clickToZoom = false;
      viewer.addHandler("open", function (event) {
        vue.hasImage = true;
        viewer.clearOverlays();
        vue._setBackground();


        var openedSeite = vue.seiten.find(function (s) {
          return s.deepSrc === event.source;
        });

        vue.openedSeite = openedSeite;
        if (openedSeite.$_allTranscripts) {
          vue.$emit("imageOpened");
          return;
        }

        vue.$store.dispatch("fechtSeiteDocs", openedSeite).then(function (res) {
          if (vue.modusOption.key === "ansicht") {
            return;
          }
          if (openedSeite.$_allTranscripts) {}

          vue.$emit("imageOpened");
        });
      });

      viewer.addHandler("zoom", function () {
        vue.$emit("eventFromOSDViewer", {
          type: "zoom",
          zoom: viewer.viewport.getZoom(),
          center: viewer.viewport.getCenter()
        });
      });

      viewer.addHandler("canvas-drag", function () {
        vue.$emit("eventFromOSDViewer", {
          type: "canvas-drag",
          zoom: viewer.viewport.getZoom(),
          center: viewer.viewport.getCenter()
        });
      });

      this.mouseTracker = new OpenSeadragon.MouseTracker({
        element: viewerContanier,
        keyDownHandler: function keyDownHandler(e) {
          if (e.keyCode === 46) {
            var fabricCanvas = vue.fabricjsOverlay.fabricCanvas();
            fabricCanvas.remove(fabricCanvas.getActiveObject());
          }
        },
        keyUpHandler: function keyUpHandler(e) {}
      }).setTracking(true);

      this.viewer = viewer;
      this.fabricjsOverlay = this.viewer.fabricjsOverlay({
        scale: 500
      });
    }
  }
});

/***/ }),

/***/ 938:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ol_Map__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ol_View__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ol_source_Vector__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ol_layer_Vector__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ol_layer_Tile__ = __webpack_require__(1736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ol_source_XYZ__ = __webpack_require__(1767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ol_format_GeoJSON__ = __webpack_require__(1719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ol_Overlay_js__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_ol_geom_Point_js__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_ol_style__ = __webpack_require__(1769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_ol_geom_Circle__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_ol_proj__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_ol_events_condition_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_ol_interaction_js__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_ol_interaction_Select_js__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_ol_geom_js__ = __webpack_require__(1721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_ol_Feature__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_ol_control_js__ = __webpack_require__(1710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_ol_extent_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vuex__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_d3__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Timeline_vue__ = __webpack_require__(1912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Timeline_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__Timeline_vue__);








__webpack_require__(1560);


























/* harmony default export */ __webpack_exports__["default"] = ({
  props: { geoData: Object, option: Object },
  data: function data() {
    return {
      stadtFilterIds: null,
      map: null,
      fixierendItems: [],
      currentInfobox: null,
      hoveringFeature: null,
      centerCity: "Jena",
      fensterZIndex: 1,
      tourLineLayer: null,
      baseLayer: null
    };
  },

  components: {
    TimelineView: __WEBPACK_IMPORTED_MODULE_28__Timeline_vue___default.a
  },
  created: function created() {
    this.$store.dispatch("orteundwege/prepareAllfensterDataCollection").then(function (data) {});
  },

  mounted: function mounted() {
    var vue = this;
    this.initMap();
    this.setMapExtent();
    vue.$el.addEventListener("resize", function () {
      vue.map.updateSize();
    });
  },


  watch: {
    stadtFilterIds: function stadtFilterIds() {
      this.updatePiechartLayer();
    },
    activeInfoItem: function activeInfoItem(infoItem) {
      if (!infoItem) {
        return;
      }
      var vue = this;
      var feature = this.getFeatureByRow(infoItem.row);
      if (feature) {
        this.flyTo(feature.getGeometry().getCoordinates(), function () {
          vue.openInfoFenster(infoItem);
          vue.drawTourplan(infoItem);
        });
      }
    },


    sidebarRightList: {
      handler: function handler(d) {
        var _this = this;

        this.updatePiechartLayer();
        this.$store.dispatch("orteundwege/updateAllOrtsFensterData").then(function (res) {
          _this.resetAllInboxLine();
        });
      },
      deep: true
    },
    filterMerzgebieteGeoData: {
      handler: function handler() {
        this.updateMerzgebieteLayer();
      },
      deep: true
    }
  },

  methods: {
    changeDate: function changeDate(ids) {
      this.stadtFilterIds = ids;
    },
    setMapExtent: function setMapExtent() {
      var map = this.map;
      var extent = map.getView().calculateExtent(map.getSize());
    },
    createPiechartStyle: function createPiechartStyle(img, imgSize) {
      var iconStyle = new __WEBPACK_IMPORTED_MODULE_15_ol_style__["a" /* Style */]({
        image: new __WEBPACK_IMPORTED_MODULE_15_ol_style__["b" /* Icon */]({
          img: img,
          imgSize: imgSize
        })
      });
      return iconStyle;
    },
    createMapLayer: function createMapLayer() {
      var layer = new __WEBPACK_IMPORTED_MODULE_10_ol_layer_Tile__["a" /* default */]({
        source: new __WEBPACK_IMPORTED_MODULE_11_ol_source_XYZ__["a" /* default */]({
          crossOrigin: "anonymous",
          url: "static/map_tiles/background/world/{z}/{x}/{y}" + ".png",
          maxZoom: 8,
          tilePixelRatio: 2,
          tileSize: [512, 512]
        })
      });
      this.baseLayer = layer;
      return layer;
    },
    createRetinaLayer: function createRetinaLayer() {
      var layer = new __WEBPACK_IMPORTED_MODULE_10_ol_layer_Tile__["a" /* default */]({
        source: new __WEBPACK_IMPORTED_MODULE_11_ol_source_XYZ__["a" /* default */]({
          crossOrigin: "anonymous",
          url: "static/map_tiles/retina/{z}/{x}/{-y}" + ".png",
          maxZoom: 8,
          tilePixelRatio: 2,
          tileSize: [512, 512]
        })
      });
      this.baseLayer = layer;
      return layer;
    },
    createCityLayer: function createCityLayer() {
      var vue = this;

      var layer = new __WEBPACK_IMPORTED_MODULE_9_ol_layer_Vector__["a" /* default */]({
        declutter: true,
        style: function style(feature, resolution) {
          return new __WEBPACK_IMPORTED_MODULE_15_ol_style__["a" /* Style */]({
            geometry: new __WEBPACK_IMPORTED_MODULE_16_ol_geom_Circle__["a" /* default */](feature.getGeometry().getCoordinates(), 2 * resolution),
            fill: new __WEBPACK_IMPORTED_MODULE_15_ol_style__["c" /* Fill */]({ color: "#000" }),
            stroke: new __WEBPACK_IMPORTED_MODULE_15_ol_style__["d" /* Stroke */]({ color: "#000", width: 1 }),
            text: new __WEBPACK_IMPORTED_MODULE_15_ol_style__["e" /* Text */]({
              textAlign: "left",
              offsetX: 12,
              font: "12px Arial, Helvetica, sans-serif, Verdana",
              fill: new __WEBPACK_IMPORTED_MODULE_15_ol_style__["c" /* Fill */]({
                color: "#222"
              }),
              text: feature.get("stadtname")
            })
          });
        }
      });
      this.cityLayer = layer;

      return layer;
    },
    createPiechartLayer: function createPiechartLayer() {
      var vue = this;
      var piechartLayer = new __WEBPACK_IMPORTED_MODULE_9_ol_layer_Vector__["a" /* default */]({
        style: function style(feature) {
          return vue.createPiechartStyle(feature.get("icon"), feature.get("iconSize"));
        }
      });
      this.piechartLayer = piechartLayer;
      this.updatePiechartLayer();
      return piechartLayer;
    },
    initMap: function initMap() {
      var vue = this;
      var option = this.option;
      var zoom = option.zoom ? option.zoom : 5;

      var layers = [this.createMapLayer(), this.createRetinaLayer(), this.createCityLayer(), this.createMerzgebieteLayer()];
      if (option && option.showPiechart) {
        layers.push(this.createPiechartLayer());
      }
      layers = layers.concat(this.createTourplanLayers());

      var center = this.geoData.features.find(function (f) {
        return f.properties.stadtname === vue.centerCity;
      });
      if (!center) {
        center = this.geoData.features[0];
      }

      var RotateNorthControl = function (Control) {
        function RotateNorthControl(opt_options) {
          var options = opt_options || {};
          var element = document.createElement("div");
          element.className = "ksm-map__controls ol-unselectable";

          var ortsIcon = vue.$el.querySelector(".alle-ortsfenster-schliessen");
          element.appendChild(ortsIcon);

          var infoIcon = vue.$el.querySelector(".alle-infofenster-schliessen");
          element.appendChild(infoIcon);

          Control.call(this, {
            element: element,
            target: options.target
          });

          infoIcon.addEventListener("click", function () {
            vue.closeAllFenster("infoFenster", { resetActiveInfoItem: true });
          }, false);

          ortsIcon.addEventListener("click", function () {
            vue.closeAllFenster("ortsFenster");
          }, false);
        }

        if (Control) RotateNorthControl.__proto__ = Control;
        RotateNorthControl.prototype = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(Control && Control.prototype);
        RotateNorthControl.prototype.constructor = RotateNorthControl;
        return RotateNorthControl;
      }(__WEBPACK_IMPORTED_MODULE_23_ol_control_js__["a" /* Control */]);

      var controls = [];
      if (option && option.showControls) {
        controls = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23_ol_control_js__["b" /* defaults */])({
          attribution: false
        }).extend([new RotateNorthControl()]);
      }
      var centerPos = [0, 0];
      if (center) {
        centerPos = center.geometry.coordinates;
      }
      var map = new __WEBPACK_IMPORTED_MODULE_6_ol_Map__["a" /* default */]({
        target: vue.$refs["map-container"],
        controls: controls,
        layers: layers,
        view: new __WEBPACK_IMPORTED_MODULE_7_ol_View__["a" /* default */]({
          center: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_ol_proj__["a" /* fromLonLat */])(centerPos, "EPSG:3857"),
          zoom: zoom,
          maxZoom: 8,
          minZoom: 3
        })
      });
      vue.map = map;

      document.addEventListener("mouseup", function () {
        vue.currentInfobox = null;
        vue.startMove = false;
      });

      map.on("singleclick", function (evt) {
        var hoveringFeature = vue.hoveringFeature;
        if (hoveringFeature) {
          vue.openFenster({
            feature: hoveringFeature,
            type: "ortsFenster"
          });
        }
      });

      map.on("pointermove", function (evt) {
        vue.startMove = true;
        var currentInfobox = vue.currentInfobox;
        if (currentInfobox) {
          return vue.moveInfobox(vue, evt, currentInfobox);
        }

        var features = map.getFeaturesAtPixel(evt.pixel);
        if (features && features.find(function (f) {
          return f.get("icon");
        })) {
          map.getTargetElement().style.cursor = "pointer";
          vue.hoverFetureIcon(features.find(function (f) {
            return f.get("icon");
          }));
        } else {
          if (vue.hoveringFeature) {
            vue.hoveringFeature.setStyle(null);
          }
          vue.hoveringFeature = null;
          map.getTargetElement().style.cursor = "";
        }
      });

      map.getView().on("change:resolution", function () {
        vue.resetAllInboxLine();
      });

      vue.$emit("inited", map);
    },
    fixierenFenster: function fixierenFenster(fensterData) {
      fensterData.infoItem.fixied = true;
      this.fixierendItems.push(fensterData.infoItem);
    },
    closeFenster: function closeFenster(fensterData) {
      fensterData.visible = false;
      if (fensterData.type === "infoFenster") {
        this.clickInfoItem(null);
        fensterData.infoItem.fixied = false;
        this.refreshTourplanLayer();
      }
      this.refreshFensterLine(fensterData);
    },
    startClick: function startClick(evt) {
      if (!evt) {
        return;
      }
      this.clickInfoItemTimestamp = evt.timeStamp;
    },
    clickInfoItem: function clickInfoItem(infoItem, evt) {
      if (evt && evt.timeStamp - this.clickInfoItemTimestamp > 100) {
        return;
      }
      this.$store.commit("orteundwege/activeInfoItem", infoItem);
      if (infoItem) {
        this.$store.state.eventBus.$emit("ortundwege-accor-scroll", infoItem);
        this.$store.commit("orteundwege/expandAccor", infoItem.accor);
      }
    },
    navigatorInfoFenster: function navigatorInfoFenster(fensterData, to) {
      this.$store.commit("orteundwege/expandAccor", fensterData.infoItem.accor);
      this.$store.dispatch("orteundwege/navigatorInfoFenster", {
        infoItem: fensterData.infoItem,
        to: to
      });
    },
    closeAllFenster: function closeAllFenster(type, opts) {
      var vue = this;
      this.fensterDataCollection.filter(function (fensterData) {
        return fensterData.type === type && fensterData.visible;
      }).forEach(function (fensterData) {
        vue.closeFenster(fensterData);
      });
      if (type === "infoFenster") {
        if (opts && opts.resetActiveInfoItem) {
          this.$store.commit("orteundwege/activeInfoItem", null);
        }
        this.sidebarRightList.forEach(function (accor) {
          accor.infoItems.forEach(function (it) {
            it.fixied = false;
          });
        });
        vue.refreshTourplanLayer();
      }
    },
    refreshTourplanLayer: function refreshTourplanLayer() {
      var vue = this;
      vue.tourPunktLayer.setSource(null);
      vue.tourLineLayer.setSource(null);
    },
    resetAllInboxLine: function resetAllInboxLine() {
      var _this2 = this;

      this.fensterDataCollection.forEach(function (fensterData) {
        _this2.refreshFensterLine(fensterData);
      });
    },
    refreshFensterLine: function refreshFensterLine(fensterData) {
      if (!fensterData.lineFeature || !fensterData.lineLayer) {
        return;
      }
      if (fensterData.infoItems && fensterData.infoItems.length < 1 && fensterData.type !== "infoFenster" || fensterData.visible === false && (fensterData.infoItem ? !fensterData.infoItem.fixied : true)) {
        fensterData.lineLayer.setVisible(false);
        return;
      } else {
        fensterData.lineLayer.setVisible(true);
      }
      var vue = this;
      var geometry = fensterData.lineFeature.getGeometry();
      var lineCoors = geometry.getCoordinates();
      geometry.setCoordinates([vue.getCenterOfOverlay(fensterData.overlay), lineCoors[1]]);
    },
    moveInfobox: function moveInfobox(vue, evt, currentInfobox) {
      var mouseClickPos = currentInfobox.mouseClickPos,
          overlayCoordinate = currentInfobox.overlayCoordinate,
          fensterData = currentInfobox.fensterData;


      if (!mouseClickPos) {
        mouseClickPos = evt.coordinate;
        currentInfobox.mouseClickPos = mouseClickPos;
      }
      fensterData.position = [evt.coordinate[0] - mouseClickPos[0] + overlayCoordinate[0], evt.coordinate[1] - mouseClickPos[1] + overlayCoordinate[1]];
      fensterData.overlay.setPosition(fensterData.position);
      vue.refreshFensterLine(fensterData);
    },
    getCenterOfOverlay: function getCenterOfOverlay(overlay) {
      var element = overlay.getElement();
      var _ref = [element.clientWidth, element.clientHeight],
          w = _ref[0],
          h = _ref[1];

      var map = this.map;
      var endPixel = map.getPixelFromCoordinate(overlay.getPosition());
      return map.getCoordinateFromPixel([endPixel[0] - w / 2, endPixel[1] + h / 2]);
    },
    hoverFetureIcon: function hoverFetureIcon(feature) {
      if (this.hoveringFeature) {
        this.hoveringFeature.setStyle(null);
      }
      var canvas = document.createElement("canvas");
      var image = feature.get("icon");
      var w = image.width + 8;
      var h = image.height + 8;
      var lineWidth = 2;
      canvas.width = w;
      canvas.height = h;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(image, 0, 0, w, h);
      ctx.beginPath();
      ctx.arc(w / 2, h / 2, (w - lineWidth) / 2, 0, 2 * Math.PI, false);
      ctx.lineWidth = lineWidth;
      ctx.strokeStyle = "#fff";
      ctx.stroke();
      var style = this.createPiechartStyle(canvas, [w, h]);
      style.setText(new __WEBPACK_IMPORTED_MODULE_15_ol_style__["e" /* Text */]({
        textAlign: "left",
        offsetX: 20,
        font: "14px",
        fill: new __WEBPACK_IMPORTED_MODULE_15_ol_style__["c" /* Fill */]({
          color: "#000"
        }),
        stroke: new __WEBPACK_IMPORTED_MODULE_15_ol_style__["d" /* Stroke */]({
          color: "#fff",
          width: 5
        }),
        text: feature.get("stadtname")
      }));
      style.setZIndex(10);
      feature.setStyle(style);
      this.hoveringFeature = feature;
    },
    fensterMouseDown: function fensterMouseDown(fensterData, evt) {
      if (evt.target.getAttribute("data-coordinates")) {
        return;
      }
      var vue = this;
      vue.fensterToTop(fensterData);
      vue.currentInfobox = {
        fensterData: fensterData,
        overlay: fensterData.overlay,
        overlayCoordinate: fensterData.overlay.getPosition(),
        mouseClickPos: null,
        lineFeature: fensterData.lineFeature
      };
    },
    getGeometryByOffset: function getGeometryByOffset(geometry, offset) {
      var vue = this;
      var clone = geometry.clone();

      var _clone$getCoordinates = clone.getCoordinates(),
          _clone$getCoordinates2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_clone$getCoordinates, 2),
          c0 = _clone$getCoordinates2[0],
          c1 = _clone$getCoordinates2[1];

      var start = vue.map.getPixelFromCoordinate(c0);
      var end = vue.map.getPixelFromCoordinate(c1);
      var _ref2 = [start[0], start[1], end[0], end[1]],
          x0 = _ref2[0],
          y0 = _ref2[1],
          x1 = _ref2[2],
          y1 = _ref2[3];

      var dx = x1 - x0;
      var dy = y1 - y0;
      var dxy = Math.sqrt(dx * dx + dy * dy);
      if (dxy === 0) {
        return;
      }

      var _x0 = offset / dxy * dx + x0;
      var _x1 = x0 + (dxy - offset) / dxy * dx;
      var _y0 = offset / dxy * dy + y0;
      var _y1 = (dxy - offset) / dxy * dy + y0;

      var newStart = vue.map.getCoordinateFromPixel([_x0, _y0]);
      var newEnd = vue.map.getCoordinateFromPixel([_x1, _y1]);
      clone.setCoordinates([newStart, newEnd], "XY");
      return [clone, dxy];
    },
    createFensterOverlay: function createFensterOverlay(item, startPoint) {
      var vue = this;
      var stadtindex = item.stadtindex;
      var div = vue.$el.querySelector(".ksm_map_infobox_container").querySelector("[data-stadtindex='" + item.type + "_" + stadtindex + "']");
      if (!div) {
        return;
      }
      var computedStyle = window.getComputedStyle(div, null);
      var pos = vue.map.getPixelFromCoordinate(startPoint);
      var overlay = new __WEBPACK_IMPORTED_MODULE_13_ol_Overlay_js__["a" /* default */]({
        element: div,
        id: stadtindex,
        positioning: "top-right",
        position: vue.map.getCoordinateFromPixel([pos[0] - div.clientWidth - 50, pos[1] - div.clientHeight - 50])
      });
      vue.map.addOverlay(overlay);
      item.overlay = overlay;
      vue.fensterToTop(item);

      setTimeout(function () {
        var lineFeature = vue.createLineFeature([vue.getCenterOfOverlay(overlay), startPoint]);

        var lineLayer = new __WEBPACK_IMPORTED_MODULE_9_ol_layer_Vector__["a" /* default */]({
          source: new __WEBPACK_IMPORTED_MODULE_8_ol_source_Vector__["a" /* default */]({
            features: [lineFeature]
          }),
          style: new __WEBPACK_IMPORTED_MODULE_15_ol_style__["a" /* Style */]({
            stroke: new __WEBPACK_IMPORTED_MODULE_15_ol_style__["d" /* Stroke */]({
              width: 2,
              color: [0, 0, 0, 0.4]
            }),
            fill: new __WEBPACK_IMPORTED_MODULE_15_ol_style__["c" /* Fill */]({
              color: [0, 0, 0, 0.6]
            })
          })
        });
        item.lineFeature = lineFeature;
        item.lineLayer = lineLayer;
        vue.map.addLayer(lineLayer);
      }, 100);
    },
    createLineFeature: function createLineFeature(coor) {
      return new __WEBPACK_IMPORTED_MODULE_22_ol_Feature__["a" /* default */](new __WEBPACK_IMPORTED_MODULE_21_ol_geom_js__["a" /* LineString */](coor));
    },
    setInfoItemTourData: function setInfoItemTourData(infoItem) {
      var vue = this;
      var accor = infoItem.accor,
          row = infoItem.row;

      var infoItems = accor.infoItems;
      var idx = infoItems.indexOf(infoItem);

      var currentFeature = this.getFeatureByRow(row);
      if (!currentFeature) {
        console.log("kein Feature von ", row);
        return;
      }
      var currentCoordinates = currentFeature.getGeometry().getCoordinates();

      var lineFeatures = [];
      var punkte = [currentFeature];
      var stadtindex = currentFeature.get("stadtindex");
      if (idx > 0) {
        var preFeature = this.getFeatureByRow(infoItems[idx - 1].row);
        if (preFeature && preFeature.get("stadtindex") !== stadtindex) {
          var preCoor = preFeature.getGeometry().getCoordinates();
          punkte.push(preFeature);
          lineFeatures.push(vue.createLineFeature([preCoor, currentCoordinates]));
        }
      }
      if (idx < infoItems.length - 1) {
        var nextFeature = this.getFeatureByRow(infoItems[idx + 1].row);
        if (nextFeature && nextFeature.get("stadtindex") !== stadtindex) {
          var nextCoor = nextFeature.getGeometry().getCoordinates();
          punkte.push(nextFeature);
          lineFeatures.push(vue.createLineFeature([currentCoordinates, nextCoor]));
        }
      }
      return [punkte, lineFeatures];
    },
    drawTourplan: function drawTourplan(infoItem) {
      var _this3 = this;

      var vue = this;
      var activeAccordion = this.sidebarRightList.find(function (it) {
        return it.isExpand;
      });
      var isHolland = activeAccordion.id === "holland";

      var lineFeatures = [];
      var punkte = [];
      var accor = infoItem.accor;

      vue.fixierendItems.concat(infoItem).forEach(function (infoItem) {
        var accor = infoItem.accor,
            row = infoItem.row;

        var infoItems = accor.infoItems;
        var idx = infoItems.indexOf(infoItem);

        var currentFeature = _this3.getFeatureByRow(row);
        if (!currentFeature) {
          console.log("kein Feature von ", row);
          return;
        }
        var currentCoordinates = currentFeature.getGeometry().getCoordinates();
        punkte.push(currentFeature);
        var stadtindex = currentFeature.get("stadtindex");

        if (isHolland && idx > 0) {
          var preFeature = _this3.getFeatureByRow(infoItems[idx - 1].row);
          if (preFeature && preFeature.get("stadtindex") !== stadtindex) {
            var preCoor = preFeature.getGeometry().getCoordinates();
            punkte.push(preFeature);
            lineFeatures.push(vue.createLineFeature([preCoor, currentCoordinates]));
          }
        }
        if (isHolland && idx < infoItems.length - 1) {
          var nextFeature = _this3.getFeatureByRow(infoItems[idx + 1].row);
          if (nextFeature && nextFeature.get("stadtindex") !== stadtindex) {
            var nextCoor = nextFeature.getGeometry().getCoordinates();
            punkte.push(nextFeature);
            lineFeatures.push(vue.createLineFeature([currentCoordinates, nextCoor]));
          }
        }
      });
      punkte = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(punkte)));
      lineFeatures = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(lineFeatures)));

      var punktStyleFunc = function punktStyleFunc(feature) {
        var styles = [];
        styles.push(new __WEBPACK_IMPORTED_MODULE_15_ol_style__["a" /* Style */]({
          geometry: feature.getGeometry(),
          image: new __WEBPACK_IMPORTED_MODULE_15_ol_style__["b" /* Icon */]({
            img: vue.createCanvasCircle({
              w: 30,
              h: 30,
              lineWidth: 3,
              color: accor.color
            }),
            imgSize: [30, 30]
          })
        }));
        return styles;
      };

      vue.tourPunktLayer.setSource(new __WEBPACK_IMPORTED_MODULE_8_ol_source_Vector__["a" /* default */]({
        features: punkte
      }));
      vue.tourPunktLayer.setStyle(punktStyleFunc);

      vue.tourLineLayer.setSource(new __WEBPACK_IMPORTED_MODULE_8_ol_source_Vector__["a" /* default */]({
        features: lineFeatures
      }));
      var lineStyleFunc = function lineStyleFunc(feature) {
        var geometry = feature.getGeometry();

        var _vue$getGeometryByOff = vue.getGeometryByOffset(geometry, 15),
            _vue$getGeometryByOff2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_vue$getGeometryByOff, 2),
            clone = _vue$getGeometryByOff2[0],
            cxy = _vue$getGeometryByOff2[1];

        var styles = [];

        if (clone && lineFeatures.length > 0) {
          styles.push(new __WEBPACK_IMPORTED_MODULE_15_ol_style__["a" /* Style */]({
            geometry: clone,
            stroke: new __WEBPACK_IMPORTED_MODULE_15_ol_style__["d" /* Stroke */]({
              color: accor.color,
              width: 3
            })
          }));
        }

        geometry.forEachSegment(function (start, end) {
          var dx = end[0] - start[0];
          var dy = end[1] - start[1];
          var rotation = Math.atan2(dy, dx);

          if (dx !== dy && cxy > 25) {
            styles.push(new __WEBPACK_IMPORTED_MODULE_15_ol_style__["a" /* Style */]({
              geometry: new __WEBPACK_IMPORTED_MODULE_14_ol_geom_Point_js__["a" /* default */](end),
              image: new __WEBPACK_IMPORTED_MODULE_15_ol_style__["b" /* Icon */]({
                img: vue.createCanvasTriangle({
                  w: 15,
                  h: 15,
                  color: accor.color
                }),
                anchor: [1.7, 0.5],
                imgSize: [15, 15],
                rotateWithView: true,
                rotation: -rotation
              })
            }));
          }
        });
        return styles;
      };
      vue.tourLineLayer.setStyle(lineStyleFunc);
    },
    createTourplanLayers: function createTourplanLayers() {
      var tourLineLayer = new __WEBPACK_IMPORTED_MODULE_9_ol_layer_Vector__["a" /* default */](),
          tourPunktLayer = new __WEBPACK_IMPORTED_MODULE_9_ol_layer_Vector__["a" /* default */]();

      this.tourPunktLayer = tourPunktLayer;
      this.tourLineLayer = tourLineLayer;
      return [tourLineLayer, tourPunktLayer];
    },
    createCanvasCircle: function createCanvasCircle(_ref3) {
      var w = _ref3.w,
          h = _ref3.h,
          color = _ref3.color,
          lineWidth = _ref3.lineWidth;

      var canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      var ctx = canvas.getContext("2d");
      ctx.beginPath();
      ctx.arc(w / 2, h / 2, (w - lineWidth) / 2, 0, 2 * Math.PI, false);
      ctx.lineWidth = lineWidth;
      ctx.strokeStyle = color;
      ctx.stroke();
      return canvas;
    },
    createCanvasCircleGradient: function createCanvasCircleGradient(_ref4) {
      var w = _ref4.w,
          h = _ref4.h,
          color = _ref4.color,
          lineWidth = _ref4.lineWidth;

      var canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      var ctx = canvas.getContext("2d");
      ctx.beginPath();
      var grad = ctx.createRadialGradient(w / 2, h / 2, 0, w / 2, h / 2, w / 2);
      grad.addColorStop(0, color);
      grad.addColorStop(0.3, color);
      grad.addColorStop(1, "transparent");
      ctx.arc(w / 2, h / 2, w / 2, 0, 2 * Math.PI, false);
      ctx.fillStyle = grad;
      ctx.globalAlpha = 0.55;
      ctx.fill();

      return canvas;
    },
    createCanvasTriangle: function createCanvasTriangle(_ref5) {
      var w = _ref5.w,
          h = _ref5.h,
          color = _ref5.color;

      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");
      ctx.beginPath();
      ctx.moveTo(0, 0);
      ctx.lineTo(w, h / 2);
      ctx.lineTo(0, h);
      ctx.fillStyle = color;
      ctx.fill();
      ctx.closePath();
      return canvas;
    },
    getFeatureByRow: function getFeatureByRow(row) {
      var stadtindex = row.stadtindex || row.ortsindex;
      return this.cityLayer.getSource().getFeatures().find(function (f) {
        return stadtindex.split("#").indexOf(f.get("stadtindex")) > -1;
      });
    },
    openInfoFenster: function openInfoFenster(infoItem) {
      console.log(infoItem);
      var accor = infoItem.accor,
          row = infoItem.row;

      var vue = this;
      var stadtindex = row.stadtindex || row.ortsindex;
      var feature = vue.getFeatureByRow(row);
      if (!feature) {
        return;
      }

      vue.fensterDataCollection.filter(function (fensterData) {
        return fensterData.type === "infoFenster" && fensterData.visible;
      }).forEach(function (fensterData) {
        fensterData.visible = false;
        vue.refreshFensterLine(fensterData);
      });

      vue.refreshTourplanLayer();
      vue.openFenster({
        feature: feature,
        type: "infoFenster",
        infoItem: infoItem
      });
    },
    openFenster: function openFenster(_ref6) {
      var feature = _ref6.feature,
          type = _ref6.type,
          infoItem = _ref6.infoItem;

      var vue = this;
      var stadtindex = feature.get("stadtindex");
      var fensterData = this.fensterDataCollection.find(function (fensterData) {
        return fensterData.stadtindex === stadtindex && fensterData.type === type;
      });
      fensterData.visible = true;
      fensterData.infoItem = infoItem;

      if (!fensterData.infoItems && type === "ortsFenster") {
        vue.$store.commit("orteundwege/updateOrtsFensterInfoItems", fensterData);
      }

      if (!fensterData.overlay) {
        vue.createFensterOverlay(fensterData, feature.getGeometry().getCoordinates());
      } else {
        fensterData.visible = true;
        vue.fensterToTop(fensterData);
        if (fensterData.infoItems && fensterData.infoItems.length < 1 || fensterData.visible === false) {
          fensterData.lineLayer.setVisible(false);
        } else {
          fensterData.lineLayer.setVisible(true);
        }
      }

      if (fensterData.type === "infoFenster") {
        var lastActiveInfoItem = this.$store.state.orteundwege.data.lastActiveInfoItem;
        if (lastActiveInfoItem) {
          var lastFensterData = this.fensterDataCollection.find(function (fensterData) {
            return fensterData.infoItem === lastActiveInfoItem;
          });
          if (lastFensterData) {
            fensterData.overlay.setPosition(lastFensterData.overlay.getPosition());
            vue.refreshFensterLine(fensterData);
          }
        }
      }
    },
    createMerzgebieteLayer: function createMerzgebieteLayer() {
      var vue = this;
      var merzgebieteLayer = new __WEBPACK_IMPORTED_MODULE_9_ol_layer_Vector__["a" /* default */]({
        style: function style(feature) {
          var canvas = vue.createCanvasCircleGradient({
            w: 50,
            h: 50,
            lineWidth: 2,
            color: feature.get("color")
          });

          return new __WEBPACK_IMPORTED_MODULE_15_ol_style__["a" /* Style */]({
            image: new __WEBPACK_IMPORTED_MODULE_15_ol_style__["b" /* Icon */]({
              img: canvas,
              imgSize: [60, 60]
            })
          });
        }
      });
      this.merzgebieteLayer = merzgebieteLayer;
      this.updateMerzgebieteLayer();
      return merzgebieteLayer;
    },
    flyTo: function flyTo(location, done) {
      var view = this.map.getView();
      var duration = 500;
      var zoom = 5;
      var parts = 1;
      var called = false;
      function callback(complete) {
        --parts;
        if (called) {
          return;
        }
        if (parts === 0 || !complete) {
          called = true;
          done(complete);
        }
      }
      view.animate({
        center: location,
        duration: duration
      }, callback);
    },
    updatePiechartLayer: function updatePiechartLayer() {
      var stadtFilterIds = this.stadtFilterIds;
      var vue = this;
      if (!this.option || !this.option.showPiechart) {
        return;
      }

      var features = this.geoData.features.filter(function (f) {
        return f.properties.icon;
      });
      if (stadtFilterIds) {
        features = features.filter(function (f) {
          return stadtFilterIds.indexOf(f.properties.stadtindex) > -1;
        });
      }

      var source = {
        type: "FeatureCollection",
        features: features
      };
      this.piechartLayer.setSource(new __WEBPACK_IMPORTED_MODULE_8_ol_source_Vector__["a" /* default */]({
        features: new __WEBPACK_IMPORTED_MODULE_12_ol_format_GeoJSON__["a" /* default */]().readFeatures(source, {
          featureProjection: "EPSG:3857"
        })
      }));
      setTimeout(function () {
        vue.map.updateSize();
      }, 50);
    },
    updateCityLayer: function updateCityLayer() {
      var featureMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
      var merzgebitFeatures = this.filterMerzgebieteGeoData.features.filter(function (f) {
        return f.show === true;
      }).forEach(function (f) {
        featureMap.set(f.properties.id, {
          geometry: f.geometry,
          properties: {
            stadtindex: f.properties.id,
            stadtname: f.properties.name
          },
          type: "Feature"
        });
      });
      this.geoData.features.forEach(function (f) {
        featureMap.set(f.properties.stadtindex, {
          geometry: f.geometry,
          properties: {
            stadtindex: f.properties.stadtindex,
            stadtname: f.properties.stadtname
          },
          type: "Feature"
        });
      });

      var source = {
        type: "FeatureCollection",
        features: [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(featureMap.values()))
      };

      this.cityLayer.setSource(new __WEBPACK_IMPORTED_MODULE_8_ol_source_Vector__["a" /* default */]({
        features: new __WEBPACK_IMPORTED_MODULE_12_ol_format_GeoJSON__["a" /* default */]().readFeatures(source, {
          featureProjection: "EPSG:3857"
        })
      }));
    },
    updateMerzgebieteLayer: function updateMerzgebieteLayer() {
      var source = {
        type: "FeatureCollection",
        features: this.filterMerzgebieteGeoData.features.filter(function (f) {
          return f.show;
        })
      };
      this.merzgebieteLayer.setSource(new __WEBPACK_IMPORTED_MODULE_8_ol_source_Vector__["a" /* default */]({
        features: new __WEBPACK_IMPORTED_MODULE_12_ol_format_GeoJSON__["a" /* default */]().readFeatures(source, {
          featureProjection: "EPSG:3857"
        })
      }));
      this.updateCityLayer();
    },
    fensterToTop: function fensterToTop(item) {
      var vue = this;
      var infobox = item.overlay.getElement();
      var zIndex = ++this.fensterZIndex;
      var overlayContainer = infobox.parentNode;
      overlayContainer.style.zIndex = zIndex;
      item.zIndex = zIndex;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_vuex__["b" /* mapGetters */])({
    fensterDataCollection: ["orteundwege/fensterDataCollection"],
    sidebarRightList: ["orteundwege/sidebarRightList"],
    activeInfoItem: ["orteundwege/activeInfoItem"],
    filterMerzgebieteGeoData: ["orteundwege/filterMerzgebieteGeoData"]
  }), {
    timelineViewInput: function timelineViewInput() {
      if (!this.sidebarRightList) {
        return;
      }
      var out = [];
      this.sidebarRightList.filter(function (it) {
        return it.id === "holland" || it.id === "merzabende";
      }).forEach(function (it) {
        it.infoItems.forEach(function (info) {
          out.push(info);
        });
      });
      out.sort(function (a, b) {
        a = a.row.datvon;
        b = b.row.datvon;
        if (a > b) {
          return 1;
        } else if (a < b) {
          return -1;
        }
        return 0;
      });
      return out;
    }
  })
});

/***/ }),

/***/ 939:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    cols: Number,
    sidebar_left_collapse: Boolean,
    sidebar_right_collapse: Boolean,
    sidebar_left_width: String,
    sidebar_right_width: String,
    group: Number
  },
  data: function data() {
    return {
      minWidthSidebar1: 250,
      maxWidthSidebar1: 800,
      minWidthSidebar2: 250,
      maxWidthSidebar2: 800,
      widthRight: null,
      widthLeft: null,
      leftCollapse: false,
      rightCollapse: false,
      leftMove: null,
      startSplit: null,
      startPos: null,
      dragging: false
    };
  },

  mounted: function mounted() {
    var _this = this;

    if (this.cols == 3) {
      this.widthLeft = this.$refs["sidebar-1"].clientWidth;
    }
    this.widthRight = this.$refs["sidebar-2"].clientWidth;
    this.leftCollapse = this.sidebar_left_collapse;
    this.rightCollapse = this.sidebar_right_collapse;
    var vue = this;
    this.$store.state.eventBus.$on("splitlayout-sidebar-open" + this.group, function (id) {
      if (id == 1) {
        _this.leftCollapse = false;
      } else if (id == 2) {
        _this.rightCollapse = false;
      }
    });
  },
  watch: {},
  methods: {
    setCollapseRight: function setCollapseRight() {
      this.rightCollapse = !this.rightCollapse;
      var s = this.$refs["sidebar-2"];
      s.classList.add("animation");
      setTimeout(function () {
        s.classList.remove("animation");
      }, 300);
      this.$emit("clickCollapse");
    },
    setCollapseLeft: function setCollapseLeft() {
      this.leftCollapse = !this.leftCollapse;
      var s = this.$refs["sidebar-1"];
      s.classList.add("animation");
      setTimeout(function () {
        s.classList.remove("animation");
      }, 300);
      this.$emit("clickCollapse");
    },
    dragStart: function dragStart(e, isLeft) {
      e.preventDefault();
      this.dragging = true;
      this.startPos = e.pageX;
      if (isLeft) {
        this.startSplit = this.widthLeft;
      } else {
        this.startSplit = this.widthRight;
      }
      this.leftMove = isLeft;
      e.target.classList.add("movie");
      e.stopPropagation();
    },
    dragMove: function dragMove(e) {
      if (this.dragging) {
        e.preventDefault();
        var dx = e.pageX - this.startPos;
        if (this.leftMove) {
          this.widthLeft = this.startSplit + dx;
        } else {
          this.widthRight = this.startSplit - dx;
        }
        e.stopPropagation();
      }
    },
    dragStop: function dragStop(e) {
      e.target.classList.remove("movie");
      if (this.dragging) {
        e.preventDefault();
        this.dragging = false;
        e.stopPropagation();
        this.$emit("dragStop");
        this.$store.state.eventBus.$emit('dragStop');
      }
    }
  },
  computed: {
    defaultStyleSidebar: function defaultStyleSidebar() {
      return this.cols === 2 ? "width:30%" : "width:20%";
    },
    modus: function modus() {
      return this.$route.params.modus;
    },
    styleSidebar1: function styleSidebar1() {
      if (this.widthLeft == null) {
        return this.sidebar_left_width ? this.sidebar_left_width : this.defaultStyleSidebar;
      } else {
        return "width:" + this.widthSidebar1;
      }
    },
    widthSidebar1: function widthSidebar1() {
      if (this.leftCollapse) {
        return "0px";
      }

      if (this.widthLeft < this.minWidthSidebar1) {
        return this.minWidthSidebar1 + "px";
      }

      if (this.widthLeft > this.maxWidthSidebar1) {
        return this.maxWidthSidebar1 + "px";
      }
      return this.widthLeft + "px";
    },
    styleSidebar2: function styleSidebar2() {
      if (this.widthRight == null) {
        return this.sidebar_right_width ? this.sidebar_right_width : this.defaultStyleSidebar;
      } else {
        return "width:" + this.widthSidebar2;
      }
    },
    widthSidebar2: function widthSidebar2() {
      if (this.rightCollapse) {
        return "0px";
      }
      if (this.widthRight < this.minWidthSidebar2) {
        return this.minWidthSidebar2 + "px";
      }

      if (this.widthRight > this.maxWidthSidebar2) {
        return this.maxWidthSidebar2 + "px";
      }
      return this.widthRight + "px";
    }
  }
});

/***/ }),

/***/ 940:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    seiteIdx: Number,
    seiten: Array,
    aligen: String,
    imageHeight: Number
  },
  data: function data() {
    return {};
  },

  watch: {
    thumbnailSrc: function thumbnailSrc() {
      var vue = this;
      setTimeout(function () {
        var i = vue.seiteIdx;
        var imgElemente = vue.$el.querySelectorAll(".ksm-thumbnail");
        if (imgElemente && imgElemente[i]) {
          imgElemente[i].scrollIntoView({ behavior: "smooth" });
        }
      }, 300);
    },
    seiteIdx: function seiteIdx(i) {}
  },

  mounted: function mounted() {},
  methods: {
    selectItem: function selectItem(i) {
      this.$emit("selectItem", i);
    }
  },
  computed: {
    modus: function modus() {
      var m = this.$route.params.modus;
      return m ? m : "default";
    },
    seite: function seite() {
      if (!this.seiten) {
        return;
      }
      return this.seiten[this.seiteIdx];
    },
    thumbnailSrc: function thumbnailSrc() {
      if (!this.seite) {
        return;
      }
      return this.seite.thumbnailSrc;
    }
  }
});

/***/ }),

/***/ 941:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_utils__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_datepicker__ = __webpack_require__(2005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_datepicker__);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["fullDoc", "toolbarItemData", "type", "infoItemList", "activeInfoItem", "splitLayoutResize"],
  data: function data() {
    return {
      tooltipStyle: "",
      tooltipOption: {
        show: true,
        content: "",
        placement: "top-center",
        classes: ["timeline-info"],
        offset: 10,
        delay: {
          show: 0,
          hide: 0
        }
      },

      timelineData: null,
      hoverItems: null,
      brushSelection: null,
      briefWechselData: null,
      senderTimelineData: null,
      receiverTimelineData: null,
      initSenderId: null,
      leftSide: 10,
      width: null,
      height: 75,
      rightSide: 5,
      rectHeight: 25,
      lineY: 40,
      minDate: null,
      maxDate: null,
      currentTransform: null,
      zoomScaleExtent: [1, 50],
      zoomScale: null,
      zoomVal: 0,
      origScale: null,
      w: 0,
      timerId: null,
      showLoading: true,
      vonbis: null,
      zooming: false,
      zoomBrush: null,
      zoomEventFromBrush: false,
      vonDatum: null,
      bisDatum: null,
      notDayBefore: null,
      notDayAfter: null,
      dateVonFormat: {
        stringify: function stringify(date) {
          return date ? __WEBPACK_IMPORTED_MODULE_4_moment__(date).format("DD.MM.YYYY") : null;
        },
        parse: function parse(value) {
          if (value) {
            value = value + "";
            var len = value.split(".").length;
            if (len == 1) {
              value = "01.01." + value;
            } else if (len == 2) {
              value = "01." + value;
            }
          }
          return value ? __WEBPACK_IMPORTED_MODULE_4_moment__(value, "DD.MM.YYYY") : null;
        }
      },
      dateBisFormat: {
        stringify: function stringify(date) {
          return date ? __WEBPACK_IMPORTED_MODULE_4_moment__(date).format("DD.MM.YYYY") : null;
        },
        parse: function parse(value) {
          if (value) {
            value = value.replace(/[,-\/]/g, ".");
            value = value + "";
            var len = value.split(".").length;
            if (len == 1) {
              value = "31.12." + value;
            } else if (len == 2) {
              return __WEBPACK_IMPORTED_MODULE_4_moment__(value, "MM.YYYY").endOf("month");
            }
          }
          return value ? __WEBPACK_IMPORTED_MODULE_4_moment__(value, "DD.MM.YYYY") : null;
        }
      }
    };
  },

  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_6_vue2_datepicker___default.a
  },
  computed: {
    a_baseDocuments: function a_baseDocuments() {
      if (!this.toolbarItemData || !this.toolbarItemData._baseProjects) {
        return;
      }
      return this.$store.getters.getDocumentsByProjectIds(this.toolbarItemData._baseProjects.map(function (p) {
        return p.id;
      }));
    },
    isBriefWechsel: function isBriefWechsel() {
      return this.type === "briefWechsel";
    }
  },
  watch: {
    a_baseDocuments: function a_baseDocuments() {
      if (!this.isBriefWechsel) {
        this.a_initData();
      }
    },
    hoverItems: function hoverItems(_hoverItems) {
      var t = "";
      if (_hoverItems) {
        _hoverItems.forEach(function (it) {
          var row = it.row;
          var dateStr = row._datvon + " " + (row._datbis ? " &ndash; " + row._datbis : "");
          t += '<div class="ksm-flex"><div class="ksm-map__fenster-item-icon" style="background-color:' + it.accor.color + '"></div><div class="ksm-flex-1">' + dateStr + "</div></div>";
          t += "<div>" + (row.stadtname ? row.stadtname : "") + " " + (row.ortsname ? row.ortsname : "") + "</div>";
          t += "<div>" + row.short_113_html + "</div>";
          t = '<div style="margin-bottom:10px">' + t + "</div>";
        });
      }
      this.tooltipOption.content = t;
    },
    activeInfoItem: function activeInfoItem(d) {
      this.drawActiveInfoItem(d, "selected");
    },
    splitLayoutResize: function splitLayoutResize() {
      var vue = this;
      setTimeout(function () {
        vue.drawAll();
      }, 300);
    }
  },
  mounted: function mounted() {
    this.a_initData();

    var vue = this;
    setTimeout(function () {
      vue.showLoading = false;
    }, 5000);
  },
  methods: {
    a_initData: function a_initData() {
      var vue = this;
      var infoItemList = this.infoItemList;
      if (!infoItemList || infoItemList.length == 0) {
        return;
      }

      var parseTime = __WEBPACK_IMPORTED_MODULE_3_d3__["f" /* timeParse */]("%Y-%m-%d");

      var list = this.infoItemList.map(function (doc) {
        var d = parseTime(doc.row.datvon);

        return {
          item: doc,
          date: d
        };
      }).sort(function (a, b) {
        return a.date - b.date;
      });

      vue.minDate = list[0].date;
      vue.maxDate = list[list.length - 1].date;
      vue.timelineData = list;
      vue.showLoading = false;
      vue.drawAll();
      window.addEventListener("resize", function () {
        vue.drawAll();
      });
    },
    a_brushended: function a_brushended() {
      if (this.zooming) {
        return;
      }
      var selection = __WEBPACK_IMPORTED_MODULE_3_d3__["g" /* event */].selection;
      if (!__WEBPACK_IMPORTED_MODULE_3_d3__["g" /* event */].sourceEvent) return;
      if (!selection) return;
      this.brushSelection = selection;
      this.a_dispatchDateChanged();
    },
    a_debounce: function a_debounce(fn, wait) {
      wait = wait || 0;
      var vue = this;
      var timerId = this.timerId;
      function a_debounced() {
        if (timerId) {
          clearTimeout(timerId);
          timerId = null;
        }
        timerId = setTimeout(function () {
          fn();
        }, wait);
        vue.timerId = timerId;
      }

      return a_debounced;
    },
    a_dispatchDateChanged: function a_dispatchDateChanged() {
      if (this.isBriefWechsel) {
        return;
      }
      var brushSelection = this.brushSelection;
      if (!brushSelection) {
        var rect = this.brushContainer.select("rect.selection");
        var xVon = rect.attr("x");
        var xBis = -(-xVon - rect.attr("width"));
        brushSelection = [xVon, xBis];
      }

      var vue = this;
      var scale = this.zoomScale || this.origScale;
      var vonbis = brushSelection.map(scale.invert);
      this.vonbis = vonbis;
      this.a_setBrushText(vonbis);

      var vonStr = __WEBPACK_IMPORTED_MODULE_4_moment__(vonbis[0]).format("YYYY-MM-DD");
      var bisStr = __WEBPACK_IMPORTED_MODULE_4_moment__(vonbis[1]).format("YYYY-MM-DD");
      var set = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a();
      this.infoItemList.filter(function (it) {
        return it.row.datvon >= vonStr && it.row.datvon <= bisStr;
      }).forEach(function (it) {
        set.add(it.row.stadtindex);
      });

      setTimeout(function () {
        vue.$emit("changeDate", [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(set)));
      }, 1);
    },
    emptySvg: function emptySvg() {
      __WEBPACK_IMPORTED_MODULE_3_d3__["a" /* select */](this.$refs["background_container"]).selectAll("*").remove();
      __WEBPACK_IMPORTED_MODULE_3_d3__["a" /* select */](this.$refs["content_container"]).selectAll("*").remove();
    },
    zoomClick: function zoomClick(val) {
      this.zoom.scaleBy(this.zoomRect.transition().duration(500), val);
    },
    zoomed: function zoomed() {
      var vue = this;
      var transform = __WEBPACK_IMPORTED_MODULE_3_d3__["g" /* event */].transform;
      this.currentTransform = transform;
      var height = this.divContainer.clientHeight;
      var origScale = vue.origScale;
      var zoomScale = transform.rescaleX(origScale);
      this.xAxisContainer.call(vue.xAxis.scale(zoomScale));
      this.zoomScale = zoomScale;
      this.datebarContainer.selectAll(".ev-timeline__date-g").remove();

      this.zoomVal = transform.k;

      if (!this.isBriefWechsel) {
        var vonbis = this.vonbis;
        if (!vonbis) {
          vonbis = __WEBPACK_IMPORTED_MODULE_3_d3__["h" /* brushSelection */](this.brushContainer.node());
          vonbis = vonbis.map(origScale.invert);
          this.vonbis = vonbis;
        }

        var _origScale$domain$map = origScale.domain().map(zoomScale),
            _origScale$domain$map2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_origScale$domain$map, 2),
            xx = _origScale$domain$map2[0],
            yy = _origScale$domain$map2[1];

        this.zooming = true;
        this.brush.extent([[xx, 0], [yy, height]]);
        this.brushContainer.call(this.brush);
        this.brush.move(this.brushContainer, vonbis.map(zoomScale));
        this.zooming = false;
      }

      this.beforeDrawDateBar();
    },
    drawAll: function drawAll() {
      if (this.$route.name == "orteundwege" && this.$el.clientWidth > 0) {
        this.emptySvg();
        this.initTimeline();
        this.beforeDrawDateBar();
      }
    },
    beforeDrawDateBar: function beforeDrawDateBar() {
      var xScale = this.zoomScale || this.origScale;

      this.drawDateBar(xScale, this.timelineData);
      this.drawActiveInfoItem(this.activeInfoItem, "selected");
    },
    drawActiveInfoItem: function drawActiveInfoItem(activeInfoItem, className) {
      className = "ev-timeline__date-g--" + className;
      this.datebarContainer.selectAll("." + className).remove();
      if (!activeInfoItem) {
        return;
      }
      var datvon = activeInfoItem.row.datvon;
      var _h = this.rectHeight;

      var xScale = this.zoomScale || this.origScale;
      var selected = __WEBPACK_IMPORTED_MODULE_3_d3__["f" /* timeParse */]("%Y-%m-%d")(activeInfoItem.row.datvon);
      var x = xScale(selected) - 2;
      var g = this.datebarContainer.append("g").attr("class", "ev-timeline__date-g " + className).attr("transform", "translate(" + x + ",5)");

      g.append("rect").attr("fill", activeInfoItem.accor.color).attr("pointer-events", "all").attr("height", _h + 10).attr("width", 5);

      var otherSameDay = this.infoItemList.find(function (d) {
        return d.row.datvon === datvon && d !== activeInfoItem;
      });

      if (otherSameDay) {
        var _h2 = (_h + 10) / 2;
        var y = 0;
        if (otherSameDay.accor.id === "merzabende") {
          y = _h2;
        }
        g.append("rect").attr("fill", otherSameDay.accor.color).attr("pointer-events", "none").attr("y", y).attr("height", _h2).attr("width", 5);
      }
    },
    drawDateBar: function drawDateBar(xScale, data, className, rectHeight) {
      var vue = this;
      if (!data) {
        return [];
      }
      if (!className) {
        className = "";
      }
      if (!rectHeight) {
        rectHeight = vue.rectHeight;
      }
      var w = this.width;

      var von = xScale.invert(0);
      var bis = xScale.invert(w);
      var ranges = [];
      data.forEach(function (doc) {
        var d = doc.date;
        if (d < von || d > bis) {
          return;
        }
        var x = xScale(d);
        if (x < 0 || x > w) {
          return;
        }
        ranges.push([x, x + 5, doc]);
      });

      var activeX = 0;
      this.datebarContainer.selectAll("aa").data(ranges).enter().append("g").attr("class", "ev-timeline__date-g " + className).attr("transform", function (d) {
        var t = __WEBPACK_IMPORTED_MODULE_3_d3__["a" /* select */](this);
        t.append("rect").attr("class", "ev-timeline__datebar").attr("height", rectHeight).attr("width", d[1] - d[0]).attr("transform", function () {
          return "translate(0,15)";
        });
        return "translate(" + (d[0] - 2) + ",0)";
      });

      return ranges;
    },
    getMouseOverItems: function getMouseOverItems(x) {
      var vue = this;
      var scale = vue.zoomScale || vue.origScale;
      var item = null;
      var out = null;
      var parseTime = __WEBPACK_IMPORTED_MODULE_3_d3__["f" /* timeParse */]("%Y-%m-%d");
      vue.timelineData.forEach(function (td) {
        var tx = scale(td.date);
        if (x - 2 < tx && tx < x + 2) {
          item = td.item;
        }
      });

      if (item) {
        out = [item];
        var other = vue.infoItemList.find(function (d) {
          return d.row.datvon === item.row.datvon && d !== item;
        });
        if (other) {
          out.push(other);
        }
      }
      vue.hoverItems = out;
      return out;
    },
    a_setBrushText: function a_setBrushText(vonbis) {
      var vue = this;
      var w = this.w;
      var rect = vue.brushContainer.select("rect.selection");
      var xVon = rect.attr("x");
      var xBis = -(-xVon - rect.attr("width"));
      var vonStr = "";
      var bisStr = "";
      var invalid = false;
      if (!xVon || !xBis) {
        invalid = true;
      } else {
        if (!vonbis) {
          var scale = vue.zoomScale || vue.origScale;
          vonbis = [xVon, xBis].map(scale.invert);
        }
        vonStr = __WEBPACK_IMPORTED_MODULE_4_moment__(vonbis[0]).format("DD.MM.YYYY");
        bisStr = __WEBPACK_IMPORTED_MODULE_4_moment__(vonbis[1]).format("DD.MM.YYYY");
      }

      vue.vonDatum = __WEBPACK_IMPORTED_MODULE_4_moment__(vonbis[0]);
      vue.bisDatum = __WEBPACK_IMPORTED_MODULE_4_moment__(vonbis[1]);

      return;
      if (invalid) {
        return;
      }

      var dist = vue.textvon.node().getBBox().width;

      vue.textvon.attr("x", xVon - dist < 0 ? 5 : xVon - dist - 5);
      vue.textbis.attr("x", xBis >= w - dist ? w - dist - 5 : xBis + 5);
    },
    changeDatepicker: function changeDatepicker() {
      var dVon = new Date(this.vonDatum);
      var dBis = new Date(this.bisDatum);
      var scale = this.zoomScale || this.origScale;
      this.brushContainer.call(this.brush.move, [dVon, dBis].map(scale));
    },
    initTimeline: function initTimeline() {
      var svg = this.$refs["ev_corr-svg"];
      if (!svg) {
        return;
      }

      if (this.isBriefWechsel) {
        if (!this.senderTimelineData && !this.receiverTimelineData) {
          return;
        }
      } else if (!this.timelineData) {
        return;
      }

      var divContainer = this.$refs["svg-container"];
      this.divContainer = divContainer;
      this.width = divContainer.clientWidth;
      var vue = this;
      var lineY = this.lineY;

      var rootG = __WEBPACK_IMPORTED_MODULE_3_d3__["a" /* select */](this.$refs["background_container"]);

      rootG.append("line").attr("class", "separator-line").attr("x1", 0).attr("y1", lineY).attr("x2", vue.width).attr("y2", lineY);

      var w = vue.width - vue.rightSide - vue.leftSide;
      var h = divContainer.clientHeight;
      this.w = w;

      var clipPathId = "clip_ortundwege";
      __WEBPACK_IMPORTED_MODULE_3_d3__["a" /* select */](vue.$refs["clipPath"]).attr("id", clipPathId);
      __WEBPACK_IMPORTED_MODULE_3_d3__["a" /* select */](vue.$refs["clipPath_rect"]).attr("width", w).attr("height", h);

      var contentContainer = __WEBPACK_IMPORTED_MODULE_3_d3__["a" /* select */](this.$refs["content_container"]);
      contentContainer.attr("clip-path", "url(#" + clipPathId + ")");
      vue.contentContainer = contentContainer;

      var diff = this.isBriefWechsel ? 1 : 2;
      var origScale = __WEBPACK_IMPORTED_MODULE_3_d3__["i" /* scaleTime */]().range([0, w]).domain([__WEBPACK_IMPORTED_MODULE_4_moment__(vue.minDate).subtract(diff, "years"), __WEBPACK_IMPORTED_MODULE_4_moment__(vue.maxDate).add(diff, "years")]);
      vue.origScale = origScale;
      vue.notDayBefore = origScale.domain()[0];
      vue.notDayAfter = origScale.domain()[1];
      var xAxis = __WEBPACK_IMPORTED_MODULE_3_d3__["j" /* axisBottom */]().scale(origScale).tickFormat(__WEBPACK_IMPORTED_MODULE_5__utils_utils__["a" /* timelineTickFormat */]).tickSizeOuter(0).tickSizeInner(10);

      vue.xAxis = xAxis;

      var axisOffsetY = lineY;
      vue.xAxisContainer = contentContainer.append("g").attr("class", "x axis").call(xAxis).attr("transform", "translate(0," + axisOffsetY + ")");

      var zoom = __WEBPACK_IMPORTED_MODULE_3_d3__["k" /* zoom */]().translateExtent([[0, 0], [w, h]]).extent([[0, 0], [w, h]]).scaleExtent(vue.zoomScaleExtent).on("zoom", function () {
        if (vue.isBriefWechsel) {
          vue.zoomed();
          return;
        }
        if (this.tagName.toLowerCase() === "g") {
          if (!vue.zoomEventFromBrush) {
            vue.zoomEventFromBrush = true;
          } else {
            zoom.transform(vue.zoomRect, __WEBPACK_IMPORTED_MODULE_3_d3__["g" /* event */].transform);
          }
          return;
        } else {
          vue.zoomEventFromBrush = false;
          zoom.transform(vue.zoomBrush, __WEBPACK_IMPORTED_MODULE_3_d3__["g" /* event */].transform);
          vue.zoomed();
        }
      });

      var zoom2 = __WEBPACK_IMPORTED_MODULE_3_d3__["k" /* zoom */]().translateExtent([[0, 0], [w, h]]).extent([[0, 0], [w, h]]).scaleExtent(vue.zoomScaleExtent).on("zoom", function () {
        if (!vue.zoomEventFromBrush) {
          vue.zoomEventFromBrush = true;
          return;
        }
        zoom.transform(vue.zoomRect, __WEBPACK_IMPORTED_MODULE_3_d3__["g" /* event */].transform);
      }, true);

      vue.zoom = zoom;

      vue.zoomRect = contentContainer.append("rect").attr("class", "ev-timeline__zoom-rect").attr("width", w).attr("height", h).on("wheel", function () {
        __WEBPACK_IMPORTED_MODULE_3_d3__["g" /* event */].preventDefault();
      }).call(zoom);

      if (!this.isBriefWechsel) {
        var brush = __WEBPACK_IMPORTED_MODULE_3_d3__["l" /* brushX */]().extent([[0, 0], [w, h]]).on("brush", function () {
          vue.a_setBrushText();
          vue.a_brushended();
        });


        vue.brush = brush;

        var zoomBrush = contentContainer.append("g").call(zoom);
        this.zoomBrush = zoomBrush;
        var brushContainer = zoomBrush.append("g").attr("class", "ev-timeline__brush-container").on("wheel", function () {}).call(brush);
        vue.brushContainer = brushContainer;
        brushContainer.select("rect.overlay").attr("pointer-events", "none");
        brushContainer.select("rect.selection").attr("pointer-events", "auto");

        vue.textvon = brushContainer.append("text").attr("class", "ev-timeline__brush-label").attr("y", 12).text("");

        vue.textbis = brushContainer.append("text").attr("class", "ev-timeline__brush-label").attr("y", 12).text("");

        var moveExtent = null;
        if (!this.isBriefWechsel && this.toolbarItemData && this.toolbarItemData.timeDomain) {
          var _toolbarItemData$time = this.toolbarItemData.timeDomain.map(__WEBPACK_IMPORTED_MODULE_3_d3__["f" /* timeParse */]("%Y-%m-%d")),
              _toolbarItemData$time2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_toolbarItemData$time, 2),
              d0 = _toolbarItemData$time2[0],
              d1 = _toolbarItemData$time2[1];

          if (d0 !== undefined && d1 !== undefined) {
            moveExtent = [d0, d1].map(origScale);
          }
        }

        if (!moveExtent) {
          if (vue.minDate === vue.maxDate) {
            moveExtent = [5, w - 5];
          } else {
            moveExtent = [origScale(__WEBPACK_IMPORTED_MODULE_4_moment__(vue.minDate)), origScale(__WEBPACK_IMPORTED_MODULE_4_moment__(vue.maxDate))];
          }
        }
        brushContainer.call(brush.move, moveExtent);
      }

      contentContainer.on("mousemove", function () {
        var x = __WEBPACK_IMPORTED_MODULE_3_d3__["m" /* mouse */](this)[0];
        var items = vue.getMouseOverItems(x);
        if (items) {
          vue.tooltipStyle = "left:" + x + "px;";
          vue.drawActiveInfoItem(items[0], "hover");
        } else {
          vue.drawActiveInfoItem(null, "hover");
          vue.tooltipStyle = "display:none";
        }
      }).on("click", function () {
        if (vue.hoverItems) {
          vue.$emit("clickInfoItem", vue.hoverItems[0]);
        }
      });

      vue.datebarContainer = contentContainer.append("g").attr("class", "ev-timeline__date-container");
    }
  }
});

/***/ }),

/***/ 942:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "g-checkbox",
  props: ["checked", "size"],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 943:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "g-connect-btn",
  props: ["rotate"],
  data: function data() {
    return {
      isConnected: false
    };
  },

  methods: {
    stopEvent: function stopEvent(evt) {
      evt.stopPropagation();
      evt.preventDefault();
      evt.stopImmediatePropagation();
      evt.cancelBubble = true;
    },
    doClick: function doClick(evt) {
      this.isConnected = !this.isConnected;
      this.stopEvent(evt);
      this.$emit("connectClick", this.isConnected);
    }
  }
});

/***/ }),

/***/ 944:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "g-play-btn",
  props: ["isPlaying", "size"],
  data: function data() {
    return {};
  },

  methods: {
    stopEvent: function stopEvent(evt) {
      evt.stopPropagation();
      evt.preventDefault();
      evt.stopImmediatePropagation();
      evt.cancelBubble = true;
    },
    doClick: function doClick(evt) {
      this.stopEvent(evt);
      this.$emit("click");
    }
  }
});

/***/ }),

/***/ 945:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "g-format-html",
  props: ["inputData"],
  data: function data() {
    return {};
  },

  mounted: function mounted() {},
  computed: {
    list: function list() {
      if (!this.inputData) {
        return;
      }
      var _inputData = this.inputData,
          n = _inputData.n,
          merz = _inputData.merz,
          doc = _inputData.doc,
          addLink = _inputData.addLink,
          seite = _inputData.seite,
          accordion = _inputData.accordion,
          modus = _inputData.modus;


      var div = this.$_getNewHtmlElement(n.html, merz, doc, addLink);
      div.classList.add("ksm-accordion__section");
      div.setAttribute("data-acco", accordion.id + "#" + n.ID);
      var obj = seite.$_accoId_transcript_mapping[n.category].find(function (c) {
        return c.ID === n.ID;
      });

      if (obj && obj.ids.length > 0) {
        div.setAttribute("data-transcript", obj.ids.join(","));
        modus === "ansicht" ? "" : div.classList.add("div-with-transcript");
      }
      return div.outerHTML;
    }
  },
  methods: {}
});

/***/ }),

/***/ 946:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "g-person-merz",
  props: ["person", "modusOption"],
  data: function data() {
    return {};
  },

  computed: {
    accoExpandPersonList: function accoExpandPersonList() {
      if (this.modusOption) {
        return this.modusOption.accoExpandPersonList;
      }
    }
  },
  methods: {
    isSeiteSelected: function isSeiteSelected(it, it2, perId) {
      var query = this.$route.query;
      if (!query) {
        return;
      }
      var merzId = query.merzId;
      if (!merzId) {
        return;
      }
      var seiteIdx = query.seiteIdx;
      return it.merz.id === merzId && seiteIdx - it2.idx === 0;
    },
    toPath: function toPath(it, it2, perId) {
      var option = this.modusOption;
      var query = {
        merzId: it.merz.id,
        seiteIdx: it2.idx
      };
      var b_query = {
        b_merzId: it.merz.id,
        b_seiteIdx: it2.idx
      };

      var useQuery = void 0;
      var path = void 0;
      var modusId = void 0;

      if (option && option.key.match(/^b_/)) {
        modusId = "vergleichsmodus";
        useQuery = b_query;
      } else if (option) {
        modusId = option.key + "smodus";
        useQuery = query;
      } else {
        modusId = "untersuchungsmodus";
        useQuery = query;
      }

      var merzName = it.merz.name;
      if (merzName.indexOf("Merz") === 0) {
        path = "/texte/merzhefte/" + modusId;
      } else if (merzName === "ursonate") {} else {
        if (this.$route.name === "texte-modus" && modusId === "vergleichsmodus") {
          useQuery = query;
        }
        path = "/merzwerbe/untersuchungsmodus";
      }

      this.$store.commit("addAccoPersonList", {
        path: path,
        query: useQuery,
        perId: perId,
        merzId: it.merz.id,
        seiteIdx: it2.idx
      });

      if (!path) {
        this.$router.push({
          query: useQuery
        });
      } else {
        this.$router.push({
          path: path,
          query: useQuery
        });
      }
    }
  }
});

/***/ }),

/***/ 947:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "g-loading",
  props: ["size"],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 948:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "g-loading-circle",
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 949:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "g-loading-mask",
  props: ["size"],
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 950:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      scrollElementList: []
    };
  },

  activated: function activated() {
    this.scrollElementList.forEach(function (item) {
      item.element.scrollTop = item.top;
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.scrollElementList.length < 1) {
      this.addScrollElement(this.$refs.scrollElement);
    }

    this.scrollElementList.forEach(function (item) {
      item.top = item.element.scrollTop;
    });
    next();
  },
  methods: {
    addScrollElement: function addScrollElement(elem) {
      if (!elem) {
        return;
      }
      this.scrollElementList.push({
        element: elem,
        top: 0
      });
    }
  }
});

/***/ }),

/***/ 951:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  created: function created() {},
  watch: {},

  mounted: function mounted() {},
  methods: {
    changeSeite: function changeSeite(i) {
      this.$_modusChangeEvent("modus/changeModusSeite", {
        modus: this.modus,
        seiteIdx: i
      });
    },
    b_changeSeite: function b_changeSeite(i, type) {
      this.$_modusChangeEvent("modus/b_changeSeite", {
        modus: this.modus,
        seiteIdx: i
      });
    }
  },
  computed: {
    modus: function modus() {
      return this.$store.getters["modus/getModusByIdKey"]({
        modusId: this.modusId,
        viewKey: this.viewKey
      });
    },
    merz: function merz() {
      return this.$store.getters["modus/getModusMerz"](this.modus);
    },
    seiteIdx: function seiteIdx() {
      return this.$store.getters["modus/getModusSeiteIdx"](this.modus);
    },
    seite: function seite() {
      if (this.seiten && this.seiteIdx != undefined) {
        return this.seiten[this.seiteIdx];
      }
    },
    seiten: function seiten() {
      return this.$store.getters["modus/getModusSeiten"](this.modus);
    },
    modusOption: function modusOption() {
      return this.modus.option;
    },
    b_merz: function b_merz() {
      return this.$store.getters["modus/b_merz"](this.modus);
    },
    b_seiteIdx: function b_seiteIdx() {
      return this.$store.getters["modus/b_seiteIdx"](this.modus);
    },
    b_seiten: function b_seiten() {
      return this.$store.getters["modus/b_seiten"](this.modus);
    },
    b_modusOption: function b_modusOption() {
      return this.modus.option.b;
    }
  }
});

/***/ }),

/***/ 952:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      routeName: null,
      localParams: {},
      enableParams: true };
  },

  created: function created() {
    this.routeName = this.$route.name;
  },
  watch: {
    $route: function $route(to, from) {
      if (this.$route.name !== this.routeName) {
        return;
      }
      this.urlToLocal();
      this.localToUrl();
    },

    localParams: {
      handler: function handler(d) {
        this.localToUrl();

        this.$store.commit("updateObject", {
          from: d,
          to: this.stateUrlParams
        });
      },

      deep: true
    }
  },
  activated: function activated() {
    this.urlToLocal();
    this.localToUrl();
  },

  mounted: function mounted() {},
  methods: {
    urlToLocal: function urlToLocal() {
      var queryParams = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$route.query));
      var localParams = this.localParams;
      var hasDiff = false;
      for (var key in queryParams) {
        var val = queryParams[key];
        if (val !== null && val !== undefined && localParams[key] !== undefined && val !== localParams[key]) {
          localParams[key] = val;
          hasDiff = true;
        }
      }
      if (hasDiff) {}
      return hasDiff;
    },
    localToUrl: function localToUrl() {
      if (!this.enableParams) {
        return;
      }

      var queryParams = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$route.query));
      var localParams = this.localParams;
      var hasDiff = false;
      for (var key in localParams) {
        var val = localParams[key];
        if (val !== null && val !== undefined && val !== queryParams[key]) {
          queryParams[key] = val;
          hasDiff = true;
        }
      }

      if (hasDiff) {
        this.$router.push({
          query: queryParams
        });
      }
      return hasDiff;
    }
  },
  computed: {}
});

/***/ }),

/***/ 953:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_comps_DeepzoomView_vue__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_comps_DeepzoomView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_comps_DeepzoomView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_comps_Thumbnail_vue__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_comps_Thumbnail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_comps_Thumbnail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_comps_SplitLayout_vue__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_comps_SplitLayout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_comps_SplitLayout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sidebar_vue__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Sidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_comps_mixins_Modus_vue__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_comps_mixins_Modus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_comps_mixins_Modus_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["viewKey"],
  mixins: [__WEBPACK_IMPORTED_MODULE_5_comps_mixins_Modus_vue___default.a],
  components: {
    "deepzoom-view": __WEBPACK_IMPORTED_MODULE_0_comps_DeepzoomView_vue___default.a,
    "split-layout": __WEBPACK_IMPORTED_MODULE_2_comps_SplitLayout_vue___default.a,
    "sidebar-view": __WEBPACK_IMPORTED_MODULE_3__Sidebar_vue___default.a,
    "foot-thumbnail": __WEBPACK_IMPORTED_MODULE_1_comps_Thumbnail_vue___default.a
  },
  data: function data() {
    return {
      modusId: "ansichtsmodus"
    };
  },

  methods: {},
  computed: {
    einfuehrung: function einfuehrung() {
      var merz = this.merz;
      if (!merz || !merz.$_einfuehrungDoc) {
        return;
      }

      var newDiv = this.$_getNewHtmlElement(merz.$_einfuehrungDoc._source["114_html"], merz, merz.$_einfuehrungDoc, true);

      return newDiv.outerHTML;
    }
  }
});

/***/ }),

/***/ 954:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar_vue__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Sidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_comps_SplitLayout_vue__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_comps_SplitLayout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_comps_SplitLayout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_comps_DeepzoomView_vue__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_comps_DeepzoomView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_comps_DeepzoomView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_comps_FabricView_vue__ = __webpack_require__(1911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_comps_FabricView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_comps_FabricView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_fabric__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_fabric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_fabric__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_comps_mixins_Modus_vue__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_comps_mixins_Modus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_comps_mixins_Modus_vue__);












/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7_comps_mixins_Modus_vue___default.a],
  components: {
    "split-layout": __WEBPACK_IMPORTED_MODULE_2_comps_SplitLayout_vue___default.a,
    "fasimile-comp": __WEBPACK_IMPORTED_MODULE_4_comps_DeepzoomView_vue___default.a,
    "fabric-comp": __WEBPACK_IMPORTED_MODULE_5_comps_FabricView_vue___default.a,
    "sidebar-view": __WEBPACK_IMPORTED_MODULE_1__Sidebar_vue___default.a
  },
  props: {
    viewKey: String
  },
  data: function data() {
    return {
      modusId: "kompositionsmodus",
      images: [],
      imageOffsetX: 0,
      imageOffsetY: 0,
      canvasOffset: null,
      canvas: null,
      canvasContainer: null,
      deepzoomOpened: false,
      zoom: null,
      syncZoomEnable: false
    };
  },

  watch: {
    fetchCropImages: function fetchCropImages() {
      var vue = this;
      var handleDragStart = vue.handleDragStart;
      var handleDragEnd = vue.handleDragEnd;
      var furniture = this.$el.querySelector(".furniture");
      var images = furniture.querySelectorAll("img");
      vue.images = images;
      images.forEach(function (img) {
        img.addEventListener("dragstart", handleDragStart, false);
        img.addEventListener("dragend", handleDragEnd, false);
      });
    },
    seite: function seite() {
      if (this.fetchCropImages) {
        return;
      }
      this.images = [];
    }
  },
  mounted: function mounted() {
    this.fabricComp = this.$refs["fabricComp"];
    this.fabricViewer = this.fabricComp.viewer;
    this.fabricjsOverlay = this.fabricComp.fabricjsOverlay;
    this.fabricjsOverlayCanvas = this.fabricjsOverlay.canvas();
    this.fabricCanvas = this.fabricjsOverlay.fabricCanvas();

    this.fasimileComp = this.$refs["fasimileComp"];
    this.fasimileViewer = this.fasimileComp.viewer;
    this.initFabricCanvasDrag();
  },
  activated: function activated() {
    var zoom = this.zoom;
    if (zoom > 0 && this.fabricViewer) {
      var viewport = this.fabricViewer.viewport;
    }
  },
  deactivated: function deactivated() {
    this.zoom = this.fabricViewer.viewport.getZoom();
  },

  computed: {
    fetchCropImages: function fetchCropImages() {
      var seite = this.seite;
      if (!seite || !seite._.fetchCropImagesEnd) {
        return;
      }
      return true;
    }
  },

  methods: {
    initFabricCanvasDrag: function initFabricCanvasDrag() {
      var vue = this;
      var canvasContainer = vue.fabricViewer.container;
      function handleDragOver(e) {
        if (e.preventDefault) {
          e.preventDefault();
        }
        e.dataTransfer.dropEffect = "copy";
        return false;
      }

      function handleDragEnter(e) {
        this.classList.add("over");
      }

      function handleDragLeave(e) {
        this.classList.remove("over");
      }

      function handleDrop(e) {
        e = e || window.event;
        if (e.preventDefault) {
          e.preventDefault();
        }

        var fabricCanvas = vue.fabricCanvas;
        var canvasOffset = vue.fabricViewer.container.getBoundingClientRect();
        var offsetPoint = vue.fabricjsOverlay.offsetPoint();
        var fabricZoom = fabricCanvas.getZoom();

        if (e.stopPropagation) {
          e.stopPropagation();
        }
        var draggingImg = vue.$el.querySelector(".furniture img.img_dragging");
        if (!draggingImg) {
          return;
        }

        var y = e.clientY - (canvasOffset.top + vue.imageOffsetY - offsetPoint.y);
        var x = e.clientX - (canvasOffset.left + vue.imageOffsetX - offsetPoint.x);

        var w = draggingImg.width / fabricZoom;
        var h = draggingImg.height / fabricZoom;

        var newImage = new __WEBPACK_IMPORTED_MODULE_6_fabric__["fabric"].Image(draggingImg, {
          width: w,
          height: h,
          left: x / fabricZoom,
          top: y / fabricZoom
        });
        var trID = draggingImg.getAttribute("data-trid");
        newImage.set("id", vue.getImgFileName(trID));

        fabricCanvas.add(newImage);
        return false;
      }

      canvasContainer.addEventListener("dragenter", handleDragEnter, false);
      canvasContainer.addEventListener("dragover", handleDragOver, false);
      canvasContainer.addEventListener("dragleave", handleDragLeave, false);
      canvasContainer.addEventListener("drop", handleDrop, false);
    },
    getImgFileName: function getImgFileName(trID) {
      if (!this.seite || !this.seite.$_allTranscripts) {
        return trID;
      }
      var obj = this.seite.$_allTranscripts.find(function (obj) {
        return obj.transcripts.find(function (tr) {
          return tr.id === trID;
        });
      });
      if (obj) {
        var docID = obj.docID;
        var doc = this.seite.docs.find(function (d) {
          return d.docID - docID === 0;
        });
        if (doc) {
          trID = trID + "#" + doc.filename;
        }
      }
      return trID;
    },
    updateRightViewer: function updateRightViewer(playload) {
      if (!this.syncZoomEnable) {
        return;
      }
      var viewport = this.fasimileViewer.viewport;
      switch (playload.type) {
        case "canvas-drag":
          if (!this.syncZoomEnable) {
            return;
          }
          if (viewport.getCenter() - playload.center !== 0) {
            viewport.panTo(playload.center, false);
          }
          break;

        case "zoom":
          if (!this.syncZoomEnable) {
            return;
          }
          if (playload.zoom - viewport.getZoom() !== 0) {
            viewport.zoomTo(playload.zoom, true);
            viewport.panTo(playload.center, false);
          }
          break;
      }
    },
    updateLeftViewer: function updateLeftViewer(playload) {
      var viewport = this.fabricViewer.viewport;
      switch (playload.type) {
        case "canvas-drag":
          if (!this.syncZoomEnable) {
            return;
          }
          if (viewport.getCenter() - playload.center !== 0) {
            viewport.panTo(playload.center, false);
          }
          break;

        case "zoom":
          if (!this.syncZoomEnable) {
            return;
          }
          if (playload.zoom - viewport.getZoom() !== 0) {
            viewport.zoomTo(playload.zoom, true);
            viewport.panTo(playload.center, false);
          }
          break;

        case "transcript-double-click":
          this._addTranscriptElementPerClick(playload);
          break;

        case "dragTranscriptElementEnd":
          this._addTranscriptElementPerDrag(playload);
          break;
      }
    },
    _addTranscriptElementPerDrag: function _addTranscriptElementPerDrag(playload) {
      var div = playload.div;
      if (!div) {
        return;
      }
      var fabricCanvas = this.fabricCanvas;
      var divOffset = div.getBoundingClientRect();
      var canvasOffset = this.fabricViewer.container.getBoundingClientRect();
      var offsetPoint = this.fabricjsOverlay.offsetPoint();
      var fabricZoom = fabricCanvas.getZoom();

      if (canvasOffset.left + canvasOffset.width - divOffset.width < divOffset.left || divOffset.height + divOffset.top > canvasOffset.top + canvasOffset.height) {
        document.body.removeChild(div);
        return;
      }

      var imgCanvas = div.querySelector("canvas");
      var w = imgCanvas.width / fabricZoom;
      var h = imgCanvas.height / fabricZoom;
      var x = divOffset.left - canvasOffset.left + offsetPoint.x;
      var y = divOffset.top - canvasOffset.top + offsetPoint.y;

      var img = new __WEBPACK_IMPORTED_MODULE_6_fabric__["fabric"].Image(imgCanvas, {
        width: w,
        height: h,
        left: x / fabricZoom,
        top: y / fabricZoom
      });
      var trID = div.getAttribute("data-trid");
      img.set("id", this.getImgFileName(trID));
      fabricCanvas.add(img);
      fabricCanvas.setActiveObject(img);
      document.body.removeChild(div);
    },
    _addTranscriptElementPerClick: function _addTranscriptElementPerClick(playload) {
      var transcripts = playload.data;
      var div = playload.dragDiv;

      if (!transcripts) {
        document.body.removeChild(div);
        return;
      }
      var fabricViewer = this.fabricViewer;
      var viewport = fabricViewer.viewport;
      var ctx = fabricViewer.drawer.context;
      var fabricCanvas = this.fabricCanvas;
      var canvasOffset = fabricViewer.container.getBoundingClientRect();

      transcripts.forEach(function (tr) {
        var pos = viewport.imageToViewerElementCoordinates(new OpenSeadragon.Point(tr.x, tr.y));
        var viewportZoom = viewport.getZoom(true);
        var image1 = fabricViewer.world.getItemAt(0);
        var zoom = image1.viewportToImageZoom(viewportZoom);
        var fabricZoom = fabricCanvas.getZoom();

        var _ref = [Number(pos.x), Number(pos.y), Number(tr.w * zoom), Number(tr.h * zoom)],
            x = _ref[0],
            y = _ref[1],
            w = _ref[2],
            h = _ref[3];
        var _ref2 = [Number(tr.x * zoom / fabricZoom), Number(tr.y * zoom / fabricZoom), Number(tr.w * zoom / fabricZoom), Number(tr.h * zoom / fabricZoom)],
            x2 = _ref2[0],
            y2 = _ref2[1],
            w2 = _ref2[2],
            h2 = _ref2[3];


        if (x < 0 || y < 0 || w < 1 || h < 1) {
          return;
        }

        div.addEventListener("transitionend", function (event) {
          var data = ctx.getImageData(x, y, w, h);
          var c = document.createElement("canvas");
          c.setAttribute("id", "_temp_canvas");
          c.width = w;
          c.height = h;
          c.getContext("2d").putImageData(data, 0, 0);
          __WEBPACK_IMPORTED_MODULE_6_fabric__["fabric"].Image.fromURL(c.toDataURL(), function (img) {
            img.left = x2;
            img.top = y2;
            img.width = w2;
            img.height = h2;
            img.id = tr.content;

            fabricCanvas.add(img);
            img.bringToFront();
            fabricCanvas.setActiveObject(img);
          });
          div.parentNode && div.parentNode.removeChild(div);
        }, false);
        div.style.left = x + canvasOffset.left + "px";
      });
    },
    updateViewport: function updateViewport() {
      return;
      if (!this.deepzoomOpened) {
        return;
      }

      var canvas = this.canvas;
      canvas.clear();
      var fasimileViewer = this.fasimileViewer;
      var viewport = fasimileViewer.viewport;
      var ctx = fasimileViewer.drawer.context;
      if (deepzoom.transcripts && deepzoom.transcripts.length < 1000) {
        deepzoom.transcripts.forEach(function (tr) {
          var pos = viewer.viewport.imageToViewerElementCoordinates(new OpenSeadragon.Point(tr.x, tr.y));
          var viewportZoom = viewer.viewport.getZoom(true);
          var rotate = viewer.viewport.getRotation();
          var image1 = viewer.world.getItemAt(0);
          var zoom = image1.viewportToImageZoom(viewportZoom);

          var _ref3 = [Number(pos.x), Number(pos.y), Number(tr.w * zoom), Number(tr.h * zoom)],
              x = _ref3[0],
              y = _ref3[1],
              w = _ref3[2],
              h = _ref3[3];


          if (x < 0 || y < 0 || w < 1 || h < 1) {
            return;
          }

          var data = ctx.getImageData(x, y, w, h);
          var c = document.createElement("canvas");
          c.setAttribute("id", "_temp_canvas");
          c.width = w;
          c.height = h;
          c.getContext("2d").putImageData(data, 0, 0);
          __WEBPACK_IMPORTED_MODULE_6_fabric__["fabric"].Image.fromURL(c.toDataURL(), function (img) {
            img.left = x;
            img.top = y;
            img.id = tr.content;
            canvas.add(img);
            img.bringToFront();
            canvas.setActiveObject(img);
          });
        });
      }
    },
    imageOpened: function imageOpened() {
      this.deepzoomOpened = true;
    },
    selectPage: function selectPage(i) {
      this.$_modusChangeEvent("modus/changeSeite", i);
    },
    resizeCanvas: function resizeCanvas() {
      this.canvas.setHeight(this.canvasContainer.clientHeight);
      this.canvas.setWidth(this.canvasContainer.clientWidth);
    },
    handleDragStart: function handleDragStart(e) {
      var vue = this;
      var targetImg = e.target;
      var images = vue.$el.querySelector(".furniture img.img_dragging");
      if (images) {
        [].forEach.call(images, function (img) {
          img.classList.remove("img_dragging");
        });
      }
      targetImg.classList.add("img_dragging");
      var imageOffset = $(targetImg).offset();
      this.imageOffsetX = e.clientX - imageOffset.left;
      this.imageOffsetY = e.clientY - imageOffset.top;
    },
    handleDragEnd: function handleDragEnd(e) {
      e.target.classList.remove("img_dragging");
    },
    save: function save() {
      var canvas = this.canvas;
      var o = canvas.toJSON(["id"]);
      console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(o));
    },
    loadTest: function loadTest() {}
  }
});

/***/ }),

/***/ 955:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Ansicht_vue__ = __webpack_require__(1922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Ansicht_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Ansicht_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Vergleich_vue__ = __webpack_require__(1925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Vergleich_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Vergleich_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Komposition_vue__ = __webpack_require__(1923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Komposition_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Komposition_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Untersuchung_vue__ = __webpack_require__(1924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Untersuchung_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Untersuchung_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_comps_mixins_Modus_vue__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_comps_mixins_Modus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_comps_mixins_Modus_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "modusindexsite",
  props: ["viewKey"],
  mixins: [__WEBPACK_IMPORTED_MODULE_4_comps_mixins_Modus_vue___default.a],
  components: {
    ansichtsmodus: __WEBPACK_IMPORTED_MODULE_0__Ansicht_vue___default.a,
    vergleichsmodus: __WEBPACK_IMPORTED_MODULE_1__Vergleich_vue___default.a,
    kompositionsmodus: __WEBPACK_IMPORTED_MODULE_2__Komposition_vue___default.a,
    untersuchungsmodus: __WEBPACK_IMPORTED_MODULE_3__Untersuchung_vue___default.a
  },
  data: function data() {
    return {
      selectedUrlparmas: {
        merzId: null,
        seiteIdx: null,
        b_merzId: null,
        b_seiteIdx: null
      }
    };
  },

  watch: {
    modusUrlparams: {
      deep: true,
      handler: function handler(val, oldVal) {
        this.updateUrlparmams(val);
      }
    }
  },

  mounted: function mounted() {
    if (this.modusUrlparams) {
      this.updateUrlparmams(this.modusUrlparams);
    }
  },

  methods: {
    updateUrlparmams: function updateUrlparmams(val) {
      this.$_extend(this.selectedUrlparmas, val);
    },
    changeModus: function changeModus(modus) {
      this.$_modusChangeEvent("modus/changeModus", {
        modus: modus
      });
    },
    b_changeMerz: function b_changeMerz(e) {
      this.$_modusChangeEvent("modus/b_changeMerz", {
        modus: this.modus,
        merzId: e.target.value
      });
    },
    changeMerz: function changeMerz(e) {
      this.$_modusChangeEvent("modus/changeModusMerz", {
        modus: this.modus,
        merzId: e.target.value
      });
    },
    b_changeSeite: function b_changeSeite(e) {
      this.$_modusChangeEvent("modus/b_changeSeite", {
        modus: this.modus,
        seiteIdx: e.target.value
      });
    },
    changeSeite: function changeSeite(e) {
      this.$_modusChangeEvent("modus/changeModusSeite", {
        modus: this.modus,
        seiteIdx: e.target.value
      });
    },
    changeTransparent: function changeTransparent(e) {
      this.$_modusChangeEvent("modus/changeTransparenz", {
        modus: this.modus,
        val: e.target.value
      });
    }
  },
  computed: {
    sourceData: function sourceData() {
      return this.$store.state[this.viewKey];
    },
    modusData: function modusData() {
      return this.sourceData.modusData;
    },
    merzListe: function merzListe() {
      return this.sourceData.merzListe;
    },
    modus: function modus() {
      return this.modusData.active_modus;
    },
    modusUrlparams: function modusUrlparams() {
      return this.$store.getters["modus/getModusUrlparams"](this.modus);
    },
    transparenzValue: function transparenzValue() {
      var untersuchungsmodus = this.modusData.modusItems.find(function (m) {
        return m.id === "untersuchungsmodus";
      });
      return untersuchungsmodus.option.transparenz;
    }
  }
});

/***/ }),

/***/ 956:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_comps_Thumbnail__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_comps_Thumbnail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_comps_Thumbnail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_comps_MapView_vue__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_comps_MapView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_comps_MapView_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Thumbnail: __WEBPACK_IMPORTED_MODULE_2_comps_Thumbnail___default.a, MapView: __WEBPACK_IMPORTED_MODULE_3_comps_MapView_vue___default.a },
  props: {
    merz: Object,
    seiteIdx: Number,
    sidebarPageStyle: String,
    modusOption: Object
  },

  data: function data() {
    return {
      transcriptOverlayers: [],
      needReloadCropImages: true,
      stopFetchCropImg: false,
      cropImageList: [],
      geoData: null,
      map: null
    };
  },


  watch: {
    fetchSeiteDataDone: function fetchSeiteDataDone(a) {
      this.cropImageList = [];
      if (a && this.needReloadCropImages) {
        this.drawCropImages();
      }
    },
    seite: function seite(a) {
      this.stopFetchCropImg = true;
      this.cropImageList = [];
      if (!this.fetchSeiteDataDone) {
        this.needReloadCropImages = true;
      } else if (this.needReloadCropImages) {
        this.needReloadCropImages = false;
        this.drawCropImages();
      }
    }
  },
  created: function created() {
    var _this = this;

    this.$store.dispatch("orteundwege/fetchGeoData", this).then(function (res) {
      _this.geoData = res;
    });
  },
  methods: {
    gotoPerson: function gotoPerson(person) {
      this.$router.push({
        path: "/personen",
        query: {
          lemmaID: person.lemmaID
        }
      });
    },
    scrollToPersonById: function scrollToPersonById() {
      var vue = this;
      var ids = this.accoExpandPersonList;
      if (ids && ids.length > 0) {
        this.selectItem("acco_personen");
        var elem = this.$el.querySelector("[data-pid='" + ids[ids.length - 1].perId + "'");
        if (elem) {
          setTimeout(function () {
            elem.scrollIntoView({ behavior: "smooth" });
            var trElem = elem.querySelector("[data-transcript]");
            if (trElem) {
              var transcriptIds = trElem.getAttribute("data-transcript");
              if (transcriptIds) {
                var opt = vue.modusOption;
                vue.$store.state.eventBus.$emit(["mouseclick.sidebar", opt.viewKey, opt.key].join("-"), transcriptIds);
              }
            }
          }, 2000);
        }
      }
    },
    forEachFetchtranscriptCropImg: function forEachFetchtranscriptCropImg(tag, seite, partTranscripts) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var cropImageList, i, tr, trID, l, base64, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                cropImageList = _this2.cropImageList;
                i = 0, l = partTranscripts.length;

              case 2:
                if (!(i < l)) {
                  _context.next = 18;
                  break;
                }

                tr = partTranscripts[i];
                trID = tr.id;

                if (!_this2.stopFetchCropImg) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return");

              case 7:
                base64 = seite._.cropImages[tr.id];

                if (base64) {
                  _context.next = 14;
                  break;
                }

                _context.next = 11;
                return _this2.$store.dispatch("fetchtranscriptCropImg", {
                  id: trID,
                  tag: tag
                });

              case 11:
                res = _context.sent;

                base64 = "data:Image/png;base64," + res;
                seite._.cropImages[tr.id] = base64;

              case 14:
                cropImageList.push({
                  text: tr.text,
                  id: trID,
                  src: base64
                });

              case 15:
                i++;
                _context.next = 2;
                break;

              case 18:
                if (!seite._.fetchCropImagesEnd) {
                  seite._.fetchCropImagesEnd = true;
                }

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    isAccoPersonExpand: function isAccoPersonExpand(perId) {
      var _this3 = this;

      return this.accoExpandPersonList && this.accoExpandPersonList.find(function (p) {
        return p.perId === perId && p.merzId === _this3.merz.id && p.seiteIdx - _this3.seiteIdx === 0;
      });
    },
    togglePersonItem: function togglePersonItem(i) {
      this.$store.commit("updateAccoPersonList", {
        modusOption: this.modusOption,
        perId: i,
        merzId: this.merz.id,
        seiteIdx: this.seiteIdx
      });
    },
    mapInited: function mapInited(map) {
      this.map = map;
      setTimeout(function () {
        map.updateSize();
      }, 300);
    },
    drawCropImages: function drawCropImages() {
      var _this4 = this;

      this.stopFetchCropImg = false;
      var seite = this.seite;
      var graphElemente = this.graphElemente;
      if (!graphElemente) {
        return;
      }
      var _allTranscripts = seite.$_allTranscripts;
      seite.$_attachmentTags.forEach(function (at) {
        var docID = parseInt(at.docID, 10);
        var ids = graphElemente[docID];
        if (ids) {
          var seiteTrans = _allTranscripts.find(function (d) {
            return d.docID - docID === 0;
          });
          _this4.forEachFetchtranscriptCropImg(at.tag, seite, seiteTrans.transcripts.filter(function (tr) {
            return ids.indexOf(tr.id) > -1;
          }));
        }
      });
    },
    selectItem: function selectItem(id) {
      this.$store.dispatch("modus/updateModusOption", {
        modusOption: this.modusOption,
        key: this.modusOption.key + "/openedAccordionId",
        val: id
      });
    },
    selectThumbnail: function selectThumbnail(i) {
      this.$emit("changeSeite", i);
    },
    handleMouseover: function handleMouseover(e) {
      if (this.modusOption.key === "ansicht") {
        return;
      }

      var target = e.target;
      var vue = this;
      var transcriptIds = void 0;
      while (target.parentNode && !target.classList.contains("ksm-accordion__body")) {
        transcriptIds = target.getAttribute("data-transcript");
        if (transcriptIds) {
          break;
        } else {
          target = target.parentNode;
        }
      }

      transcriptIds = transcriptIds ? transcriptIds.split(",") : [];
      var opt = this.modusOption;
      this.$store.state.eventBus.$emit(["mouseover.sidebar", opt.viewKey, opt.key].join("-"), transcriptIds);
    },
    handleMouseout: function handleMouseout(e) {
      var opt = this.modusOption;
      this.$store.state.eventBus.$emit(["mouseover.sidebar", opt.viewKey, opt.key].join("-"), []);
    },
    handleMouseclick: function handleMouseclick(e) {
      var section = e.target;
      var transcriptIds = section.getAttribute("data-transcript");
      if (transcriptIds) {
        var opt = this.modusOption;
        this.$store.state.eventBus.$emit(["mouseclick.sidebar", opt.viewKey, opt.key].join("-"), transcriptIds);
      }
    },
    getAccordionHtml: function getAccordionHtml(accordion) {
      var _this5 = this;

      var out = [];
      var merz = this.merz;
      var seite = this.seite;
      var fudkeys = accordion.fudkeys;
      var modus = this.modusOption.key;

      this.seite.$_docInfo.forEach(function (doc) {
        var notes = doc._source.notes;
        if (!notes) {
          return;
        }

        notes.filter(function (n) {
          return fudkeys.indexOf(n.category) > -1;
        }).forEach(function (n) {
          var cat = n.category;
          if (cat == "Übersetzung" && n.html.indexOf("dt.:") == 0) {
            n.html = n.html.substring(4);
          }
          var div = _this5.$_getNewHtmlElement(n.html, merz, doc, true);
          div.classList.add("ksm-accordion__section");
          div.setAttribute("data-acco", accordion.id + "#" + n.ID);
          var obj = seite.$_accoId_transcript_mapping[cat].find(function (c) {
            return c.ID === n.ID;
          });

          if (obj && obj.ids.length > 0) {
            div.setAttribute("data-transcript", obj.ids.join(","));
            modus === "ansicht" ? "" : div.classList.add("div-with-transcript");
          }
          out.push(div.outerHTML);
        });
      });

      return out;
    },
    imgDragStart: function imgDragStart(e) {
      this.$emit("imgDragStart", e);
    },
    imgDragEnd: function imgDragEnd(e) {
      this.$emit("imgDragEnd", e);
    }
  },

  mounted: function mounted() {
    var vue = this;
    this.$store.state.eventBus.$on(["mouseover.transcripts", this.modusOption.viewKey, this.modusOption.key].join("-"), function (data) {
      var data_acco_strings = [];
      data.forEach(function (acco) {
        data_acco_strings.push(acco.accoID + "#" + acco.accoItemIdx);
      });

      var divs = vue.$el.querySelectorAll("[data-acco]");
      if (divs) {
        divs.forEach(function (div) {
          if (data_acco_strings.indexOf(div.getAttribute("data-acco")) > -1) {
            div.classList.add("div-with-transcript-hover");
          } else {
            div.classList.remove("div-with-transcript-hover");
          }
        });
      }
    });

    this.$store.state.eventBus.$on(["mouseover.transcripts.komposition", this.modusOption.viewKey, this.modusOption.key].join("-"), function (trs) {
      var divs = vue.$el.querySelectorAll("[data-acco]");
      var trID = void 0;
      if (trs && trs.length > 0) {
        trID = trs[0].id;
      }
      if (divs) {
        divs.forEach(function (div) {
          if (div.getAttribute("data-acco").indexOf(trID) > -1) {
            div.classList.add("div-with-transcript-hover");
          } else {
            div.classList.remove("div-with-transcript-hover");
          }
        });
      }
    });

    this.$store.state.eventBus.$on(["mouseclick.transcripts", this.modusOption.viewKey, this.modusOption.key].join("-"), function (ids) {
      var div = vue.$el.querySelector(".ksm-accordion__expand .div-with-transcript-hover");
      if (div) {
        div.scrollIntoView({ behavior: "smooth" });
      }
    });

    this.$store.state.eventBus.$on("dragStop", function () {
      if (vue.map) {
        vue.map.updateSize();
      }
    });

    if (this.needReloadCropImages) {
      this.needReloadCropImages = false;
      this.drawCropImages();
    }
    this.scrollToPersonById();
  },

  computed: {
    ortGeoData: function ortGeoData() {
      if (!this.geoData || !this.orte) {
        return;
      }
      var idxs = this.orte.map(function (o) {
        return o.ID + "";
      });
      var features = this.geoData.features.filter(function (f) {
        return idxs.indexOf(f.properties.stadtindex) > -1;
      });
      return {
        features: features,
        type: "FeatureCollection"
      };
    },
    openedAccordionId: function openedAccordionId() {
      return this.modusOption["openedAccordionId"];
    },
    accoExpandPersonList: function accoExpandPersonList() {
      return this.modusOption.accoExpandPersonList;
    },
    showArrow: function showArrow() {
      if (this.modusOption.key === "ansicht" || this.modusOption.key === "komposition") {
        return false;
      }

      return true;
    },
    accordionList: function accordionList() {
      var modusOption = this.modusOption;
      var list = modusOption.accordionList;
      var out = void 0;
      if (modusOption.urlparams.merzId === "Merz24") {
        out = list.filter(function (it) {
          return ["acco_inventarisierung", "acco_kommentar", "acco_einzelstellenkommentare", "acco_personen", "acco_relation", "acco_themen"].indexOf(it.id) > -1;
        });
      } else if (modusOption.urlparams.merzId === "Merz10" || modusOption.urlparams.merzId === "Merz25") {
        out = list.filter(function (it) {
          return it.id !== "acco_themen";
        });
      } else {
        out = list.filter(function (it) {
          return ["acco_transkription", "acco_themen"].indexOf(it.id) === -1;
        });
      }

      if (out.length > 0 && !out.find(function (o) {
        return o.id === modusOption.openedAccordionId;
      })) {
        modusOption.openedAccordionId = out[0].id;
      }
      return out;
    },
    graphElemente: function graphElemente() {
      var seite = this.seite;
      if (!seite || !seite.$_graphElemente) {
        return;
      }
      return this.seite.$_graphElemente;
    },
    transcriptMap: function transcriptMap() {
      var seite = this.seite;
      if (!seite || !seite.$_accoId_transcript_mapping) {
        return;
      }

      var outMap = [];
      var idList = [];
      var map = seite.$_accoId_transcript_mapping;
      this.modusOption.accordionList.forEach(function (accordion) {
        accordion.fudkeys.forEach(function (k) {
          var arr = map[k];
          if (arr) {
            arr.forEach(function (ar) {
              idList = idList.concat(ar.ids);
            });
          }
        });
      });

      seite.$_allTranscripts.forEach(function (it) {
        var tmp = it.transcripts.filter(function (tr) {
          return idList.indexOf(tr.id) > -1;
        });
        outMap.push({
          docID: it.docID,
          transcripts: tmp
        });
      });

      return outMap;
    },
    seiten: function seiten() {
      if (this.merz) {
        return this.merz.seiten;
      }
    },
    seite: function seite() {
      if (this.seiten && this.seiteIdx != undefined) {
        return this.seiten[this.seiteIdx];
      }
    },
    mainKommentar: function mainKommentar() {
      var _this6 = this;

      if (this.seite && this.seite.$_mainKommentar) {
        var res = [];
        this.seite.$_mainKommentar.forEach(function (mk) {
          var div = _this6.$_getNewHtmlElement(mk._source["114_html"], _this6.merz, mk, true);
          res.push(div.outerHTML);
        });
        return res;
      }
    },
    acco_inventarisierung: function acco_inventarisierung() {
      return this.$store.getters["modus/getSeiteDataExtendInfo"](this.seite, "acco_inventarisierung", this.modusOption.viewKey);
    },
    noteHtmlData: function noteHtmlData() {
      if (!this.seite || !this.seite.$_docInfo) {
        return;
      }
      var out = {};
      var getAccordionHtml = this.getAccordionHtml;
      this.modusOption.accordionList.forEach(function (fi) {
        out[fi.id] = getAccordionHtml(fi);
      });
      return out;
    },
    personen: function personen() {
      var pers = this.$store.getters["modus/getSeiteDataExtendInfo"](this.seite, "personen");
      if (!pers) {
        return [];
      }

      pers = pers.filter(function (item) {
        return item.transcripts.length > 0;
      });
      return pers;
    },
    orte: function orte() {
      var orte = this.$store.getters["modus/getSeiteDataExtendInfo"](this.seite, "orte");
      if (!orte) {
        return;
      }

      var seen = [];
      orte = orte.filter(function (item) {
        return seen.hasOwnProperty(item.ID) ? false : seen[item.ID] = true;
      });
      return orte;
    },
    themen: function themen() {
      if (!this.seite) {
        return [];
      }

      if (this.seite.$_themen && this.seite.$_themen.length > 0) {
        return this.seite.$_themen;
      }

      var themen = this.$store.getters["modus/getSeiteDataExtendInfo"](this.seite, "themen");
      this.seite.$_themen = themen ? themen : [];
      return this.seite.$_themen;
    },
    fetchSeiteDataDone: function fetchSeiteDataDone() {
      var seite = this.seite;
      if (!seite || !seite.$_fetchAllExtendInfoEnd) {
        return;
      }
      this.needReloadCropImages = true;
      return true;
    }
  }
});

/***/ }),

/***/ 957:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sidebar_vue__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Sidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_comps_SplitLayout_vue__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_comps_SplitLayout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_comps_SplitLayout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_comps_DeepzoomView_vue__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_comps_DeepzoomView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_comps_DeepzoomView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_comps_Thumbnail_vue__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_comps_Thumbnail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_comps_Thumbnail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_comps_mixins_Modus_vue__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_comps_mixins_Modus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_comps_mixins_Modus_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["viewKey"],
  mixins: [__WEBPACK_IMPORTED_MODULE_4_comps_mixins_Modus_vue___default.a],
  components: {
    "deepzoom-view": __WEBPACK_IMPORTED_MODULE_2_comps_DeepzoomView_vue___default.a,
    "split-layout": __WEBPACK_IMPORTED_MODULE_1_comps_SplitLayout_vue___default.a,
    "sidebar-view": __WEBPACK_IMPORTED_MODULE_0__Sidebar_vue___default.a,
    "foot-thumbnail": __WEBPACK_IMPORTED_MODULE_3_comps_Thumbnail_vue___default.a
  },
  data: function data() {
    return {
      modusId: "untersuchungsmodus"
    };
  }
});

/***/ }),

/***/ 958:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_comps_DeepzoomView_vue__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_comps_DeepzoomView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_comps_DeepzoomView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_comps_Thumbnail_vue__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_comps_Thumbnail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_comps_Thumbnail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_comps_SplitLayout_vue__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_comps_SplitLayout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_comps_SplitLayout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sidebar_vue__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Sidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_comps_mixins_Modus_vue__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_comps_mixins_Modus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_comps_mixins_Modus_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["viewKey"],
  mixins: [__WEBPACK_IMPORTED_MODULE_4_comps_mixins_Modus_vue___default.a],
  components: {
    "deepzoom-view": __WEBPACK_IMPORTED_MODULE_0_comps_DeepzoomView_vue___default.a,
    "split-layout": __WEBPACK_IMPORTED_MODULE_2_comps_SplitLayout_vue___default.a,
    "sidebar-view": __WEBPACK_IMPORTED_MODULE_3__Sidebar_vue___default.a,
    "foot-thumbnail": __WEBPACK_IMPORTED_MODULE_1_comps_Thumbnail_vue___default.a
  },
  data: function data() {
    return {
      alleTranscriptionZeigen: false,
      sidebar_left_collapse: true,
      sidebar_right_collapse: true,
      modusId: "vergleichsmodus"
    };
  }
});

/***/ }),

/***/ 959:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),

/***/ 960:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      titles: {
        P: "PRIMÄRLITERATUR",
        A: "AUSSTELLUNGSKATALOGE",
        S: "SEKUNDÄRLITERATUR"
      },
      item: null
    };
  },

  watch: {
    item: function item(k) {
      this.scrollToItem(k);
    }
  },
  methods: {
    scrollToItem: function scrollToItem(k) {
      if (!k) {
        return;
      }
      var vue = this;
      setTimeout(function () {
        var pattern = "[data-keyitem='" + k + "']";
        var item = vue.$el.querySelector(pattern);
        if (item) {
          item.scrollIntoView({ block: "start", behavior: "smooth" });
        }
      }, 100);
    },
    getKeyItem: function getKeyItem(it) {
      var keyitem = it.keyitem.toLowerCase();
      if (keyitem == this.keyitem) {
        this.item = keyitem;
      }
      return keyitem;
    }
  },
  mounted: function mounted() {
    this.scrollToItem(this.item);
  },
  computed: {
    bibliographie: function bibliographie() {
      return this.$store.getters.bibliographie;
    },
    keyitem: function keyitem() {
      var keyitem = this.$route.params.keyitem;
      if (keyitem) {
        return keyitem.toLowerCase();
      }
    }
  }
});

/***/ }),

/***/ 961:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      htmlText: ""
    };
  },

  mounted: function mounted() {
    var vue = this;
    this.$store.dispatch("fechtDocumentById", [1184]).then(function (res) {
      if (!res || !res.doc) {
        return;
      }
      vue.htmlText = res.doc[0]._source["114_html"];
    });
  },
  methods: {}
});

/***/ }),

/***/ 962:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),

/***/ 963:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      logoItems: [{
        png: "uni-wuppertal_logo_grau.png",
        title: "Uni Wuppertal",
        url: "https://www.uni-wuppertal.de/",
        style: "height:45px; width:120px"
      }, {
        png: "SMH_Logo_SCHWARZ.jpg",
        title: "Sprengel Museum",
        url: "http://www.sprengel-museum.de/",
        style: "height:48px; width:20px"
      }, {
        img: "kompetenz_logo_2016_neg.svg",
        title: "Kompetenzzentrum",
        url: "http://kompetenzzentrum.uni-trier.de/de/",
        style: "height:100%; width:180px; margin-right:-15px"
      }, {
        img: "Logo_Uni_Trier_typo_neg.svg",
        title: "Uni Trier",
        url: "http://www.uni-trier.de",
        style: "height:100%; width:160px;padding-bottom:5px; margin-right:-15px"
      }, {
        png: "dfg_logo_schriftzug_blau_foerderung_4c.jpg",
        title: "Uni Trier",
        url: "http://www.dfg.de",
        style: "height:45px; width:140px"
      }],
      footNavItems: [{
        url: "/projektinfo",
        label: "Projektinfo"
      }, {
        url: "/beteiligte",
        label: "Beteiligte"
      }, {
        url: "/foerderer",
        label: "Förderer"
      }, {
        url: "/kontakt",
        label: "Kontakt"
      }, {
        url: "/datenschutz",
        label: "Datenschutz"
      }, {
        url: "/impressum",
        label: "Impressum"
      }]
    };
  },

  computed: {
    showFooter: function showFooter() {},
    isHome: function isHome() {
      return this.$route.name == "home";
    },
    footItemsLeft: function footItemsLeft() {
      var out = [this.footNavItems[0]];
      out = out.concat(this.logoItems);
      return out;
    },
    footItemsRight: function footItemsRight() {
      return this.footNavItems.filter(function (a, i) {
        return i > 0;
      });
    }
  },
  methods: {}
});

/***/ }),

/***/ 964:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Nav_vue__ = __webpack_require__(1938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Nav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Nav_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  components: {
    "nav-view": __WEBPACK_IMPORTED_MODULE_0__Nav_vue___default.a
  },
  computed: {
    isHome: function isHome() {
      return this.$route.name == "home";
    }
  },
  methods: {}
});

/***/ }),

/***/ 965:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),

/***/ 966:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3__ = __webpack_require__(77);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      rectImages: [{
        path: "merzwerbe",
        src: "startseite-merzw.jpg"
      }, {
        path: "texte/ursonate",
        src: "startseite-film.jpg"
      }, {
        path: "texte/merzhefte",
        src: "startseite-texte.jpg"
      }],
      links: ["/schwitters", "/schwitters", "", "/orteundwege", "/merzwerbe", "/texte/ursonate", "/texte/merzhefte", "/personen", "/kunstwerke", "/orteundwege", "/orteundwege", "/orteundwege"]
    };
  },

  mounted: function mounted() {
    this.svg = this.$el.querySelector(".ksm-home__content svg");
    this.addJpg();
    this.addLinks();
  },
  methods: {
    addJpg: function addJpg() {
      var vue = this;
      var bildrahmen = this.svg.querySelector("#bildrahmen");
      var rects = bildrahmen.querySelectorAll("rect");
      var rectImages = this.rectImages;
      var i = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(rects), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var rect = _step.value;

          var $rect = __WEBPACK_IMPORTED_MODULE_1_d3__["a" /* select */](rect);
          __WEBPACK_IMPORTED_MODULE_1_d3__["a" /* select */](bildrahmen).append("image").attr("xlink:href", "static/icons/" + rectImages[i].src).attr("x", $rect.attr("x")).attr("y", $rect.attr("y")).attr("data-path", rectImages[i].path).attr("class", "ksm-home-img").attr("width", $rect.attr("width")).attr("height", $rect.attr("height")).on("click", function () {
            var path = this.getAttribute("data-path");
            vue.$router.push(path);
          });
          i++;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    addLinks: function addLinks() {
      var gs = this.svg.querySelectorAll("#text > g");
      var links = this.links;
      var i = 0;
      var vue = this;

      var _loop = function _loop(g) {
        g.classList.add("ksm-home-g");
        var box = g.getBBox();
        var rect = __WEBPACK_IMPORTED_MODULE_1_d3__["a" /* select */](g).append("rect").attr("x", box.x).attr("y", box.y).attr("width", box.width).attr("height", box.height).attr("data-linkIdx", i).attr("class", function () {
          var idx = this.getAttribute("data-linkIdx");
          if (links[idx]) {
            return "ksm-home__rect-wrapper";
          } else {
            g.classList.remove("ksm-home-g");
            return "ksm-home__rect-wrapper-nolink";
          }
        }).on("click", function () {
          var idx = this.getAttribute("data-linkIdx");
          if (links[idx]) {
            vue.$router.push({
              path: links[idx]
            });
          }
        });
        i++;
      };

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(gs), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var g = _step2.value;

          _loop(g);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }
});

/***/ }),

/***/ 967:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      htmlText: ""
    };
  },

  mounted: function mounted() {
    var vue = this;
    this.$store.dispatch("fechtDocumentById", [1183]).then(function (res) {
      if (!res || !res.doc) {
        return;
      }

      var doc = res.doc[0];
      vue.htmlText = vue.$_getNewHtmlElement(doc._source["114_html"], null, doc, true).innerHTML;
    });
  },
  methods: {}
});

/***/ }),

/***/ 968:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {};
	},

	methods: {}

});

/***/ }),

/***/ 969:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },
  mounted: function mounted() {},


  methods: {},
  computed: {}
});

/***/ }),

/***/ 970:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modus_ModusIndex__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modus_ModusIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_modus_ModusIndex__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "merzwerbe",
  components: {
    ModusIndex: __WEBPACK_IMPORTED_MODULE_0__components_modus_ModusIndex___default.a
  },
  created: function created() {},

  data: function data() {
    return {};
  },


  mounted: function mounted() {}
});

/***/ }),

/***/ 971:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      tooltipOption: {
        content: "Es ist vorgesehen, hier die bildnerischen Werke des aktualisierten „Kurt Schwitters. Catalogue raisonné“ bereitzustellen.",
        placement: "bottom-center",
        classes: ["info"]
      },
      navItems: [{
        path: "/kunstwerke",
        names: ["kunstwerke"],
        label: "Kunstwerke",
        disable: true
      }, {
        path: "/texte/merzhefte",
        names: ["texte-modus", "texte", "ursonate"],
        label: "Texte"
      }, {
        path: "/merzwerbe/untersuchungsmodus",
        names: ["werbe-modus"],
        label: "Merz-Werbe"
      }, {
        path: "/personen",
        names: ["personen"],
        label: "Personen"
      }, {
        path: "/orteundwege",
        names: ["orteundwege"],
        label: "Orte und Wege"
      }, {
        path: "/bibliographie",
        names: ["bibliographie"],
        label: "Bibliographie"
      }, {
        path: "/suche",
        names: ["suche"],
        label: "Suche"
      }, {
        path: "/hilfe",
        names: ["hilfe"],
        label: "Hilfe"
      }]
    };
  },

  created: function created() {},
  watch: {},
  computed: {
    routeName: function routeName() {
      return this.$route.name;
    },
    navList: function navList() {
      return this.navItems.map(function (it) {
        return it;
      });
    }
  },
  methods: {
    toPage: function toPage(it) {
      if (it.disable) {
        return;
      }
      this.$router.push({
        path: it.path
      });
    }
  }
});

/***/ }),

/***/ 972:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_comps_MapView_vue__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_comps_MapView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_comps_MapView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_comps_SplitLayout_vue__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_comps_SplitLayout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_comps_SplitLayout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_timers__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orte_Sidebar_OrteUndWege__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orte_Sidebar_OrteUndWege___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__orte_Sidebar_OrteUndWege__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "orteundwege",
  data: function data() {
    return {
      map: null,
      geoData: null,
      mapOption: {
        showControls: true,
        showPiechart: true,
        splitLayoutResize: null
      }
    };
  },

  components: {
    MapView: __WEBPACK_IMPORTED_MODULE_0_comps_MapView_vue___default.a,
    SplitLayout: __WEBPACK_IMPORTED_MODULE_1_comps_SplitLayout_vue___default.a,
    SidebarView: __WEBPACK_IMPORTED_MODULE_3__orte_Sidebar_OrteUndWege___default.a
  },
  created: function created() {
    var _this = this;

    this.$store.dispatch("orteundwege/fetchGeoData", this).then(function (res) {
      _this.geoData = res;
    });
  },
  computed: {
    sidebarRightList: function sidebarRightList() {
      return this.$store.getters["orteundwege/sidebarRightList"];
    },
    sidebarLeftList: function sidebarLeftList() {
      return this.$store.getters["orteundwege/sidebarLeftList"];
    },
    showTextInfo: function showTextInfo() {
      if (!this.sidebarLeftList) {
        return;
      }
      var isExpand = this.sidebarRightList.find(function (it) {
        return it.isExpand;
      });
      return ["holland", "merzabende", "merzgebiete"].indexOf(isExpand.id) > -1;
    }
  },
  methods: {
    clickCollapse: function clickCollapse() {},
    dragStop: function dragStop() {
      this.mapUpdate();
      this.mapOption.splitLayoutResize = new Date().getTime();
    },
    mapUpdate: function mapUpdate() {
      var map = this.map;
      if (map) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_timers__["setTimeout"])(function () {
          map.updateSize();
        }, 300);
      }
    },
    mapInited: function mapInited(map) {
      this.map = map;
    }
  }
});

/***/ }),

/***/ 973:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_comps_SplitLayout_vue__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_comps_SplitLayout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_comps_SplitLayout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orte_Sidebar_OrteUndWege__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orte_Sidebar_OrteUndWege___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__orte_Sidebar_OrteUndWege__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_comps_mixins_KeepScroll__ = __webpack_require__(1921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_comps_mixins_KeepScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_comps_mixins_KeepScroll__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "personen",
  mixins: [__WEBPACK_IMPORTED_MODULE_4_comps_mixins_KeepScroll___default.a],
  data: function data() {
    return {
      selectedIdx: 0,
      personenExpandIdx: [],
      firstScroll: false
    };
  },

  components: {
    SplitLayout: __WEBPACK_IMPORTED_MODULE_2_comps_SplitLayout_vue___default.a,
    SidebarView: __WEBPACK_IMPORTED_MODULE_3__orte_Sidebar_OrteUndWege___default.a
  },
  watch: {
    schwitters: function schwitters(d) {
      var vue = this;
      if (d && !vue.firstScroll) {
        setTimeout(function () {
          vue.scrollTo(d.lemmaID);
        }, 1);
      }
    }
  },

  activated: function activated() {
    this.autoScrollToPerson();
  },

  mounted: function mounted() {
    this.autoScrollToPerson();
  },

  methods: {
    autoScrollToPerson: function autoScrollToPerson() {
      var vue = this;
      if (this.lemmaID) {
        setTimeout(function () {
          vue.scrollTo(vue.lemmaID);
          vue.$router.push({
            query: null
          });
        }, 1);
      } else if (this.schwitters && !this.firstScroll && this.personenExpandIdx.length < 2) {
        setTimeout(function () {
          vue.scrollTo(vue.schwitters.lemmaID);
        }, 1);
      }
    },
    togglePersonItem: function togglePersonItem(i, b) {
      var idx = this.personenExpandIdx.indexOf(i);
      if (idx > -1) {
        if (!b) {
          this.personenExpandIdx.splice(idx, 1);
        }
      } else {
        this.personenExpandIdx.push(i);
      }
    },
    scrollTo: function scrollTo(persId) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var vue, elem, clickEvent, person;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                vue = _this;
                elem = _this.$el.querySelector("#pers_" + persId);

                if (elem) {
                  elem.scrollIntoView({ block: "start", behavior: "smooth" });
                  clickEvent = new MouseEvent("click", {
                    view: window,
                    bubbles: true,
                    cancelable: false
                  });
                  person = _this.personenCollection2.find(function (p) {
                    return p.lemmaID - persId === 0;
                  });

                  _this.selectedIdx = _this.personenCollection2.indexOf(person);
                  _this.togglePersonItem(persId, true);
                } else if (persId) {
                  setTimeout(function () {
                    vue.scrollTo(persId);
                  }, 1000);
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  computed: {
    lemmaID: function lemmaID() {
      return this.$route.query.lemmaID;
    },
    schwitters: function schwitters() {
      if (!this.personenCollection2) {
        return;
      }
      var schwitters = this.personenCollection2.find(function (p) {
        return p.content === "Doesburg, Nelly »Pétro« van";
      });
      return schwitters;
    },
    personenCollection2: function personenCollection2() {
      return this.$store.state.personen.collection2;
    },
    personenText: function personenText() {
      if (!this.personenCollection2) {
        return;
      }
      var p = this.personenCollection2[this.selectedIdx];
      var text = p.text;
      if (text) {
        text = '<span style="font-weight:bold">' + p.content + "</span>, " + text;
      }
      return text;
    }
  }
});

/***/ }),

/***/ 974:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),

/***/ 975:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(218);






var getNum = function getNum(d) {
  var i = parseInt(d.name.replace("/", ",").split(",")[0].replace(/\D*/, ""), 10);
  if (isNaN(i)) {
    i = 0;
  }
  return i;
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "suche",
  data: function data() {
    return {
      searchKeys: "",
      resultText: "",
      resultList: [],
      showLoading: false
    };
  },

  methods: {
    actionKeydown: function actionKeydown(evt) {
      if (evt.keyCode === 13) {
        this.searchStart();
      }
    },
    formatSearchKeys: function formatSearchKeys(key) {
      var text = [];
      if (key === undefined || key === "" || key === null) {
        return;
      }
      key = key.replace(/\"/g, "'");

      var regex = /'[^']+'/;
      var matchRes = key.match(regex);

      var max = 100;

      while (matchRes && max) {
        max--;
        var idx = matchRes.index;
        if (idx > 0) {
          key.substring(0, idx).trim().split(" ").forEach(function (s) {
            text.push(s.replace(/'/g, ""));
          });
        }
        text.push(matchRes[0].replace(/'/g, ""));
        key = key.substring(idx + matchRes[0].length).trim();
        matchRes = key.match(regex);
      }
      if (!key) {
        return text;
      }
      key.split(" ").forEach(function (w) {
        text.push(w.replace(/'/g, ""));
      });
      return text;
    },
    searchStart: function searchStart() {
      this.searchKeys = this.searchKeys.trim();
      this.showLoading = true;
      this.resultText = "";
      var searchKeys = this.formatSearchKeys(this.searchKeys);
      var vue = this;
      this.resultList = null;
      if (!searchKeys) {
        setTimeout(function () {
          vue.showLoading = false;
        }, 500);
        return;
      }
      var out = [];
      var seiteIdMap = this.seiteIdMap;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api__["b" /* postQuery */])("simpleSearch", {
        text: searchKeys
      }).then(function (res) {
        setTimeout(function () {
          vue.showLoading = false;
        }, 500);

        vue.resultList = [];
        if (!res.data) {
          return;
        }
        var allMerz = vue.allMerz;
        var merzItems = res.data.filter(function (d) {
          return d.val;
        }).map(function (d) {
          var obj = void 0;
          var hl = d.highlight;
          var hls = [];
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(hl).forEach(function (k) {
            hl[k].forEach(function (v, i) {
              v = v.replace(/<em>/g, '<span style="background-color:yellow">');
              v = v.replace(/<\/em>/g, "</span>");
              var t = void 0;
              if (k === "114_plaintext") {
                t = "Einführung";
              } else if (k === "98_plaintext") {
                t = "Transkription";
              } else if (k === "notes.content") {
                t = "Einzelstellenkommentare";
              }
              hls.push({ key: k, type: t, val: "... " + v + " ..." });
            });
          });
          if (d.docTyp.id === "114") {
            var merz = allMerz.find(function (merz) {
              return merz.merzNameId - d.val === 0;
            });
            if (!merz) {
              console.log("ohne Merz mit ID ", d.val);
              return;
            }
            obj = {
              hls: hls,
              seite: merz.seiten[0],
              merz: merz
            };
          } else {
            console.log(d.ID);
            console.log(seiteIdMap);
            obj = seiteIdMap[d.ID];
            console.log(obj);
            obj.hls = hls;
          }
          return obj;
        });

        var merzMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
        merzItems.forEach(function (it) {
          if (!it) {
            return;
          }

          var merz = it.merz;
          var seite = it.seite;
          if (seite) {
            var sIdx = seite.idx;
            var obj = merzMap.get(merz.id);
            if (obj) {
              if (!obj.seitenData.find(function (d) {
                return d.seite.idx === sIdx;
              })) {
                obj.seitenData.push({
                  seite: seite,
                  hls: it.hls
                });
              }
            } else {
              merzMap.set(merz.id, {
                merz: merz,
                seitenData: [{
                  seite: seite,
                  hls: it.hls
                }]
              });
            }
          }
        });
        var resultList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(merzMap.values()));
        resultList.sort(function (a, b) {
          a = a.merz.name;
          b = b.merz.name;
          if (a.match(/\d+/) && b.match(/\d+/)) {
            a = getNum({ name: a });
            b = getNum({ name: b });
            if (a > b) {
              return 1;
            } else if (a < b) {
              return -1;
            }
            return 0;
          } else {
            return a.localeCompare(b, "de");
          }
        });
        vue.resultList = resultList;
        if (resultList.length < 1) {
          vue.resultText = "Die Suche ergibt keine Treffer.";
        }
      });
    },
    toPath: function toPath(it, it2, key) {
      var query = {
        merzId: it.merz.id,
        seiteIdx: it2.seite.idx
      };
      var b_query = {
        b_merzId: it.merz.id,
        b_seiteIdx: it2.seite.idx
      };

      var useQuery = void 0;
      var path = void 0;
      var modusId = void 0;
      console.log(key);

      if (key === "114_plaintext") {
        modusId = "ansichtsmodus";
        useQuery = query;
      } else if (key === "notes.content") {
        modusId = "untersuchungsmodus";
        useQuery = query;
      } else if (key === "98_plaintext") {
        modusId = "untersuchungsmodus";
        useQuery = query;
      }

      var merzName = it.merz.name;
      var modus = void 0;
      if (merzName.indexOf("Merz") === 0) {
        path = "/texte/merzhefte/" + modusId;
        modus = this.$store.getters["modus/getModusByIdKey"]({
          modusId: modusId,
          viewKey: "texte"
        });
      } else if (merzName === "ursonate") {} else {
        path = "/merzwerbe/" + modusId;
        modus = this.$store.getters["modus/getModusByIdKey"]({
          modusId: modusId,
          viewKey: "werbe"
        });
      }

      if (modusId === "untersuchungsmodus" && modus) {
        this.$store.commit("updateObjectByKey", {
          obj: modus.option,
          key: "openedAccordionId",
          val: "acco_einzelstellenkommentare"
        });
      }

      if (!path) {
        this.$router.push({
          query: useQuery
        });
      } else {
        this.$router.push({
          path: path,
          query: useQuery
        });
      }
    }
  },
  computed: {
    texte: function texte() {
      return this.$store.state.texte.merzListe;
    },
    werbe: function werbe() {
      return this.$store.state.werbe.merzListe;
    },
    ursonate_noten: function ursonate_noten() {
      return this.$store.state.ursonate_noten.merzListe;
    },
    ursonate_texte: function ursonate_texte() {
      return this.$store.state.ursonate_texte.merzListe;
    },
    allMerz: function allMerz() {
      var list = [];
      var texte = this.texte,
          werbe = this.werbe,
          ursonate_noten = this.ursonate_noten,
          ursonate_texte = this.ursonate_texte;

      if (texte) {
        list = list.concat(texte);
      }
      if (werbe) {
        list = list.concat(werbe);
      }
      if (ursonate_noten) {
        list = list.concat(ursonate_noten);
      }
      if (ursonate_texte) {
        list = list.concat(ursonate_texte);
      }
      return list;
    },
    seiteIdMap: function seiteIdMap() {
      var list = this.allMerz;
      var seiteIdMap = {};
      list.forEach(function (merz) {
        merz.seiten.forEach(function (seite) {
          seite.seiteIds.forEach(function (id) {
            seiteIdMap[id] = {
              merz: merz,
              seite: seite
            };
          });
        });
      });
      return seiteIdMap;
    }
  }
});

/***/ }),

/***/ 976:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  props: {
    list: Array,
    hiddenToolbar: Boolean
  },

  data: function data() {
    return {
      openedAccordionId: 0
    };
  },


  methods: {
    clickAccordion: function clickAccordion(accor) {
      if (accor.isInfoText) {
        return;
      }
      this.$store.commit("orteundwege/expandAccor", accor);
    },
    clickColorCBX: function clickColorCBX(accor) {
      accor.checked = !accor.checked;
      this.$store.commit("orteundwege/updatePiechartIcon");
    },
    clickInfoItem: function clickInfoItem(infoItem) {
      this.$store.commit("orteundwege/activeInfoItem", infoItem);
    }
  },

  mounted: function mounted() {
    var vue = this;
    this.$store.state.eventBus.$on("ortundwege-accor-scroll", function (item) {
      setTimeout(function () {
        var elem = vue.$el.querySelector(".__" + item.accor.id + "-active");
        if (elem) {
          elem.scrollIntoView({ block: "start", behavior: "smooth" });
        }
      }, 300);
    });
  },

  computed: {
    lemmaID: function lemmaID() {
      return this.$route.query.lemmaID;
    },
    activeInfoItem: function activeInfoItem() {
      return this.$store.getters["orteundwege/activeInfoItem"];
    },
    infoText: function infoText() {
      if (!this.sidebarRightList) {
        return "";
      }

      var infoText = "";
      var accor = this.sidebarRightList.find(function (accor) {
        return accor.isExpand;
      });
      if (accor.textDoc) {
        infoText = accor.textDoc._source["113_html"];
        infoText = this.$_getNewHtmlElement(infoText, null, accor.textDoc, true);
        infoText = infoText.innerHTML;
      }
      return infoText;
    },
    sidebarRightList: function sidebarRightList() {
      return this.$store.getters["orteundwege/sidebarRightList"];
    }
  }
});

/***/ }),

/***/ 977:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ursonate_NotenView__ = __webpack_require__(1949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ursonate_NotenView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ursonate_NotenView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ursonate_TextView__ = __webpack_require__(1950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ursonate_TextView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ursonate_TextView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ursonate_FilmView__ = __webpack_require__(1947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ursonate_FilmView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ursonate_FilmView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ursonate_AudioView__ = __webpack_require__(1946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ursonate_AudioView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ursonate_AudioView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_splitpanes__ = __webpack_require__(1900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_splitpanes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_splitpanes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_splitpanes_dist_splitpanes_css__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_splitpanes_dist_splitpanes_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_splitpanes_dist_splitpanes_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(167);










__WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].component("OpenCloseButtons", {
  props: ["showMerz24"],
  data: function data() {
    return {
      count: 0
    };
  },
  methods: {
    mini: function mini() {
      this.$emit("minimize");
    },
    fullsize: function fullsize() {
      this.$emit("fullsize");
    }
  },
  template: "<div class=\"ksm-flex\" style=\"height:22px\">\n  <router-link v-if=\"showMerz24\" tag=\"div\" to=\"/texte/merzhefte/untersuchungsmodus?merzId=Merz24&seiteIdx=0\" class=\"ksm-medien__icon-s2 ksm-link--svg2\" title=\"Zu Merz 24\" @click=\"fullsize\" v-html=\"$_getSvg('untersuchungsmodus.svg')\" style=\"margin-right:5px\"></router-link>\n  <span class=\"ksm-medien__icon-s ksm-link--svg2\" title=\"Bereich maximieren\" @click=\"fullsize\" v-html=\"$_getSvg('oeffnen.svg')\" style=\"margin-right:5px\"></span>\n  <span class=\"ksm-medien__icon-s ksm-link--svg2\" title=\"Bereich minimieren\" @click=\"mini\" v-html=\"$_getSvg('schliessen.svg')\"></span>\n  </div>"
});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "medienOverview",
  components: { NotenView: __WEBPACK_IMPORTED_MODULE_0__ursonate_NotenView___default.a, TextView: __WEBPACK_IMPORTED_MODULE_1__ursonate_TextView___default.a, FilmView: __WEBPACK_IMPORTED_MODULE_2__ursonate_FilmView___default.a, AudioView: __WEBPACK_IMPORTED_MODULE_3__ursonate_AudioView___default.a, Splitpanes: __WEBPACK_IMPORTED_MODULE_4_splitpanes___default.a },
  created: function created() {
    this.$store.dispatch("fetchUrsonate");
  },
  computed: {},
  mounted: function mounted() {
    var sp = this.$el.querySelectorAll(".splitpanes__splitter");
    if (sp) {
      sp[1].appendChild(this.$refs.all_play_btn_1.$el);
      sp[2].appendChild(this.$refs.all_play_btn_2.$el);
    }
  },
  data: function data() {
    return {
      rowTop: 50,
      columnTopLeft: 50,
      columnBottomLeft: 50,
      isTextMin: false,
      isNotenMin: false,
      isAudioMin: false,
      isVideoMin: false,
      isConnect1: false,
      isConnect2: false,
      themaPlaying: null,
      audioIsPlaying: false,
      von2: null
    };
  },

  watch: {
    isConnect2: function isConnect2(b) {
      if (!b) {
        this.von2 = null;
      }
    },
    isTextMin: function isTextMin(b) {
      if (b) {
        this.columnTopLeft = 0;
        if (this.isNotenMin) {
          this.rowTop = 0;
        }
      } else {
        if (this.rowTop === 0) {
          this.rowTop = 50;
          this.columnTopLeft = 100;
        } else {
          this.columnTopLeft = 50;
        }
      }
    },
    isNotenMin: function isNotenMin(b) {
      if (b) {
        this.columnTopLeft = 100;
        if (this.isTextMin) {
          this.rowTop = 0;
        }
      } else {
        if (this.rowTop === 0) {
          this.rowTop = 50;
          this.columnTopLeft = 0;
        } else {
          this.columnTopLeft = 50;
        }
      }
    },
    isAudioMin: function isAudioMin(b) {
      if (b) {
        this.columnBottomLeft = 0;
        if (this.isVideoMin) {
          this.rowTop = 100;
        }
      } else {
        if (this.rowTop === 100) {
          this.rowTop = 50;
          this.columnBottomLeft = 100;
        } else {
          this.columnBottomLeft = 50;
        }
      }
    },
    isVideoMin: function isVideoMin(b) {
      if (b) {
        this.columnBottomLeft = 100;
        if (this.isAudioMin) {
          this.rowTop = 100;
        }
      } else {
        if (this.rowTop === 100) {
          this.rowTop = 50;
          this.columnBottomLeft = 0;
        } else {
          this.columnBottomLeft = 50;
        }
      }
    }
  },
  methods: {
    audioToggle: function audioToggle() {
      if (this.audioIsPlaying) {
        this.$store.state.eventBus.$emit("audio-pause");
      } else {
        this.$store.state.eventBus.$emit("audio-play");
      }
    },
    audioChange: function audioChange(_ref) {
      var d = _ref.d,
          isPlaying = _ref.isPlaying;

      this.audioIsPlaying = isPlaying;

      if (this.isConnect1) {
        this.themaPlaying = d;
      }

      if (this.isConnect2 && d && d.von2) {
        if (this.von2 !== d.von2) {
          var curr = d.von2 + (d.currentTime - d.von) * d.playbackRate;
          this.$store.state.eventBus.$emit("video" + "-sync", {
            playbackRate: d.playbackRate,
            currentTime: curr,
            isPlaying: isPlaying
          });
          if (isPlaying) {
            this.von2 = d.von2;
          }
        }
      } else if (this.isConnect2) {
        this.von2 = null;
        this.$store.state.eventBus.$emit("video" + "-pause");
      } else {
        this.von2 = null;
      }
    },
    doConnect1: function doConnect1(d) {
      this.isConnect1 = d;
    },
    doConnect2: function doConnect2(d) {
      this.isConnect2 = d;
      this.$store.state.eventBus.$emit("audio-connect-2", d);
    },
    resizeRowTop: function resizeRowTop(d) {
      this.rowTop = d[0].width;
    },
    resizeColumnTopLeft: function resizeColumnTopLeft(d) {
      this.columnTopLeft = d[0].width;
    },
    resizeColumnBottomLeft: function resizeColumnBottomLeft(d) {
      this.columnBottomLeft = d[0].width;
    },
    minimize: function minimize(name) {
      var isTextMin = this.isTextMin,
          isNotenMin = this.isNotenMin,
          isAudioMin = this.isAudioMin,
          isVideoMin = this.isVideoMin;

      switch (name) {
        case "text":
          if (isNotenMin && isAudioMin && isVideoMin) {
            return;
          }
          this.isTextMin = true;
          break;
        case "note":
          if (isTextMin && isAudioMin && isVideoMin) {
            return;
          }
          this.isNotenMin = true;
          break;

        case "audio":
          if (isTextMin && isNotenMin && isVideoMin) {
            return;
          }
          this.isAudioMin = true;
          break;

        case "video":
          if (isTextMin && isAudioMin && isNotenMin) {
            return;
          }
          this.isVideoMin = true;
          break;
      }
    },
    fullsize: function fullsize(name) {
      var isTextMin = this.isTextMin,
          isNotenMin = this.isNotenMin,
          isAudioMin = this.isAudioMin,
          isVideoMin = this.isVideoMin;

      switch (name) {
        case "text":
          this.isTextMin = false;
          this.isNotenMin = true;
          this.isAudioMin = true;
          this.isVideoMin = true;
          break;
        case "note":
          this.isTextMin = true;
          this.isNotenMin = false;
          this.isAudioMin = true;
          this.isVideoMin = true;
          break;

        case "audio":
          this.isTextMin = true;
          this.isNotenMin = true;
          this.isAudioMin = false;
          this.isVideoMin = true;
          break;

        case "video":
          this.isTextMin = true;
          this.isNotenMin = true;
          this.isAudioMin = true;
          this.isVideoMin = false;
          break;
      }
    }
  }
});

/***/ }),

/***/ 978:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3__ = __webpack_require__(77);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "modusstart",
  data: function data() {
    return {
      rendered: false
    };
  },

  watch: {
    merzListe: function merzListe() {
      this.updateSvg();
    }
  },
  mounted: function mounted() {
    this.updateSvg();
  },


  methods: {
    gotoPage: function gotoPage(merzId) {
      this.$router.push({
        path: "/texte/merzhefte/ansichtsmodus?merzId=" + merzId + "&seiteIdx=0"
      });
    },
    updateSvg: function updateSvg() {

      if (!this.merzListe || this.rendered) {
        return;
      }
      var vue = this;

      var svgstr = this.$_getSvg("schwitters_hefte_auswahl_RD_web-felder-nr3.svg");

      var div = document.createElement("div");
      div.innerHTML = svgstr;
      var svg = div.firstChild;
      svg.style.width = "100%";
      svg.style.height = "100%";

      this.$el.querySelector(".ksm-merz-container").appendChild(svg);

      var merzListe = this.merzListe;
      var rects = svg.querySelectorAll("rect");
      var title_g = this.$el.querySelectorAll(".st1");
      var uses = svg.querySelectorAll("use");
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(uses), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var u = _step.value;

          __WEBPACK_IMPORTED_MODULE_1_d3__["a" /* select */](u).style("fill", null);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var merz241_g_clone = void 0;
      var merz242_g = void 0;
      var x = 0.0,
          y = 0.0;
      var add = false;

      var _loop = function _loop(g) {
        add = false;
        if (g.getAttribute("id")) {
          var rect_id = g.getAttribute("id").replace("_g", "_");

          if (rect_id === "SVGID_st241_") {
            merz241_g_clone = g.cloneNode(true);
            add = true;
          }
          if (rect_id === "SVGID_st242_") {
            merz242_g = g;
            add = true;
          }
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(rects), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var rect = _step3.value;

              if (rect.getAttribute("id") === rect_id) {
                if (add) {
                  x = parseFloat(__WEBPACK_IMPORTED_MODULE_1_d3__["a" /* select */](rect).attr("x"));
                  y += parseFloat(__WEBPACK_IMPORTED_MODULE_1_d3__["a" /* select */](rect).attr("height"));
                }
                if (!rect.classList.contains("st0")) {
                  g.insertBefore(rect.parentNode.parentNode, g.firstChild);
                } else {
                  g.insertBefore(rect, g.firstChild);
                }
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          __WEBPACK_IMPORTED_MODULE_1_d3__["a" /* select */](g).on("mouseover", function () {
            g.classList.remove("hide_merz_rect");
            g.classList.add("show_merz_rect");
          }).on("mouseout", function () {
            g.classList.remove("show_merz_rect");
            g.classList.add("hide_merz_rect");
          }).on("click", function () {
            g.classList.remove("show_merz_rect");
            g.classList.add("hide_merz_rect");
            if (rect_id === "SVGID_st132_" || rect_id === "SVGID_st242_") {
              vue.$router.push({
                path: "/texte/ursonate"
              });
              return;
            }

            var merz = merzListe.find(function (merz) {
              return merz.svgID === rect_id;
            });
            if (merz) {
              vue.gotoPage(merz.id);
            }
          });

          g.classList.add("hide_merz_rect");
        }
      };

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(title_g), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var g = _step2.value;

          _loop(g);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      merz241_g_clone.removeAttribute("id");
      merz241_g_clone.classList.remove("hide_merz_rect");
      __WEBPACK_IMPORTED_MODULE_1_d3__["a" /* select */](merz241_g_clone).remove("class", "hide_merz_rect").attr("transform", "scale(0.6) translate(" + x / 1.43 + "," + (y * 4 + 10) + ")");
      svg.appendChild(merz241_g_clone);

      this.rendered = true;
    }
  },
  computed: {
    merzListe: function merzListe() {
      return this.$store.getters.texte.merzListe;
    }
  }
});

/***/ }),

/***/ 979:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modus_ModusIndex__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modus_ModusIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_modus_ModusIndex__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ModusIndex: __WEBPACK_IMPORTED_MODULE_0__components_modus_ModusIndex___default.a
  },
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),

/***/ 980:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PlayerControls__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PlayerControls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PlayerControls__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { PlayerControls: __WEBPACK_IMPORTED_MODULE_0__PlayerControls___default.a },
  props: ["isConnect2"],
  data: function data() {
    return {
      duration: 0,
      media: null,
      selected_audio: "Audio1924",
      isPause: true
    };
  },

  watch: {
    selected_audio: function selected_audio(f) {
      var schallplatten = this.$el.querySelector(".ksm-schallplatten");
      schallplatten.classList.remove("ksm-rotating");
      this.media.src = "./static/multimedia/" + this.audioSrc;
      this.media.load();
    }
  },
  mounted: function mounted() {
    var vue = this;
    var media = this.$el.querySelector(".ksm-media");
    this.media = media;
    var schallplatten = this.$el.querySelector(".ksm-schallplatten");

    vue.$store.state.eventBus.$on("audio-connect-2", function (isConnect2) {
      if (isConnect2 && !vue.isPause) {} else if (isConnect2) {}
    });

    media.addEventListener("play", function () {
      if (vue.isConnect2) {}
      schallplatten.classList.add("ksm-rotating");
    });

    media.addEventListener("pause", function () {
      if (vue.isConnect2) {
        vue.$store.state.eventBus.$emit("video-pause", vue.media.currentTime);
      }
      schallplatten.classList.remove("ksm-rotating");
    });
  },
  computed: {
    audioSrc: function audioSrc() {
      if (this.selected_audio === "Audio1924") {
        return "platte_1923.mp3";
      } else {
        return "platte_1932.mp3";
      }
    }
  },
  methods: {
    audioChange: function audioChange(obj) {
      this.$emit("audioChange", obj);
    },
    playPause: function playPause(d) {
      this.isPause = d;
    }
  }
});

/***/ }),

/***/ 981:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PlayerControls__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PlayerControls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PlayerControls__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { PlayerControls: __WEBPACK_IMPORTED_MODULE_0__PlayerControls___default.a },
  props: ["isConnect2"],
  data: function data() {
    return {
      duration: 0,
      media: null,
      isPause: true
    };
  },

  mounted: function mounted() {
    var vue = this;
    var media = this.$el.querySelector(".ksm-media");
    this.media = media;
    media.addEventListener("play", function () {
      if (vue.isConnect2) {}
    });

    media.addEventListener("pause", function () {
      if (vue.isConnect2) {}
    });
  },
  methods: {
    videoPlaying: function videoPlaying() {
      this.$emit("videoPlaying");
    },
    playPause: function playPause(d) {
      this.isPause = d;
    }
  }
});

/***/ }),

/***/ 982:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PlayerControls__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PlayerControls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PlayerControls__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vendor_midi_js__ = __webpack_require__(427);








var midiPlayer = __WEBPACK_IMPORTED_MODULE_4__vendor_midi_js__["MIDI"].Player;

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["meiName", "seite"],
  components: { PlayerControls: __WEBPACK_IMPORTED_MODULE_3__PlayerControls___default.a },
  data: function data() {
    return {
      currentTime: 0,
      duration: 0,
      midiData: null,
      noteTranscriptMap: null,
      transcriptMeasureMap: null,
      meiTranscripts: [],
      page: 1,
      ids: [],
      zoom: 20,
      svg: null,
      playerDataLoaded: false
    };
  },

  watch: {
    meiName: function meiName() {
      this.svgHighligthReset();
      midiPlayer.stop();
      this.playerDataLoaded = false;
      this.loadMei();
    },
    midiData: function midiData(d) {
      this.svgHighligthReset();
      midiPlayer.stop();
    }
  },
  mounted: function mounted() {
    this.initPlayer();
    this.loadMei();
  },


  methods: {
    initPlayer: function initPlayer() {
      var vue = this;
      var vrvToolkit = new verovio.toolkit();
      this.vrvToolkit = vrvToolkit;
      window.addEventListener("resize", function () {});

      var _getContainerSize = this.getContainerSize(),
          w = _getContainerSize.w,
          h = _getContainerSize.h;

      midiPlayer.setAnimation(function (data, element) {
        vue.currentTime = midiPlayer.currentTime;
      });
      midiPlayer.addListener(function (data) {
        vue.midiUpdate(data.now);
      });
    },
    seekbarChange: function seekbarChange(t) {
      if (midiPlayer.playing) {
        midiPlayer.pause();
        midiPlayer.currentTime = t;
        midiPlayer.resume();
      } else {
        midiPlayer.currentTime = t;
        this.midiUpdate(t);
      }
    },
    playPause: function playPause(pause) {
      if (pause) {
        midiPlayer.pause(true);
        return;
      }
      var vue = this;
      if (!this.playerDataLoaded) {
        this.playerDataLoaded = true;
        midiPlayer.loadFile(this.midiData, function () {
          midiPlayer.start();
          vue.duration = midiPlayer.endTime;
          vue.currentTime = midiPlayer.currentTime;
        });
      } else {
        midiPlayer.resume();
      }
    },
    getContainerSize: function getContainerSize() {
      var container = this.$el.querySelector(".ksm-ursonate_note");
      var style = window.getComputedStyle(container);
      return {
        w: parseFloat(style.getPropertyValue("width").replace("px", "")),
        h: parseFloat(style.getPropertyValue("height").replace("px", ""))
      };
    },
    setOptions: function setOptions() {
      var vue = this;
      var zoom = this.zoom;

      var _getContainerSize2 = this.getContainerSize(),
          w = _getContainerSize2.w,
          h = _getContainerSize2.h;

      var pageHeight = h * 100 / zoom;
      var pageWidth = w * 100 / zoom;
      var options = {
        scale: zoom,
        adjustPageHeight: true
      };
      this.vrvToolkit.setOptions(options);
    },
    sondernFall: function sondernFall(file, data) {
      console.log(file);

      if (file.indexOf("que_06842367_Bl.3v, Bl.4r.mei") > -1) {
        data = data.replace('<staff xml:id="m-303" n="1">', '<measure xml:id="m-302" n="14" facs="#zone_1fae54ca-f00e-40f3-b45e-715cca533a9d"><staff xml:id="m-303" n="1">');
      }

      var xmlData = $.parseXML(data);
      var mdivs = xmlData.querySelectorAll("mdiv");
      if (mdivs.length > 1) {
        var section1 = mdivs[0].querySelector("section");
        var i = 0;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(mdivs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var d = _step.value;

            if (i > 0) {
              var measures = d.querySelectorAll("measure");
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(measures), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var m = _step2.value;

                  section1.appendChild(m);
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }

              d.remove();
            }
            i++;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        var xmlString = void 0;

        if (window.ActiveXObject) {
          xmlString = xmlData.xml;
        } else {
            xmlString = new XMLSerializer().serializeToString(xmlData);
          }
        data = xmlString;
      }

      return data;
    },
    midiUpdate: function midiUpdate(time) {
      if (time === midiPlayer.endTime) {}
      var vue = this;

      var vrvTime = Math.max(0, time);
      var ids = this.ids;
      var elementsattime = this.vrvToolkit.getElementsAtTime(vrvTime);
      if (elementsattime.page > 0) {
        if (elementsattime.page != this.page) {
          this.page = elementsattime.page;
          this.loadPage();
        }

        if (elementsattime.notes.length > 0 && this.ids != elementsattime.notes) {
          this.ids.forEach(function (noteid) {
            if ($.inArray(noteid, elementsattime.notes) == -1) {
              var transcript = vue.noteTranscriptMap.get(noteid);
              var measure = vue.transcriptMeasureMap.get(transcript);
              if (measure) {
                var measurElem = vue.container.querySelector("#rect_" + measure);
                if (measurElem) {
                  measurElem.classList.remove("ksm-ursonate_measure-active");
                }
              }

              var noteElem = vue.container.querySelector("#" + noteid);
              if (noteElem) {
                noteElem.classList.remove("ksm-ursonate_note-active");
              }
            }
          });
          this.ids = elementsattime.notes;
          this.ids.forEach(function (noteid) {
            if ($.inArray(noteid, elementsattime.notes) != -1) {
              var tr_id = vue.noteTranscriptMap.get(noteid);
              vue.$emit("transcriptUpdate", [tr_id]);

              var transcript = vue.noteTranscriptMap.get(noteid);
              var measure = vue.transcriptMeasureMap.get(transcript);
              if (measure) {
                var n1 = vue.container.querySelector("#rect_" + measure);
                if (n1) {
                  n1.classList.add("ksm-ursonate_measure-active");
                }
              }
              var n2 = vue.container.querySelector("#" + noteid);
              if (n2) {
                n2.classList.add("ksm-ursonate_note-active");
              }
            }
          });
        }
      }
    },
    svgHighligthReset: function svgHighligthReset() {
      var vue = this;
      this.ids.forEach(function (noteid) {
        var transcript = vue.noteTranscriptMap.get(noteid);
        var measure = vue.transcriptMeasureMap.get(transcript);
        if (measure) {
          var n1 = vue.container.querySelector("#rect_" + measure);
          if (n1) {
            n1.classList.remove("ksm-ursonate_measure-active");
          }
        }
        var n2 = vue.container.querySelector("#" + noteid);
        if (n2) {
          n2.classList.remove("ksm-ursonate_note-active");
        }
      });
      vue.$emit("transcriptUpdate", []);
    },
    applyZoom: function applyZoom() {
      this.vrvToolkit.redoLayout();
      this.setOptions();
      this.loadPage();
    },
    parseMei: function parseMei(file, data) {
      this.setOptions();
      data = this.sondernFall(file, data);

      var tmpDiv = document.createElement("div");
      var tmpTrs = [];
      tmpDiv.innerHTML = data;

      var surface = tmpDiv.querySelectorAll("surface");
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(surface), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var sf = _step3.value;

          var zones = sf.querySelectorAll("zone");
          var _iteratorNormalCompletion5 = true;
          var _didIteratorError5 = false;
          var _iteratorError5 = undefined;

          try {
            for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(zones), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
              var zone = _step5.value;

              var id = zone.getAttribute("xml:id");
              var ulx = zone.getAttribute("ulx");
              var uly = zone.getAttribute("uly");
              var lrx = zone.getAttribute("lrx");
              var lry = zone.getAttribute("lry");
              tmpTrs.push({
                id: id.replace("zone_", ""),
                x: parseFloat(ulx),
                y: parseFloat(uly),
                w: parseFloat(lrx) - parseFloat(ulx),
                h: parseFloat(lry) - parseFloat(uly)
              });
            }
          } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
              }
            } finally {
              if (_didIteratorError5) {
                throw _iteratorError5;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      this.meiTranscripts = tmpTrs;
      this.seite.$_allTranscripts[0] = {
        transcripts: tmpTrs
      };
      this.seite.$_parseMei = true;
      var noteMap = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
      var measureMap = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
      var measure = tmpDiv.querySelectorAll("measure");
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(measure), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var m = _step4.value;

          var facs = m.getAttribute("facs");
          if (!facs) {
            continue;
          }
          var tr_id = facs.replace("#zone_", "");
          measureMap.set(tr_id, m.getAttribute("xml:id"));
          var notes = m.querySelectorAll("note");
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(notes), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var n = _step6.value;

              var xmlId = n.getAttribute("xml:id");
              if (xmlId) {
                noteMap.set(xmlId, tr_id);
              }
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      this.noteTranscriptMap = noteMap;
      this.transcriptMeasureMap = measureMap;

      this.vrvToolkit.loadData(data);
      var base64midi = this.vrvToolkit.renderToMIDI();
      this.midiData = "data:audio/midi;base64," + base64midi;
      this.page = 1;
      this.loadPage();
    },
    loadMei: function loadMei() {
      var vue = this;

      if (!this.meiName) {
        return;
      }

      if (this.container) {
        this.container.innerHTML = "";
      }
      var meiName = this.meiName;
      if (meiName === "que_06842362_von hinten_Cvin, Bl.1r.mei") {
        meiName = "que_06842362_Bl.3v, Cvin.mei";
      } else if (meiName === "que_06842362_von hinten_Bl.1v, Bl.2r.mei") {
        meiName = "que_06842362_Bl.2v, Bl.3r.mei";
      } else if (meiName === "que_06842366_Bl.1v, Bl.2r.mei") {
        meiName = "que_06842366_ Bl.1v, Bl.2r.mei";
      }
      var file = "./static/multimedia/mei/" + meiName;
      $.ajax({
        url: file,
        dataType: "text",
        success: function success(data) {
          vue.parseMei(file, data);
        },
        error: function error() {
          vue.midiData = null;
          vue.seite.$_parseMei = true;
          console.log(file, "nicht gefunden!!!");
        }
      });
    },
    loadPage: function loadPage() {
      var vrvToolkit = this.vrvToolkit;
      var page = this.page ? this.page : 1;
      var svg = vrvToolkit.renderToSVG(page, {});
      var container = this.$el.querySelector(".ksm-ursonate_note");
      container.innerHTML = svg;
      this.container = container;
      var measureGs = container.querySelectorAll(".measure");
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(measureGs), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var g = _step7.value;

          var box = g.getBBox();
          __WEBPACK_IMPORTED_MODULE_2_d3__["a" /* select */](g).append("rect").attr("x", box.x).attr("y", box.y).attr("id", "rect_" + g.getAttribute("id")).attr("width", box.width).attr("height", box.height).attr("fill", "transparent");
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }
    }
  }
});

/***/ }),

/***/ 983:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_comps_Thumbnail_vue__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_comps_Thumbnail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_comps_Thumbnail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_comps_DeepzoomView_vue__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_comps_DeepzoomView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_comps_DeepzoomView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NotenPlayer__ = __webpack_require__(1948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NotenPlayer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__NotenPlayer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_comps_mixins_Urlparams__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_comps_mixins_Urlparams___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_comps_mixins_Urlparams__);









/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5_comps_mixins_Urlparams___default.a],
  components: { Thumbnail: __WEBPACK_IMPORTED_MODULE_1_comps_Thumbnail_vue___default.a, DeepzoomView: __WEBPACK_IMPORTED_MODULE_2_comps_DeepzoomView_vue___default.a, NotenPlayer: __WEBPACK_IMPORTED_MODULE_4__NotenPlayer___default.a },
  data: function data() {
    return {
      viewKey: "ursonate_noten",
      noteTranscriptMap: null,
      transcriptMeasureMap: null,

      meiName: null,
      localParams: {
        noteIdx: "0"
      },
      groupIdx: 0
    };
  },

  watch: {
    seite: {
      deep: true,
      handler: function handler(d) {
        this.updateMeiName(d);
      }
    }
  },
  mounted: function mounted() {
    this.updateMeiName(this.seite);
  },

  computed: {
    stateUrlParams: function stateUrlParams() {
      return this.modus.option.urlparams;
    },
    modus: function modus() {
      return this.$store.getters["modus/getModusByIdKey"]({
        modusId: "simple",
        viewKey: this.viewKey
      });
    },
    seite: function seite() {
      if (this.seiten) {
        return this.seiten[this.localParams.noteIdx];
      }
    },
    seiten: function seiten() {
      var list = this.$store.state.ursonate_noten.merzListe;
      if (list) {
        return list[0].seiten;
      }
    },
    notenGroup: function notenGroup() {
      if (this.seiten) {
        var group = [];
        this.seiten.forEach(function (s, i) {
          var label = s.title;
          var odate = s.datum;
          var g = group.find(function (g) {
            return g.label === label;
          });
          if (!g) {
            g = {
              label: label,
              seiten: [],
              idx: i,
              odate: odate
            };
            group.push(g);
          }
          g.seiten.push(s);
        });
        group.sort(function (a, b) {
          if (a.odate.length == 0 && b.odate.length == 0) return 0;
          if (a.odate.length == 0) return 1;
          if (b.odate.length == 0) return -1;
          return a.odate > b.odate ? 1 : b.odate > a.odate ? -1 : 0;
        });
        return group;
      }
    },
    isReady: function isReady() {
      return this.seite && this.seite.$_parseMei;
    }
  },

  methods: {
    transcriptUpdate: function transcriptUpdate(d) {
      var opt = this.modus.option;
      this.$store.state.eventBus.$emit(["marknote.sidebar", opt.viewKey, opt.key].join("-"), d);
    },
    updateMeiName: function updateMeiName(d) {
      if (d && d.$_docInfo && d.$_allTranscripts) {
        var arr = d.thumbnailSrc.split("/");
        arr = arr[arr.length - 1];
        arr = arr.split(".");
        arr = arr.slice(0, arr.length - 1);
        arr.push("mei");
        this.meiName = arr.join(".");
      }
    },
    changeGroup: function changeGroup(i) {
      this.localParams.noteIdx = this.notenGroup[this.groupIdx].seiten[0].idx + "";
    },
    changeSeite: function changeSeite(i) {
      this.localParams.noteIdx = i + "";
      var j = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.notenGroup), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var g = _step.value;

          if (g.seiten.find(function (s) {
            return s.idx - i === 0;
          })) {
            this.groupIdx = j;
            return;
          }
          j++;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }
});

/***/ }),

/***/ 984:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["media", "mediaName", "mediaType", "duration", "currentTime", "playBtnDisable"],
  components: {},
  data: function data() {
    return {
      isPlaying: false,
      localDuration: 0,
      seekbarlock: false,
      w: 0
    };
  },

  watch: {
    mediaName: function mediaName() {
      this.isPlaying = false;
    },
    currentTime: function currentTime(t) {
      if (this.mediaType === "midi") {
        this.seekbar.value = t;
      }
    },
    duration: function duration(d) {
      if (this.mediaType === "midi") {
        this.seekbar.max = d;
      }
    }
  },

  computed: {
    ursonateData: function ursonateData() {
      return this.$store.state.ursonateData;
    },
    ursonateData2: function ursonateData2() {
      return this.$store.state.ursonateData2;
    },
    svgData: function svgData() {
      var _this = this;

      if (!this.ursonateData || !this.ursonateData2 || !this.localDuration || this.mediaType === "midi") {
        return;
      }
      var w = this.w;
      var duration = this.localDuration;
      var factor = 3000 / duration;
      var ursonateData2 = this.ursonateData2;

      var themen = this.ursonateData.filter(function (d) {
        return d["medien"] === _this.mediaName;
      }).map(function (d, i) {
        var arr = d["timestamp"].split("-");
        var von = arr[0];
        var bis = arr[1];
        var von2 = void 0,
            bis2 = void 0;
        von = parseFloat(von.split(":")[0]) * 60 + parseFloat(von.split(":")[1]);
        bis = parseFloat(bis.split(":")[0]) * 60 + parseFloat(bis.split(":")[1]);
        var duration = bis - von;
        var duration2 = void 0;
        var playbackRate = void 0;

        var ursonateData2Item = ursonateData2.find(function (d2) {
          return d2.ID - d.ID === 0;
        });
        if (_this.mediaName !== "Film" && ursonateData2Item) {
          var arr2 = ursonateData2Item["timestamp2"].split("-");
          von2 = arr2[0];
          bis2 = arr2[1];
          von2 = parseFloat(von2.split(":")[0]) * 60 + parseFloat(von2.split(":")[1]);
          bis2 = parseFloat(bis2.split(":")[0]) * 60 + parseFloat(bis2.split(":")[1]);
          duration2 = bis2 - von2;
          playbackRate = duration2 / duration;
        }

        var width = (bis - von) * factor + "px";
        return {
          von: von,
          bis: bis,
          von2: von2,
          bis2: bis2,
          duration: duration,
          duration2: duration2,
          playbackRate: playbackRate,
          title: d.thema,
          tooltipOpt: {
            content: d.thema,
            placement: "top-center",
            classes: ["info"]
          },
          currentTime: null,
          class: d.thema.replace(" ", "-").toLowerCase(),

          docID: d.docID,
          x: von * factor,
          width: width
        };
      });

      return themen;
    }
  },
  mounted: function mounted() {
    var vue = this;
    var mediaType = this.mediaType;
    if (this.mediaType === "midi") {
      this.setMidiPlayer();
    } else {
      this.setNormalPlayer();
    }

    this.$store.state.eventBus.$on(mediaType + "-play", function (currentTime) {
      if (!vue.isPlaying) {
        if (currentTime !== undefined && currentTime !== null) {
          vue.media.currentTime = currentTime;
        }
        vue.play();
      }
    });

    if (mediaType === "video") {
      this.$store.state.eventBus.$on(mediaType + "-sync", function (_ref) {
        var playbackRate = _ref.playbackRate,
            currentTime = _ref.currentTime,
            isPlaying = _ref.isPlaying;

        vue.media.playbackRate = playbackRate;
        vue.media.currentTime = currentTime;
        if (!vue.isPlaying && isPlaying) {
          vue.play();
        }
      });
    }

    this.$store.state.eventBus.$on(mediaType + "-pause", function (currentTime) {
      if (vue.isPlaying) {
        vue.play();
      }
    });
  },
  methods: {
    setMidiPlayer: function setMidiPlayer() {
      var vue = this;
      var seekbar = this.$el.querySelector(".ksm-player__seekbar");
      this.seekbar = seekbar;
      seekbar.addEventListener("change", function (e) {
        e.preventDefault();
        vue.$emit("seekbarChange", seekbar.value);
      });
      if (this.duration) {
        seekbar.max = this.duration;
      }
    },
    setNormalPlayer: function setNormalPlayer() {
      var vue = this;
      var media = this.media;
      var mediaName = this.mediaName;
      var seekbar = this.$el.querySelector(".ksm-player__seekbar");
      vue.w = this.$el.querySelector(".ksm-player__row-middle").clientWidth;
      this.seekbar = seekbar;
      media.addEventListener("loadedmetadata", function (e) {
        e.preventDefault();
        var duration = media.duration;
        vue.localDuration = duration;
        vue.seekbar.max = duration;
      });
      media.addEventListener("timeupdate", function (e) {
        if (vue.seekbarlock) {
          return;
        }
        e.preventDefault();
        var t = parseFloat(media.currentTime);
        vue.seekbar.value = t;

        var d = void 0;
        if (vue.svgData) {
          d = vue.svgData.find(function (d) {
            return t >= d.von && t <= d.bis;
          });
          if (d) {
            d.currentTime = t;
          }
        }
        if (mediaName.indexOf("Audio") === 0) {
          vue.$emit("audioChange", { d: d, isPlaying: vue.isPlaying });
        } else if (mediaName.indexOf("Film") === 0) {
          vue.$emit("videoPlaying", d);
        }
      });
      media.addEventListener("ended", function (e) {
        console.log("ended");
      });
      seekbar.addEventListener("mousedown", function (e) {
        vue.seekbarlock = true;
      });
      seekbar.addEventListener("mouseup", function (e) {
        vue.seekbarlock = false;
      });
      seekbar.addEventListener("change", function (e) {
        e.preventDefault();
        vue.seekbar.max = media.duration;
        media.currentTime = seekbar.value;
        if (!vue.isPlaying) {}
      });
    },
    play: function play(playbackRate) {
      if (this.mediaType === "video" && playbackRate) {
        if (this.playBtnDisable) {
          return;
        }
        this.media.playbackRate = playbackRate;
      }
      if (this.mediaType === "midi") {
        this.playMidi();
      } else {
        this.playNormal();
      }
    },
    playMidi: function playMidi() {
      if (this.isPlaying) {
        this.$emit("playPause", true);
      } else {
        this.$emit("playPause");
      }
      this.isPlaying = !this.isPlaying;
    },
    playNormal: function playNormal() {
      if (this.isPlaying) {
        this.$emit("playPause", true);
        this.media.pause();
      } else {
        this.media.play();
        this.$emit("playPause");
      }
      this.isPlaying = !this.isPlaying;
    }
  }
});

/***/ }),

/***/ 985:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_comps_Thumbnail_vue__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_comps_Thumbnail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_comps_Thumbnail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_comps_DeepzoomView_vue__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_comps_DeepzoomView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_comps_DeepzoomView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_comps_mixins_Urlparams__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_comps_mixins_Urlparams___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_comps_mixins_Urlparams__);







/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3_comps_mixins_Urlparams___default.a],
  components: { Thumbnail: __WEBPACK_IMPORTED_MODULE_0_comps_Thumbnail_vue___default.a, DeepzoomView: __WEBPACK_IMPORTED_MODULE_1_comps_DeepzoomView_vue___default.a },
  props: ["themaPlaying", "isConnect1"],
  data: function data() {
    return {
      viewName: "textView",
      noteTranscriptMap: null,
      transcriptMeasureMap: null,
      ready: false,
      localParams: {
        seiteIdx: "0"
      }
    };
  },

  watch: {
    seite: {
      deep: true,
      handler: function handler(d) {}
    },
    themaPlaying: {
      handler: function handler(d) {
        this.gotoSeite();
      },

      tree: true
    },
    isConnect1: function isConnect1(d) {
      if (d) {
        this.gotoSeite();
      } else {
        var opt = this.modus.option;
        this.$store.state.eventBus.$emit(["marknote.sidebar", opt.viewKey, opt.key].join("-"), []);
      }
    }
  },
  mounted: function mounted() {
    this.gotoSeite();
  },

  computed: {
    stateUrlParams: function stateUrlParams() {
      return this.modus.option.urlparams;
    },
    modus: function modus() {
      return this.$store.getters["modus/getModusByIdKey"]({
        modusId: "simple",
        viewKey: "ursonate_texte"
      });
    },
    seite: function seite() {
      if (this.seiten) {
        return this.seiten[this.localParams.seiteIdx];
      }
    },
    seiten: function seiten() {
      var list = this.$store.state.ursonate_texte.merzListe;
      if (list) {
        return list[0].seiten;
      }
    }
  },

  methods: {
    changeSeite: function changeSeite(i) {
      this.localParams.seiteIdx = i + "";
    },
    gotoSeite: function gotoSeite() {
      var d = this.themaPlaying;
      var opt = this.modus.option;
      if (d && d.docID) {
        var seite = this.seiten.find(function (seite) {
          return seite.seiteIds.indexOf(d.docID) > -1;
        });
        if (seite) {
          this.changeSeite(seite.idx);
          var themen = seite.$_themen;
          if (!themen || themen.length < 1) {
            themen = this.$store.getters["modus/getSeiteDataExtendInfo"](seite, "themen");
          }

          if (themen && d.class) {
            var t = themen.find(function (t) {
              return t.class === d.class;
            });
            if (t) {
              this.$store.state.eventBus.$emit(["marknote.sidebar", opt.viewKey, opt.key].join("-"), t.transcripts);
            }
          }
        }
      }
    }
  }
});

/***/ }),

/***/ 986:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icon_Loading__ = __webpack_require__(1918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icon_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__icon_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icon_LoadingMask__ = __webpack_require__(1920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icon_LoadingMask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__icon_LoadingMask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icon_LoadingCircle__ = __webpack_require__(1919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icon_LoadingCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__icon_LoadingCircle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__btn_Checkbox__ = __webpack_require__(1913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__btn_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__btn_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__btn_PlayButton__ = __webpack_require__(1915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__btn_PlayButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__btn_PlayButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__btn_ConnectButton__ = __webpack_require__(1914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__btn_ConnectButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__btn_ConnectButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__comps_PersonMerz__ = __webpack_require__(1917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__comps_PersonMerz___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__comps_PersonMerz__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__comps_FormatHtml__ = __webpack_require__(1916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__comps_FormatHtml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__comps_FormatHtml__);










var components = {
    Loading: __WEBPACK_IMPORTED_MODULE_1__icon_Loading___default.a,
    LoadingMask: __WEBPACK_IMPORTED_MODULE_2__icon_LoadingMask___default.a,
    LoadingCircle: __WEBPACK_IMPORTED_MODULE_3__icon_LoadingCircle___default.a,
    Checkbox: __WEBPACK_IMPORTED_MODULE_4__btn_Checkbox___default.a,
    PlayButton: __WEBPACK_IMPORTED_MODULE_5__btn_PlayButton___default.a,
    ConnectButton: __WEBPACK_IMPORTED_MODULE_6__btn_ConnectButton___default.a,
    PersonMerz: __WEBPACK_IMPORTED_MODULE_7__comps_PersonMerz___default.a,
    FormatHtml: __WEBPACK_IMPORTED_MODULE_8__comps_FormatHtml___default.a
};

var install = function install(Vue, Option) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(components).forEach(function (key) {
        Vue.component(components[key].name, components[key]);
    });
};
/* harmony default export */ __webpack_exports__["a"] = ({
    install: install
});

/***/ }),

/***/ 987:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(2003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home__ = __webpack_require__(1933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Kunstwerke_vue__ = __webpack_require__(1936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Kunstwerke_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Kunstwerke_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_texte_Start_vue__ = __webpack_require__(1944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_texte_Start_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_texte_Start_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_texte_TexteModus_vue__ = __webpack_require__(1945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_texte_TexteModus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_texte_TexteModus_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_texte_MedienOverview_vue__ = __webpack_require__(1943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_texte_MedienOverview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_texte_MedienOverview_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_MerzWerbe_vue__ = __webpack_require__(1937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_MerzWerbe_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_MerzWerbe_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Personen_vue__ = __webpack_require__(1940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Personen_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_Personen_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_OrteUndWege_vue__ = __webpack_require__(1939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_OrteUndWege_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_OrteUndWege_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Bibliographie_vue__ = __webpack_require__(1927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Bibliographie_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_Bibliographie_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Suche_vue__ = __webpack_require__(1942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Suche_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_Suche_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Hilfe_vue__ = __webpack_require__(1932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Hilfe_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_Hilfe_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Projektinfo_vue__ = __webpack_require__(1941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Projektinfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_Projektinfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_Beteiligte_vue__ = __webpack_require__(1926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_Beteiligte_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_Beteiligte_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_Foerderer_vue__ = __webpack_require__(1929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_Foerderer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__views_Foerderer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_Kontakt_vue__ = __webpack_require__(1935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_Kontakt_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__views_Kontakt_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_Datenschutz_vue__ = __webpack_require__(1928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_Datenschutz_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__views_Datenschutz_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_Impressum_vue__ = __webpack_require__(1934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_Impressum_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__views_Impressum_vue__);




















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: "/",
    name: "home",
    component: __WEBPACK_IMPORTED_MODULE_2__views_Home___default.a
  }, {
    path: "/kunstwerke",
    name: "kunstwerke",
    component: __WEBPACK_IMPORTED_MODULE_3__views_Kunstwerke_vue___default.a
  }, {
    path: "/texte/merzhefte",
    name: "texte",
    component: __WEBPACK_IMPORTED_MODULE_4__views_texte_Start_vue___default.a
  }, {
    path: "/texte/ursonate",
    name: "medien-overview",
    component: __WEBPACK_IMPORTED_MODULE_6__views_texte_MedienOverview_vue___default.a
  }, {
    path: "/texte/merzhefte/:modus",
    name: "texte-modus",
    component: __WEBPACK_IMPORTED_MODULE_5__views_texte_TexteModus_vue___default.a
  }, {
    path: "/merzwerbe/:modus?",
    name: "werbe-modus",
    component: __WEBPACK_IMPORTED_MODULE_7__views_MerzWerbe_vue___default.a
  }, {
    path: "/personen",
    name: "personen",
    component: __WEBPACK_IMPORTED_MODULE_8__views_Personen_vue___default.a
  }, {
    path: "/orteundwege",
    name: "orteundwege",
    component: __WEBPACK_IMPORTED_MODULE_9__views_OrteUndWege_vue___default.a
  }, {
    path: "/bibliographie/:keyitem?",
    name: "bibliographie",
    component: __WEBPACK_IMPORTED_MODULE_10__views_Bibliographie_vue___default.a
  }, {
    path: "/suche",
    name: "suche",
    component: __WEBPACK_IMPORTED_MODULE_11__views_Suche_vue___default.a
  }, {
    path: "/hilfe",
    name: "hilfe",
    component: __WEBPACK_IMPORTED_MODULE_12__views_Hilfe_vue___default.a

  }, {
    path: "/projektinfo",
    name: "projektinfo",
    component: __WEBPACK_IMPORTED_MODULE_13__views_Projektinfo_vue___default.a
  }, {
    path: "/beteiligte",
    name: "beteiligte",
    component: __WEBPACK_IMPORTED_MODULE_14__views_Beteiligte_vue___default.a
  }, {
    path: "/foerderer",
    name: "foerderer",
    component: __WEBPACK_IMPORTED_MODULE_15__views_Foerderer_vue___default.a
  }, {
    path: "/kontakt",
    name: "kontakt",
    component: __WEBPACK_IMPORTED_MODULE_16__views_Kontakt_vue___default.a
  }, {
    path: "/datenschutz",
    name: "datenschutz",
    component: __WEBPACK_IMPORTED_MODULE_17__views_Datenschutz_vue___default.a
  }, {
    path: "/impressum",
    name: "impressum",
    component: __WEBPACK_IMPORTED_MODULE_18__views_Impressum_vue___default.a
  }]
}));

/***/ }),

/***/ 988:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fechtDocumentById", function() { return fechtDocumentById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fechtSeiteDocs", function() { return fechtSeiteDocs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchMerzAndPersonData", function() { return fetchMerzAndPersonData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchMerzExtendByIdPromise", function() { return fetchMerzExtendByIdPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchSeiteExtendByIdPromise", function() { return fetchSeiteExtendByIdPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchtranscriptCropImg", function() { return fetchtranscriptCropImg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchBibliographie", function() { return fetchBibliographie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchUrsonate", function() { return fetchUrsonate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setOSDToolTips", function() { return setOSDToolTips; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__datamodel_sidebar_model__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api__ = __webpack_require__(218);










var isProduction =  true ? true : false;

var getTransriptsFromClass = function getTransriptsFromClass(html, atype, id) {
  var pattern = /<span class=\"(.*?)\"/g;
  var match = void 0;
  var transcripts = [];
  while (match = pattern.exec(html)) {
    var spanclass = match[1];
    if (spanclass.indexOf(atype + "-" + id) >= 0) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(spanclass.split(" ")), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var singleclass = _step.value;

          if (singleclass.indexOf("id-") >= 0) {
            var singleid = singleclass.substring(3);
            transcripts.push(singleid);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }
  return transcripts;
};

var _getSeiteNoteTranscriptMapping = function _getSeiteNoteTranscriptMapping(seite, docs) {
  var out = {};
  var keySet = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_set___default.a();
  __WEBPACK_IMPORTED_MODULE_7__datamodel_sidebar_model__["a" /* default */].forEach(function (it) {
    it.fudkeys.forEach(function (key) {
      keySet.add(key);
    });
  });
  var fudkeys = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(keySet));

  docs.forEach(function (doc) {
    var html98 = doc._source["98_html"];
    var notes = doc._source.notes;
    if (notes) {
      notes.forEach(function (n) {
        var cat = n.category;
        if (fudkeys.indexOf(cat) < 0) {
          return;
        }
        out[cat] ? null : out[cat] = [];
        var transcriptIDs = getTransriptsFromClass(html98, "notice", n.ID + " ");
        var o = {};
        var ids = [];
        transcriptIDs.forEach(function (id) {
          o[id] = 1;
        });
        ids = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(o);
        out[cat].push({
          ID: n.ID,
          ids: ids
        });
      });
    }

    fudkeys.forEach(function (key) {
      var val = doc._source[key];
      if (val) {
        val.forEach(function (obj) {
          if (!out[key]) {
            out[key] = [];
          }

          var has = out[key].find(function (h) {
            return h.ID === obj.ID;
          });
          var ids = getTransriptsFromClass(html98, "index", obj.ID);

          if (has) {
            has.ids = has.ids.concat(ids);
          } else {
            out[key].push({
              ID: obj.ID,
              ids: ids
            });
          }
        });
      }
    });
  });
  return out;
};

var initPersonenCollection2 = function initPersonenCollection2(personArr, merzMap) {

  personArr.forEach(function (person) {
    var merzItems = person.docIds.map(function (id) {
      return merzMap[id];
    });
    var newMerzItems = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
    merzItems.forEach(function (it) {
      if (!it) {
        return;
      }

      var m = it.merz;
      var seite = it.seite;
      var sIdx = seite.idx;

      var obj = newMerzItems.get(m.id);
      if (obj) {
        if (!obj.seiten.find(function (s) {
          return s.idx === sIdx;
        })) {
          obj.seiten.push(seite);
        }
      } else {
        newMerzItems.set(m.id, {
          merz: m,
          seiten: [seite]
        });
      }
    });
    var merzItems1 = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(newMerzItems.values()));
    merzItems1.sort(function (a, b) {
      a = a.merz.name;
      b = b.merz.name;
      if (a.match(/\d+/) && b.match(/\d+/)) {
        a = getNum({ name: a });
        b = getNum({ name: b });
        if (a > b) {
          return 1;
        } else if (a < b) {
          return -1;
        }
        return 0;
      } else {
        return a.localeCompare(b, 'de');
      }
    });

    person.merzItems1 = merzItems1;
    person.transcripts = [];
  });

  personArr.sort(function (a, b) {
    return a.content.localeCompare(b.content, 'de');
  });
  return personArr;
};

var getNum = function getNum(d) {
  var i = parseInt(d.name.replace("/", ",").split(",")[0].replace(/\D*/, ""), 10);
  if (isNaN(i)) {
    i = 0;
  }
  return i;
};

var initMerzData = function initMerzData(merzSeitenData) {
  var data = {};
  var docIDmap = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
  merzSeitenData.sort(function (a, b) {
    return a.docID - b.docID;
  }).forEach(function (seite) {
    var name = seite["Merzname"].replace("Merz ", "Merz");
    data[name] ? data[name].push(seite) : data[name] = [seite];
    docIDmap.set(seite.docID + '', seite);
  });

  var merzListe = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(data).map(function (name) {
    return {
      name: name,
      seiten: data[name],
      id: name.replace(/\s/g, "")
    };
  });

  var imageDziDir = "static/image_dzi";

  merzListe.forEach(function (merz) {
    var merzName = merz.name;
    if (merz.seiten && merz.seiten[0]) {
      merz.merzNameId = merz.seiten[0].MerzNameID;
    }

    var onePage = {};
    merz.seiten.forEach(function (d, i) {
      var imgD = void 0;
      var dzidir = imageDziDir;
      if (d.aufseite !== null) {
        imgD = docIDmap.get(d.aufseite + '');
      } else {
        imgD = d;
      }
      var img = imgD["doppelseite"];
      if (img) {
        d["imgDir"] = "doppelseitig";
      } else {
        img = imgD["einzelseite"];
        d["imgDir"] = "einseitig";
      }

      if (!img) {
        return;
      }

      if (onePage[img]) {
        onePage[img].seiteIds.push(d.docID);
        onePage[img].docs.push(d);
        return;
      }

      onePage[img] = {};

      if (merzName.indexOf("Merz") === 0 && merzName !== "Merz25") {
        onePage[img]["thumbnailSrc"] = [imageDziDir, "Thumbnails", img.replace(".jpg", ".png")].join("/");
        onePage[img]["deepSrc"] = [dzidir, img.replace(".jpg", ".png"), img.replace(".jpg", "") + ".dzi"].join("/");
      } else if (merzName === "Ursonate") {
        onePage[img]["thumbnailSrc"] = [imageDziDir, "Thumbnails", "thb", img.replace(".jpg", ".png")].join("/");
        onePage[img]["deepSrc"] = [dzidir, img.replace(".jpg", ".tif"), img.replace(".jpg", "").replace(".png", "") + ".dzi"].join("/");
      } else {
        var tbImg = img;
        if (merzName === "Merz25") {
          tbImg = img.replace(".jpg", ".png");
        }

        onePage[img]["thumbnailSrc"] = [imageDziDir, "Thumbnails", "thb", tbImg].join("/");
        onePage[img]["deepSrc"] = [dzidir, img.replace(".jpg", ".png"), img.replace(".jpg", "").replace(".png", "") + ".dzi"].join("/");
      }

      var format = d["format"];
      if (format && format.indexOf("x") > 0) {
        format = format.split("x");
        onePage[img].width = parseFloat(format[1].replace("cm", "").replace(",", "."), 10);
        onePage[img].height = parseFloat(format[0].replace(",", "."), 10);
      }

      onePage[img].seiteIds = [d.docID];
      onePage[img].docs = [d];
      onePage[img].title = d.title;
    });

    var arr = [];
    for (var k in onePage) {
      arr.push(onePage[k]);
    }
    merz.seiten = arr.sort(function (a, b) {
      a = a.docs[0].docID;
      b = b.docs[0].docID;
      if (a - b > 0) {
        return 1;
      } else if (a - b < 0) {
        return -1;
      }
      return 0;
    });


    var isMerzwerbe = false;
    if (!merz.name.match(/^Merz\d*/) && merz.name !== "Ursonate" && !merz.name.match(/Noten/g)) {
      isMerzwerbe = true;
    }

    merz.seiten.forEach(function (s, i) {
      s.idx = i;
      var _n = s.docs.map(function (_d) {
        if (isMerzwerbe) {
          return _d.title;
        } else {
          return _d.paginierung ? _d.paginierung : _d["ArtderSeiteText"];
        }
      }).join(",");
      if (_n.match(/[^\d\,]/)) {
        s.name = _n;
      } else {
        s.name = "Seite " + _n;
      }

      var _v = s.docs.map(function (_d) {
        return _d.varianteseite ? _d.varianteseite : '';
      }).join("");
      if (_v !== '') {
        s.variante = _v;
      } else {
        s.variante = '';
      }

      var _da = s.docs.map(function (_d) {
        return _d.datum ? _d.datum : '';
      })[0];
      if (_da !== '') {
        s.datum = _da;
      } else {
        s.datum = '';
      }
    });
  });

  merzListe.forEach(function (merz) {
    merz._ = {
      einfuehrung: null,
      fetchEifuehrung: false
    };
    Object.defineProperty(merz, "$_einfuehrungDoc", {
      get: function get() {
        if (!merz._.fetchEifuehrung) {
          merz._.fetchEifuehrung = true;
          merz.merzNameId && fetchMerzExtendByIdPromise(merz.merzNameId).then(function (res) {
            if (res.merz && res.merz[0][0]) {
              var docID = res.merz[0][0].docID;
              fechtDocumentById(null, docID).then(function (d) {
                if (d && d.doc[0]) {
                  merz._.einfuehrung = d.doc[0];
                }
              });
            }
          });
        }
        return merz._.einfuehrung;
      }
    });

    merz.seiten.forEach(function (seite) {
      seite.$_themen = null;
      seite.$_parseMei = false;
      seite._ = {
        mainKommentar: null,
        docInfo: [],
        graphElemente: null,
        attachmentTags: null,
        fetchAttachmentTagsEnd: false,
        fetchMainKommentar: false,
        fetchMerzSeitenInfoStart: false,
        fetchMerzSeitenInfoEnd: false,
        cropImages: {},
        fetchCropImagesEnd: false,
        fetchGraphElemente: false
      };

      Object.defineProperty(seite, "$_mainKommentar", {
        get: function get() {
          if (!seite._.fetchMainKommentar) {
            seite._.fetchMainKommentar = true;
            fetchSeiteExtendByIdPromise(null, seite.seiteIds.join(",")).then(function (res) {
              seite._.mainKommentar = res;
            });
          }
          return seite._.mainKommentar;
        }
      });

      Object.defineProperty(seite, "$_fetchCropImagesEnd", {
        get: function get() {
          return seite._.fetchCropImagesEnd;
        }
      });

      Object.defineProperty(seite, "$_attachmentTags", {
        get: function get() {
          if (!seite._.attachmentTags && seite.docs) {
            seite._.attachmentTags = [];
            seite.docs.forEach(function (d) {
              if (d.filename) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__api__["a" /* queryPromise */])("attachment/" + d.filename).then(function (res) {
                  seite._.attachmentTags.push({
                    docID: d.docID,
                    tag: res.tag
                  });
                  if (seite._.attachmentTags.length === seite.docs.length) {
                    seite._.fetchAttachmentTagsEnd = true;
                  }
                });
              }
            });
          }
          return seite._.attachmentTags;
        }
      });

      Object.defineProperty(seite, "$_fetchAllExtendInfoEnd", {
        get: function get() {
          if (seite.$_attachmentTags && seite.$_docInfo && seite._.fetchAttachmentTagsEnd && seite._.fetcmerzSeitenDataocInfoEnd && seite.$_graphElemente) {
            return true;
          }
        }
      });

      Object.defineProperty(seite, "$_docInfo", {
        get: function get() {
          if (!seite._.fetcmerzSeitenDataocInfoStart) {
            seite._.fetcmerzSeitenDataocInfoStart = true;
            fechtSeiteDocs(null, seite);
          }
          return seite._.docInfo;
        }
      });

      Object.defineProperty(seite, "$_graphElemente", {
        get: function get() {
          if (!seite._.fetchGraphElemente) {
            seite._.fetchGraphElemente = true;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__api__["a" /* queryPromise */])("getGraphElementeBySeite/" + seite.seiteIds.join(",")).then(function (res) {
              seite._.graphElemente = res.transcripts;
            });
          }
          return seite._.graphElemente;
        }
      });
    });
  });

  merzListe.sort(function (a, b) {
    a = getNum(a);
    b = getNum(b);
    if (a > b) {
      return 1;
    } else if (a < b) {
      return -1;
    }
    return 0;
  });

  var merzSvgMapping = [{
    id: "Merz1",
    svgID: "SVGID_15_"
  }, {
    id: "Merz2",
    svgID: "SVGID_17_"
  }, {
    id: "Merz3",
    svgID: "SVGID_29_"
  }, {
    id: "Merz4",
    svgID: "SVGID_27_"
  }, {
    id: "Merz5",
    svgID: "SVGID_11_"
  }, {
    id: "Merz6",
    svgID: "SVGID_19_"
  }, {
    id: "Merz7",
    svgID: "SVGID_21_"
  }, {
    id: "Merz8/9",
    svgID: "SVGID_23_"
  }, {
    id: "Merz10",
    svgID: "SVGID_st10_"
  }, {
    id: "Merz11",
    svgID: "SVGID_25_"
  }, {
    id: "Merz12",
    svgID: "SVGID_13_"
  }, {
    id: "Merz13",
    svgID: "SVGID_st131_"
  }, {
    id: "Merz14,15",
    svgID: "SVGID_1_"
  }, {
    id: "Merz16/17",
    svgID: "SVGID_3_"
  }, {
    id: "Merz18/19",
    svgID: "SVGID_5_"
  }, {
    id: "Merz20",
    svgID: "SVGID_7_"
  }, {
    id: "Merz21",
    svgID: "SVGID_9_"
  }, {
    id: "Merz22",
    svgID: "SVGID_st22_"
  }, {
    id: "Merz23",
    svgID: "SVGID_st23_"
  }, {
    id: "Merz24",
    svgID: "SVGID_st241_"
  }, {
    id: "Merz25",
    svgID: "SVGID_st25_"
  }];

  merzSvgMapping.forEach(function (a) {
    var merz = merzListe.find(function (m) {
      return m.id === a.id;
    });
    if (merz) {
      merz.svgID = a.svgID;
    }
  });

  return merzListe;
};

var _initDocsTranscripts = function _initDocsTranscripts(openedSeite, docs) {
  var out = [];
  docs.forEach(function (d, idx) {
    if (!openedSeite.docs[idx]) {
      return;
    }
    var offsetX = parseFloat(openedSeite.docs[idx].doppelseitex);
    var offsetY = parseFloat(openedSeite.docs[idx].doppelseitey);

    d._source.transcript.forEach(function (tr) {
      if (offsetX > 0 || offsetY > 0) {
        var ulx = parseFloat(tr.ulx) + offsetX;
        var lrx = parseFloat(tr.lrx) + offsetX;
        var uly = parseFloat(tr.uly) + offsetY;
        var lry = parseFloat(tr.lry) + offsetY;
        tr.x = parseFloat(ulx);
        tr.y = parseFloat(uly);
        tr.w = parseFloat(lrx) - parseFloat(ulx);
        tr.h = parseFloat(lry) - parseFloat(uly);
      } else {
        tr.x = parseFloat(tr.ulx);
        tr.y = parseFloat(tr.uly);
        tr.w = parseFloat(tr.lrx) - parseFloat(tr.ulx);
        tr.h = parseFloat(tr.lry) - parseFloat(tr.uly);
      }
    });
    out.push({
      docID: d._id,
      transcripts: d._source.transcript
    });
  });
  return out;
};

var fechtDocumentById = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(store, ids) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__api__["a" /* queryPromise */])("document/" + ids);

          case 2:
            return _context.abrupt("return", _context.sent);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function fechtDocumentById(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var fechtSeiteDocs = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(store, seite) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__api__["a" /* queryPromise */])("document/" + seite.seiteIds.join(",")).then(function (d) {
              if (d && d.doc && !seite._.fetcmerzSeitenDataocInfoEnd) {
                seite._.docInfo = seite._.docInfo.concat(d.doc);
                seite.$_accoId_transcript_mapping = _getSeiteNoteTranscriptMapping(seite, d.doc);
                seite._.fetcmerzSeitenDataocInfoEnd = true;
                seite.$_allTranscripts = _initDocsTranscripts(seite, d.doc);
              }
              return d;
            });

          case 2:
            return _context2.abrupt("return", _context2.sent);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function fechtSeiteDocs(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var fetchMerzAndPersonData = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref4) {
    var state = _ref4.state,
        commit = _ref4.commit;
    var res, jsonMerzList, merzListe, seiteIdMap, texte, werbe, ursonate;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__api__["a" /* queryPromise */])("merzperson");

          case 2:
            res = _context3.sent;


            if (res && res.merzListe) {
              jsonMerzList = res.merzListe;
              merzListe = initMerzData(jsonMerzList);
              seiteIdMap = {};
              texte = [];
              werbe = [];
              ursonate = [];


              merzListe.forEach(function (merz) {
                if (merz.name.match(/^Merz\d*/)) {
                  texte.push(merz);
                } else if (merz.name === "Ursonate" || merz.name.match(/Noten/g)) {
                  ursonate.push(merz);
                } else {
                  werbe.push(merz);
                }
                merz.seiten.forEach(function (seite) {
                  seite.seiteIds.forEach(function (id) {
                    seiteIdMap[id] = {
                      merz: merz,
                      seite: seite
                    };
                  });
                });
              });
              state.texte.merzListe = texte;
              state.werbe.merzListe = werbe;
              state.ursonate_noten.merzListe = ursonate;
              state.ursonate_texte.merzListe = texte.filter(function (m) {
                return m.name === 'Merz24';
              });
              state.personen.collection2 = initPersonenCollection2(res.personen, seiteIdMap);
            }

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function fetchMerzAndPersonData(_x5) {
    return _ref3.apply(this, arguments);
  };
}();

var fetchMerzExtendByIdPromise = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(merzId) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__api__["a" /* queryPromise */])("merz/extend/" + merzId);

          case 2:
            return _context4.abrupt("return", _context4.sent);

          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function fetchMerzExtendByIdPromise(_x6) {
    return _ref5.apply(this, arguments);
  };
}();

var fetchSeiteExtendByIdPromise = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(sotre, seiteIds) {
    var res, merzIds, res2, out;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__api__["a" /* queryPromise */])("seite/extend/" + seiteIds);

          case 2:
            res = _context5.sent;

            if (!(!res.seite || !res.seite[0])) {
              _context5.next = 5;
              break;
            }

            return _context5.abrupt("return");

          case 5:
            merzIds = res.seite[0].map(function (_seite) {
              return _seite.docID;
            });

            if (!(merzIds.length < 1)) {
              _context5.next = 8;
              break;
            }

            return _context5.abrupt("return");

          case 8:
            _context5.next = 10;
            return fechtDocumentById(null, merzIds.join(","));

          case 10:
            res2 = _context5.sent;
            out = [];

            res2.doc.forEach(function (d) {
              out.push(d);
            });
            return _context5.abrupt("return", out);

          case 14:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function fetchSeiteExtendByIdPromise(_x7, _x8) {
    return _ref6.apply(this, arguments);
  };
}();

var fetchtranscriptCropImg = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(store, playload) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__api__["a" /* queryPromise */])("transcriptCropImg/attachment/download/" + playload.id + "/" + playload.tag));

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function fetchtranscriptCropImg(_x9, _x10) {
    return _ref7.apply(this, arguments);
  };
}();

var fetchBibliographie = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(_ref9) {
    var state = _ref9.state;
    var res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (state.bibliographie) {
              _context7.next = 5;
              break;
            }

            _context7.next = 3;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__api__["a" /* queryPromise */])("bibliographie");

          case 3:
            res = _context7.sent;

            state.bibliographie = res.bibliographie;

          case 5:
            return _context7.abrupt("return", state.bibliographie);

          case 6:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, this);
  }));

  return function fetchBibliographie(_x11) {
    return _ref8.apply(this, arguments);
  };
}();

var fetchUrsonate = function () {
  var _ref10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(_ref11) {
    var state = _ref11.state;
    var res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (state.ursonateData) {
              _context8.next = 6;
              break;
            }

            _context8.next = 3;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__api__["a" /* queryPromise */])("getUrsonate");

          case 3:
            res = _context8.sent;

            state.ursonateData = res.ursonate;
            state.ursonateData2 = res.ursonate2;

          case 6:
            return _context8.abrupt("return", state.ursonateData);

          case 7:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, this);
  }));

  return function fetchUrsonate(_x12) {
    return _ref10.apply(this, arguments);
  };
}();

var setOSDToolTips = function setOSDToolTips(store, OSD) {
  var OSDTooltips = store.state.OSDTooltips;
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(OSDTooltips).forEach(function (key) {
    OSD.setString("Tooltips." + key, OSDTooltips[key]);
  });
};

/***/ }),

/***/ 989:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SIDEBAR_MODEL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OSDTooltips; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return THEMEN_COLORS; });
var OSDTooltips = {
  FullPage: "Vollbildmodus",
  Home: "Vollständige Seite an Fenstergröße anpassen",
  ZoomIn: "Vergrößen",
  ZoomOut: "Verkleinen",
  NextPage: "Nächste Seite",
  PreviousPage: "Vorherige Seite",
  RotateLeft: "Nach rechts drehen",
  RotateRight: "Nach links drehen"
};

var THEMEN_COLORS = {
  'Thema 1': '#690000',
  'Thema 2': '#689b5e',
  'Thema 3': '#c73c33',
  'Thema 3a': '#51685a',
  'Thema 4': '#dfc963',
  'Thema 5': '#214d78',
  'Thema 6': '#350021',
  'Thema 7': '#763f18',
  'Thema iii': '#6e66a6',
  'Thema 9': '#000000',
  'Thema 10': '#335a9b',
  'Thema 11': '#12578b',
  'Thema 12': '#774725',
  'Thema 13': '#65b095',
  'Thema 14': '#737069',
  'Thema 15': '#0a0019',
  'Thema 16': '#004524',
  'Thema 17': '#70212e',
  'Thema 17a': '#f9fcac',
  'Thema 18': '#d77427',
  'Thema 18a': '#d7852f'
};



/***/ }),

/***/ 990:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createNew; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sidebar_model__ = __webpack_require__(425);



var getAccordionList = function getAccordionList(itemIds) {
  var str = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_1__sidebar_model__["a" /* default */]);
  return JSON.parse(str).filter(function (it) {
    return itemIds.indexOf(it.id) > -1;
  });
};

var modusData = {
  active_modus: null,
  modusItems: [{
    img: "ansichtsmodus.svg",
    id: "ansichtsmodus",
    label: "Ansichts-Modus",
    viewKey: null,
    option: {
      key: "ansicht",
      openedAccordionId: "acco_kommentar",
      accordionList: getAccordionList(["acco_kommentar"]),
      urlparams: {
        merzId: null,
        seiteIdx: 0
      }
    }
  }, {
    img: "untersuchungsmodus.svg",
    id: "untersuchungsmodus",
    label: "Untersuchungs-Modus",
    viewKey: null,
    option: {
      key: "untersuchung",
      accordionList: getAccordionList(["acco_inventarisierung", "acco_transkription", "acco_einzelstellenkommentare", "acco_uebersetzung", "acco_relation", "acco_orte", "acco_personen", "acco_themen"]),
      openedAccordionId: "acco_inventarisierung",
      transparenz: 0,
      urlparams: {
        merzId: null,
        seiteIdx: null
      },
      popupBoxList: [],
      accoExpandPersonList: []
    }
  }, {
    img: "vergleichsmodus.svg",
    id: "vergleichsmodus",
    label: "Vergleichs-Modus",
    viewKey: null,
    option: {
      key: "vergleich",
      accordionList: getAccordionList(["acco_inventarisierung", "acco_transkription", "acco_einzelstellenkommentare", "acco_uebersetzung", "acco_relation", "acco_orte", "acco_personen", "acco_seitenvorschau", "acco_themen"]),
      openedAccordionId: "acco_uebersetzung",
      urlparams: {
        merzId: null,
        seiteIdx: null
      },
      popupBoxList: [],
      accoExpandPersonList: [],
      b: {
        key: "b_vergleich",
        accordionList: getAccordionList(["acco_inventarisierung", "acco_transkription", "acco_einzelstellenkommentare", "acco_uebersetzung", "acco_relation", "acco_orte", "acco_personen", "acco_seitenvorschau", "acco_themen"]),
        openedAccordionId: "acco_uebersetzung",
        urlparams: {
          merzId: null,
          seiteIdx: null
        },
        popupBoxList: [],
        accoExpandPersonList: []
      }
    }
  }, {
    img: "kompositionsmodus.svg",
    id: "kompositionsmodus",
    label: "Kompositions-Modus",
    viewKey: null,
    option: {
      key: "komposition",
      accordionList: getAccordionList(["acco_elementebibliothek"]),
      openedAccordionId: "acco_elementebibliothek",
      transparenz: 1,
      urlparams: {
        merzId: null,
        seiteIdx: null
      }
    }
  }, {
    img: null,
    id: "simple",
    label: "Simple-Modus",
    viewKey: null,
    option: {
      key: "simple",
      accordionList: [],
      openedAccordionId: null,
      transparenz: 1,
      urlparams: {}
    }
  }]
};

var createNew = function createNew(viewKey) {
  var str = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(modusData);

  var data = JSON.parse(str);
  if (viewKey === 'ursonate_noten' || viewKey === 'ursonate_texte') {
    data.modusItems = data.modusItems.filter(function (d) {
      return d.id === 'simple';
    });
  } else if (viewKey === 'werbe') {
    data.modusItems = data.modusItems.filter(function (d) {
      return d.id !== 'simple';
    });
    data.modusItems.forEach(function (modus) {
      modus.option.accordionList = modus.option.accordionList.filter(function (acco) {
        return ['acco_kommentar', 'acco_inventarisierung'].indexOf(acco.id) > -1;
      });
      if (modus.option.b) {
        modus.option.b.accordionList = modus.option.b.accordionList.filter(function (acco) {
          return ['acco_kommentar', 'acco_inventarisierung'].indexOf(acco.id) > -1;
        });
      }
    });
  } else {
    data.modusItems = data.modusItems.filter(function (d) {
      return d.id !== 'simple';
    });
  }

  data.modusItems.forEach(function (modus) {
    modus.option.viewKey = viewKey;
    if (modus.option.b) {
      modus.option.b.viewKey = viewKey;
    }
  });

  data.active_modus = data.modusItems[0];
  return data;
};

/***/ }),

/***/ 991:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transcripts", function() { return transcripts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "texte", function() { return texte; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "werbe", function() { return werbe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bibliographie", function() { return bibliographie; });

var transcripts = function transcripts(state) {
  return state.transcripts;
};

var texte = function texte(state) {
  return state.texte;
};

var werbe = function werbe(state) {
  return state.werbe;
};

var bibliographie = function bibliographie(state) {
  return state.bibliographie;
};

/***/ }),

/***/ 992:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__datamodel_modus_model__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__datamodel_constants__ = __webpack_require__(989);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  themen_colors: __WEBPACK_IMPORTED_MODULE_7__datamodel_constants__["a" /* THEMEN_COLORS */],
  texte: {
    modusData: __WEBPACK_IMPORTED_MODULE_6__datamodel_modus_model__["a" /* createNew */]("texte"),
    merzListe: null
  },
  werbe: {
    modusData: __WEBPACK_IMPORTED_MODULE_6__datamodel_modus_model__["a" /* createNew */]("werbe"),
    merzListe: null
  },
  ursonate_noten: {
    modusData: __WEBPACK_IMPORTED_MODULE_6__datamodel_modus_model__["a" /* createNew */]("ursonate_noten"),
    merzListe: null
  },
  ursonate_texte: {
    modusData: __WEBPACK_IMPORTED_MODULE_6__datamodel_modus_model__["a" /* createNew */]("ursonate_texte"),
    merzListe: null
  },

  cache: {
    documents: []
  },
  personen: {
    collection2: null
  },

  merzListe: null,
  bibliographie: null,
  orteundwege: null,
  ursonateData: null,
  ursonateData2: null,
  OSDTooltips: __WEBPACK_IMPORTED_MODULE_7__datamodel_constants__["b" /* OSDTooltips */]
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */],
  modules: __WEBPACK_IMPORTED_MODULE_5__modules__["a" /* default */]
}));

/***/ }),

/***/ 993:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modus_js__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__orteundwege_js__ = __webpack_require__(995);



/* harmony default export */ __webpack_exports__["a"] = ({
    modus: __WEBPACK_IMPORTED_MODULE_0__modus_js__["a" /* default */],
    orteundwege: __WEBPACK_IMPORTED_MODULE_1__orteundwege_js__["a" /* default */]
});

/***/ }),

/***/ 994:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__);








var _actions;

var getTransriptsFromClass = function getTransriptsFromClass(html, atype, id) {
  var pattern = /<span class=\"(.*?)\"/g;
  var match = void 0;
  var transcripts = [];
  while (match = pattern.exec(html)) {
    var spanclass = match[1];
    if (spanclass.indexOf(atype + '-' + id) >= 0) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(spanclass.split(' ')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var singleclass = _step.value;

          if (singleclass.indexOf('id-') >= 0) {
            var singleid = singleclass.substring(3);
            transcripts.push(singleid);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }
  return transcripts;
};

var state = {};

var getters = {
  getSeiteDataExtendInfo: function getSeiteDataExtendInfo(state, rootGetters, rootState) {
    return function (seite, type, viewKey) {
      if (!seite || !seite.$_docInfo) {
        return;
      }

      var docs = seite.$_docInfo;
      switch (type) {
        case 'acco_inventarisierung':
          var out = [];
          var options = [{
            label: 'Dokumenttitel',
            field: '98_documenttitle'
          }, {
            label: 'Art der Seite',
            field: '98_artderseite'
          }, {
            label: 'Format',
            field: '98_format'
          }, {
            label: 'Anzahl der Exemplare',
            field: '98_anzexemplare'
          }];

          if (viewKey !== 'werbe') {
            options = options.concat([{
              label: 'Datum von',
              field: '98_datum'
            }, {
              label: 'Datum bis',
              field: '98_datumbis'
            }]);
          }

          options = options.concat([{
            label: 'Datum',
            field: '98_datumalternativ'
          }, {
            label: 'Datum (Kommentar)',
            field: '98_datumkommentar'
          }, {
            label: 'Status',
            field: '98_seistatus'
          }, {
            label: 'Sachbegriff',
            field: '98_sachbegriff'
          }, {
            label: 'Material/Technik',
            field: '98_materialtechnik'
          }, {
            label: 'Inventar-Nr',
            field: '98_inventarnr'
          }, {
            label: 'Standort/Eigentümer',
            field: '98_standorteigen'
          }, {
            label: 'Signatur Sprengel Museum Hannover',
            field: '98_KSAsignaturItem'
          }, {
            label: 'Signatur',
            field: '98_SonstigeArchiveItem'
          }]);

          docs.forEach(function (doc, i) {
            var sour = doc._source;
            var tmp = [];
            options.forEach(function (opt) {
              var val = sour[opt.field];
              if (val !== undefined) {
                tmp.push({
                  label: opt.label,
                  value: val
                });
              }
            });
            out.push({
              docID: doc._id,
              data: tmp
            });
          });
          return out;

        case 'personen':
          var list = rootState.personen.collection2;
          if (!seite || !seite.$_accoId_transcript_mapping) {
            return;
          }
          if (!list) {
            return;
          }
          var trans = seite.$_accoId_transcript_mapping["index_personenindex_8"];
          var seiteIds = seite.seiteIds;
          var pers = list.filter(function (it) {
            return it.docIds.find(function (id) {
              return seiteIds.indexOf(id) > -1;
            });
          });
          pers.forEach(function (p) {
            var obj = trans.find(function (m) {
              return m.ID - p.lemmaID === 0;
            });
            if (obj.ids.length > 0) {
              p.transcripts = obj.ids;
            }
          });

          return pers;

        case 'orte':
          if (!seite || !seite.$_accoId_transcript_mapping) {
            return;
          }
          var orte = [];
          var orteMapping = seite.$_accoId_transcript_mapping['index_ortsindex_7'];
          docs.forEach(function (doc) {
            var arr = doc._source['index_ortsindex_7'];
            if (arr) {
              arr.forEach(function (a) {
                var mapItem = orteMapping.find(function (m) {
                  return m.ID === a.ID;
                });
                if (mapItem) {
                  a = JSON.parse(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(a));
                  a.transcripts = mapItem.ids;
                  orte.push(a);
                }
              });
            }
          });

          return orte;

        case 'themen':
          var themenMap = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default.a();
          var colors = rootState.themen_colors;
          var allTranscripts = seite.$_allTranscripts;
          docs.forEach(function (doc) {
            var arr = doc._source['index_ursonate_25'];
            var docTranscripts = void 0;
            if (allTranscripts) {
              docTranscripts = allTranscripts.find(function (d) {
                return d.docID === doc._id;
              });
            }
            if (arr) {
              arr.filter(function (a) {
                return a.parentID === "" || a.parentID === "0";
              }).forEach(function (a) {
                var id = a.ID;
                if (themenMap.has(id)) {
                  return;
                }

                var obj = seite.$_accoId_transcript_mapping['index_ursonate_25'].find(function (m) {
                  return m.ID === id;
                });
                var ids = obj.ids;
                var color = colors[a.content];
                if (docTranscripts) {
                  docTranscripts.transcripts.forEach(function (tr) {
                    if (ids.indexOf(tr.id) > -1) {
                      tr.$_color = color;
                    }
                  });
                }
                var thema = a.content;
                themenMap.set(id, {
                  checked: false,
                  info: a,
                  class: thema.indexOf('Thema') > -1 ? thema.replace(/\s/g, '-').toLowerCase() : '',
                  transcripts: ids
                });
              });
            }
          });
          var themenOut = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(themenMap.values()));
          themenOut.sort(function (a, b) {
            a = a.info.content;
            b = b.info.content;
            if (a > b) {
              return 1;
            } else if (a < b) {
              return -1;
            }
            return 0;
          });
          return themenOut;
      }
    };
  },

  getModusByIdKey: function getModusByIdKey(state, getters, rootState) {
    return function (_ref) {
      var modusId = _ref.modusId,
          viewKey = _ref.viewKey;

      return rootState[viewKey].modusData.modusItems.find(function (it) {
        return it.id === modusId;
      });
    };
  },

  getModusUrlparams: function getModusUrlparams(state, getters, rootState) {
    return function (modus) {
      var ansicht = rootState[modus.option.viewKey].modusData.modusItems.find(function (m) {
        return m.id === 'ansichtsmodus';
      });
      var ansicht_urlparmas = ansicht.option.urlparams;
      if (!ansicht_urlparmas.merzId) {
        var merzListe = rootState[modus.option.viewKey].merzListe;
        if (merzListe) {
          ansicht_urlparmas.merzId = merzListe[0].id;
        }
      }

      var urlparams = modus.option.urlparams;
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(urlparams).forEach(function (k) {
        if (urlparams[k] == null) {
          urlparams[k] = ansicht_urlparmas[k];
        }
      });

      if (modus.id === 'vergleichsmodus') {
        var outUrlparams = {};
        var urlparams_b = modus.option.b.urlparams;
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(urlparams_b).forEach(function (k) {
          if (urlparams_b[k] == null) {
            urlparams_b[k] = ansicht_urlparmas[k];
          }
          outUrlparams['b_' + k] = urlparams_b[k];
          outUrlparams[k] = urlparams[k];
        });
        return outUrlparams;
      }
      return urlparams;
    };
  },

  getModusMerz: function getModusMerz(state, getters, rootState) {
    return function (modus) {
      var data = rootState[modus.option.viewKey];
      return data.merzListe && data.merzListe.find(function (m) {
        return m.id === modus.option.urlparams.merzId;
      });
    };
  },

  getModusSeiteIdx: function getModusSeiteIdx() {
    return function (modus) {
      return parseInt(modus.option.urlparams.seiteIdx, 10);
    };
  },

  getModusSeiten: function getModusSeiten(state, getters, rootState) {
    return function (modus) {
      var data = rootState[modus.option.viewKey];
      if (!data.merzListe) {
        return;
      }
      var merz = data.merzListe.find(function (m) {
        return m.id === modus.option.urlparams.merzId;
      });
      if (merz) {
        return merz.seiten;
      }
    };
  },

  b_merz: function b_merz(state, getters, rootState) {
    return function (modus) {
      var data = rootState[modus.option.viewKey];
      var merzId = modus.option.b.urlparams.merzId;
      return data.merzListe && data.merzListe.find(function (m) {
        return m.id === merzId;
      });
    };
  },

  b_seiteIdx: function b_seiteIdx(state, getters, rootState) {
    return function (modus) {
      return parseInt(modus.option.b.urlparams.seiteIdx, 10);
    };
  },
  vergleichsseite: function vergleichsseite(state, getters, rootState) {
    return function (modus) {
      var seiteIdx = getters.b_seiteIdx(modus);
      var seiten = getters.b_seiten(modus);
      if (seiten) {
        return seiten[seiteIdx];
      }
    };
  },
  b_seiten: function b_seiten(state, getters) {
    return function (modus) {
      var merz = getters.b_merz(modus);
      if (merz) {
        return merz.seiten;
      }
    };
  }
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'changeModusMerz', function changeModusMerz(_ref2, _ref3) {
  var modus = _ref3.modus,
      merzId = _ref3.merzId;

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref2);

  modus.option.urlparams.merzId = merzId;
  modus.option.urlparams.seiteIdx = 0;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'changeModusSeite', function changeModusSeite(_ref4, _ref5) {
  var modus = _ref5.modus,
      seiteIdx = _ref5.seiteIdx;

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref4);

  modus.option.urlparams.seiteIdx = seiteIdx;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'changeTransparenz', function changeTransparenz(_ref6, _ref7) {
  var modus = _ref7.modus,
      val = _ref7.val;

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref6);

  modus.option.transparenz = val;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'b_changeMerz', function b_changeMerz(_ref8, _ref9) {
  var modus = _ref9.modus,
      merzId = _ref9.merzId;

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref8);

  modus.option.b.urlparams.merzId = merzId;
  modus.option.b.urlparams.seiteIdx = 0;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'b_changeSeite', function b_changeSeite(_ref10, _ref11) {
  var modus = _ref11.modus,
      seiteIdx = _ref11.seiteIdx;

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref10);

  modus.option.b.urlparams.seiteIdx = seiteIdx;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'changeModus', function changeModus(_ref12, _ref13) {
  var rootState = _ref12.rootState;
  var modus = _ref13.modus;

  var viewKey = modus.option.viewKey;
  var data = rootState[viewKey];
  data.modusData.active_modus = modus;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'updateModusOption', function updateModusOption(_ref14, _ref15) {
  var rootState = _ref14.rootState;
  var modusOption = _ref15.modusOption,
      key = _ref15.key,
      val = _ref15.val;

  var opts = key.split('/');
  if (opts.length != 2) {
    console.error('opts length error');
    return;
  }
  var modusKey = opts[0];
  var modus = rootState[modusOption.viewKey].modusData.modusItems.find(function (m) {
    return m.option.key === modusKey || m.option.b && m.option.b.key === modusKey;
  });

  if (modusKey === 'b_vergleich') {
    modus.option.b[opts[1]] = val;
  } else {
    modus.option[opts[1]] = val;
  }
}), _actions);

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, 'updatePopupBoxList', function updatePopupBoxList(state, obj) {
  var data = obj.data,
      modusOption = obj.modusOption;

  var item = modusOption.popupBoxList.find(function (p) {
    return p.merzId === data.merzId && p.seiteIdx === data.seitIdx;
  });
  if (item) {
    item.data = data;
  } else {
    data.seiteIdx = modusOption.urlparams.seiteIdx;
    data.merzId = modusOption.urlparams.merzId;
    modusOption.popupBoxList.push(data);
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 995:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_d3__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);






var _mutations;





var createPiechartIcon = function createPiechartIcon(colorArr) {
  var piechartSize = 25;
  var strokeWidth = 1.5;
  var radius = Math.min(piechartSize, piechartSize) / 2;

  var newSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  newSVG.setAttributeNS(null, 'version', '1.1');
  newSVG.setAttributeNS(null, 'height', piechartSize);
  newSVG.setAttributeNS(null, 'width', piechartSize);
  var svg = __WEBPACK_IMPORTED_MODULE_6_d3__["a" /* select */](newSVG).attr('width', piechartSize).attr('height', piechartSize);

  var g = svg.append('g').attr('transform', 'translate(' + piechartSize / 2 + ',' + piechartSize / 2 + ')');

  var data = colorArr.map(function (c) {
    return 1;
  });
  var color = __WEBPACK_IMPORTED_MODULE_6_d3__["b" /* scaleOrdinal */](colorArr);
  var pie = __WEBPACK_IMPORTED_MODULE_6_d3__["c" /* pie */]();

  var arc = __WEBPACK_IMPORTED_MODULE_6_d3__["d" /* arc */]().innerRadius(0).outerRadius(radius - strokeWidth);

  var arcs = g.selectAll('arc').data(pie(data)).enter().append('g').attr('class', 'ksm-map__arc');

  arcs.append('path').attr('fill', function (d, i) {
    return color(i);
  }).attr('d', arc).style('stroke', 'white').style('stroke-width', strokeWidth);

  var svgStr = new XMLSerializer().serializeToString(newSVG);
  var svgIcon = new Image();
  svgIcon.src = 'data:image/svg+xml;base64,' + btoa(svgStr);
  return svgIcon;
};

var fensterDataObject = {
  stadtindex: null,
  zIndex: 0,
  visible: false,
  overlay: null,
  lineLayer: null,
  lineFeature: null,
  infoItems: null,
  infoItem: null,
  type: null,
  x: 0,
  y: 0
};

var state = {
  fetched: false,
  data: {
    activeInfoItem: null,
    lastActiveInfoItem: null,
    geoData: null,
    merzgebieteGeoData: null,
    fensterDataCollection: [],
    sidebarLeftList: [{
      label: 'Infotext',
      color: '',
      show: true,
      isInfoText: true,
      isExpand: true
    }],
    sidebarRightList: [{
      label: 'Holland-Dada-Feldzug 1923',
      id: 'holland',
      color: '#b80718',
      typ: '224',
      indexID: [16],
      checked: true,
      textDocId: '582',
      textDoc: null,
      show: true,
      infoItems: [],
      stadtIndexList: [],
      isExpand: true,
      showTitle: false
    }, {
      label: 'Merzabende',
      id: 'merzabende',
      typ: '225',
      indexID: [16],
      color: '#f39400',
      checked: true,
      textDocId: 1173,
      textDoc: null,
      show: true,
      infoItems: [],
      stadtIndexList: [],
      isExpand: false,
      showTitle: false
    }, {
      label: 'Merzgebiete',
      id: 'merzgebiete',
      typ: null,
      indexID: [],
      color: 'rgb(245, 235, 118)',
      checked: true,
      textDocId: null,
      textDoc: null,
      show: true,
      infoItems: [],
      stadtIndexList: [],
      isExpand: false,
      merzgebiete: [],
      showTitle: false
    }, {
      label: 'Veranstaltungsorte',
      id: 'veranstaltung',
      color: '#009ee3',
      indexID: [16],
      typ: null,
      checked: true,
      textDocId: null,
      textDoc: null,
      show: true,
      infoItems: [],
      stadtIndexList: [],
      isExpand: false,
      showTitle: true
    }, {
      label: 'Ausstellungsorte',
      id: 'ausstellung',
      color: '#009037',
      indexID: [15],
      typ: null,
      checked: true,
      textDocId: null,
      textDoc: null,
      show: true,
      infoItems: [],
      stadtIndexList: [],
      isExpand: false,
      showTitle: true
    }, {
      label: 'Veröffentlichungsorte',
      id: 'veröffentlichung',
      color: '#004594',
      indexID: [10, 11],
      typ: null,
      checked: true,
      textDocId: null,
      textDoc: null,
      show: true,
      infoItems: [],
      stadtIndexList: [],
      isExpand: false,
      showTitle: true
    }, {
      label: 'Institutionen',
      id: 'institutionen',
      color: '#94127d',
      indexID: [12],
      typ: null,
      checked: true,
      textDocId: null,
      textDoc: null,
      show: true,
      infoItems: [],
      stadtIndexList: [],
      isExpand: false,
      showTitle: true
    }]
  }
};

var getters = {
  filterMerzgebieteGeoData: function filterMerzgebieteGeoData(state) {
    var accor = state.data.sidebarRightList.find(function (accor) {
      return accor.id === 'merzgebiete';
    });
    accor.merzgebiete.forEach(function (mgb) {
      var b = mgb.checked && accor.checked ? true : false;
      mgb.list.forEach(function (it) {
        it.show = b;
      });
    });
    return state.data.merzgebieteGeoData;
  },
  fensterDataCollection: function fensterDataCollection(state) {
    return state.data.fensterDataCollection;
  },
  sidebarRightList: function sidebarRightList(state) {
    return state.data.sidebarRightList;
  },
  sidebarLeftList: function sidebarLeftList(state) {
    return state.data.sidebarLeftList;
  },
  activeInfoItem: function activeInfoItem(state) {
    return state.data.activeInfoItem;
  },
  fensterDataByFeature: function fensterDataByFeature(state) {
    return function (_ref) {
      var feature = _ref.feature,
          type = _ref.type;

      var stadtindex = feature.get('stadtindex');
      return state.data.fensterDataCollection.find(function (d) {
        return d.stadtindex === stadtindex && d.type === type;
      });
    };
  }
};

var actions = {
  prepareAllfensterDataCollection: function prepareAllfensterDataCollection(store) {
    var geoData = state.data.geoData;
    if (!geoData) {
      return store.state.data.fensterDataCollection;
    }
    store.state.data.fensterDataCollection = [];
    ['infoFenster', 'ortsFenster'].forEach(function (type) {
      geoData.features.filter(function (f) {
        return f.properties.icon;
      }).forEach(function (f) {
        var fensterData = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(fensterDataObject));
        fensterData.type = type;
        fensterData.stadtindex = f.properties.stadtindex;
        fensterData.stadtname = f.properties.stadtname;
        store.commit('addFensterData', fensterData);
      });
    });
    return store.getters.fensterDataCollection;
  },
  navigatorInfoFenster: function navigatorInfoFenster(store, _ref2) {
    var infoItem = _ref2.infoItem,
        to = _ref2.to;

    var infoItems = infoItem.accor.infoItems;
    var idx = infoItems.indexOf(infoItem);
    idx = idx + to;
    if (idx < 0 || idx > infoItems.length - 1) {
      return;
    }

    store.state.data.lastActiveInfoItem = infoItem;
    store.commit('activeInfoItem', infoItems[idx]);
  },
  updateAllOrtsFensterData: function updateAllOrtsFensterData(store) {
    state.data.fensterDataCollection.forEach(function (fensterData) {
      store.commit('updateOrtsFensterInfoItems', fensterData);
    });
  },


  fetchGeoData: function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(store, vue) {
      var resJson, geoData, rows, sidebarRightList, merzgebieteGeoData, merzgebietIdx, textIds, docsJson, merzAccor, merzgebietFeatures, colors;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!state.data.geoData) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return', state.data.geoData);

            case 2:
              _context.next = 4;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__api__["a" /* queryPromise */])('getOrteUndWege?expandInfo=true');

            case 4:
              resJson = _context.sent;
              geoData = resJson.info.cities;
              rows = resJson.info.performances;
              sidebarRightList = state.data.sidebarRightList;
              merzgebieteGeoData = resJson.info.merzgebiete;
              merzgebietIdx = resJson.info.merzgebietIdx;


              geoData.features.forEach(function (f) {
                f.properties.stadtindex = f.properties.stadtindex.toString();
              });

              rows.forEach(function (row) {
                row.short_113_html = '';
                row.full_113_html = '';
                if (row.doc) {
                  var doc = row.webdoc ? row.webdoc : row.doc;
                  var doc_113_html = row.webdoc ? doc['114_html'] : doc['113_html'];
                  if (doc_113_html) {
                    var tmp = document.createElement('div');
                    tmp.innerHTML = doc_113_html;
                    var arr = tmp.textContent.split(' ');
                    var words = [];
                    for (var i = 0; i < 3; i++) {
                      if (arr[i]) {
                        words.push(arr[i]);
                      }
                    }
                    row.short_113_html = '(' + words.join(' ') + '...)';
                    row.full_113_html = vue.$_getNewHtmlElement(doc_113_html, null, { _source: doc }, true).innerHTML;
                  }
                }
                if (row.stadtindex) {
                  row.stadtindex = row.stadtindex.toString();
                }

                var datvon = row.datvon;
                var _datvon = '';
                var _datbis = '';
                row._datvon = '';
                if (datvon) {
                  var arrRes = [];
                  datvon.split('-').forEach(function (a) {
                    if (parseInt(a, 10) !== 0) {
                      arrRes.push(a);
                    }
                  });
                  _datvon = arrRes.reverse().join('.');
                  if (_datvon.split('.').length === 2) {
                    _datvon = __WEBPACK_IMPORTED_MODULE_7_moment__(_datvon, 'MM.YYYY').locale('de').format('MMMM YYYY');
                  }
                } else {
                  row.datvon = '';
                }

                var datbis = row.datbis;
                row._datbis = '';
                if (datbis) {
                  var _arrRes = [];
                  datbis.split('-').forEach(function (a) {
                    if (parseInt(a, 10) !== 0) {
                      _arrRes.push(a);
                    }
                  });
                  _datbis = _arrRes.reverse().join('.');
                  if (_datbis.split('.').length === 2) {
                    _datbis = __WEBPACK_IMPORTED_MODULE_7_moment__(_datbis, 'MM.YYYY').locale('de').format('MMMM YYYY');
                  }
                } else {
                  row.datbis = '';
                }

                if (_datvon && _datbis && _datvon === _datbis) {
                  _datbis = '';
                }
                row._datvon = _datvon;
                row._datbis = _datbis;
              });

              rows.sort(function (a, b) {
                var d = a.datvon.replace(/-/g, '') - b.datvon.replace(/-/g, '');
                if (d > 0) {
                  return 1;
                } else if (d < 0) {
                  return -1;
                }
                return 0;
              });

              rows.forEach(function (row) {
                var _stadtindex = row.stadtindex || row.ortsindex;
                var _stadtindexList = _stadtindex.toString().split('#');
                row._stadtindexList = _stadtindexList;

                var indexID = row.indexID;

                if (indexID !== 16) {
                  var _accor = sidebarRightList.find(function (accor) {
                    return accor.indexID.indexOf(indexID) >= 0;
                  });
                  _accor.infoItems.push({ accor: _accor, row: row });
                } else if (row.typ) {
                  sidebarRightList.filter(function (accor) {
                    return row.typ.indexOf(accor.typ) >= 0;
                  }).forEach(function (accor) {
                    accor.infoItems.push({ accor: accor, row: row });
                  });

                  var veranstaltung = row.typ.split('#').find(function (t) {
                    return t !== '224' && t !== '225';
                  });
                  if (veranstaltung) {
                    var _accor2 = sidebarRightList.find(function (accor) {
                      return accor.label === 'Veranstaltungsorte';
                    });
                    _accor2.infoItems.push({ accor: _accor2, row: row });
                  }
                }
              });

              textIds = [];

              sidebarRightList.forEach(function (accor) {
                if (accor.textDocId) {
                  textIds.push(accor.textDocId);
                }
                var stadtIndexObj = {};
                accor.infoItems.forEach(function (item) {
                  item.row._stadtindexList.forEach(function (i) {
                    stadtIndexObj[i] = true;
                  });
                });
                accor.stadtIndexList = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(stadtIndexObj);

                if (accor.id === 'veröffentlichung') {
                  accor.infoItems.sort(function (a, b) {
                    var aName = a.row.stadtName ? a.row.stadtName : a.row.ortsname;
                    var bName = b.row.stadtName ? b.row.stadtName : b.row.ortsname;

                    if (aName && bName) {
                      return aName.localeCompare(bName, 'de');
                    }
                  });
                }
              });

              _context.next = 18;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__api__["a" /* queryPromise */])('document/' + textIds.join(','));

            case 18:
              docsJson = _context.sent;

              docsJson.doc.forEach(function (doc) {
                var id = doc._id;
                sidebarRightList.find(function (accor) {
                  return accor.textDocId - id === 0;
                }).textDoc = doc;
              });

              merzAccor = sidebarRightList.find(function (accor) {
                return accor.id === 'merzgebiete';
              });
              merzgebietFeatures = merzgebieteGeoData.features;
              colors = __WEBPACK_IMPORTED_MODULE_6_d3__["b" /* scaleOrdinal */](__WEBPACK_IMPORTED_MODULE_6_d3__["e" /* schemeCategory10 */]);

              merzgebietIdx.forEach(function (idxRow, i) {
                var list = merzgebietFeatures.filter(function (feature) {
                  var mgb = feature.properties.merzgebiet;
                  if (mgb && mgb.split('#').indexOf(idxRow.ID.toString()) > -1) {
                    feature.properties.color = colors(i);
                    return true;
                  }
                });
                merzAccor.merzgebiete.push({
                  name: 'Merzgebiet ' + idxRow.data,
                  checked: false,
                  list: list,
                  color: colors(i)
                });
              });

              state.data.geoData = geoData;
              state.data.merzgebieteGeoData = merzgebieteGeoData;
              store.commit('updatePiechartIcon');
              return _context.abrupt('return', state.data.geoData);

            case 28:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function fetchGeoData(_x, _x2) {
      return _ref3.apply(this, arguments);
    }

    return fetchGeoData;
  }()
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'addFensterData', function addFensterData(state, fensterData) {
  state.data.fensterDataCollection.push(fensterData);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'updateOrtsFensterInfoItems', function updateOrtsFensterInfoItems(state, fensterData) {
  var stadtindex = fensterData.stadtindex;
  var tmpList = [];
  state.data.sidebarRightList.filter(function (accor) {
    return accor.checked;
  }).forEach(function (accor) {
    accor.infoItems.filter(function (item) {
      return item.row._stadtindexList.indexOf(stadtindex) > -1;
    }).forEach(function (item) {
      tmpList.push(item);
    });
  });
  fensterData.infoItems = tmpList;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'updatePiechartIcon', function updatePiechartIcon(state) {
  var checkedAccor = state.data.sidebarRightList.filter(function (it) {
    return it.checked;
  });
  state.data.geoData.features.forEach(function (feature) {
    var stadtindex = feature.properties.stadtindex;
    var colors = checkedAccor.filter(function (accor) {
      return accor.stadtIndexList.indexOf(stadtindex) > -1;
    }).map(function (accor) {
      return accor.color;
    });

    if (colors.length > 0) {
      feature.properties.icon = createPiechartIcon(colors);
      feature.properties.iconSize = [25, 25];
    } else {
      delete feature.properties.icon;
      delete feature.properties.iconSize;
    }
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'activeInfoItem', function activeInfoItem(state, data) {
  state.data.activeInfoItem = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'expandAccor', function expandAccor(state, data) {
  state.data.sidebarRightList.forEach(function (accor) {
    if (accor === data) {
      accor.isExpand = true;
    } else {
      accor.isExpand = false;
    }
  });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 996:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);



var _updateObjectByKey$te;

/* harmony default export */ __webpack_exports__["a"] = (_updateObjectByKey$te = {
  updateObjectByKey: function updateObjectByKey(state, data) {
    var key = data.key,
        obj = data.obj,
        val = data.val;

    obj[key] = val;
  },
  texteMerzListe: function texteMerzListe(state, data) {
    state.texte.merzListe = data;
  },
  werbeMerzListe: function werbeMerzListe(state, data) {
    state.werbe.merzListe = data;
  }

}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_updateObjectByKey$te, "options", function options(state, data) {
  $.extend(true, state.options, data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_updateObjectByKey$te, "updateModusDataByUrl", function updateModusDataByUrl(state, to) {
  var name = to.name;
  var modusData = void 0;
  if (name === "texte-modus") {
    modusData = state.texte.modusData;
  } else if (name === "werbe-modus") {
    modusData = state.werbe.modusData;
  } else {
    return;
  }

  var newUrlparams = to.query;
  var modusId = to.params.modus;
  var active = modusData.modusItems.find(function (m) {
    return m.id === modusId;
  });
  if (!active) {
    active = modusData.modusItems[0];
  }
  modusData.active_modus = active;
  var urlparams = active.option.urlparams;
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(newUrlparams).forEach(function (k) {
    if (newUrlparams[k] === undefined || newUrlparams[k] === "") {
      return;
    }
    if (k.indexOf("b_") > -1) {
      var b = active.option.b.urlparams;
      if (k.indexOf("Idx") > -1) {
        b[k.replace("b_", "")] = parseInt(newUrlparams[k], 10);
      } else {
        b[k.replace("b_", "")] = newUrlparams[k];
      }
    } else {
      if (k.indexOf("Idx") > -1) {
        urlparams[k] = parseInt(newUrlparams[k], 10);
      } else {
        urlparams[k] = newUrlparams[k];
      }
    }
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_updateObjectByKey$te, 'updateObject', function updateObject(state, _ref) {
  var from = _ref.from,
      to = _ref.to;

  for (var opt in from) {
    to[opt] = from[opt];
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_updateObjectByKey$te, 'updateAccoPersonList', function updateAccoPersonList(state, _ref2) {
  var modusOption = _ref2.modusOption,
      perId = _ref2.perId,
      merzId = _ref2.merzId,
      seiteIdx = _ref2.seiteIdx;

  var p = modusOption.accoExpandPersonList.find(function (p) {
    return p.merzId === merzId && p.seiteIdx === seiteIdx && p.perId === perId;
  });
  if (p) {
    modusOption.accoExpandPersonList.splice(modusOption.accoExpandPersonList.indexOf(p), 1);
  } else {
    modusOption.accoExpandPersonList.push({
      perId: perId,
      merzId: merzId,
      seiteIdx: seiteIdx
    });
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_updateObjectByKey$te, 'addAccoPersonList', function addAccoPersonList(state, _ref3) {
  var perId = _ref3.perId,
      merzId = _ref3.merzId,
      seiteIdx = _ref3.seiteIdx,
      path = _ref3.path,
      query = _ref3.query;

  var arr = path.split('/');
  var viewKey = arr[1];
  var modusId = arr[arr.length - 1];
  if (viewKey === 'merzwerbe') {
    viewKey = 'werbe';
  }
  var modusOption = state[viewKey].modusData.modusItems.find(function (m) {
    return m.id === modusId;
  }).option;

  if (query.b_merzId) {
    modusOption = modusOption.b;
  }

  var p = modusOption.accoExpandPersonList.find(function (p) {
    return p.merzId === merzId && p.seiteIdx === seiteIdx && p.perId === perId;
  });
  if (!p) {
    modusOption.accoExpandPersonList.push({
      perId: perId,
      merzId: merzId,
      seiteIdx: seiteIdx
    });
  }
}), _updateObjectByKey$te);

/***/ }),

/***/ 997:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);



var icons = __webpack_require__(2009);

/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {
    Vue.prototype.$_getRandomId = function () {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
      }
      return 'ID' + s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4();
    };

    Vue.prototype.$_getIcon = function (iconName) {
      return iconName ? icons('./' + iconName) : '';
    };

    Vue.prototype.$_getSvg = function (iconName) {
      return __webpack_require__(2008)("./" + iconName);
    };

    Vue.prototype.$_getModusContainer = function (el) {
      var out = void 0,
          parent = el.parentNode;
      while (parent && !out) {
        if (parent.className.match('ksm-modus__container')) {
          out = parent.parentNode;
        } else {
          parent = parent.parentNode;
        }
      }
      return out;
    }, Vue.prototype.$_extend = function (target, obj) {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(obj).forEach(function (k) {
        target[k] = obj[k];
      });
    }, Vue.prototype.$_modusChangeEvent = function (eventType, data) {
      var _this = this;

      var vue = this;
      vue.$store.dispatch(eventType, data).then(function () {
        if (data.stopUpdateUrl) {
          return;
        }
        var urlparams = vue.$store.getters['modus/getModusUrlparams'](data.modus);
        _this.$router.push({
          query: urlparams,
          params: {
            modus: data.modus.id
          }
        });
      });
    }, Vue.prototype.$_findAncestor = function (el, className) {
      while ((el = el.parentElement) && !el.classList.contains(className)) {}
      return el;
    }, Vue.prototype.$_getNewHtmlElement = function (htmlTxt, merz, doc, addLink) {
      var _this2 = this;

      var newDiv = document.createElement('div');
      newDiv.innerHTML = htmlTxt;

      var _source = doc._source;
      var kursivKeys = ['index_bildkuenstlerische_werke_14', 'index_literarische_werke_13', 'index_musikalische_werke_18', 'index_publikationen_11', 'index_zeitschriften_10', 'index_zeitungen_17'];
      var index_fields = [];
      var index_fields_kursiv = [];
      var notes_fields = [];
      var personIds = [];
      if (_source && _source['index_personenindex_8']) {
        personIds = _source['index_personenindex_8'];
        if (personIds) {
          personIds = personIds.map(function (p) {
            return p.ID;
          });
        }
      }

      for (var key in _source) {
        var val = _source[key];
        if (key.match(/^index_/)) {
          index_fields = index_fields.concat(val);

          if (kursivKeys.indexOf(key) > -1) {
            index_fields_kursiv = index_fields_kursiv.concat(val);
          }
        } else if (key == 'notes') {
          notes_fields = notes_fields.concat(val);

          index_fields_kursiv = index_fields_kursiv.concat(val);
        }
      }

      var spans = newDiv.querySelectorAll('span');
      var merzListe = this.$store.getters.texte.merzListe;
      for (var si = 0, l = spans.length; si < l; si++) {
        var s = spans[si];

        var classNames = s.className.trim().split(" ");

        var _loop = function _loop(ci) {
          var className = classNames[ci];
          var a = document.createElement('a');
          var class_id = className.replace(/\D/g, '');
          var useFields = void 0;
          if (className.indexOf('index') > -1) {
            if (personIds.indexOf(class_id) > -1) {
              a.href = "#/personen?lemmaID=" + class_id;
            }
            useFields = index_fields;
          } else if (className.indexOf('notice') > -1) {
            useFields = notes_fields;
          } else if (className.indexOf('doc') > -1 && merzListe) {
            var query = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this2.$route.query));
            var url = '';
            var modus = void 0;
            merzListe.forEach(function (_merz, i) {
              if (_merz === merz || !merz) {
                modus = 'ansichtsmodus';
              } else {
                modus = 'vergleichsmodus';
              }
              _merz.seiten.forEach(function (seite, j) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                  for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(seite.seiteIds), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var id = _step.value;

                    if (id == class_id) {
                      if (modus === 'ansichtsmodus') {
                        query.merzId = _merz.id;
                        query.seiteIdx = j;
                      } else {
                        query.b_merzId = _merz.id;
                        query.b_seiteIdx = j;
                      }

                      url = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(query).map(function (k) {
                        return encodeURIComponent(k) + '=' + encodeURIComponent(query[k]);
                      }).join('&');
                      url = '#/texte/merzhefte/' + modus + '?' + url;
                    }
                  }
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                      _iterator.return();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }
              });
            });
            a.href = url;
            a.title = a.href;
          } else if (className.indexOf('id-http') > -1) {
            var isLink = void 0;

            var href = className.replace(/^id-/, '');
            if (href.match(/zotero/)) {
              href = href.split('items/');
              href = '#/bibliographie/' + href[1].trim();
              a.title = 'Zur Bibliographie';
            } else {
              href = href.split(' ')[0];
              a.target = '_blank';
            }
            a.href = href;
          } else if (className.indexOf('id-mailto') > -1) {
            a.href = className.replace('id-', '').trim();
            a.target = '_blank';
          }

          if (useFields) {
            var res = useFields.find(function (p) {
              return p.ID == class_id;
            });
            if (res) {
              a.title = res.content;
            }
          }
          if (useFields && index_fields_kursiv) {
            var _res = index_fields_kursiv.find(function (p) {
              return p.ID - class_id === 0;
            });
            if (_res) {
              a.classList.add('ksm-kursiv');
            }
          }
          if (!(addLink && a.href)) {
            if (a.className) {
              s.classList.add(a.className);
            }
          } else {
            s.parentNode.insertBefore(a, s);
            a.appendChild(s);
          }
        };

        for (var ci = 0; ci < classNames.length; ci++) {
          _loop(ci);
        }
      }
      return newDiv;
    };
  }
});

/***/ }),

/***/ 998:
/***/ (function(module, exports) {



(function () {
  if (!window.OpenSeadragon) {
    console.error("[openseadragon-canvas-overlay] requires OpenSeadragon");
    return;
  }

  OpenSeadragon.Viewer.prototype.fabricjsOverlay = function (options) {
    this._fabricjsOverlayInfo = new Overlay(this);
    this._fabricjsOverlayInfo._scale = options.scale;

    return this._fabricjsOverlayInfo;
  };

  var counter = function () {
    var i = 1;

    return function () {
      return i++;
    };
  }();

  var Overlay = function Overlay(viewer) {
    var self = this;

    this._viewer = viewer;

    this._containerWidth = 0;
    this._containerHeight = 0;

    this._canvasdiv = document.createElement("div");
    this._canvasdiv.style.position = "absolute";
    this._canvasdiv.style.left = 0;
    this._canvasdiv.style.top = 0;
    this._canvasdiv.style.width = "100%";
    this._canvasdiv.style.height = "100%";
    this._viewer.canvas.appendChild(this._canvasdiv);

    this._canvas = document.createElement("canvas");

    this._id = "osd-overlaycanvas-" + counter();
    this._canvas.setAttribute("id", this._id);
    this._canvasdiv.appendChild(this._canvas);
    this.resize();
    this._fabricCanvas = new fabric.Canvas(this._canvas);

    this._fabricCanvas.selection = false;

    this._fabricCanvas.on("mouse:move", function (options) {
      if (options.target) {
        self._viewer.setMouseNavEnabled(false);
        options.e.preventDefaultAction = true;
        options.e.preventDefault();
        options.e.stopPropagation();
      } else {
        self._viewer.setMouseNavEnabled(true);
      }
    });

    this._viewer.addHandler("canvas-click", function () {
      self._fabricCanvas.deactivateAll().renderAll();
    });
    this._viewer.addHandler("update-viewport", function () {
      self.resize();
      self.resizecanvas();
    });

    this._viewer.addHandler("open", function () {
      self.resize();
      self.resizecanvas();
    });
  };

  Overlay.prototype = {
    canvas: function canvas() {
      return this._canvas;
    },
    fabricCanvas: function fabricCanvas() {
      return this._fabricCanvas;
    },
    offsetPoint: function offsetPoint() {
      return this._offsetPoint;
    },

    clear: function clear() {
      this._fabricCanvas.clearAll();
    },

    resize: function resize() {
      if (this._containerWidth !== this._viewer.container.clientWidth) {
        this._containerWidth = this._viewer.container.clientWidth;
        this._canvasdiv.setAttribute("width", this._containerWidth);
        this._canvas.setAttribute("width", this._containerWidth);
      }

      if (this._containerHeight !== this._viewer.container.clientHeight) {
        this._containerHeight = this._viewer.container.clientHeight;
        this._canvasdiv.setAttribute("height", this._containerHeight);
        this._canvas.setAttribute("height", this._containerHeight);
      }
    },
    resizecanvas: function resizecanvas() {
      var origin = new OpenSeadragon.Point(0, 0);
      var viewportZoom = this._viewer.viewport.getZoom(true);
      this._fabricCanvas.setWidth(this._containerWidth);
      this._fabricCanvas.setHeight(this._containerHeight);
      var zoom = this._viewer.viewport._containerInnerSize.x * viewportZoom / this._scale;
      this._fabricCanvas.setZoom(zoom);
      var viewportWindowPoint = this._viewer.viewport.viewportToWindowCoordinates(origin);
      var x = Math.round(viewportWindowPoint.x);
      var y = Math.round(viewportWindowPoint.y);
      var canvasOffset = this._canvasdiv.getBoundingClientRect();

      var pageScroll = OpenSeadragon.getPageScroll();
      this._offsetPoint = new fabric.Point(canvasOffset.left - x + pageScroll.x, canvasOffset.top - y + pageScroll.y);
      this._fabricCanvas.absolutePan(this._offsetPoint);
    }
  };
})();

/***/ }),

/***/ 999:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export guid */
/* unused harmony export mergeSearchOption */
/* unused harmony export cleanSearchFieldData */
/* unused harmony export deepFilterCopy */
/* unused harmony export deepCopySlide */
/* unused harmony export cloneToolbarItemData */
/* unused harmony export fullTimeFormat */
/* unused harmony export getDocSubtitle */
/* unused harmony export formatDeDate */
/* unused harmony export mergeIntervals */
/* unused harmony export XSLTransform */
/* unused harmony export getObjectNamesFromHtml */
/* unused harmony export updateRenderingHtml */
/* unused harmony export mergeInterval */
/* unused harmony export deLocalTimeFormat */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return timelineTickFormat; });
/* unused harmony export deDateToString */
/* unused harmony export dateToIso */
/* unused harmony export deString2Date */
/* unused harmony export isoToDate */
/* unused harmony export roughSizeOfObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_d3__ = __webpack_require__(77);









var guid = function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }
  return 'ID' + s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4();
};

var mergeSearchOption = function mergeSearchOption(searchOption) {
  if (searchOption.text.length < 1 && searchOption.time.length < 1) {
    return;
  }
  var and = [],
      not = [],
      or = [];

  searchOption.text.forEach(function (row) {
    var key = row.searchkey;
    if (row.logic === 'and') {
      and.push(key);
    } else if (row.logic === 'not') {
      not.push(key);
    } else if (row.logic === 'or') {
      or.push(key);
    }
  });

  var time_and = [],
      time_not = [],
      time_or = [];

  searchOption.time.forEach(function (row) {
    var from = row.from,
        to = row.to;

    if (!from && !to) {
      return;
    }

    var val = {
      from: from,
      to: to
    };

    if (row.logic === 'and') {
      time_and.push(val);
    } else if (row.logic === 'not') {
      time_not.push(val);
    } else if (row.logic === 'or') {
      time_or.push(val);
    }
  });

  return {
    text: {
      and: and,
      not: not,
      or: or
    },
    time: {
      and: time_and,
      not: time_not,
      or: time_or
    }
  };
};

var cleanSearchFieldData = function cleanSearchFieldData(_searchFormData) {
  if (!_searchFormData) {
    return;
  }
  var text = [];
  var _addSearchKey = function _addSearchKey(obj, w) {
    if (!w) {
      return;
    }
    var clone = JSON.parse(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(obj));
    clone.searchkey = w;
    text.push(clone);
  };
  _searchFormData.text.forEach(function (t) {
    var key = t.searchkey;
    if (key === undefined || key === '' || key === null) {
      return;
    }
    key = key.trim();
    if (key === '') {
      return;
    }

    var regex = /"[^"]+"/;
    var matchRes = key.match(regex);

    var max = 100;

    while (matchRes && max) {
      max--;
      var idx = matchRes.index;
      if (idx > 0) {
        key.substring(0, idx).trim().split(' ').forEach(function (s) {
          _addSearchKey(t, s);
        });
      }
      _addSearchKey(t, matchRes[0]);
      key = key.substring(idx + matchRes[0].length).trim();
      matchRes = key.match(regex);
    }
    if (!key) {
      return;
    }
    key.split(" ").forEach(function (w) {
      _addSearchKey(t, w);
    });
  });

  var time = [];
  _searchFormData.time.forEach(function (row) {
    var from = row.from,
        to = row.to;

    if (!from && !to) {
      return;
    }
    time.push(row);
  });
  if (text.length + time.length < 1) {
    return;
  }

  return {
    text: text.length > 0 ? text : null,
    time: time.length > 0 ? time : null
  };
};

var deepFilterCopy = function deepFilterCopy(obj) {
  var tempObj = Array.isArray(obj) ? [] : {};
  for (var key in obj) {
    if (key.indexOf('_') == 0) {
      continue;
    }
    var o = obj[key];
    tempObj[key] = ((typeof o === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(o)) === 'object' || typeof o === 'function') && o !== null ? deepFilterCopy(o) : o;
  }
  return tempObj;
};

var deepCopySlide = function deepCopy(obj) {
  var tempObj = Array.isArray(obj) ? [] : {};
  for (var key in obj) {
    var o = obj[key];
    if (key.indexOf('__') == 0) {
      tempObj[key] = null;
    } else if (key.indexOf('_') == 0) {
      tempObj[key] = o;
    } else {
      tempObj[key] = ((typeof o === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(o)) === 'object' || typeof o === 'function') && o !== null ? deepCopy(o) : o;
    }
  }
  return tempObj;
};

var cloneToolbarItemData = function cloneToolbarItemData(data) {
  var clone = {};
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
    if (key.indexOf('__') == 0) {
      clone[key] = null;
    } else if (key.indexOf('_') == 0) {
      clone[key] = data[key];
    } else {
      clone[key] = JSON.parse(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(data[key]));
    }
  });
  return clone;
};

var fullTimeFormat = function fullTimeFormat(date) {
  return __WEBPACK_IMPORTED_MODULE_7_d3__["n" /* timeFormat */]('%Y-%m-%d %H:%M:%S')(date);
};

var getDocSubtitle = function getDocSubtitle(doc) {
  var out = [];

  if (doc.i && !doc.idDocument) {
    if (doc.x && doc.x[0]) {
      out.push(doc.x[0].n);
    }
    if (doc.dd) {
      out.push(doc.dd);
    }

    if (doc.j === 'di') {
      out.push('Tagebuch');
    } else {
      out.push('Brief');
    }
  } else {
    if (doc.schreibort && doc.schreibort[0]) {
      out.push(doc.schreibort[0].name);
    }
    if (doc.datierung && doc.datierung[0]) {
      out.push(doc.datierung[0].datum);
    }

    if (doc.docType === 'di') {
      out.push('Tagebuch');
    } else {
      out.push('Brief');
    }
  }
  return out.join(', ');
};

var formatDeDate = function formatDeDate(date) {
  var monthNames = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

  var day = date.getDate();
  var monthIndex = date.getMonth();
  var year = date.getFullYear();

  return day + '. ' + monthNames[monthIndex] + ' ' + year;
};

var mergeIntervals = function mergeIntervals(intervals) {
  if (intervals.length <= 1) return intervals;

  var stack = [];
  var top = null;

  intervals = intervals.sort();

  stack.push(intervals[0]);

  for (var i = 1; i < intervals.length; i++) {
    top = stack[stack.length - 1];

    if (top[1] < intervals[i][0]) {
      stack.push(intervals[i]);
    } else if (top[1] < intervals[i][1]) {
        top[1] = intervals[i][1];
        stack.pop();
        stack.push(top);
      }
  }

  return stack;
};

var XSLTransform = function XSLTransform(xmlStr) {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    try {
      xmlStr = xmlStr.replace('<TEI>', '<TEI  xmlns="http://www.tei-c.org/ns/1.0">');
      xmlStr = xmlStr.replace('& ', '&amp; ');

      var xmlDoc = $.parseXML(xmlStr);
      var xsl = $.parseXML(transformXSL);

      var node = document.createElement('div');
      if (window.ActiveXObject || 'ActiveXObject' in window) {
        var xslt = new ActiveXObject('Msxml2.XSLTemplate');
        var xslDoc = new ActiveXObject('Msxml2.FreeThreadedDOMDocument');
        xslDoc.loadXML(xslStr);
        xslt.stylesheet = xslDoc;

        var xslProc = xslt.createProcessor();
        xslProc.input = xmlDoc;
        xslProc.transform();
        node.innerHTML = xslProc.output;
      } else if (document.implementation && document.implementation.createDocument) {
        var xsltProcessor = new XSLTProcessor();
        xsltProcessor.importStylesheet(xsl);
        var resultDocument = xsltProcessor.transformToFragment(xmlDoc, document);
        node.appendChild(resultDocument);
      }
      resolve(node.firstChild);
    } catch (err) {
      reject(err);
    }
  });
};

var getObjectNamesFromHtml = function getObjectNamesFromHtml(elem) {
  var set = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a();
  var clone = elem.cloneNode(true);
  var hiddenNodes = clone.querySelectorAll('.ev-xsl__comment-container');
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(hiddenNodes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var n = _step.value;

      n.innerHTML = '';
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var nameNodes = clone.querySelectorAll("[class^='ev-xsl__name']");
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(nameNodes), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var el = _step2.value;

      set.add(el.getAttribute('data-objectName'));
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(set));
};

var updateRenderingHtml = function updateRenderingHtml(elem, renderingSelection) {
  var nameNodes = elem.querySelectorAll("[class^='ev-xsl__name']");
  nameNodes.forEach(function (n) {
    var c = false;
    renderingSelection.forEach(function (name) {
      var className = "ev-xsl__name--" + name;
      if (n.classList.contains(className)) {
        c = true;
      }
    });
    if (c) {
      n.classList.remove("ev-normal-text-bg");
    } else {
      n.classList.add("ev-normal-text-bg");
    }
  });
};

var mergeInterval = function mergeInterval(ranges) {
  if (ranges.length < 1) return ranges;

  var newRanges = [];
  var i1 = ranges[0];
  for (var i = 0, len = ranges.length; i < len; i++) {
    var i2;
    if (i === len - 1) {
      i2 = [Number.MAX_VALUE, Number.MAX_VALUE];
    } else {
      i2 = ranges[i + 1];
    }

    if (i2[0] >= i1[0] && i2[0] <= i1[1]) {
      i1[1] = Math.max(i1[1], i2[1]);
    } else {
      newRanges.push(i1);
      i1 = i2;
    }
  }
  return newRanges;
};

var deLocalTimeFormat = __WEBPACK_IMPORTED_MODULE_7_d3__["o" /* timeFormatDefaultLocale */]({
  decimal: ',',
  thousands: '.',
  grouping: [3],
  currency: ['€', ''],
  dateTime: '%a %b %e %X %Y',
  date: '%d.%m.%Y',
  time: '%H:%M:%S',
  periods: ['AM', 'PM'],
  days: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
  shortDays: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
  shortMonths: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez']
});

var timelineTickFormat = function timelineTickFormat(date) {
  if (date.getMinutes()) {
    return;
  } else if (date.getHours()) {
    return;
  } else if (date.getDay() && date.getDate() != 1) {
    return deLocalTimeFormat.format('%d.%b')(date);
  } else if (date.getDate() != 1) {
    return deLocalTimeFormat.format('%d.%b')(date);
  } else if (date.getMonth()) {
    return deLocalTimeFormat.format('%b')(date);
  } else {
    return deLocalTimeFormat.format('%Y')(date);
  }
};

var deDateToString = function deDateToString(d) {
  var format = __WEBPACK_IMPORTED_MODULE_7_d3__["n" /* timeFormat */]('%d.%m.%Y');
  return format(d);
};

var dateToIso = function dateToIso(d) {
  var format = __WEBPACK_IMPORTED_MODULE_7_d3__["n" /* timeFormat */]('%Y-%m-%d');
  return format(d);
};

var deString2Date = function deString2Date(s) {
  return __WEBPACK_IMPORTED_MODULE_7_d3__["f" /* timeParse */]('%d.%m.%Y')(s);
};
var isoToDate = function isoToDate(d) {
  return __WEBPACK_IMPORTED_MODULE_7_d3__["f" /* timeParse */]('%Y-%m-%d')(d);
};

var roughSizeOfObject = function roughSizeOfObject(object) {
  var objectList = [];
  var stack = [object];
  var bytes = 0;

  while (stack.length) {
    var value = stack.pop();

    if (typeof value === 'boolean') {
      bytes += 4;
    } else if (typeof value === 'string') {
      bytes += value.length * 2;
    } else if (typeof value === 'number') {
      bytes += 8;
    } else if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(value)) === 'object' && objectList.indexOf(value) === -1) {
      objectList.push(value);

      for (var i in value) {
        stack.push(value[i]);
      }
    }
  }
  return bytes / 1000 + 'k';
};

/***/ })

},[2015]);


// WEBPACK FOOTER //
// static/js/app.9e82c68b747866e6b949.js